(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-vehicle"), require("@sm360/widget-commons-forms"), require("lodash"), require("immutable"), require("@sm360/widget-commons-basic-components"), require("react-dom"), require("@sm360/widget-login"));
	else if(typeof define === 'function' && define.amd)
		define("trade-in", ["react", "@sm360/widget-commons-core-services", "@sm360/widget-commons-general", "@sm360/widget-commons-vehicle", "@sm360/widget-commons-forms", "_", "immutable", "@sm360/widget-commons-basic-components", "react-dom", "@sm360/widget-login"], factory);
	else if(typeof exports === 'object')
		exports["trade-in"] = factory(require("react"), require("@sm360/widget-commons-core-services"), require("@sm360/widget-commons-general"), require("@sm360/widget-commons-vehicle"), require("@sm360/widget-commons-forms"), require("lodash"), require("immutable"), require("@sm360/widget-commons-basic-components"), require("react-dom"), require("@sm360/widget-login"));
	else
		root["TradeIn"] = factory(root["React"], root["CommonsCoreServices"], root["CommonsGeneral"], root["CommonsVehicle"], root["CommonsForms"], root["_"], root["Immutable"], root["CommonsBasicComponents"], root["ReactDOM"], root["Login"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__, __WEBPACK_EXTERNAL_MODULE_lodash__, __WEBPACK_EXTERNAL_MODULE_immutable__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_basic_components__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE__sm360_widget_login__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/@babel/runtime/helpers/interopRequireDefault.js":
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var url = __webpack_require__("../../node_modules/url/url.js");
var portableFetch = __webpack_require__("../../node_modules/portable-fetch/fetch-npm-browserify.js");
var BASE_PATH = "https://service-lead-submission.sm360.ca".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
/**
 * AttachmentApi - fetch parameter creator
 * @export
 */
exports.AttachmentApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file', 'Required parameter file was null or undefined when calling upload.');
            }
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId', 'Required parameter organizationId was null or undefined when calling upload.');
            }
            var localVarPath = "/upload";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }
            if (file !== undefined) {
                localVarFormParams.set('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AttachmentApi - functional programming interface
 * @export
 */
exports.AttachmentApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            var localVarFetchArgs = exports.AttachmentApiFetchParamCreator(configuration).upload(file, organizationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * AttachmentApi - factory interface
 * @export
 */
exports.AttachmentApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Upload file to attach later on lead submission
         * @param {any} file File to upload
         * @param {number} organizationId Id of the organization in which the Lead is submitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: function (file, organizationId, options) {
            return exports.AttachmentApiFp(configuration).upload(file, organizationId, options)(fetch, basePath);
        },
    };
};
/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
var AttachmentApi = /** @class */ (function (_super) {
    __extends(AttachmentApi, _super);
    function AttachmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Upload file to attach later on lead submission
     * @param {any} file File to upload
     * @param {number} organizationId Id of the organization in which the Lead is submitted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    AttachmentApi.prototype.upload = function (file, organizationId, options) {
        return exports.AttachmentApiFp(this.configuration).upload(file, organizationId, options)(this.fetch, this.basePath);
    };
    return AttachmentApi;
}(BaseAPI));
exports.AttachmentApi = AttachmentApi;
/**
 * LeadApi - fetch parameter creator
 * @export
 */
exports.LeadApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadSubmissionRequest' is not null or undefined
            if (leadSubmissionRequest === null || leadSubmissionRequest === undefined) {
                throw new RequiredError('leadSubmissionRequest', 'Required parameter leadSubmissionRequest was null or undefined when calling send.');
            }
            var localVarPath = "/send";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oidc required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oidc", [])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LeadSubmissionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(leadSubmissionRequest || {}) : (leadSubmissionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadApi - functional programming interface
 * @export
 */
exports.LeadApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            var localVarFetchArgs = exports.LeadApiFetchParamCreator(configuration).send(leadSubmissionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * LeadApi - factory interface
 * @export
 */
exports.LeadApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @summary Submit a new lead
         * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: function (leadSubmissionRequest, options) {
            return exports.LeadApiFp(configuration).send(leadSubmissionRequest, options)(fetch, basePath);
        },
    };
};
/**
 * LeadApi - object-oriented interface
 * @export
 * @class LeadApi
 * @extends {BaseAPI}
 */
var LeadApi = /** @class */ (function (_super) {
    __extends(LeadApi, _super);
    function LeadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Submit a new lead
     * @param {LeadSubmissionRequest} leadSubmissionRequest Lead object to submit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.send = function (leadSubmissionRequest, options) {
        return exports.LeadApiFp(this.configuration).send(leadSubmissionRequest, options)(this.fetch, this.basePath);
    };
    return LeadApi;
}(BaseAPI));
exports.LeadApi = LeadApi;


/***/ }),

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/configuration.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
    return Configuration;
}());
exports.Configuration = Configuration;


/***/ }),

/***/ "../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable
/**
 * Lead Submission
 * Lead Submission Microservice
 *
 * OpenAPI spec version: 0.1.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/api.js"));
__export(__webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/configuration.js"));


/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/ConfigurationManager/ConfigurationManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},_createClass=function(){function a(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,'value'in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),_ravenJs=__webpack_require__("../../node_modules/raven-js/src/singleton.js"),_ravenJs2=_interopRequireDefault(_ravenJs),_lodash=__webpack_require__("lodash"),_config=__webpack_require__("./src/config/index.js"),_config2=_interopRequireDefault(_config),_logLevel=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js"),_logLevel2=_interopRequireDefault(_logLevel),_logger=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js"),_logger2=_interopRequireDefault(_logger);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError('Cannot call a class as a function')}var ConfigurationManager=function(){function a(b,c){_classCallCheck(this,a),this.console=_logger2.default;var d=_config2.default.sentry,e=d.default?d.default.sentry:d.sentry;this.sentryLevel=_logLevel2.default.DEBUG,this.consoleLevel=_logLevel2.default.DEBUG,this.loggerName=b||'',e&&e.url&&(this.configureSentry(e,b,c),this.setLogLevel(e))}return _createClass(a,[{key:'configureSentry',value:function configureSentry(a,b,c){if(a&&a.url){var d=_extends({},a,{logger:b||''});d.whitelistUrls&&(d.whitelistUrls=(0,_lodash.map)(d.whitelistUrls,function(a){return(0,_lodash.startsWith)(a,'^')?new RegExp(a):a})),_ravenJs2.default.config(a.url,d).install(),_ravenJs2.default.setExtraContext(c)}}},{key:'setLogLevel',value:function setLogLevel(a){var b=a.sentryLevel,c=a.consoleLevel;if(b&&_logLevel2.default[b])this.sentryLevel=_logLevel2.default[b.toUpperCase()];else throw new Error('Log level ['+b+'] is not supported');if(c&&_logLevel2.default[c])this.consoleLevel=_logLevel2.default[c.toUpperCase()];else throw new Error('Log level ['+c+'] is not supported')}}]),a}();exports.default=ConfigurationManager;
//# sourceMappingURL=ConfigurationManager.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/ConsoleLogger/logger.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var logger={};if('undefined'!=typeof console)logger=console;else if('undefined'!=typeof window&&'undefined'!=typeof window.console)logger=window.console;else{var noop=function(){};logger={debug:noop,error:noop,info:noop,log:noop,warn:noop,trace:noop}}var log=logger;exports.default=log;
//# sourceMappingURL=logger.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/LoggerSentry/LoggerSentry.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _createClass=function(){function a(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,'value'in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),_ravenJs=__webpack_require__("../../node_modules/raven-js/src/singleton.js"),_ravenJs2=_interopRequireDefault(_ravenJs),_logLevel=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js"),_logLevel2=_interopRequireDefault(_logLevel),_ConfigurationManager2=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/ConfigurationManager/ConfigurationManager.js"),_ConfigurationManager3=_interopRequireDefault(_ConfigurationManager2);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(a,b){if(!a)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return b&&('object'==typeof b||'function'==typeof b)?b:a}function _inherits(a,b){if('function'!=typeof b&&null!==b)throw new TypeError('Super expression must either be null or a function, not '+typeof b);a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,enumerable:!1,writable:!0,configurable:!0}}),b&&(Object.setPrototypeOf?Object.setPrototypeOf(a,b):a.__proto__=b)}var LoggerSentry=function(a){function b(){return _classCallCheck(this,b),_possibleConstructorReturn(this,(b.__proto__||Object.getPrototypeOf(b)).apply(this,arguments))}return _inherits(b,a),_createClass(b,[{key:'sendToSentry',value:function sendToSentry(a,b,c,d){if(_ravenJs2.default.isSetup&&this.sentryLevel.level<=a.level)if(b)_ravenJs2.default.captureException(b,{message:c,level:a.name,extra:d||{}});else{var e={level:a.name,extra:d||{}};_ravenJs2.default.captureMessage(c,e)}}},{key:'error',value:function error(a,b,c){this.sendToSentry(_logLevel2.default.ERROR,b,a,c),this.consoleLevel.level<=_logLevel2.default.ERROR.level&&this.console.error('[ERROR]','"'+this.loggerName+'"',a||'',b||'')}},{key:'warning',value:function warning(a,b,c){this.sendToSentry(_logLevel2.default.WARNING,b,a,c),this.consoleLevel.level<=_logLevel2.default.WARNING.level&&this.console.warn('[WARNING]','"'+this.loggerName+'"',a||'',b||'')}},{key:'info',value:function info(a,b,c){this.sendToSentry(_logLevel2.default.INFO,b,a,c),this.consoleLevel.level<=_logLevel2.default.INFO.level&&this.console.info('[INFO]','"'+this.loggerName+'"',a||'',b||'')}},{key:'debug',value:function debug(a,b,c){this.sendToSentry(_logLevel2.default.DEBUG,b,a,c),this.consoleLevel.level<=_logLevel2.default.DEBUG.level&&this.console.log('[DEBUG]','"'+this.loggerName+'"',a||'',b||'')}}]),b}(_ConfigurationManager3.default);exports.default=LoggerSentry;
//# sourceMappingURL=LoggerSentry.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/constants/logLevel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0}),exports.default={DEBUG:{level:1,name:'debug'},INFO:{level:2,name:'info'},WARNING:{level:3,name:'warning'},ERROR:{level:4,name:'error'},NONE:{level:99,name:'none'}};
//# sourceMappingURL=logLevel.js.map

/***/ }),

/***/ "../../node_modules/@sm360/logger-sentry/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var _LoggerSentry=__webpack_require__("../../node_modules/@sm360/logger-sentry/dist/LoggerSentry/LoggerSentry.js"),_LoggerSentry2=_interopRequireDefault(_LoggerSentry);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}exports.default=_LoggerSentry2.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/add-dom-event-listener/lib/EventBaseObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/add-dom-event-listener/lib/EventObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__("../../node_modules/add-dom-event-listener/lib/EventBaseObject.js");

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__("../../node_modules/object-assign/index.js");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/add-dom-event-listener/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__("../../node_modules/add-dom-event-listener/lib/EventObject.js");

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/axios/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../node_modules/axios/lib/adapters/xhr.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__("../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__("../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__("../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__("../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("../../node_modules/axios/lib/helpers/btoa.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__("../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__("../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/Cancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/CancelToken.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../node_modules/axios/lib/cancel/isCancel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/Axios.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__("../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__("../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../node_modules/axios/lib/core/InterceptorManager.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../node_modules/axios/lib/core/createError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/dispatchRequest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__("../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__("../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__("../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__("../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__("../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/enhanceError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/settle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../node_modules/axios/lib/core/transformData.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../node_modules/axios/lib/defaults.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__("../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/axios/lib/helpers/bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/btoa.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/buildURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/combineURLs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/cookies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/parseHeaders.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../node_modules/axios/lib/helpers/spread.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../node_modules/axios/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__("../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-own-property-descriptor.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("../../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("../../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("../../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("../../node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("../../node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("../../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("../../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("../../node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "../../node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("../../node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("../../node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
var $Object = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js").f;

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var toIObject = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js");
var $DP = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "../../node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("../../node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "../../node_modules/chain-function/index.js":
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),

/***/ "../../node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "../../node_modules/component-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__("../../node_modules/component-indexof/index.js");
} catch (err) {
  var index = __webpack_require__("../../node_modules/component-indexof/index.js");
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),

/***/ "../../node_modules/component-indexof/index.js":
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "../../node_modules/css-animation/es/Event.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),

/***/ "../../node_modules/css-animation/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("../../node_modules/babel-runtime/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__("../../node_modules/css-animation/es/Event.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__("../../node_modules/component-classes/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),

/***/ "../../node_modules/dom-align/dist-web/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),

/***/ "../../node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("../../node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__("../../node_modules/dom-helpers/class/hasClass.js"));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "../../node_modules/dom-helpers/transition/properties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("../../node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("../../node_modules/dom-helpers/util/inDOM.js"));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),

/***/ "../../node_modules/dom-helpers/util/inDOM.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/dom-helpers/util/requestAnimationFrame.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("../../node_modules/@babel/runtime/helpers/interopRequireDefault.js");

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__("../../node_modules/dom-helpers/util/inDOM.js"));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "../../node_modules/lodash/noop.js":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "../../node_modules/node-libs-browser/node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/object-assign/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../../node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/portable-fetch/fetch-npm-browserify.js":
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__("../../node_modules/whatwg-fetch/fetch.js");
module.exports = self.fetch.bind(self);


/***/ }),

/***/ "../../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("../../node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "../../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("../../node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "../../node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "../../node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "../../node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("../../node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("../../node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "../../node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("../../node_modules/raf/node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raf/node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../node_modules/raven-js/src/configError.js":
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),

/***/ "../../node_modules/raven-js/src/console.js":
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = utils.safeJoin(args, ' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg =
          'Assertion failed: ' + (utils.safeJoin(args.slice(1), ' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),

/***/ "../../node_modules/raven-js/src/raven.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__("../../node_modules/raven-js/vendor/TraceKit/tracekit.js");
var stringify = __webpack_require__("../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js");
var md5 = __webpack_require__("../../node_modules/raven-js/vendor/md5/md5.js");
var RavenConfigError = __webpack_require__("../../node_modules/raven-js/src/configError.js");

var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");
var isErrorEvent = utils.isErrorEvent;
var isDOMError = utils.isDOMError;
var isDOMException = utils.isDOMException;
var isError = utils.isError;
var isObject = utils.isObject;
var isPlainObject = utils.isPlainObject;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;
var supportsReferrerPolicy = utils.supportsReferrerPolicy;
var serializeKeysForMessage = utils.serializeKeysForMessage;
var serializeException = utils.serializeException;
var sanitize = utils.sanitize;

var wrapConsoleMethod = __webpack_require__("../../node_modules/raven-js/src/console.js").wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    // SENTRY_RELEASE can be injected by https://github.com/getsentry/sentry-webpack-plugin
    release: _window.SENTRY_RELEASE && _window.SENTRY_RELEASE.id,
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    captureUnhandledRejections: true,
    maxMessageLength: 0,
    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1,
    sanitizeKeys: []
  };
  this._fetchDefaults = {
    method: 'POST',
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    referrerPolicy: supportsReferrerPolicy() ? 'origin' : ''
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.27.0',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      if (self._globalOptions.captureUnhandledRejections) {
        self._attachPromiseRejectionHandler();
      }

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = {};
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} _before A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /**
   * Uninstalls the global error handler.
   *
   * @return {Raven}
   */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._detachPromiseRejectionHandler();
    this._unpatchFunctionToString();
    this._restoreBuiltIns();
    this._restoreConsole();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /**
   * Callback used for `unhandledrejection` event
   *
   * @param {PromiseRejectionEvent} event An object containing
   *   promise: the Promise that was rejected
   *   reason: the value with which the Promise was rejected
   * @return void
   */
  _promiseRejectionHandler: function(event) {
    this._logDebug('debug', 'Raven caught unhandled promise rejection:', event);
    this.captureException(event.reason, {
      mechanism: {
        type: 'onunhandledrejection',
        handled: false
      }
    });
  },

  /**
   * Installs the global promise rejection handler.
   *
   * @return {raven}
   */
  _attachPromiseRejectionHandler: function() {
    this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this);
    _window.addEventListener &&
      _window.addEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Uninstalls the global promise rejection handler.
   *
   * @return {raven}
   */
  _detachPromiseRejectionHandler: function() {
    _window.removeEventListener &&
      _window.removeEventListener('unhandledrejection', this._promiseRejectionHandler);
    return this;
  },

  /**
   * Manually capture an exception and send it over to Sentry
   *
   * @param {error} ex An exception to be logged
   * @param {object} options A specific set of options for this error [optional]
   * @return {Raven}
   */
  captureException: function(ex, options) {
    options = objectMerge({trimHeadFrames: 0}, options ? options : {});

    if (isErrorEvent(ex) && ex.error) {
      // If it is an ErrorEvent with `error` property, extract it to get actual Error
      ex = ex.error;
    } else if (isDOMError(ex) || isDOMException(ex)) {
      // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
      // then we just extract the name and message, as they don't provide anything else
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
      // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
      var name = ex.name || (isDOMError(ex) ? 'DOMError' : 'DOMException');
      var message = ex.message ? name + ': ' + ex.message : name;

      return this.captureMessage(
        message,
        objectMerge(options, {
          // neither DOMError or DOMException provide stack trace and we most likely wont get it this way as well
          // but it's barely any overhead so we may at least try
          stacktrace: true,
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    } else if (isError(ex)) {
      // we have a real Error object
      ex = ex;
    } else if (isPlainObject(ex)) {
      // If it is plain Object, serialize it manually and extract options
      // This will allow us to group events based on top-level keys
      // which is much better than creating new group when any key/value change
      options = this._getCaptureExceptionOptionsFromPlainObject(options, ex);
      ex = new Error(options.message);
    } else {
      // If none of previous checks were valid, then it means that
      // it's not a DOMError/DOMException
      // it's not a plain Object
      // it's not a valid ErrorEvent (one with an error property)
      // it's not an Error
      // So bail out and capture it as a simple message:
      return this.captureMessage(
        ex,
        objectMerge(options, {
          stacktrace: true, // if we fall back to captureMessage, default to attempting a new trace
          trimHeadFrames: options.trimHeadFrames + 1
        })
      );
    }

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  _getCaptureExceptionOptionsFromPlainObject: function(currentOptions, ex) {
    var exKeys = Object.keys(ex).sort();
    var options = objectMerge(currentOptions, {
      message:
        'Non-Error exception captured with keys: ' + serializeKeysForMessage(exKeys),
      fingerprint: [md5(exKeys)],
      extra: currentOptions.extra || {}
    });
    options.extra.__serialized__ = serializeException(ex);

    return options;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};
    msg = msg + ''; // Make sure it's actually a string

    var data = objectMerge(
      {
        message: msg
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];

    // if stack[1] is `Raven.captureException`, it means that someone passed a string to it and we redirected that call
    // to be handled by `captureMessage`, thus `initialCall` is the 3rd one, not 2nd
    // initialCall => captureException(string) => captureMessage(string)
    if (initialCall && initialCall.func === 'Raven.captureException') {
      initialCall = stack.stack[2];
    }

    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    // Always attempt to get stacktrace if message is empty.
    // It's the only way to provide any helpful information to the user.
    if (this._globalOptions.stacktrace || options.stacktrace || data.message === '') {
      // fingerprint on msg, not stack trace (legacy behavior, could be revisited)
      data.fingerprint = data.fingerprint == null ? msg : data.fingerprint;

      options = objectMerge(
        {
          trimHeadFrames: 0
        },
        options
      );
      // Since we know this is a synthetic trace, the top frame (this function call)
      // MUST be from Raven.js, so mark it for trimming
      // We add to the trim counter so that callers can choose to trim extra frames, such
      // as utility functions.
      options.trimHeadFrames += 1;

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Make sure that fingerprint is always wrapped in an array
    if (data.fingerprint) {
      data.fingerprint = isArray(data.fingerprint)
        ? data.fingerprint
        : [data.fingerprint];
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = objectMerge(
      {
        eventId: this.lastEventId(),
        dsn: this._dsn,
        user: this._globalContext.user || {}
      },
      options
    );

    if (!options.eventId) {
      throw new RavenConfigError('Missing eventId');
    }

    if (!options.dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var encodedOptions = [];

    for (var key in options) {
      if (key === 'user') {
        var user = options.user;
        if (user.name) encodedOptions.push('name=' + encode(user.name));
        if (user.email) encodedOptions.push('email=' + encode(user.email));
      } else {
        encodedOptions.push(encode(key) + '=' + encode(options[key]));
      }
    }
    var globalServer = this._getGlobalServer(this._parseDSN(options.dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/?' + encodedOptions.join('&');
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: orig.name || '<anonymous>'}
              }
            },
            originalCallback
          );
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          target: global,
                          function: 'handleEvent',
                          handler: (fn && fn.name) || '<anonymous>'
                        }
                      }
                    },
                    fn.handleEvent
                  );
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(
                  {
                    mechanism: {
                      type: 'instrument',
                      data: {
                        target: global,
                        function: 'addEventListener',
                        handler: (fn && fn.name) || '<anonymous>'
                      }
                    }
                  },
                  fn,
                  before
                ),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(
              self.wrap(
                {
                  mechanism: {
                    type: 'instrument',
                    data: {
                      function: 'requestAnimationFrame',
                      handler: (orig && orig.name) || '<anonymous>'
                    }
                  }
                },
                cb
              )
            );
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(
            {
              mechanism: {
                type: 'instrument',
                data: {function: prop, handler: (orig && orig.name) || '<anonymous>'}
              }
            },
            orig
          );
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = _window.XMLHttpRequest && _window.XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(
                    {
                      mechanism: {
                        type: 'instrument',
                        data: {
                          function: 'onreadystatechange',
                          handler: (orig && orig.name) || '<anonymous>'
                        }
                      }
                    },
                    orig,
                    onreadystatechangeHandler
                  );
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            return origFetch
              .apply(this, args)
              .then(function(response) {
                fetchData.status_code = response.status;

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData
                });

                return response;
              })
              ['catch'](function(err) {
                // if there is an error performing the request
                self.captureBreadcrumb({
                  type: 'http',
                  category: 'fetch',
                  data: fetchData,
                  level: 'error'
                });

                throw err;
              });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else if (_document.attachEvent) {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      _window.history.pushState &&
      _window.history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(_window.history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(_window.history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _restoreConsole: function() {
    // eslint-disable-next-line guard-for-in
    for (var method in this._originalConsoleMethods) {
      this._originalConsole[method] = this._originalConsoleMethods[method];
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function(stackInfo, options) {
    options = options || {};
    options.mechanism = options.mechanism || {
      type: 'onerror',
      handled: false
    };

    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo(stackInfo, options);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        transaction: fileurl
      },
      options
    );

    var ex = data.exception.values[0];
    if (ex.type == null && ex.value === '') {
      ex.value = 'Unrecoverable error caught';
    }

    // Move mechanism from options to exception interface
    // We do this, as requiring user to pass `{exception:{mechanism:{ ... }}}` would be
    // too much
    if (!data.exception.mechanism && data.mechanism) {
      data.exception.mechanism = data.mechanism;
      delete data.mechanism;
    }

    data.exception.mechanism = objectMerge(
      {
        type: 'generic',
        handled: true
      },
      data.exception.mechanism || {}
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': _navigator.userAgent
      };
    }

    // Check in `window` instead of `document`, as we may be in ServiceWorker environment
    if (_window.location && _window.location.href) {
      httpData.url = _window.location.href;
    }

    if (this._hasDocument && _document.referrer) {
      if (!httpData.headers) httpData.headers = {};
      httpData.headers.Referer = _document.referrer;
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.transaction !== last.transaction // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    data = this._sanitizeData(data);

    // Cleanup empty properties before sending them to the server
    Object.keys(data).forEach(function(key) {
      if (data[key] == null || data[key] === '' || isEmptyObject(data[key])) {
        delete data[key];
      }
    });

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _sanitizeData: function(data) {
    return sanitize(data, this._globalOptions.sanitizeKeys);
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    var evaluatedFetchParameters = {};

    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHash(opts.options.headers);
    }

    if (opts.options.fetchParameters) {
      evaluatedFetchParameters = this._evaluateHash(opts.options.fetchParameters);
    }

    if (supportsFetch()) {
      evaluatedFetchParameters.body = stringify(opts.data);

      var defaultFetchOptions = objectMerge({}, this._fetchDefaults);
      var fetchOptions = objectMerge(defaultFetchOptions, evaluatedFetchParameters);

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHash: function(hash) {
    var evaluated = {};

    for (var key in hash) {
      if (hash.hasOwnProperty(key)) {
        var value = hash[key];
        evaluated[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluated;
  },

  _logDebug: function(level) {
    // We allow `Raven.debug` and `Raven.config(DSN, { debug: true })` to not make backward incompatible API change
    if (
      this._originalConsoleMethods[level] &&
      (this.debug || this._globalOptions.debug)
    ) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/src/singleton.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__("../../node_modules/raven-js/src/raven.js");

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/**
 * DISCLAIMER:
 *
 * Expose `Client` constructor for cases where user want to track multiple "sub-applications" in one larger app.
 * It's not meant to be used by a wide audience, so pleaaase make sure that you know what you're doing before using it.
 * Accidentally calling `install` multiple times, may result in an unexpected behavior that's very hard to debug.
 *
 * It's called `Client' to be in-line with Raven Node implementation.
 *
 * HOWTO:
 *
 * import Raven from 'raven-js';
 *
 * const someAppReporter = new Raven.Client();
 * const someOtherAppReporter = new Raven.Client();
 *
 * someAppReporter.config('__DSN__', {
 *   ...config goes here
 * });
 *
 * someOtherAppReporter.config('__OTHER_DSN__', {
 *   ...config goes here
 * });
 *
 * someAppReporter.captureMessage(...);
 * someAppReporter.captureException(...);
 * someAppReporter.captureBreadcrumb(...);
 *
 * someOtherAppReporter.captureMessage(...);
 * someOtherAppReporter.captureException(...);
 * someOtherAppReporter.captureBreadcrumb(...);
 *
 * It should "just work".
 */
module.exports.Client = RavenConstructor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/src/utils.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var stringify = __webpack_require__("../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js");

var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined'
      ? global
      : typeof self !== 'undefined'
        ? self
        : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return Object.prototype.toString.call(value) === '[object ErrorEvent]';
}

function isDOMError(value) {
  return Object.prototype.toString.call(value) === '[object DOMError]';
}

function isDOMException(value) {
  return Object.prototype.toString.call(value) === '[object DOMException]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isPlainObject(what) {
  return Object.prototype.toString.call(what) === '[object Object]';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  if (!isPlainObject(what)) return false;

  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMError() {
  try {
    new DOMError(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsDOMException() {
  try {
    new DOMException(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

// Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
// https://caniuse.com/#feat=referrer-policy
// It doesn't. And it throw exception instead of ignoring this parameter...
// REF: https://github.com/getsentry/raven-js/issues/1233
function supportsReferrerPolicy() {
  if (!supportsFetch()) return false;

  try {
    // eslint-disable-next-line no-new
    new Request('pickleRick', {
      referrerPolicy: 'origin'
    });
    return true;
  } catch (e) {
    return false;
  }
}

function supportsPromiseRejectionEvent() {
  return typeof PromiseRejectionEvent === 'function';
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  if (typeof max !== 'number') {
    throw new Error('2nd argument to `truncate` function should be a number');
  }
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  if (typeof url !== 'string') return {};
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if stacktrace is malformed
  if (frames1 === undefined || frames2 === undefined) return false;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  if (obj == null) return;
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns {string}
 */
function safeJoin(input, delimiter) {
  if (!isArray(input)) return '';

  var output = [];

  for (var i = 0; i < input.length; i++) {
    try {
      output.push(String(input[i]));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

// Default Node.js REPL depth
var MAX_SERIALIZE_EXCEPTION_DEPTH = 3;
// 50kB, as 100kB is max payload size, so half sounds reasonable
var MAX_SERIALIZE_EXCEPTION_SIZE = 50 * 1024;
var MAX_SERIALIZE_KEYS_LENGTH = 40;

function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}

function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

function serializeValue(value) {
  if (typeof value === 'string') {
    var maxLength = 40;
    return truncate(value, maxLength);
  } else if (
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    typeof value === 'undefined'
  ) {
    return value;
  }

  var type = Object.prototype.toString.call(value);

  // Node.js REPL notation
  if (type === '[object Object]') return '[Object]';
  if (type === '[object Array]') return '[Array]';
  if (type === '[object Function]')
    return value.name ? '[Function: ' + value.name + ']' : '[Function]';

  return value;
}

function serializeObject(value, depth) {
  if (depth === 0) return serializeValue(value);

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(function(acc, key) {
      acc[key] = serializeObject(value[key], depth - 1);
      return acc;
    }, {});
  } else if (Array.isArray(value)) {
    return value.map(function(val) {
      return serializeObject(val, depth - 1);
    });
  }

  return serializeValue(value);
}

function serializeException(ex, depth, maxSize) {
  if (!isPlainObject(ex)) return ex;

  depth = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_DEPTH : depth;
  maxSize = typeof depth !== 'number' ? MAX_SERIALIZE_EXCEPTION_SIZE : maxSize;

  var serialized = serializeObject(ex, depth);

  if (jsonSize(stringify(serialized)) > maxSize) {
    return serializeException(ex, depth - 1);
  }

  return serialized;
}

function serializeKeysForMessage(keys, maxLength) {
  if (typeof keys === 'number' || typeof keys === 'string') return keys.toString();
  if (!Array.isArray(keys)) return '';

  keys = keys.filter(function(key) {
    return typeof key === 'string';
  });
  if (keys.length === 0) return '[object has no keys]';

  maxLength = typeof maxLength !== 'number' ? MAX_SERIALIZE_KEYS_LENGTH : maxLength;
  if (keys[0].length >= maxLength) return keys[0];

  for (var usedKeys = keys.length; usedKeys > 0; usedKeys--) {
    var serialized = keys.slice(0, usedKeys).join(', ');
    if (serialized.length > maxLength) continue;
    if (usedKeys === keys.length) return serialized;
    return serialized + '\u2026';
  }

  return '';
}

function sanitize(input, sanitizeKeys) {
  if (!isArray(sanitizeKeys) || (isArray(sanitizeKeys) && sanitizeKeys.length === 0))
    return input;

  var sanitizeRegExp = joinRegExp(sanitizeKeys);
  var sanitizeMask = '********';
  var safeInput;

  try {
    safeInput = JSON.parse(stringify(input));
  } catch (o_O) {
    return input;
  }

  function sanitizeWorker(workerInput) {
    if (isArray(workerInput)) {
      return workerInput.map(function(val) {
        return sanitizeWorker(val);
      });
    }

    if (isPlainObject(workerInput)) {
      return Object.keys(workerInput).reduce(function(acc, k) {
        if (sanitizeRegExp.test(k)) {
          acc[k] = sanitizeMask;
        } else {
          acc[k] = sanitizeWorker(workerInput[k]);
        }
        return acc;
      }, {});
    }

    return workerInput;
  }

  return sanitizeWorker(safeInput);
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isDOMError: isDOMError,
  isDOMException: isDOMException,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isPlainObject: isPlainObject,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsDOMError: supportsDOMError,
  supportsDOMException: supportsDOMException,
  supportsFetch: supportsFetch,
  supportsReferrerPolicy: supportsReferrerPolicy,
  supportsPromiseRejectionEvent: supportsPromiseRejectionEvent,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill,
  safeJoin: safeJoin,
  serializeException: serializeException,
  serializeKeysForMessage: serializeKeysForMessage,
  sanitize: sanitize
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/vendor/TraceKit/tracekit.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__("../../node_modules/raven-js/src/utils.js");

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';
  return document.location.href;
}

function getLocationOrigin() {
  if (typeof document === 'undefined' || document.location == null) return '';

  // Oh dear IE10...
  if (!document.location.origin) {
    return (
      document.location.protocol +
      '//' +
      document.location.hostname +
      (document.location.port ? ':' + document.location.port : '')
    );
  }

  return document.location.origin;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
   * Add a crash handler.
   * @param {Function} handler
   */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
   * Remove a crash handler.
   * @param {Function} handler
   */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
   * Remove all crash handlers.
   */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} msg Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    // NOTE: blob urls are now supposed to always have an origin, therefore it's format
    // which is `blob:http://url/path/with-some-uuid`, is matched by `blob.*?:\/` as well
    var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
    // Used to additionally parse URL/line/column from eval frames
    var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    var lines = ex.stack.split('\n');
    var stack = [];
    var submatch;
    var parts;
    var element;
    var reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      if (element.url && element.url.substr(0, 5) === 'blob:') {
        // Special case for handling JavaScript loaded into a blob.
        // We use a synchronous AJAX request here as a blob is already in
        // memory - it's not making a network request.  This will generate a warning
        // in the browser console, but there has already been an error so that's not
        // that much of an issue.
        var xhr = new XMLHttpRequest();
        xhr.open('GET', element.url, false);
        xhr.send(null);

        // If we failed to download the source, skip this patch
        if (xhr.status === 200) {
          var source = xhr.responseText || '';

          // We trim the source down to the last 300 characters as sourceMappingURL is always at the end of the file.
          // Why 300? To be in line with: https://github.com/getsentry/sentry/blob/4af29e8f2350e20c28a6933354e4f42437b4ba42/src/sentry/lang/javascript/processor.py#L164-L175
          source = source.slice(-300);

          // Now we dig out the source map URL
          var sourceMaps = source.match(/\/\/# sourceMappingURL=(.*)$/);

          // If we don't find a source map comment or we find more than one, continue on to the next element.
          if (sourceMaps) {
            var sourceMapAddress = sourceMaps[1];

            // Now we check to see if it's a relative URL.
            // If it is, convert it to an absolute one.
            if (sourceMapAddress.charAt(0) === '~') {
              sourceMapAddress = getLocationOrigin() + sourceMapAddress.slice(1);
            }

            // Now we strip the '.map' off of the end of the URL and update the
            // element so that Sentry can match the map to the blob.
            element.url = sourceMapAddress.slice(0, -4);
          }
        }
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../node_modules/raven-js/vendor/json-stringify-safe/stringify.js":
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),

/***/ "../../node_modules/raven-js/vendor/md5/md5.js":
/***/ (function(module, exports) {

/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
* Add integers, wrapping at 2^32. This uses 16-bit operations internally
* to work around bugs in some JS interpreters.
*/
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xffff);
}

/*
* Bitwise rotate a 32-bit number to the left.
*/
function bitRotateLeft(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
* These functions implement the four basic operations the algorithm uses.
*/
function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
  return md5cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
  return md5cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/*
* Calculate the MD5 of an array of little-endian words, and a bit length.
*/
function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << (len % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;

    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }
  return [a, b, c, d];
}

/*
* Convert an array of little-endian words to a string
*/
function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;
  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xff);
  }
  return output;
}

/*
* Convert a raw string to an array of little-endian words
* Characters >255 have their high-byte silently ignored.
*/
function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;
  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }
  var length8 = input.length * 8;
  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << (i % 32);
  }
  return output;
}

/*
* Calculate the MD5 of a raw string
*/
function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}

/*
* Calculate the HMAC-MD5, of a key and some data (raw strings)
*/
function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  var hash;
  ipad[15] = opad[15] = undefined;
  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }
  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }
  hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}

/*
* Convert a raw string to a hex string
*/
function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;
  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
  }
  return output;
}

/*
* Encode a string as utf-8
*/
function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}

/*
* Take string arguments and return either raw or hex encoded strings
*/
function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}

function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }
    return rawMD5(string);
  }
  if (!raw) {
    return hexHMACMD5(key, string);
  }
  return rawHMACMD5(key, string);
}

module.exports = md5;


/***/ }),

/***/ "../../node_modules/rc-align/es/Align.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__("../../node_modules/dom-align/dist-web/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__("../../node_modules/rc-util/es/Dom/addEventListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("../../node_modules/rc-align/es/util.js");












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),

/***/ "../../node_modules/rc-align/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__("../../node_modules/rc-align/es/Align.js");
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),

/***/ "../../node_modules/rc-align/es/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__("../../node_modules/rc-util/es/Dom/contains.js");


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),

/***/ "../../node_modules/rc-animate/es/Animate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__("../../node_modules/rc-util/es/unsafeLifecyclesPolyfill.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__("../../node_modules/rc-animate/es/ChildrenUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__("../../node_modules/rc-animate/es/AnimateChild.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__("../../node_modules/rc-animate/es/util/animate.js");













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),

/***/ "../../node_modules/rc-animate/es/AnimateChild.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__("../../node_modules/css-animation/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__("../../node_modules/rc-animate/es/util/animate.js");










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),

/***/ "../../node_modules/rc-animate/es/ChildrenUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),

/***/ "../../node_modules/rc-animate/es/util/animate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ "../../node_modules/rc-slider/es/Handle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Handle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          vertical = _props.vertical,
          offset = _props.offset,
          handleStyle = _props.handleStyle,
          restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'vertical', 'offset', 'handleStyle']);

      var style = vertical ? { bottom: offset + '%' } : { left: offset + '%' };

      var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, handleStyle);
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps, { className: className, style: elStyle }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  handleStyle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

/***/ }),

/***/ "../../node_modules/rc-slider/es/Range.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("../../node_modules/babel-runtime/helpers/toConsumableArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__("../../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Track__ = __webpack_require__("../../node_modules/rc-slider/es/common/Track.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_createSlider__ = __webpack_require__("../../node_modules/rc-slider/es/common/createSlider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__("../../node_modules/rc-slider/es/utils.js");







/* eslint-disable react/prop-types */







var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ handle: null });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v) {
      return _this.trimAlignValue(v);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Range, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
      var bounds = this.state.bounds;

      var value = nextProps.value || bounds;
      var nextBounds = value.map(function (v) {
        return _this2.trimAlignValue(v, nextProps);
      });
      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
        return v === bounds[i];
      })) return;

      this.setState({ bounds: nextBounds });
      if (bounds.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_12__utils__["h" /* isValueOutOfRange */](v, nextProps);
      })) {
        this.props.onChange(nextBounds);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else if (state.handle !== undefined) {
        this.setState({ handle: state.handle });
      }

      var data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: boundNeedMoving,
        recent: boundNeedMoving
      });

      var prevValue = bounds[boundNeedMoving];
      if (value === prevValue) return;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[boundNeedMoving] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_12__utils__["i" /* pauseEvent */](e);
      var props = this.props;
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[state.handle] = value;
      var nextHandle = state.handle;
      if (props.pushable !== false) {
        var originalValue = state.bounds[nextHandle];
        this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        handle: nextHandle,
        bounds: nextBounds
      });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value > bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound = closestBound + 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
      if (isAtTheSamePoint) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props = this.props,
          marks = _props.marks,
          step = _props.step,
          min = _props.min,
          max = _props.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle, originalValue) {
      var threshold = this.props.pushable;

      var value = bounds[handle];

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = originalValue;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var valInRange = __WEBPACK_IMPORTED_MODULE_12__utils__["a" /* ensureValueInRange */](v, mergedProps);
      var valNotConflict = this.ensureValueNotConflict(valInRange, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_12__utils__["b" /* ensureValuePrecision */](valNotConflict, mergedProps);
    }
  }, {
    key: 'ensureValueNotConflict',
    value: function ensureValueNotConflict(val, _ref) {
      var allowCross = _ref.allowCross;

      var state = this.state || {};
      var handle = state.handle,
          bounds = state.bounds;
      /* eslint-disable eqeqeq */

      if (!allowCross && handle != null) {
        if (handle > 0 && val <= bounds[handle - 1]) {
          return bounds[handle - 1];
        }
        if (handle < bounds.length - 1 && val >= bounds[handle + 1]) {
          return bounds[handle + 1];
        }
      }
      /* eslint-enable eqeqeq */
      return val;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          handleGenerator = _props2.handle;


      var offsets = bounds.map(function (v) {
        return _this3.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          disabled: disabled,
          ref: function ref(h) {
            return _this3.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__common_createSlider__["a" /* default */])(Range));

/***/ }),

/***/ "../../node_modules/rc-slider/es/Slider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Track__ = __webpack_require__("../../node_modules/rc-slider/es/common/Track.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_createSlider__ = __webpack_require__("../../node_modules/rc-slider/es/common/createSlider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__("../../node_modules/rc-slider/es/utils.js");





/* eslint-disable react/prop-types */






var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Slider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

      var prevValue = this.state.value;
      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
      var nextValue = this.trimAlignValue(value, nextProps);
      if (nextValue === prevValue) return;

      this.setState({ value: nextValue });
      if (__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* isValueOutOfRange */](value, nextProps)) {
        this.props.onChange(nextValue);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      }

      var changedValue = state.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_9__utils__["i" /* pauseEvent */](e);
      var state = this.state;
      var value = this.calcValueByPos(position);
      var oldValue = state.value;
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var val = __WEBPACK_IMPORTED_MODULE_9__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_9__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          included = _props.included,
          disabled = _props.disabled,
          minimumTrackStyle = _props.minimumTrackStyle,
          handleStyle = _props.handleStyle,
          handleGenerator = _props.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        handleStyle: handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });
      var track = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Track__["a" /* default */], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        length: offset,
        minimumTrackStyle: minimumTrackStyle
      });

      return { tracks: track, handles: handle };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Slider.displayName = 'Slider';
Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
Slider.defaultProps = {};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__common_createSlider__["a" /* default */])(Slider));

/***/ }),

/***/ "../../node_modules/rc-slider/es/common/Marks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("../../node_modules/babel-runtime/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("../../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = 100 / (marksCount - 1);
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text', true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;

    var markPoint = marks[point];
    var markPointIsObject = (typeof markPoint === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(markPoint)) === 'object' && !__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),

/***/ "../../node_modules/rc-slider/es/common/Steps.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("../../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__("../../node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);





var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_3_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i = i + step) {
      if (points.indexOf(i) >= 0) continue;
      points.push(i);
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';
    var style = vertical ? { bottom: offset } : { left: offset };

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var pointClassName = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-active', isActived), _classNames));

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),

/***/ "../../node_modules/rc-slider/es/common/Track.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var Track = function Track(_ref) {
  var className = _ref.className,
      included = _ref.included,
      vertical = _ref.vertical,
      offset = _ref.offset,
      length = _ref.length,
      minimumTrackStyle = _ref.minimumTrackStyle;

  var style = {
    visibility: included ? 'visible' : 'hidden'
  };
  if (vertical) {
    style.bottom = offset + '%';
    style.height = length + '%';
  } else {
    style.left = offset + '%';
    style.width = length + '%';
  }
  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, minimumTrackStyle);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: className, style: elStyle });
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),

/***/ "../../node_modules/rc-slider/es/common/createSlider.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__("../../node_modules/babel-runtime/helpers/get.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__("../../node_modules/rc-util/es/Dom/addEventListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__("../../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning__ = __webpack_require__("../../node_modules/warning/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Steps__ = __webpack_require__("../../node_modules/rc-slider/es/common/Steps.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Marks__ = __webpack_require__("../../node_modules/rc-slider/es/common/Marks.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Handle__ = __webpack_require__("../../node_modules/rc-slider/es/Handle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__("../../node_modules/rc-slider/es/utils.js");


















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["d" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["f" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentMouseEvents();
        __WEBPACK_IMPORTED_MODULE_16__utils__["i" /* pauseEvent */](e);
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["f" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_16__utils__["i" /* pauseEvent */](e);
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["d" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }

      _this.handlesRefs = {};
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentEnhancer, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
                this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();

        return this.props.vertical ? rect.top : rect.left;
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        return this.props.vertical ? slider.clientHeight : slider.clientWidth;
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props = this.props,
            vertical = _props.vertical,
            min = _props.min,
            max = _props.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props2 = this.props,
            min = _props2.min,
            max = _props2.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props3 = this.props,
            prefixCls = _props3.prefixCls,
            className = _props3.className,
            marks = _props3.marks,
            dots = _props3.dots,
            step = _props3.step,
            included = _props3.included,
            disabled = _props3.disabled,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max,
            children = _props3.children,
            maximumTrackStyle = _props3.maximumTrackStyle,
            style = _props3.style;

        var _get$call = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls, true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-vertical', vertical), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));

        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            style: style
          },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', { className: prefixCls + '-rail', style: maximumTrackStyle }),
          tracks,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Steps__["a" /* default */], {
            prefixCls: prefixCls,
            vertical: vertical,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min
          }),
          handles,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Marks__["a" /* default */], {
            className: prefixCls + '-mark',
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min
          }),
          children
        );
      }
    }]);

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    handleStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      delete restProps.value;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    minimumTrackStyle: {},
    maximumTrackStyle: {},
    handleStyle: {}
  }), _temp;
}

/***/ }),

/***/ "../../node_modules/rc-slider/es/createSliderWithTooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("../../node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__("../../node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__ = __webpack_require__("../../node_modules/rc-tooltip/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__("../../node_modules/rc-slider/es/Handle.js");












function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call(this, props));

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState({
          visibles: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.state.visibles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, visible))
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['value', 'dragging', 'index', 'disabled']);

        var tipFormatter = _this.props.tipFormatter;

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__["a" /* default */],
          {
            prefixCls: 'rc-slider-tooltip',
            overlay: tipFormatter(value),
            visible: !disabled && (_this.state.visibles[index] || dragging),
            placement: 'top',
            key: index
          },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restProps, {
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      };

      _this.state = { visibles: {} };
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    }
  }, _temp;
}

/***/ }),

/***/ "../../node_modules/rc-slider/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__("../../node_modules/rc-slider/es/Slider.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__("../../node_modules/rc-slider/es/Range.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__("../../node_modules/rc-slider/es/Handle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__("../../node_modules/rc-slider/es/createSliderWithTooltip.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return __WEBPACK_IMPORTED_MODULE_1__Range__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Handle", function() { return __WEBPACK_IMPORTED_MODULE_2__Handle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSliderWithTooltip", function() { return __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a"]; });





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),

/***/ "../../node_modules/rc-slider/es/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["h"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["g"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["d"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["i"] = pauseEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("../../node_modules/babel-runtime/helpers/toConsumableArray.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

/***/ }),

/***/ "../../node_modules/rc-tooltip/es/Content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ "../../node_modules/rc-tooltip/es/Tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__("../../node_modules/rc-trigger/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__("../../node_modules/rc-tooltip/es/placements.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__("../../node_modules/rc-tooltip/es/Content.js");











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),

/***/ "../../node_modules/rc-tooltip/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__("../../node_modules/rc-tooltip/es/Tooltip.js");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),

/***/ "../../node_modules/rc-tooltip/es/placements.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),

/***/ "../../node_modules/rc-trigger/es/LazyRenderBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("../../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),

/***/ "../../node_modules/rc-trigger/es/Popup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__("../../node_modules/rc-align/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__("../../node_modules/rc-animate/es/Animate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__("../../node_modules/rc-trigger/es/PopupInner.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__("../../node_modules/rc-trigger/es/LazyRenderBox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("../../node_modules/rc-trigger/es/utils.js");













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),

/***/ "../../node_modules/rc-trigger/es/PopupInner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__("../../node_modules/rc-trigger/es/LazyRenderBox.js");







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),

/***/ "../../node_modules/rc-trigger/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("../../node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("../../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("../../node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__("../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__("../../node_modules/rc-util/es/Dom/contains.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__("../../node_modules/rc-util/es/Dom/addEventListener.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__("../../node_modules/rc-util/es/ContainerRender.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__("../../node_modules/rc-util/es/Portal.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__("../../node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__("../../node_modules/rc-trigger/es/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__("../../node_modules/rc-trigger/es/Popup.js");

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["a" /* polyfill */])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),

/***/ "../../node_modules/rc-trigger/es/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("../../node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),

/***/ "../../node_modules/rc-util/es/ContainerRender.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ContainerRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  function ContainerRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContainerRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),

/***/ "../../node_modules/rc-util/es/Dom/addEventListener.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__("../../node_modules/add-dom-event-listener/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),

/***/ "../../node_modules/rc-util/es/Dom/contains.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),

/***/ "../../node_modules/rc-util/es/Portal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("react-dom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("../../node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Portal).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),

/***/ "../../node_modules/rc-util/es/unsafeLifecyclesPolyfill.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("react");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),

/***/ "../../node_modules/react-addons-css-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__("../../node_modules/react-transition-group/CSSTransitionGroup.js");


/***/ }),

/***/ "../../node_modules/react-collapse/lib/Collapse.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = __webpack_require__("../../node_modules/react-motion/lib/react-motion.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SPRING_PRECISION = 1;

var WAITING = 'WAITING';
var RESIZING = 'RESIZING';
var RESTING = 'RESTING';
var IDLING = 'IDLING';

var noop = function noop() {
  return null;
};
var css = {
  collapse: 'ReactCollapse--collapse',
  content: 'ReactCollapse--content'
};

var Collapse = exports.Collapse = function (_React$PureComponent) {
  _inherits(Collapse, _React$PureComponent);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      currentState: IDLING,
      from: 0,
      to: 0
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          isOpened = _props.isOpened,
          forceInitialAnimation = _props.forceInitialAnimation,
          onRest = _props.onRest;

      if (isOpened) {
        var to = this.getTo();
        if (forceInitialAnimation) {
          var from = this.wrapper.clientHeight;
          this.setState({ currentState: RESIZING, from: from, to: to });
        } else {
          this.setState({ currentState: IDLING, from: to, to: to });
        }
      }
      onRest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasNestedCollapse) {
        // For nested collapses we do not need to change to waiting state
        // and should keep `height:auto`
        // Because children will be animated and height will not jump anyway
        // See https://github.com/nkbt/react-collapse/issues/76 for more details
        if (nextProps.isOpened !== this.props.isOpened) {
          // Still go to WAITING state if own isOpened was changed
          this.setState({ currentState: WAITING });
        }
      } else if (this.state.currentState === IDLING && (nextProps.isOpened || this.props.isOpened)) {
        this.setState({ currentState: WAITING });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var _props2 = this.props,
          isOpened = _props2.isOpened,
          onRest = _props2.onRest,
          onMeasure = _props2.onMeasure;


      if (this.state.currentState === IDLING) {
        onRest();
        return;
      }

      if (prevState.to !== this.state.to) {
        onMeasure({ height: this.state.to, width: this.content.clientWidth });
      }

      var from = this.wrapper.clientHeight;
      var to = isOpened ? this.getTo() : 0;

      if (from !== to) {
        this.setState({ currentState: RESIZING, from: from, to: to });
        return;
      }

      if (this.state.currentState === RESTING || this.state.currentState === WAITING) {
        this.setState({ currentState: IDLING, from: from, to: to });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      cancelAnimationFrame(this.raf);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactMotion.Motion, _extends({}, this.getMotionProps(), {
        onRest: this.onRest,
        children: this.renderContent }));
    }
  }]);

  return Collapse;
}(_react2.default.PureComponent);

Collapse.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  springConfig: _propTypes2.default.objectOf(_propTypes2.default.number),
  forceInitialAnimation: _propTypes2.default.bool,

  hasNestedCollapse: _propTypes2.default.bool,

  fixedHeight: _propTypes2.default.number,

  theme: _propTypes2.default.objectOf(_propTypes2.default.string),
  style: _propTypes2.default.object,

  onRender: _propTypes2.default.func,
  onRest: _propTypes2.default.func,
  onMeasure: _propTypes2.default.func,

  children: _propTypes2.default.node.isRequired
};
Collapse.defaultProps = {
  forceInitialAnimation: false,
  hasNestedCollapse: false,
  fixedHeight: -1,
  style: {},
  theme: css,
  onRender: noop,
  onRest: noop,
  onMeasure: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onContentRef = function (content) {
    _this2.content = content;
  };

  this.onWrapperRef = function (wrapper) {
    _this2.wrapper = wrapper;
  };

  this.onRest = function () {
    _this2.raf = requestAnimationFrame(_this2.setResting);
  };

  this.setResting = function () {
    _this2.setState({ currentState: RESTING });
  };

  this.getTo = function () {
    var fixedHeight = _this2.props.fixedHeight;

    return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
  };

  this.getWrapperStyle = function (height) {
    if (_this2.state.currentState === IDLING && _this2.state.to) {
      var fixedHeight = _this2.props.fixedHeight;

      if (fixedHeight > -1) {
        return { overflow: 'hidden', height: fixedHeight };
      }
      return { height: 'auto' };
    }

    if (_this2.state.currentState === WAITING && !_this2.state.to) {
      return { overflow: 'hidden', height: 0 };
    }

    return { overflow: 'hidden', height: Math.max(0, height) };
  };

  this.getMotionProps = function () {
    var springConfig = _this2.props.springConfig;


    return _this2.state.currentState === IDLING ? {
      // When completely stable, instantly jump to the position
      defaultStyle: { height: _this2.state.to },
      style: { height: _this2.state.to }
    } : {
      // Otherwise, animate
      defaultStyle: { height: _this2.state.from },
      style: { height: (0, _reactMotion.spring)(_this2.state.to, _extends({ precision: SPRING_PRECISION }, springConfig)) }
    };
  };

  this.renderContent = function (_ref) {
    var height = _ref.height;

    // eslint-disable-line
    var _props3 = _this2.props,
        _isOpened = _props3.isOpened,
        _springConfig = _props3.springConfig,
        _forceInitialAnimation = _props3.forceInitialAnimation,
        _hasNestedCollapse = _props3.hasNestedCollapse,
        _fixedHeight = _props3.fixedHeight,
        theme = _props3.theme,
        style = _props3.style,
        onRender = _props3.onRender,
        _onRest = _props3.onRest,
        _onMeasure = _props3.onMeasure,
        children = _props3.children,
        props = _objectWithoutProperties(_props3, ['isOpened', 'springConfig', 'forceInitialAnimation', 'hasNestedCollapse', 'fixedHeight', 'theme', 'style', 'onRender', 'onRest', 'onMeasure', 'children']);

    var _state = _this2.state,
        from = _state.from,
        to = _state.to;

    // DANGEROUS, use with caution, never do setState with it

    onRender({ current: height, from: from, to: to });

    return _react2.default.createElement(
      'div',
      _extends({
        ref: _this2.onWrapperRef,
        className: theme.collapse,
        style: _extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
      }, props),
      _react2.default.createElement(
        'div',
        { ref: _this2.onContentRef, className: theme.content },
        children
      )
    );
  };
};

/***/ }),

/***/ "../../node_modules/react-collapse/lib/UnmountClosed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Collapse = __webpack_require__("../../node_modules/react-collapse/lib/Collapse.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnmountClosed = exports.UnmountClosed = function (_React$PureComponent) {
  _inherits(UnmountClosed, _React$PureComponent);

  function UnmountClosed(props) {
    _classCallCheck(this, UnmountClosed);

    var _this = _possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));

    _this.componentWillReceiveProps = function (_ref) {
      var isOpened = _ref.isOpened;

      if (!_this.props.isOpened && isOpened) {
        _this.setState({
          forceInitialAnimation: true,
          shouldUnmount: false
        });
      }
    };

    _this.onRest = function () {
      var _this$props = _this.props,
          isOpened = _this$props.isOpened,
          onRest = _this$props.onRest;


      if (!isOpened) {
        _this.setState({ shouldUnmount: true });
      }
      if (onRest) {
        onRest.apply(undefined, arguments);
      }
    };

    _this.state = {
      shouldUnmount: !_this.props.isOpened,
      forceInitialAnimation: !_this.props.isOpened
    };
    return _this;
  }

  _createClass(UnmountClosed, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpened = _props.isOpened,
          _onRest = _props.onRest,
          props = _objectWithoutProperties(_props, ['isOpened', 'onRest']);

      var _state = this.state,
          forceInitialAnimation = _state.forceInitialAnimation,
          shouldUnmount = _state.shouldUnmount;


      return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
        forceInitialAnimation: forceInitialAnimation,
        isOpened: isOpened,
        onRest: this.onRest
      }, props));
    }
  }]);

  return UnmountClosed;
}(_react2.default.PureComponent);

UnmountClosed.propTypes = {
  isOpened: _propTypes2.default.bool.isRequired,
  onRest: _propTypes2.default.func
};

/***/ }),

/***/ "../../node_modules/react-collapse/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__("../../node_modules/react-collapse/lib/Collapse.js"),
    Collapse = _require.Collapse;

var _require2 = __webpack_require__("../../node_modules/react-collapse/lib/UnmountClosed.js"),
    UnmountClosed = _require2.UnmountClosed;

UnmountClosed.Collapse = Collapse;
UnmountClosed.UnmountClosed = UnmountClosed;

module.exports = UnmountClosed;

/***/ }),

/***/ "../../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ "../../node_modules/react-motion/lib/Motion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ "../../node_modules/react-motion/lib/StaggeredMotion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),

/***/ "../../node_modules/react-motion/lib/TransitionMotion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__("../../node_modules/react-motion/lib/mapToZero.js");

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__("../../node_modules/react-motion/lib/stepper.js");

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__("../../node_modules/react-motion/lib/mergeDiff.js");

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__("../../node_modules/performance-now/lib/performance-now.js");

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__("../../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__("../../node_modules/react-motion/lib/shouldStopAnimation.js");

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),

/***/ "../../node_modules/react-motion/lib/mapToZero.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/mergeDiff.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ "../../node_modules/react-motion/lib/presets.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),

/***/ "../../node_modules/react-motion/lib/react-motion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__("../../node_modules/react-motion/lib/Motion.js");

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__("../../node_modules/react-motion/lib/StaggeredMotion.js");

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__("../../node_modules/react-motion/lib/TransitionMotion.js");

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__("../../node_modules/react-motion/lib/spring.js");

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__("../../node_modules/react-motion/lib/presets.js");

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__("../../node_modules/react-motion/lib/stripStyle.js");

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__("../../node_modules/react-motion/lib/reorderKeys.js");

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ "../../node_modules/react-motion/lib/reorderKeys.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/shouldStopAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/spring.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__("../../node_modules/react-motion/lib/presets.js");

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-motion/lib/stepper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),

/***/ "../../node_modules/react-motion/lib/stripStyle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-responsive/dist/react-responsive.js":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["MediaQuery"] = factory(require("react"));
	else
		root["MediaQuery"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_15__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(15);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchmediaquery = __webpack_require__(11);
	
	var _matchmediaquery2 = _interopRequireDefault(_matchmediaquery);
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _toQuery = __webpack_require__(9);
	
	var _toQuery2 = _interopRequireDefault(_toQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultTypes = {
	  component: _propTypes2.default.node,
	  query: _propTypes2.default.string,
	  values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  onChange: _propTypes2.default.func,
	  onBeforeChange: _propTypes2.default.func
	};
	var mediaKeys = Object.keys(_mediaQuery2.default.all);
	var excludedQueryKeys = Object.keys(defaultTypes);
	var excludedPropKeys = excludedQueryKeys.concat(mediaKeys);
	
	function omit(object, keys) {
	  var newObject = _extends({}, object);
	  keys.forEach(function (key) {
	    return delete newObject[key];
	  });
	  return newObject;
	}
	
	var MediaQuery = function (_React$Component) {
	  _inherits(MediaQuery, _React$Component);
	
	  function MediaQuery() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MediaQuery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = { matches: false }, _this.updateMatches = function () {
	      if (_this._mql.matches === _this.state.matches) {
	        return;
	      }
	      _this.setState({
	        matches: _this._mql.matches
	      });
	    }, _this.removeMql = function () {
	      if (_this._mql) {
	        _this._mql.removeListener(_this.updateMatches);
	        _this._mql.dispose();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MediaQuery, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateQuery(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.updateQuery(nextProps);
	    }
	  }, {
	    key: 'updateQuery',
	    value: function updateQuery(props) {
	      var values = void 0;
	      if (props.query) {
	        this.query = props.query;
	      } else {
	        this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys));
	      }
	
	      if (!this.query) {
	        throw new Error('Invalid or missing MediaQuery!');
	      }
	
	      if (props.values) {
	        values = Object.keys(props.values).reduce(function (result, key) {
	          result[(0, _hyphenateStyleName2.default)(key)] = props.values[key];
	          return result;
	        }, {});
	      }
	
	      this.removeMql();
	
	      this._mql = (0, _matchmediaquery2.default)(this.query, values);
	      this._mql.addListener(this.updateMatches);
	      this.updateMatches();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(_, nextState) {
	      if (this.props.onBeforeChange && this.state.matches !== nextState.matches) {
	        this.props.onBeforeChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_, prevState) {
	      if (this.props.onChange && prevState.matches !== this.state.matches) {
	        this.props.onChange(this.state.matches);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeMql();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (typeof this.props.children === 'function') {
	        return this.props.children(this.state.matches);
	      }
	
	      if (this.state.matches === false) {
	        return null;
	      }
	      var props = omit(this.props, excludedPropKeys);
	      var hasMergeProps = Object.keys(props).length > 0;
	      var childrenCount = _react2.default.Children.count(this.props.children);
	      var wrapChildren = this.props.component || childrenCount > 1 || typeof this.props.children === 'string' || Array.isArray(this.props.children) && childrenCount == 1 || this.props.children === undefined;
	      if (wrapChildren) {
	        return _react2.default.createElement(this.props.component || 'div', props, this.props.children);
	      } else if (hasMergeProps) {
	        return _react2.default.cloneElement(this.props.children, props);
	      } else if (childrenCount) {
	        return this.props.children;
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return MediaQuery;
	}(_react2.default.Component);
	
	MediaQuery.displayName = 'MediaQuery';
	MediaQuery.defaultProps = {
	  values: {}
	};
	exports.default = MediaQuery;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (process.env.NODE_ENV !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	// properties that match media queries
	var matchers = {
	  orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),
	
	  scan: _propTypes2.default.oneOf(['progressive', 'interlace']),
	
	  aspectRatio: _propTypes2.default.string,
	  deviceAspectRatio: _propTypes2.default.string,
	
	  height: stringOrNumber,
	  deviceHeight: stringOrNumber,
	
	  width: stringOrNumber,
	  deviceWidth: stringOrNumber,
	
	  color: _propTypes2.default.bool,
	
	  colorIndex: _propTypes2.default.bool,
	
	  monochrome: _propTypes2.default.bool,
	  resolution: stringOrNumber
	
	  // media features
	};var features = _extends({
	  minAspectRatio: _propTypes2.default.string,
	  maxAspectRatio: _propTypes2.default.string,
	  minDeviceAspectRatio: _propTypes2.default.string,
	  maxDeviceAspectRatio: _propTypes2.default.string,
	
	  minHeight: stringOrNumber,
	  maxHeight: stringOrNumber,
	  minDeviceHeight: stringOrNumber,
	  maxDeviceHeight: stringOrNumber,
	
	  minWidth: stringOrNumber,
	  maxWidth: stringOrNumber,
	  minDeviceWidth: stringOrNumber,
	  maxDeviceWidth: stringOrNumber,
	
	  minColor: _propTypes2.default.number,
	  maxColor: _propTypes2.default.number,
	
	  minColorIndex: _propTypes2.default.number,
	  maxColorIndex: _propTypes2.default.number,
	
	  minMonochrome: _propTypes2.default.number,
	  maxMonochrome: _propTypes2.default.number,
	
	  minResolution: stringOrNumber,
	  maxResolution: stringOrNumber
	
	}, matchers);
	
	// media types
	var types = {
	  all: _propTypes2.default.bool,
	  grid: _propTypes2.default.bool,
	  aural: _propTypes2.default.bool,
	  braille: _propTypes2.default.bool,
	  handheld: _propTypes2.default.bool,
	  print: _propTypes2.default.bool,
	  projection: _propTypes2.default.bool,
	  screen: _propTypes2.default.bool,
	  tty: _propTypes2.default.bool,
	  tv: _propTypes2.default.bool,
	  embossed: _propTypes2.default.bool
	};
	
	var all = _extends({}, types, features);
	
	// add the type property
	matchers.type = Object.keys(types);
	
	exports.default = {
	  all: all,
	  types: types,
	  matchers: matchers,
	  features: features
	};
	module.exports = exports['default'];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (process.env.NODE_ENV !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (process.env.NODE_ENV !== 'production') {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(13)();
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (obj) {
	  var rules = [];
	  Object.keys(_mediaQuery2.default.all).forEach(function (k) {
	    var v = obj[k];
	    if (v != null) {
	      rules.push(keyVal(k, v));
	    }
	  });
	  return join(rules);
	};
	
	var _hyphenateStyleName = __webpack_require__(7);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var negate = function negate(cond) {
	  return 'not ' + cond;
	};
	
	function keyVal(k, v) {
	  var realKey = (0, _hyphenateStyleName2.default)(k);
	
	  // px shorthand
	  if (typeof v === 'number') {
	    v = v + 'px';
	  }
	  if (v === true) {
	    return k;
	  }
	  if (v === false) {
	    return negate(k);
	  }
	  return '(' + realKey + ': ' + v + ')';
	}
	
	function join(conds) {
	  return conds.join(' and ');
	}
	
	module.exports = exports['default'];

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	'use strict';
	
	exports.match = matchQuery;
	exports.parse = parseQuery;
	
	// -----------------------------------------------------------------------------
	
	var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
	    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
	    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
	    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
	    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	
	function matchQuery(mediaQuery, values) {
	    return parseQuery(mediaQuery).some(function (query) {
	        var inverse = query.inverse;
	
	        // Either the parsed or specified `type` is "all", or the types must be
	        // equal for a match.
	        var typeMatch = query.type === 'all' || values.type === query.type;
	
	        // Quit early when `type` doesn't match, but take "not" into account.
	        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
	            return false;
	        }
	
	        var expressionsMatch = query.expressions.every(function (expression) {
	            var feature  = expression.feature,
	                modifier = expression.modifier,
	                expValue = expression.value,
	                value    = values[feature];
	
	            // Missing or falsy values don't match.
	            if (!value) { return false; }
	
	            switch (feature) {
	                case 'orientation':
	                case 'scan':
	                    return value.toLowerCase() === expValue.toLowerCase();
	
	                case 'width':
	                case 'height':
	                case 'device-width':
	                case 'device-height':
	                    expValue = toPx(expValue);
	                    value    = toPx(value);
	                    break;
	
	                case 'resolution':
	                    expValue = toDpi(expValue);
	                    value    = toDpi(value);
	                    break;
	
	                case 'aspect-ratio':
	                case 'device-aspect-ratio':
	                case /* Deprecated */ 'device-pixel-ratio':
	                    expValue = toDecimal(expValue);
	                    value    = toDecimal(value);
	                    break;
	
	                case 'grid':
	                case 'color':
	                case 'color-index':
	                case 'monochrome':
	                    expValue = parseInt(expValue, 10) || 1;
	                    value    = parseInt(value, 10) || 0;
	                    break;
	            }
	
	            switch (modifier) {
	                case 'min': return value >= expValue;
	                case 'max': return value <= expValue;
	                default   : return value === expValue;
	            }
	        });
	
	        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
	    });
	}
	
	function parseQuery(mediaQuery) {
	    return mediaQuery.split(',').map(function (query) {
	        query = query.trim();
	
	        var captures    = query.match(RE_MEDIA_QUERY),
	            modifier    = captures[1],
	            type        = captures[2],
	            expressions = captures[3] || '',
	            parsed      = {};
	
	        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
	        parsed.type    = type ? type.toLowerCase() : 'all';
	
	        // Split expressions into a list.
	        expressions = expressions.match(/\([^\)]+\)/g) || [];
	
	        parsed.expressions = expressions.map(function (expression) {
	            var captures = expression.match(RE_MQ_EXPRESSION),
	                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	
	            return {
	                modifier: feature[1],
	                feature : feature[2],
	                value   : captures[2]
	            };
	        });
	
	        return parsed;
	    });
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function toDecimal(ratio) {
	    var decimal = Number(ratio),
	        numbers;
	
	    if (!decimal) {
	        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
	        decimal = numbers[1] / numbers[2];
	    }
	
	    return decimal;
	}
	
	function toDpi(resolution) {
	    var value = parseFloat(resolution),
	        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];
	
	    switch (units) {
	        case 'dpcm': return value / 2.54;
	        case 'dppx': return value * 96;
	        default    : return value;
	    }
	}
	
	function toPx(length) {
	    var value = parseFloat(length),
	        units = String(length).match(RE_LENGTH_UNIT)[1];
	
	    switch (units) {
	        case 'em' : return value * 16;
	        case 'rem': return value * 16;
	        case 'cm' : return value * 96 / 2.54;
	        case 'mm' : return value * 96 / 2.54 / 10;
	        case 'in' : return value * 96;
	        case 'pt' : return value * 72;
	        case 'pc' : return value * 72 / 12;
	        default   : return value;
	    }
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var staticMatch = __webpack_require__(10).match;
	var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
	
	// our fake MediaQueryList
	function Mql(query, values){
	  var self = this;
	  if(dynamicMatch){
	    var mql = dynamicMatch.call(window, query);
	    this.matches = mql.matches;
	    this.media = mql.media;
	    // TODO: is there a time it makes sense to remove this listener?
	    mql.addListener(update);
	  } else {
	    this.matches = staticMatch(query, values);
	    this.media = query;
	  }
	
	  this.addListener = addListener;
	  this.removeListener = removeListener;
	  this.dispose = dispose;
	
	  function addListener(listener){
	    if(mql){
	      mql.addListener(listener);
	    }
	  }
	
	  function removeListener(listener){
	    if(mql){
	      mql.removeListener(listener);
	    }
	  }
	
	  // update ourselves!
	  function update(evt){
	    self.matches = evt.matches;
	    self.media = evt.media;
	  }
	
	  function dispose(){
	    if(mql){
	      mql.removeListener(update);
	    }
	  }
	}
	
	function matchMedia(query, values){
	  return new Mql(query, values);
	}
	
	module.exports = matchMedia;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	if (process.env.NODE_ENV !== 'production') {
	  var invariant = __webpack_require__(3);
	  var warning = __webpack_require__(6);
	  var ReactPropTypesSecret = __webpack_require__(4);
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var ReactPropTypesSecret = __webpack_require__(4);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(2);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(4);
	var checkPropTypes = __webpack_require__(12);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ })
/******/ ])
});
;
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ "../../node_modules/react-transition-group/CSSTransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__("../../node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__("../../node_modules/react-transition-group/CSSTransitionGroupChild.js");

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__("../../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-transition-group/CSSTransitionGroupChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__("../../node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("../../node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__("../../node_modules/dom-helpers/util/requestAnimationFrame.js");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__("../../node_modules/dom-helpers/transition/properties.js");

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("react-dom");

var _PropTypes = __webpack_require__("../../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__("../../node_modules/chain-function/index.js");

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__("../../node_modules/warning/browser.js");

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__("../../node_modules/react-transition-group/utils/ChildMapping.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "../../node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("react");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "../../node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "../../node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("../../node_modules/node-libs-browser/node_modules/punycode/punycode.js");
var util = __webpack_require__("../../node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("../../node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "../../node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "../../node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "../../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../../node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "../widget-build-and-quote/src/constants/errorCodes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BAD_QUOTE_REVISION = exports.BAD_QUOTE_REVISION = 114;

/***/ }),

/***/ "../widget-commons-leads/src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","authentication":"https://service.authentication.dev.office.n360.io","leadSubmission":"https://service.lead-submission.dev.n360.io","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]},"secrets":{"authentication":"452e9145-29ab-4275-bca9-fa8ba7ae19d9"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("../widget-commons-leads/src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("../widget-commons-leads/src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("../widget-commons-leads/src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("../widget-commons-leads/src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "../widget-commons-leads/src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service.lead-submission.int.n360.io","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"33934e6c-d3ba-41c1-b62f-334dee5f8d8f"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service.lead-submission.int.n360.io","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"33934e6c-d3ba-41c1-b62f-334dee5f8d8f"}}

/***/ }),

/***/ "../widget-commons-leads/src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","authentication":"https://service-authentication.sm360.ca","leadSubmission":"https://service.lead-submission.prod.n360.io","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]},"secrets":{"authentication":"6524a774-d33b-47c4-9f13-ea2ad2fb12ee"}}

/***/ }),

/***/ "../widget-commons-leads/src/constants/LeadTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LEAD_TYPES = {
    ACCOUNT_CREATION: 87,
    APPOINTMENT_NEW: 23,
    APPOINTMENT_USED: 24,
    CONFIRMATION_NEW: 76,
    CONFIRMATION_USED: 66,
    DEPOSIT_NEW: 75,
    DEPOSIT_USED: 65,
    FACEBOOK_CONNECTION: 53,
    FINANCING_NEW: 77,
    FINANCING_USED: 67,
    INFORMATION_REQUEST: 38,
    TRADE_IN_NEW: 4,
    TRADE_IN_USED: 8
};

exports.default = LEAD_TYPES;

/***/ }),

/***/ "../widget-commons-leads/src/constants/VehicleTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VEHICLE_TYPES = {
    CATALOG: 1,
    INVENTORY: 2
};

exports.default = VEHICLE_TYPES;

/***/ }),

/***/ "../widget-commons-leads/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = exports.LEAD_TYPES = exports.LeadSubmissionBuilder = undefined;

var _LeadTypes = __webpack_require__("../widget-commons-leads/src/constants/LeadTypes.js");

var _LeadTypes2 = _interopRequireDefault(_LeadTypes);

var _LeadSubmissionBuilder = __webpack_require__("../widget-commons-leads/src/services/LeadSubmissionBuilder.js");

var _LeadSubmissionBuilder2 = _interopRequireDefault(_LeadSubmissionBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = "7.1.6";

exports.LeadSubmissionBuilder = _LeadSubmissionBuilder2.default;
exports.LEAD_TYPES = _LeadTypes2.default;
exports.version = version;
exports.default = {
    LeadSubmissionBuilder: _LeadSubmissionBuilder2.default,
    LEAD_TYPES: _LeadTypes2.default,
    version: version
};

/***/ }),

/***/ "../widget-commons-leads/src/services/LeadSubmissionBuilder.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _leadSubmissionFetchClientapi = __webpack_require__("../../node_modules/@sm360/lead-submission-fetch-clientapi/dist/index.js");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _VehicleTypes = __webpack_require__("../widget-commons-leads/src/constants/VehicleTypes.js");

var _VehicleTypes2 = _interopRequireDefault(_VehicleTypes);

var _LeadTypes = __webpack_require__("../widget-commons-leads/src/constants/LeadTypes.js");

var _LeadTypes2 = _interopRequireDefault(_LeadTypes);

var _config = __webpack_require__("../widget-commons-leads/src/config/index.js");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// temporary forced valdation for facebook account creation
//------------------
// function isLeadSubmissionRequestValid(leadSubmissionRequest) {
//     const { contact } = leadSubmissionRequest.lead;
//     const contactHasMinimumInfo = contact.firstname && contact.lastname && (contact.email1 || contact.homePhone);
//     return contactHasMinimumInfo;
// }
//------------------

var LeadSubmissionBuilder = function () {
    /**
     * Service to build and submit a lead
     * @example
     * new LeadSubmissionBuilder()
     *      .addContactInformation('Rick', 'Sanchez', '5141231234', 'valid_email')
     *      .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
     *      .addQuote(VALID_QUOTE)
     *      .addVehicle(VALID_QUOTE)
     *      .submit()
     */
    function LeadSubmissionBuilder() {
        _classCallCheck(this, LeadSubmissionBuilder);

        this.leadSubmissionRequest = {
            lead: {
                organizationId: _widgetCommonsCoreServices.ConfigsService.getOrganizationId(),
                organizationUnitId: _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId(),
                sourceTypeId: 0, // 0 = Web
                contact: {},
                tracking: {
                    websiteId: _widgetCommonsCoreServices.ConfigsService.getWebsiteId(),
                    url: _widgetCommonsCoreServices.WindowProxy.get() ? _widgetCommonsCoreServices.WindowProxy.location().href : undefined
                },
                vehicle: {},
                media: 'Showroom'
            },
            subscriptionInfo: {
                contexts: [],
                info: 'Showroom Sign Up Form'
            }
        };
    }

    /**
     * Setting up the contact information
     * @param {string} firstname
     * @param {string} lastname
     * @param {string} phone
     * @param {string} email
     * @param {number} [contactId]
     */


    _createClass(LeadSubmissionBuilder, [{
        key: 'addContactInformation',
        value: function addContactInformation(firstname, lastname, phone, email, contactId) {
            this.leadSubmissionRequest.lead.contact.firstname = firstname;
            this.leadSubmissionRequest.lead.contact.lastname = lastname;
            this.leadSubmissionRequest.lead.contact.homePhone = phone;
            this.leadSubmissionRequest.lead.contact.email1 = email;
            this.leadSubmissionRequest.lead.contact.id = contactId;
            return this;
        }

        /**
         * Setting up account creation information
         */

    }, {
        key: 'setIsAccountCreation',
        value: function setIsAccountCreation() {
            this.leadSubmissionRequest.accountCreation = true;
            return this;
        }

        /**
         * Setting up the lead type ID
         * @param {LEAD_TYPE} leadType
         */

    }, {
        key: 'addLeadType',
        value: function addLeadType(leadType) {
            if (!Object.values(_LeadTypes2.default).includes(leadType)) {
                throw new Error('Lead type [' + leadType + '] is not supported');
            }

            this.leadSubmissionRequest.lead.typeId = leadType;
            return this;
        }

        /**
         * Setting up opt-in email
         * @param {boolean} optInEmail
         */

    }, {
        key: 'addOptInEmail',
        value: function addOptInEmail(optInEmail) {
            if (optInEmail) {
                this.leadSubmissionRequest.subscriptionInfo.contexts.push('newsletter', 'marketing', 'service');
            }

            return this;
        }

        /**
         * Setting up quote information
         * @param {object} quote.id
         */

    }, {
        key: 'addQuote',
        value: function addQuote(quote) {
            if (quote) {
                this.leadSubmissionRequest.quoteId = quote.id;
            }

            return this;
        }

        /**
         * Setting up vehicle information
         * @param {object} quote
         */

    }, {
        key: 'addVehicle',
        value: function addVehicle(quote) {
            if (quote && quote.vehicle) {
                var vehicle = quote.vehicle,
                    vehicleId = quote.vehicleId;

                var vehicleInventoryId = vehicleId || vehicle.vehicleId;
                this.leadSubmissionRequest.lead.vehicle.vehicleInventoryId = vehicleInventoryId;
                this.leadSubmissionRequest.lead.vehicle.catalogVehicleId = vehicle.catalogVehicleId;
                this.leadSubmissionRequest.lead.vehicle.typeId = vehicleInventoryId ? _VehicleTypes2.default.INVENTORY : _VehicleTypes2.default.CATALOG;
            }

            return this;
        }

        /**
         * Setting up the trade in vehicle details
         * @param {number} year
         * @param {string} make
         * @param {string} model
         * @param {string} trim
         * @param {string} bodyStyle
         * @param {string} color
         * @param {number} kilometers
         * @param {string} vin
         */

    }, {
        key: 'addTradeInVehicle',
        value: function addTradeInVehicle(year, make, model, trim, bodyStyle, color, kilometers, vin) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.year = year;
            this.leadSubmissionRequest.lead.tradeIn.make = make;
            this.leadSubmissionRequest.lead.tradeIn.model = model;
            this.leadSubmissionRequest.lead.tradeIn.trim = trim;
            this.leadSubmissionRequest.lead.tradeIn.bodyStyle = bodyStyle;
            this.leadSubmissionRequest.lead.tradeIn.exteriorColor = color;
            this.leadSubmissionRequest.lead.tradeIn.kilometers = kilometers;
            this.leadSubmissionRequest.lead.tradeIn.vin = vin;

            return this;
        }

        /**
         * Setting up the estimation's details
         * @param {number} value
         * @param {number} low
         * @param {number} high
         */

    }, {
        key: 'addTradeInEstimation',
        value: function addTradeInEstimation(value, low, high) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.estimation = {};
            this.leadSubmissionRequest.lead.tradeIn.estimation.amount = value;
            this.leadSubmissionRequest.lead.tradeIn.estimation.high = high;
            this.leadSubmissionRequest.lead.tradeIn.estimation.low = low;
            return this;
        }

        /**
         * Setting up the trade in questionnaire
         * @param {object} evaluation
         * @param {*} evaluation.questionKey Key represents the question and the value is the answer
         */

    }, {
        key: 'addTradeInEvaluation',
        value: function addTradeInEvaluation(evaluation) {
            if (!this.leadSubmissionRequest.lead.tradeIn) {
                this.leadSubmissionRequest.lead.tradeIn = {};
            }
            this.leadSubmissionRequest.lead.tradeIn.conditionForm = evaluation;
            return this;
        }
    }, {
        key: 'addFinancingInformation',
        value: function addFinancingInformation() {
            // TODO when migrating financing
            throw new Error('Not yet implemented');
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this = this;

            var accountPromise = _widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsGeneral.AccountService.getLoggedAccount() : Promise.resolve({});

            return accountPromise.then(function (_ref) {
                var contactId = _ref.contactId;

                if (!_this.leadSubmissionRequest.lead.contact.id) {
                    _this.leadSubmissionRequest.lead.contact.id = contactId;
                }
                // temporary forced valdation for facebook account creation
                // ------------------
                // if (!isLeadSubmissionRequestValid(this.leadSubmissionRequest)) {
                //     return Promise.reject(new Error('Lead is invalid. Missing contact information'));
                // }
                // -------------------

                return _widgetCommonsCoreServices.TokenService.fetch().then(function (accessToken) {
                    return (0, _leadSubmissionFetchClientapi.LeadApiFp)({
                        accessToken: accessToken
                    }).send(_this.leadSubmissionRequest)(undefined, _config2.default.endpoint.leadSubmission);
                });
            });
        }
    }]);

    return LeadSubmissionBuilder;
}();

exports.default = LeadSubmissionBuilder;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/actions/modelYearActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LOAD_MODEL_YEAR_SUCCESS = exports.LOAD_MODEL_YEAR_SUCCESS = 'LOAD_MODEL_YEAR_SUCCESS';
var CHANGE_BUILD_AND_QUOTE_SECTION = exports.CHANGE_BUILD_AND_QUOTE_SECTION = 'CHANGE_BUILD_AND_QUOTE_SECTION';

var SET_MODEL_YEARS = exports.SET_MODEL_YEARS = 'SET_MODEL_YEARS';
var SET_MODEL_TRIMS = exports.SET_MODEL_TRIMS = 'SET_MODEL_TRIMS';
var SET_DRIVE_POWER_TRAINS = exports.SET_DRIVE_POWER_TRAINS = 'SET_DRIVE_POWER_TRAINS';
var SET_OPTIONS_PACKAGES = exports.SET_OPTIONS_PACKAGES = 'SET_OPTIONS_PACKAGES';

exports.default = {
    LOAD_MODEL_YEAR_SUCCESS: LOAD_MODEL_YEAR_SUCCESS,
    SET_MODEL_YEARS: SET_MODEL_YEARS,
    SET_MODEL_TRIMS: SET_MODEL_TRIMS,
    SET_DRIVE_POWER_TRAINS: SET_DRIVE_POWER_TRAINS,
    SET_OPTIONS_PACKAGES: SET_OPTIONS_PACKAGES,
    CHANGE_BUILD_AND_QUOTE_SECTION: CHANGE_BUILD_AND_QUOTE_SECTION
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/actions/modelYearActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setModelYear = setModelYear;
exports.loadModelYearSuccess = loadModelYearSuccess;
exports.setModelYears = setModelYears;
exports.setModelTrims = setModelTrims;
exports.setDrivePowerTrains = setDrivePowerTrains;
exports.setOptionsPackages = setOptionsPackages;
exports.loadModelYears = loadModelYears;
exports.loadModelYearFromQuote = loadModelYearFromQuote;
exports.loadModelYear = loadModelYear;
exports.validateSelectedOptions = validateSelectedOptions;
exports.loadOptions = loadOptions;
exports.updateSelectedPackageAmounts = updateSelectedPackageAmounts;
exports.updateFromQuote = updateFromQuote;

var _modelYearActionTypes = __webpack_require__("../widget-commons-vehicle/src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ShowroomService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

var _quoteActions = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActions.js");

var QuoteActions = _interopRequireWildcard(_quoteActions);

var _ModelYearAPIService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearAPIService/ModelYearAPIService.js");

var _ModelYearAPIService2 = _interopRequireDefault(_ModelYearAPIService);

var _ModelYearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActions.js");

var PurchaseMethodsActions = _interopRequireWildcard(_purchaseMethodsActions);

var _tradeInVehicleActions = __webpack_require__("../widget-commons-vehicle/src/Vehicle/actions/tradeInVehicleActions.js");

var TradeInVehicleActions = _interopRequireWildcard(_tradeInVehicleActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setModelYear(modelYear) {
    return { type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear };
}

function loadModelYearSuccess(modelYear) {
    return { type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear };
}

function setModelYears(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_MODEL_YEARS, modelYear: modelYear };
}

function setModelTrims(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_MODEL_TRIMS, modelYear: modelYear };
}

function setDrivePowerTrains(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_DRIVE_POWER_TRAINS, modelYear: modelYear };
}

function setOptionsPackages(modelYear) {
    return { type: _modelYearActionTypes2.default.SET_OPTIONS_PACKAGES, modelYear: modelYear };
}

function loadModelYears(modelYearsParams, tradeInVehicleParams, initialLoad) {
    return function (dispatch, getState) {
        return _ModelYearAPIService2.default.loadModelYears(modelYearsParams, tradeInVehicleParams).then(function (results) {
            var state = getState();
            var currentPurchaseMethods = state.purchaseMethods;
            var selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
            var modelYear = state.modelYear.modelTrims.size > 0 ? _ModelYearService2.default.resetPaymentsAndPurchaseAmounts(_ModelYearService2.default.resetModelYears(state.modelYear, results.years), currentPurchaseMethods) : _ModelYearService2.default.resetModelYears(state.modelYear, results.years);

            modelYear = _ModelYearService2.default.selectPurchaseMethod(modelYear, initialLoad ? _purchaseMethods.BEST_PAYMENT : selectedPurchaseMethod);

            dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(modelYear.getSelectedYearPurchaseMethods()));
            dispatch(setModelYear(modelYear));

            if (results.tradeInVehicle && results.tradeInVehicle.id) {
                dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
            } else {
                var defaultPurchaseMethods = new _PurchaseMethodsModel2.default();
                dispatch(PurchaseMethodsActions.setTradeIn(defaultPurchaseMethods.tradeIn));
                dispatch(PurchaseMethodsActions.setLien(defaultPurchaseMethods.lien));
            }

            var paymentFrequency = _widgetCommonsGeneral.LocalStorageService.get('paymentFrequency');
            if (paymentFrequency) {
                dispatch(PurchaseMethodsActions.selectPaymentFrequency({
                    value: parseInt(paymentFrequency, 10)
                }));
            }
        }).catch(function (error) {
            throw error;
        });
    };
}

function loadModelYearFromQuote(quote) {
    return function (dispatch) {
        var vehicle = quote.vehicle;

        var modelYearsParams = {
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            bodyStyleCode: vehicle.bodyStyleCode,
            modelTrimCode: vehicle.modelTrimCode,
            quoteId: quote.id
        };
        var tradeInVehicleParams = {
            id: ''
        };
        return _ModelYearAPIService2.default.loadModelYear(modelYearsParams, tradeInVehicleParams).then(function (results) {
            return dispatch(loadModelYearSuccess(results.modelYear));
        });
    };
}

function loadModelYear(modelYearsParams, tradeInVehicleParams) {
    return function (dispatch, getState) {
        return _ModelYearAPIService2.default.loadModelYear(modelYearsParams, tradeInVehicleParams).then(function (results) {
            var state = getState();
            var currentPurchaseMethods = state.purchaseMethods;
            var selectedPurchaseMethod = currentPurchaseMethods.getSelectedPurchaseMethod();
            var modelYear = state.modelYear.modelYearsAreLoaded() ? _ModelYearService2.default.resetPaymentsAndPurchaseAmounts(_ModelYearService2.default.resetModelYears(results.modelYear, state.modelYear.years, modelYearsParams.year), currentPurchaseMethods) : results.modelYear;
            modelYear = _ModelYearService2.default.selectPurchaseMethod(modelYear, selectedPurchaseMethod);

            dispatch(setModelYear(modelYear));
            var cabSizes = results.modelYear.cabSizes;

            if (cabSizes && cabSizes.length) {
                modelYear = _ModelYearService2.default.setSelectedCabSize(modelYear, cabSizes[0]);
            } else {
                var modelTrims = results.modelYear.modelTrims;

                if (modelTrims.size > 0) {
                    if (modelYearsParams.modelTrimCode) {
                        var newOptionsPackage = modelYear.optionsPackages.filter(function (optionsPackage) {
                            return optionsPackage.configuration.modelTrimCode === modelYearsParams.modelTrimCode;
                        }).first();
                        var modelTrimSelectionCode = newOptionsPackage ? newOptionsPackage.configuration.modelTrim.selectionCode : '';
                        var newModelTrim = modelTrimSelectionCode ? modelYear.modelTrims.filter(function (modelTrim) {
                            return modelTrim.selectionCode === modelTrimSelectionCode;
                        }).first() : state.modelYear.modelTrims.first();

                        modelYear = _ModelYearService2.default.setSelectedModelTrim(modelYear, newModelTrim);
                    } else {
                        modelYear = _ModelYearService2.default.setSelectedModelTrim(modelYear, modelTrims.first());
                    }
                }
            }
            var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();

            var exteriorColour = null;
            if (selectedOptionsPackage) {
                dispatch(setModelYear(modelYear));
                dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));

                var interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();
                if (interiorColour) {
                    var interiorColourAmounts = {
                        retail: interiorColour.retail,
                        residualRetail: interiorColour.residualRetail
                    };
                    dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
                }

                exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();
                if (exteriorColour) {
                    var exteriorColourAmounts = {
                        retail: exteriorColour.retail,
                        residualRetail: exteriorColour.residualRetail
                    };
                    dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
                }
            }

            if (results.tradeInVehicle && results.tradeInVehicle.id) {
                dispatch(TradeInVehicleActions.setTradeInVehicle(results.tradeInVehicle));
                dispatch(PurchaseMethodsActions.setTradeIn(results.tradeInVehicle.getTradeInAmount()));
                dispatch(PurchaseMethodsActions.setLien(results.tradeInVehicle.getLienAmount()));
            }

            var paymentFrequency = _widgetCommonsGeneral.LocalStorageService.get('paymentFrequency');
            if (!modelYearsParams.quoteId && paymentFrequency) {
                dispatch(PurchaseMethodsActions.selectPaymentFrequency({
                    value: parseInt(paymentFrequency, 10)
                }));
            }
        }).catch(function (error) {
            throw error;
        });
    };
}

function validateSelectedOptions(currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var configuration = modelYear ? modelYear.getSelectedOptionsPackageConfiguration() : null;
        if (!configuration) {
            return Promise.reject();
        }

        var _modelYear = modelYear,
            year = _modelYear.year,
            make = _modelYear.make;

        var locale = _widgetCommonsCoreServices.LocaleService.getLocale();

        return _ShowroomService2.default.validateSelectedOptions(DataOrigins.OPTIONS_VALIDATION, year, make, configuration, locale, '', null).then(function (_ref) {
            var configurationToken = _ref.configurationToken,
                items = _ref.items;

            modelYear = _ModelYearService2.default.resetConfigurationToken(modelYear, configurationToken);
            modelYear = _ModelYearService2.default.resetOptionsAvailability(modelYear, items);
            dispatch(setOptionsPackages(modelYear));
        });
    };
}

function loadOptionsSuccess(options, modelYear) {
    return function (dispatch, getState) {
        var newModelYear = modelYear || getState().modelYear;
        newModelYear = _ModelYearService2.default.setAvailableOptions(newModelYear, options);
        var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();

        if (selectedOptionsPackage) {
            dispatch(setOptionsPackages(newModelYear));
            dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
        }
        return newModelYear;
    };
}

function loadOptions(modelYear) {
    var year = modelYear.year,
        make = modelYear.make;

    var configuration = modelYear.getSelectedOptionsPackageConfiguration();
    return function (dispatch) {
        return _ShowroomService2.default.loadModelTrimOptions(year, make, configuration).then(function (options) {
            return dispatch(loadOptionsSuccess(options, modelYear));
        }).catch(function (error) {
            throw error;
        });
    };
}
function updateExteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var exteriorColour = modelYear.getSelectedOptionsPackageExteriorColour();

        if (exteriorColour) {
            var exteriorColourAmounts = {
                retail: exteriorColour.retail,
                residualRetail: exteriorColour.residualRetail
            };
            dispatch(PurchaseMethodsActions.setExteriorColourAmounts(exteriorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}

function updateInteriorColourAmounts(skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var modelYear = currentModelYear || getState().modelYear;
        var interiorColour = modelYear.getSelectedOptionsPackageInteriorColour();

        if (interiorColour) {
            var interiorColourAmounts = {
                retail: interiorColour.retail,
                residualRetail: interiorColour.residualRetail
            };
            dispatch(PurchaseMethodsActions.setInteriorColourAmounts(interiorColourAmounts));
            if (!skipOptionsValidation) {
                dispatch(validateSelectedOptions(modelYear));
            }
        }
    };
}
function updateSelectedPackageAmounts(selectedOptionsPackage, skipOptionsValidation, currentModelYear) {
    return function (dispatch, getState) {
        var exteriorColour = selectedOptionsPackage.configuration.getSelectedExteriorColour();
        var interiorColour = selectedOptionsPackage.configuration.getSelectedInteriorColour();
        var modelYear = currentModelYear || getState().modelYear;

        if (exteriorColour || interiorColour) {
            if (exteriorColour) {
                modelYear = _ModelYearService2.default.setSelectedExteriorColour(modelYear, exteriorColour);
            }
            if (interiorColour) {
                modelYear = _ModelYearService2.default.setSelectedInteriorColour(modelYear, interiorColour);
            }
            dispatch({ type: _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS, modelYear: modelYear });
        }

        dispatch(PurchaseMethodsActions.loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
        dispatch(updateInteriorColourAmounts(true, modelYear));
        dispatch(updateExteriorColourAmounts(skipOptionsValidation, modelYear));
    };
}

function updateFromQuote(quoteId, bqConfirmation) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.quote && state.quote.id !== quoteId) {
            return Promise.resolve();
        }
        var newModelYear = _ModelYearService2.default.resetModelYearFromQuote(state.modelYear, state.quote);
        dispatch(loadModelYearSuccess(newModelYear));
        return dispatch(loadOptions(newModelYear)).then(function () {
            var selectedOptionsPackage = newModelYear.getSelectedOptionsPackage();
            if (selectedOptionsPackage) {
                state = getState();
                newModelYear = _ModelYearService2.default.resetModelYearOptionsFromQuote(state.modelYear, state.quote);
                dispatch(loadModelYearSuccess(newModelYear));
                if (bqConfirmation) {
                    dispatch(validateSelectedOptions(newModelYear, true)).then(function () {
                        dispatch(QuoteActions.setQuote(state.quote.set('modified', false)));
                    });
                }
                return dispatch(updateSelectedPackageAmounts(selectedOptionsPackage, true));
            }
            return Promise.resolve();
        });
    };
}

exports.default = {
    setModelYear: setModelYear,
    setModelYears: setModelYears,
    setModelTrims: setModelTrims,
    setDrivePowerTrains: setDrivePowerTrains,
    setOptionsPackages: setOptionsPackages,
    loadModelYears: loadModelYears,
    loadModelYear: loadModelYear,
    validateSelectedOptions: validateSelectedOptions,
    updateFromQuote: updateFromQuote,
    loadOptions: loadOptions,
    loadModelYearFromQuote: loadModelYearFromQuote,
    updateExteriorColourAmounts: updateExteriorColourAmounts,
    updateSelectedPackageAmounts: updateSelectedPackageAmounts
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var IMAGE_STATUS = exports.IMAGE_STATUS = {
    NO_IMAGE: 0,
    IMAGE_FROM_PREVIOUS_YEAR: 1,
    IMAGE_FROM_PREVIOUS_TRIM: 2,
    MAIN_IMAGE: 3,
    PARTIAL_COLORIZED: 4,
    FULL_COLORIZED: 5
};

exports.default = {
    IMAGE_STATUS: IMAGE_STATUS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"engine":{"size":"%{displacement}L %{cylinders}cyl.","sizeTurbo":"%{displacement}L %{cylinders}cyl. turbo","power":"%{hp}hp / %{torque}lb. ft. torque"},"transmission":{"types":"%{type}","speeds":"%{speeds} speed","cvt":"%{type} CVT","typesSpeeds":"%{type} %{speeds} speed"},"fuel":{"city":"City: ","highway":"Hwy: ","100km":"L / 100km"}}

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"engine":{"size":"%{displacement}L %{cylinders}cyl.","sizeTurbo":"%{displacement}L %{cylinders}cyl. turbo","power":"%{hp}hp / %{torque}lb. pi. de couple"},"transmission":{"types":"%{type}","speeds":"%{speeds} vitesses","cvt":"%{type} CVT","typesSpeeds":"%{type} %{speeds} vitesses"},"fuel":{"city":"Ville: ","highway":"Route: ","100km":"L / 100km"}}

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EXTERIOR_COLOUR_STATUSES = exports.YearService = exports.TransmissionService = exports.OptionsPackageService = exports.OptionService = exports.ModelYearService = exports.ModelTrimService = exports.ModelTrimItemsService = exports.ModelTrimConfigurationService = exports.EngineService = exports.DriveTrainService = exports.DrivePowerTrainService = exports.DataUtilitiesService = exports.ColourService = exports.ModelYearReducer = exports.YearModel = exports.TransmissionModel = exports.OptionsPackageModel = exports.OptionModel = exports.ModelYearModel = exports.ModelTrimModel = exports.ModelTrimConfigurationModel = exports.FeatureModel = exports.FeatureIconModel = exports.EngineModel = exports.DriveTrainModel = exports.DrivePowerTrainModel = exports.ColourModel = exports.BoxSizeModel = exports.CabSizeModel = exports.Translations = exports.ModelYearActionsTypes = exports.ModelYearActions = undefined;

var _modelYearActions = __webpack_require__("../widget-commons-vehicle/src/ModelYear/actions/modelYearActions.js");

var _modelYearActions2 = _interopRequireDefault(_modelYearActions);

var _modelYearActionTypes = __webpack_require__("../widget-commons-vehicle/src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _en = __webpack_require__("../widget-commons-vehicle/src/ModelYear/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("../widget-commons-vehicle/src/ModelYear/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _CabSizeModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/CabSizeModel.js");

var _CabSizeModel2 = _interopRequireDefault(_CabSizeModel);

var _BoxSizeModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/BoxSizeModel.js");

var _BoxSizeModel2 = _interopRequireDefault(_BoxSizeModel);

var _ColourModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ColourModel.js");

var _ColourModel2 = _interopRequireDefault(_ColourModel);

var _DrivePowerTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DrivePowerTrainModel.js");

var _DrivePowerTrainModel2 = _interopRequireDefault(_DrivePowerTrainModel);

var _DriveTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _FeatureIconModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/FeatureIconModel.js");

var _FeatureIconModel2 = _interopRequireDefault(_FeatureIconModel);

var _FeatureModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/FeatureModel.js");

var _FeatureModel2 = _interopRequireDefault(_FeatureModel);

var _ModelTrimConfigurationModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

var _ModelTrimModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelTrimModel.js");

var _ModelTrimModel2 = _interopRequireDefault(_ModelTrimModel);

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _OptionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionModel.js");

var _OptionModel2 = _interopRequireDefault(_OptionModel);

var _OptionsPackageModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionsPackageModel.js");

var _OptionsPackageModel2 = _interopRequireDefault(_OptionsPackageModel);

var _TransmissionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _YearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _modelYearReducer = __webpack_require__("../widget-commons-vehicle/src/ModelYear/reducers/modelYearReducer.js");

var _modelYearReducer2 = _interopRequireDefault(_modelYearReducer);

var _ColourService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ColourService/ColourService.js");

var _ColourService2 = _interopRequireDefault(_ColourService);

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _DataUtilitiesService2 = _interopRequireDefault(_DataUtilitiesService);

var _DrivePowerTrainService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js");

var _DrivePowerTrainService2 = _interopRequireDefault(_DrivePowerTrainService);

var _DriveTrainService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DriveTrainService/DriveTrainService.js");

var _DriveTrainService2 = _interopRequireDefault(_DriveTrainService);

var _EngineService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/EngineService/EngineService.js");

var _EngineService2 = _interopRequireDefault(_EngineService);

var _ModelTrimConfigurationService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js");

var _ModelTrimConfigurationService2 = _interopRequireDefault(_ModelTrimConfigurationService);

var _ModelTrimItemsService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _ModelTrimItemsService2 = _interopRequireDefault(_ModelTrimItemsService);

var _ModelTrimService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimService/ModelTrimService.js");

var _ModelTrimService2 = _interopRequireDefault(_ModelTrimService);

var _ModelYearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

var _OptionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js");

var _OptionService2 = _interopRequireDefault(_OptionService);

var _OptionsPackageService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionsPackageService/OptionsPackageService.js");

var _OptionsPackageService2 = _interopRequireDefault(_OptionsPackageService);

var _TransmissionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/TransmissionService/TransmissionService.js");

var _TransmissionService2 = _interopRequireDefault(_TransmissionService);

var _YearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/YearService/YearService.js");

var _YearService2 = _interopRequireDefault(_YearService);

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _exteriorColourStatuses2 = _interopRequireDefault(_exteriorColourStatuses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

exports.ModelYearActions = _modelYearActions2.default;
exports.ModelYearActionsTypes = _modelYearActionTypes2.default;
exports.Translations = Translations;
exports.CabSizeModel = _CabSizeModel2.default;
exports.BoxSizeModel = _BoxSizeModel2.default;
exports.ColourModel = _ColourModel2.default;
exports.DrivePowerTrainModel = _DrivePowerTrainModel2.default;
exports.DriveTrainModel = _DriveTrainModel2.default;
exports.EngineModel = _EngineModel2.default;
exports.FeatureIconModel = _FeatureIconModel2.default;
exports.FeatureModel = _FeatureModel2.default;
exports.ModelTrimConfigurationModel = _ModelTrimConfigurationModel2.default;
exports.ModelTrimModel = _ModelTrimModel2.default;
exports.ModelYearModel = _ModelYearModel2.default;
exports.OptionModel = _OptionModel2.default;
exports.OptionsPackageModel = _OptionsPackageModel2.default;
exports.TransmissionModel = _TransmissionModel2.default;
exports.YearModel = _YearModel2.default;
exports.ModelYearReducer = _modelYearReducer2.default;
exports.ColourService = _ColourService2.default;
exports.DataUtilitiesService = _DataUtilitiesService2.default;
exports.DrivePowerTrainService = _DrivePowerTrainService2.default;
exports.DriveTrainService = _DriveTrainService2.default;
exports.EngineService = _EngineService2.default;
exports.ModelTrimConfigurationService = _ModelTrimConfigurationService2.default;
exports.ModelTrimItemsService = _ModelTrimItemsService2.default;
exports.ModelTrimService = _ModelTrimService2.default;
exports.ModelYearService = _ModelYearService2.default;
exports.OptionService = _OptionService2.default;
exports.OptionsPackageService = _OptionsPackageService2.default;
exports.TransmissionService = _TransmissionService2.default;
exports.YearService = _YearService2.default;
exports.EXTERIOR_COLOUR_STATUSES = _exteriorColourStatuses2.default;
exports.default = {
    ModelYearActions: _modelYearActions2.default,
    ModelYearActionsTypes: _modelYearActionTypes2.default,

    Translations: Translations,

    CabSizeModel: _CabSizeModel2.default,
    BoxSizeModel: _BoxSizeModel2.default,
    ColourModel: _ColourModel2.default,
    DrivePowerTrainModel: _DrivePowerTrainModel2.default,
    DriveTrainModel: _DriveTrainModel2.default,
    EngineModel: _EngineModel2.default,
    FeatureIconModel: _FeatureIconModel2.default,
    FeatureModel: _FeatureModel2.default,
    ModelTrimConfigurationModel: _ModelTrimConfigurationModel2.default,
    ModelTrimModel: _ModelTrimModel2.default,
    ModelYearModel: _ModelYearModel2.default,
    OptionModel: _OptionModel2.default,
    OptionsPackageModel: _OptionsPackageModel2.default,
    TransmissionModel: _TransmissionModel2.default,
    YearModel: _YearModel2.default,
    ModelYearReducer: _modelYearReducer2.default,

    ColourService: _ColourService2.default,
    DataUtilitiesService: _DataUtilitiesService2.default,
    DrivePowerTrainService: _DrivePowerTrainService2.default,
    DriveTrainService: _DriveTrainService2.default,
    EngineService: _EngineService2.default,
    ModelTrimConfigurationService: _ModelTrimConfigurationService2.default,
    ModelTrimItemsService: _ModelTrimItemsService2.default,
    ModelTrimService: _ModelTrimService2.default,
    ModelYearService: _ModelYearService2.default,
    OptionService: _OptionService2.default,
    OptionsPackageService: _OptionsPackageService2.default,
    TransmissionService: _TransmissionService2.default,
    YearService: _YearService2.default,

    EXTERIOR_COLOUR_STATUSES: _exteriorColourStatuses2.default
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/BoxSizeModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoxSizeRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {}
});

var BoxSize = function (_BoxSizeRecord) {
    _inherits(BoxSize, _BoxSizeRecord);

    function BoxSize() {
        _classCallCheck(this, BoxSize);

        return _possibleConstructorReturn(this, (BoxSize.__proto__ || Object.getPrototypeOf(BoxSize)).apply(this, arguments));
    }

    return BoxSize;
}(BoxSizeRecord);

exports.default = BoxSize;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/CabSizeModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CabSizeRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configurationIds: {}
});

var CabSize = function (_CabSizeRecord) {
    _inherits(CabSize, _CabSizeRecord);

    function CabSize() {
        _classCallCheck(this, CabSize);

        return _possibleConstructorReturn(this, (CabSize.__proto__ || Object.getPrototypeOf(CabSize)).apply(this, arguments));
    }

    return CabSize;
}(CabSizeRecord);

exports.default = CabSize;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/ColourModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColourRecord = (0, _immutable.Record)({
    colourCode: '',
    colourDescription: '',
    fabricDescription: '',
    selected: false,
    enabled: true,
    visible: true,
    colourTile: '',
    photo1: '',
    photo2: '',
    photo3: '',
    retail: 0,
    residualRetail: 0
});

var Colour = function (_ColourRecord) {
    _inherits(Colour, _ColourRecord);

    function Colour() {
        _classCallCheck(this, Colour);

        return _possibleConstructorReturn(this, (Colour.__proto__ || Object.getPrototypeOf(Colour)).apply(this, arguments));
    }

    _createClass(Colour, [{
        key: 'getColourCode',
        value: function getColourCode() {
            return this.get('colourCode');
        }
    }, {
        key: 'getColourSelectionCode',
        value: function getColourSelectionCode() {
            return this.colourCode + '>' + _dataTypes.SUPPLIER_OPTION;
        }
    }]);

    return Colour;
}(ColourRecord);

exports.default = Colour;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/DrivePowerTrainModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _DriveTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DrivePowerTrainRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    rank: 0,
    driveTrain: new _DriveTrainModel2.default(),
    engine: new _EngineModel2.default(),
    transmission: new _TransmissionModel2.default(),
    configurationIds: {},
    bestOptionsPackageCode: ''
});

var DrivePowerTrain = function (_DrivePowerTrainRecor) {
    _inherits(DrivePowerTrain, _DrivePowerTrainRecor);

    function DrivePowerTrain() {
        _classCallCheck(this, DrivePowerTrain);

        return _possibleConstructorReturn(this, (DrivePowerTrain.__proto__ || Object.getPrototypeOf(DrivePowerTrain)).apply(this, arguments));
    }

    _createClass(DrivePowerTrain, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return DrivePowerTrain;
}(DrivePowerTrainRecord);

exports.default = DrivePowerTrain;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/DriveTrainModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DriveTrainRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    code: '',
    rank: 0,
    description: '',
    longDescription: ''
});

var DriveTrain = function (_DriveTrainRecord) {
    _inherits(DriveTrain, _DriveTrainRecord);

    function DriveTrain() {
        _classCallCheck(this, DriveTrain);

        return _possibleConstructorReturn(this, (DriveTrain.__proto__ || Object.getPrototypeOf(DriveTrain)).apply(this, arguments));
    }

    _createClass(DriveTrain, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return DriveTrain;
}(DriveTrainRecord);

exports.default = DriveTrain;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/EngineModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EngineRecord = (0, _immutable.Record)({
    selectionCode: '0L-0C-0',
    code: '',
    fuelTypeCode: 0,
    cylinders: 0,
    displacement: 0,
    isTurbo: false,
    hp: 0,
    hpRpm: 0,
    torque: 0,
    torqueRpm: 0
});

var Engine = function (_EngineRecord) {
    _inherits(Engine, _EngineRecord);

    function Engine() {
        _classCallCheck(this, Engine);

        return _possibleConstructorReturn(this, (Engine.__proto__ || Object.getPrototypeOf(Engine)).apply(this, arguments));
    }

    _createClass(Engine, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getSizeSpecifications',
        value: function getSizeSpecifications() {
            return this.get('isTurbo') ? _widgetCommonsCoreServices.LocaleService.t('engine.sizeTurbo', {
                displacement: this.get('displacement'),
                cylinders: this.get('cylinders')
            }) : _widgetCommonsCoreServices.LocaleService.t('engine.size', {
                displacement: this.get('displacement'),
                cylinders: this.get('cylinders')
            });
        }
    }, {
        key: 'getPowerSpecifications',
        value: function getPowerSpecifications() {
            if (this.hp === 0 || this.torque === 0) {
                return '';
            }
            return _widgetCommonsCoreServices.LocaleService.t('engine.power', { hp: this.get('hp'), torque: this.get('torque') });
        }
    }]);

    return Engine;
}(EngineRecord);

exports.default = Engine;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/FeatureIconModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureIconRecord = (0, _immutable.Record)({
    code: '',
    description: '',
    rank: _dataTypes.DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: _dataTypes.DEFAULT_KEY_ORDER
});

var FeatureIcon = function (_FeatureIconRecord) {
    _inherits(FeatureIcon, _FeatureIconRecord);

    function FeatureIcon() {
        _classCallCheck(this, FeatureIcon);

        return _possibleConstructorReturn(this, (FeatureIcon.__proto__ || Object.getPrototypeOf(FeatureIcon)).apply(this, arguments));
    }

    return FeatureIcon;
}(FeatureIconRecord);

exports.default = FeatureIcon;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/FeatureModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeatureRecord = (0, _immutable.Record)({
    code: '',
    description: '',
    dataTypeId: 0,
    typeIds: [],
    iconTypeCodes: [],
    isStandard: false,
    rank: _dataTypes.DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: _dataTypes.DEFAULT_KEY_ORDER
});

var Feature = function (_FeatureRecord) {
    _inherits(Feature, _FeatureRecord);

    function Feature() {
        _classCallCheck(this, Feature);

        return _possibleConstructorReturn(this, (Feature.__proto__ || Object.getPrototypeOf(Feature)).apply(this, arguments));
    }

    return Feature;
}(FeatureRecord);

exports.default = Feature;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/ModelTrimConfigurationModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _DriveTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

var _EngineModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelTrimConfigurationRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    id: 0,
    rank: 0,
    modelTrimCode: '',
    modelTrimCodeId: '',
    modelTrimRank: 0,
    packageSelectionCode: '',
    packageCode: '',
    modelTrim: {
        trimsBitField: 0,
        trimsBitFields: [],
        selectionCode: '',
        code: '',
        description: '',
        extensionCode: '',
        extensionDescription: ''
    },
    package: {
        code: '',
        description: ''
    },
    configurationToken: '',
    cabSizeSelectionCode: '',
    cabSize: null,
    boxSizeSelectionCode: '',
    boxSize: null,
    driveTrainSelectionCode: '',
    driveTrain: new _DriveTrainModel2.default(),
    engine: new _EngineModel2.default(),
    transmission: new _TransmissionModel2.default(),
    purchaseMethods: new _PurchaseMethodsModel2.default(),
    seating: 0,
    fuelCity: 0.0,
    fuelHighway: 0.0,
    modelTrimFeatures: {},
    features: {},
    featureIcons: (0, _immutable.List)([]),
    nonModelTrimFeatureIconsCount: 0,
    configurationOptions: [],
    exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
    exteriorColours: (0, _immutable.List)([]),
    interiorColours: (0, _immutable.List)([]),
    options: [],
    smNewTrimCarId: 0,
    smNewCarId: 0,
    configurationItemsAreLoaded: false,
    optionsTotalRetail: 0,
    optionsTotalResidualRetail: 0
});

var ModelTrimConfiguration = function (_ModelTrimConfigurati) {
    _inherits(ModelTrimConfiguration, _ModelTrimConfigurati);

    function ModelTrimConfiguration() {
        _classCallCheck(this, ModelTrimConfiguration);

        return _possibleConstructorReturn(this, (ModelTrimConfiguration.__proto__ || Object.getPrototypeOf(ModelTrimConfiguration)).apply(this, arguments));
    }

    _createClass(ModelTrimConfiguration, [{
        key: 'getSelectedExteriorColour',
        value: function getSelectedExteriorColour() {
            var availableExteriorColours = this.exteriorColours.filter(function (colour) {
                return colour.selected;
            });
            if (availableExteriorColours.size === 1) {
                return availableExteriorColours.first();
            }
            return '';
        }
    }, {
        key: 'getSelectedInteriorColour',
        value: function getSelectedInteriorColour() {
            var availableInteriorColours = this.interiorColours.filter(function (colour) {
                return colour.selected;
            });
            if (availableInteriorColours.size === 1) {
                return availableInteriorColours.first();
            }
            return '';
        }
    }, {
        key: 'getSelectedOptions',
        value: function getSelectedOptions() {
            return (0, _lodash.flatten)((0, _lodash.map)(this.options, function (option) {
                return option.getSelectedItemsAndPackages();
            }));
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            return (0, _lodash.flatten)((0, _lodash.map)(this.options, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getExteriorColourOptions',
        value: function getExteriorColourOptions() {
            var exteriorColourItems = (0, _lodash.filter)(this.options, function (option) {
                return option.id === _modelTrimItemCategories.EXTERIOR_COLOUR;
            });
            return (0, _lodash.flatten)((0, _lodash.map)(exteriorColourItems, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getInteriorColourOptions',
        value: function getInteriorColourOptions() {
            var exteriorColourItems = (0, _lodash.filter)(this.options, function (option) {
                return option.id === _modelTrimItemCategories.INTERIOR_TRIM;
            });
            return (0, _lodash.flatten)((0, _lodash.map)(exteriorColourItems, function (option) {
                return (0, _lodash.concat)(option.itemsPackages, option.items);
            }));
        }
    }, {
        key: 'getValidationSelectedOptions',
        value: function getValidationSelectedOptions() {
            var selectedExteriorColour = this.getSelectedExteriorColour();
            var selectedInteriorColour = this.getSelectedInteriorColour();
            var isCashPurchase = this.purchaseMethods.cashPurchase.selected;
            var selectedOptions = (0, _lodash.map)(this.getSelectedOptions(), function (option) {
                return option.getValidationOption(isCashPurchase);
            });

            var selectedItems = [];
            if (selectedExteriorColour) {
                selectedItems.push({
                    code: selectedExteriorColour.colourCode,
                    supplier: _dataTypes.SUPPLIER_OPTION,
                    flag: _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED,
                    amounts: {
                        retail: selectedExteriorColour.retail,
                        residualizingAmount: selectedExteriorColour.residualRetail
                    }
                });
            }
            if (selectedInteriorColour) {
                selectedItems.push({
                    code: selectedInteriorColour.colourCode,
                    supplier: _dataTypes.SUPPLIER_OPTION,
                    flag: _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED,
                    amounts: {
                        retail: selectedInteriorColour.retail,
                        residualizingAmount: selectedInteriorColour.residualRetail
                    }
                });
            }

            return (0, _lodash.unionBy)(selectedOptions, selectedItems, 'code');
        }
    }, {
        key: 'getConfigurationOptionsSelectionCodes',
        value: function getConfigurationOptionsSelectionCodes() {
            return (0, _lodash.map)(this.configurationOptions, function (configurationOption) {
                return configurationOption.selectionCode;
            });
        }
    }, {
        key: 'getOptionsSelectionCodes',
        value: function getOptionsSelectionCodes() {
            var selectedExteriorColour = this.getSelectedExteriorColour();
            var selectedInteriorColour = this.getSelectedInteriorColour();
            var selectedOptions = (0, _lodash.map)(this.getSelectedOptions(), function (option) {
                return option.selectionCode;
            });

            var selectedItems = [];
            if (selectedExteriorColour) {
                selectedItems.push(selectedExteriorColour.getColourSelectionCode());
            }
            if (selectedInteriorColour) {
                selectedItems.push(selectedInteriorColour.getColourSelectionCode());
            }

            return (0, _lodash.union)(selectedOptions, selectedItems);
        }
    }, {
        key: 'getPurchaseMethodsSelectedOptions',
        value: function getPurchaseMethodsSelectedOptions() {
            var configurationOptionsCodes = (0, _lodash.map)(this.configurationOptions, function (configurationOption) {
                return configurationOption.selectionCode;
            });
            return (0, _lodash.filter)(this.purchaseMethods.selectedOptions, function (option) {
                return option.dataType === _dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < _dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > _dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM) && !(0, _lodash.includes)(configurationOptionsCodes, option.selectionCode);
            });
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            return this.purchaseMethods.getEmployeeRebate();
        }
    }]);

    return ModelTrimConfiguration;
}(ModelTrimConfigurationRecord);

exports.default = ModelTrimConfiguration;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/ModelTrimModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModelTrimRecord = (0, _immutable.Record)({
    cabSizeTrimsBitField: 0,
    cabSizeTrimsBitFields: [],
    boxSizeTrimsBitField: 0,
    boxSizeTrimsBitFields: [],
    trimsBitField: 0,
    trimsBitFields: [],
    trimCode: '',
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    trimExtensionCode: '',
    trimExtensionDescription: '',
    rank: 0,
    configurationIds: {},
    features: {},
    featureIcons: {},
    comparisonModelTrimCode: '',
    comparisonModelTrim: '',
    comparisonModelTrimExtension: '',
    comparisonAddFeatures: {},
    comparisonRemoveFeatures: {},
    comparisonAddFeatureIcons: {}
});

var ModelTrim = function (_ModelTrimRecord) {
    _inherits(ModelTrim, _ModelTrimRecord);

    function ModelTrim() {
        _classCallCheck(this, ModelTrim);

        return _possibleConstructorReturn(this, (ModelTrim.__proto__ || Object.getPrototypeOf(ModelTrim)).apply(this, arguments));
    }

    _createClass(ModelTrim, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getModelTrimFullDescription',
        value: function getModelTrimFullDescription() {
            return this.trimExtensionDescription ? this.description + ' ' + this.trimExtensionDescription : this.description;
        }

        /**
         * Return the Model Trim description or an empty string if it repeats or contain the Model Name.
         * @param {string} modelName the name of the model
         * @returns {string} description
         */

    }, {
        key: 'getDescription',
        value: function getDescription(modelName) {
            if (!modelName) {
                return this.description;
            }

            return modelName === this.description || modelName.includes(this.description) ? '' : this.description;
        }
    }]);

    return ModelTrim;
}(ModelTrimRecord);

exports.default = ModelTrim;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _YearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-bitwise: 0 */

var ModelYearRecord = (0, _immutable.Record)({
    year: 0,
    make: '',
    model: '',
    bodyStyleCode: '',
    isSingleConfiguration: false,
    hasOptions: true,
    cabSizes: [],
    boxSizes: [],
    modelTrims: (0, _immutable.List)([]),
    drivePowerTrains: (0, _immutable.List)([]),
    optionsPackages: (0, _immutable.List)([]),
    years: (0, _immutable.List)([new _YearModel2.default()])
});

var ModelYear = function (_ModelYearRecord) {
    _inherits(ModelYear, _ModelYearRecord);

    function ModelYear() {
        _classCallCheck(this, ModelYear);

        return _possibleConstructorReturn(this, (ModelYear.__proto__ || Object.getPrototypeOf(ModelYear)).apply(this, arguments));
    }

    _createClass(ModelYear, [{
        key: 'getAvailableModelTrims',
        value: function getAvailableModelTrims() {
            return this.modelTrims.filter(function (modelTrim) {
                return modelTrim.visible;
            });
        }
    }, {
        key: 'modelYearsAreLoaded',
        value: function modelYearsAreLoaded() {
            var selectedYear = this.getSelectedYear();
            return selectedYear && selectedYear.year !== 0;
        }
    }, {
        key: 'modelYearIsLoaded',
        value: function modelYearIsLoaded() {
            var selectedYear = this.getSelectedYear();
            var selectedYearAsTrimsAndPowers = selectedYear && selectedYear.modelTrims.size > 0;

            return selectedYearAsTrimsAndPowers && selectedYear.year === this.year;
        }
    }, {
        key: 'getSelectedYear',
        value: function getSelectedYear() {
            return this.years.filter(function (year) {
                return year.selected;
            }).first();
        }
    }, {
        key: 'getSelectedYearPurchaseMethods',
        value: function getSelectedYearPurchaseMethods() {
            var selectedYear = this.getSelectedYear();
            return selectedYear ? selectedYear.purchaseMethods : undefined;
        }
    }, {
        key: 'getSelectedCabSize',
        value: function getSelectedCabSize() {
            return (0, _lodash.find)(this.cabSizes, function (cabSize) {
                return cabSize.selected;
            });
        }
    }, {
        key: 'getSelectedBoxSize',
        value: function getSelectedBoxSize() {
            return (0, _lodash.find)(this.boxSizes, function (boxSize) {
                return boxSize.selected;
            });
        }
    }, {
        key: 'getSelectedModelTrim',
        value: function getSelectedModelTrim() {
            return this.getAvailableModelTrims().filter(function (modelTrim) {
                return modelTrim.selected;
            }).first();
        }
    }, {
        key: 'getAvailableDriveTrains',
        value: function getAvailableDriveTrains() {
            return this.drivePowerTrains.filter(function (drivePowerTrain) {
                return drivePowerTrain.visible;
            });
        }
    }, {
        key: 'getSelectedDrivePowerTrain',
        value: function getSelectedDrivePowerTrain() {
            return this.getAvailableDriveTrains().filter(function (drivePowerTrain) {
                return drivePowerTrain.selected;
            }).first();
        }
    }, {
        key: 'getAvailableOptionsPackages',
        value: function getAvailableOptionsPackages() {
            return this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.visible;
            });
        }
    }, {
        key: 'getSelectedOptionsPackage',
        value: function getSelectedOptionsPackage() {
            return this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
        }
    }, {
        key: 'getSelectedOptionsPackageConfiguration',
        value: function getSelectedOptionsPackageConfiguration() {
            var selectedOptionsPackage = this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
            return selectedOptionsPackage ? selectedOptionsPackage.configuration : undefined;
        }
    }, {
        key: 'getOptionsPackageConfigurationFromCode',
        value: function getOptionsPackageConfigurationFromCode(optionsPackageCode) {
            var selectedOptionsPackage = this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.selectionCode === optionsPackageCode;
            }).first();

            return selectedOptionsPackage ? selectedOptionsPackage.configuration : undefined;
        }
    }, {
        key: 'getOptionsPackageFromConfigurationId',
        value: function getOptionsPackageFromConfigurationId(configurationId) {
            return this.optionsPackages.filter(function (optionsPackage) {
                return optionsPackage.configuration.id === configurationId;
            }).first();
        }
    }, {
        key: 'getBestAvailableOptionsPackageFromTrimsBitField',
        value: function getBestAvailableOptionsPackageFromTrimsBitField(trimsBitField, engineSelectionCode, transmissionSelectionCode) {
            var availableOptionsPackages = this.optionsPackages.filter(function (optionsPackage) {
                return (0, _DataUtilitiesService.intersectModelTrimsBitFieldValue)(optionsPackage, trimsBitField, false) > 0 && optionsPackage.configuration.engine.selectionCode === engineSelectionCode && optionsPackage.configuration.transmission.selectionCode === transmissionSelectionCode;
            });

            if (availableOptionsPackages.size === 0) {
                return '';
            }
            return availableOptionsPackages.minBy(function (optionsPackage) {
                return optionsPackage.rank;
            }).selectionCode;
        }
    }, {
        key: 'getSelectedOptionsPackageExteriorColour',
        value: function getSelectedOptionsPackageExteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.getSelectedExteriorColour() : '';
        }
    }, {
        key: 'getSelectedOptionsPackageInteriorColour',
        value: function getSelectedOptionsPackageInteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.getSelectedInteriorColour() : '';
        }
    }, {
        key: 'getSelectedOptionsPackageBestAvailableExteriorColour',
        value: function getSelectedOptionsPackageBestAvailableExteriorColour() {
            var configuration = this.getSelectedOptionsPackageConfiguration();
            return configuration ? configuration.exteriorColours.minBy(function (colour) {
                return colour.retail;
            }) : '';
        }
    }, {
        key: 'getSelectedOptionsPackagePurchaseMethods',
        value: function getSelectedOptionsPackagePurchaseMethods() {
            var selectedOptionsPackage = this.getAvailableOptionsPackages().filter(function (optionsPackage) {
                return optionsPackage.selected;
            }).first();
            return selectedOptionsPackage ? selectedOptionsPackage.configuration.purchaseMethods : undefined;
        }
    }, {
        key: 'getSelectedPurchaseMethods',
        value: function getSelectedPurchaseMethods() {
            if (this.modelTrims.size > 0) {
                return this.getSelectedOptionsPackagePurchaseMethods();
            } else if (this.modelYearsAreLoaded()) {
                return this.getSelectedYearPurchaseMethods();
            }
            return '';
        }
    }, {
        key: 'getPaymentCalculationWithTerm',
        value: function getPaymentCalculationWithTerm(term) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTerm(term) : '';
        }
    }, {
        key: 'getPaymentCalculationWithPaymentFrequency',
        value: function getPaymentCalculationWithPaymentFrequency(paymentFrequency) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithPaymentFrequency(paymentFrequency) : '';
        }
    }, {
        key: 'getPaymentCalculationWithCashDown',
        value: function getPaymentCalculationWithCashDown(cashDown) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithCashDown(cashDown) : '';
        }
    }, {
        key: 'getPaymentCalculationWithTradeIn',
        value: function getPaymentCalculationWithTradeIn(tradeIn) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTradeIn(tradeIn) : '';
        }
    }, {
        key: 'getPaymentCalculationWithLien',
        value: function getPaymentCalculationWithLien(lien) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithLien(lien) : '';
        }
    }, {
        key: 'getPaymentCalculationWithExteriorColour',
        value: function getPaymentCalculationWithExteriorColour(exteriorColourAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithInteriorColour',
        value: function getPaymentCalculationWithInteriorColour(interiorColourAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithOptions',
        value: function getPaymentCalculationWithOptions(optionsAmounts) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts) : '';
        }
    }, {
        key: 'getPaymentCalculationWithTaxesIncluded',
        value: function getPaymentCalculationWithTaxesIncluded(taxesIncluded) {
            var purchaseMethods = this.getSelectedPurchaseMethods();
            return purchaseMethods ? purchaseMethods.getPaymentCalculationWithTaxesIncluded(taxesIncluded) : '';
        }
    }, {
        key: 'getSelectedExteriorColour',
        value: function getSelectedExteriorColour() {
            var configurationExteriorColour = this.getSelectedOptionsPackageExteriorColour();
            var configurationExteriorColourPhoto = configurationExteriorColour ? configurationExteriorColour.photo1 : '';
            var yearExteriorColour = this.getSelectedYear();
            var yearExteriorColourPhoto = yearExteriorColour ? yearExteriorColour.exteriorColours.photo1 : '';
            return configurationExteriorColourPhoto || yearExteriorColourPhoto;
        }
    }, {
        key: 'getBestPurchaseMethodYear',
        value: function getBestPurchaseMethodYear(purchaseMethod) {
            var availableYears = void 0;
            var bestYear = void 0;
            switch (purchaseMethod) {
                case PurchaseMethods.CASH_PURCHASE:
                    availableYears = this.years.toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.cashPurchase.getRetail();
                    });
                    break;

                case PurchaseMethods.LEASE:
                    availableYears = this.years.filter(function (year) {
                        return year.purchaseMethods.lease.getCalculatedPayment() > 0;
                    }).toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.lease.getCalculatedPayment();
                    });
                    break;

                case PurchaseMethods.FINANCE:
                    availableYears = this.years.filter(function (year) {
                        return year.purchaseMethods.finance.getCalculatedPayment() > 0;
                    }).toArray();
                    bestYear = (0, _lodash.minBy)(availableYears, function (year) {
                        return year.purchaseMethods.finance.getCalculatedPayment();
                    });
                    break;

                default:
                    return 0;
            }

            return bestYear ? bestYear.year : 0;
        }
    }, {
        key: 'getBestPurchaseMethodsYear',
        value: function getBestPurchaseMethodsYear() {
            return {
                cashPurchaseYear: this.getBestPurchaseMethodYear(PurchaseMethods.CASH_PURCHASE),
                leaseYear: this.getBestPurchaseMethodYear(PurchaseMethods.LEASE),
                financeYear: this.getBestPurchaseMethodYear(PurchaseMethods.FINANCE)
            };
        }
    }, {
        key: 'getVehicleFromConfiguration',
        value: function getVehicleFromConfiguration(vehicle) {
            var veh = vehicle && vehicle instanceof _VehicleModel2.default ? vehicle : new _VehicleModel2.default();
            var configuration = this.getSelectedOptionsPackageConfiguration();

            return veh.set('vehicleConditionType', _vehicle2.default.CONDITIONS.NEW).set('year', this.year).set('make', this.make).set('model', this.model).set('bodyStyleCode', this.bodyStyleCode).set('modelTrimCode', configuration.modelTrimCode).set('configurationId', configuration.id).set('catalogVehicleId', configuration.smNewCarId).set('configuration', configuration).set('purchaseMethods', configuration.purchaseMethods);
        }

        // Was made for specifics cases like `Mazda mazda3` [SHOWROOM-2152]

    }, {
        key: 'modelContainsMake',
        value: function modelContainsMake() {
            return this.model.includes(this.make);
        }
    }]);

    return ModelYear;
}(ModelYearRecord);

exports.default = ModelYear;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/OptionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FEATURE = _dataTypes.DATA_TYPES.FEATURE,
    FEE = _dataTypes.DATA_TYPES.FEE,
    TAX_AND_DUTY = _dataTypes.DATA_TYPES.TAX_AND_DUTY,
    REBATE = _dataTypes.DATA_TYPES.REBATE;


var OptionRecord = (0, _immutable.Record)({
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    isConfigurationOption: false,
    dueAtDelivery: false,
    userSelected: false,
    code: '',
    keyOrder: _dataConversions.DEFAULT_KEY_ORDER,
    parentCode: '',
    includedCodes: [],
    label: '',
    description: '',
    note: '',
    dataType: 0,
    typeID: 0,
    typeDescription: '',
    typeNote: '',
    parentTypeID: null,
    parentTypeDescription: '',
    parentTypeNote: '',
    categoryID: 0,
    supplier: '',
    supplierCodes: [],
    flag: 0,
    retail: 0,
    residualizingAmount: 0,
    isTaxable: true,
    imageUrl: '',
    webUrl: '',
    htmlBlock: '',
    mostPopular: false,
    isGroup: false,
    isInstalledAtDealership: false,
    protectionCoverage: null,
    isIncludedInPriceOrPayment: false
});

var Option = function (_OptionRecord) {
    _inherits(Option, _OptionRecord);

    function Option() {
        _classCallCheck(this, Option);

        return _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
    }

    _createClass(Option, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getShowroomQuoteItem',
        value: function getShowroomQuoteItem() {
            var dataType = this.dataType,
                typeID = this.typeID,
                code = this.code,
                supplier = this.supplier,
                flag = this.flag,
                retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                selected = this.selected,
                userSelected = this.userSelected;
            // Reset flag based on selected field

            var selectionFlag = flag;
            if (selected) {
                selectionFlag = flag | _dataTypes.ITEM_FLAG.SELECTED | (userSelected ? _dataTypes.ITEM_FLAG.USER_SELECTED : 0);
            } else {
                selectionFlag = flag & ~_dataTypes.ITEM_FLAG.SELECTED;
            }

            return {
                dataType: dataType,
                typeID: typeID,
                code: code,
                supplier: supplier,
                flag: selectionFlag,
                amounts: {
                    retail: retail,
                    residualizingAmount: residualizingAmount
                }
            };
        }
    }, {
        key: 'calculateItemAmounts',
        value: function calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor) {
            var selectionCode = this.selectionCode,
                retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                isTaxable = this.isTaxable;


            var payment = 0;
            if (selectedFinanceTerm) {
                payment = Math.round(selectedFinanceTerm.calculatePaymentAdjustment(retail, residualizingAmount) * 100) / 100;
            }

            var itemAmounts = {
                selectionCode: selectionCode,
                retail: retail,
                taxes: isTaxable ? Math.round(retail * taxesFactor * 100) / 100 : 0,
                payment: payment,
                paymentTaxes: isLease || isTaxable ? Math.round(payment * taxesFactor * 100) / 100 : 0
            };

            return itemAmounts;
        }
    }, {
        key: 'getValidationOption',
        value: function getValidationOption(isCashPurchase) {
            var retail = this.retail,
                residualizingAmount = this.residualizingAmount,
                code = this.code,
                supplier = this.supplier,
                userSelected = this.userSelected,
                dataType = this.dataType,
                typeID = this.typeID;


            var isDealerDiscount = isCashPurchase && this.isDealerCashPurchaseOnlyDiscount();
            var selectionFlag = this.selected && !this.isDealerCashPurchaseOnlyDiscount() || isDealerDiscount ? _dataTypes.ITEM_FLAG.SELECTED : _dataTypes.ITEM_FLAG.NOT_SELECTED;

            return {
                code: code,
                supplier: supplier,
                dataType: dataType,
                typeID: typeID,
                flag: selectionFlag | (userSelected ? _dataTypes.ITEM_FLAG.USER_SELECTED : 0),
                amounts: {
                    retail: retail,
                    residualizingAmount: residualizingAmount
                }
            };
        }
    }, {
        key: 'getOptionDescriptionWithAmounts',
        value: function getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, isReduction) {
            var optionPricing = this.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor, isReduction);

            if (isReduction) {
                optionPricing.retail *= -1;
                optionPricing.taxes *= -1;
                optionPricing.payment *= -1;
                optionPricing.paymentTaxes *= -1;
            }

            return _extends({
                description: this.description,
                imageUrl: this.imageUrl
            }, optionPricing);
        }
    }, {
        key: 'isDealerInventoryOption',
        value: function isDealerInventoryOption() {
            return this.supplier === _dataTypes.DEALER_OPTION && this.dataType === FEATURE.DATA_TYPE_ID && this.typeID === FEATURE.TYPES.DEALER_INVENTORY;
        }
    }, {
        key: 'isDealerDiscount',
        value: function isDealerDiscount() {
            return this.supplier === _dataTypes.DEALER_OPTION && this.dataType === REBATE.DATA_TYPE_ID && this.typeID === REBATE.TYPES.DEALER_DISCOUNT;
        }
    }, {
        key: 'isDealerFee',
        value: function isDealerFee() {
            return this.supplier === _dataTypes.DEALER_OPTION && (this.dataType === FEE.DATA_TYPE_ID || this.dataType === TAX_AND_DUTY.DATA_TYPE_ID);
        }
    }, {
        key: 'isDealerCashPurchaseOnlyDiscount',
        value: function isDealerCashPurchaseOnlyDiscount() {
            return this.isDealerDiscount() && (0, _lodash.includes)(this.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);
        }
    }]);

    return Option;
}(OptionRecord);

exports.default = Option;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/OptionsPackageModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _ModelTrimConfigurationModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsPackageRecord = (0, _immutable.Record)({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    code: '',
    description: '',
    rank: 0,
    configuration: new _ModelTrimConfigurationModel2.default()
});

var OptionsPackage = function (_OptionsPackageRecord) {
    _inherits(OptionsPackage, _OptionsPackageRecord);

    function OptionsPackage() {
        _classCallCheck(this, OptionsPackage);

        return _possibleConstructorReturn(this, (OptionsPackage.__proto__ || Object.getPrototypeOf(OptionsPackage)).apply(this, arguments));
    }

    _createClass(OptionsPackage, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return OptionsPackage;
}(OptionsPackageRecord);

exports.default = OptionsPackage;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/OptionsSelectionResolutionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsSelectionResolutionRecord = (0, _immutable.Record)({
    id: '',
    isCancel: false,
    addedOptions: [],
    removedOptions: [],
    resolutionActionOptions: [],
    selected: false,
    isExteriorColour: false,
    availableExteriorColours: [],
    isInteriorColour: false,
    availableInteriorColours: []
});

function getOptionsWithPricing(options, isLease, selectedFinanceTerm, taxesFactor, isRemoved) {
    var optionsPricing = (0, _lodash.map)(options, function (option) {
        return option.getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, isRemoved);
    });
    return optionsPricing;
}

var OptionsSelectionResolution = function (_OptionsSelectionReso) {
    _inherits(OptionsSelectionResolution, _OptionsSelectionReso);

    function OptionsSelectionResolution() {
        _classCallCheck(this, OptionsSelectionResolution);

        return _possibleConstructorReturn(this, (OptionsSelectionResolution.__proto__ || Object.getPrototypeOf(OptionsSelectionResolution)).apply(this, arguments));
    }

    _createClass(OptionsSelectionResolution, [{
        key: 'getResolutionActionOptions',
        value: function getResolutionActionOptions(validationSelectedOptions) {
            var resolutionActionOptions = (0, _lodash.map)(this.resolutionActionOptions, function (resolutionActionOption) {
                return {
                    code: resolutionActionOption.code,
                    supplier: resolutionActionOption.supplier,
                    flag: resolutionActionOption.selected ? _dataTypes.ITEM_FLAG.SELECTED | _dataTypes.ITEM_FLAG.USER_SELECTED : _dataTypes.ITEM_FLAG.NOT_SELECTED,
                    amounts: {
                        retail: resolutionActionOption.retail,
                        residualizingAmount: resolutionActionOption.residualizingAmount
                    }
                };
            });
            return (0, _lodash.unionBy)(resolutionActionOptions, validationSelectedOptions, 'code');
        }
    }, {
        key: 'getResolution',
        value: function getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor) {
            var id = this.id,
                selected = this.selected;


            var addedOptions = getOptionsWithPricing(this.addedOptions, isLease, selectedFinanceTerm, taxesFactor, false);
            var removedOptions = getOptionsWithPricing(this.removedOptions, isLease, selectedFinanceTerm, taxesFactor, true);

            var addedTotals = (0, _lodash.reduce)(addedOptions, function (result, option) {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes
                };
            }, {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0
            });

            var removedTotals = (0, _lodash.reduce)(removedOptions, function (result, option) {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes
                };
            }, {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0
            });

            var pricingDifferenceTotal = {
                retail: addedTotals.retail + removedTotals.retail + triggerOption.retail,
                taxes: addedTotals.taxes + removedTotals.taxes + triggerOption.taxes,
                payment: addedTotals.payment + removedTotals.payment + triggerOption.payment,
                paymentTaxes: addedTotals.paymentTaxes + removedTotals.paymentTaxes + triggerOption.paymentTaxes
            };

            return {
                id: id,
                addedOptions: addedOptions,
                removedOptions: removedOptions,
                pricingDifferenceTotal: pricingDifferenceTotal,
                selected: selected
            };
        }
    }]);

    return OptionsSelectionResolution;
}(OptionsSelectionResolutionRecord);

exports.default = OptionsSelectionResolution;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/OptionsSelectionResolutionsModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OptionsSelectionResolutionsRecord = (0, _immutable.Record)({
    triggeredFromOptionAdd: true,
    resolutionTriggerOptionSelectionCode: '',
    resolutions: []
});

var OptionsSelectionResolutions = function (_OptionsSelectionReso) {
    _inherits(OptionsSelectionResolutions, _OptionsSelectionReso);

    function OptionsSelectionResolutions() {
        _classCallCheck(this, OptionsSelectionResolutions);

        return _possibleConstructorReturn(this, (OptionsSelectionResolutions.__proto__ || Object.getPrototypeOf(OptionsSelectionResolutions)).apply(this, arguments));
    }

    _createClass(OptionsSelectionResolutions, [{
        key: 'getResolutionActionOptions',
        value: function getResolutionActionOptions(validationSelectedOptions) {
            var selectedResolution = (0, _lodash.find)(this.resolutions, function (resolution) {
                return resolution.selected;
            });
            if (selectedResolution) {
                return selectedResolution.getResolutionActionOptions(validationSelectedOptions);
            }

            var cancelResolution = (0, _lodash.find)(this.resolutions, function (resolution) {
                return resolution.isCancel;
            });
            return cancelResolution.getResolutionActionOptions(validationSelectedOptions);
        }
    }, {
        key: 'getResolutions',
        value: function getResolutions(configuration, isLease, selectedFinanceTerm, taxesFactor) {
            var _this2 = this;

            var errorTriggerOption = (0, _lodash.find)(configuration.getOptions(), function (option) {
                return option.selectionCode === _this2.resolutionTriggerOptionSelectionCode;
            });
            if (!errorTriggerOption) {
                return null;
            }

            var triggerOption = errorTriggerOption.getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, !this.triggeredFromOptionAdd);

            var selectableResolutions = (0, _lodash.filter)(this.resolutions, function (resolution) {
                return !resolution.isCancel;
            });

            var resolutions = (0, _lodash.map)(selectableResolutions, function (optionsResolution) {
                return optionsResolution.getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor);
            });

            return {
                triggeredFromOptionAdd: this.triggeredFromOptionAdd,
                triggerOption: triggerOption,
                resolutions: resolutions,
                showPayments: !(0, _lodash.isUndefined)(selectedFinanceTerm)
            };
        }
    }]);

    return OptionsSelectionResolutions;
}(OptionsSelectionResolutionsRecord);

exports.default = OptionsSelectionResolutions;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TransmissionRecord = (0, _immutable.Record)({
    selectionCode: '',
    code: '',
    typeCode: '',
    rank: 0,
    type: 0,
    speeds: 0,
    isCVT: false,
    description: ''
});

var Transmission = function (_TransmissionRecord) {
    _inherits(Transmission, _TransmissionRecord);

    function Transmission() {
        _classCallCheck(this, Transmission);

        return _possibleConstructorReturn(this, (Transmission.__proto__ || Object.getPrototypeOf(Transmission)).apply(this, arguments));
    }

    _createClass(Transmission, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }, {
        key: 'getTypeAndSpeeds',
        value: function getTypeAndSpeeds() {
            var speed = _widgetCommonsCoreServices.LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
            var types = _widgetCommonsCoreServices.LocaleService.t('transmission.types', { type: this.get('description') });
            return this.get('isCVT') ? _widgetCommonsCoreServices.LocaleService.t('transmission.cvt', { type: this.get('description') }) : types + ' <span class=\'speed\'>' + speed + '</span>';
        }
    }, {
        key: 'getTransmission',
        value: function getTransmission() {
            var speed = _widgetCommonsCoreServices.LocaleService.t('transmission.speeds', { speeds: this.get('speeds') });
            var types = _widgetCommonsCoreServices.LocaleService.t('transmission.types', { type: this.get('description') });
            return this.get('isCVT') ? _widgetCommonsCoreServices.LocaleService.t('transmission.cvt', { type: this.get('description') }) : types + ' ' + speed;
        }
    }]);

    return Transmission;
}(TransmissionRecord);

exports.default = Transmission;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/models/YearModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YearRecord = (0, _immutable.Record)({
    year: 0,
    selected: false,
    make: '',
    model: '',
    bodyStyleCode: '',
    bodyStyle: '',
    modelTrimPurchaseMethodIds: [],
    isSingleConfiguration: false,
    hasOptions: true,
    exteriorColours: {
        photo1: '',
        photo2: '',
        photo3: ''
    },
    exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
    highRebate: 0,
    highRebatePurchaseMethod: _purchaseMethodsValues2.default.CASH,
    modelTrims: (0, _immutable.List)([]),
    drivePowerTrains: (0, _immutable.List)([]),
    optionsPackages: (0, _immutable.List)([]),
    purchaseMethods: new _PurchaseMethodsModel2.default()
});

var Year = function (_YearRecord) {
    _inherits(Year, _YearRecord);

    function Year() {
        _classCallCheck(this, Year);

        return _possibleConstructorReturn(this, (Year.__proto__ || Object.getPrototypeOf(Year)).apply(this, arguments));
    }

    _createClass(Year, [{
        key: 'getModelTrimSelectedPurchaseMethodId',
        value: function getModelTrimSelectedPurchaseMethodId(selectedPurchaseMethod) {
            return (0, _lodash.find)(this.modelTrimPurchaseMethodIds, function (modelTrimPurchaseMethodId) {
                return modelTrimPurchaseMethodId.purchaseMethod === selectedPurchaseMethod;
            });
        }
    }]);

    return Year;
}(YearRecord);

exports.default = Year;

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/reducers/modelYearReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = modelYearReducer;

var _modelYearActionTypes = __webpack_require__("../widget-commons-vehicle/src/ModelYear/actions/modelYearActionTypes.js");

var _modelYearActionTypes2 = _interopRequireDefault(_modelYearActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _ModelYearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js");

var _ModelYearService2 = _interopRequireDefault(_ModelYearService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modelYearReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _ModelYearModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case _modelYearActionTypes2.default.LOAD_MODEL_YEAR_SUCCESS:
            return action.modelYear;

        case _modelYearActionTypes2.default.SET_MODEL_YEARS:
            return state.set('year', action.modelYear.year).set('years', action.modelYear.years);

        case _modelYearActionTypes2.default.SET_MODEL_TRIMS:
            return state.set('modelTrims', action.modelYear.modelTrims).set('drivePowerTrains', action.modelYear.drivePowerTrains).set('optionsPackages', action.modelYear.optionsPackages);

        case _modelYearActionTypes2.default.SET_DRIVE_POWER_TRAINS:
            return state.set('drivePowerTrains', action.modelYear.drivePowerTrains).set('optionsPackages', action.modelYear.optionsPackages);

        case _modelYearActionTypes2.default.SET_OPTIONS_PACKAGES:
            return state.set('optionsPackages', action.modelYear.optionsPackages);

        case _purchaseMethodsActionTypes2.default.SELECT_PURCHASE_METHOD:
            return _ModelYearService2.default.selectPurchaseMethod(state, action.purchaseMethod);

        case _purchaseMethodsActionTypes2.default.SELECT_TERM:
            return _ModelYearService2.default.selectTerm(state, parseInt(action.term, 10));

        case _purchaseMethodsActionTypes2.default.SELECT_PAYMENT_FREQUENCY:
            return _ModelYearService2.default.selectPaymentFrequency(state, action.paymentFrequency.value);

        case _purchaseMethodsActionTypes2.default.SELECT_KM_PLAN:
            return _ModelYearService2.default.selectKMPlan(state, action.kmPlan.value);

        case _purchaseMethodsActionTypes2.default.SET_CASH_DOWN:
            return _ModelYearService2.default.setCashDown(state, action.cashDown);

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return _ModelYearService2.default.setTradeIn(state, action.tradeIn);

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return _ModelYearService2.default.setLien(state, action.lien);

        case _purchaseMethodsActionTypes2.default.SET_EXTERIOR_COLOUR_AMOUNTS:
            return _ModelYearService2.default.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case _purchaseMethodsActionTypes2.default.SET_INTERIOR_COLOUR_AMOUNTS:
            return _ModelYearService2.default.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case _purchaseMethodsActionTypes2.default.SET_OPTIONS_AMOUNTS:
            return _ModelYearService2.default.setOptionsAmounts(state, action.optionsAmounts);

        case _purchaseMethodsActionTypes2.default.SET_TAXES_INCLUDED:
            return _ModelYearService2.default.setTaxesIncluded(state, action.taxesIncluded);

        default:
            return state;
    }
}

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/BoxSizeService/BoxSizeService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetBoxSizeFromOriginData = resetBoxSizeFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _BoxSizeModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/BoxSizeModel.js");

var _BoxSizeModel2 = _interopRequireDefault(_BoxSizeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetBoxSizeFromModelData(modelBoxSizeData) {
    if (modelBoxSizeData.length <= _dataConversions.BOX_SIZE_DATA.CODE) {
        return new _BoxSizeModel2.default();
    }

    var code = modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.CODE];
    var rank = void 0;
    switch (code) {
        case _dataConversions.BOX_SIZE_SHORT:
            rank = 100;
            break;
        case _dataConversions.BOX_SIZE_LONG:
            rank = 200;
            break;
        default:
            rank = 300;
            break;
    }

    var description = (0, _DataUtilitiesService.getDescriptionData)(modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.DESCRIPTION]);
    var boxLength = (0, _lodash.toNumber)((0, _lodash.first)(description));
    if ((0, _lodash.isFinite)(boxLength)) {
        rank += boxLength;
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _BoxSizeModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelBoxSizeData[_dataConversions.BOX_SIZE_DATA.ID_CODE],
        code: code,
        rank: rank,
        description: description
    });
}

function resetBoxSizeFromOriginData(dataOrigin, originBoxSizeData) {
    if ((0, _lodash.isEmpty)(originBoxSizeData) || !(0, _lodash.isObjectLike)(originBoxSizeData)) {
        return new _BoxSizeModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _BoxSizeModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetBoxSizeFromModelData(originBoxSizeData);

        default:
            return new _BoxSizeModel2.default();
    }
}

exports.default = {
    resetBoxSizeFromOriginData: resetBoxSizeFromOriginData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/CabSizeService/CabSizeService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetCabSizeFromOriginData = resetCabSizeFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _CabSizeModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/CabSizeModel.js");

var _CabSizeModel2 = _interopRequireDefault(_CabSizeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetCabSizeFromModelData(modelCabSizeData) {
    if (modelCabSizeData.length <= _dataConversions.CAB_SIZE_DATA.CODE) {
        return new _CabSizeModel2.default();
    }

    var code = modelCabSizeData[_dataConversions.CAB_SIZE_DATA.CODE];
    var rank = void 0;
    switch (code) {
        case _dataConversions.CAB_SIZE_REGULAR:
            rank = 1;
            break;
        case _dataConversions.CAB_SIZE_EXTENDED:
            rank = 2;
            break;
        case _dataConversions.CAB_SIZE_CREW:
            rank = 3;
            break;
        default:
            rank = 4;
            break;
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelCabSizeData[_dataConversions.CAB_SIZE_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _CabSizeModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelCabSizeData[_dataConversions.CAB_SIZE_DATA.ID_CODE],
        code: code,
        rank: rank,
        description: (0, _DataUtilitiesService.getDescriptionData)(modelCabSizeData[_dataConversions.CAB_SIZE_DATA.DESCRIPTION])
    });
}

function resetCabSizeFromOriginData(dataOrigin, originCabSizeData) {
    if ((0, _lodash.isEmpty)(originCabSizeData) || !(0, _lodash.isObjectLike)(originCabSizeData)) {
        return new _CabSizeModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _CabSizeModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetCabSizeFromModelData(originCabSizeData);

        default:
            return new _CabSizeModel2.default();
    }
}

exports.default = {
    resetCabSizeFromOriginData: resetCabSizeFromOriginData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ColourService/ColourService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetColourFromConfigurationData = resetColourFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _ColourModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ColourModel.js");

var _ColourModel2 = _interopRequireDefault(_ColourModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetColourFromConfigurationData(configurationColourData, features) {
    if ((0, _lodash.isEmpty)(configurationColourData) || configurationColourData.length <= _dataConversions.COLOUR_DATA.PRICING) {
        return new _ColourModel2.default();
    }

    var retail = 0;
    var residualRetail = 0;
    if (!(0, _lodash.isEmpty)(configurationColourData[_dataConversions.COLOUR_DATA.PRICING]) && configurationColourData[_dataConversions.COLOUR_DATA.PRICING].length === 2) {
        var configurationTrimPricing = configurationColourData[_dataConversions.COLOUR_DATA.PRICING];

        retail = configurationTrimPricing[_dataConversions.COLOUR_DATA.AMOUNTS.RETAIL];
        residualRetail = configurationTrimPricing[_dataConversions.COLOUR_DATA.AMOUNTS.RESIDUAL_RETAIL];
    }

    var colourCode = configurationColourData[_dataConversions.COLOUR_DATA.CODE];
    var colourDescription = (0, _lodash.isUndefined)(features) || (0, _lodash.isEmpty)(features) || (0, _lodash.isEmpty)(features[colourCode]) ? '' : features[colourCode].description;

    var fabricDescription = '';
    var seatColourDescription = '';
    if (!(0, _lodash.isEmpty)(features) && !(0, _lodash.isEmpty)(features[colourCode]) && !(0, _lodash.isEmpty)(features[colourCode].colourFeatures)) {
        fabricDescription = features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_FABRIC] || '';
        seatColourDescription = features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_SEAT] || features[colourCode].colourFeatures[_dataConversions.COLOUR_DATA.FEATURE_INTERIOR] || '';
    }

    return new _ColourModel2.default({
        colourCode: colourCode,
        colourDescription: seatColourDescription || colourDescription,
        fabricDescription: fabricDescription,
        selected: false,
        enabled: true,
        visible: true,
        colourTile: configurationColourData[_dataConversions.COLOUR_DATA.TILE],
        photo1: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_1],
        photo2: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_2],
        photo3: configurationColourData[_dataConversions.COLOUR_DATA.PHOTO_3],
        retail: retail,
        residualRetail: residualRetail
    });
}

exports.default = {
    resetColourFromConfigurationData: resetColourFromConfigurationData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDescriptionData = getDescriptionData;
exports.getModelTrimsBitField = getModelTrimsBitField;
exports.getBaseSelectionObject = getBaseSelectionObject;
exports.getSelectionObject = getSelectionObject;
exports.getDataObject = getDataObject;
exports.getIncentiveExpirationDays = getIncentiveExpirationDays;
exports.mergeModelTrimsBitField = mergeModelTrimsBitField;
exports.intersectModelTrimsBitFieldValue = intersectModelTrimsBitFieldValue;
exports.getObjectFromAvailabilityFlag = getObjectFromAvailabilityFlag;

var _lodash = __webpack_require__("lodash");

/* eslint no-bitwise: 0 */

function getDescriptionData(description) {
    return (0, _lodash.isEmpty)(description) ? '' : description[0];
}

function getModelTrimsBitField(trimsBitFieldsData) {
    var modelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: []
    };
    if (!(0, _lodash.isArrayLike)(trimsBitFieldsData) && !(0, _lodash.isFinite)(trimsBitFieldsData)) {
        return modelTrimsBitField;
    }

    if ((0, _lodash.isArrayLike)(trimsBitFieldsData)) {
        if (trimsBitFieldsData.length === 1) {
            modelTrimsBitField.trimsBitField = trimsBitFieldsData[0];
        } else {
            modelTrimsBitField.trimsBitFields = trimsBitFieldsData;
        }
    } else {
        modelTrimsBitField.trimsBitField = trimsBitFieldsData;
    }
    return modelTrimsBitField;
}

function getBaseSelectionObject(trimFlag, selectionCode) {
    var _getModelTrimsBitFiel = getModelTrimsBitField(trimFlag),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return {
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: selectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false
    };
}

function getSelectionObject(trimFlag, selectionCode, code, description) {
    var selectionObj = getBaseSelectionObject(trimFlag, selectionCode);
    selectionObj.code = code;
    selectionObj.description = getDescriptionData(description);

    return selectionObj;
}

function getDataObject(dataItem, flagIndex, descriptionIndex) {
    var dataObject = {};

    if ((0, _lodash.isEmpty)(dataItem)) {
        return dataObject;
    }

    var code = getDescriptionData(dataItem[descriptionIndex]);
    dataObject = getSelectionObject(dataItem[flagIndex], code, code, dataItem[descriptionIndex]);

    return dataObject;
}

function getIncentiveExpirationDays(incentiveExpirationDate) {
    var today = new Date();
    var expirationDays = 30;
    if (incentiveExpirationDate) {
        var expirationConvertedDate = new Date(incentiveExpirationDate);
        if (expirationConvertedDate > today) {
            var expirationMonth = expirationConvertedDate.getMonth();
            if (today.getFullYear() < expirationConvertedDate.getFullYear()) {
                expirationMonth += 12;
            }

            var expirationDay = expirationConvertedDate.getDate();
            if (today.getMonth() < expirationMonth) {
                expirationDay += 30;
            }

            expirationDays = expirationDay - today.getDate() + 1;
        }
    }

    return expirationDays;
}

function mergeModelTrimsBitField(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB, orOperation) {
    var mergedModelTrimsBitField = {
        trimsBitField: 0,
        trimsBitFields: []
    };
    if ((0, _lodash.isUndefined)(modelTrimsBitFieldObjectA.trimsBitField) || (0, _lodash.isUndefined)(modelTrimsBitFieldObjectB.trimsBitField)) {
        return mergedModelTrimsBitField;
    }

    if (modelTrimsBitFieldObjectA.trimsBitField || modelTrimsBitFieldObjectB.trimsBitField) {
        mergedModelTrimsBitField.trimsBitField = orOperation ? modelTrimsBitFieldObjectA.trimsBitField | modelTrimsBitFieldObjectB.trimsBitField : modelTrimsBitFieldObjectA.trimsBitField & modelTrimsBitFieldObjectB.trimsBitField;
        return mergedModelTrimsBitField;
    }

    var emptyObjectA = (0, _lodash.isEmpty)(modelTrimsBitFieldObjectA.trimsBitFields);
    var emptyObjectB = (0, _lodash.isEmpty)(modelTrimsBitFieldObjectB.trimsBitFields);
    if (orOperation && (emptyObjectA || emptyObjectB)) {
        if (emptyObjectA && emptyObjectB) {
            return mergedModelTrimsBitField;
        }
        mergedModelTrimsBitField.trimsBitFields = emptyObjectA ? modelTrimsBitFieldObjectB.trimsBitFields : modelTrimsBitFieldObjectA.trimsBitFields;

        return mergedModelTrimsBitField;
    } else if (emptyObjectA || emptyObjectB || modelTrimsBitFieldObjectA.trimsBitFields.length !== modelTrimsBitFieldObjectB.trimsBitFields.length) {
        return mergedModelTrimsBitField;
    }

    for (var i = 0; i < modelTrimsBitFieldObjectA.trimsBitFields.length; i += 1) {
        mergedModelTrimsBitField.trimsBitFields.push(orOperation ? modelTrimsBitFieldObjectA.trimsBitFields[i] | modelTrimsBitFieldObjectB.trimsBitFields[i] : modelTrimsBitFieldObjectA.trimsBitFields[i] & modelTrimsBitFieldObjectB.trimsBitFields[i]);
    }
    return mergedModelTrimsBitField;
}

function intersectModelTrimsBitFieldValue(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB) {
    var mergedModelTrimsBitField = mergeModelTrimsBitField(modelTrimsBitFieldObjectA, modelTrimsBitFieldObjectB, false);

    if ((0, _lodash.isEmpty)(mergedModelTrimsBitField.trimsBitFields)) {
        return mergedModelTrimsBitField.trimsBitField;
    }

    return (0, _lodash.sum)(mergedModelTrimsBitField.trimsBitFields);
}

function getObjectFromAvailabilityFlag(objectList, availabilityBitField) {
    var availableObject = null;

    if ((0, _lodash.isEmpty)(objectList) || !(0, _lodash.isArrayLikeObject)(objectList) || !availabilityBitField.trimsBitField && (0, _lodash.isEmpty)(availabilityBitField.trimsBitFields)) {
        return availableObject;
    }

    availableObject = (0, _lodash.find)(objectList, function (item) {
        return intersectModelTrimsBitFieldValue(item, availabilityBitField) > 0;
    });

    return (0, _lodash.isUndefined)(availableObject) ? null : availableObject;
}

exports.default = {
    getDescriptionData: getDescriptionData,
    getBaseSelectionObject: getBaseSelectionObject,
    getSelectionObject: getSelectionObject,
    getDataObject: getDataObject,
    getObjectFromAvailabilityFlag: getObjectFromAvailabilityFlag,
    getIncentiveExpirationDays: getIncentiveExpirationDays,
    getModelTrimsBitField: getModelTrimsBitField,
    mergeModelTrimsBitField: mergeModelTrimsBitField,
    intersectModelTrimsBitFieldValue: intersectModelTrimsBitFieldValue
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetDrivePowerTrainFromOriginData = resetDrivePowerTrainFromOriginData;
exports.addDrivePowerTrainConfigurationId = addDrivePowerTrainConfigurationId;

var _lodash = __webpack_require__("lodash");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _DrivePowerTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DrivePowerTrainModel.js");

var _DrivePowerTrainModel2 = _interopRequireDefault(_DrivePowerTrainModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function resetDrivePowerTrainFromModelData(modelData) {
    var drivePowerTrainSelectionCode = modelData.driveTrain.selectionCode + '|' + (modelData.engine.getSelectionCode() + '|') + ('' + modelData.transmission.getSelectionCode());

    var drivePowerTrainRank = modelData.driveTrain.rank * 100000 + (modelData.engine.hp + 1000) * 10 + modelData.transmission.rank;

    return new _DrivePowerTrainModel2.default({
        trimsBitField: 0,
        trimsBitFields: [],
        selectionCode: drivePowerTrainSelectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        rank: drivePowerTrainRank,
        driveTrain: modelData.driveTrain,
        engine: modelData.engine,
        transmission: modelData.transmission,
        configurationIds: {},
        bestOptionsPackageCode: ''
    });
}

function resetDrivePowerTrainFromOriginData(dataOrigin, originDrivePowerTrainData) {
    if ((0, _lodash.isEmpty)(originDrivePowerTrainData) || !(0, _lodash.isObjectLike)(originDrivePowerTrainData)) {
        return new _DrivePowerTrainModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _DrivePowerTrainModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDrivePowerTrainFromModelData(originDrivePowerTrainData);

        default:
            return new _DrivePowerTrainModel2.default();
    }
}

function addDrivePowerTrainConfigurationId(drivePowerTrain, configurationId, configuration) {
    var _mergeModelTrimsBitFi = (0, _DataUtilitiesService.mergeModelTrimsBitField)(drivePowerTrain, configuration, true),
        trimsBitField = _mergeModelTrimsBitFi.trimsBitField,
        trimsBitFields = _mergeModelTrimsBitFi.trimsBitFields;

    var configurationIds = drivePowerTrain.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return drivePowerTrain.set('trimsBitField', trimsBitField).set('trimsBitFields', trimsBitFields).set('configurationIds', configurationIds);
}

exports.default = {
    resetDrivePowerTrainFromModelData: resetDrivePowerTrainFromModelData,
    resetDrivePowerTrainFromOriginData: resetDrivePowerTrainFromOriginData,
    addDrivePowerTrainConfigurationId: addDrivePowerTrainConfigurationId
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/DriveTrainService/DriveTrainService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetDriveTrainFromOriginData = resetDriveTrainFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _DriveTrainModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/DriveTrainModel.js");

var _DriveTrainModel2 = _interopRequireDefault(_DriveTrainModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function resetDriveTrainFromModelData(modelDriveTrainData) {
    if (modelDriveTrainData.length <= _dataConversions.DRIVE_TRAIN_DATA.LONG_DESCRIPTION) {
        return new _DriveTrainModel2.default();
    }

    var _getModelTrimsBitFiel = (0, _DataUtilitiesService.getModelTrimsBitField)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.BIT_FIELD]),
        trimsBitField = _getModelTrimsBitFiel.trimsBitField,
        trimsBitFields = _getModelTrimsBitFiel.trimsBitFields;

    return new _DriveTrainModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.ID_CODE],
        code: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.ID_CODE],
        rank: modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.CODE] === _dataConversions.DRIVE_TRAIN_4WD ? 2 : 1,
        description: (0, _DataUtilitiesService.getDescriptionData)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.DESCRIPTION]),
        longDescription: (0, _DataUtilitiesService.getDescriptionData)(modelDriveTrainData[_dataConversions.DRIVE_TRAIN_DATA.LONG_DESCRIPTION])
    });
}

function resetDriveTrainFromOriginData(dataOrigin, originDriveTrainData) {
    if ((0, _lodash.isEmpty)(originDriveTrainData) || !(0, _lodash.isObjectLike)(originDriveTrainData)) {
        return new _DriveTrainModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _DriveTrainModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetDriveTrainFromModelData(originDriveTrainData);

        default:
            return new _DriveTrainModel2.default();
    }
}

exports.default = {
    resetDriveTrainFromOriginData: resetDriveTrainFromOriginData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/EngineService/EngineService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetEngineFromConfigurationData = resetEngineFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _EngineModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetEngineFromConfigurationData(configurationEngineData) {
    if ((0, _lodash.isEmpty)(configurationEngineData) || configurationEngineData.length <= _dataConversions.ENGINE_DATA.TORQUE_RPM) {
        return new _EngineModel2.default();
    }

    var selectionCode = configurationEngineData[_dataConversions.ENGINE_DATA.DISPLACEMENT] + 'L-' + (configurationEngineData[_dataConversions.ENGINE_DATA.CYLINDERS] + 'C-') + ('' + (configurationEngineData[_dataConversions.ENGINE_DATA.IS_TURBO] ? 'T-' : '')) + ('' + configurationEngineData[_dataConversions.ENGINE_DATA.FUEL]);

    return new _EngineModel2.default({
        selectionCode: selectionCode,
        code: '',
        fuelTypeCode: configurationEngineData[_dataConversions.ENGINE_DATA.FUEL],
        cylinders: configurationEngineData[_dataConversions.ENGINE_DATA.CYLINDERS],
        displacement: configurationEngineData[_dataConversions.ENGINE_DATA.DISPLACEMENT],
        isTurbo: configurationEngineData[_dataConversions.ENGINE_DATA.IS_TURBO],
        hp: configurationEngineData[_dataConversions.ENGINE_DATA.HP],
        hpRpm: configurationEngineData[_dataConversions.ENGINE_DATA.HP_RPM],
        torque: configurationEngineData[_dataConversions.ENGINE_DATA.TORQUE],
        torqueRpm: configurationEngineData[_dataConversions.ENGINE_DATA.TORQUE_RPM]
    });
}

exports.default = {
    resetEngineFromConfigurationData: resetEngineFromConfigurationData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelTrimConfigurationFromModelData = resetModelTrimConfigurationFromModelData;

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _ModelTrimConfigurationModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelTrimConfigurationModel.js");

var _ModelTrimConfigurationModel2 = _interopRequireDefault(_ModelTrimConfigurationModel);

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _ModelTrimItemsService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _EngineService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/EngineService/EngineService.js");

var _TransmissionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/TransmissionService/TransmissionService.js");

var _ColourService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ColourService/ColourService.js");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 no-bitwise: 0 */

function getConfigurationColours(configurationColoursData, features) {
    var colours = {};
    (0, _lodash.forEach)(configurationColoursData, function (configurationColourData) {
        var colour = (0, _ColourService.resetColourFromConfigurationData)(configurationColourData, features);
        if (colour.colourCode !== '') {
            colours[colour.colourCode] = colour;
        }
    });

    return colours;
}

function getConfigurationFeaturesAndOptions(configurationFeatureCodesData, modelFeaturesAndOptions, configurationTrimsBitField) {
    var configurationFeaturesAndOptions = {
        modelTrimFeatures: {},
        features: {},
        options: {}
    };

    if ((0, _lodash.isEmpty)(configurationFeatureCodesData) || (0, _lodash.isEmpty)(modelFeaturesAndOptions) || !(0, _lodash.isObjectLike)(modelFeaturesAndOptions) || !configurationTrimsBitField.trimsBitField && (0, _lodash.isEmpty)(configurationTrimsBitField.trimsBitFields)) {
        return configurationFeaturesAndOptions;
    }

    var currentFeaturesAndOptions = (0, _lodash.find)(modelFeaturesAndOptions, function (featuresAndOptions) {
        return UtilitiesService.intersectModelTrimsBitFieldValue(featuresAndOptions, configurationTrimsBitField) > 0;
    });
    configurationFeaturesAndOptions.options = currentFeaturesAndOptions.options;

    if (currentFeaturesAndOptions && (!(0, _lodash.isEmpty)(currentFeaturesAndOptions.options) || !(0, _lodash.isEmpty)(currentFeaturesAndOptions.features))) {
        (0, _lodash.forEach)(configurationFeatureCodesData, function (featureCode) {
            if (!(0, _lodash.isUndefined)(currentFeaturesAndOptions.options[featureCode])) {
                configurationFeaturesAndOptions.features[featureCode] = currentFeaturesAndOptions.options[featureCode];

                configurationFeaturesAndOptions.features[featureCode].rank = currentFeaturesAndOptions.options[featureCode].keyOrder === 0 ? _dataTypes.DEFAULT_KEY_ORDER : currentFeaturesAndOptions.options[featureCode].keyOrder;
            } else if (!(0, _lodash.isUndefined)(currentFeaturesAndOptions.features[featureCode])) {
                configurationFeaturesAndOptions.modelTrimFeatures[featureCode] = currentFeaturesAndOptions.features[featureCode];

                configurationFeaturesAndOptions.modelTrimFeatures[featureCode].rank = currentFeaturesAndOptions.features[featureCode].keyOrder === 0 ? _dataTypes.DEFAULT_KEY_ORDER : currentFeaturesAndOptions.features[featureCode].keyOrder;
            }
        });
    }

    return configurationFeaturesAndOptions;
}

function getConfigurationFeatureRankedIcons(configuration, configurationFeatureIcons) {
    var configFeatureRankedIcons = [];
    (0, _lodash.forEach)(configurationFeatureIcons, function (iconType, iconTypeKey) {
        (0, _lodash.forEach)(iconType.featureCodes, function (iconFeatureCode) {
            configFeatureRankedIcons.push((0, _immutable.Map)((0, _ModelTrimItemsService.getIconFromFeatureCode)(configuration.features, configuration.modelTrimFeatures, iconType, iconTypeKey, iconFeatureCode)));
        });
    });

    return (0, _lodash.sortBy)(configFeatureRankedIcons, function (rankedIcon) {
        return rankedIcon.rank;
    });
}

function resetModelTrimConfigurationFromModelData(modelTrimConfiguration, modelOptions, modelTrim, driveTrains, cabSizes, boxSizes) {
    if ((0, _lodash.isEmpty)(modelTrimConfiguration) || !(0, _lodash.isObjectLike)(modelTrimConfiguration) || (0, _lodash.isEmpty)(modelTrim) || !(0, _lodash.isObjectLike)(modelTrim) || (0, _lodash.isEmpty)(driveTrains) || !(0, _lodash.isArrayLikeObject)(driveTrains)) {
        return new _ModelTrimConfigurationModel2.default();
    }

    var _UtilitiesService$get = UtilitiesService.getModelTrimsBitField(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.BIT_FIELD]),
        trimsBitField = _UtilitiesService$get.trimsBitField,
        trimsBitFields = _UtilitiesService$get.trimsBitFields;

    var configID = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.ID];
    var configStringID = (configID.length === 1 ? '0' : '') + configID;
    var configModelTrimCode = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRIM_CODE];
    var configPackageCode = modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.PACKAGE_CODE];
    var configTrimsBitField = {
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields
    };

    var featuresAndOptions = getConfigurationFeaturesAndOptions(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.OPTION_CODES], modelOptions, configTrimsBitField);

    var configFeatureIcons = (0, _ModelTrimItemsService.getFeatureIcons)(featuresAndOptions.features, featuresAndOptions.modelTrimFeatures);
    if (!(0, _lodash.isEmpty)(configFeatureIcons) && !(0, _lodash.isEmpty)(featuresAndOptions.modelTrimFeatures)) {
        (0, _lodash.forEach)(featuresAndOptions.modelTrimFeatures, function (feature) {
            (0, _lodash.map)(feature.iconTypes, function (iconType, key) {
                var newIconType = iconType;
                if (!(0, _lodash.isEmpty)(configFeatureIcons[key]) && newIconType.featureCode !== configFeatureIcons[key].featureCode) {
                    newIconType.isInvalid = true;
                }
            });
        });
    }

    var featureIcons = getConfigurationFeatureRankedIcons(featuresAndOptions, configFeatureIcons);
    var nonModelTrimFeatureIcons = (0, _lodash.filter)(featureIcons, function (featureIcon) {
        return !featureIcon.isFromModelTrim;
    });

    var exteriorColourStatus = (0, _lodash.isUndefined)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.EXTERIOR_COLOUR_STATUS]) ? _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE : modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.EXTERIOR_COLOUR_STATUS];
    var driveTrain = UtilitiesService.getObjectFromAvailabilityFlag(driveTrains, configTrimsBitField);
    var driveTrainSelectionCode = driveTrain === null ? '' : driveTrain.selectionCode;
    var cabSize = UtilitiesService.getObjectFromAvailabilityFlag(cabSizes, configTrimsBitField);
    var cabSizeSelectionCode = cabSize === null ? '' : cabSize.selectionCode;
    var boxSize = UtilitiesService.getObjectFromAvailabilityFlag(boxSizes, configTrimsBitField);
    var boxSizeSelectionCode = boxSize === null ? '' : boxSize.selectionCode;

    var configurationDescription = UtilitiesService.getDescriptionData(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.DESCRIPTION]);
    return new _ModelTrimConfigurationModel2.default({
        trimsBitField: trimsBitField,
        trimsBitFields: trimsBitFields,
        selectionCode: configModelTrimCode + '|' + configStringID,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: configPackageCode + '|' + configStringID,
        description: configurationDescription,
        id: configID,
        rank: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.RANK],
        modelTrimCode: configModelTrimCode,
        modelTrimCodeId: configModelTrimCode + '|' + configID,
        modelTrimRank: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRIM_RANK],
        packageSelectionCode: configPackageCode,
        packageCode: configPackageCode.substring(0, 3) === _dataTypes.SYSTEM_PACKAGE_CODE ? '' : configPackageCode,
        modelTrim: modelTrim,
        package: {
            code: configPackageCode.substring(0, 3) === _dataTypes.SYSTEM_PACKAGE_CODE ? '' : configPackageCode,
            description: configurationDescription
        },
        cabSizeSelectionCode: cabSizeSelectionCode,
        cabSize: cabSize,
        boxSizeSelectionCode: boxSizeSelectionCode,
        boxSize: boxSize,
        driveTrainSelectionCode: driveTrainSelectionCode,
        driveTrain: driveTrain,
        engine: (0, _EngineService.resetEngineFromConfigurationData)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.ENGINE]),
        transmission: (0, _TransmissionService.resetTransmissionFromConfigurationData)(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.TRANSMISSION]),
        purchaseMethods: (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelTrimConfiguration),
        seating: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.SEATING],
        fuelCity: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.FUEL_CONSUMPTION][0],
        fuelHighway: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.FUEL_CONSUMPTION][1],
        modelTrimFeatures: featuresAndOptions.modelTrimFeatures,
        features: featuresAndOptions.features,
        featureIcons: (0, _immutable.List)(featureIcons),
        nonModelTrimFeatureIconsCount: nonModelTrimFeatureIcons.length,
        exteriorColourStatus: exteriorColourStatus,
        exteriorColours: (0, _immutable.List)((0, _lodash.values)(getConfigurationColours(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.URL_EXTERIOR_COLOUR], featuresAndOptions.options))),
        interiorColours: (0, _immutable.List)((0, _lodash.values)(getConfigurationColours(modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.URL_INTERIOR_TRIM], featuresAndOptions.options))),
        smNewTrimCarId: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.CAR_ID],
        smNewCarId: modelTrimConfiguration[_dataConversions.MODEL_CONFIGURATION.VEH_ID],
        configurationItemsAreLoaded: false
    });
}

exports.default = {
    getConfigurationColours: getConfigurationColours,
    getConfigurationFeaturesAndOptions: getConfigurationFeaturesAndOptions,
    getConfigurationFeatureRankedIcons: getConfigurationFeatureRankedIcons,
    resetModelTrimConfigurationFromModelData: resetModelTrimConfigurationFromModelData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFeatureIcons = getFeatureIcons;
exports.getIconFromFeatureCode = getIconFromFeatureCode;
exports.getModelYearFeaturesAndOptions = getModelYearFeaturesAndOptions;

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _apiDataConversionConstants = __webpack_require__("../widget-commons-vehicle/src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var DATA_TYPES = Constants.VIEW_2_1.DATA_TYPES;

var FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES;
var FEATURE_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES.FEATURE;
var MODEL_YEAR_FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.FEATURES;
var DEFAULT_KEY_ORDER = 9999999;
var DEFINED_RANK = 10000000;
var UNDEFINED_RANK = 30000000;
var FEATURE_TYPE_ID_START = 100;
var FEATURE_TYPE_IGNORE = 5;
var DEFAULT_ICON = Constants.VIEW_2_1.DEFAULT_ICON;
function getFeatureIcons(features, modelTrimFeatures) {
    var featureIcons = {};
    var featureCode = '';
    var featureDesc = '';
    var featureKeyOrder = DEFAULT_KEY_ORDER;

    (0, _lodash.forEach)(features, function (feature) {
        var newFeature = feature;
        featureCode = newFeature.code;
        featureDesc = newFeature.description;
        featureKeyOrder = newFeature.keyOrder === 0 ? DEFAULT_KEY_ORDER : newFeature.keyOrder;

        if (newFeature.dataTypeID === DATA_TYPES.FEATURE && !(0, _lodash.isEmpty)(newFeature.iconTypes)) {
            (0, _lodash.forEach)(newFeature.iconTypes, function (iconType, iconKey) {
                if ((0, _lodash.isEmpty)(featureIcons[iconKey]) || iconType.value > featureIcons[iconKey].value) {
                    featureIcons[iconKey] = iconType;
                    featureIcons[iconKey].featureCode = featureCode;
                    featureIcons[iconKey].featureCodes = [];
                    featureIcons[iconKey].featureCodes.push(featureCode);
                }
            });
        } else if (newFeature.dataTypeID === DATA_TYPES.FEATURE && (newFeature.typeID > FEATURE_TYPE_ID_START || newFeature.typeID < FEATURE_TYPE_IGNORE)) {
            newFeature.iconTypes[DEFAULT_ICON] = {
                iconCode: DEFAULT_ICON,
                value: 0,
                rank: featureKeyOrder,
                keyOrder: featureKeyOrder,
                description: featureDesc,
                featureCode: featureCode
            };

            if ((0, _lodash.isUndefined)(featureIcons[DEFAULT_ICON])) {
                featureIcons[DEFAULT_ICON] = newFeature.iconTypes[DEFAULT_ICON];
                featureIcons[DEFAULT_ICON].featureCodes = [];
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            } else {
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            }
        }
    });

    (0, _lodash.forEach)(modelTrimFeatures, function (feature) {
        if (!(0, _lodash.isEmpty)(feature.iconTypes)) {
            (0, _lodash.forEach)(feature.iconTypes, function (iconType, key) {
                if ((0, _lodash.isEmpty)(featureIcons[key])) {
                    featureIcons[key] = iconType;
                    featureIcons[key].featureCode = feature.code;
                }
            });
        }
    });

    return featureIcons;
}

function getIconFromFeatureCode(features, modelTrimFeatures, iconType, iconTypeKey, featureCode) {
    var iconObject = {
        code: featureCode,
        description: iconType.description,
        typeDescription: iconType.description,
        value: iconType.value
    };

    var featureRank = DEFINED_RANK;
    var modelFeatureRank = DEFINED_RANK;
    var featureIsModelTrim = true;

    if (!(0, _lodash.isUndefined)(features[featureCode])) {
        featureRank += features[featureCode].rank;
        modelFeatureRank += features[featureCode].rank;
        featureIsModelTrim = false;
        iconObject.description = features[featureCode].description;
        iconObject.typeDescription = iconTypeKey === DEFAULT_ICON ? features[featureCode].description : iconType.description;
    } else if (!(0, _lodash.isUndefined)(modelTrimFeatures[featureCode])) {
        featureRank += DEFINED_RANK + modelTrimFeatures[featureCode].rank;
        modelFeatureRank += modelTrimFeatures[featureCode].rank;
        iconObject.description = modelTrimFeatures[featureCode].description;
        iconObject.typeDescription = iconTypeKey === DEFAULT_ICON ? modelTrimFeatures[featureCode].description : iconType.description;
    } else {
        featureRank = UNDEFINED_RANK;
        modelFeatureRank = UNDEFINED_RANK;
    }

    return {
        rank: featureRank,
        modelTrimRank: modelFeatureRank,
        code: iconTypeKey,
        isFromModelTrim: featureIsModelTrim,
        iconObject: (0, _immutable.Map)(iconObject)
    };
}

function getModelFeatureOption(modelFeatureOptionData) {
    var modelFeatureOption = {};

    if ((0, _lodash.isEmpty)(modelFeatureOptionData)) {
        return modelFeatureOption;
    }

    modelFeatureOption.code = modelFeatureOptionData[FEATURE_CONSTANTS.CODE];
    modelFeatureOption.type = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE];
    modelFeatureOption.keyOrder = modelFeatureOptionData[FEATURE_CONSTANTS.KEY_ORDER];
    modelFeatureOption.dataTypeID = modelFeatureOptionData[FEATURE_CONSTANTS.DATA_TYPE_ID];
    modelFeatureOption.typeID = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ID];
    modelFeatureOption.description = modelFeatureOptionData[FEATURE_CONSTANTS.DESCRIPTION];
    modelFeatureOption.isStandard = modelFeatureOptionData[FEATURE_CONSTANTS.IS_STANDARD];
    modelFeatureOption.typeIDs = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_IDS];
    modelFeatureOption.colourFeatures = modelFeatureOptionData[FEATURE_CONSTANTS.COLOUR_FEATURES];

    modelFeatureOption.iconTypes = {};
    var icons = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ICONS];
    if (!(0, _lodash.isEmpty)(icons)) {
        (0, _lodash.forEach)(icons, function (icon) {
            if ((0, _lodash.isEmpty)(modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]])) {
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]] = {
                    rank: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    keyOrder: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    value: icon[FEATURE_CONSTANTS.ICON.VALUE],
                    description: icon[FEATURE_CONSTANTS.ICON.DESCRIPTION],
                    featureCode: modelFeatureOption.code,
                    featureCodes: []
                };
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].featureCodes.push(modelFeatureOption.code);
                if (modelFeatureOption.keyOrder === 0 && modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder > 0 || modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder < modelFeatureOption.keyOrder) {
                    modelFeatureOption.keyOrder = modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder;
                }
            }
        });
    } else if (modelFeatureOption.dataTypeID === DATA_TYPES.FEATURE && (modelFeatureOption.typeID > FEATURE_TYPE_ID_START || modelFeatureOption.typeID === 0)) {
        modelFeatureOption.iconTypes[DEFAULT_ICON] = {
            iconCode: DEFAULT_ICON,
            value: 0,
            rank: modelFeatureOption.keyOrder,
            keyOrder: modelFeatureOption.keyOrder,
            description: modelFeatureOption.description,
            featureCode: modelFeatureOption.code
        };
    }

    return modelFeatureOption;
}

function splitModelFeaturesAndOptions(modelFeaturesAndOptionsData) {
    var modelFeaturesAndOptions = {
        trimsBitField: 0,
        trimsBitFields: 0,
        features: {},
        options: {}
    };

    if ((0, _lodash.isEmpty)(modelFeaturesAndOptionsData)) {
        return modelFeaturesAndOptions;
    }

    var _UtilitiesService$get = UtilitiesService.getModelTrimsBitField(modelFeaturesAndOptionsData[FEATURES_CONSTANTS.BIT_FIELD]),
        trimsBitField = _UtilitiesService$get.trimsBitField,
        trimsBitFields = _UtilitiesService$get.trimsBitFields;

    modelFeaturesAndOptions.trimsBitField = trimsBitField;
    modelFeaturesAndOptions.trimsBitFields = trimsBitFields;
    (0, _lodash.forEach)(modelFeaturesAndOptionsData[FEATURES_CONSTANTS.LIST], function (modelFeatureOption) {
        var featureOption = getModelFeatureOption(modelFeatureOption);
        if (featureOption.isStandard) {
            modelFeaturesAndOptions.features[featureOption.code] = featureOption;
        } else {
            modelFeaturesAndOptions.options[featureOption.code] = featureOption;
        }
    });

    return modelFeaturesAndOptions;
}

function getModelYearFeaturesAndOptions(modelYearFeaturesAndOptionsData) {
    var featuresAndOptions = (0, _lodash.map)(modelYearFeaturesAndOptionsData[MODEL_YEAR_FEATURES_CONSTANTS], function (modelFeaturesAndOptions) {
        return splitModelFeaturesAndOptions(modelFeaturesAndOptions);
    });

    return featuresAndOptions;
}

exports.default = {
    getFeatureIcons: getFeatureIcons,
    getIconFromFeatureCode: getIconFromFeatureCode,
    getModelFeatureOption: getModelFeatureOption,
    splitModelFeaturesAndOptions: splitModelFeaturesAndOptions,
    getModelYearFeaturesAndOptions: getModelYearFeaturesAndOptions
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ModelTrimService/ModelTrimService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelTrimFromOriginData = resetModelTrimFromOriginData;
exports.addModelTrimConfigurationId = addModelTrimConfigurationId;
exports.resetModelTrimComparisonFeatures = resetModelTrimComparisonFeatures;

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelTrimItemsService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var _ModelTrimModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelTrimModel.js");

var _ModelTrimModel2 = _interopRequireDefault(_ModelTrimModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function getModelTrimFeatureIcons(configurationFeatureIcons) {
    var featureIcons = {};
    (0, _lodash.forEach)(configurationFeatureIcons.toArray(), function (featureIcon) {
        if (featureIcon.isFromModelTrim && (0, _lodash.isUndefined)(featureIcons[featureIcon.iconObject.code])) {
            featureIcons[featureIcon.iconObject.code] = featureIcon;
        }
    });

    return featureIcons;
}

function getModelTrimAddFeatureRankedIcons(features, modelTrimFeatures, comparisonAddFeatures) {
    var modelTrimAddFeatureRankedIcons = [];
    var modelTrimCompareFeatureIcons = (0, _ModelTrimItemsService.getFeatureIcons)(comparisonAddFeatures);

    (0, _lodash.forEach)(modelTrimCompareFeatureIcons, function (iconType, iconTypeKey) {
        (0, _lodash.forEach)(iconType.featureCodes, function (featureCode) {
            modelTrimAddFeatureRankedIcons.push((0, _immutable.fromJS)((0, _ModelTrimItemsService.getIconFromFeatureCode)(features, modelTrimFeatures, iconType, iconTypeKey, featureCode)));
        });
    });

    return (0, _lodash.sortBy)(modelTrimAddFeatureRankedIcons, function (rankedIcon) {
        return rankedIcon.get('rank');
    });
}

function resetModelTrimFromModelData(modelData) {
    return new _ModelTrimModel2.default({
        trimCode: modelData.configuration.modelTrimCode,
        trimsBitField: modelData.configuration.modelTrim.trimsBitField,
        trimsBitFields: modelData.configuration.modelTrim.trimsBitFields,
        selectionCode: modelData.configuration.modelTrim.code,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: modelData.configuration.modelTrim.code,
        description: modelData.configuration.modelTrim.description,
        trimExtensionCode: modelData.configuration.modelTrim.extensionCode,
        trimExtensionDescription: modelData.configuration.modelTrim.extensionDescription,
        rank: modelData.configuration.modelTrimRank,
        configurationIds: {},
        features: modelData.configuration.modelTrimFeatures,
        featureIcons: getModelTrimFeatureIcons(modelData.configuration.featureIcons),
        comparisonModelTrimCode: '',
        comparisonModelTrim: '',
        comparisonModelTrimExtension: '',
        comparisonAddFeatures: {},
        comparisonRemoveFeatures: {},
        comparisonAddFeatureIcons: {}
    });
}

function resetModelTrimFromOriginData(dataOrigin, originModelTrimData) {
    if ((0, _lodash.isEmpty)(originModelTrimData) || !(0, _lodash.isObjectLike)(originModelTrimData)) {
        return new _ModelTrimModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _ModelTrimModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetModelTrimFromModelData(originModelTrimData);

        default:
            return new _ModelTrimModel2.default();
    }
}

function addModelTrimConfigurationId(modelTrim, configurationId, configuration) {
    var _mergeModelTrimsBitFi = (0, _DataUtilitiesService.mergeModelTrimsBitField)(modelTrim, configuration, true),
        trimsBitField = _mergeModelTrimsBitFi.trimsBitField,
        trimsBitFields = _mergeModelTrimsBitFi.trimsBitFields;

    var configurationIds = modelTrim.get('configurationIds');
    configurationIds[configurationId] = configuration.trimsBitField;

    return modelTrim.set('trimsBitField', trimsBitField).set('trimsBitFields', trimsBitFields).set('configurationIds', configurationIds);
}

function resetModelTrimComparisonFeatures(prevTrimID, prevTrim, prevTrimExtension, prevTrimFeatures, modelTrim) {
    var compareModelTrim = modelTrim;

    var comparisonAddFeatures = {};
    var comparisonAddFeatureIcons = {};
    var comparisonRemoveFeatures = {};

    (0, _lodash.forEach)(modelTrim.features, function (feature, key) {
        comparisonAddFeatures[key] = feature;
        if (!(0, _lodash.isEmpty)(modelTrim.featureIcons) && !(0, _lodash.isUndefined)(modelTrim.featureIcons[key])) {
            comparisonAddFeatureIcons[key] = modelTrim.featureIcons[key];
        }
    });

    if (!(0, _lodash.isEmpty)(prevTrimFeatures)) {
        compareModelTrim = compareModelTrim.set('comparisonModelTrimCode', prevTrimID).set('comparisonModelTrim', prevTrim).set('comparisonModelTrimExtension', prevTrimExtension);

        (0, _lodash.forEach)(prevTrimFeatures, function (prevTrimFeature, prevTrimKey) {
            if (!(0, _lodash.isEmpty)(comparisonAddFeatures[prevTrimKey])) {
                delete comparisonAddFeatures[prevTrimKey];
                if (!(0, _lodash.isEmpty)(compareModelTrim.featureIcons) && !(0, _lodash.isUndefined)(compareModelTrim.featureIcons[prevTrimKey])) {
                    delete comparisonAddFeatureIcons[prevTrimKey];
                }
            } else {
                comparisonRemoveFeatures[prevTrimKey] = prevTrimFeature;
            }
        });

        (0, _lodash.forEach)(comparisonAddFeatures, function (comparisonFeature, comparisonFeatureKey) {
            if (!(0, _lodash.isEmpty)(prevTrimFeatures[comparisonFeatureKey])) {
                delete comparisonAddFeatures[comparisonFeatureKey];
            }
        });
    }

    return compareModelTrim.set('comparisonAddFeatures', comparisonAddFeatures).set('comparisonAddFeatureIcons', (0, _immutable.List)(getModelTrimAddFeatureRankedIcons(modelTrim.features, modelTrim.modelTrimFeatures, comparisonAddFeatures))).set('comparisonRemoveFeatures', comparisonRemoveFeatures);
}

exports.default = {
    getModelTrimFeatureIcons: getModelTrimFeatureIcons,
    getModelTrimAddFeatureRankedIcons: getModelTrimAddFeatureRankedIcons,
    resetModelTrimFromModelData: resetModelTrimFromModelData,
    resetModelTrimFromOriginData: resetModelTrimFromOriginData,
    addModelTrimConfigurationId: addModelTrimConfigurationId,
    resetModelTrimComparisonFeatures: resetModelTrimComparisonFeatures
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ModelYearAPIService/ModelYearAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModelYearAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelYearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js");

var _TradeInVehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var _ShowroomAPIService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _TradeInVehicleAPIService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _DisclaimerAPIService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _TradeInVehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to merge Model Years API calls responses into a new models object and return the new merged object
 * @param {Object[]} results API response data array
 * @param {Boolean} requestTradeInVehicleLoad
 * @param {String} language
 */
function mergeLoadBuildAndQuoteModelYearsDataResults(results, requestTradeInVehicleLoad, language, disclaimers) {
    if ((0, _lodash.isEmpty)(results)) {
        return {
            years: (0, _immutable.List)([]),
            tradeInVehicle: new _TradeInVehicleModel2.default()
        };
    }
    var modelYearsData = results[0].data.view;
    var modelYearsConverted = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEARS, modelYearsData, (0, _lodash.isEmpty)(language) ? 'en' : language, disclaimers);

    var tradeInVehicle = requestTradeInVehicleLoad && !(0, _lodash.isEmpty)(results[1]) ? (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(results[1].data) : new _TradeInVehicleModel2.default();

    return {
        years: modelYearsConverted.years,
        tradeInVehicle: tradeInVehicle
    };
}

/**
 * Util to merge Model Year API calls responses into a new models object and return the new merged object
 * @param {Object[]} results API response data array
 * @param {Boolean} requestTradeInVehicleLoad
 * @param {String} language
 */
function mergeLoadBuildAndQuoteModelYearDataResults(results, requestTradeInVehicleLoad, language, disclaimers) {
    if ((0, _lodash.isEmpty)(results)) {
        return {
            modelYear: new _ModelYearModel2.default(),
            purchaseMethods: new _PurchaseMethodsModel2.default(),
            tradeInVehicle: new _TradeInVehicleModel2.default()
        };
    }
    var modelYearData = results[0].data.view;
    var modelYearConverted = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelYearData, (0, _lodash.isEmpty)(language) ? 'en' : language, disclaimers);

    var tradeInVehicle = requestTradeInVehicleLoad && !(0, _lodash.isEmpty)(results[1]) ? (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(results[1].data) : new _TradeInVehicleModel2.default();

    return _extends({}, modelYearConverted, {
        tradeInVehicle: tradeInVehicle
    });
}

/**
 * Groups Make Model Year api calls to ShowroomAPI
 */

var ModelYearAPIService = function () {
    function ModelYearAPIService() {
        _classCallCheck(this, ModelYearAPIService);

        /**
         * The base path for Make Model Year ShowroomAPI
         * @type {string}
         */
        this.basePathModelYear = _index2.default.endpoint.showroom + '/service/v1/view/2.1';

        /**
         * The base path for Make Model Years ShowroomAPI
         * @type {string}
         */
        this.basePathModelYears = _index2.default.endpoint.showroom + '/service/v1/view/1.1';
    }

    /**
     * Returns the axios request configuration object to load a Make Model Year Model for a given model year
     * @param {string} publicToken
     * @param {int} year
     * @param {string} make
     * @param {string} model
     * @param {string} bodyStyleCode
     */


    _createClass(ModelYearAPIService, [{
        key: 'getLoadModelYearRequestConfig',
        value: function getLoadModelYearRequestConfig(publicToken, year, make, model, bodyStyleCode) {
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            var requestConfig = {
                url: this.basePathModelYear,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                location: (0, _lodash.isEmpty)(location) ? '' : location,
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                year: (0, _lodash.isFinite)(year) ? year : 0,
                make: (0, _lodash.toUpper)((0, _lodash.isString)(make) ? make : ''),
                model: (0, _lodash.isString)(model) ? model : '',
                bodyStyleCode: (0, _lodash.toUpper)((0, _lodash.isString)(bodyStyleCode) ? bodyStyleCode : ''),
                datalevel: 256,
                unfiltered: true
            };

            return requestConfig;
        }

        /**
         * Returns the axios request configuration object to load a Make Model Year Model for all years of a given model
         * @param {string} publicToken
         * @param {string} make
         * @param {string} model
         * @param {string} bodyStyleCode
         */

    }, {
        key: 'getLoadModelYearsRequestConfig',
        value: function getLoadModelYearsRequestConfig(publicToken, make, model, bodyStyleCode) {
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            var requestConfig = {
                url: this.basePathModelYears,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                location: (0, _lodash.isEmpty)(location) ? '' : location,
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                make: (0, _lodash.toUpper)((0, _lodash.isString)(make) ? make : ''),
                model: (0, _lodash.isString)(model) ? model : '',
                bodyStyleCode: (0, _lodash.toUpper)((0, _lodash.isString)(bodyStyleCode) ? bodyStyleCode : ''),
                subGrouping: 'year',
                datalevel: 768
            };

            return requestConfig;
        }

        /**
         * Returns a Model Years Models Object from model and trade in parameters
         * @param {Object} modelYearsParams
         * @param {Object} tradeInVehicleParams
         */

    }, {
        key: 'loadModelYears',
        value: function loadModelYears(modelYearsParams, tradeInVehicleParams) {
            var _this = this;

            if (!(0, _lodash.isObjectLike)(modelYearsParams) || (0, _lodash.isEmpty)(modelYearsParams.make) || (0, _lodash.isEmpty)(modelYearsParams.model) || (0, _lodash.isEmpty)(modelYearsParams.bodyStyleCode)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            }

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var requireTradeInVehicleLoad = ((0, _lodash.isEmpty)(tradeInVehicleParams) || (0, _lodash.isEmpty)(tradeInVehicleParams.tradeInVehicleId)) && !(0, _lodash.isEmpty)(token);
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                    var promises = [];
                    var make = modelYearsParams.make,
                        model = modelYearsParams.model,
                        bodyStyleCode = modelYearsParams.bodyStyleCode;

                    var modelYearsRequestConfig = _this.getLoadModelYearsRequestConfig(publicToken.data, make, model, bodyStyleCode);
                    promises.push(_axios2.default.request(modelYearsRequestConfig));

                    if (requireTradeInVehicleLoad) {
                        var tradeInVehicleId = !(0, _lodash.isEmpty)(tradeInVehicleParams) ? tradeInVehicleParams.tradeInVehicleId : '';
                        var tradeInVehicleRequestConfig = _TradeInVehicleAPIService2.default.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
                        promises.push(_axios2.default.request(tradeInVehicleRequestConfig));
                    }

                    return _axios2.default.all(promises).then(function (results) {
                        return mergeLoadBuildAndQuoteModelYearsDataResults(results, requireTradeInVehicleLoad, language, disclaimers);
                    }).catch(function () {
                        console.error('Unable to load Model Years Data for ' + make + ' ' + model + ' ' + bodyStyleCode);
                        return Promise.reject();
                    });
                });
            });
        }

        /**
         * Returns a Model Year Models Object from model and trade in parameters
         * @param {Object} modelYearParams
         * @param {Object} tradeInVehicleParams
         */

    }, {
        key: 'loadModelYear',
        value: function loadModelYear(modelYearParams, tradeInVehicleParams) {
            var _this2 = this;

            if (!(0, _lodash.isObjectLike)(modelYearParams) || !(0, _lodash.isFinite)(modelYearParams.year) || (0, _lodash.isEmpty)(modelYearParams.make) || (0, _lodash.isEmpty)(modelYearParams.model) || (0, _lodash.isEmpty)(modelYearParams.bodyStyleCode)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            }

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var requireTradeInVehicleLoad = ((0, _lodash.isEmpty)(tradeInVehicleParams) || (0, _lodash.isEmpty)(tradeInVehicleParams.tradeInVehicleId)) && !(0, _lodash.isEmpty)(token);
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                    var promises = [];
                    var year = modelYearParams.year,
                        make = modelYearParams.make,
                        model = modelYearParams.model,
                        bodyStyleCode = modelYearParams.bodyStyleCode;

                    var modelYearsRequestConfig = _this2.getLoadModelYearRequestConfig(publicToken.data, year, make, model, bodyStyleCode);
                    promises.push(_axios2.default.request(modelYearsRequestConfig));

                    if (requireTradeInVehicleLoad) {
                        var tradeInVehicleId = !(0, _lodash.isEmpty)(tradeInVehicleParams) ? tradeInVehicleParams.tradeInVehicleId : '';
                        var tradeInVehicleRequestConfig = _TradeInVehicleAPIService2.default.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
                        promises.push(_axios2.default.request(tradeInVehicleRequestConfig));
                    }

                    return _axios2.default.all(promises).then(function (results) {
                        return mergeLoadBuildAndQuoteModelYearDataResults(results, requireTradeInVehicleLoad, language, disclaimers);
                    }).catch(function () {
                        console.error('Unable to load Model Year Data for ' + year + ' ' + make + ' ' + model + ' ' + bodyStyleCode);
                        return Promise.reject();
                    });
                });
            });
        }
    }]);

    return ModelYearAPIService;
}();

exports.ModelYearAPIService = ModelYearAPIService;
exports.default = new ModelYearAPIService();

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetModelYearFromOriginData = resetModelYearFromOriginData;
exports.setSelectedDrivePowerTrain = setSelectedDrivePowerTrain;
exports.setSelectedModelTrim = setSelectedModelTrim;
exports.setSelectedBoxSize = setSelectedBoxSize;
exports.setSelectedCabSize = setSelectedCabSize;
exports.setSelectedOptionsPackage = setSelectedOptionsPackage;
exports.setSelectedExteriorColour = setSelectedExteriorColour;
exports.setSelectedInteriorColour = setSelectedInteriorColour;
exports.resetModelYears = resetModelYears;
exports.resetModelYear = resetModelYear;
exports.resetConfigurationToken = resetConfigurationToken;
exports.resetOptionsAvailability = resetOptionsAvailability;
exports.resetOptionsSelectionResolutions = resetOptionsSelectionResolutions;
exports.setAvailableOptions = setAvailableOptions;
exports.setSelectedOptions = setSelectedOptions;
exports.resetPaymentsAndPurchaseAmounts = resetPaymentsAndPurchaseAmounts;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.selectTerm = selectTerm;
exports.selectKMPlan = selectKMPlan;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setTaxesIncluded = setTaxesIncluded;
exports.resetModelYearFromQuote = resetModelYearFromQuote;
exports.resetModelYearOptionsFromQuote = resetModelYearOptionsFromQuote;
exports.setSelectedModelYear = setSelectedModelYear;
exports.resetEmployeeRebateAdjustment = resetEmployeeRebateAdjustment;
exports.resetPercentageRebateAdjustment = resetPercentageRebateAdjustment;

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _apiDataConversionConstants = __webpack_require__("../widget-commons-vehicle/src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethodsConstants = _interopRequireWildcard(_purchaseMethods);

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var UtilitiesService = _interopRequireWildcard(_DataUtilitiesService);

var _ModelTrimConfigurationService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimConfigurationService/ModelTrimConfigurationService.js");

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _QuoteItemCategoryService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _ModelTrimItemsService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimItemsService/ModelTrimItemsService.js");

var ModelTrimItemsService = _interopRequireWildcard(_ModelTrimItemsService);

var _CabSizeService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/CabSizeService/CabSizeService.js");

var _BoxSizeService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/BoxSizeService/BoxSizeService.js");

var _DriveTrainService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DriveTrainService/DriveTrainService.js");

var _YearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/YearService/YearService.js");

var YearService = _interopRequireWildcard(_YearService);

var _ModelTrimService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelTrimService/ModelTrimService.js");

var ModelTrimService = _interopRequireWildcard(_ModelTrimService);

var _DrivePowerTrainService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DrivePowerTrainService/DrivePowerTrainService.js");

var DrivePowerTrainService = _interopRequireWildcard(_DrivePowerTrainService);

var _OptionsPackageService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionsPackageService/OptionsPackageService.js");

var OptionsPackageService = _interopRequireWildcard(_OptionsPackageService);

var _OptionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js");

var OptionService = _interopRequireWildcard(_OptionService);

var _OptionsSelectionResolutionsService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionsService/OptionsSelectionResolutionsService.js");

var OptionsSelectionResolutionsService = _interopRequireWildcard(_OptionsSelectionResolutionsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint no-bitwise: 0 */

function getDefaultModelTrimConfiguration() {
    return {
        year: 0,
        make: '',
        model: '',
        bodyStyleCode: '',
        bodyStyle: '',
        cabSize: {},
        driveTrain: {},
        boxSize: {},
        modelTrim: {},
        configurationId: 0,
        configuration: {},
        exteriorColourStatus: _exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE,
        package: {
            code: '',
            selectionCode: '',
            description: ''
        },
        engine: {
            code: '',
            selectionCode: '',
            fuelTypeCode: '',
            cylinders: 0,
            displacement: 0.0,
            isTurbo: false,
            hp: 0,
            hpRpm: 0,
            torque: 0,
            torqueRpm: 0,
            description: ''
        },
        transmission: {
            code: '',
            selectionCode: '',
            typeCode: '',
            rank: 99,
            label: '',
            type: '',
            speeds: 0,
            isCVT: false,
            description: ''
        },
        priceIds: {
            modelTrimCode: '',
            configurationId: 0
        },
        leaseIds: {
            modelTrimCode: '',
            configurationId: 0
        },
        financeIds: {
            modelTrimCode: '',
            configurationId: 0
        }
    };
}

function setModelTrimFeatures(modelTrimConfigurations, modelTrimFeatures) {
    var newModelTrimFeatures = modelTrimFeatures;

    (0, _lodash.forEach)(modelTrimConfigurations.modelTrimFeatures, function (modelTrimFeature, key) {
        if ((0, _lodash.isEmpty)(modelTrimFeatures[key])) {
            newModelTrimFeatures[key] = {
                trimsBitField: modelTrimConfigurations.trimsBitField,
                feature: modelTrimFeature
            };
        } else {
            var modelTrimTrimsBitField = newModelTrimFeatures[key].trimsBitField;
            newModelTrimFeatures[key].trimsBitField = modelTrimTrimsBitField | modelTrimConfigurations.trimsBitField;
        }
    });
}

function getModelTrimsConfigurationsFromModelData(modelData, modelTrimsData, modelOptions) {
    var configurations = [];

    if ((0, _lodash.isEmpty)(modelTrimsData) || (0, _lodash.isEmpty)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.TRIMS])) {
        return configurations;
    }

    var cabSizes = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.CABS], function (modelCabSize) {
        cabSizes.push((0, _CabSizeService.resetCabSizeFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelCabSize));
    });

    var boxSizes = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.BOXES], function (modelBoxSize) {
        boxSizes.push((0, _BoxSizeService.resetBoxSizeFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelBoxSize));
    });

    var driveTrains = [];
    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.DRIVES], function (modelDriveTrain) {
        driveTrains.push((0, _DriveTrainService.resetDriveTrainFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelDriveTrain));
    });

    (0, _lodash.forEach)(modelTrimsData[Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.TRIMS], function (trim) {
        var trimDescription = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.DESCRIPTION]);
        var trimExtensionCode = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_CODE]);
        var trimSelectionCode = trimDescription + '|' + trimExtensionCode;

        var modelTrim = UtilitiesService.getSelectionObject(trim[Constants.VIEW_2_1.VEHICLE.TRIM.BIT_FIELD], trimSelectionCode, trimSelectionCode, trim[Constants.VIEW_2_1.VEHICLE.TRIM.DESCRIPTION]);

        modelTrim.extensionCode = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_CODE]);
        modelTrim.extensionDescription = UtilitiesService.getDescriptionData(trim[Constants.VIEW_2_1.VEHICLE.TRIM.EXTENSION_DESCRIPTION]);

        modelTrim.hasOptions = trim[Constants.VIEW_2_1.VEHICLE.TRIM.HAS_OPTIONS];

        var modelTrimFeatures = {};
        var allConfigTrimsBitField = 0;
        if (!(0, _lodash.isEmpty)(trim[Constants.VIEW_2_1.VEHICLE.TRIM.CONFIGURATIONS])) {
            var modelTrimConfigs = [];
            (0, _lodash.forEach)(trim[Constants.VIEW_2_1.VEHICLE.TRIM.CONFIGURATIONS], function (modelTrimConfiguration) {
                if (modelTrimConfiguration.length === _dataConversions.MODEL_TAXES.TAXES_FACTOR - 1) {
                    modelTrimConfiguration.push(_exteriorColourStatuses.IMAGE_STATUS.NO_IMAGE);
                }
                modelTrimConfiguration.push(modelData.taxesFactor);
                modelTrimConfiguration.push(modelData.taxCodes);

                var conf = (0, _ModelTrimConfigurationService.resetModelTrimConfigurationFromModelData)(modelTrimConfiguration, modelOptions, modelTrim, driveTrains, cabSizes, boxSizes);
                setModelTrimFeatures(conf, modelTrimFeatures);
                var tempTrimsBitField = allConfigTrimsBitField;
                allConfigTrimsBitField = tempTrimsBitField | conf.trimsBitField;

                modelTrimConfigs.push(conf);
                configurations.push(conf);
            });
        }
    });

    return configurations;
}

function getModelTrimsFromModelData(dataOrigin, modelTrimsData) {
    var vehicle = {
        year: 0,
        make: '',
        model: '',
        bodyStyleCode: '',
        bodyStyle: '',
        vehicles: []
    };

    switch (dataOrigin) {
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            {
                vehicle.make = modelTrimsData.make;
                vehicle.model = modelTrimsData.model;
                vehicle.bodyStyleCode = modelTrimsData.bodyStyleCode;
                vehicle.bodyStyle = modelTrimsData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX];

                vehicle.year = modelTrimsData.years[0][Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.YEAR];

                var modelOptions = ModelTrimItemsService.getModelYearFeaturesAndOptions(modelTrimsData.years[0]);

                var modelTrimsConfigurations = getModelTrimsConfigurationsFromModelData(modelTrimsData, modelTrimsData.years[0], modelOptions);

                vehicle.vehicles = (0, _lodash.map)(modelTrimsConfigurations, function (modelTrimConfiguration) {
                    var configurationVehicle = getDefaultModelTrimConfiguration();
                    configurationVehicle.year = vehicle.year;
                    configurationVehicle.make = vehicle.make;
                    configurationVehicle.model = vehicle.model;
                    configurationVehicle.bodyStyleCode = vehicle.bodyStyleCode;
                    configurationVehicle.bodyStyle = vehicle.bodyStyleCode;

                    configurationVehicle.cabSize = modelTrimConfiguration.cabSize;
                    configurationVehicle.boxSize = modelTrimConfiguration.boxSize;
                    configurationVehicle.driveTrain = modelTrimConfiguration.driveTrain;

                    configurationVehicle.modelTrimCode = modelTrimConfiguration.modelTrimCode;
                    configurationVehicle.modelTrim = modelTrimConfiguration.modelTrim;

                    configurationVehicle.configurationId = modelTrimConfiguration.id;
                    configurationVehicle.configuration = modelTrimConfiguration;
                    configurationVehicle.package = modelTrimConfiguration.package;
                    configurationVehicle.engine = modelTrimConfiguration.engine;
                    configurationVehicle.transmission = modelTrimConfiguration.transmission;

                    return {
                        vehicle: configurationVehicle,
                        purchaseMethods: modelTrimConfiguration.purchaseMethods
                    };
                });
                break;
            }
        default:
            break;
    }

    return vehicle;
}

function getModelTrimFromModelData(dataOrigin, modelTrimData) {
    var modelTrim = getDefaultModelTrimConfiguration();

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            modelTrim.make = modelTrimData.make;
            modelTrim.model = modelTrimData.model;
            modelTrim.bodyStyleCode = modelTrimData.bodyStyleCode;
            modelTrim.bodyStyle = modelTrimData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX];

            if (modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_PRICE]) {
                var highPriceObject = modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_PRICE][Constants.VIEW_1.VEHICLE.HIGH_PRICE_INDEX];
                modelTrim.exteriorColours = {
                    photo1: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_1],
                    photo2: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_2],
                    photo3: highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_3]
                };

                if (!(0, _lodash.isUndefined)(highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS])) {
                    modelTrim.exteriorColourStatus = highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS];
                } else if (modelTrim.exteriorColours.photo1) {
                    modelTrim.exteriorColourStatus = _exteriorColourStatuses.IMAGE_STATUS.FULL_COLORIZED;
                }
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.REBATE]) {
                var rebateObject = modelTrimData[Constants.VIEW_1.VEHICLE.REBATE][Constants.VIEW_1.VEHICLE.REBATE_INDEX];
                modelTrim.rebate = rebateObject[Constants.VIEW_1.VEHICLE.REBATE_RETAIL];
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_REBATE]) {
                var highRebateObject = modelTrimData[Constants.VIEW_1.VEHICLE.HIGH_REBATE][Constants.VIEW_1.VEHICLE.HIGH_REBATE_INDEX];
                var highRebateTaxes = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
                modelTrim.highRebate = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
                modelTrim.highRebatePurchaseMethod = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
            }

            if (modelTrimData[Constants.VIEW_1.VEHICLE.PRICE]) {
                var priceObject = modelTrimData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX];
                if (priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER]) {
                    modelTrim.priceModelDisclaimer = priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER][Constants.VIEW_1.PRICE_DISCLAIMER.MODEL_SHORT];
                    modelTrim.priceExclusionsDisclaimer = priceObject[Constants.VIEW_1.VEHICLE.PRICE_DISCLAIMER][Constants.VIEW_1.PRICE_DISCLAIMER.EXCLUSIONS];
                }

                if (priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE] && priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE]) {
                    modelTrim.priceIds.year = priceObject[Constants.VIEW_1.VEHICLE.PRICE_YEAR];
                    modelTrim.priceIds.modelTrimCode = priceObject[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE];
                    modelTrim.priceIds.configurationId = priceObject[Constants.VIEW_1.VEHICLE.PRICE_CONFIGURATION_ID];
                }
            }

            modelTrim.leaseModelDisclaimer = '';
            if (modelTrimData[Constants.VIEW_1.VEHICLE.LEASE]) {
                var leaseObject = modelTrimData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX];
                if (leaseObject[Constants.VIEW_1.VEHICLE.LEASE_DISCLAIMER]) {
                    modelTrim.leaseModelDisclaimer = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_DISCLAIMER][Constants.VIEW_1.FINANCE_DISCLAIMER.MODEL_SHORT];
                }

                if (leaseObject[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE] && leaseObject[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID]) {
                    modelTrim.leaseIds.year = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_YEAR];
                    modelTrim.leaseIds.modelTrimCode = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE];
                    modelTrim.leaseIds.configurationId = leaseObject[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID];
                }
            }

            modelTrim.financeModelDisclaimer = '';
            if (modelTrimData[Constants.VIEW_1.VEHICLE.FINANCE]) {
                var financeObject = modelTrimData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX];
                if (financeObject[Constants.VIEW_1.VEHICLE.FINANCE_DISCLAIMER]) {
                    modelTrim.financeModelDisclaimer = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_DISCLAIMER][Constants.VIEW_1.FINANCE_DISCLAIMER.MODEL_SHORT];
                }

                if (financeObject[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE] && financeObject[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID]) {
                    modelTrim.financeIds.year = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_YEAR];
                    modelTrim.financeIds.modelTrimCode = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE];
                    modelTrim.financeIds.configurationId = financeObject[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID];
                }
            }

            modelTrim.makeVisible = true;
            modelTrim.bodyStyleVisible = true;
            modelTrim.modelVisible = true;
            modelTrim.visible = true;
            break;

        default:
            break;
    }

    return modelTrim;
}

function resetModelComparisonFeatures(model) {
    var prevTrimID = '';
    var prevTrim = '';
    var prevTrimExtension = '';
    var prevTrimFeatures = {};

    return (0, _lodash.map)(model.modelTrims, function (modelTrim) {
        var newModelTrim = ModelTrimService.resetModelTrimComparisonFeatures(prevTrimID, prevTrim, prevTrimExtension, prevTrimFeatures, modelTrim);
        prevTrimID = modelTrim.selectionCode;
        prevTrim = modelTrim.description;
        prevTrimExtension = modelTrim.trimExtensionDescription;
        prevTrimFeatures = modelTrim.features;

        return newModelTrim;
    });
}

function getModelPowersAndTrimsFromModelData(modelPowersAndTrimsData, disclaimers) {
    var modelYear = {
        isSingleConfiguration: true,
        hasOptions: false,
        cabSizes: {},
        boxSizes: {},
        modelTrims: {},
        drivePowerTrains: {},
        optionsPackages: {}
    };

    if ((0, _lodash.isEmpty)(modelPowersAndTrimsData)) {
        return modelYear;
    }

    var modelTrimDrivePowerConfigurationCount = {};

    (0, _lodash.forEach)(modelPowersAndTrimsData, function (modelPowerAndTrimData) {
        var modelPowerAndTrim = modelPowerAndTrimData.vehicle;

        if (modelPowerAndTrim.configuration.modelTrim.hasOptions) {
            modelYear.hasOptions = true;
        }

        var drivePowerTrainSelectionCode = modelPowerAndTrim.driveTrain.selectionCode + '|' + (modelPowerAndTrim.engine.getSelectionCode() + '|') + ('' + modelPowerAndTrim.transmission.getSelectionCode());

        var cabSizeSelectionCode = (0, _lodash.isNull)(modelPowerAndTrim.cabSize) ? '' : modelPowerAndTrim.cabSize.selectionCode;
        var boxSizeSelectionCode = (0, _lodash.isNull)(modelPowerAndTrim.boxSize) ? '' : modelPowerAndTrim.boxSize.selectionCode;
        var modelTrimSelectionCode = modelPowerAndTrim.modelTrim.selectionCode;
        var packageSelectionCode = '' + cabSizeSelectionCode + modelPowerAndTrim.package.selectionCode + '|' + ('' + modelPowerAndTrim.configurationId);
        var modelTrimConfigurationId = modelPowerAndTrim.configuration.selectionCode;

        if (cabSizeSelectionCode && (0, _lodash.isEmpty)(modelYear.cabSizes[cabSizeSelectionCode])) {
            modelYear.cabSizes[cabSizeSelectionCode] = modelPowerAndTrim.cabSize;
        }

        if (boxSizeSelectionCode && (0, _lodash.isEmpty)(modelYear.boxSizes[boxSizeSelectionCode])) {
            modelYear.boxSizes[boxSizeSelectionCode] = modelPowerAndTrim.boxSize;
        }

        if ((0, _lodash.isEmpty)(modelYear.modelTrims[modelTrimSelectionCode])) {
            modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode] = {};
            modelYear.modelTrims[modelTrimSelectionCode] = ModelTrimService.resetModelTrimFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim);
        } else if (modelYear.modelTrims[modelTrimSelectionCode].rank > modelPowerAndTrim.configuration.modelTrimRank) {
            modelYear.modelTrims[modelTrimSelectionCode] = modelYear.modelTrims[modelTrimSelectionCode].set('rank', modelPowerAndTrim.configuration.modelTrimRank);
        }

        if ((0, _lodash.isEmpty)(modelYear.drivePowerTrains[drivePowerTrainSelectionCode])) {
            modelYear.drivePowerTrains[drivePowerTrainSelectionCode] = DrivePowerTrainService.resetDrivePowerTrainFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim);
        }

        if ((0, _lodash.isUndefined)(modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode])) {
            modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode] = 0;
        } else {
            modelYear.isSingleConfiguration = false;
        }
        modelTrimDrivePowerConfigurationCount[modelTrimSelectionCode][drivePowerTrainSelectionCode] += 1;

        if ((0, _lodash.isEmpty)(modelYear.optionsPackages[packageSelectionCode])) {
            modelYear.optionsPackages[packageSelectionCode] = OptionsPackageService.resetOptionsPackageFromOriginData(DataOrigins.MODEL_YEAR_POWERS_TRIMS, modelPowerAndTrim, disclaimers);
        }

        if ((0, _lodash.isEmpty)(modelYear.drivePowerTrains[drivePowerTrainSelectionCode].configurationIds[modelTrimConfigurationId])) {
            modelYear.drivePowerTrains[drivePowerTrainSelectionCode] = DrivePowerTrainService.addDrivePowerTrainConfigurationId(modelYear.drivePowerTrains[drivePowerTrainSelectionCode], modelTrimConfigurationId, modelPowerAndTrim.configuration);
        }

        if ((0, _lodash.isEmpty)(modelYear.modelTrims[modelTrimSelectionCode].configurationIds[modelTrimConfigurationId])) {
            modelYear.modelTrims[modelTrimSelectionCode] = ModelTrimService.addModelTrimConfigurationId(modelYear.modelTrims[modelTrimSelectionCode], modelTrimConfigurationId, modelPowerAndTrim.configuration);
        }
    });

    modelYear.cabSizes = (0, _lodash.sortBy)(modelYear.cabSizes, function (cabSize) {
        return cabSize.rank;
    });

    modelYear.boxSizes = (0, _lodash.sortBy)(modelYear.boxSizes, function (boxSize) {
        return boxSize.rank;
    });

    modelYear.modelTrims = (0, _lodash.sortBy)(modelYear.modelTrims, function (modelTrim) {
        return modelTrim.rank;
    });

    modelYear.drivePowerTrains = (0, _lodash.sortBy)(modelYear.drivePowerTrains, function (drivePowerTrain) {
        return drivePowerTrain.rank;
    });

    modelYear.optionsPackages = (0, _lodash.sortBy)(modelYear.optionsPackages, function (optionsPackage) {
        return optionsPackage.rank;
    });

    modelYear.modelTrims = resetModelComparisonFeatures(modelYear);

    return modelYear;
}

function resetModelYearFromModelData(modelModelYearData, locale, disclaimers) {
    var vehicle = modelModelYearData[0].vehicle;

    var powersAndTrims = getModelPowersAndTrimsFromModelData(modelModelYearData, disclaimers);

    return new _ModelYearModel2.default({
        lang: locale,
        year: vehicle.year,
        make: vehicle.make,
        model: vehicle.model,
        bodyStyleCode: vehicle.bodyStyleCode,
        isSingleConfiguration: powersAndTrims.isSingleConfiguration,
        hasOptions: powersAndTrims.hasOptions,
        cabSizes: (0, _lodash.values)(powersAndTrims.cabSizes),
        boxSizes: (0, _lodash.values)(powersAndTrims.boxSizes),
        modelTrims: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.modelTrims).map(function (modelTrim) {
            return modelTrim;
        })),
        drivePowerTrains: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.drivePowerTrains).map(function (drivePowerTrain) {
            return drivePowerTrain;
        })),
        optionsPackages: (0, _immutable.List)().concat((0, _lodash.values)(powersAndTrims.optionsPackages).map(function (pack) {
            return pack;
        }))
    });
}

function getMergedModelTrimTrimsBitField(modelTrim) {
    var modelTrimTrimsBitField = {
        trimsBitField: modelTrim.trimsBitField,
        trimsBitFields: modelTrim.trimsBitFields
    };

    if (modelTrim.cabSizeTrimsBitField || !(0, _lodash.isEmpty)(modelTrim.cabSizeTrimsBitFields)) {
        modelTrimTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, {
            trimsBitField: modelTrim.cabSizeTrimsBitField,
            trimsBitFields: modelTrim.cabSizeTrimsBitFields
        }, false);
    }
    if (modelTrim.boxSizeTrimsBitField || !(0, _lodash.isEmpty)(modelTrim.boxSizeTrimsBitFields)) {
        modelTrimTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, {
            trimsBitField: modelTrim.boxSizeTrimsBitField,
            trimsBitFields: modelTrim.boxSizeTrimsBitFields
        }, false);
    }
    return modelTrimTrimsBitField;
}

function resetModelYearItemVisibility(modelYearItem, trimsBitField) {
    return modelYearItem.set('visible', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearItem, trimsBitField) > 0).set('selected', false);
}

function resetModelYearOptionPackagesVisibility(modelYearOptionsPackage, trimsBitField, engineSelectionCode, transmissionSelectionCode) {
    return modelYearOptionsPackage.set('visible', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearOptionsPackage, trimsBitField) > 0 && modelYearOptionsPackage.configuration.engine.selectionCode === engineSelectionCode && modelYearOptionsPackage.configuration.transmission.selectionCode === transmissionSelectionCode).set('selected', false);
}

function resetModelYearItemAvailability(modelYearItem, trimsBitField) {
    return modelYearItem.set('enabled', UtilitiesService.intersectModelTrimsBitFieldValue(modelYearItem, trimsBitField) > 0).set('selected', false);
}

function resetModelTrimsAvailabilityFromBoxSize(modelTrim, boxSizeTrimsBitField) {
    var mergedModelTrimAndCab = UtilitiesService.mergeModelTrimsBitField(modelTrim, {
        trimsBitField: modelTrim.cabSizeTrimsBitField,
        trimsBitFields: modelTrim.cabSizeTrimsBitFields
    }, false);

    return modelTrim.set('boxSizeTrimsBitField', boxSizeTrimsBitField.trimsBitField).set('boxSizeTrimsBitFields', boxSizeTrimsBitField.trimsBitFields).set('enabled', UtilitiesService.intersectModelTrimsBitFieldValue(mergedModelTrimAndCab, boxSizeTrimsBitField) > 0).set('selected', false);
}

function selectModelYearItemFromCode(modelYearItem, selectionCode) {
    return modelYearItem.set('selected', modelYearItem.selectionCode === selectionCode);
}

function resetModelYearFromOriginData(dataOrigin, originModelYearData, locale, disclaimers) {
    if ((0, _lodash.isEmpty)(originModelYearData) || !(0, _lodash.isObjectLike)(originModelYearData)) {
        return new _ModelYearModel2.default();
    }
    var vehicles = [];

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            vehicles = (0, _lodash.map)(originModelYearData, function (modelData) {
                var vehicle = {};
                vehicle.vehicle = getModelTrimFromModelData(dataOrigin, modelData);
                var purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(dataOrigin, modelData);
                vehicle.purchaseMethods = disclaimers ? purchaseMethods.set('disclaimers', disclaimers) : purchaseMethods;

                return vehicle;
            });

            return vehicles;

        case DataOrigins.MODEL_YEARS:
            {
                var convertedVehicle = {
                    years: []
                };

                (0, _lodash.forEach)(originModelYearData, function (modelData) {
                    (0, _lodash.forEach)(modelData, function (modelYearData, key) {
                        convertedVehicle.years.push(YearService.resetYearFromOriginData(DataOrigins.MODELS_COLLECTION, modelYearData, parseInt(key, 10), disclaimers));
                    });
                });

                if (convertedVehicle.years.length > 2) {
                    convertedVehicle.years = (0, _lodash.takeRight)((0, _lodash.sortBy)(convertedVehicle.years, function (y) {
                        return y.year;
                    }), 2);
                }

                convertedVehicle.years = (0, _immutable.List)(convertedVehicle.years);
                return convertedVehicle;
            }
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            (0, _lodash.forEach)(originModelYearData, function (modelYearData) {
                var modelTrims = getModelTrimsFromModelData(dataOrigin, modelYearData);

                (0, _lodash.forEach)(modelTrims.vehicles, function (vehicle) {
                    vehicles.push({
                        vehicle: vehicle.vehicle,
                        purchaseMethods: vehicle.purchaseMethods
                    });
                });
            });

            return {
                modelYear: resetModelYearFromModelData(vehicles, locale, disclaimers),
                purchaseMethods: disclaimers ? vehicles[0].purchaseMethods.set('disclaimers', disclaimers) : vehicles[0].purchaseMethods
            };

        default:
            return new _ModelYearModel2.default();
    }
}

function resetSelectedExteriorColour(modelYear) {
    if (!modelYear.getSelectedOptionsPackageExteriorColour()) {
        var exteriorColor = modelYear.getSelectedOptionsPackageBestAvailableExteriorColour();
        if (!exteriorColor) {
            return modelYear;
        }
        var exteriorColourSelectionCode = exteriorColor.colourCode;
        return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
            return OptionsPackageService.resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode);
        }));
    }

    return modelYear;
}

function resetSelectedOptionsPackage(modelYear) {
    var availableOptionsPackages = modelYear.optionsPackages.filter(function (optionsPackage) {
        return optionsPackage.visible;
    });

    if (availableOptionsPackages.size === 0) {
        return modelYear;
    }

    var optionsPackageSelectionCode = availableOptionsPackages.minBy(function (optionsPackage) {
        return optionsPackage.rank;
    }).selectionCode;
    var newModelYear = modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return selectModelYearItemFromCode(optionsPackage, optionsPackageSelectionCode);
    }));

    return resetSelectedExteriorColour(newModelYear);
}

function resetDrivePowerTrainWithOptionsPackage(modelYear, drivePowerTrain, drivePowerTrainSelectionCode, modelTrimTrimsBitField) {
    var drivePowerTrainTrimsBitField = UtilitiesService.mergeModelTrimsBitField(drivePowerTrain, modelTrimTrimsBitField, false);
    return selectModelYearItemFromCode(drivePowerTrain, drivePowerTrainSelectionCode).set('bestOptionsPackageCode', modelYear.getBestAvailableOptionsPackageFromTrimsBitField(drivePowerTrainTrimsBitField, drivePowerTrain.engine.selectionCode, drivePowerTrain.transmission.selectionCode));
}

function setSelectedDrivePowerTrain(modelYear, selectedDrivePowerTrain) {
    var selectedModelTrim = modelYear.getSelectedModelTrim();
    if (!selectedModelTrim) {
        return modelYear;
    }
    var modelTrimTrimsBitField = getMergedModelTrimTrimsBitField(selectedModelTrim);

    var drivePowerTrainSelectionCode = selectedDrivePowerTrain.selectionCode;
    var optionsPackageTrimsBitField = UtilitiesService.mergeModelTrimsBitField(modelTrimTrimsBitField, selectedDrivePowerTrain, false);

    var engineSelectionCode = selectedDrivePowerTrain.engine.selectionCode;
    var transmissionSelectionCode = selectedDrivePowerTrain.transmission.selectionCode;
    var newModelYear = modelYear.set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return selectModelYearItemFromCode(drivePowerTrain, drivePowerTrainSelectionCode);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return resetModelYearOptionPackagesVisibility(optionsPackage, optionsPackageTrimsBitField, engineSelectionCode, transmissionSelectionCode);
    }));

    return resetSelectedOptionsPackage(newModelYear);
}

function resetSelectedDrivePowerTrain(modelYear, modelTrimTrimsBitField) {
    var availableDrivePowerTrains = modelYear.drivePowerTrains.filter(function (drivePowerTrain) {
        return drivePowerTrain.visible;
    });

    if (availableDrivePowerTrains.size === 0) {
        return modelYear;
    }

    var drivePowerTrainSelectionCode = availableDrivePowerTrains.minBy(function (drivePowerTrain) {
        return drivePowerTrain.rank;
    }).selectionCode;

    var newModelYear = modelYear.set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return resetDrivePowerTrainWithOptionsPackage(modelYear, drivePowerTrain, drivePowerTrainSelectionCode, modelTrimTrimsBitField);
    }));

    var selectedDrivePowerTrain = newModelYear.getSelectedDrivePowerTrain();
    if (selectedDrivePowerTrain) {
        return setSelectedDrivePowerTrain(newModelYear, selectedDrivePowerTrain);
    }
    return resetSelectedOptionsPackage(newModelYear);
}

function setSelectedModelTrim(modelYear, selectedModelTrim) {
    var modelTrimSelectionCode = selectedModelTrim.selectionCode;
    var modelTrimTrimsBitField = getMergedModelTrimTrimsBitField(selectedModelTrim);

    var newModelYear = modelYear.set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return selectModelYearItemFromCode(modelTrim, modelTrimSelectionCode);
    })).set('drivePowerTrains', modelYear.drivePowerTrains.map(function (drivePowerTrain) {
        return resetModelYearItemVisibility(drivePowerTrain, modelTrimTrimsBitField);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return resetModelYearItemVisibility(optionsPackage, modelTrimTrimsBitField);
    }));

    return resetSelectedDrivePowerTrain(newModelYear, modelTrimTrimsBitField);
}

function resetSelectedModelTrim(modelYear) {
    var availableModelTrims = modelYear.modelTrims.filter(function (modelTrim) {
        return modelTrim.enabled;
    });

    if (availableModelTrims.size === 0) {
        return modelYear;
    }

    var selectedModelTrim = availableModelTrims.minBy(function (modelTrim) {
        return modelTrim.rank;
    });
    return setSelectedModelTrim(modelYear, selectedModelTrim);
}

function setSelectedBoxSize(modelYear, selectedBoxSize) {
    if (!selectedBoxSize.enabled) {
        return modelYear;
    }

    var boxSizeSelectionCode = selectedBoxSize.selectionCode;
    var boxSizeTrimsBitField = {
        trimsBitField: selectedBoxSize.trimsBitField,
        trimsBitFields: selectedBoxSize.trimsBitFields
    };

    var newModelYear = modelYear.set('boxSizes', modelYear.boxSizes.map(function (boxSize) {
        return selectModelYearItemFromCode(boxSize, boxSizeSelectionCode);
    })).set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return resetModelTrimsAvailabilityFromBoxSize(modelTrim, boxSizeTrimsBitField);
    }));

    return resetSelectedModelTrim(newModelYear);
}

function resetSelectedBoxSize(modelYear) {
    var availableBoxSizes = modelYear.boxSizes.filter(function (boxSize) {
        return boxSize.enabled;
    });

    if (availableBoxSizes.size === 0) {
        return modelYear;
    }

    var selectedBoxSize = (0, _lodash.min)(availableBoxSizes, function (boxSize) {
        return boxSize.rank;
    });
    return setSelectedBoxSize(modelYear, selectedBoxSize);
}

function setSelectedCabSize(modelYear, selectedCabSize) {
    var cabSizeSelectionCode = selectedCabSize.selectionCode;
    var cabSizeTrimsBitField = {
        trimsBitField: selectedCabSize.trimsBitField,
        trimsBitFields: selectedCabSize.trimsBitFields
    };

    var newModelYear = modelYear.set('cabSizes', modelYear.cabSizes.map(function (cabSize) {
        return selectModelYearItemFromCode(cabSize, cabSizeSelectionCode);
    })).set('boxSizes', modelYear.boxSizes.map(function (boxSize) {
        return resetModelYearItemAvailability(boxSize, cabSizeTrimsBitField);
    })).set('modelTrims', modelYear.modelTrims.map(function (modelTrim) {
        return modelTrim.set('cabSizeTrimsBitField', selectedCabSize.trimsBitField).set('cabSizeTrimsBitFields', selectedCabSize.trimsBitFields);
    }));

    return resetSelectedBoxSize(newModelYear, selectedCabSize);
}

function setSelectedOptionsPackage(modelYear, selectedOptionsPackage, forceSelect) {
    if (!forceSelect && (!modelYear.getSelectedModelTrim() || !modelYear.getSelectedDrivePowerTrain())) {
        return modelYear;
    }

    var optionsPackageSelectionCode = selectedOptionsPackage.selectionCode;
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return selectModelYearItemFromCode(optionsPackage, optionsPackageSelectionCode);
    }));
}

function setSelectedExteriorColour(modelYear, exteriorColour) {
    var exteriorColourSelectionCode = exteriorColour.colourCode;

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode);
    }));
}

function setSelectedInteriorColour(modelYear, interiorColour) {
    var interiorColourSelectionCode = (0, _lodash.isNull)(interiorColour) ? '' : interiorColour.colourCode;

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageInteriorColours(optionsPackage, interiorColourSelectionCode);
    }));
}

function resetYear(year, modelYear) {
    if (year.year === modelYear.year) {
        return year.set('selected', true).set('isSingleConfiguration', modelYear.isSingleConfiguration).set('hasOptions', modelYear.hasOptions).set('modelTrims', modelYear.modelTrims).set('drivePowerTrains', modelYear.drivePowerTrains).set('optionsPackages', modelYear.optionsPackages);
    }

    return year.set('selected', false);
}

function resetModelYears(modelYear, modelYears, selectedYear) {
    var lastYear = modelYears.last();
    var newModelYear = modelYear.set('year', selectedYear || lastYear.year).set('make', lastYear.make).set('model', lastYear.model).set('bodyStyleCode', lastYear.bodyStyleCode);

    return newModelYear.set('years', modelYears.map(function (year) {
        return resetYear(year, newModelYear);
    }));
}

function resetModelYear(modelYear, year) {
    if (year) {
        var newModelYear = modelYear.set('modelTrims', year.modelTrims).set('drivePowerTrains', year.drivePowerTrains).set('optionsPackages', year.optionsPackages);

        return setSelectedModelTrim(newModelYear, newModelYear.modelTrims.first());
    }

    return modelYear.set('modelTrims', (0, _immutable.List)([])).set('drivePowerTrains', (0, _immutable.List)([])).set('optionsPackages', (0, _immutable.List)([]));
}

function resetConfigurationToken(modelYear, configurationToken) {
    if (!(0, _lodash.isString)(configurationToken)) {
        return modelYear;
    }

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return optionsPackage.selected ? optionsPackage.setIn(['configuration', 'configurationToken'], configurationToken) : optionsPackage;
    }));
}

function resetOptionsAvailability(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    var availableOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.AVAILABLE) > 0 && option.supplier === dataTypes.SUPPLIER_OPTION;
    });
    var availableOptionsCodes = (0, _lodash.map)(availableOptions, function (option) {
        return option.code;
    });

    var selectedOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0 && (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) === 0;
    }).map(function (option) {
        return OptionService.resetOptionFromOptionData(option);
    });

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptionsAvailability(optionsPackage, availableOptionsCodes, selectedOptions);
    }));
}

function resetOptionsSelectionResolutions(modelYear, resolutions) {
    if (!(0, _lodash.isObjectLike)(resolutions)) {
        return modelYear;
    }

    var configuration = modelYear.getSelectedOptionsPackageConfiguration();
    var optionsSelectionResolutions = OptionsSelectionResolutionsService.resetResolutionOptionsFromResolutionsData(resolutions.resolutions, configuration, resolutions.optionSelectionCode);

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptionsSelectionResolutions(optionsPackage, optionsSelectionResolutions);
    }));
}

function setAvailableOptions(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    var configurationOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0;
    }).map(function (option) {
        return OptionService.resetOptionFromProtectionItem(option);
    });
    var configurationOptionsCodes = (0, _lodash.map)(configurationOptions, function (configurationOption) {
        return configurationOption.selectionCode;
    });

    var configurationAvailableOptions = (0, _lodash.filter)(options, function (option) {
        return (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_AVAILABLE) > 0;
    });

    var availableOptions = (0, _lodash.filter)(configurationAvailableOptions, function (option) {
        return (option.flag & (dataTypes.ITEM_FLAG.CONFIGURATION_AVAILABLE | dataTypes.ITEM_FLAG.AVAILABLE)) > 0 && (option.flag & dataTypes.ITEM_FLAG.IGNORE_ITEM) === 0 && (option.supplier === dataTypes.SUPPLIER_OPTION || option.supplier === dataTypes.DEALER_OPTION) && option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID <= dataTypes.DATA_TYPES.FEATURE.TYPES.SAFETY || option.typeID >= dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR) && (!(0, _lodash.includes)(configurationOptionsCodes, option.code + '>' + option.supplier) || (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) > 0);
    }).map(function (option) {
        return OptionService.resetOptionFromProtectionItem(option);
    });

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageAvailableOptions(optionsPackage, availableOptions, configurationOptions);
    }));
}

function setSelectedOptions(modelYear, options) {
    if (!(0, _lodash.isArrayLikeObject)(options)) {
        return modelYear;
    }

    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageOptions(optionsPackage, options);
    }));
}

function recalculatePayments(modelYear, paymentCalculationParameters) {
    return paymentCalculationParameters ? modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.recalculateYearPayments(year, paymentCalculationParameters);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters);
    })) : modelYear;
}

function recalculatePurchaseAmounts(modelYear, paymentCalculationParameters) {
    return paymentCalculationParameters ? modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.recalculateYearPayments(year, paymentCalculationParameters);
    })).set('optionsPackages', modelYear.get('optionsPackages').map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePurchaseAmounts(optionsPackage, paymentCalculationParameters);
    })) : modelYear;
}

function resetPaymentsAndPurchaseAmounts(modelYear, purchaseMethods) {
    var paymentCalculationParameters = purchaseMethods ? purchaseMethods.getPaymentCalculationParameters() : '';
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function selectPurchaseMethod(modelYear, purchaseMethod) {
    return modelYear.set('years', modelYear.years.map(function (year) {
        return YearService.resetYearPurchaseMethod(year, purchaseMethod);
    })).set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackagePurchaseMethod(optionsPackage, purchaseMethod);
    }));
}

function selectPaymentFrequency(modelYear, paymentFrequency) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithPaymentFrequency(paymentFrequency);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function selectTerm(modelYear, term) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTerm(term);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function selectKMPlan(modelYear, kmPlan) {
    var purchaseMethods = modelYear.getSelectedOptionsPackagePurchaseMethods();
    if (!purchaseMethods) {
        return modelYear;
    }

    var paymentCalculationParameters = purchaseMethods.getPaymentCalculationParameters();
    var newOptionsPackages = modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.selectOptionsPackageKMPlan(optionsPackage, kmPlan);
    });

    return modelYear.set('optionsPackages', newOptionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters);
    }));
}

function setCashDown(modelYear, cashDown) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithCashDown(cashDown);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setTradeIn(modelYear, tradeIn) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTradeIn(tradeIn);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setLien(modelYear, lien) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithLien(lien);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setExteriorColourAmounts(modelYear, exteriorColourAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setInteriorColourAmounts(modelYear, interiorColourAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    return recalculatePurchaseAmounts(modelYear, paymentCalculationParameters);
}

function setOptionsAmounts(modelYear, optionsAmounts) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithOptions(optionsAmounts);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function setTaxesIncluded(modelYear, taxesIncluded) {
    var paymentCalculationParameters = modelYear.getPaymentCalculationWithTaxesIncluded(taxesIncluded);
    return recalculatePayments(modelYear, paymentCalculationParameters);
}

function resetModelYearFromQuote(modelYear, quote) {
    if ((0, _lodash.isEmpty)(quote) || !(0, _lodash.isObjectLike)(quote)) {
        return modelYear;
    }

    var newModelYear = modelYear;
    var cabSizeCode = quote.vehicle.cabSizeCode;
    if (cabSizeCode && modelYear.cabSizes && modelYear.cabSizes.length) {
        var selectedCabSize = (0, _lodash.find)(modelYear.cabSizes, function (cabSize) {
            return cabSize.code === cabSizeCode;
        });
        if (!selectedCabSize) {
            return newModelYear;
        }
        newModelYear = setSelectedCabSize(newModelYear, selectedCabSize);

        var boxSizeCode = quote.vehicle.boxSizeCode;
        var boxSizeDesc = (0, _lodash.isEmpty)(quote.vehicle.boxSize) ? '' : quote.vehicle.boxSize[0];
        if (boxSizeCode && modelYear.boxSizes && modelYear.boxSizes.length) {
            var selectedBoxSize = (0, _lodash.find)(modelYear.boxSizes, function (boxSize) {
                return boxSize.code === boxSizeCode && boxSize.selectionCode === boxSizeCode + '-' + boxSizeDesc;
            });

            if (!selectedBoxSize) {
                return newModelYear;
            }
            newModelYear = setSelectedBoxSize(newModelYear, selectedBoxSize.set('enabled', true));
        }
    }
    var configurationId = quote.vehicle.modelTrimCode + '|' + quote.vehicle.configurationId;

    var selectedModelTrim = (0, _lodash.find)(newModelYear.modelTrims.toArray(), function (modelTrim) {
        return !(0, _lodash.isUndefined)(modelTrim.configurationIds[configurationId]);
    });

    if (!selectedModelTrim) {
        return newModelYear;
    }
    newModelYear = setSelectedModelTrim(newModelYear, selectedModelTrim);

    var selectedDrivePowerTrain = (0, _lodash.find)(newModelYear.drivePowerTrains.toArray(), function (drivePowerTrain) {
        return !(0, _lodash.isUndefined)(drivePowerTrain.configurationIds[configurationId]);
    });

    if (!selectedDrivePowerTrain) {
        return newModelYear;
    }
    newModelYear = setSelectedDrivePowerTrain(newModelYear, selectedDrivePowerTrain);

    var selectedOptionsPackage = (0, _lodash.find)(newModelYear.optionsPackages.toArray(), function (optionsPackage) {
        return optionsPackage.configuration.selectionCode === configurationId;
    });

    if (!selectedOptionsPackage) {
        return newModelYear;
    }
    newModelYear = setSelectedOptionsPackage(newModelYear, selectedOptionsPackage, true);

    var selectedExteriorColourCode = quote.vehicle.purchaseMethods.getSelectedExteriorColourCode();
    if (selectedExteriorColourCode) {
        var selectedExteriorColour = (0, _lodash.find)(selectedOptionsPackage.configuration.exteriorColours.toArray(), function (colour) {
            return colour.colourCode === selectedExteriorColourCode;
        });
        if (selectedExteriorColour) {
            newModelYear = setSelectedExteriorColour(newModelYear, selectedExteriorColour);
        }
    }

    var selectedInteriorColourCode = quote.vehicle.purchaseMethods.getSelectedInteriorColourCode();
    if (selectedInteriorColourCode) {
        var selectedInteriorColour = (0, _lodash.find)(selectedOptionsPackage.configuration.interiorColours.toArray(), function (colour) {
            return colour.colourCode === selectedInteriorColourCode;
        });
        if (selectedInteriorColour) {
            newModelYear = setSelectedInteriorColour(newModelYear, selectedInteriorColour);
        }
    }

    var paymentCalculationParameters = quote.vehicle.purchaseMethods.getPaymentCalculationParameters();
    newModelYear = selectPurchaseMethod(newModelYear, quote.vehicle.purchaseMethods.getSelectedPurchaseMethod());
    newModelYear = recalculatePayments(newModelYear, paymentCalculationParameters);
    var selectedFinance = quote.vehicle.purchaseMethods.getSelectedFinance();
    var annualKMAllowed = selectedFinance ? selectedFinance.annualKMAllowed : 0;
    if (annualKMAllowed > 0) {
        return selectKMPlan(newModelYear, annualKMAllowed);
    }

    newModelYear = resetConfigurationToken(newModelYear, quote.vehicle.configurationToken);
    return newModelYear;
}

function resetModelYearOptionsFromQuote(modelYear, quote) {
    if ((0, _lodash.isEmpty)(quote) || !(0, _lodash.isObjectLike)(quote)) {
        return modelYear;
    }

    var selectedOptionsPackage = modelYear.getSelectedOptionsPackage();
    if (!selectedOptionsPackage) {
        return modelYear;
    }

    var quoteOptions = [].concat(quote.vehicle.purchaseMethods.getSelectedOptionsAndColours(), quote.vehicle.purchaseMethods.getSelectedDealerFees());
    var quoteSelectedOptions = (0, _lodash.filter)(quoteOptions, function (option) {
        return option.selected;
    });
    var dealerSelectedOptions = (0, _lodash.filter)(quoteSelectedOptions, function (option) {
        return option.isDealerInventoryOption() || option.isDealerFee();
    });
    var dealerSelectedDiscounts = quote.vehicle.purchaseMethods.getSelectedDealerDiscounts(true);

    if (dealerSelectedOptions.length || dealerSelectedDiscounts.length) {
        var configurationOptions = (0, _lodash.map)(selectedOptionsPackage.configuration.options, function (option) {
            switch (option.id) {
                case _modelTrimItemCategories.DEALER_INVENTORY:
                    return option.set('itemsPackages', (0, _lodash.unionBy)(option.itemsPackages, dealerSelectedOptions, 'selectionCode'));
                case _modelTrimItemCategories.DEALER_DISCOUNT:
                    return option.set('itemsPackages', (0, _lodash.unionBy)(option.itemsPackages, dealerSelectedDiscounts, 'selectionCode'));
                default:
                    return option;
            }
        });

        selectedOptionsPackage = selectedOptionsPackage.setIn(['configuration', 'options'], configurationOptions);
    }
    var resetQuoteSelectedOptions = (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromOptionsValidation)(selectedOptionsPackage.configuration.options, quoteSelectedOptions);

    var newModelYear = setSelectedOptions(modelYear, resetQuoteSelectedOptions);
    var paymentCalculationParameters = quote.vehicle.purchaseMethods.getPaymentCalculationParameters();
    newModelYear = selectPurchaseMethod(newModelYear, quote.vehicle.purchaseMethods.getSelectedPurchaseMethod());
    return recalculatePayments(newModelYear, paymentCalculationParameters);
}

function setSelectedModelYear(modelYear, selectedYear) {
    var newModelYear = modelYear.set('year', selectedYear.year).set('modelTrims', selectedYear.modelTrims).set('drivePowerTrains', selectedYear.drivePowerTrains).set('optionsPackages', selectedYear.optionsPackages).set('years', modelYear.years.map(function (year) {
        return year.set('selected', year.year === selectedYear.year);
    }));

    if (!selectedYear.purchaseMethods.getSelectedPurchaseMethodIsValid()) {
        return selectPurchaseMethod(newModelYear, PurchaseMethodsConstants.CASH_PURCHASE);
    }
    return newModelYear;
}

function resetEmployeeRebateAdjustment(modelYear, rebateAdjustment) {
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackageEmployeeRebateAdjustment(optionsPackage, rebateAdjustment);
    }));
}

function resetPercentageRebateAdjustment(modelYear, rebateAdjustment) {
    return modelYear.set('optionsPackages', modelYear.optionsPackages.map(function (optionsPackage) {
        return OptionsPackageService.resetOptionsPackagePercentageRebateAdjustment(optionsPackage, rebateAdjustment);
    }));
}

exports.default = {
    resetModelYearFromOriginData: resetModelYearFromOriginData,
    setSelectedDrivePowerTrain: setSelectedDrivePowerTrain,
    setSelectedCabSize: setSelectedCabSize,
    setSelectedBoxSize: setSelectedBoxSize,
    setSelectedModelTrim: setSelectedModelTrim,
    setSelectedOptionsPackage: setSelectedOptionsPackage,
    setSelectedExteriorColour: setSelectedExteriorColour,
    setSelectedInteriorColour: setSelectedInteriorColour,
    setSelectedModelYear: setSelectedModelYear,
    resetModelYears: resetModelYears,
    resetModelYear: resetModelYear,
    resetConfigurationToken: resetConfigurationToken,
    resetOptionsAvailability: resetOptionsAvailability,
    resetOptionsSelectionResolutions: resetOptionsSelectionResolutions,
    setAvailableOptions: setAvailableOptions,
    setSelectedOptions: setSelectedOptions,
    resetPaymentsAndPurchaseAmounts: resetPaymentsAndPurchaseAmounts,
    selectPurchaseMethod: selectPurchaseMethod,
    selectPaymentFrequency: selectPaymentFrequency,
    selectTerm: selectTerm,
    selectKMPlan: selectKMPlan,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setOptionsAmounts: setOptionsAmounts,
    setTaxesIncluded: setTaxesIncluded,
    resetModelYearFromQuote: resetModelYearFromQuote,
    resetModelYearOptionsFromQuote: resetModelYearOptionsFromQuote,
    resetEmployeeRebateAdjustment: resetEmployeeRebateAdjustment,
    resetPercentageRebateAdjustment: resetPercentageRebateAdjustment
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetOptionFromOptionData = resetOptionFromOptionData;
exports.resetOptionFromQuoteItem = resetOptionFromQuoteItem;
exports.resetOptionFromProtectionItem = resetOptionFromProtectionItem;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _OptionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionModel.js");

var _OptionModel2 = _interopRequireDefault(_OptionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 no-bitwise: 0 */

function convertOptionFlags(option) {
    return {
        enabled: (option.flag & dataTypes.ITEM_FLAG.AVAILABLE) > 0,
        selected: (option.flag & dataTypes.ITEM_FLAG.SELECTED) > 0,
        isConfigurationOption: (option.flag & dataTypes.ITEM_FLAG.CONFIGURATION_SELECTED) > 0,
        isTaxable: (option.flag & (dataTypes.ITEM_FLAG.NON_TAXABLE_FEDERAL | dataTypes.ITEM_FLAG.NON_TAXABLE_PROVINCIAL)) === 0,
        dueAtDelivery: option.priceInclusion ? option.priceInclusion.epi === 0 : false
    };
}

function resetOptionFromOptionData(optionData) {
    if ((0, _lodash.isEmpty)(optionData) || !(0, _lodash.isObjectLike)(optionData)) {
        return new _OptionModel2.default();
    }

    var _convertOptionFlags = convertOptionFlags(optionData),
        enabled = _convertOptionFlags.enabled,
        selected = _convertOptionFlags.selected,
        isConfigurationOption = _convertOptionFlags.isConfigurationOption,
        isTaxable = _convertOptionFlags.isTaxable,
        dueAtDelivery = _convertOptionFlags.dueAtDelivery;

    return new _OptionModel2.default({
        selectionCode: optionData.code + '>' + optionData.supplier,
        enabled: enabled,
        visible: true,
        selected: selected,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        userSelected: false,
        code: optionData.code,
        parentCode: optionData.parentCode,
        description: optionData.description,
        dataType: optionData.dataType,
        typeID: optionData.typeID,
        supplier: optionData.supplier,
        flag: optionData.flag,
        residualizingAmount: optionData.residualizingAmount,
        retail: optionData.retail,
        isTaxable: isTaxable
    });
}

function resetOptionFromQuoteItem(quoteItem, isIncludedInPriceOrPayment) {
    if ((0, _lodash.isEmpty)(quoteItem) || !(0, _lodash.isObjectLike)(quoteItem)) {
        return new _OptionModel2.default();
    }

    var _convertOptionFlags2 = convertOptionFlags(quoteItem),
        enabled = _convertOptionFlags2.enabled,
        selected = _convertOptionFlags2.selected,
        isConfigurationOption = _convertOptionFlags2.isConfigurationOption,
        isTaxable = _convertOptionFlags2.isTaxable,
        dueAtDelivery = _convertOptionFlags2.dueAtDelivery;

    var hasDealerCashOnlyDiscount = (0, _lodash.includes)(quoteItem.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);

    return new _OptionModel2.default({
        selectionCode: quoteItem.code + '>' + quoteItem.supplier,
        enabled: enabled,
        visible: true,
        selected: selected || hasDealerCashOnlyDiscount,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        userSelected: false,
        code: quoteItem.code,
        description: (0, _lodash.isEmpty)(quoteItem.description) ? '' : quoteItem.description.descriptions[0],
        dataType: quoteItem.dataType,
        typeID: quoteItem.typeID,
        supplier: quoteItem.supplier,
        supplierCodes: quoteItem.supplierCodes,
        flag: quoteItem.flag,
        residualizingAmount: quoteItem.amounts.residualizingAmount,
        retail: quoteItem.amounts.retail,
        isTaxable: isTaxable,
        isIncludedInPriceOrPayment: isIncludedInPriceOrPayment || false
    });
}

function resetOptionFromProtectionItem(protectionItem) {
    if ((0, _lodash.isEmpty)(protectionItem) || !(0, _lodash.isObjectLike)(protectionItem)) {
        return new _OptionModel2.default();
    }

    var dataType = protectionItem.dataType,
        typeID = protectionItem.typeID,
        categoryID = protectionItem.categoryID,
        flag = protectionItem.flag,
        code = protectionItem.code,
        parentCode = protectionItem.parentCode,
        keyOrder = protectionItem.keyOrder,
        includedCodes = protectionItem.includedCodes,
        supplier = protectionItem.supplier,
        supplierCodes = protectionItem.supplierCodes,
        description = protectionItem.description,
        amounts = protectionItem.amounts,
        imageUrl = protectionItem.imageUrl,
        webUrl = protectionItem.webUrl,
        htmlTag = protectionItem.htmlTag,
        isPopular = protectionItem.isPopular,
        isDealerInstalled = protectionItem.isDealerInstalled,
        identificationType = protectionItem.identificationType,
        parentIdentificationType = protectionItem.parentIdentificationType,
        protectionCoverage = protectionItem.protectionCoverage;

    var _convertOptionFlags3 = convertOptionFlags(protectionItem),
        enabled = _convertOptionFlags3.enabled,
        selected = _convertOptionFlags3.selected,
        isConfigurationOption = _convertOptionFlags3.isConfigurationOption,
        isTaxable = _convertOptionFlags3.isTaxable,
        dueAtDelivery = _convertOptionFlags3.dueAtDelivery;

    var optionDesc = !(0, _lodash.isEmpty)(description) && !(0, _lodash.isEmpty)(description.description) ? description.description : description;

    return new _OptionModel2.default({
        selectionCode: code + '>' + supplier,
        enabled: enabled,
        selected: selected,
        isConfigurationOption: isConfigurationOption,
        dueAtDelivery: dueAtDelivery,
        code: code,
        parentCode: !(0, _lodash.isEmpty)(parentCode) ? parentCode : '',
        keyOrder: keyOrder,
        includedCodes: includedCodes,
        label: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.labels[0],
        description: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.descriptions[0],
        note: (0, _lodash.isEmpty)(optionDesc) ? '' : optionDesc.notes[0],
        dataType: dataType,
        typeID: typeID,
        typeDescription: !(0, _lodash.isEmpty)(identificationType) ? identificationType.description.descriptions[0] : '',
        typeNote: !(0, _lodash.isEmpty)(identificationType) ? identificationType.description.notes[0] : '',
        parentTypeID: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.typeID : null,
        parentTypeDescription: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.description.descriptions[0] : '',
        parentTypeNote: !(0, _lodash.isEmpty)(parentIdentificationType) ? parentIdentificationType.description.notes[0] : '',
        categoryID: categoryID,
        supplier: supplier,
        supplierCodes: supplierCodes,
        flag: flag,
        residualizingAmount: amounts.residualizingAmount,
        retail: amounts.retail,
        isTaxable: isTaxable,
        imageUrl: (0, _lodash.isEmpty)(imageUrl) ? '' : imageUrl[0],
        webUrl: (0, _lodash.isEmpty)(webUrl) ? '' : webUrl[0],
        htmlBlock: (0, _lodash.isEmpty)(htmlTag) ? '' : htmlTag[0],
        mostPopular: isPopular,
        isGroup: !(0, _lodash.isEmpty)(identificationType) ? identificationType.isGroup : false,
        isInstalledAtDealership: isDealerInstalled,
        protectionCoverage: !(0, _lodash.isEmpty)(protectionCoverage) ? protectionCoverage : null
    });
}

exports.default = {
    resetOptionFromOptionData: resetOptionFromOptionData,
    resetOptionFromQuoteItem: resetOptionFromQuoteItem,
    resetOptionFromProtectionItem: resetOptionFromProtectionItem
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/OptionsPackageService/OptionsPackageService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetOptionsPackageFromOriginData = resetOptionsPackageFromOriginData;
exports.resetOptionsPackageExteriorColours = resetOptionsPackageExteriorColours;
exports.resetOptionsPackageInteriorColours = resetOptionsPackageInteriorColours;
exports.resetOptionsPackageOptionsAvailability = resetOptionsPackageOptionsAvailability;
exports.resetOptionsPackageOptionsSelectionResolutions = resetOptionsPackageOptionsSelectionResolutions;
exports.resetOptionsPackageAvailableOptions = resetOptionsPackageAvailableOptions;
exports.resetOptionsPackageOptions = resetOptionsPackageOptions;
exports.resetOptionsPackagePurchaseMethod = resetOptionsPackagePurchaseMethod;
exports.recalculateOptionsPackagePayments = recalculateOptionsPackagePayments;
exports.recalculateOptionsPackagePurchaseAmounts = recalculateOptionsPackagePurchaseAmounts;
exports.selectOptionsPackageKMPlan = selectOptionsPackageKMPlan;
exports.resetOptionsPackageEmployeeRebateAdjustment = resetOptionsPackageEmployeeRebateAdjustment;
exports.resetOptionsPackagePercentageRebateAdjustment = resetOptionsPackagePercentageRebateAdjustment;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _OptionsPackageModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionsPackageModel.js");

var _OptionsPackageModel2 = _interopRequireDefault(_OptionsPackageModel);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _QuoteItemCategoryService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FEATURE = _dataTypes.DATA_TYPES.FEATURE;


function resetOptionsPackageFromModelData(modelData, disclaimers) {
    var selectionCode = '' + modelData.configuration.cabSizeSelectionCode + (modelData.configuration.packageSelectionCode + '|' + modelData.configuration.id);

    var optionsPackage = new _OptionsPackageModel2.default({
        trimsBitField: modelData.configuration.trimsBitField,
        trimsBitFields: modelData.configuration.trimsBitFields,
        selectionCode: selectionCode,
        enabled: true,
        visible: true,
        selected: false,
        userSelected: false,
        code: modelData.configuration.packageCode,
        description: modelData.configuration.package.description,
        rank: modelData.configuration.rank,
        configuration: modelData.configuration
    });

    return optionsPackage.setIn(['configuration', 'purchaseMethods', 'disclaimers'], disclaimers);
}

function resetOptionsPackageFromOriginData(dataOrigin, originOptionsPackageData, disclaimers) {
    if ((0, _lodash.isEmpty)(originOptionsPackageData) || !(0, _lodash.isObjectLike)(originOptionsPackageData)) {
        return new _OptionsPackageModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return new _OptionsPackageModel2.default();

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetOptionsPackageFromModelData(originOptionsPackageData, disclaimers);

        default:
            return new _OptionsPackageModel2.default();
    }
}

function resetOptionsPackageExteriorColours(optionsPackage, exteriorColourSelectionCode) {
    var configuration = optionsPackage.configuration;
    var exteriorColourCategory = (0, _lodash.find)(configuration.options, function (optionCategory) {
        return optionCategory.id === _modelTrimItemCategories.EXTERIOR_COLOUR;
    });
    var selectedOption = exteriorColourCategory ? (0, _lodash.find)(exteriorColourCategory.itemsPackages, function (itemsPackage) {
        return itemsPackage.selectionCode === exteriorColourSelectionCode + '>' + _dataTypes.SUPPLIER_OPTION;
    }) : null;

    var exteriorColours = configuration.exteriorColours.map(function (colour) {
        return colour.set('selected', colour.colourCode === exteriorColourSelectionCode);
    });

    var options = configuration.options;
    if (!(0, _lodash.isNil)(selectedOption)) {
        options = (0, _QuoteItemCategoryService.selectQuoteItemPackage)(configuration.options, exteriorColourCategory, selectedOption);
    }

    return optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColours).setIn(['configuration', 'options'], options);
}

function resetOptionsPackageInteriorColours(optionsPackage, interiorColourSelectionCode) {
    var configuration = optionsPackage.configuration;
    var interiorColourCategory = (0, _lodash.find)(configuration.options, function (optionCategory) {
        return optionCategory.id === _modelTrimItemCategories.INTERIOR_TRIM;
    });
    var selectedOption = interiorColourCategory ? (0, _lodash.find)(interiorColourCategory.itemsPackages, function (itemsPackage) {
        return itemsPackage.selectionCode === interiorColourSelectionCode + '>' + _dataTypes.SUPPLIER_OPTION;
    }) : null;

    var interiorColours = configuration.interiorColours.map(function (colour) {
        return colour.set('selected', colour.colourCode === interiorColourSelectionCode);
    });

    var options = configuration.options;
    if (!(0, _lodash.isNil)(selectedOption)) {
        options = (0, _QuoteItemCategoryService.selectQuoteItemPackage)(configuration.options, interiorColourCategory, selectedOption);
    }

    return optionsPackage.setIn(['configuration', 'interiorColours'], interiorColours).setIn(['configuration', 'options'], options);
}

function resetOptionsPackageOptionsAvailability(optionsPackage, availableOptionsCodes, selectedOptions) {
    var validSelectedOptions = (0, _lodash.isEmpty)(selectedOptions) || (0, _lodash.isArrayLikeObject)(selectedOptions);
    if (!(0, _lodash.isArray)(availableOptionsCodes) || !validSelectedOptions) {
        return optionsPackage;
    }

    var selectedExteriorColour = (0, _lodash.find)(selectedOptions, function (selectedOption) {
        return selectedOption.typeID === FEATURE.TYPES.EXTERIOR_COLOUR;
    });
    var selectedExteriorColourCode = selectedExteriorColour ? selectedExteriorColour.code : '';
    var exteriorColourOptionsPackage = optionsPackage.configuration.exteriorColours.map(function (colour) {
        return colour.set('enabled', (0, _lodash.includes)(availableOptionsCodes, colour.colourCode)).set('selected', colour.colourCode === selectedExteriorColourCode);
    });

    var selectedInteriorColour = (0, _lodash.find)(selectedOptions, function (selectedOption) {
        return selectedOption.typeID === FEATURE.TYPES.INTERIOR_TRIM;
    });
    var selectedInteriorColourCode = selectedInteriorColour ? selectedInteriorColour.code : '';
    var interiorColourOptionsPackage = optionsPackage.configuration.interiorColours.map(function (colour) {
        return colour.set('enabled', (0, _lodash.includes)(availableOptionsCodes, colour.colourCode)).set('selected', colour.colourCode === selectedInteriorColourCode);
    });

    var options = (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromOptionsValidation)(optionsPackage.configuration.options, selectedOptions);

    if (optionsPackage.selected) {
        var newOptionsPackage = optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColourOptionsPackage).setIn(['configuration', 'interiorColours'], interiorColourOptionsPackage).setIn(['configuration', 'options'], options);

        var configPurchaseMethods = PurchaseMethodsService.resetSelectedOptions(newOptionsPackage.configuration.purchaseMethods, newOptionsPackage.configuration.getSelectedOptions(), newOptionsPackage.configuration.configurationOptions);

        configPurchaseMethods = configPurchaseMethods.set('optionsSelectionResolutions', null);
        return newOptionsPackage.setIn(['configuration', 'purchaseMethods'], configPurchaseMethods);
    }
    return optionsPackage.setIn(['configuration', 'exteriorColours'], exteriorColourOptionsPackage).setIn(['configuration', 'interiorColours'], interiorColourOptionsPackage).setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
}

function resetOptionsPackageOptionsSelectionResolutions(optionsPackage, resolutions) {
    if (!optionsPackage.selected || !(0, _lodash.isObjectLike)(resolutions) || (0, _lodash.isEmpty)(resolutions.resolutions)) {
        return optionsPackage.setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
    }

    return optionsPackage.setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], resolutions);
}

function resetOptionsPackageAvailableOptions(optionsPackage, availableOptions, configurationOptions) {
    if (optionsPackage.selected) {
        return optionsPackage.setIn(['configuration', 'options'], (0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromModelTrimOptions)(availableOptions)).setIn(['configuration', 'configurationOptions'], configurationOptions).setIn(['configuration', 'purchaseMethods', 'availableOptions'], availableOptions).setIn(['configuration', 'purchaseMethods', 'configurationOptions'], configurationOptions).setIn(['configuration', 'purchaseMethods', 'optionsSelectionResolutions'], null);
    }
    return optionsPackage;
}

function resetOptionsPackageOptions(optionsPackage, options) {
    if (optionsPackage.selected) {
        var newOptionsPackage = optionsPackage.setIn(['configuration', 'options'], options);
        var selectedOptions = newOptionsPackage.configuration.getSelectedOptions();
        var purchaseMethods = PurchaseMethodsService.resetSelectedOptions(optionsPackage.configuration.purchaseMethods, selectedOptions, optionsPackage.configuration.configurationOptions);

        return newOptionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}

function resetOptionsPackagePurchaseMethod(optionsPackage, purchaseMethod) {
    return optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.selectPurchaseMethod(optionsPackage.configuration.purchaseMethods, purchaseMethod));
}

function recalculateOptionsPackagePayments(optionsPackage, paymentCalculationParameters) {
    return optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.recalculatePayments(optionsPackage.configuration.purchaseMethods, paymentCalculationParameters));
}

function recalculateOptionsPackagePurchaseAmounts(optionsPackage, paymentCalculationParameters) {
    var newOptionsPackage = optionsPackage.setIn(['configuration', 'purchaseMethods'], PurchaseMethodsService.recalculatePurchaseAmounts(optionsPackage.configuration.purchaseMethods, paymentCalculationParameters));

    return recalculateOptionsPackagePayments(newOptionsPackage, paymentCalculationParameters);
}

function selectOptionsPackageKMPlan(optionsPackage, kmPlan) {
    var purchaseMethods = optionsPackage.configuration.purchaseMethods;
    var selectedFinance = purchaseMethods.getSelectedFinance();

    if (!selectedFinance) {
        return optionsPackage;
    }

    var newKMPlan = selectedFinance.getKMPlan(kmPlan);
    if (!newKMPlan) {
        return optionsPackage;
    }

    var newPurchaseMethods = purchaseMethods.lease.selected ? purchaseMethods.setIn(['lease', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['lease', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['lease', 'terms'], newKMPlan.terms) : purchaseMethods.setIn(['finance', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['finance', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['finance', 'terms'], newKMPlan.terms);

    return optionsPackage.setIn(['configuration', 'purchaseMethods'], newPurchaseMethods);
}

function resetOptionsPackageEmployeeRebateAdjustment(optionsPackage, rebateAdjustment) {
    if (optionsPackage.selected) {
        var purchaseMethods = PurchaseMethodsService.resetOptionsAmounts(optionsPackage.configuration.purchaseMethods.set('employeeRebateAdjustment', (0, _lodash.isFinite)(rebateAdjustment) ? rebateAdjustment : 0));

        return optionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}

function resetOptionsPackagePercentageRebateAdjustment(optionsPackage, rebateAdjustment) {
    if (optionsPackage.selected) {
        var purchaseMethods = PurchaseMethodsService.resetOptionsAmounts(optionsPackage.configuration.purchaseMethods.setIn(['cashPurchase', 'optionsAdjustmentDiscounts'], (0, _lodash.isFinite)(rebateAdjustment) ? rebateAdjustment : 0));

        return optionsPackage.setIn(['configuration', 'purchaseMethods'], purchaseMethods);
    }
    return optionsPackage;
}
exports.default = {
    resetOptionsPackageFromOriginData: resetOptionsPackageFromOriginData,
    resetOptionsPackageExteriorColours: resetOptionsPackageExteriorColours,
    resetOptionsPackageInteriorColours: resetOptionsPackageInteriorColours,
    resetOptionsPackageOptionsAvailability: resetOptionsPackageOptionsAvailability,
    resetOptionsPackageOptionsSelectionResolutions: resetOptionsPackageOptionsSelectionResolutions,
    resetOptionsPackageAvailableOptions: resetOptionsPackageAvailableOptions,
    resetOptionsPackageOptions: resetOptionsPackageOptions,
    resetOptionsPackagePurchaseMethod: resetOptionsPackagePurchaseMethod,
    recalculateOptionsPackagePayments: recalculateOptionsPackagePayments,
    recalculateOptionsPackagePurchaseAmounts: recalculateOptionsPackagePurchaseAmounts,
    selectOptionsPackageKMPlan: selectOptionsPackageKMPlan,
    resetOptionsPackageEmployeeRebateAdjustment: resetOptionsPackageEmployeeRebateAdjustment,
    resetOptionsPackagePercentageRebateAdjustment: resetOptionsPackagePercentageRebateAdjustment
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetResolutionOptionsFromResolutionData = resetResolutionOptionsFromResolutionData;

var _lodash = __webpack_require__("lodash");

var _OptionsSelectionResolutionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionsSelectionResolutionModel.js");

var _OptionsSelectionResolutionModel2 = _interopRequireDefault(_OptionsSelectionResolutionModel);

var _OptionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js");

var OptionService = _interopRequireWildcard(_OptionService);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-bitwise: 0 */

var FEATURE = _dataTypes.DATA_TYPES.FEATURE;
function resetResolutionOptionsFromResolutionData(resolution, configurationOptionsSelectionCodes, originalOptionsSelectionCodes, triggerSelectionCode) {
    var optionsSelectionResolution = new _OptionsSelectionResolutionModel2.default();
    if ((0, _lodash.isEmpty)(resolution) || !(0, _lodash.isArrayLikeObject)(resolution.items) || !(0, _lodash.isArrayLike)(configurationOptionsSelectionCodes) || !(0, _lodash.isArrayLike)(originalOptionsSelectionCodes)) {
        return optionsSelectionResolution;
    }

    var options = (0, _lodash.map)(resolution.items, function (option) {
        return OptionService.resetOptionFromOptionData(option);
    });

    var nonDefaultOptions = (0, _lodash.filter)(options, function (option) {
        return !(0, _lodash.includes)(configurationOptionsSelectionCodes, option.selectionCode);
    });

    var newlyAddedOptions = (0, _lodash.filter)(nonDefaultOptions, function (option) {
        return option.selected && !(0, _lodash.includes)(originalOptionsSelectionCodes, option.selectionCode);
    });
    var newlyAddedOptionsSelectionCodes = (0, _lodash.map)(newlyAddedOptions, function (newlyAddedOption) {
        return newlyAddedOption.selectionCode;
    });

    var newlyRemovedOptions = (0, _lodash.filter)(nonDefaultOptions, function (option) {
        return !option.selected && (0, _lodash.includes)(originalOptionsSelectionCodes, option.selectionCode);
    });
    var newlyRemovedOptionsSelectionCodes = (0, _lodash.map)(newlyRemovedOptions, function (newlyRemovedOption) {
        return newlyRemovedOption.selectionCode;
    });

    var resolvedOptionsSelectionCodes = (0, _lodash.map)(resolution.resolvedItems, function (option) {
        return option.item;
    });
    var actionOptions = (0, _lodash.filter)(nonDefaultOptions, function (nonDefaultOption) {
        return (0, _lodash.includes)(resolvedOptionsSelectionCodes, nonDefaultOption.selectionCode);
    });

    var addedCodes = (0, _lodash.join)((0, _lodash.map)(newlyAddedOptions, function (newlyAddedOption) {
        return newlyAddedOption.selectionCode;
    }), '|');
    var removedCodes = (0, _lodash.join)((0, _lodash.map)(newlyRemovedOptions, function (newlyRemovedOption) {
        return newlyRemovedOption.selectionCode;
    }), '|');

    var isCancel = newlyAddedOptionsSelectionCodes.length === 1 && (0, _lodash.includes)(newlyAddedOptionsSelectionCodes, triggerSelectionCode) || newlyRemovedOptionsSelectionCodes.length === 1 && (0, _lodash.includes)(newlyRemovedOptionsSelectionCodes, triggerSelectionCode);

    var id = '';
    if (addedCodes || removedCodes) {
        id = 'A' + addedCodes + '-R' + removedCodes;
    }

    var exteriorColourOptions = (0, _lodash.filter)(newlyRemovedOptions, function (option) {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR;
    });
    var availableExteriorColours = [];
    if (!(0, _lodash.isEmpty)(exteriorColourOptions)) {
        availableExteriorColours = (0, _lodash.filter)(nonDefaultOptions, function (option) {
            return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.EXTERIOR_COLOUR && (option.flag & _dataTypes.ITEM_FLAG.AVAILABLE) === _dataTypes.ITEM_FLAG.AVAILABLE;
        });
    }

    var interiorColourOptions = (0, _lodash.filter)(newlyRemovedOptions, function (option) {
        return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.INTERIOR_TRIM;
    });
    var availableInteriorColours = [];
    if (!(0, _lodash.isEmpty)(interiorColourOptions)) {
        availableInteriorColours = (0, _lodash.filter)(nonDefaultOptions, function (option) {
            return option.dataType === FEATURE.DATA_TYPE_ID && option.typeID === FEATURE.TYPES.INTERIOR_TRIM && (option.flag & _dataTypes.ITEM_FLAG.AVAILABLE) === _dataTypes.ITEM_FLAG.AVAILABLE;
        });
    }

    return optionsSelectionResolution.set('id', id).set('isCancel', isCancel).set('addedOptions', newlyAddedOptions).set('removedOptions', newlyRemovedOptions).set('resolutionActionOptions', actionOptions).set('isExteriorColour', !(0, _lodash.isEmpty)(exteriorColourOptions)).set('availableExteriorColours', availableExteriorColours).set('isInteriorColour', !(0, _lodash.isEmpty)(interiorColourOptions)).set('availableInteriorColours', availableInteriorColours);
}

exports.default = {
    resetResolutionOptionsFromResolutionData: resetResolutionOptionsFromResolutionData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionsService/OptionsSelectionResolutionsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetResolutionOptionsFromResolutionsData = resetResolutionOptionsFromResolutionsData;

var _lodash = __webpack_require__("lodash");

var _OptionsSelectionResolutionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionsSelectionResolutionService/OptionsSelectionResolutionService.js");

var _OptionsSelectionResolutionsModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/OptionsSelectionResolutionsModel.js");

var _OptionsSelectionResolutionsModel2 = _interopRequireDefault(_OptionsSelectionResolutionsModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-bitwise: 0 */

function resetResolutionOptionsFromResolutionsData(resolutions, configuration, triggerSelectionCode) {
    var optionsSelectionResolutions = new _OptionsSelectionResolutionsModel2.default();
    if ((0, _lodash.isEmpty)(resolutions) || !(0, _lodash.isArrayLikeObject)(resolutions) || !(0, _lodash.isObjectLike)(configuration) || (0, _lodash.isEmpty)(configuration.selectionCode)) {
        return optionsSelectionResolutions;
    }
    var configurationOptionsSelectionCodes = configuration.getConfigurationOptionsSelectionCodes();
    var originalOptionsSelectionCodes = configuration.getOptionsSelectionCodes();

    var convertedResolutions = (0, _lodash.map)(resolutions, function (resolution) {
        return (0, _OptionsSelectionResolutionService.resetResolutionOptionsFromResolutionData)(resolution, configurationOptionsSelectionCodes, originalOptionsSelectionCodes, triggerSelectionCode);
    });

    // Failed resolution from bad data
    var validResolutions = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return !convertedResolution.isCancel;
    });
    if (!validResolutions) {
        var cancelResolution = convertedResolutions[0];
        var invalidResolution = cancelResolution.set('isCancel', false);

        return optionsSelectionResolutions.set('triggeredFromOptionAdd', (0, _lodash.includes)(originalOptionsSelectionCodes, triggerSelectionCode)).set('resolutionTriggerOptionSelectionCode', triggerSelectionCode).set('resolutions', [cancelResolution, invalidResolution]);
    }

    var nonColourResolutions = (0, _lodash.filter)(convertedResolutions, function (convertedResolution) {
        return !convertedResolution.isExteriorColour && !convertedResolution.isInteriorColour;
    });

    var exteriorColourResolutions = [];
    var exteriorColourResolution = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return convertedResolution.isExteriorColour;
    });
    if (exteriorColourResolution) {
        exteriorColourResolutions = (0, _lodash.isEmpty)(exteriorColourResolution.availableExteriorColours) ? [exteriorColourResolution] : (0, _lodash.map)(exteriorColourResolution.availableExteriorColours, function (availableExteriorColour) {
            return exteriorColourResolution.set('id', 'A' + availableExteriorColour.selectionCode + '-' + exteriorColourResolution.id).set('addedOptions', (0, _lodash.concat)(exteriorColourResolution.addedOptions, availableExteriorColour)).set('resolutionActionOptions', (0, _lodash.concat)(exteriorColourResolution.resolutionActionOptions, availableExteriorColour.set('selected', true)));
        });
    }

    var interiorColourResolutions = [];
    var interiorColourResolution = (0, _lodash.find)(convertedResolutions, function (convertedResolution) {
        return convertedResolution.isInteriorColour;
    });
    if (interiorColourResolution) {
        interiorColourResolutions = (0, _lodash.isEmpty)(interiorColourResolution.availableInteriorColours) ? [interiorColourResolution] : (0, _lodash.map)(interiorColourResolution.availableInteriorColours, function (availableInteriorColour) {
            return interiorColourResolution.set('id', 'A' + availableInteriorColour.selectionCode + '-' + interiorColourResolution.id).set('addedOptions', (0, _lodash.concat)(interiorColourResolution.addedOptions, availableInteriorColour)).set('resolutionActionOptions', (0, _lodash.concat)(interiorColourResolution.resolutionActionOptions, availableInteriorColour.set('selected', true)));
        });
    }

    return optionsSelectionResolutions.set('triggeredFromOptionAdd', (0, _lodash.includes)(originalOptionsSelectionCodes, triggerSelectionCode)).set('resolutionTriggerOptionSelectionCode', triggerSelectionCode).set('resolutions', (0, _lodash.concat)(nonColourResolutions, exteriorColourResolutions, interiorColourResolutions));
}

exports.default = {
    resetResolutionOptionsFromResolutionsData: resetResolutionOptionsFromResolutionsData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/TransmissionService/TransmissionService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetTransmissionFromConfigurationData = resetTransmissionFromConfigurationData;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _DataUtilitiesService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js");

var _TransmissionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint import/prefer-default-export: 0 */

function resetTransmissionFromConfigurationData(configurationTransmissionData) {
    if ((0, _lodash.isEmpty)(configurationTransmissionData) || configurationTransmissionData.length <= _dataConversions.TRANSMISSION_DATA.DESCRIPTION) {
        return new _TransmissionModel2.default();
    }

    var selectionCode = configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE] + '-' + (configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.SPEEDS] + '-') + ('' + configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.IS_CVT]);

    return new _TransmissionModel2.default({
        selectionCode: selectionCode,
        code: '',
        typeCode: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE],
        rank: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE_CODE] === 'MA' ? 1 : 2,
        type: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.TYPE],
        speeds: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.SPEEDS],
        isCVT: configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.IS_CVT],
        description: (0, _DataUtilitiesService.getDescriptionData)(configurationTransmissionData[_dataConversions.TRANSMISSION_DATA.DESCRIPTION])
    });
}

exports.default = {
    resetTransmissionFromConfigurationData: resetTransmissionFromConfigurationData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/ModelYear/services/YearService/YearService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetYearFromOriginData = resetYearFromOriginData;
exports.resetYearPurchaseMethod = resetYearPurchaseMethod;
exports.recalculateYearPayments = recalculateYearPayments;
exports.recalculateYearPurchaseAmounts = recalculateYearPurchaseAmounts;

var _lodash = __webpack_require__("lodash");

var _apiDataConversionConstants = __webpack_require__("../widget-commons-vehicle/src/constants/apiDataConversionConstants.js");

var Constants = _interopRequireWildcard(_apiDataConversionConstants);

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _YearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/YearModel.js");

var _YearModel2 = _interopRequireDefault(_YearModel);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function resetYearFromCollectionData(collectionData, year, disclaimers) {
    var exteriorColours = {
        photo1: '',
        photo2: '',
        photo3: ''
    };
    var exteriorColourStatus = 0;

    if (collectionData[Constants.VIEW_1.VEHICLE.HIGH_PRICE]) {
        var highPriceObject = collectionData[Constants.VIEW_1.VEHICLE.HIGH_PRICE][Constants.VIEW_1.VEHICLE.HIGH_PRICE_INDEX];
        exteriorColours.photo1 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_1];
        exteriorColours.photo2 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_2];
        exteriorColours.photo3 = highPriceObject[Constants.VIEW_1.VEHICLE.URL_EXTERIOR_COLOUR][Constants.VIEW_1.COLOUR_IMAGE.PHOTO_3];

        if (!(0, _lodash.isUndefined)(highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS])) {
            exteriorColourStatus = highPriceObject[Constants.VIEW_1.VEHICLE.EXTERIOR_COLOUR_STATUS];
        } else if (exteriorColours.photo1) {
            exteriorColourStatus = _exteriorColourStatuses.IMAGE_STATUS.FULL_COLORIZED;
        }
    }

    var highRebate = 0;
    var highRebatePurchaseMethod = _purchaseMethodsValues2.default.CASH;
    if (collectionData[Constants.VIEW_1.VEHICLE.HIGH_REBATE]) {
        var highRebateObject = collectionData[Constants.VIEW_1.VEHICLE.HIGH_REBATE][Constants.VIEW_1.VEHICLE.HIGH_REBATE_INDEX];
        var highRebateTaxes = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
        highRebate = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
        highRebatePurchaseMethod = highRebateObject[Constants.VIEW_1.VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
    }

    var modelTrimPurchaseMethodIds = [];

    if (collectionData[Constants.VIEW_1.VEHICLE.PRICE] && collectionData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX]) {
        var price = collectionData[Constants.VIEW_1.VEHICLE.PRICE][Constants.VIEW_1.VEHICLE.PRICE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.CASH,
            modelTrimCode: price[Constants.VIEW_1.VEHICLE.PRICE_MODEL_TRIM_CODE],
            configurationId: price[Constants.VIEW_1.VEHICLE.PRICE_CONFIGURATION_ID]
        });
    }

    if (collectionData[Constants.VIEW_1.VEHICLE.FINANCE] && collectionData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX]) {
        var finance = collectionData[Constants.VIEW_1.VEHICLE.FINANCE][Constants.VIEW_1.VEHICLE.FINANCE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.FINANCE,
            modelTrimCode: finance[Constants.VIEW_1.VEHICLE.FINANCE_MODEL_TRIM_CODE],
            configurationId: finance[Constants.VIEW_1.VEHICLE.FINANCE_CONFIGURATION_ID]
        });
    }

    if (collectionData[Constants.VIEW_1.VEHICLE.LEASE] && collectionData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX]) {
        var lease = collectionData[Constants.VIEW_1.VEHICLE.LEASE][Constants.VIEW_1.VEHICLE.LEASE_INDEX];
        modelTrimPurchaseMethodIds.push({
            purchaseMethod: _purchaseMethodsValues2.default.LEASE,
            modelTrimCode: lease[Constants.VIEW_1.VEHICLE.LEASE_MODEL_TRIM_CODE],
            configurationId: lease[Constants.VIEW_1.VEHICLE.LEASE_CONFIGURATION_ID]
        });
    }

    return new _YearModel2.default({
        year: year,
        make: collectionData.make,
        model: collectionData.model,
        bodyStyleCode: collectionData.bodyStyleCode,
        bodyStyle: collectionData.bodyStyle[Constants.DESCRIPTION_LANGUAGE_INDEX],
        modelTrimPurchaseMethodIds: modelTrimPurchaseMethodIds,
        exteriorColours: exteriorColours,
        exteriorColourStatus: exteriorColourStatus,
        highRebate: highRebate,
        highRebatePurchaseMethod: highRebatePurchaseMethod,
        purchaseMethods: PurchaseMethodsService.resetPurchaseMethodsFromOriginData(DataOrigins.MODELS_COLLECTION, collectionData, undefined, disclaimers)
    });
}

function resetYearFromOriginData(dataOrigin, originYearData, year, disclaimers) {
    if ((0, _lodash.isEmpty)(originYearData) || !(0, _lodash.isObjectLike)(originYearData)) {
        return new _YearModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetYearFromCollectionData(originYearData, year, disclaimers);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return new _YearModel2.default();

        default:
            return new _YearModel2.default();
    }
}

function resetYearPurchaseMethod(year, purchaseMethod) {
    return year.set('purchaseMethods', PurchaseMethodsService.selectPurchaseMethod(year.purchaseMethods, purchaseMethod));
}

function recalculateYearPayments(year, paymentCalculationParameters) {
    var newPaymentCalculationParameters = paymentCalculationParameters;
    var selectedLeaseTerm = void 0;
    var selectedFinanceTerm = void 0;
    if (!(0, _lodash.find)(year.purchaseMethods.lease.terms, function (term) {
        return term.term === paymentCalculationParameters.selectedLeaseTerm;
    })) {
        selectedLeaseTerm = (0, _lodash.last)(year.purchaseMethods.lease.terms).term;
    }
    if (!(0, _lodash.find)(year.purchaseMethods.finance.terms, function (term) {
        return term.term === paymentCalculationParameters.selectedFinanceTerm;
    })) {
        selectedFinanceTerm = (0, _lodash.last)(year.purchaseMethods.finance.terms).term;
    }
    if (selectedLeaseTerm || selectedFinanceTerm) {
        newPaymentCalculationParameters = (0, _lodash.clone)(paymentCalculationParameters);
        newPaymentCalculationParameters.selectedLeaseTerm = selectedLeaseTerm || newPaymentCalculationParameters.selectedLeaseTerm;
        newPaymentCalculationParameters.selectedFinanceTerm = selectedFinanceTerm || newPaymentCalculationParameters.selectedFinanceTerm;
    }

    return year.set('purchaseMethods', PurchaseMethodsService.recalculatePayments(year.purchaseMethods, newPaymentCalculationParameters));
}

function recalculateYearPurchaseAmounts(year, paymentCalculationParameters) {
    var newYear = year.set('purchaseMethods', PurchaseMethodsService.recalculatePurchaseAmounts(year.purchaseMethods, paymentCalculationParameters));

    return recalculateYearPayments(newYear, paymentCalculationParameters);
}

exports.default = {
    resetYearFromOriginData: resetYearFromOriginData,
    resetYearPurchaseMethod: resetYearPurchaseMethod,
    recalculateYearPayments: recalculateYearPayments,
    recalculateYearPurchaseAmounts: recalculateYearPurchaseAmounts
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LOAD_PURCHASE_METHODS_SUCCESS = exports.LOAD_PURCHASE_METHODS_SUCCESS = 'LOAD_PURCHASE_METHODS_SUCCESS';

var SELECT_PURCHASE_METHOD = exports.SELECT_PURCHASE_METHOD = 'SELECT_PURCHASE_METHOD';
var SELECT_PAYMENT_FREQUENCY = exports.SELECT_PAYMENT_FREQUENCY = 'SELECT_PAYMENT_FREQUENCY';
var SELECT_TERM = exports.SELECT_TERM = 'SELECT_TERM';
var SELECT_KM_PLAN = exports.SELECT_KM_PLAN = 'SELECT_KM_PLAN';

var SET_CASH_DOWN = exports.SET_CASH_DOWN = 'SET_CASH_DOWN';
var SET_TRADE_IN = exports.SET_TRADE_IN = 'SET_TRADE_IN';
var SET_LIEN = exports.SET_LIEN = 'SET_LIEN';
var SET_EXTERIOR_COLOUR_AMOUNTS = exports.SET_EXTERIOR_COLOUR_AMOUNTS = 'SET_EXTERIOR_COLOUR_AMOUNTS';
var SET_INTERIOR_COLOUR_AMOUNTS = exports.SET_INTERIOR_COLOUR_AMOUNTS = 'SET_INTERIOR_COLOUR_AMOUNTS';
var SET_OPTIONS_AMOUNTS = exports.SET_OPTIONS_AMOUNTS = 'SET_OPTIONS_AMOUNTS';

var SET_DELIVERY_FEE = exports.SET_DELIVERY_FEE = 'SET_DELIVERY_FEE';
var SET_DEPOSIT = exports.SET_DEPOSIT = 'SET_DEPOSIT';

var SET_TAXES_INCLUDED = exports.SET_TAXES_INCLUDED = 'SET_TAXES_INCLUDED';

var SELECT_OPTIONS_RESOLUTION = exports.SELECT_OPTIONS_RESOLUTION = 'SELECT_OPTIONS_RESOLUTION';

var RESET_SELECTED_INCENTIVE_REBATES = exports.RESET_SELECTED_INCENTIVE_REBATES = 'RESET_SELECTED_INCENTIVE_REBATES';

var QUOTE_UPDATE_TYPES = exports.QUOTE_UPDATE_TYPES = [SELECT_PURCHASE_METHOD, SELECT_PAYMENT_FREQUENCY, SELECT_TERM, SELECT_KM_PLAN, SET_CASH_DOWN, SET_TRADE_IN, SET_LIEN, SET_TAXES_INCLUDED, SELECT_OPTIONS_RESOLUTION];

exports.default = {
    LOAD_PURCHASE_METHODS_SUCCESS: LOAD_PURCHASE_METHODS_SUCCESS,
    SELECT_PURCHASE_METHOD: SELECT_PURCHASE_METHOD,
    SELECT_PAYMENT_FREQUENCY: SELECT_PAYMENT_FREQUENCY,
    SELECT_TERM: SELECT_TERM,
    SELECT_KM_PLAN: SELECT_KM_PLAN,
    SET_CASH_DOWN: SET_CASH_DOWN,
    SET_TRADE_IN: SET_TRADE_IN,
    SET_LIEN: SET_LIEN,
    SET_EXTERIOR_COLOUR_AMOUNTS: SET_EXTERIOR_COLOUR_AMOUNTS,
    SET_INTERIOR_COLOUR_AMOUNTS: SET_INTERIOR_COLOUR_AMOUNTS,
    SET_OPTIONS_AMOUNTS: SET_OPTIONS_AMOUNTS,
    SET_DELIVERY_FEE: SET_DELIVERY_FEE,
    SET_DEPOSIT: SET_DEPOSIT,
    SET_TAXES_INCLUDED: SET_TAXES_INCLUDED,
    SELECT_OPTIONS_RESOLUTION: SELECT_OPTIONS_RESOLUTION,
    RESET_SELECTED_INCENTIVE_REBATES: RESET_SELECTED_INCENTIVE_REBATES,
    QUOTE_UPDATE_TYPES: QUOTE_UPDATE_TYPES
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadPurchaseMethodsSuccess = loadPurchaseMethodsSuccess;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectTerm = selectTerm;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setDeliveryFee = setDeliveryFee;
exports.setDeposit = setDeposit;
exports.setTaxesIncluded = setTaxesIncluded;
exports.setKMPlan = setKMPlan;
exports.selectOptionsResolution = selectOptionsResolution;
exports.resetIncentivesRebates = resetIncentivesRebates;

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _modelYearActions = __webpack_require__("../widget-commons-vehicle/src/ModelYear/actions/modelYearActions.js");

var _quoteActions = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActions.js");

var _purchaseMethodsActionTypes = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var purchaseMethodsTypes = _interopRequireWildcard(_purchaseMethodsActionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function loadPurchaseMethodsSuccess(purchaseMethods) {
    return { type: purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS, purchaseMethods: purchaseMethods };
}

function selectPurchaseMethod(purchaseMethod) {
    return function (dispatch, getState) {
        dispatch({ type: purchaseMethodsTypes.SELECT_PURCHASE_METHOD, purchaseMethod: purchaseMethod });
        dispatch((0, _modelYearActions.validateSelectedOptions)()).then(function () {
            var state = getState();
            var selectedOptionsPackage = state.modelYear.getSelectedOptionsPackage();
            dispatch(loadPurchaseMethodsSuccess(selectedOptionsPackage.configuration.purchaseMethods));
            dispatch((0, _quoteActions.setQuoteModified)());
        });
    };
}

function selectTerm(term) {
    return { type: purchaseMethodsTypes.SELECT_TERM, term: term };
}

function selectPaymentFrequency(paymentFrequency) {
    return { type: purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY, paymentFrequency: paymentFrequency };
}

function setCashDown(cashDown) {
    return { type: purchaseMethodsTypes.SET_CASH_DOWN, cashDown: cashDown };
}

function setTradeIn(tradeIn) {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('tradeIn', parseInt(tradeIn, 10));
    }
    return { type: purchaseMethodsTypes.SET_TRADE_IN, tradeIn: tradeIn };
}

function setLien(lien) {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy && windowProxy.localStorage) {
        windowProxy.localStorage.setItem('lien', parseInt(lien, 10));
    }
    return { type: purchaseMethodsTypes.SET_LIEN, lien: lien };
}

function setExteriorColourAmounts(exteriorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS, exteriorColourAmounts: exteriorColourAmounts };
}

function setInteriorColourAmounts(interiorColourAmounts) {
    return { type: purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS, interiorColourAmounts: interiorColourAmounts };
}

function setOptionsAmounts(optionsAmounts) {
    return { type: purchaseMethodsTypes.SET_OPTIONS_AMOUNTS, optionsAmounts: optionsAmounts };
}

function setDeliveryFee(addFee) {
    return { type: purchaseMethodsTypes.SET_DELIVERY_FEE, addFee: addFee };
}

function setDeposit(deposit) {
    return { type: purchaseMethodsTypes.SET_DEPOSIT, deposit: deposit };
}

function setTaxesIncluded(taxesIncluded) {
    return { type: purchaseMethodsTypes.SET_TAXES_INCLUDED, taxesIncluded: taxesIncluded };
}

function setKMPlan(kmPlan) {
    return { type: purchaseMethodsTypes.SELECT_KM_PLAN, kmPlan: kmPlan };
}

function selectOptionsResolution(resolutionId) {
    return { type: purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION, resolutionId: resolutionId };
}

function resetIncentivesRebates() {
    return { type: purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES };
}

exports.default = {
    loadPurchaseMethodsSuccess: loadPurchaseMethodsSuccess,
    selectPurchaseMethod: selectPurchaseMethod,
    selectTerm: selectTerm,
    selectPaymentFrequency: selectPaymentFrequency,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setOptionsAmounts: setOptionsAmounts,
    setDeliveryFee: setDeliveryFee,
    setDeposit: setDeposit,
    setTaxesIncluded: setTaxesIncluded,
    setKMPlan: setKMPlan,
    selectOptionsResolution: selectOptionsResolution,
    resetIncentivesRebates: resetIncentivesRebates
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODEL_TERM = exports.MODEL_TERM = {
    APR: 0,
    TERM: 1,
    DISCOUNT: 3,
    REBATE: 4,
    REBATE_AT_DELIVERY: 5,
    CASH_DOWN: 6,
    PAYMENT_FREQUENCIES: 7,
    RESIDUAL_RATE: 8,
    FINANCED_AMOUNT: 9,
    FINANCED_AMOUNT_WITH_TAXES: 10,
    RESIDUAL_AMOUNT: 11,
    CREDIT_RATE: 12,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT: 13,
    CREDIT_RATE_WITH_CASH_REBATE_ADJUSTMENT_TAXES: 14,
    INCLUDED_CODES: 15,
    REBATES_DETAILS: 16,
    REBATE_TAXES: 17,
    REBATE_TAXES_AT_DELIVERY: 18,
    REBATE_AT_STANDARD_RATE: 19
};

var COLLECTION_FREQUENCY = exports.COLLECTION_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    BASE_PAYMENT: 1,
    FEES_PAYMENT: 2,
    DUTIES_PAYMENT: 3,
    PAYMENT_TAXES: 4,
    FINANCE_FACTOR: 5,
    BALLOON_FACTOR: 6,
    DISCLAIMERS: 12
};

var CALCULATOR_FREQUENCY = exports.CALCULATOR_FREQUENCY = {
    PAYMENT_FREQUENCY: 'paymentPerYear',
    PAYMENT: 'payment',
    PAYMENT_TAXES: 'taxes',
    CASH_DOWN: 'cashDown',
    FINANCE_FACTOR: 'finFactor',
    BALLOON_FACTOR: 'balloonFactor',
    DISCLAIMER: 'disclaimer'
};

var MODEL_FREQUENCY = exports.MODEL_FREQUENCY = {
    PAYMENT_FREQUENCY: 0,
    PAYMENT: 1,
    PAYMENT_TAXES: 2,
    FINANCE_FACTOR: 3,
    BALLOON_FACTOR: 4
};

var COLLECTION_FINANCE = exports.COLLECTION_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 6,
    BEST_TERM: 7,
    BEST_TERM_INDEX: 8,
    BEST_TERM_WITH_CASH: 9,
    BEST_TERM_WITH_CASH_INDEX: 10,
    PHOTO_URLS: 11,
    FINANCE_DISCLAIMERS: 12,
    LEASE_DISCLAIMERS: 18,
    LEASE_ANNUAL_KM: 12,
    LEASE_MAX_EXCEEDING_KM: 13,
    LEASE_MAX_TERM_KM: 14,
    LEASE_ALLOW_EXCEEDING_KM: 15,
    LEASE_MAX_TERM_EXCEEDING_KM: 16,
    LEASE_END_TERM_KM_COST: 17
};

var CALCULATOR_FINANCE = exports.CALCULATOR_FINANCE = {
    VEHICLE: 'vehicle',
    FINANCE: 'finance',
    LEASE: 'lease'
};

var VEHICLE_FINANCE = exports.VEHICLE_FINANCE = {
    FINANCE: 'finance',
    LEASE: 'lease',
    INDEX: 0,
    TERMS: 0
};

var MODEL_FINANCE = exports.MODEL_FINANCE = {
    FINANCE: 16,
    LEASE: 17,
    INDEX: 0,
    TERMS: 0,
    LEASE_ANNUAL_KM: 1,
    LEASE_MAX_EXCEEDING_KM: 2,
    LEASE_MAX_TERM_KM: 3,
    LEASE_ALLOW_EXCEEDING_KM: 4,
    LEASE_MAX_TERM_EXCEEDING_KM: 5,
    LEASE_END_TERM_KM_COST: 6
};

var MODEL_CASH_PURCHASE = exports.MODEL_CASH_PURCHASE = {
    PRICING: 15,
    RETAIL: 0,
    DISCOUNTS: 1,
    REBATES: 2,
    REBATES_AT_DELIVERY: 3,
    INCLUDED_CODES: 4,
    REBATES_DETAILS: 5,
    REBATES_TAXES: 6,
    DEALER_FEES: 7
};

var VEHICLE_CASH_PURCHASE = exports.VEHICLE_CASH_PURCHASE = {
    PRICING: 'price'
};

var COLLECTION_CASH_PURCHASE = exports.COLLECTION_CASH_PURCHASE = {
    PRICING: 'price',
    INDEX: 0,
    RETAIL: 6,
    REBATES: 7,
    AMOUNTS: 9,
    MSRP: 0,
    FREIGHT_PDI: 1,
    TAXES_AND_DUTIES: 2,
    DISCLAIMERS: 10,
    REBATES_DETAILS: 11,
    DISCOUNTS: 12,
    REBATES_AT_DELIVERY: 13,
    REBATES_TAXES: 14
};

var MODEL_TAXES = exports.MODEL_TAXES = {
    TAXES_FACTOR: 21,
    TAX_CODES: 22
};

var REBATE_DETAILS = exports.REBATE_DETAILS = {
    REBATE_TYPE_ID: 0,
    REBATE_CODE: 1,
    REBATE_DESCRIPTION: 2,
    REBATE_AMOUNT: 3,
    REBATE_IS_AT_DELIVERY: 4,
    REBATE_IS_AFTER_TAXES: 5,
    REBATE_TAXES: 6,
    REBATE_TAXES_AT_DELIVERY: 7
};

exports.default = {
    MODEL_TERM: MODEL_TERM,
    COLLECTION_FREQUENCY: COLLECTION_FREQUENCY,
    CALCULATOR_FREQUENCY: CALCULATOR_FREQUENCY,
    MODEL_FREQUENCY: MODEL_FREQUENCY,
    COLLECTION_FINANCE: COLLECTION_FINANCE,
    CALCULATOR_FINANCE: CALCULATOR_FINANCE,
    VEHICLE_FINANCE: VEHICLE_FINANCE,
    MODEL_FINANCE: MODEL_FINANCE,
    MODEL_CASH_PURCHASE: MODEL_CASH_PURCHASE,
    VEHICLE_CASH_PURCHASE: VEHICLE_CASH_PURCHASE,
    COLLECTION_CASH_PURCHASE: COLLECTION_CASH_PURCHASE,
    MODEL_TAXES: MODEL_TAXES,
    REBATE_DETAILS: REBATE_DETAILS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/constants/disclaimers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DISCLAIMERS = {
    CASH: {
        VEHICLE_DESCRIPTION: 1,
        SELLING_PRICE: 2,
        INCLUDED_REBATES: 3,
        INCLUDED_FEES: 4,
        EXCLUDED_FEES: 5
    },
    FINANCE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 11,
            COST_OF_CREDIT: 12,
            CREDIT_RATE: 13
        },
        KM_PLAN: 0,
        CREDIT_APPROVAL: 14,
        CASH_DOWN_TAX_EXCLUDED: 15
    },
    LEASE: {
        VEHICLE_DESCRIPTION: 1,
        TERM: {
            SELLING_PRICE: 2,
            INCLUDED_REBATES: 3,
            INCLUDED_FEES: 4,
            EXCLUDED_FEES: 5,
            TERM_APR: 6
        },
        PAYMENT_FREQUENCY: {
            PAYMENT_CASH_DOWN: 7,
            TOTAL_OBLIGATION: 0,
            COST_OF_CREDIT: 0,
            CREDIT_RATE: 0
        },
        KM_PLAN: 11,
        CREDIT_APPROVAL: 12,
        CASH_DOWN_TAX_EXCLUDED: 13
    },
    GENERAL_FEES_EXCLUSION: 1,
    PRICES_SUBJECT_TO_CHANGE: 2,
    NOT_RESPONSIBLE: 3,
    HIGH_TRANSACTION_VOLUME: 4,
    ILLUSTRATION_PURPOSES: 6,
    OPTIONS_TRIMS_VARIATION: 7,
    EXCLUDED_TAXES: 9,
    PRICE_PAYMENTS_EXCLUDED_TAXES: 11
};

exports.default = DISCLAIMERS;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var WEEKLY = exports.WEEKLY = 52;
var BI_WEEKLY = exports.BI_WEEKLY = 26;
var SEMI_MONTHLY = exports.SEMI_MONTHLY = 24;
var MONTHLY = exports.MONTHLY = 12;

exports.default = {
    WEEKLY: WEEKLY,
    BI_WEEKLY: BI_WEEKLY,
    SEMI_MONTHLY: SEMI_MONTHLY,
    MONTHLY: MONTHLY
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LEASE = exports.LEASE = 'lease';
var FINANCE = exports.FINANCE = 'finance';
var CASH_PURCHASE = exports.CASH_PURCHASE = 'cashPurchase';
var BEST_PAYMENT = exports.BEST_PAYMENT = 'bestPayment';

exports.default = {
    LEASE: LEASE,
    FINANCE: FINANCE,
    CASH_PURCHASE: CASH_PURCHASE,
    BEST_PAYMENT: BEST_PAYMENT
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PURCHASE_METHODS = {
    CASH: 0x1,
    FINANCE: 0x100,
    FINANCE_WITH_BALLOON: 0x300,
    LEASE: 0x1000,
    SINGLE_PAYMENT_LEASE: 0x3000
};

exports.default = PURCHASE_METHODS;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"purchaseMethods":{"lease":"Lease","finance":"Finance","cashPurchase":"Purchase","bestPayment":"Best Payment","leaseVerb":"Lease","financeVerb":"Finance","cashPurchaseVerb":"Purchase","msrp":"MSRP","cashDiscount":"Cash Discount","pdiFreight":"PDI & Freight","otherFees":"Other fees","QSTGST":"QST / GST","cashPurchaseTitle":"Cash Purchase","months":"months","monthsAbr":"mo"},"KM_PLANS":{"TITLE":"KM Plan","ANNUAL_KM_ALLOWED":"%{annualKMAllowed} km/year","ANNUAL_KM_INCLUDED":"%{annualKMAllowed} km per year included","END_TERM_KM_COST":"Charges of %{endTermKMCost} per exceeding kilometer will apply"},"paymentFrequencies":{"title":"Payment Frequency","weekly":"Weekly","biWeekly":"Bi-Weekly","semiMonthly":"Semi-Monthly","monthly":"Monthly","perWeek":"/ Week","perBiWeek":"/ Bi-Weekly","perSemiMonth":"/ Semi-Month","perMonth":"/ Month"},"DOWN_PAYMENTS":{"CASH_DOWN":"down payment","CASH_DOWN_LABEL":"Cash Down","DISCOUNT":"discount","REBATES":"rebates","CASH_DOWN_WITH_AMOUNT":"%{cashDown} cash down","DISCOUNT_WITH_AMOUNT":"%{discount} discount","REBATES_WITH_AMOUNT":"%{rebate} rebates"},"DISCLAIMERS":{"PLUS_TAXES_AND_LIC":"+ Taxes & Lic.","PLUS_TAXES_CODES_AND_LIC":"+ %{taxCodes} & Lic."},"DISCLAIMERS_DEFAULT_VALUES":{"ILLUSTRATION":"Models and pictures shown for illustration purposes only.","HIGH_VOLUME":"Due to a large number of transactions, it is possible that the vehicle you reserved is already sold. In the case of this occurring, we will contact you as soon as possible and your deposit will be refunded immediately.","OPTIONS_VARIATION":"Options and accessories may vary by trim.","DATA_RESPONSIBILITY":"While every reasonable effort is made to ensure the accuracy of this information, we are not responsible for any errors or omissions contained on these pages. Please verify all information and pricing with a sales representative or ask online.","PRICE_CHANGE":"Prices, payments and rates are subject to change without notice. Please validate the information with a sales representative.","PRICE_EXCLUSION":"License, insurance, registration, additional options and applicable taxes are extra.","TAXES_EXCLUDED":"+ %{taxCodes} & licence","PRICE_PAYMENTS_TAXES_EXCLUDED":"Price and payments don't include taxes and licence fee","CREDIT_APPROVAL":"Finance and lease offers on approved credit. Rates and requirements may vary depending on credit worthiness."}}

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"purchaseMethods":{"lease":"Location","finance":"Financement","cashPurchase":"Achat","bestPayment":"Meilleur paiement","leaseVerb":"Louez","financeVerb":"Financez","cashPurchaseVerb":"Achetez","msrp":"PDSF","cashDiscount":"Rabais","pdiFreight":"Transport et préparation","otherFees":"Autres frais","QSTGST":"TPS / TVQ","cashPurchaseTitle":"Prix à l'achat","months":"mois","monthsAbr":"mo"},"KM_PLANS":{"TITLE":"Plan de km","ANNUAL_KM_ALLOWED":"%{annualKMAllowed} km/année","ANNUAL_KM_INCLUDED":"%{annualKMAllowed} km par année inclus","END_TERM_KM_COST":"Des frais de %{endTermKMCost} par kilomètre excédentaire s'appliqueront"},"paymentFrequencies":{"title":"Fréquence de paiement","weekly":"à la semaine","biWeekly":"aux 2 semaines","semiMonthly":"à la quinzaine","monthly":"au mois","perWeek":"/ sem.","perBiWeek":"/ 2 sem.","perSemiMonth":"/ quinz.","perMonth":"/ mois"},"DOWN_PAYMENTS":{"CASH_DOWN":"d'acompte","CASH_DOWN_LABEL":"Acompte","DISCOUNT":"escompte","REBATES":"rabais","CASH_DOWN_WITH_AMOUNT":"%{cashDown} d'acompte","DISCOUNT_WITH_AMOUNT":"%{discount} d'escompte","REBATES_WITH_AMOUNT":"%{rebate} de rabais"},"DISCLAIMERS":{"PLUS_TAXES_AND_LIC":"+ Taxes et droits","PLUS_TAXES_CODES_AND_LIC":"+ %{taxCodes} et droits"},"DISCLAIMERS_DEFAULT_VALUES":{"ILLUSTRATION":"Les modèles et images montrés à des fins d'illustration seulement.","HIGH_VOLUME":"En raison d'un grand nombre de transactions, il est possible que le véhicule que vous avez réservé soit déjà vendu. Dans ce cas, nous vous contacterons dès que possible et votre dépôt sera remboursé immédiatement.","OPTIONS_VARIATION":"Les options et accessoires peuvent varier selon la version.","DATA_RESPONSIBILITY":"Bien que tous les efforts raisonnables soient faits pour assurer l'exactitude de ces informations, nous ne sommes pas responsables des erreurs ou omissions contenues sur ces pages. S'il vous plaît vérifier toutes les informations et les prix avec un représentant des ventes ou demander en ligne.","PRICE_CHANGE":"Les prix, paiements et taux sont sujets à des changements sans préavis. Veuillez valider l'information auprès d'un représentant aux ventes.","PRICE_EXCLUSION":"Immatriculation, assurance, enregistrement, options additionnelles et taxes applicables sont en sus.","TAXES_EXCLUDED":"+ %{taxCodes} et immatriculation","PRICE_PAYMENTS_TAXES_EXCLUDED":"Les prix et paiements n'incluent pas les taxes et immatriculation","CREDIT_APPROVAL":"Offres de financement et location sur approbation de crédit. Les taux et les exigences peuvent varier en fonction de la solvabilité."}}

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisclaimerAPIService = exports.TermService = exports.PurchaseMethodsService = exports.PaymentFrequencyService = exports.FinanceService = exports.CashPurchaseService = exports.PurchaseMethodsReducer = exports.TermModel = exports.PurchaseMethodsModel = exports.PaymentFrequencyModel = exports.FinanceModel = exports.CashPurchaseModel = exports.Translations = exports.PurchaseMethodsValues = exports.PurchaseMethodsConstant = exports.PaymentFrequencies = exports.DataConversions = exports.PurchaseMethodsActionsTypes = exports.PurchaseMethodsActions = undefined;

var _purchaseMethodsActions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActions.js");

var _purchaseMethodsActions2 = _interopRequireDefault(_purchaseMethodsActions);

var _purchaseMethodsActionTypes = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _dataConversions2 = _interopRequireDefault(_dataConversions);

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

var _paymentFrequencies2 = _interopRequireDefault(_paymentFrequencies);

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var _purchaseMethods2 = _interopRequireDefault(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _en = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

var _CashPurchaseModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

var _FinanceModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _PaymentFrequencyModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PaymentFrequencyModel.js");

var _PaymentFrequencyModel2 = _interopRequireDefault(_PaymentFrequencyModel);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _TermModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _purchaseMethodsReducer = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/reducers/purchaseMethodsReducer.js");

var _purchaseMethodsReducer2 = _interopRequireDefault(_purchaseMethodsReducer);

var _CashPurchaseService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

var _CashPurchaseService2 = _interopRequireDefault(_CashPurchaseService);

var _FinanceService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/FinanceService/FinanceService.js");

var _FinanceService2 = _interopRequireDefault(_FinanceService);

var _PaymentFrequencyService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js");

var _PaymentFrequencyService2 = _interopRequireDefault(_PaymentFrequencyService);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _PurchaseMethodsService2 = _interopRequireDefault(_PurchaseMethodsService);

var _TermService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/TermService/TermService.js");

var _TermService2 = _interopRequireDefault(_TermService);

var _DisclaimerAPIService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translations = {
    en: _en2.default,
    fr: _fr2.default
};

exports.PurchaseMethodsActions = _purchaseMethodsActions2.default;
exports.PurchaseMethodsActionsTypes = _purchaseMethodsActionTypes2.default;
exports.DataConversions = _dataConversions2.default;
exports.PaymentFrequencies = _paymentFrequencies2.default;
exports.PurchaseMethodsConstant = _purchaseMethods2.default;
exports.PurchaseMethodsValues = _purchaseMethodsValues2.default;
exports.Translations = Translations;
exports.CashPurchaseModel = _CashPurchaseModel2.default;
exports.FinanceModel = _FinanceModel2.default;
exports.PaymentFrequencyModel = _PaymentFrequencyModel2.default;
exports.PurchaseMethodsModel = _PurchaseMethodsModel2.default;
exports.TermModel = _TermModel2.default;
exports.PurchaseMethodsReducer = _purchaseMethodsReducer2.default;
exports.CashPurchaseService = _CashPurchaseService2.default;
exports.FinanceService = _FinanceService2.default;
exports.PaymentFrequencyService = _PaymentFrequencyService2.default;
exports.PurchaseMethodsService = _PurchaseMethodsService2.default;
exports.TermService = _TermService2.default;
exports.DisclaimerAPIService = _DisclaimerAPIService2.default;
exports.default = {
    PurchaseMethodsActions: _purchaseMethodsActions2.default,
    PurchaseMethodsActionsTypes: _purchaseMethodsActionTypes2.default,
    DataConversions: _dataConversions2.default,
    PaymentFrequencies: _paymentFrequencies2.default,
    PurchaseMethodsConstant: _purchaseMethods2.default,
    PurchaseMethodsValues: _purchaseMethodsValues2.default,

    Translations: Translations,

    CashPurchaseModel: _CashPurchaseModel2.default,
    FinanceModel: _FinanceModel2.default,
    PaymentFrequencyModel: _PaymentFrequencyModel2.default,
    PurchaseMethodsModel: _PurchaseMethodsModel2.default,
    TermModel: _TermModel2.default,
    PurchaseMethodsReducer: _purchaseMethodsReducer2.default,

    CashPurchaseService: _CashPurchaseService2.default,
    FinanceService: _FinanceService2.default,
    PaymentFrequencyService: _PaymentFrequencyService2.default,
    PurchaseMethodsService: _PurchaseMethodsService2.default,
    TermService: _TermService2.default,
    DisclaimerAPIService: _DisclaimerAPIService2.default
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/CashPurchaseModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CashPurchaseRecord = (0, _immutable.Record)({
    purchaseMethod: PurchaseMethods.CASH_PURCHASE,
    purchaseMethodValue: _purchaseMethodsValues2.default.CASH,
    selected: false,
    available: true,
    retail: 0,
    retailAdjustment: 0,
    discounts: 0,
    rebates: 0,
    rebatesTaxes: 0,
    rebatesAtDelivery: 0,
    pricingAmounts: {
        msrp: 0,
        freightPDI: 0,
        taxesAndDuties: 0
    },
    dealerFees: 0,
    optionsAdjustment: 0,
    optionsTaxesAdjustment: 0,
    netTradeInAdjustment: 0,
    tradeInTaxesAdjustment: 0,
    includedItemsCodes: [],
    rebatesDetails: [],
    optionsAdjustmentDiscounts: 0
});

var CashPurchase = function (_CashPurchaseRecord) {
    _inherits(CashPurchase, _CashPurchaseRecord);

    function CashPurchase() {
        _classCallCheck(this, CashPurchase);

        return _possibleConstructorReturn(this, (CashPurchase.__proto__ || Object.getPrototypeOf(CashPurchase)).apply(this, arguments));
    }

    _createClass(CashPurchase, [{
        key: 'getRetail',
        value: function getRetail() {
            return this.retail + this.optionsAdjustment;
        }
    }, {
        key: 'getTotalRebates',
        value: function getTotalRebates() {
            return this.discounts + this.rebates + this.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getTotalRebatesWithTaxes',
        value: function getTotalRebatesWithTaxes() {
            return this.discounts + this.rebates + this.rebatesTaxes + this.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var electricRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.ELECTRIC;
            });

            if ((0, _lodash.isEmpty)(electricRebates)) {
                return null;
            }

            return {
                description: electricRebates[0].description,
                rebate: (0, _lodash.sumBy)(electricRebates, function (electricRebate) {
                    return electricRebate.amount;
                })
            };
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var employeeRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
            });

            if ((0, _lodash.isEmpty)(employeeRebates)) {
                return null;
            }

            return {
                description: employeeRebates[0].description,
                rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
                    return employeeRebate.amount;
                })
            };
        }
    }]);

    return CashPurchase;
}(CashPurchaseRecord);

exports.default = CashPurchase;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/DisclaimersModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisclaimersRecord = (0, _immutable.Record)({
    illustration: '',
    highVolume: '',
    optionsVariation: '',
    dataResponsibility: '',
    priceChange: '',
    priceExclusion: '',
    taxesExcluded: '',
    pricePaymentsTaxesExcluded: '',

    cashPurchase: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: ''
    },

    lease: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    },

    finance: {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    }
});

var Disclaimers = function (_DisclaimersRecord) {
    _inherits(Disclaimers, _DisclaimersRecord);

    function Disclaimers() {
        _classCallCheck(this, Disclaimers);

        return _possibleConstructorReturn(this, (Disclaimers.__proto__ || Object.getPrototypeOf(Disclaimers)).apply(this, arguments));
    }

    return Disclaimers;
}(DisclaimersRecord);

exports.default = Disclaimers;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/FinanceModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _TermModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinanceRecord = (0, _immutable.Record)({
    purchaseMethod: PurchaseMethods.FINANCE,
    purchaseMethodValue: _purchaseMethodsValues2.default.FINANCE,
    annualKMAllowed: 0,
    endTermKMCost: 0,
    selected: false,
    available: false,
    terms: [new _TermModel2.default()],
    selectedTerm: 0,
    kmPlans: []
});

var Finance = function (_FinanceRecord) {
    _inherits(Finance, _FinanceRecord);

    function Finance() {
        _classCallCheck(this, Finance);

        return _possibleConstructorReturn(this, (Finance.__proto__ || Object.getPrototypeOf(Finance)).apply(this, arguments));
    }

    _createClass(Finance, [{
        key: 'getSelectedTerm',
        value: function getSelectedTerm() {
            var _this2 = this;

            return (0, _lodash.find)(this.terms, function (term) {
                return term.term === _this2.selectedTerm;
            });
        }
    }, {
        key: 'getBestPaymentTerm',
        value: function getBestPaymentTerm(maximumTerm) {
            return (0, _lodash.minBy)((0, _lodash.filter)(this.terms, function (filterTerm) {
                return maximumTerm === 0 || filterTerm.term <= maximumTerm;
            }), function (term) {
                return term.calculatedPayment;
            });
        }
    }, {
        key: 'getBestPaymentFrequency',
        value: function getBestPaymentFrequency() {
            if ((0, _lodash.isEmpty)(this.terms)) {
                return _paymentFrequencies.MONTHLY;
            }
            return this.terms[0].getBestPaymentFrequency();
        }
    }, {
        key: 'getAvailablePaymentFrequencies',
        value: function getAvailablePaymentFrequencies() {
            if ((0, _lodash.isEmpty)(this.terms) || !this.terms[0].term) {
                return [];
            }
            return this.terms[0].getAvailablePaymentFrequencies();
        }
    }, {
        key: 'getSelectedTermFrequency',
        value: function getSelectedTermFrequency() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.getPaymentFrequency() : '';
        }
    }, {
        key: 'getCalculatedPayment',
        value: function getCalculatedPayment() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.calculatedPayment : 0;
        }
    }, {
        key: 'getCashDown',
        value: function getCashDown() {
            var selectedTerm = this.getSelectedTerm();
            return selectedTerm ? selectedTerm.cashDown : 0;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getKMPlansDropDownValues',
        value: function getKMPlansDropDownValues(I18n) {
            return this.kmPlans.map(function (kmPlan) {
                return {
                    value: kmPlan.annualKMAllowed,
                    label: I18n.t('KM_PLANS.ANNUAL_KM_ALLOWED', { annualKMAllowed: kmPlan.annualKMAllowed })
                };
            });
        }
    }, {
        key: 'getKMPlan',
        value: function getKMPlan(annualKMAllowed) {
            return (0, _lodash.find)(this.kmPlans, function (kmPlan) {
                return kmPlan.annualKMAllowed === annualKMAllowed;
            });
        }
    }, {
        key: 'getDisclaimerParameters',
        value: function getDisclaimerParameters() {
            var selectedTerm = this.getSelectedTerm();
            if (!selectedTerm || !selectedTerm.term) {
                return null;
            }

            var term = selectedTerm.term,
                paymentFrequency = selectedTerm.paymentFrequency,
                cashDown = selectedTerm.cashDown;


            return {
                purchaseMethod: this.purchaseMethodValue,
                cashDown: cashDown,
                terms: [term],
                paymentFrequencies: [paymentFrequency]
            };
        }
    }, {
        key: 'hasValidTerms',
        get: function get() {
            return this.terms.length > 0 && this.terms[0].payment > 0;
        }
    }]);

    return Finance;
}(FinanceRecord);

exports.default = Finance;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/PaymentFrequencyModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentFrequencyRecord = (0, _immutable.Record)({
    paymentFrequency: _paymentFrequencies.MONTHLY,
    payment: 0,
    paymentTaxes: 0,
    financeFactor: 0,
    balloonFactor: 0,
    cashDownPaymentAdjustment: 0,
    netTradeInPaymentAdjustment: 0,
    netTradeInPaymentTaxesAdjustment: 0,
    calculatedNetPayment: 0,
    calculatedPayment: 0,
    disclaimers: []
});

var PaymentFrequency = function (_PaymentFrequencyReco) {
    _inherits(PaymentFrequency, _PaymentFrequencyReco);

    function PaymentFrequency() {
        _classCallCheck(this, PaymentFrequency);

        return _possibleConstructorReturn(this, (PaymentFrequency.__proto__ || Object.getPrototypeOf(PaymentFrequency)).apply(this, arguments));
    }

    _createClass(PaymentFrequency, [{
        key: 'getSelectionCode',
        value: function getSelectionCode() {
            return this.get('selectionCode');
        }
    }]);

    return PaymentFrequency;
}(PaymentFrequencyRecord);

exports.default = PaymentFrequency;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

var PaymentFrequencies = _interopRequireWildcard(_paymentFrequencies);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _FinanceModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _CashPurchaseModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

var _DisclaimersModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/DisclaimersModel.js");

var _DisclaimersModel2 = _interopRequireDefault(_DisclaimersModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint no-bitwise: 0 */

var MODEL_TRIM_OPTION_CODE = '_MT';

var PurchaseMethodsRecord = (0, _immutable.Record)({
    taxesIncluded: false,
    taxesFactor: 0,
    taxCodes: [],
    tradeIn: 0,
    lien: 0,
    exteriorColourRetail: 0.0,
    exteriorColourResidualRetail: 0.0,
    interiorColourRetail: 0.0,
    interiorColourResidualRetail: 0.0,
    optionsTotalRetail: 0.0,
    optionsTotalResidualRetail: 0.0,
    employeeRebateAdjustment: 0.0,
    highRebate: 0,
    highRebatePurchaseMethod: _purchaseMethodsValues2.default.CASH,
    finance: new _FinanceModel2.default(),
    lease: new _FinanceModel2.default(),
    cashPurchase: new _CashPurchaseModel2.default(),
    availableOptions: [],
    selectedOptions: [],
    configurationOptions: [],
    optionsSelectionResolutions: null,
    disclaimers: new _DisclaimersModel2.default()
});

function checkIsOption(option) {
    return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
}

var PurchaseMethods = function (_PurchaseMethodsRecor) {
    _inherits(PurchaseMethods, _PurchaseMethodsRecor);

    function PurchaseMethods(args) {
        _classCallCheck(this, PurchaseMethods);

        var newArgs = {};
        var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();

        if (windowProxy && windowProxy.localStorage) {
            var _windowProxy$localSto = windowProxy.localStorage,
                tradeIn = _windowProxy$localSto.tradeIn,
                lien = _windowProxy$localSto.lien;


            if (tradeIn) {
                var parseTradeIn = parseInt(tradeIn, 10);

                // eslint-disable-next-line no-restricted-globals
                newArgs.tradeIn = !isNaN(parseTradeIn) ? parseTradeIn : 0;
            }

            if (lien) {
                var parseLien = parseInt(lien, 10);

                // eslint-disable-next-line no-restricted-globals
                newArgs.lien = !isNaN(parseLien) ? parseLien : 0;
            }
        }

        return _possibleConstructorReturn(this, (PurchaseMethods.__proto__ || Object.getPrototypeOf(PurchaseMethods)).call(this, _extends({}, args, newArgs)));
    }

    _createClass(PurchaseMethods, [{
        key: 'getPaymentCalculationParameters',
        value: function getPaymentCalculationParameters() {
            var isLease = this.lease.selected;
            var selectedFinanceTerm = isLease ? this.lease.getSelectedTerm() : this.finance.getSelectedTerm();

            var taxesIncluded = this.taxesIncluded,
                taxesFactor = this.taxesFactor,
                tradeIn = this.tradeIn,
                lien = this.lien,
                exteriorColourRetail = this.exteriorColourRetail,
                exteriorColourResidualRetail = this.exteriorColourResidualRetail,
                interiorColourRetail = this.interiorColourRetail,
                interiorColourResidualRetail = this.interiorColourResidualRetail,
                optionsTotalRetail = this.optionsTotalRetail,
                optionsTotalResidualRetail = this.optionsTotalResidualRetail,
                dealerFeesTotalRetail = this.dealerFeesTotalRetail;


            return {
                isLease: isLease,
                selectedFinanceTerm: this.finance.selectedTerm,
                selectedLeaseTerm: this.lease.selectedTerm,
                paymentFrequency: selectedFinanceTerm ? selectedFinanceTerm.paymentFrequency : PaymentFrequencies.MONTHLY,
                taxesIncluded: taxesIncluded,
                taxesFactor: taxesFactor,
                cashDown: selectedFinanceTerm ? selectedFinanceTerm.cashDown : 0,
                tradeIn: tradeIn,
                lien: lien,
                exteriorColourRetail: exteriorColourRetail,
                exteriorColourResidualRetail: exteriorColourResidualRetail,
                interiorColourRetail: interiorColourRetail,
                interiorColourResidualRetail: interiorColourResidualRetail,
                optionsTotalRetail: optionsTotalRetail,
                optionsTotalResidualRetail: optionsTotalResidualRetail,
                dealerFeesTotalRetail: dealerFeesTotalRetail
            };
        }
    }, {
        key: 'getPaymentCalculationWithTerm',
        value: function getPaymentCalculationWithTerm(term) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (paymentCalculationParameters.isLease) {
                paymentCalculationParameters.selectedLeaseTerm = parseInt(term, 10);
            } else {
                paymentCalculationParameters.selectedFinanceTerm = parseInt(term, 10);
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithPaymentFrequency',
        value: function getPaymentCalculationWithPaymentFrequency(paymentFrequency) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.paymentFrequency = paymentFrequency;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTargetPayment',
        value: function getPaymentCalculationWithTargetPayment(targetPayment) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.targetPayment = (0, _lodash.isFinite)(targetPayment) ? targetPayment : 0;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithCashDown',
        value: function getPaymentCalculationWithCashDown(cashDown) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.cashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTradeIn',
        value: function getPaymentCalculationWithTradeIn(tradeIn) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.tradeIn = (0, _lodash.isFinite)(tradeIn) ? tradeIn : 0;
            if (paymentCalculationParameters.tradeIn === 0) {
                paymentCalculationParameters.lien = 0;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithLien',
        value: function getPaymentCalculationWithLien(lien) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (paymentCalculationParameters.tradeIn === 0) {
                paymentCalculationParameters.lien = 0;
            } else {
                paymentCalculationParameters.lien = (0, _lodash.isFinite)(lien) ? lien : 0;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithExteriorColour',
        value: function getPaymentCalculationWithExteriorColour(exteriorColourAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.exteriorColourRetail = (0, _lodash.isFinite)(exteriorColourAmounts.retail) ? exteriorColourAmounts.retail : 0;
            paymentCalculationParameters.exteriorColourResidualRetail = paymentCalculationParameters.exteriorColourRetail === 0 || !(0, _lodash.isFinite)(exteriorColourAmounts.residualRetail) ? 0 : exteriorColourAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithInteriorColour',
        value: function getPaymentCalculationWithInteriorColour(interiorColourAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.interiorColourRetail = (0, _lodash.isFinite)(interiorColourAmounts.retail) ? interiorColourAmounts.retail : 0;
            paymentCalculationParameters.interiorColourResidualRetail = paymentCalculationParameters.interiorColourRetail === 0 || !(0, _lodash.isFinite)(interiorColourAmounts.residualRetail) ? 0 : interiorColourAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithOptions',
        value: function getPaymentCalculationWithOptions(optionsAmounts) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            paymentCalculationParameters.optionsTotalRetail = (0, _lodash.isFinite)(optionsAmounts.retail) ? optionsAmounts.retail : 0;
            paymentCalculationParameters.optionsTotalResidualRetail = paymentCalculationParameters.optionsTotalRetail === 0 || !(0, _lodash.isFinite)(optionsAmounts.residualRetail) ? 0 : optionsAmounts.residualRetail;
            return paymentCalculationParameters;
        }
    }, {
        key: 'getPaymentCalculationWithTaxesIncluded',
        value: function getPaymentCalculationWithTaxesIncluded(taxesIncluded) {
            var paymentCalculationParameters = this.getPaymentCalculationParameters();
            if (!(0, _lodash.isBoolean)(taxesIncluded)) {
                paymentCalculationParameters.taxesIncluded = false;
            } else {
                paymentCalculationParameters.taxesIncluded = taxesIncluded;
            }
            return paymentCalculationParameters;
        }
    }, {
        key: 'getSelectedFinance',
        value: function getSelectedFinance() {
            if (this.lease.selected) {
                return this.lease;
            } else if (this.finance.selected) {
                return this.finance;
            }
            return '';
        }
    }, {
        key: 'getSelectedPurchaseMethodValue',
        value: function getSelectedPurchaseMethodValue() {
            if (this.lease.selected) {
                return this.lease.purchaseMethodValue;
            } else if (this.finance.selected) {
                return this.finance.purchaseMethodValue;
            }
            return this.cashPurchase.purchaseMethodValue;
        }
    }, {
        key: 'getSelectedPurchaseMethod',
        value: function getSelectedPurchaseMethod() {
            if (this.lease.selected) {
                return this.lease.purchaseMethod;
            } else if (this.finance.selected) {
                return this.finance.purchaseMethod;
            }
            return this.cashPurchase.purchaseMethod;
        }
    }, {
        key: 'getSelectedPurchaseMethodIsValid',
        value: function getSelectedPurchaseMethodIsValid() {
            var finance = this.finance,
                lease = this.lease;

            if (finance.selected && (finance.terms.length === 0 || finance.terms.length === 1 && finance.terms[0].term === 0) || lease.selected && (lease.terms.length === 0 || lease.terms.length === 1 && lease.terms[0].term === 0)) {
                return false;
            }
            return true;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getPurchaseMethodLabels',
        value: function getPurchaseMethodLabels(I18n) {
            var purchaseMethodLabels = {
                name: I18n.t('purchaseMethods.cashPurchase'),
                verb: I18n.t('purchaseMethods.cashPurchaseVerb')
            };

            if (this.lease.selected) {
                purchaseMethodLabels.name = I18n.t('purchaseMethods.lease');
                purchaseMethodLabels.verb = I18n.t('purchaseMethods.leaseVerb');
            } else if (this.finance.selected) {
                purchaseMethodLabels.name = I18n.t('purchaseMethods.finance');
                purchaseMethodLabels.verb = I18n.t('purchaseMethods.financeVerb');
            }

            return purchaseMethodLabels;
        }
    }, {
        key: 'getSelectedFinanceTerm',
        value: function getSelectedFinanceTerm() {
            var selectedFinanceTerm = void 0;
            if (this.lease.selected) {
                selectedFinanceTerm = this.lease.getSelectedTerm();
            } else if (this.finance.selected) {
                selectedFinanceTerm = this.finance.getSelectedTerm();
            }

            return selectedFinanceTerm;
        }
    }, {
        key: 'getFinancesBestPaymentFrequency',
        value: function getFinancesBestPaymentFrequency() {
            var financeBestPaymentFrequency = this.finance.getBestPaymentFrequency();
            var leaseBestPaymentFrequency = this.lease.getBestPaymentFrequency();
            return financeBestPaymentFrequency < leaseBestPaymentFrequency ? financeBestPaymentFrequency : leaseBestPaymentFrequency;
        }
    }, {
        key: 'getFinancesAvailablePaymentFrequencies',
        value: function getFinancesAvailablePaymentFrequencies() {
            var financePaymentFrequencies = this.finance.getAvailablePaymentFrequencies();
            var leasePaymentFrequencies = this.lease.getAvailablePaymentFrequencies();

            if (!(0, _lodash.isEmpty)(financePaymentFrequencies) && !(0, _lodash.isEmpty)(leasePaymentFrequencies)) {
                return (0, _lodash.intersection)(financePaymentFrequencies, leasePaymentFrequencies);
            } else if ((0, _lodash.isEmpty)(financePaymentFrequencies) && (0, _lodash.isEmpty)(leasePaymentFrequencies)) {
                return [PaymentFrequencies.MONTHLY];
            }
            return (0, _lodash.union)(financePaymentFrequencies, leasePaymentFrequencies);
        }
    }, {
        key: 'getSelectedFinancePaymentFrequency',
        value: function getSelectedFinancePaymentFrequency() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.paymentFrequency : PaymentFrequencies.MONTHLY;
        }
    }, {
        key: 'getSelectedFinanceTermValue',
        value: function getSelectedFinanceTermValue() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.term : 0;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getPaymentFrequencyLabels',
        value: function getPaymentFrequencyLabels(allFinances, I18n) {
            var paymentFrequencyLabels = {
                periodically: '',
                perPeriod: ''
            };

            var selectedFinanceTerm = this.getSelectedFinanceTerm() || allFinances && this.finance.getSelectedTerm();
            if (!selectedFinanceTerm) {
                return paymentFrequencyLabels;
            }

            switch (selectedFinanceTerm.paymentFrequency) {
                case PaymentFrequencies.WEEKLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.weekly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perWeek');
                    break;
                case PaymentFrequencies.BI_WEEKLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.biWeekly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perBiWeek');
                    break;
                case PaymentFrequencies.SEMI_MONTHLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.semiMonthly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perSemiMonth');
                    break;
                case PaymentFrequencies.MONTHLY:
                    paymentFrequencyLabels.periodically = I18n.t('paymentFrequencies.monthly');
                    paymentFrequencyLabels.perPeriod = I18n.t('paymentFrequencies.perMonth');
                    break;
                default:
                    break;
            }

            return paymentFrequencyLabels;
        }
    }, {
        key: 'getBestPaymentFinance',
        value: function getBestPaymentFinance() {
            var leasePayment = this.lease.getCalculatedPayment();
            var financePayment = this.finance.getCalculatedPayment();

            return leasePayment > 0 && leasePayment < financePayment ? this.lease.purchaseMethodValue : this.finance.purchaseMethodValue;
        }
    }, {
        key: 'getBestPaymentTerm',
        value: function getBestPaymentTerm(maximumTerm) {
            var selectedFinance = this.getSelectedFinance();
            return selectedFinance ? selectedFinance.getBestPaymentTerm(maximumTerm) : undefined;
        }
    }, {
        key: 'getOrderValue',
        value: function getOrderValue(purchaseMethodValue) {
            var cashRetail = this.cashPurchase.getRetail();

            // we're using cashRetail value here if there's no calculatedPayment
            // so it will be sorted at the end of the list as it's a high value
            var leasePayment = this.lease.getCalculatedPayment() || cashRetail;
            var financePayment = this.finance.getCalculatedPayment() || cashRetail;

            switch (purchaseMethodValue) {
                case _purchaseMethodsValues2.default.LEASE:
                    return leasePayment;

                case _purchaseMethodsValues2.default.FINANCE:
                    return financePayment;

                case _purchaseMethodsValues2.default.FINANCE | _purchaseMethodsValues2.default.LEASE:
                    return this.getBestPaymentFinance() === _purchaseMethodsValues2.default.LEASE ? leasePayment : financePayment;

                default:
                    return cashRetail;
            }
        }
    }, {
        key: 'getTaxCodesString',
        value: function getTaxCodesString() {
            return (0, _lodash.isEmpty)(this.taxCodes) ? '' : this.taxCodes.join(' / ');
        }
    }, {
        key: 'getCashDownFromTargetPayment',
        value: function getCashDownFromTargetPayment(targetPayment) {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm || (0, _lodash.isEmpty)(selectedFinanceTerm.paymentFrequencies) || (0, _lodash.isUndefined)(selectedFinanceTerm.paymentFrequencies[selectedFinanceTerm.paymentFrequency])) {
                return 0;
            }

            var currentPaymentFrequency = selectedFinanceTerm.paymentFrequencies[selectedFinanceTerm.paymentFrequency];
            var financeFactor = currentPaymentFrequency.financeFactor;

            if (financeFactor <= 0) {
                return 0;
            }

            var netPayment = selectedFinanceTerm.get('calculatedNetPayment');
            // eslint-disable-next-line no-restricted-globals
            var targetPaymentValue = isNaN(targetPayment) ? 0 : targetPayment;

            var targetCashdown = (netPayment - targetPaymentValue) / financeFactor;
            if (targetCashdown < 0 || Math.round(targetCashdown) === 0) {
                targetCashdown = 0;
            }
            return targetCashdown;
        }

        // I18n argument is the LocalService class to translate

    }, {
        key: 'getSelectedFinanceKMPlanParameters',
        value: function getSelectedFinanceKMPlanParameters(I18n) {
            var selectedFinance = this.getSelectedFinance();

            var kmPlanOptions = void 0;
            var selectedKMPlan = void 0;
            if (selectedFinance) {
                kmPlanOptions = selectedFinance.getKMPlansDropDownValues(I18n);
                selectedKMPlan = (0, _lodash.find)(kmPlanOptions, { value: selectedFinance.annualKMAllowed });
            }

            return selectedFinance ? {
                annualKMAllowed: selectedFinance.annualKMAllowed,
                endTermKMCost: selectedFinance.endTermKMCost,
                kmPlanOptions: kmPlanOptions,
                selectedKMPlan: selectedKMPlan
            } : {
                annualKMAllowed: 0,
                endTermKMCost: 0,
                kmPlanOptions: '',
                selectedKMPlan: ''
            };
        }
    }, {
        key: 'getSelectedFinanceCalculatedPayments',
        value: function getSelectedFinanceCalculatedPayments() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm) {
                return {
                    calculatedPaymentBeforeTaxes: 0,
                    calculatedPaymentTaxes: 0,
                    calculatedPayment: 0,
                    minimumPayment: 0,
                    maximumPayment: 0
                };
            }

            var calculatedPayments = selectedFinanceTerm.getCalculatedPayments(this.taxesIncluded);
            return {
                calculatedPaymentBeforeTaxes: calculatedPayments.calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes: calculatedPayments.calculatedPaymentTaxes,
                calculatedPayment: calculatedPayments.calculatedPayment,
                minimumPayment: 0,
                maximumPayment: selectedFinanceTerm.calculatedNetPayment
            };
        }
    }, {
        key: 'getSelectedFinanceCashDown',
        value: function getSelectedFinanceCashDown() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.cashDown : 0;
        }
    }, {
        key: 'getSelectedFinanceRebateTaxesAtDelivery',
        value: function getSelectedFinanceRebateTaxesAtDelivery() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesTaxesAtDelivery : 0;
        }
    }, {
        key: 'getSelectedRebatesAtStandardRate',
        value: function getSelectedRebatesAtStandardRate() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesAtStandardRate : 0;
        }
    }, {
        key: 'getSelectedPurchaseMethodDiscounts',
        value: function getSelectedPurchaseMethodDiscounts() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.discounts : this.cashPurchase.discounts + this.cashPurchase.optionsAdjustmentDiscounts;
        }
    }, {
        key: 'getSelectedPurchaseMethodRebates',
        value: function getSelectedPurchaseMethodRebates() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebates + selectedFinanceTerm.rebatesTaxes : this.cashPurchase.rebates + this.cashPurchase.rebatesTaxes;
        }
    }, {
        key: 'getSelectedPurchaseMethodRebatesTaxes',
        value: function getSelectedPurchaseMethodRebatesTaxes() {
            var isLease = this.lease.selected;
            if (isLease) {
                return 0;
            }
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            return selectedFinanceTerm ? selectedFinanceTerm.rebatesTaxes : this.cashPurchase.rebatesTaxes;
        }
    }, {
        key: 'getCashPurchaseAmounts',
        value: function getCashPurchaseAmounts() {
            var msrp = this.cashPurchase.getRetail();
            var taxes = msrp * this.taxesFactor;

            var rebates = 0;
            var dealerDiscounts = 0;
            var freightPDI = 0;
            var taxAndDuty = 0;
            var allSelectedOptions = this.getAllSelectedOptions();
            if (!(0, _lodash.isEmpty)(allSelectedOptions)) {
                rebates = this.getRebatesAmount(allSelectedOptions) + this.getDiscountsAmount(allSelectedOptions);
                dealerDiscounts = this.getDealerDiscountsAmount(allSelectedOptions);
                if (!rebates) {
                    rebates = this.cashPurchase.getTotalRebates();
                }

                freightPDI = this.getFreightAndPDIFeesAmount(allSelectedOptions, false);
                taxAndDuty = this.getTaxesAndDutiesAmount(allSelectedOptions, false) + this.getOtherFeesAmount(allSelectedOptions, false) + this.cashPurchase.dealerFees;
            } else {
                rebates = this.cashPurchase.getTotalRebates();
            }
            rebates += this.employeeRebateAdjustment;

            msrp -= freightPDI;
            msrp -= taxAndDuty;
            msrp -= rebates;

            return {
                msrp: msrp,
                rebates: rebates,
                dealerDiscounts: dealerDiscounts,
                freightPDI: freightPDI,
                taxAndDuty: taxAndDuty,
                taxes: taxes
            };
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getPurchaseMethodSelectedOptions',
        value: function getPurchaseMethodSelectedOptions(includeCashPurchaseOnlyDiscount) {
            return this.cashPurchase.selected ? this.selectedOptions : (0, _lodash.filter)(this.selectedOptions, function (selectedOption) {
                return includeCashPurchaseOnlyDiscount || !selectedOption.isDealerCashPurchaseOnlyDiscount();
            });
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getAllSelectedOptions',
        value: function getAllSelectedOptions(includeCashPurchaseOnlyDiscount) {
            return (0, _lodash.unionBy)(this.configurationOptions, this.getPurchaseMethodSelectedOptions(includeCashPurchaseOnlyDiscount), 'selectionCode');
        }
    }, {
        key: 'getNonConfigurationSelectedOptions',
        value: function getNonConfigurationSelectedOptions() {
            return (0, _lodash.differenceBy)(this.getPurchaseMethodSelectedOptions(), this.configurationOptions, 'selectionCode');
        }
    }, {
        key: 'getSelectedPurchaseMethodAmounts',
        value: function getSelectedPurchaseMethodAmounts() {
            var tradeIn = this.tradeIn,
                lien = this.lien;

            var cashDown = this.getSelectedFinanceCashDown();

            var modelTrim = this.cashPurchase.retail - this.cashPurchase.pricingAmounts.freightPDI - this.cashPurchase.pricingAmounts.taxesAndDuties;
            var exteriorColour = 0;
            var interiorColour = 0;
            var options = this.cashPurchase.optionsAdjustment;
            var discounts = this.getSelectedPurchaseMethodDiscounts() + this.employeeRebateAdjustment;
            var rebates = this.getSelectedPurchaseMethodRebates();
            var rebatesTaxes = this.getSelectedPurchaseMethodRebatesTaxes();
            var freightPDI = this.cashPurchase.pricingAmounts.freightPDI;

            var otherFees = 0;
            var taxAndDuty = this.cashPurchase.pricingAmounts.taxesAndDuties;
            var protections = 0;

            var taxes = this.getSelectedPurchaseMethodValue() === _purchaseMethodsValues2.default.LEASE ? 0 : this.getRoundedAmount(this.taxesFactor * (modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + this.tradeIn)));

            if (this.cashPurchase.retailAdjustment) {
                modelTrim -= this.cashPurchase.retailAdjustment;
            }

            var allSelectedOptions = this.getAllSelectedOptions();
            if ((0, _lodash.isEmpty)(allSelectedOptions) || this.hasOnlyModelTrimOption(allSelectedOptions)) {
                return {
                    modelTrim: modelTrim,
                    exteriorColour: exteriorColour,
                    interiorColour: interiorColour,
                    options: options,
                    discounts: discounts,
                    freightPDI: freightPDI,
                    otherFees: otherFees,
                    taxAndDuty: taxAndDuty,
                    rebates: rebates,
                    protections: protections,
                    taxes: taxes < 0 ? 0 : taxes,
                    tradeIn: tradeIn,
                    lien: lien,
                    cashDown: cashDown
                };
            }
            var configurationOptionsDiscounts = (0, _lodash.isEmpty)(this.configurationOptions) ? 0 : discounts;

            modelTrim = this.getModelTrimAmount(allSelectedOptions);
            exteriorColour = this.getExteriorColourAmount(allSelectedOptions);
            interiorColour = this.getInteriorColourAmount(allSelectedOptions);
            options = this.getOptionsAmount(allSelectedOptions) + this.getOptionsAmountIncludedInPrice(allSelectedOptions);
            var discountsFromOptions = this.getDiscountsAmount(allSelectedOptions) + this.getDealerDiscountsAmount(allSelectedOptions);
            discounts = discountsFromOptions > 0 ? discountsFromOptions + configurationOptionsDiscounts : discounts;
            var rebatesFromOptions = this.getRebatesAmount(allSelectedOptions);
            rebates = rebatesFromOptions > 0 ? rebatesFromOptions + rebatesTaxes : rebates;
            freightPDI = this.getFreightAndPDIFeesAmount(allSelectedOptions, false);
            otherFees = this.getOtherFeesAmount(allSelectedOptions, false);
            taxAndDuty = this.getTaxesAndDutiesAmount(allSelectedOptions, false);
            protections = this.getProtectionsAmount(allSelectedOptions);

            taxes = this.getSelectedPurchaseMethodValue() === _purchaseMethodsValues2.default.LEASE ? 0 : this.getRoundedAmount(this.taxesFactor * (modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + this.tradeIn)));

            return {
                modelTrim: modelTrim,
                exteriorColour: exteriorColour,
                interiorColour: interiorColour,
                options: options,
                discounts: discounts,
                freightPDI: freightPDI,
                otherFees: otherFees,
                taxAndDuty: taxAndDuty,
                rebates: rebates,
                protections: protections,
                taxes: taxes < 0 ? 0 : taxes,
                tradeIn: tradeIn,
                lien: lien,
                cashDown: cashDown
            };
        }
    }, {
        key: 'getSelectedPurchaseMethodResidualAmounts',
        value: function getSelectedPurchaseMethodResidualAmounts() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();

            return selectedFinanceTerm ? selectedFinanceTerm.residualAmount + selectedFinanceTerm.optionsResidualRetail * (selectedFinanceTerm.residualRate / 100) : 0;
        }
    }, {
        key: 'getSelectedPurchaseMethodDeliveryAmounts',
        value: function getSelectedPurchaseMethodDeliveryAmounts() {
            var allSelectedOptions = this.getAllSelectedOptions();
            var deliveryFees = this.getFreightAndPDIFeesAmount(allSelectedOptions, true) + this.getTaxesAndDutiesAmount(allSelectedOptions, true) + this.getOtherFeesAmount(allSelectedOptions, true);
            var deliveryCashDown = this.getSelectedFinanceCashDown();
            var deliveryRebatesTaxes = this.getSelectedFinanceRebateTaxesAtDelivery();
            var deliveryTaxes = this.lease.selected ? this.getRoundedAmount(this.taxesFactor * (deliveryFees + deliveryCashDown)) : this.getRoundedAmount(this.taxesFactor * deliveryFees);

            var deposit = this.getDepositAmount(allSelectedOptions);

            var _getSelectedFinanceCa = this.getSelectedFinanceCalculatedPayments(),
                calculatedPayment = _getSelectedFinanceCa.calculatedPayment;

            var upfrontPayment = this.lease.selected ? calculatedPayment : 0;

            return {
                deliveryFees: deliveryFees,
                deliveryCashDown: deliveryCashDown,
                deliveryTaxes: deliveryTaxes,
                deliveryRebatesTaxes: deliveryRebatesTaxes,
                deposit: deposit,
                upfrontPayment: upfrontPayment
            };
        }
    }, {
        key: 'getRoundedAmount',
        value: function getRoundedAmount(amount) {
            return Math.round(amount * 100) / 100;
        }
    }, {
        key: 'getModelTrimAmount',
        value: function getModelTrimAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID >= dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM && option.typeID <= dataTypes.DATA_TYPES.FEATURE.TYPES.TRANSMISSION ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDiscountsAmount',
        value: function getDiscountsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && option.typeID !== dataTypes.DATA_TYPES.REBATE.TYPES.DAA_CASH_DOWN && option.isTaxable && !option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getExteriorColourAmount',
        value: function getExteriorColourAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getExteriorColourResidualizingAmount',
        value: function getExteriorColourResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getInteriorColourAmount',
        value: function getInteriorColourAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getInteriorColourResidualizingAmount',
        value: function getInteriorColourResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getOptionsAmount',
        value: function getOptionsAmount(options) {
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();

            var res = void 0;

            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                if (isShowroomV25Enabled) {
                    res = sum + (checkIsOption(option) && option.isIncludedInPriceOrPayment === false ? option.retail : 0);
                } else {
                    res = sum + (checkIsOption(option) && option.supplier !== 'D' ? option.retail : 0);
                }
                return res;
            }, 0));
        }
    }, {
        key: 'getOptionsAmountIncludedInPrice',
        value: function getOptionsAmountIncludedInPrice(options) {
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();

            var res = void 0;

            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                if (isShowroomV25Enabled) {
                    res = sum + (checkIsOption(option) && option.isIncludedInPriceOrPayment === true ? option.retail : 0);
                } else {
                    res = 0;
                }
                return res;
            }, 0));
        }
    }, {
        key: 'getOptionsResidualizingAmount',
        value: function getOptionsResidualizingAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM) ? option.residualizingAmount : 0);
            }, 0));
        }
    }, {
        key: 'getRebatesAmount',
        value: function getRebatesAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && option.typeID !== dataTypes.DATA_TYPES.REBATE.TYPES.DAA_CASH_DOWN && !option.isTaxable && !option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getFreightAndPDIFeesAmount',
        value: function getFreightAndPDIFeesAmount(options, dueAtDelivery) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && (option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.FREIGHT || option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION) ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getOtherFeesAmount',
        value: function getOtherFeesAmount(options, dueAtDelivery) {
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                if (isShowroomV25Enabled) {
                    return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
                }
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && (option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT || checkIsOption(option) && option.supplier === 'D') ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getOtherFeesAmountIncluded',
        value: function getOtherFeesAmountIncluded(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (!option.dueAtDelivery && option.isIncludedInPriceOrPayment && option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID > dataTypes.DATA_TYPES.FEE.TYPES.PREPARATION && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT && option.typeID !== dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getProtectionsAmountIncluded',
        value: function getProtectionsAmountIncluded(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (!option.dueAtDelivery && option.isIncludedInPriceOrPayment && option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getTaxesAndDutiesAmount',
        value: function getTaxesAndDutiesAmount(options, dueAtDelivery) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + ((dueAtDelivery && option.dueAtDelivery || !dueAtDelivery && !option.dueAtDelivery) && option.dataType === dataTypes.DATA_TYPES.TAX_AND_DUTY.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getProtectionsAmount',
        value: function getProtectionsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDealerDiscountsAmount',
        value: function getDealerDiscountsAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.isDealerDiscount() ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getSelectedPurchaseMethodRetailOrPayment',
        value: function getSelectedPurchaseMethodRetailOrPayment() {
            var selectedFinanceTerm = this.getSelectedFinanceTerm();
            if (!selectedFinanceTerm) {
                return this.cashPurchase.getRetail() - this.cashPurchase.getTotalRebates();
            }
            return selectedFinanceTerm.calculatedPayment;
        }
    }, {
        key: 'getTradeInWithTaxCredits',
        value: function getTradeInWithTaxCredits() {
            return this.tradeIn + this.cashPurchase.tradeInTaxesAdjustment;
        }
    }, {
        key: 'getDepositAmount',
        value: function getDepositAmount(options) {
            return this.getRoundedAmount((0, _lodash.reduce)(options, function (sum, option) {
                return sum + (option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT || option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT ? option.retail : 0);
            }, 0));
        }
    }, {
        key: 'getDeliveryFee',
        value: function getDeliveryFee() {
            var fee = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.DELIVERY;
            });

            if (!fee) {
                fee = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.DELIVERY;
                });
            }
            return fee;
        }
    }, {
        key: 'getCheckoutDeposit',
        value: function getCheckoutDeposit() {
            var deposit = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT;
            });

            if (!deposit) {
                deposit = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.CHECKOUT_DEPOSIT;
                });
            }
            return deposit;
        }
    }, {
        key: 'getReservationDeposit',
        value: function getReservationDeposit() {
            var deposit = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT;
            });

            if (!deposit) {
                deposit = (0, _lodash.find)(this.availableOptions, function (option) {
                    return option.dataType === dataTypes.DATA_TYPES.FEE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEE.TYPES.RESERVATION_DEPOSIT;
                });
            }
            return deposit;
        }
    }, {
        key: 'getSelectedExteriorColourCode',
        value: function getSelectedExteriorColourCode() {
            var selectedOption = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR;
            });
            return selectedOption ? selectedOption.code : '';
        }
    }, {
        key: 'getSelectedInteriorColourCode',
        value: function getSelectedInteriorColourCode() {
            var selectedOption = (0, _lodash.find)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM;
            });
            return selectedOption ? selectedOption.code : '';
        }
    }, {
        key: 'getSelectedOptionsPackage',
        value: function getSelectedOptionsPackage() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.PACKAGE;
            });
        }
    }, {
        key: 'getSelectedOptions',
        value: function getSelectedOptions() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
            });
        }
    }, {
        key: 'getSelectedProtections',
        value: function getSelectedProtections() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
            });
        }
    }, {
        key: 'getSelectedProtectionsPackages',
        value: function getSelectedProtectionsPackages() {
            var selectedProtections = this.getSelectedProtections();
            var selectedProtectionsPackages = (0, _lodash.filter)(selectedProtections, function (protection) {
                return !(0, _lodash.isEmpty)(protection.includedCodes);
            });
            if ((0, _lodash.isEmpty)(selectedProtectionsPackages)) {
                return selectedProtections;
            }

            var includedCodes = (0, _lodash.flatten)((0, _lodash.map)(selectedProtectionsPackages, function (protection) {
                return [].concat(_toConsumableArray(protection.includedCodes), [protection.selectionCode]);
            }));

            var selectedSingleProtections = (0, _lodash.filter)(selectedProtections, function (protection) {
                return !(0, _lodash.includes)(includedCodes, protection.selectionCode);
            });
            var packagedProtections = (0, _lodash.filter)(selectedProtections, function (protection) {
                return (0, _lodash.includes)(includedCodes, protection.selectionCode);
            });

            var selectedPackagedProtections = [];
            (0, _lodash.forEach)(selectedProtectionsPackages, function (protectionsPackage) {
                var packageIncludedProtections = (0, _lodash.filter)(packagedProtections, function (protection) {
                    return (0, _lodash.includes)(protectionsPackage.includedCodes, protection.selectionCode);
                });

                var packageDescription = (0, _lodash.isEmpty)(packageIncludedProtections) ? protectionsPackage.description : (0, _lodash.join)((0, _lodash.map)(packageIncludedProtections, function (protection) {
                    return protection.label;
                }), ', ');

                var packageIncludedProtectionsRetail = (0, _lodash.sumBy)(packageIncludedProtections, function (protection) {
                    return protection.retail;
                });
                var packageIncludedProtectionsResidual = (0, _lodash.sumBy)(packageIncludedProtections, function (protection) {
                    return protection.residualizingAmount;
                });

                selectedPackagedProtections.push(protectionsPackage.set('description', packageDescription).set('retail', protectionsPackage.retail + packageIncludedProtectionsRetail).set('residualizingAmount', protectionsPackage.residualizingAmount + packageIncludedProtectionsResidual));
            });

            return (0, _lodash.orderBy)((0, _lodash.concat)(selectedPackagedProtections, selectedSingleProtections), 'keyOrder');
        }
    }, {
        key: 'getSelectedOptionsAndColours',
        value: function getSelectedOptionsAndColours() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && (option.typeID < dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM || option.typeID > dataTypes.DATA_TYPES.FEATURE.TYPES.TRANSMISSION);
            });
        }
    }, {
        key: 'getSelectedDealerFees',
        value: function getSelectedDealerFees() {
            return (0, _lodash.filter)(this.getAllSelectedOptions(), function (option) {
                return option.isDealerFee();
            });
        }

        // The includeCashPurchaseOnlyDiscount flag is used to enforce the inclusion of the cash only dealer discount

    }, {
        key: 'getSelectedDealerDiscounts',
        value: function getSelectedDealerDiscounts(includeCashPurchaseOnlyDiscount) {
            return (0, _lodash.filter)(this.getAllSelectedOptions(includeCashPurchaseOnlyDiscount), function (option) {
                return option.isDealerDiscount();
            });
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var selectedTerm = this.getSelectedFinanceTerm();
            var electricRebate = void 0;
            if (selectedTerm) {
                electricRebate = selectedTerm.getElectricRebate();
            }
            return (0, _lodash.isEmpty)(electricRebate) ? this.cashPurchase.getElectricRebate() : electricRebate;
        }
    }, {
        key: 'getBonusRebate',
        value: function getBonusRebate() {
            var bonusRebate = {
                amount: 0,
                cashPurchase: false,
                lease: false,
                finance: false
            };

            var leaseSelectedTerm = this.lease.getSelectedTerm();
            if (leaseSelectedTerm && leaseSelectedTerm.rebatesAtDelivery > 0) {
                bonusRebate.amount = leaseSelectedTerm.rebatesAtDelivery;
                bonusRebate.lease = true;
            }

            var financeSelectedTerm = this.finance.getSelectedTerm();
            if (financeSelectedTerm && financeSelectedTerm.rebatesAtDelivery > 0) {
                bonusRebate.amount = bonusRebate.amount > financeSelectedTerm.rebatesAtDelivery ? financeSelectedTerm.rebatesAtDelivery : bonusRebate.amount;
                bonusRebate.finance = true;
            }

            if (this.cashPurchase.rebatesAtDelivery > 0) {
                bonusRebate.amount = bonusRebate.amount > this.cashPurchase.rebatesAtDelivery ? this.cashPurchase.rebatesAtDelivery : bonusRebate.amount;
                bonusRebate.cashPurchase = true;
            }

            return bonusRebate;
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var selectedTerm = this.getSelectedFinanceTerm();
            return selectedTerm ? selectedTerm.getEmployeeRebate() : this.cashPurchase.getEmployeeRebate();
        }
    }, {
        key: 'getDisclaimerParameters',
        value: function getDisclaimerParameters() {
            var cashPurchase = this.cashPurchase,
                finance = this.finance,
                lease = this.lease;


            var cashPurchaseDisclaimer = {
                purchaseMethod: cashPurchase.purchaseMethodValue,
                terms: [0],
                frequencies: [0]
            };
            var financeDisclaimer = finance.getDisclaimerParameters();
            var leaseDisclaimer = lease.getDisclaimerParameters();

            var disclaimerParameters = [cashPurchaseDisclaimer];
            if (!(0, _lodash.isNull)(financeDisclaimer)) {
                disclaimerParameters.push(financeDisclaimer);
            }
            if (!(0, _lodash.isNull)(leaseDisclaimer)) {
                disclaimerParameters.push(leaseDisclaimer);
            }

            return disclaimerParameters;
        }
    }, {
        key: 'getDisclaimersForCurrentMethod',
        value: function getDisclaimersForCurrentMethod() {
            var disclaimers = this.disclaimers;

            switch (this.getSelectedPurchaseMethodValue()) {
                case _purchaseMethodsValues2.default.FINANCE:
                    return disclaimers.finance;
                case _purchaseMethodsValues2.default.LEASE:
                    return disclaimers.lease;
                case _purchaseMethodsValues2.default.CASH:
                    return disclaimers.cashPurchase;
                default:
                    return null;
            }
        }
    }, {
        key: 'hasOnlyModelTrimOption',
        value: function hasOnlyModelTrimOption(options) {
            return options && options.length === 1 && options[0].code === MODEL_TRIM_OPTION_CODE;
        }
    }]);

    return PurchaseMethods;
}(PurchaseMethodsRecord);

exports.default = PurchaseMethods;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/models/TermModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _immutable = __webpack_require__("immutable");

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TermRecord = (0, _immutable.Record)({
    term: 0,
    termIndex: 0,
    apr: 0,
    residualRate: 0,
    cashDown: 0,
    discounts: 0,
    rebates: 0,
    rebatesTaxes: 0,
    rebatesAtDelivery: 0,
    rebatesTaxesAtDelivery: 0,
    rebatesAtStandardRate: 0,
    paymentFrequencies: {},
    paymentFrequency: _paymentFrequencies.MONTHLY,
    payment: 0,
    paymentTaxes: 0,
    financedAmount: 0,
    financedAmountWithTaxes: 0,
    financedAmountAdjustment: 0,
    financedAmountWithTaxesAdjustment: 0,
    residualAmount: 0,
    optionsResidualRetail: 0,
    optionsPaymentAdjustment: 0,
    optionsPaymentTaxesAdjustment: 0,
    cashDownPaymentAdjustment: 0,
    netTradeInPaymentAdjustment: 0,
    netTradeInPaymentTaxesAdjustment: 0,
    calculatedNetPayment: 0,
    calculatedPayment: 0,
    includedItemsCodes: [],
    rebatesDetails: []
});

var Term = function (_TermRecord) {
    _inherits(Term, _TermRecord);

    function Term() {
        _classCallCheck(this, Term);

        return _possibleConstructorReturn(this, (Term.__proto__ || Object.getPrototypeOf(Term)).apply(this, arguments));
    }

    _createClass(Term, [{
        key: 'calculatePaymentAdjustment',
        value: function calculatePaymentAdjustment(financedAmount, residualRetailAmount) {
            var currentPaymentFrequency = this.paymentFrequencies[this.paymentFrequency];
            var residualAmount = residualRetailAmount * (this.residualRate / 100);

            return currentPaymentFrequency ? financedAmount * currentPaymentFrequency.financeFactor + residualAmount * currentPaymentFrequency.balloonFactor : 0;
        }
    }, {
        key: 'getBestPaymentFrequency',
        value: function getBestPaymentFrequency() {
            if ((0, _lodash.isEmpty)(this.paymentFrequencies)) {
                return _paymentFrequencies.MONTHLY;
            }
            var frequencies = (0, _lodash.values)(this.paymentFrequencies);
            return (0, _lodash.maxBy)(frequencies, 'paymentFrequency').paymentFrequency;
        }
    }, {
        key: 'getAvailablePaymentFrequencies',
        value: function getAvailablePaymentFrequencies() {
            if ((0, _lodash.isEmpty)(this.paymentFrequencies)) {
                return [_paymentFrequencies.MONTHLY];
            }
            var frequencies = (0, _lodash.values)(this.paymentFrequencies);
            return (0, _lodash.orderBy)((0, _lodash.map)(frequencies, function (frequency) {
                return frequency.paymentFrequency;
            }), ['paymentFrequency'], ['desc']);
        }
    }, {
        key: 'getPaymentFrequency',
        value: function getPaymentFrequency() {
            return this.paymentFrequencies[this.paymentFrequency];
        }
    }, {
        key: 'getCalculatedPayments',
        value: function getCalculatedPayments(taxesIncluded) {
            var calculatedPaymentRounded = Math.round(this.calculatedPayment * 100) / 100;
            var calculatedPaymentTaxes = Math.round((this.paymentTaxes + this.optionsPaymentTaxesAdjustment - this.netTradeInPaymentTaxesAdjustment) * 100) / 100;
            var calculatedPaymentBeforeTaxes = taxesIncluded ? calculatedPaymentRounded - calculatedPaymentTaxes : calculatedPaymentRounded;

            return {
                calculatedPaymentBeforeTaxes: calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes: calculatedPaymentTaxes,
                calculatedPayment: calculatedPaymentBeforeTaxes + calculatedPaymentTaxes
            };
        }
    }, {
        key: 'getFinancedAmount',
        value: function getFinancedAmount() {
            return this.financedAmount;
        }
    }, {
        key: 'getDiscountsAndRebates',
        value: function getDiscountsAndRebates() {
            return this.discounts + this.rebates;
        }
    }, {
        key: 'getDisclaimerAmounts',
        value: function getDisclaimerAmounts(taxesIncluded, financedAmountAdjustment, residualAmountAdjustment) {
            var calculatedPayments = this.getCalculatedPayments(false);
            var paymentsCount = this.term * this.paymentFrequency / _paymentFrequencies.MONTHLY;
            var financedAmount = (taxesIncluded ? this.financedAmountWithTaxes + this.financedAmountWithTaxesAdjustment : this.financedAmount + this.financedAmountAdjustment) + financedAmountAdjustment;
            var residualAmount = this.residualAmount + residualAmountAdjustment;

            var totalObligation = (taxesIncluded ? calculatedPayments.calculatedPayment : calculatedPayments.calculatedPaymentBeforeTaxes) * paymentsCount + residualAmount;
            var costOfCredit = totalObligation < financedAmount ? 0 : totalObligation - financedAmount;

            return {
                totalObligation: totalObligation,
                costOfCredit: costOfCredit,
                residualAmount: residualAmount
            };
        }
    }, {
        key: 'getElectricRebate',
        value: function getElectricRebate() {
            var electricRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.ELECTRIC;
            });

            if ((0, _lodash.isEmpty)(electricRebates)) {
                return null;
            }

            return {
                description: electricRebates[0].description,
                rebate: (0, _lodash.sumBy)(electricRebates, function (electricRebate) {
                    return electricRebate.amount;
                })
            };
        }
    }, {
        key: 'getEmployeeRebate',
        value: function getEmployeeRebate() {
            var employeeRebates = (0, _lodash.filter)(this.rebatesDetails, function (rebateDetails) {
                return rebateDetails.typeId === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
            });

            if ((0, _lodash.isEmpty)(employeeRebates)) {
                return null;
            }

            return {
                description: employeeRebates[0].description,
                rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
                    return employeeRebate.amount;
                })
            };
        }
    }]);

    return Term;
}(TermRecord);

exports.default = Term;

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/reducers/purchaseMethodsReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = purchaseMethodReducer;

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActionTypes = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var purchaseMethodsTypes = _interopRequireWildcard(_purchaseMethodsActionTypes);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function purchaseMethodReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _PurchaseMethodsModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS:
            return action.purchaseMethods || state;

        case purchaseMethodsTypes.SELECT_PURCHASE_METHOD:
            return PurchaseMethodsService.selectPurchaseMethod(state, action.purchaseMethod);

        case purchaseMethodsTypes.SELECT_TERM:
            return PurchaseMethodsService.selectTerm(state, action.term);

        case purchaseMethodsTypes.SELECT_PAYMENT_FREQUENCY:
            return PurchaseMethodsService.selectPaymentFrequency(state, action.paymentFrequency.value);

        case purchaseMethodsTypes.SET_CASH_DOWN:
            return PurchaseMethodsService.setCashDown(state, action.cashDown);

        case purchaseMethodsTypes.SET_TRADE_IN:
            return PurchaseMethodsService.setTradeIn(state, action.tradeIn);

        case purchaseMethodsTypes.SET_LIEN:
            return PurchaseMethodsService.setLien(state, action.lien);

        case purchaseMethodsTypes.SET_EXTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setExteriorColourAmounts(state, action.exteriorColourAmounts);

        case purchaseMethodsTypes.SET_INTERIOR_COLOUR_AMOUNTS:
            return PurchaseMethodsService.setInteriorColourAmounts(state, action.interiorColourAmounts);

        case purchaseMethodsTypes.SET_OPTIONS_AMOUNTS:
            return PurchaseMethodsService.setOptionsAmounts(state, action.optionsAmounts);

        case purchaseMethodsTypes.SET_DELIVERY_FEE:
            return PurchaseMethodsService.setDeliveryFee(state, action.addFee);

        case purchaseMethodsTypes.SET_DEPOSIT:
            return PurchaseMethodsService.setDeposit(state, action.deposit);

        case purchaseMethodsTypes.SET_TAXES_INCLUDED:
            return PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded);

        case purchaseMethodsTypes.SELECT_KM_PLAN:
            return PurchaseMethodsService.selectKMPlan(state, action.kmPlan.value);

        case purchaseMethodsTypes.SELECT_OPTIONS_RESOLUTION:
            return PurchaseMethodsService.selectOptionsResolution(state, action.resolutionId);

        case purchaseMethodsTypes.RESET_SELECTED_INCENTIVE_REBATES:
            return PurchaseMethodsService.resetSelectedIncentiveRebates(state);

        default:
            return state;
    }
}

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRebatesDetailsFromData = getRebatesDetailsFromData;
exports.resetCashPurchaseFromOriginData = resetCashPurchaseFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var _CashPurchaseModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/CashPurchaseModel.js");

var _CashPurchaseModel2 = _interopRequireDefault(_CashPurchaseModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function getRebatesDetailsFromData(rebatesDetailsData) {
    return (0, _lodash.map)(rebatesDetailsData, function (rebatesDetail) {
        return {
            typeId: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TYPE_ID],
            code: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_CODE],
            description: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_DESCRIPTION],
            dueAtDelivery: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_IS_AT_DELIVERY],
            isAfterTaxes: !rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_IS_AFTER_TAXES],
            amount: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_AMOUNT],
            taxes: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TAXES] || 0,
            taxesAtDelivery: rebatesDetail[_dataConversions.REBATE_DETAILS.REBATE_TAXES_AT_DELIVERY] || 0
        };
    });
}

function resetCashPurchaseFromCollectionData(collectionCashPurchaseData, selected) {
    if (!collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING] || !collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING][_dataConversions.COLLECTION_CASH_PURCHASE.INDEX]) {
        return new _CashPurchaseModel2.default();
    }

    var pricingIndex = collectionCashPurchaseData[_dataConversions.COLLECTION_CASH_PURCHASE.PRICING][_dataConversions.COLLECTION_CASH_PURCHASE.INDEX];
    var pricingAmounts = pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS] ? {
        msrp: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.MSRP],
        freightPDI: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.FREIGHT_PDI],
        taxesAndDuties: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.AMOUNTS][_dataConversions.COLLECTION_CASH_PURCHASE.TAXES_AND_DUTIES]
    } : {
        msrp: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.RETAIL],
        freightPDI: 0,
        taxesAndDuties: 0
    };

    var rebatesDetailsData = (0, _lodash.isEmpty)(pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_DETAILS]) ? [] : pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_DETAILS];
    var rebatesDetails = getRebatesDetailsFromData(rebatesDetailsData);

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.RETAIL],
        discounts: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] ? pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] : 0,
        rebates: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES],
        rebatesTaxes: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_TAXES] || 0,
        rebatesAtDelivery: pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.DISCOUNTS] ? pricingIndex[_dataConversions.COLLECTION_CASH_PURCHASE.REBATES_AT_DELIVERY] : 0,
        pricingAmounts: pricingAmounts,
        rebatesDetails: rebatesDetails
    });
}

function resetCashPurchaseFromCalculatorData(calculatorCashPurchaseData, selected) {
    if (!calculatorCashPurchaseData.vehicle) {
        return new _CashPurchaseModel2.default();
    }

    var retail = calculatorCashPurchaseData.vehicle.sellingPrice;
    var retailAdjustment = 0;
    if (!(0, _lodash.isEmpty)(calculatorCashPurchaseData.vehicle.price)) {
        var retailWithFees = calculatorCashPurchaseData.vehicle.price[_dataConversions.MODEL_CASH_PURCHASE.RETAIL];
        retailAdjustment = retailWithFees - retail;
        retail = retailWithFees;
    }

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: retail,
        retailAdjustment: retailAdjustment,
        discounts: 0,
        rebates: 0,
        rebatesTaxes: 0,
        rebatesAtDelivery: 0
    });
}

function resetCashPurchaseFromModelData(modelCashPurchaseData, selected) {
    var cashPurchaseData = modelCashPurchaseData[_dataConversions.MODEL_CASH_PURCHASE.PRICING] ? _dataConversions.MODEL_CASH_PURCHASE.PRICING : _dataConversions.VEHICLE_CASH_PURCHASE.PRICING;
    if (!modelCashPurchaseData[cashPurchaseData]) {
        return new _CashPurchaseModel2.default();
    }

    var includedItemsCodes = (0, _lodash.isEmpty)(modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.INCLUDED_CODES]) ? [] : modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.INCLUDED_CODES];
    var rebatesDetailsData = (0, _lodash.isEmpty)(modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_DETAILS]) ? [] : modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_DETAILS];
    var rebatesDetails = getRebatesDetailsFromData(rebatesDetailsData);

    var dealerFees = modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DEALER_FEES] ? modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DEALER_FEES] : 0;

    return new _CashPurchaseModel2.default({
        purchaseMethod: _purchaseMethods.CASH_PURCHASE,
        selected: selected,
        available: false,
        retail: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.RETAIL],
        dealerFees: dealerFees,
        discounts: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.DISCOUNTS],
        rebates: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES],
        rebatesTaxes: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_TAXES] || 0,
        rebatesAtDelivery: modelCashPurchaseData[cashPurchaseData][_dataConversions.MODEL_CASH_PURCHASE.REBATES_AT_DELIVERY],
        includedItemsCodes: includedItemsCodes,
        rebatesDetails: rebatesDetails
    });
}

function resetCashPurchaseFromOriginData(dataOrigin, originCashPurchaseData, selected) {
    if (!(0, _lodash.isObjectLike)(originCashPurchaseData) || (0, _lodash.isEmpty)(originCashPurchaseData)) {
        return new _CashPurchaseModel2.default();
    }

    var updatedSelected = (0, _lodash.isBoolean)(selected) ? selected : false;

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetCashPurchaseFromCollectionData(originCashPurchaseData, updatedSelected);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetCashPurchaseFromCalculatorData(originCashPurchaseData, updatedSelected);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetCashPurchaseFromModelData(originCashPurchaseData, updatedSelected);

        case DataOrigins.VEHICLE_PAYMENTS:
            return resetCashPurchaseFromModelData(originCashPurchaseData, updatedSelected);

        default:
            return new _CashPurchaseModel2.default();
    }
}

exports.default = {
    getRebatesDetailsFromData: getRebatesDetailsFromData,
    resetCashPurchaseFromCollectionData: resetCashPurchaseFromCollectionData,
    resetCashPurchaseFromCalculatorData: resetCashPurchaseFromCalculatorData,
    resetCashPurchaseFromModelData: resetCashPurchaseFromModelData,
    resetCashPurchaseFromOriginData: resetCashPurchaseFromOriginData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/FinanceService/FinanceService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetFinanceFromOriginData = resetFinanceFromOriginData;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethods = _interopRequireWildcard(_purchaseMethods);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _FinanceModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/FinanceModel.js");

var _FinanceModel2 = _interopRequireDefault(_FinanceModel);

var _TermModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _TermService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/TermService/TermService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/* eslint import/prefer-default-export: 0 */

function getFinanceTerms(dataOrigin, termsData) {
    return (0, _lodash.map)(termsData, function (termData, index) {
        return (0, _TermService.resetTermFromOriginData)(dataOrigin, termData, index);
    });
}

function resetFinanceFromCollectionData(collectionFinanceData, purchaseMethod, selected) {
    var annualKMAllowed = 0;
    var endTermKMCost = 0;
    var financeData = void 0;

    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && collectionFinanceData[_dataConversions.COLLECTION_FINANCE.LEASE]) {
        financeData = collectionFinanceData[_dataConversions.COLLECTION_FINANCE.LEASE][_dataConversions.COLLECTION_FINANCE.INDEX];
        if (financeData[_dataConversions.COLLECTION_FINANCE.LEASE_ANNUAL_KM]) {
            annualKMAllowed = financeData[_dataConversions.COLLECTION_FINANCE.LEASE_ANNUAL_KM];
        }
        if (financeData[_dataConversions.COLLECTION_FINANCE.LEASE_END_TERM_KM_COST]) {
            endTermKMCost = financeData[_dataConversions.COLLECTION_FINANCE.LEASE_END_TERM_KM_COST];
        }
    } else if (purchaseMethod === PurchaseMethods.FINANCE && collectionFinanceData[_dataConversions.COLLECTION_FINANCE.FINANCE]) {
        financeData = collectionFinanceData[_dataConversions.COLLECTION_FINANCE.FINANCE][_dataConversions.COLLECTION_FINANCE.INDEX];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;
    if (financeData) {
        terms = getFinanceTerms(DataOrigins.MODELS_COLLECTION, financeData[_dataConversions.COLLECTION_FINANCE.TERMS]);
        selectedTerm = financeData[_dataConversions.COLLECTION_FINANCE.BEST_TERM_WITH_CASH];
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: annualKMAllowed,
        endTermKMCost: endTermKMCost,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm
    });
}

function resetFinanceFromCalculatorData(calculatorFinanceData, purchaseMethod, selected) {
    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;

    if (!calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE]) {
        return new _FinanceModel2.default({
            purchaseMethod: PurchaseMethods.FINANCE,
            purchaseMethodValue: _purchaseMethodsValues2.default.FINANCE,
            annualKMAllowed: 0,
            endTermKMCost: 0,
            selected: false,
            available: false,
            terms: terms,
            selectedTerm: selectedTerm
        });
    }

    var financeData = void 0;
    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.LEASE]) {
        financeData = calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.LEASE];
    } else if (purchaseMethod === PurchaseMethods.FINANCE && calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.FINANCE]) {
        financeData = calculatorFinanceData[_dataConversions.CALCULATOR_FINANCE.VEHICLE][_dataConversions.CALCULATOR_FINANCE.FINANCE];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    if (financeData) {
        terms = getFinanceTerms(DataOrigins.PAYMENT_CALCULATOR, financeData);
        selectedTerm = terms.length > 0 ? terms[terms.length - 1].term : 0;
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: 0,
        endTermKMCost: 0,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm
    });
}

function resetFinanceFromModelData(modelFinanceData, purchaseMethod, selected) {
    var financeKMData = void 0;

    var financeDataLease = modelFinanceData[_dataConversions.MODEL_FINANCE.LEASE] ? _dataConversions.MODEL_FINANCE.LEASE : _dataConversions.VEHICLE_FINANCE.LEASE;
    var financeDataFinance = modelFinanceData[_dataConversions.MODEL_FINANCE.FINANCE] ? _dataConversions.MODEL_FINANCE.FINANCE : _dataConversions.VEHICLE_FINANCE.FINANCE;
    var newPurchaseMethods = purchaseMethod;
    if (purchaseMethod === PurchaseMethods.LEASE && modelFinanceData[financeDataLease]) {
        financeKMData = modelFinanceData[financeDataLease];
    } else if (purchaseMethod === PurchaseMethods.FINANCE && modelFinanceData[financeDataFinance]) {
        financeKMData = modelFinanceData[financeDataFinance];
    } else {
        newPurchaseMethods = PurchaseMethods.FINANCE;
    }

    var annualKMAllowed = 0;
    var endTermKMCost = 0;
    var financeData = void 0;
    if (financeKMData) {
        financeData = financeKMData[_dataConversions.MODEL_FINANCE.INDEX];
        if (financeData[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM]) {
            annualKMAllowed = financeData[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM];
        }
        if (financeData[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST]) {
            endTermKMCost = financeData[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST];
        }
    }

    var terms = [new _TermModel2.default()];
    var selectedTerm = 0;
    var kmPlans = [];
    if (financeData) {
        terms = getFinanceTerms(DataOrigins.MODEL_YEAR_POWERS_TRIMS, financeData[_dataConversions.MODEL_FINANCE.TERMS]);
        selectedTerm = terms.length > 0 ? terms[terms.length - 1].term : 0;

        if (financeKMData.length > 1) {
            (0, _lodash.forEach)(financeKMData, function (financeKM) {
                kmPlans.push({
                    annualKMAllowed: financeKM[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM] ? financeKM[_dataConversions.MODEL_FINANCE.LEASE_ANNUAL_KM] : 0,
                    endTermKMCost: financeKM[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST] ? financeKM[_dataConversions.MODEL_FINANCE.LEASE_END_TERM_KM_COST] : 0,
                    terms: getFinanceTerms(DataOrigins.MODEL_YEAR_POWERS_TRIMS, financeKM[_dataConversions.MODEL_FINANCE.TERMS])
                });
            });
        }
    }

    var purchaseMethodValue = newPurchaseMethods === PurchaseMethods.LEASE ? _purchaseMethodsValues2.default.LEASE : _purchaseMethodsValues2.default.FINANCE;

    return new _FinanceModel2.default({
        purchaseMethod: newPurchaseMethods,
        purchaseMethodValue: purchaseMethodValue,
        annualKMAllowed: annualKMAllowed,
        endTermKMCost: endTermKMCost,
        selected: selected && selectedTerm > 0,
        available: false,
        terms: terms,
        selectedTerm: selectedTerm,
        kmPlans: kmPlans
    });
}

function resetFinanceFromOriginData(dataOrigin, originFinanceData, purchaseMethod, selected) {
    if ((0, _lodash.isEmpty)(originFinanceData) || !(0, _lodash.isObjectLike)(originFinanceData)) {
        return new _FinanceModel2.default();
    }

    var updatedSelected = (0, _lodash.isBoolean)(selected) ? selected : false;

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetFinanceFromCollectionData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetFinanceFromCalculatorData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetFinanceFromModelData(originFinanceData, purchaseMethod, updatedSelected);

        case DataOrigins.VEHICLE_PAYMENTS:
            return resetFinanceFromModelData(originFinanceData, purchaseMethod, updatedSelected);

        default:
            return new _FinanceModel2.default();
    }
}

exports.default = {
    getFinanceTerms: getFinanceTerms,
    resetFinanceFromCollectionData: resetFinanceFromCollectionData,
    resetFinanceFromCalculatorData: resetFinanceFromCalculatorData,
    resetFinanceFromModelData: resetFinanceFromModelData,
    resetFinanceFromOriginData: resetFinanceFromOriginData
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPaymentFrequencyFromCollectionData = resetPaymentFrequencyFromCollectionData;
exports.resetPaymentFrequencyFromCalculatorData = resetPaymentFrequencyFromCalculatorData;
exports.resetPaymentFrequencyFromModelData = resetPaymentFrequencyFromModelData;
exports.getPaymentFrequencyDropDownValues = getPaymentFrequencyDropDownValues;

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _PaymentFrequencyModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PaymentFrequencyModel.js");

var _PaymentFrequencyModel2 = _interopRequireDefault(_PaymentFrequencyModel);

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resetPaymentFrequencyFromCollectionData(collectionPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(collectionPaymentFrequencyData) || !(0, _lodash.isObjectLike)(collectionPaymentFrequencyData) || collectionPaymentFrequencyData.length <= _dataConversions.COLLECTION_FREQUENCY.BALLOON_FACTOR) {
        return new _PaymentFrequencyModel2.default();
    }

    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.BASE_PAYMENT] + collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FEES_PAYMENT] + collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DUTIES_PAYMENT];
    var cashDownAdjustment = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    var disclaimers = collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DISCLAIMERS] ? collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.DISCLAIMERS] : [];

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.PAYMENT_TAXES],
        financeFactor: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: collectionPaymentFrequencyData[_dataConversions.COLLECTION_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment,
        disclaimers: disclaimers
    });
}

function resetPaymentFrequencyFromCalculatorData(calculatorPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(calculatorPaymentFrequencyData) || !(0, _lodash.isObjectLike)(calculatorPaymentFrequencyData)) {
        return new _PaymentFrequencyModel2.default();
    }

    var frequencyCashDown = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.CASH_DOWN];
    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT] + calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR] * frequencyCashDown;

    var cashDownAdjustment = calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    var disclaimers = [];
    if (calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.DISCLAIMER]) {
        disclaimers.push(calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.DISCLAIMER]);
    }

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.PAYMENT_TAXES],
        financeFactor: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: calculatorPaymentFrequencyData[_dataConversions.CALCULATOR_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment,
        disclaimers: disclaimers
    });
}

function resetPaymentFrequencyFromModelData(modelPaymentFrequencyData, cashDown) {
    if ((0, _lodash.isEmpty)(modelPaymentFrequencyData) || !(0, _lodash.isObjectLike)(modelPaymentFrequencyData) || modelPaymentFrequencyData.length <= _dataConversions.MODEL_FREQUENCY.BALLOON_FACTOR) {
        return new _PaymentFrequencyModel2.default();
    }

    var updatedCashDown = (0, _lodash.isFinite)(cashDown) ? cashDown : 0;
    var payment = modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT];
    var cashDownAdjustment = modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.FINANCE_FACTOR] * updatedCashDown;

    return new _PaymentFrequencyModel2.default({
        paymentFrequency: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT_FREQUENCY],
        payment: payment,
        paymentTaxes: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.PAYMENT_TAXES],
        financeFactor: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.FINANCE_FACTOR],
        balloonFactor: modelPaymentFrequencyData[_dataConversions.MODEL_FREQUENCY.BALLOON_FACTOR],
        cashDownPaymentAdjustment: cashDownAdjustment,
        netTradeInPaymentAdjustment: 0,
        netTradeInPaymentTaxesAdjustment: 0,
        calculatedNetPayment: payment,
        calculatedPayment: payment - cashDownAdjustment
    });
}

// I18n argument is the LocalService class to translate
function getPaymentFrequencyDropDownValues(I18n, purchaseMethods) {
    var paymentFrequencyDropDownValues = [{ value: _paymentFrequencies.WEEKLY, label: I18n.t('paymentFrequencies.weekly') }, { value: _paymentFrequencies.BI_WEEKLY, label: I18n.t('paymentFrequencies.biWeekly') }, { value: _paymentFrequencies.SEMI_MONTHLY, label: I18n.t('paymentFrequencies.semiMonthly') }, { value: _paymentFrequencies.MONTHLY, label: I18n.t('paymentFrequencies.monthly') }];

    if (purchaseMethods) {
        var availablePaymentFrequencies = purchaseMethods.getFinancesAvailablePaymentFrequencies();
        paymentFrequencyDropDownValues = (0, _lodash.filter)(paymentFrequencyDropDownValues, function (paymentFrequencyDropDownValue) {
            return (0, _lodash.includes)(availablePaymentFrequencies, paymentFrequencyDropDownValue.value);
        });
    }

    return paymentFrequencyDropDownValues;
}

exports.default = {
    resetPaymentFrequencyFromCollectionData: resetPaymentFrequencyFromCollectionData,
    resetPaymentFrequencyFromCalculatorData: resetPaymentFrequencyFromCalculatorData,
    resetPaymentFrequencyFromModelData: resetPaymentFrequencyFromModelData,
    getPaymentFrequencyDropDownValues: getPaymentFrequencyDropDownValues
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisclaimerAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _ShowroomAPIService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _disclaimers = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/disclaimers.js");

var _disclaimers2 = _interopRequireDefault(_disclaimers);

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _DisclaimersModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/DisclaimersModel.js");

var _DisclaimersModel2 = _interopRequireDefault(_DisclaimersModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to create a request configuration object to load Generic Disclaimers for a given context
 * @param {String} publicToken
 */
function getGenericDisclaimersRequestConfig(publicToken) {
    var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
    var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
    var language = _widgetCommonsCoreServices.LocaleService.getLocale();

    var requestConfig = {
        url: _index2.default.endpoint.showroom + '/service/v1/genericDisclaimers',
        method: 'get'
    };

    requestConfig.headers = {
        'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
    };

    requestConfig.params = {
        context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
        location: (0, _lodash.isEmpty)(location) ? '' : location,
        language: language
    };

    return requestConfig;
}

/**
 * Util to create a request configuration data and vehicle match object
 * @param {Object[]} vehicles
 */
function getVehiclesDisclaimersDataRequestConfig(vehicles) {
    var vehiclesAndRequestData = (0, _lodash.map)(vehicles, function (vehicle, index) {
        var year = vehicle.year,
            make = vehicle.make,
            model = vehicle.model,
            vehicleConditionType = vehicle.vehicleConditionType,
            modelTrimCode = vehicle.modelTrimCode,
            configurationID = vehicle.configurationID,
            configurationToken = vehicle.configurationToken,
            vehicleId = vehicle.vehicleId,
            odometer = vehicle.odometer,
            sellingPrice = vehicle.sellingPrice,
            purchaseMethods = vehicle.purchaseMethods;
        var tradeIn = purchaseMethods.tradeIn,
            lien = purchaseMethods.lien;


        var disclaimers = purchaseMethods.getDisclaimerParameters();

        var disclaimerData = void 0;
        if (vehicle.getIsVehicleNew()) {
            disclaimerData = {
                cookie: index.toString(),
                year: year,
                make: make,
                modelTrimCode: modelTrimCode,
                configurationID: configurationID,
                configurationToken: configurationToken,
                vehicleCondition: vehicleConditionType,
                vehicleId: vehicleId,
                tradeIn: tradeIn,
                lien: lien,
                disclaimers: disclaimers
            };
        } else {
            disclaimerData = {
                cookie: index.toString(),
                year: year,
                make: make,
                model: model,
                vehicleCondition: vehicleConditionType,
                vehicleId: vehicleId,
                odometer: odometer,
                retail: sellingPrice,
                tradeIn: tradeIn,
                lien: lien,
                disclaimers: disclaimers
            };
        }

        return {
            cookie: index.toString(),
            disclaimerData: disclaimerData,
            vehicle: vehicle
        };
    });

    return vehiclesAndRequestData;
}

/**
 * Util to create a request configuration data and options package match object
 * @param {Object} modelYear
 * @param {Object} optionsPackage
 */
function getOptionsPackageDisclaimersDataRequestConfig(modelYear, optionsPackage) {
    var year = modelYear.year,
        make = modelYear.make;
    var _optionsPackage$confi = optionsPackage.configuration,
        modelTrimCode = _optionsPackage$confi.modelTrimCode,
        id = _optionsPackage$confi.id,
        configurationToken = _optionsPackage$confi.configurationToken,
        purchaseMethods = _optionsPackage$confi.purchaseMethods;


    var cookie = year + '-' + make + '-' + modelTrimCode + '-' + id;

    var tradeIn = purchaseMethods.tradeIn,
        lien = purchaseMethods.lien;


    var disclaimers = purchaseMethods.getDisclaimerParameters();

    var disclaimerData = {
        cookie: cookie,
        year: year,
        make: make,
        modelTrimCode: modelTrimCode,
        configurationID: id,
        configurationToken: configurationToken,
        vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
        tradeIn: tradeIn,
        lien: lien,
        disclaimers: disclaimers
    };

    return [{
        cookie: cookie,
        disclaimerData: disclaimerData,
        modelYear: modelYear,
        optionsPackage: optionsPackage
    }];
}

/**
 * Util to create a request configuration data and model match object
 * @param {Object} model
 */
function getModelsDisclaimersDataRequestConfig(models) {
    var modelsAndRequestData = (0, _lodash.map)(models, function (model) {
        var priceYear = model.priceYear,
            leaseYear = model.leaseYear,
            financeYear = model.financeYear,
            make = model.make,
            bodyStyleCode = model.bodyStyleCode,
            priceModelTrimCode = model.priceModelTrimCode,
            leaseModelTrimCode = model.leaseModelTrimCode,
            financeModelTrimCode = model.financeModelTrimCode,
            priceConfigurationId = model.priceConfigurationId,
            leaseConfigurationId = model.leaseConfigurationId,
            financeConfigurationId = model.financeConfigurationId,
            purchaseMethods = model.purchaseMethods;

        if (!purchaseMethods) {
            return [];
        }

        var cookie = make + '-' + model.model + '-' + bodyStyleCode;

        var tradeIn = purchaseMethods.tradeIn,
            lien = purchaseMethods.lien;


        var disclaimers = purchaseMethods.getDisclaimerParameters();

        var priceDisclaimerData = {
            cookie: cookie + '-price',
            year: priceYear,
            make: make,
            modelTrimCode: priceModelTrimCode,
            configurationID: priceConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var leaseDisclaimerData = {
            cookie: cookie + '-lease',
            year: leaseYear,
            make: make,
            modelTrimCode: leaseModelTrimCode,
            configurationID: leaseConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var financeDisclaimerData = {
            cookie: cookie + '-finance',
            year: financeYear,
            make: make,
            modelTrimCode: financeModelTrimCode,
            configurationID: financeConfigurationId,
            vehicleCondition: _vehicle2.default.CONDITIONS.NEW,
            tradeIn: tradeIn,
            lien: lien,
            disclaimers: disclaimers
        };

        var CASH = _purchaseMethodsValues2.default.CASH,
            FINANCE = _purchaseMethodsValues2.default.FINANCE,
            LEASE = _purchaseMethodsValues2.default.LEASE;

        return [{
            cookie: cookie + '-price',
            disclaimerData: priceDisclaimerData,
            model: model,
            purchaseMethod: CASH,
            purchaseMethods: purchaseMethods
        }, {
            cookie: cookie + '-lease',
            disclaimerData: leaseDisclaimerData,
            model: model,
            purchaseMethod: LEASE,
            purchaseMethods: purchaseMethods
        }, {
            cookie: cookie + '-finance',
            disclaimerData: financeDisclaimerData,
            model: model,
            purchaseMethod: FINANCE,
            purchaseMethods: purchaseMethods
        }];
    });

    return (0, _lodash.flatten)(modelsAndRequestData);
}

/**
 * Util to create a request configuration object to load Disclaimers for given data requests
 * @param {String} publicToken
 * @param {Object[]} requestsData
 */
function getDisclaimersRequestConfig(publicToken, requestsData) {
    var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
    var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
    var language = _widgetCommonsCoreServices.LocaleService.getLocale();

    var requestConfig = {
        url: _index2.default.endpoint.showroom + '/service/v1/disclaimers',
        method: 'post'
    };

    requestConfig.headers = {
        'x-jwt': (0, _lodash.isString)(publicToken) ? publicToken : ''
    };

    requestConfig.params = {
        context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
        location: (0, _lodash.isEmpty)(location) ? '' : location,
        language: language
    };

    requestConfig.data = (0, _lodash.map)(requestsData, function (vehicle) {
        return vehicle.disclaimerData;
    });

    return requestConfig;
}

/**
 * Util to create a term frequency disclaimers sentences object
 * @param {Object} paymentFrequency
 * @param {Object} disclaimersIds
 */
function createTermFrequencyDisclaimersSentences(paymentFrequency, disclaimersIds) {
    var sentences = {
        paymentFrequency: 0,
        paymentAndCash: '',
        obligationAndInterest: ''
    };
    if ((0, _lodash.isEmpty)(paymentFrequency) || (0, _lodash.isEmpty)(paymentFrequency.disclaimers)) {
        return sentences;
    }
    sentences.paymentFrequency = paymentFrequency.frequency;

    var PAYMENT_CASH_DOWN = disclaimersIds.PAYMENT_CASH_DOWN,
        TOTAL_OBLIGATION = disclaimersIds.TOTAL_OBLIGATION,
        COST_OF_CREDIT = disclaimersIds.COST_OF_CREDIT,
        CREDIT_RATE = disclaimersIds.CREDIT_RATE;


    var paymentAndCash = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === PAYMENT_CASH_DOWN;
    });
    sentences.paymentAndCash = paymentAndCash ? paymentAndCash.disclaimer : '';

    var totalObligation = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === TOTAL_OBLIGATION;
    });
    var costOfCredit = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === COST_OF_CREDIT;
    });
    var creditRate = (0, _lodash.find)(paymentFrequency.disclaimers, function (disclaimer) {
        return disclaimer.id === CREDIT_RATE;
    });
    sentences.obligationAndInterest = (totalObligation ? totalObligation.disclaimer : '') + ' ' + ((costOfCredit ? costOfCredit.disclaimer : '') + ' ' + (creditRate ? creditRate.disclaimer : ''));

    return sentences;
}

/**
 * Util to create a term disclaimers sentences object
 * @param {Object} term
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createTermDisclaimersSentences(term, priceExclusions, disclaimersIds) {
    var sentences = {
        term: 0,
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: priceExclusions,
        termAndApr: '',
        frequencies: []
    };
    if ((0, _lodash.isEmpty)(term) || (0, _lodash.isEmpty)(term.disclaimers)) {
        return sentences;
    }
    sentences.term = term.term;

    var SELLING_PRICE = disclaimersIds.SELLING_PRICE,
        INCLUDED_REBATES = disclaimersIds.INCLUDED_REBATES,
        INCLUDED_FEES = disclaimersIds.INCLUDED_FEES,
        EXCLUDED_FEES = disclaimersIds.EXCLUDED_FEES,
        TERM_APR = disclaimersIds.TERM_APR;


    var sellingPrice = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === SELLING_PRICE;
    });
    sentences.sellingPrice = sellingPrice ? sellingPrice.disclaimer : '';

    var rebateInclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_REBATES;
    });
    var feeInclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_FEES;
    });
    var rebateInclusionsSentence = rebateInclusions ? rebateInclusions.disclaimer : '';
    var feeInclusionsSentence = feeInclusions ? feeInclusions.disclaimer : '';
    sentences.priceInclusions = rebateInclusionsSentence + ' ' + feeInclusionsSentence;

    var feeExclusions = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_FEES;
    });
    sentences.priceExclusions = (feeExclusions ? feeExclusions.disclaimer : '') + ' ' + priceExclusions;

    var termAndApr = (0, _lodash.find)(term.disclaimers, function (disclaimer) {
        return disclaimer.id === TERM_APR;
    });
    sentences.termAndApr = termAndApr ? termAndApr.disclaimer : '';

    sentences.frequencies = (0, _lodash.map)(term.paymentFrequencies, function (paymentFrequency) {
        return createTermFrequencyDisclaimersSentences(paymentFrequency, _disclaimers2.default.FINANCE.PAYMENT_FREQUENCY);
    });

    return sentences;
}

/**
 * Util to create a finance plan disclaimers sentences object
 * @param {Object} finance
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createFinanceDisclaimersSentences(finance, priceExclusions, disclaimersIds) {
    var sentences = {
        vehicleDescription: '',
        terms: [],
        creditApproval: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.CREDIT_APPROVAL')
    };
    if ((0, _lodash.isEmpty)(finance)) {
        return sentences;
    }

    var VEHICLE_DESCRIPTION = disclaimersIds.VEHICLE_DESCRIPTION,
        TERM = disclaimersIds.TERM,
        KM_PLAN = disclaimersIds.KM_PLAN,
        CASH_DOWN_TAX_EXCLUDED = disclaimersIds.CASH_DOWN_TAX_EXCLUDED,
        CREDIT_APPROVAL = disclaimersIds.CREDIT_APPROVAL;


    var vehicleDescription = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === VEHICLE_DESCRIPTION;
    });
    sentences.vehicleDescription = vehicleDescription ? vehicleDescription.disclaimer : '';

    sentences.terms = (0, _lodash.map)(finance.terms, function (term) {
        return createTermDisclaimersSentences(term, priceExclusions, TERM);
    });

    var kmPlan = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === KM_PLAN;
    });
    var cashDownTaxExcluded = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === CASH_DOWN_TAX_EXCLUDED;
    });
    var creditApproval = (0, _lodash.find)(finance.disclaimers, function (disclaimer) {
        return disclaimer.id === CREDIT_APPROVAL;
    });
    sentences.creditApproval = (kmPlan ? kmPlan.disclaimer : '') + ' ' + ((creditApproval ? creditApproval.disclaimer : '') + ' ') + ('' + (cashDownTaxExcluded ? cashDownTaxExcluded.disclaimer : ''));

    return sentences;
}

/**
 * Util to create a cash purchase disclaimers sentences object
 * @param {Object} cashPurchase
 * @param {String} priceExclusions
 * @param {Object} disclaimersIds
 */
function createCashPurchaseDisclaimersSentences(cashPurchase, priceExclusions, disclaimersIds) {
    var sentences = {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: priceExclusions
    };
    if ((0, _lodash.isEmpty)(cashPurchase)) {
        return sentences;
    }

    var VEHICLE_DESCRIPTION = disclaimersIds.VEHICLE_DESCRIPTION,
        SELLING_PRICE = disclaimersIds.SELLING_PRICE,
        INCLUDED_REBATES = disclaimersIds.INCLUDED_REBATES,
        INCLUDED_FEES = disclaimersIds.INCLUDED_FEES,
        EXCLUDED_FEES = disclaimersIds.EXCLUDED_FEES;


    var vehicleDescription = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === VEHICLE_DESCRIPTION;
    });
    sentences.vehicleDescription = vehicleDescription ? vehicleDescription.disclaimer : '';

    var sellingPrice = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === SELLING_PRICE;
    });
    sentences.sellingPrice = sellingPrice ? sellingPrice.disclaimer : '';

    var rebateInclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_REBATES;
    });
    var feeInclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === INCLUDED_FEES;
    });
    var rebateInclusionsSentence = rebateInclusions ? rebateInclusions.disclaimer : '';
    var feeInclusionsSentence = feeInclusions ? feeInclusions.disclaimer : '';
    sentences.priceInclusions = rebateInclusionsSentence + ' ' + feeInclusionsSentence;

    var feeExclusions = (0, _lodash.find)(cashPurchase.disclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_FEES;
    });
    sentences.priceExclusions = (feeExclusions ? feeExclusions.disclaimer : '') + ' ' + priceExclusions;

    return sentences;
}

/**
 * Util to create a purchase methods disclaimers sentences object
 * @param {Object} dataDisclaimers
 * @param {String} priceExclusions
 */
function createDisclaimersSentences(vehicleDisclaimers, priceExclusions) {
    if ((0, _lodash.isEmpty)(vehicleDisclaimers)) {
        return null;
    }

    var CASH = _purchaseMethodsValues2.default.CASH,
        FINANCE = _purchaseMethodsValues2.default.FINANCE,
        LEASE = _purchaseMethodsValues2.default.LEASE;


    var cashPurchase = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === CASH;
    });

    var finance = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === FINANCE;
    });

    var lease = (0, _lodash.find)(vehicleDisclaimers.purchaseMethods, function (purchaseMethod) {
        return purchaseMethod.purchaseMethod === LEASE;
    });

    return {
        cookie: vehicleDisclaimers.cookie,
        cashPurchase: createCashPurchaseDisclaimersSentences(cashPurchase, priceExclusions, _disclaimers2.default.CASH),
        finance: createFinanceDisclaimersSentences(finance, priceExclusions, _disclaimers2.default.FINANCE),
        lease: createFinanceDisclaimersSentences(lease, priceExclusions, _disclaimers2.default.LEASE)
    };
}

/**
 * Util to get the term and frequency finance disclaimers sentences object
 * @param {Object} finance
 * @param {Object} financeDisclaimers
 */
function getFinanceSentences(finance, financeDisclaimers) {
    var financeSentences = {
        vehicleDescription: '',
        sellingPrice: '',
        priceInclusions: '',
        priceExclusions: '',
        termAndApr: '',
        paymentAndCash: '',
        obligationAndInterest: '',
        creditApproval: ''
    };

    var financeTerm = finance.getSelectedTerm();
    var financeFrequency = finance.getSelectedTermFrequency();
    if (!financeTerm || !financeTerm.term || !financeFrequency || !financeFrequency.paymentFrequency) {
        return financeSentences;
    }

    var financeTermDisclaimers = (0, _lodash.find)(financeDisclaimers.terms, function (term) {
        return term.term === financeTerm.term;
    });
    if (!financeTermDisclaimers) {
        return financeSentences;
    }

    var financeFrequencyDisclaimers = (0, _lodash.find)(financeTermDisclaimers.frequencies, function (frequency) {
        return frequency.paymentFrequency === financeFrequency.paymentFrequency;
    });
    if (!financeFrequencyDisclaimers) {
        return financeSentences;
    }

    financeSentences = {
        vehicleDescription: financeDisclaimers.vehicleDescription,
        sellingPrice: financeTermDisclaimers.sellingPrice,
        priceInclusions: financeTermDisclaimers.priceInclusions,
        priceExclusions: financeTermDisclaimers.priceExclusions,
        termAndApr: financeTermDisclaimers.termAndApr,
        paymentAndCash: financeFrequencyDisclaimers.paymentAndCash,
        obligationAndInterest: financeFrequencyDisclaimers.obligationAndInterest,
        creditApproval: financeDisclaimers.creditApproval
    };

    return financeSentences;
}

/**
 * Util to get a basic disclaimers object
 * @param {Object} genericDisclaimers
 */
function getBasicDisclaimers(genericDisclaimers) {
    var sentences = {
        illustration: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.ILLUSTRATION'),
        highVolume: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.HIGH_VOLUME'),
        optionsVariation: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.OPTIONS_VARIATION'),
        dataResponsibility: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.DATA_RESPONSIBILITY'),
        priceChange: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_CHANGE'),
        priceExclusion: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_EXCLUSION'),
        taxesExcluded: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.TAXES_EXCLUDED', { taxCodes: ['Taxes'] }),
        pricePaymentsTaxesExcluded: _widgetCommonsCoreServices.LocaleService.t('DISCLAIMERS_DEFAULT_VALUES.PRICE_PAYMENTS_TAXES_EXCLUDED')
    };
    if ((0, _lodash.isEmpty)(genericDisclaimers)) {
        return new _DisclaimersModel2.default(sentences);
    }

    var ILLUSTRATION_PURPOSES = _disclaimers2.default.ILLUSTRATION_PURPOSES,
        HIGH_TRANSACTION_VOLUME = _disclaimers2.default.HIGH_TRANSACTION_VOLUME,
        OPTIONS_TRIMS_VARIATION = _disclaimers2.default.OPTIONS_TRIMS_VARIATION,
        NOT_RESPONSIBLE = _disclaimers2.default.NOT_RESPONSIBLE,
        PRICES_SUBJECT_TO_CHANGE = _disclaimers2.default.PRICES_SUBJECT_TO_CHANGE,
        GENERAL_FEES_EXCLUSION = _disclaimers2.default.GENERAL_FEES_EXCLUSION,
        EXCLUDED_TAXES = _disclaimers2.default.EXCLUDED_TAXES,
        PRICE_PAYMENTS_EXCLUDED_TAXES = _disclaimers2.default.PRICE_PAYMENTS_EXCLUDED_TAXES;


    var illustration = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === ILLUSTRATION_PURPOSES;
    });
    if (illustration) {
        sentences.illustration = illustration.disclaimer;
    }

    var highVolume = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === HIGH_TRANSACTION_VOLUME;
    });
    if (highVolume) {
        sentences.highVolume = highVolume.disclaimer;
    }

    var optionsVariation = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === OPTIONS_TRIMS_VARIATION;
    });
    if (optionsVariation) {
        sentences.optionsVariation = optionsVariation.disclaimer;
    }

    var dataResponsibility = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === NOT_RESPONSIBLE;
    });
    if (dataResponsibility) {
        sentences.dataResponsibility = dataResponsibility.disclaimer;
    }

    var priceChange = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === PRICES_SUBJECT_TO_CHANGE;
    });
    sentences.priceChange = priceChange ? priceChange.disclaimer : '';

    var priceExclusions = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === GENERAL_FEES_EXCLUSION;
    });
    if (priceExclusions) {
        sentences.priceExclusion = priceExclusions.disclaimer;
    }

    var taxesExcluded = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === EXCLUDED_TAXES;
    });
    if (taxesExcluded) {
        sentences.taxesExcluded = taxesExcluded.disclaimer;
    }

    var pricePaymentsTaxesExcluded = (0, _lodash.find)(genericDisclaimers, function (disclaimer) {
        return disclaimer.id === PRICE_PAYMENTS_EXCLUDED_TAXES;
    });
    if (pricePaymentsTaxesExcluded) {
        sentences.pricePaymentsTaxesExcluded = pricePaymentsTaxesExcluded.disclaimer;
    }

    return new _DisclaimersModel2.default(sentences);
}

/**
 * Util to merge Disclaimers API call response and target vehicles and return the new vehicles array
 * @param {Object} disclaimersData
 * @param {Object[]} vehiclesAndRequestData
 */
function mergeVehiclesAndDisclaimersDataResults(disclaimersData, vehiclesAndRequestData) {
    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return (0, _lodash.map)(vehiclesAndRequestData, function (vehicleAndRequestData) {
            return vehicleAndRequestData.vehicle;
        });
    }

    var disclaimers = disclaimersData.disclaimers;


    var baseDisclaimers = vehiclesAndRequestData[0].vehicle.purchaseMethods.disclaimers;
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var vehiclesAndDisclaimers = (0, _lodash.map)(vehiclesAndRequestData, function (vehicleAndRequestData) {
        var cookie = vehicleAndRequestData.cookie,
            vehicle = vehicleAndRequestData.vehicle;


        var vehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === cookie;
        });

        if (!vehicleAndDisclaimer) {
            return vehicle.setIn(['purchaseMethods', 'disclaimers'], baseDisclaimers);
        }

        var purchaseMethods = vehicle.purchaseMethods;
        var lease = vehicleAndDisclaimer.lease,
            finance = vehicleAndDisclaimer.finance;


        var financeSentences = getFinanceSentences(purchaseMethods.finance, finance);
        var leaseSentences = getFinanceSentences(purchaseMethods.lease, lease);

        var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', vehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

        return vehicle.setIn(['purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);
    });

    return vehiclesAndDisclaimers;
}

/**
 * Util to merge Disclaimers API call response and target options package and return the new model year
 * @param {Object} disclaimersData
 * @param {Object[]} optionsPackageAndRequestData
 */
function mergeOptionsPackageAndDisclaimersDataResults(disclaimersData, optionsPackageAndRequestData) {
    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return optionsPackageAndRequestData.modelYear;
    }

    var disclaimers = disclaimersData.disclaimers,
        genericDisclaimers = disclaimersData.genericDisclaimers;


    var baseDisclaimers = getBasicDisclaimers(genericDisclaimers);
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var cookie = optionsPackageAndRequestData.cookie,
        modelYear = optionsPackageAndRequestData.modelYear,
        optionsPackage = optionsPackageAndRequestData.optionsPackage;


    var vehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
        return vehicleDisclaimer.cookie === cookie;
    });

    if (!vehicleAndDisclaimer) {
        return modelYear;
    }

    var _optionsPackage$confi2 = optionsPackage.configuration,
        modelTrimCodeId = _optionsPackage$confi2.modelTrimCodeId,
        purchaseMethods = _optionsPackage$confi2.purchaseMethods;
    var lease = vehicleAndDisclaimer.lease,
        finance = vehicleAndDisclaimer.finance;


    var financeSentences = getFinanceSentences(purchaseMethods.finance, finance);
    var leaseSentences = getFinanceSentences(purchaseMethods.lease, lease);

    var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', vehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

    var newOptionsPackage = optionsPackage.setIn(['configuration', 'purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);

    return modelYear.set('optionsPackages', (0, _immutable.List)((0, _lodash.map)(modelYear.optionsPackages.toArray(), function (modelOptionsPackage) {
        var currentModelTrimCodeId = modelOptionsPackage.configuration.modelTrimCodeId;
        return currentModelTrimCodeId === modelTrimCodeId ? newOptionsPackage : modelOptionsPackage;
    })));
}

/**
 * Util to merge Disclaimers API call response and target model and return the model and purchase methods
 * @param {Object} disclaimersData
 * @param {Object[]} modelsAndRequestData
 */
function mergeModelAndDisclaimersDataResults(disclaimersData, modelsAndRequestData) {
    var CASH = _purchaseMethodsValues2.default.CASH,
        FINANCE = _purchaseMethodsValues2.default.FINANCE,
        LEASE = _purchaseMethodsValues2.default.LEASE;

    var priceModelsAndRequestData = (0, _lodash.filter)(modelsAndRequestData, function (modelAndRequestPurchaseMethodData) {
        return modelAndRequestPurchaseMethodData.purchaseMethod === CASH;
    });

    if ((0, _lodash.isEmpty)(disclaimersData) || (0, _lodash.isEmpty)(disclaimersData.disclaimers)) {
        return (0, _lodash.map)(priceModelsAndRequestData, function (priceModelAndRequestData) {
            return priceModelAndRequestData.model;
        });
    }

    var disclaimers = disclaimersData.disclaimers,
        genericDisclaimers = disclaimersData.genericDisclaimers;


    var baseDisclaimers = getBasicDisclaimers(genericDisclaimers);
    var vehicleDisclaimers = (0, _lodash.map)(disclaimers, function (disclaimer) {
        return createDisclaimersSentences(disclaimer, baseDisclaimers.priceExclusion);
    });

    var priceModelsAndDisclaimers = (0, _lodash.map)(priceModelsAndRequestData, function (priceModelAndRequestData) {
        var model = priceModelAndRequestData.model;


        var leasePurchaseMethods = (0, _lodash.find)(modelsAndRequestData, function (modelAndRequestData) {
            return modelAndRequestData.purchaseMethod === LEASE && modelAndRequestData.model.make === model.make && modelAndRequestData.model.model === model.model && modelAndRequestData.model.bodyStyleCode === model.bodyStyleCode;
        });
        var financePurchaseMethods = (0, _lodash.find)(modelsAndRequestData, function (modelAndRequestData) {
            return modelAndRequestData.purchaseMethod === FINANCE && modelAndRequestData.model.make === model.make && modelAndRequestData.model.model === model.model && modelAndRequestData.model.bodyStyleCode === model.bodyStyleCode;
        });

        var priceVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === priceModelAndRequestData.cookie;
        });
        var leaseVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === leasePurchaseMethods.cookie;
        });
        var financeVehicleAndDisclaimer = (0, _lodash.find)(vehicleDisclaimers, function (vehicleDisclaimer) {
            return vehicleDisclaimer.cookie === financePurchaseMethods.cookie;
        });

        if (!priceVehicleAndDisclaimer && !leaseVehicleAndDisclaimer && !financeVehicleAndDisclaimer) {
            return priceModelAndRequestData.model;
        }

        var lease = leaseVehicleAndDisclaimer.lease;
        var finance = financeVehicleAndDisclaimer.finance;


        var financeSentences = getFinanceSentences(financePurchaseMethods.purchaseMethods.finance, finance);
        var leaseSentences = getFinanceSentences(leasePurchaseMethods.purchaseMethods.lease, lease);

        var purchaseMethodsDisclaimers = baseDisclaimers.set('cashPurchase', priceVehicleAndDisclaimer.cashPurchase).set('finance', financeSentences).set('lease', leaseSentences);

        return priceModelAndRequestData.model.setIn(['purchaseMethods', 'disclaimers'], purchaseMethodsDisclaimers);
    });

    return priceModelsAndDisclaimers;
}

/**
 * Groups Disclaimer api calls to ShowroomAPI
 */

var DisclaimerAPIService = function () {
    function DisclaimerAPIService() {
        _classCallCheck(this, DisclaimerAPIService);
    }

    _createClass(DisclaimerAPIService, [{
        key: 'getGenericDisclaimers',

        /**
         * Gets the generic disclaimers for a context
         */
        value: function getGenericDisclaimers() {
            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getGenericDisclaimersRequestConfig(publicToken.data);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return getBasicDisclaimers(result.data);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for a list of vehicles
         * @param {Object[]} vehicles
         */

    }, {
        key: 'getVehiclesDisclaimers',
        value: function getVehiclesDisclaimers(vehicles) {
            if ((0, _lodash.isEmpty)(vehicles) || !(0, _lodash.isArrayLikeObject)(vehicles) || !(vehicles[0] instanceof _VehicleModel2.default)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param [vehicles] must be an array'));
            }

            var vehiclesAndRequestData = getVehiclesDisclaimersDataRequestConfig(vehicles);

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, vehiclesAndRequestData);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeVehiclesAndDisclaimersDataResults(result.data, vehiclesAndRequestData);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for the selected options package of a Model Year
         * @param {Object} modelYear
         * @param {Object} selectedOptionsPackage
         */

    }, {
        key: 'getModelYearSelectedOptionsPackageDisclaimers',
        value: function getModelYearSelectedOptionsPackageDisclaimers(modelYear, selectedOptionsPackage, configurationToken) {
            if ((0, _lodash.isEmpty)(modelYear) || !(modelYear instanceof _ModelYearModel2.default) || (0, _lodash.isUndefined)(selectedOptionsPackage)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param modelYear must be a valid Model Year'));
            }

            var optionsPackageAndRequestData = getOptionsPackageDisclaimersDataRequestConfig(modelYear, selectedOptionsPackage);

            optionsPackageAndRequestData[0].disclaimerData.configurationToken = configurationToken || '';

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, optionsPackageAndRequestData);

                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeOptionsPackageAndDisclaimersDataResults(result.data, optionsPackageAndRequestData[0]);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }

        /**
         * Gets the disclaimers for a list of models
         * @param {Object[]} models
         */

    }, {
        key: 'getModelsDisclaimers',
        value: function getModelsDisclaimers(models) {
            if ((0, _lodash.isEmpty)(models) || !(0, _lodash.isArrayLikeObject)(models)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('param models must be valid'));
            }

            var modelsAndRequestData = getModelsDisclaimersDataRequestConfig(models);

            return _ShowroomAPIService2.default.getPublicToken().then(function (publicToken) {
                var disclaimersRequestConfig = getDisclaimersRequestConfig(publicToken.data, modelsAndRequestData);
                return _axios2.default.request(disclaimersRequestConfig).then(function (result) {
                    return mergeModelAndDisclaimersDataResults(result.data, modelsAndRequestData);
                }).catch(function () {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('Unable to load disclaimers'));
                });
            });
        }
    }]);

    return DisclaimerAPIService;
}();

exports.DisclaimerAPIService = DisclaimerAPIService;
exports.default = new DisclaimerAPIService();

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recalculatePayments = recalculatePayments;
exports.recalculatePurchaseAmounts = recalculatePurchaseAmounts;
exports.splitRetailAndIncludedOptions = splitRetailAndIncludedOptions;
exports.resetOptionsAmounts = resetOptionsAmounts;
exports.resetPurchaseMethodsFromOriginData = resetPurchaseMethodsFromOriginData;
exports.resetPurchaseMethodsOptionsFromQuoteItems = resetPurchaseMethodsOptionsFromQuoteItems;
exports.selectPurchaseMethod = selectPurchaseMethod;
exports.selectKMPlan = selectKMPlan;
exports.selectTerm = selectTerm;
exports.setTargetPayment = setTargetPayment;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setExteriorColourAmounts = setExteriorColourAmounts;
exports.setInteriorColourAmounts = setInteriorColourAmounts;
exports.setOptionsAmounts = setOptionsAmounts;
exports.setTaxesIncluded = setTaxesIncluded;
exports.selectOptionsResolution = selectOptionsResolution;
exports.setSelectedFinanceBestPaymentTerm = setSelectedFinanceBestPaymentTerm;
exports.setDeliveryFee = setDeliveryFee;
exports.setDeposit = setDeposit;
exports.getFormattedCurrencySplit = getFormattedCurrencySplit;
exports.resetProtections = resetProtections;
exports.resetSelectedOptions = resetSelectedOptions;
exports.resetSelectedIncentiveRebates = resetSelectedIncentiveRebates;

var _lodash = __webpack_require__("lodash");

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var PurchaseMethodsConstants = _interopRequireWildcard(_purchaseMethods);

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

var _dataConversions2 = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _apiDataConversionConstants = __webpack_require__("../widget-commons-vehicle/src/constants/apiDataConversionConstants.js");

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _FinanceService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/FinanceService/FinanceService.js");

var FinanceService = _interopRequireWildcard(_FinanceService);

var _CashPurchaseService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

var CashPurchaseService = _interopRequireWildcard(_CashPurchaseService);

var _TermService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/TermService/TermService.js");

var _OptionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var VEHICLE = _apiDataConversionConstants.VIEW_1.VEHICLE;
/* eslint no-bitwise: 0 */

function recalculatePayments(purchaseMethods, paymentCalculationParameters) {
    return purchaseMethods.set('taxesIncluded', paymentCalculationParameters.taxesIncluded).set('tradeIn', paymentCalculationParameters.tradeIn).set('lien', paymentCalculationParameters.lien).set('exteriorColourRetail', paymentCalculationParameters.exteriorColourRetail).set('exteriorColourResidualRetail', paymentCalculationParameters.exteriorColourResidualRetail).set('interiorColourRetail', paymentCalculationParameters.interiorColourRetail).set('interiorColourResidualRetail', paymentCalculationParameters.interiorColourResidualRetail).set('optionsTotalRetail', paymentCalculationParameters.optionsTotalRetail).set('optionsTotalResidualRetail', paymentCalculationParameters.optionsTotalResidualRetail).setIn(['finance', 'terms'], purchaseMethods.getIn(['finance', 'terms']).map(function (term) {
        return (0, _TermService.recalculateTermPayment)(term, paymentCalculationParameters);
    })).setIn(['lease', 'terms'], purchaseMethods.getIn(['lease', 'terms']).map(function (term) {
        return (0, _TermService.recalculateTermPayment)(term, paymentCalculationParameters);
    })).setIn(['finance', 'selectedTerm'], paymentCalculationParameters.selectedFinanceTerm).setIn(['lease', 'selectedTerm'], paymentCalculationParameters.selectedLeaseTerm);
}

function recalculatePurchaseAmounts(purchaseMethods, amountsCalculationParameters) {
    var retail = purchaseMethods.getIn(['cashPurchase', 'retail']);
    var optionsAdjustment = amountsCalculationParameters.exteriorColourRetail + amountsCalculationParameters.interiorColourRetail + amountsCalculationParameters.optionsTotalRetail;
    var optionsTaxesAdjustment = optionsAdjustment * amountsCalculationParameters.taxesFactor;
    var netTradeInAdjustment = amountsCalculationParameters.tradeIn - amountsCalculationParameters.lien > retail + optionsAdjustment ? retail + optionsAdjustment : amountsCalculationParameters.tradeIn - amountsCalculationParameters.lien;
    var tradeInTaxesAdjustment = amountsCalculationParameters.tradeIn > retail + optionsAdjustment ? (retail + optionsAdjustment) * amountsCalculationParameters.taxesFactor : amountsCalculationParameters.tradeIn * amountsCalculationParameters.taxesFactor;
    return purchaseMethods.setIn(['cashPurchase', 'netTradeInAdjustment'], netTradeInAdjustment).setIn(['cashPurchase', 'tradeInTaxesAdjustment'], tradeInTaxesAdjustment).setIn(['cashPurchase', 'optionsAdjustment'], optionsAdjustment).setIn(['cashPurchase', 'optionsTaxesAdjustment'], optionsTaxesAdjustment);
}

function splitRetailAndIncludedOptions(purchaseMethods) {
    var selectedItemCodes = purchaseMethods.getSelectedOptionsAndColours();
    if ((0, _lodash.isEmpty)(purchaseMethods.getAllSelectedOptions()) || (0, _lodash.isEmpty)(selectedItemCodes)) {
        return purchaseMethods;
    }
    var optionsToReduceFromRetail = (0, _lodash.filter)(selectedItemCodes, function (selectedItemCode) {
        return (0, _lodash.includes)(purchaseMethods.cashPurchase.includedItemsCodes, selectedItemCode.selectionCode);
    });
    var optionsAdjustment = (0, _lodash.sumBy)(optionsToReduceFromRetail, function (option) {
        return option.retail;
    });
    var retail = purchaseMethods.cashPurchase.retail - optionsAdjustment;

    return purchaseMethods.set('cashPurchase', purchaseMethods.cashPurchase.set('retail', retail).set('optionsAdjustment', optionsAdjustment));
}

function resetOptionsAmounts(purchaseMethods) {
    var allSelectedOptions = purchaseMethods.getNonConfigurationSelectedOptions();
    var includedOtherFees = purchaseMethods.getOtherFeesAmountIncluded(allSelectedOptions);
    var includedProtection = purchaseMethods.getProtectionsAmountIncluded(allSelectedOptions);
    var optionsRetail = purchaseMethods.getOptionsAmount(allSelectedOptions);
    var optionsResidualizingAmount = purchaseMethods.getOptionsResidualizingAmount(allSelectedOptions);
    var otherFeesRetail = purchaseMethods.getOtherFeesAmount(allSelectedOptions, false) - includedOtherFees;
    var protectionsRetail = purchaseMethods.getProtectionsAmount(allSelectedOptions) - includedProtection;
    var dealerDiscounts = purchaseMethods.getDealerDiscountsAmount(allSelectedOptions);
    var employeeRebateAdjustment = purchaseMethods.employeeRebateAdjustment;

    var optionsAmounts = {
        retail: optionsRetail + otherFeesRetail + protectionsRetail - dealerDiscounts - employeeRebateAdjustment,
        residualRetail: optionsResidualizingAmount
    };

    var calculationParameters = purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    newPurchaseMethods = recalculatePayments(newPurchaseMethods, calculationParameters);

    var exteriorColourRetail = purchaseMethods.getExteriorColourAmount(allSelectedOptions);
    var exteriorColourResidualizingAmount = purchaseMethods.getExteriorColourResidualizingAmount(allSelectedOptions);

    var exteriorColourAmounts = {
        retail: exteriorColourRetail,
        residualRetail: exteriorColourResidualizingAmount
    };

    calculationParameters = newPurchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    newPurchaseMethods = recalculatePurchaseAmounts(newPurchaseMethods, calculationParameters);
    newPurchaseMethods = recalculatePayments(newPurchaseMethods, calculationParameters);

    var interiorColourRetail = purchaseMethods.getInteriorColourAmount(allSelectedOptions);
    var interiorColourResidualizingAmount = purchaseMethods.getInteriorColourResidualizingAmount(allSelectedOptions);

    var interiorColourAmounts = {
        retail: interiorColourRetail,
        residualRetail: interiorColourResidualizingAmount
    };

    calculationParameters = newPurchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    newPurchaseMethods = recalculatePurchaseAmounts(newPurchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function resetOptions(purchaseMethods, resetOption, add) {
    var selectedOptions = (0, _lodash.filter)(purchaseMethods.getAllSelectedOptions(), function (option) {
        return option.selectionCode !== resetOption.selectionCode;
    });
    var availableOptions = (0, _lodash.filter)(purchaseMethods.availableOptions, function (option) {
        return option.selectionCode !== resetOption.selectionCode;
    });

    if (add) {
        selectedOptions.push(resetOption.set('selected', true));
    } else {
        availableOptions.push(resetOption.set('selected', false));
    }

    return resetOptionsAmounts(purchaseMethods.set('selectedOptions', selectedOptions).set('availableOptions', availableOptions));
}

function resetPurchaseMethodsFromOriginData(dataOrigin, originPurchaseMethodsData, defaultPurchaseMethod, disclaimers) {
    if ((0, _lodash.isEmpty)(originPurchaseMethodsData) || !(0, _lodash.isArrayLikeObject)(originPurchaseMethodsData) && !(0, _lodash.isObjectLike)(originPurchaseMethodsData)) {
        return new _PurchaseMethodsModel2.default();
    }
    var lease = FinanceService.resetFinanceFromOriginData(dataOrigin, originPurchaseMethodsData, PurchaseMethodsConstants.LEASE, true);
    var finance = FinanceService.resetFinanceFromOriginData(dataOrigin, originPurchaseMethodsData, PurchaseMethodsConstants.FINANCE, !lease.selected);
    var cashPurchase = CashPurchaseService.resetCashPurchaseFromOriginData(dataOrigin, originPurchaseMethodsData, !lease.selected && !finance.selected);

    var taxesFactor = 0;
    var taxCodes = [];
    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        case DataOrigins.PAYMENT_CALCULATOR:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            taxesFactor = originPurchaseMethodsData[_dataConversions2.MODEL_TAXES.TAXES_FACTOR];
            taxCodes = originPurchaseMethodsData[_dataConversions2.MODEL_TAXES.TAX_CODES];
            break;
        case DataOrigins.VEHICLE_PAYMENTS:
            taxesFactor = originPurchaseMethodsData.taxesFactor;
            taxCodes = originPurchaseMethodsData.taxCodes;
            break;
        default:
            break;
    }

    if (defaultPurchaseMethod) {
        lease = lease.set('selected', defaultPurchaseMethod === PurchaseMethodsConstants.LEASE);
        finance = finance.set('selected', defaultPurchaseMethod === PurchaseMethodsConstants.FINANCE);
        cashPurchase = cashPurchase.set('selected', defaultPurchaseMethod !== PurchaseMethodsConstants.LEASE && defaultPurchaseMethod !== PurchaseMethodsConstants.FINANCE);
    }

    var highRebate = 0;
    var highRebatePurchaseMethod = _purchaseMethodsValues2.default.CASH;
    if (originPurchaseMethodsData[VEHICLE.HIGH_REBATE]) {
        var highRebateObject = originPurchaseMethodsData[VEHICLE.HIGH_REBATE][VEHICLE.HIGH_REBATE_INDEX];
        var highRebateTaxes = highRebateObject[VEHICLE.HIGH_REBATE_REBATES_TAXES] || 0;
        highRebate = highRebateObject[VEHICLE.HIGH_REBATE_RETAIL] + highRebateTaxes;
        highRebatePurchaseMethod = highRebateObject[VEHICLE.HIGH_REBATE_PURCHASE_METHOD];
    }

    var purchaseMethods = new _PurchaseMethodsModel2.default({
        taxesFactor: taxesFactor,
        taxCodes: taxCodes,
        highRebate: highRebate,
        highRebatePurchaseMethod: highRebatePurchaseMethod,
        lease: lease,
        finance: finance,
        cashPurchase: cashPurchase
    });

    var newPurchaseMethods = disclaimers ? purchaseMethods.set('disclaimers', disclaimers) : purchaseMethods;
    return dataOrigin === DataOrigins.VEHICLE_PAYMENTS ? splitRetailAndIncludedOptions(newPurchaseMethods) : newPurchaseMethods;
}

function resetPurchaseMethodsOptionsFromQuoteItems(purchaseMethods, quoteItems, availableQuoteItems) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItems)) {
        return purchaseMethods;
    }

    var selectedQuoteItems = (0, _lodash.filter)(quoteItems, function (quoteItem) {
        var selected = (quoteItem.flag & dataTypes.ITEM_FLAG.SELECTED) > 0;
        var hasDealerCashOnlyDiscount = (0, _lodash.includes)(quoteItem.supplierCodes, _dataConversions.CASH_PURCHASE_ONLY_DISCOUNT);
        return selected || hasDealerCashOnlyDiscount;
    });

    var availableItems = (0, _lodash.map)(availableQuoteItems, function (quoteItem) {
        return (0, _OptionService.resetOptionFromQuoteItem)(quoteItem, false);
    });

    var includedItemCodes = purchaseMethods.cashPurchase.includedItemsCodes;
    var selectedTerm = purchaseMethods.getSelectedFinanceTerm();
    if (selectedTerm) {
        includedItemCodes = selectedTerm.includedItemsCodes;
    }
    return purchaseMethods.set('availableOptions', availableItems).set('selectedOptions', (0, _lodash.map)(selectedQuoteItems, function (selectedQuoteItem) {
        var itemCode = selectedQuoteItem.code + '>' + selectedQuoteItem.supplier;
        return (0, _OptionService.resetOptionFromQuoteItem)(selectedQuoteItem, (0, _lodash.includes)(includedItemCodes, itemCode));
    }));
}

function setBestPaymentFinance(purchaseMethods) {
    var bestPaymentFinance = purchaseMethods.getBestPaymentFinance();
    return purchaseMethods.setIn(['lease', 'selected'], bestPaymentFinance === _purchaseMethodsValues2.default.LEASE).setIn(['finance', 'selected'], bestPaymentFinance === _purchaseMethodsValues2.default.FINANCE).setIn(['cashPurchase', 'selected'], false);
}

function selectPurchaseMethod(purchaseMethods, purchaseMethod) {
    return purchaseMethod === PurchaseMethodsConstants.BEST_PAYMENT ? setBestPaymentFinance(purchaseMethods) : purchaseMethods.setIn(['finance', 'selected'], purchaseMethod === PurchaseMethodsConstants.FINANCE).setIn(['lease', 'selected'], purchaseMethod === PurchaseMethodsConstants.LEASE).setIn(['cashPurchase', 'selected'], purchaseMethod === PurchaseMethodsConstants.CASH_PURCHASE);
}

function selectKMPlan(purchaseMethods, kmPlan) {
    var calculationParameters = purchaseMethods.getPaymentCalculationParameters();
    var selectedFinance = purchaseMethods.getSelectedFinance();
    if (!selectedFinance) {
        return purchaseMethods;
    }
    var newKMPlan = selectedFinance.getKMPlan(kmPlan);
    if (!newKMPlan) {
        return purchaseMethods;
    }
    var newPurchaseMethods = purchaseMethods.getIn(['lease', 'selected']) ? purchaseMethods.setIn(['lease', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['lease', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['lease', 'terms'], newKMPlan.terms) : purchaseMethods.setIn(['finance', 'annualKMAllowed'], newKMPlan.annualKMAllowed).setIn(['finance', 'endTermKMCost'], newKMPlan.endTermKMCost).setIn(['finance', 'terms'], newKMPlan.terms);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function selectTerm(purchaseMethods, term) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTerm(term);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setTargetPayment(purchaseMethods, targetPayment) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTargetPayment(targetPayment);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function selectPaymentFrequency(purchaseMethods, paymentFrequency) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithPaymentFrequency(paymentFrequency);
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setCashDown(purchaseMethods, cashDown) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithCashDown(parseFloat(cashDown));
    return recalculatePayments(purchaseMethods, calculationParameters);
}

function setTradeIn(purchaseMethods, tradeIn) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTradeIn(tradeIn);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setLien(purchaseMethods, lien) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithLien(lien);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setExteriorColourAmounts(purchaseMethods, exteriorColourAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithExteriorColour(exteriorColourAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setInteriorColourAmounts(purchaseMethods, interiorColourAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithInteriorColour(interiorColourAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setOptionsAmounts(purchaseMethods, optionsAmounts) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithOptions(optionsAmounts);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function setTaxesIncluded(purchaseMethods, taxesIncluded) {
    var calculationParameters = purchaseMethods.getPaymentCalculationWithTaxesIncluded(taxesIncluded);
    var newPurchaseMethods = recalculatePurchaseAmounts(purchaseMethods, calculationParameters);
    return recalculatePayments(newPurchaseMethods, calculationParameters);
}

function selectOptionsResolution(purchaseMethods, resolutionId) {
    return purchaseMethods.setIn(['optionsSelectionResolutions', 'resolutions'], (0, _lodash.map)(purchaseMethods.optionsSelectionResolutions.resolutions, function (resolution) {
        return resolution.set('selected', resolution.id === resolutionId);
    }));
}

function setSelectedFinanceBestPaymentTerm(purchaseMethods, maximumTerm) {
    var selectedFinance = purchaseMethods.getSelectedFinance();
    var bestPaymentTerm = selectedFinance ? selectedFinance.getBestPaymentTerm(maximumTerm) : undefined;
    if (!bestPaymentTerm) {
        return purchaseMethods;
    }
    return selectTerm(purchaseMethods, bestPaymentTerm.term);
}

function setDeliveryFee(purchaseMethods, addFee) {
    var deliveryFee = purchaseMethods.getDeliveryFee();
    if (!deliveryFee) {
        return purchaseMethods;
    }

    return resetOptions(purchaseMethods, deliveryFee, addFee);
}

function setDeposit(purchaseMethods, deposit) {
    var depositItem = deposit.checkout ? purchaseMethods.getCheckoutDeposit() : purchaseMethods.getReservationDeposit();
    if (!depositItem) {
        return purchaseMethods;
    }
    var depositAmount = -1 * deposit.override;

    return resetOptions(purchaseMethods, depositItem.set('retail', depositAmount).set('dueAtDelivery', true), true);
}

function getFormattedCurrencySplit(formattedCurrency) {
    var formattedCurrencySplit = {
        beforeDecimal: '',
        afterDecimal: ''
    };
    var decimalPoint = formattedCurrency.indexOf('.');
    if (decimalPoint === -1) {
        decimalPoint = formattedCurrency.indexOf(',');
    }
    if (decimalPoint > -1) {
        formattedCurrencySplit.beforeDecimal = formattedCurrency.substring(0, decimalPoint);
        formattedCurrencySplit.afterDecimal = formattedCurrency.substring(decimalPoint + 1, formattedCurrency.length);
    } else {
        formattedCurrencySplit.beforeDecimal = formattedCurrency;
    }
    return formattedCurrencySplit;
}

function resetProtections(purchaseMethods, protections) {
    var selectedOptions = (0, _lodash.filter)(purchaseMethods.getAllSelectedOptions(), function (option) {
        return option.dataType !== dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
    });

    var selectedProtections = [];
    (0, _lodash.forEach)(protections, function (protection) {
        selectedProtections = (0, _lodash.concat)(selectedProtections, protection.getSelectedItemsAndPackages());
    });

    return resetOptionsAmounts(purchaseMethods.set('selectedOptions', (0, _lodash.concat)(selectedOptions, selectedProtections)));
}

function resetSelectedOptions(purchaseMethods, options, configurationOptions) {
    var hasSelectedExtColour = !(0, _lodash.isUndefined)((0, _lodash.find)(options, function (option) {
        return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR;
    }));
    var hasSelectedIntColour = !(0, _lodash.isUndefined)((0, _lodash.find)(options, function (option) {
        return option.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && option.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM;
    }));

    var purchaseMethodsOptions = purchaseMethods.selectedOptions;
    if (hasSelectedExtColour) {
        purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethodsOptions, function (purchaseMethodsOption) {
            return !(purchaseMethodsOption.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && purchaseMethodsOption.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.EXTERIOR_COLOUR);
        });
    }
    if (hasSelectedIntColour) {
        purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethodsOptions, function (purchaseMethodsOption) {
            return !(purchaseMethodsOption.dataType === dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID && purchaseMethodsOption.typeID === dataTypes.DATA_TYPES.FEATURE.TYPES.INTERIOR_TRIM);
        });
    }
    purchaseMethodsOptions = (0, _lodash.intersectionBy)(options, purchaseMethodsOptions, 'selectionCode');

    return resetOptionsAmounts(purchaseMethods.set('configurationOptions', configurationOptions).set('selectedOptions', (0, _lodash.unionBy)(purchaseMethodsOptions, options, 'selectionCode')));
}

function resetSelectedIncentiveRebates(purchaseMethods) {
    var purchaseMethodsOptions = (0, _lodash.filter)(purchaseMethods.selectedOptions, function (selectedOption) {
        return selectedOption.supplier !== dataTypes.SUPPLIER_INCENTIVE || selectedOption.userSelected;
    });

    return purchaseMethods.set('selectedOptions', purchaseMethodsOptions);
}

exports.default = {
    getFormattedCurrencySplit: getFormattedCurrencySplit,
    recalculatePayments: recalculatePayments,
    recalculatePurchaseAmounts: recalculatePurchaseAmounts,
    resetOptions: resetOptions,
    resetOptionsAmounts: resetOptionsAmounts,
    resetProtections: resetProtections,
    resetPurchaseMethodsFromOriginData: resetPurchaseMethodsFromOriginData,
    resetPurchaseMethodsOptionsFromQuoteItems: resetPurchaseMethodsOptionsFromQuoteItems,
    resetSelectedOptions: resetSelectedOptions,
    resetSelectedIncentiveRebates: resetSelectedIncentiveRebates,
    selectKMPlan: selectKMPlan,
    selectOptionsResolution: selectOptionsResolution,
    selectPaymentFrequency: selectPaymentFrequency,
    selectPurchaseMethod: selectPurchaseMethod,
    selectTerm: selectTerm,
    setBestPaymentFinance: setBestPaymentFinance,
    setCashDown: setCashDown,
    setDeliveryFee: setDeliveryFee,
    setDeposit: setDeposit,
    setExteriorColourAmounts: setExteriorColourAmounts,
    setInteriorColourAmounts: setInteriorColourAmounts,
    setLien: setLien,
    setOptionsAmounts: setOptionsAmounts,
    setSelectedFinanceBestPaymentTerm: setSelectedFinanceBestPaymentTerm,
    setTargetPayment: setTargetPayment,
    setTaxesIncluded: setTaxesIncluded,
    setTradeIn: setTradeIn,
    splitRetailAndIncludedOptions: splitRetailAndIncludedOptions
};

/***/ }),

/***/ "../widget-commons-vehicle/src/PurchaseMethods/services/TermService/TermService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetTermFromOriginData = resetTermFromOriginData;
exports.recalculateTermPayment = recalculateTermPayment;

var _lodash = __webpack_require__("lodash");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/dataConversions.js");

var _paymentFrequencies = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/paymentFrequencies.js");

var _TermModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/TermModel.js");

var _TermModel2 = _interopRequireDefault(_TermModel);

var _PaymentFrequencyService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PaymentFrequencyService/PaymentFrequencyService.js");

var PaymentFrequencyService = _interopRequireWildcard(_PaymentFrequencyService);

var _CashPurchaseService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/CashPurchaseService/CashPurchaseService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function resetTermFromCollectionData(collectionTermData, termIndex) {
    var term = collectionTermData.term,
        apr = collectionTermData.apr,
        frequenciesPayments = collectionTermData.frequenciesPayments,
        cashDown = collectionTermData.cashDown,
        discount = collectionTermData.discount,
        rebate = collectionTermData.rebate,
        rebateTaxes = collectionTermData.rebateTaxes,
        rebateAtDelivery = collectionTermData.rebateAtDelivery,
        rebateAtStandardRate = collectionTermData.rebateAtStandardRate,
        rebates = collectionTermData.rebates,
        financedAmount = collectionTermData.financedAmount,
        financedAmountWithTaxes = collectionTermData.financedAmountWithTaxes,
        residualAmount = collectionTermData.residualAmount;


    var paymentFrequencies = {};
    var defaultFrequency = void 0;
    (0, _lodash.forEach)(frequenciesPayments, function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromCollectionData(frequency, cashDown);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var rebatesDetailsData = (0, _lodash.isEmpty)(rebates) ? [] : rebates;
    var rebatesDetails = (0, _CashPurchaseService.getRebatesDetailsFromData)(rebatesDetailsData);

    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: term,
        termIndex: termIndex,
        apr: apr,
        residualRate: 0,
        cashDown: cashDown,
        discounts: discount || 0,
        rebates: rebate,
        rebatesTaxes: rebateTaxes || 0,
        rebatesAtDelivery: rebateAtDelivery,
        rebatesAtStandardRate: rebateAtStandardRate || 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: financedAmount,
        financedAmountWithTaxes: financedAmountWithTaxes,
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: residualAmount,
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment,
        rebatesDetails: rebatesDetails
    });
}

function resetTermFromCalculatorData(calculatorTermData, termIndex) {
    var term = calculatorTermData.term,
        apr = calculatorTermData.apr,
        frequencies = calculatorTermData.frequencies,
        financedAmount = calculatorTermData.financedAmount,
        financedAmountWithTaxes = calculatorTermData.financedAmountWithTaxes,
        residualAmount = calculatorTermData.residualAmount;


    var paymentFrequencies = {};
    var cashDown = 0;
    (0, _lodash.forEach)(frequencies, function (frequency) {
        if (cashDown < frequency.cashDown) {
            cashDown = frequency.cashDown;
        }
    });

    var defaultFrequency = void 0;
    (0, _lodash.forEach)(frequencies, function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromCalculatorData(frequency, cashDown);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: term,
        termIndex: termIndex,
        apr: apr,
        residualRate: 0,
        cashDown: cashDown,
        discounts: 0,
        rebates: 0,
        rebatesTaxes: 0,
        rebatesAtDelivery: 0,
        rebatesTaxesAtDelivery: 0,
        rebatesAtStandardRate: 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: financedAmount,
        financedAmountWithTaxes: financedAmountWithTaxes,
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: residualAmount,
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment
    });
}

function resetTermFromModelData(modelTermData, termIndex) {
    if (modelTermData.length <= _dataConversions.MODEL_TERM.PAYMENT_FREQUENCIES) {
        return new _TermModel2.default();
    }

    var paymentFrequencies = {};
    var defaultFrequency = void 0;
    (0, _lodash.forEach)(modelTermData[_dataConversions.MODEL_TERM.PAYMENT_FREQUENCIES], function (frequency) {
        var paymentFrequency = PaymentFrequencyService.resetPaymentFrequencyFromModelData(frequency, modelTermData[_dataConversions.MODEL_TERM.CASH_DOWN]);
        paymentFrequencies[paymentFrequency.paymentFrequency] = paymentFrequency;
        defaultFrequency = paymentFrequency.paymentFrequency;
    });

    if (paymentFrequencies[_paymentFrequencies.WEEKLY]) {
        defaultFrequency = _paymentFrequencies.WEEKLY;
    }

    var rebatesDetailsData = (0, _lodash.isEmpty)(modelTermData[_dataConversions.MODEL_TERM.REBATES_DETAILS]) ? [] : modelTermData[_dataConversions.MODEL_TERM.REBATES_DETAILS];
    var rebatesDetails = (0, _CashPurchaseService.getRebatesDetailsFromData)(rebatesDetailsData);

    var includedItemsCodes = modelTermData[_dataConversions.MODEL_TERM.INCLUDED_CODES] || [];

    var cashDown = modelTermData[_dataConversions.MODEL_TERM.CASH_DOWN];
    var financedAmountAdjustment = cashDown ? Math.round(cashDown * 100) / 100 * -1 : 0;

    return new _TermModel2.default({
        term: modelTermData[_dataConversions.MODEL_TERM.TERM],
        termIndex: termIndex,
        apr: modelTermData[_dataConversions.MODEL_TERM.APR],
        residualRate: modelTermData[_dataConversions.MODEL_TERM.RESIDUAL_RATE],
        cashDown: cashDown,
        discounts: modelTermData[_dataConversions.MODEL_TERM.DISCOUNT],
        rebates: modelTermData[_dataConversions.MODEL_TERM.REBATE],
        rebatesTaxes: modelTermData[_dataConversions.MODEL_TERM.REBATE_TAXES] || 0,
        rebatesAtDelivery: modelTermData[_dataConversions.MODEL_TERM.REBATE_AT_DELIVERY],
        rebatesTaxesAtDelivery: modelTermData[_dataConversions.MODEL_TERM.REBATE_TAXES_AT_DELIVERY] || 0,
        rebatesAtStandardRate: modelTermData[_dataConversions.MODEL_TERM.REBATE_AT_STANDARD_RATE] || 0,
        paymentFrequencies: paymentFrequencies,
        paymentFrequency: defaultFrequency,
        payment: paymentFrequencies[defaultFrequency].payment,
        paymentTaxes: paymentFrequencies[defaultFrequency].paymentTaxes,
        financedAmount: modelTermData[_dataConversions.MODEL_TERM.FINANCED_AMOUNT],
        financedAmountWithTaxes: modelTermData[_dataConversions.MODEL_TERM.FINANCED_AMOUNT_WITH_TAXES],
        financedAmountAdjustment: financedAmountAdjustment,
        financedAmountWithTaxesAdjustment: financedAmountAdjustment,
        residualAmount: modelTermData[_dataConversions.MODEL_TERM.RESIDUAL_AMOUNT],
        cashDownPaymentAdjustment: paymentFrequencies[defaultFrequency].cashDownPaymentAdjustment,
        netTradeInPaymentAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentAdjustment,
        netTradeInPaymentTaxesAdjustment: paymentFrequencies[defaultFrequency].netTradeInPaymentTaxesAdjustment,
        calculatedNetPayment: paymentFrequencies[defaultFrequency].calculatedNetPayment,
        calculatedPayment: paymentFrequencies[defaultFrequency].calculatedPayment,
        includedItemsCodes: includedItemsCodes,
        rebatesDetails: rebatesDetails
    });
}

function resetTermFromOriginData(dataOrigin, originTermData, termIndex) {
    if ((0, _lodash.isEmpty)(originTermData) || !(0, _lodash.isObjectLike)(originTermData)) {
        return new _TermModel2.default();
    }

    switch (dataOrigin) {
        case DataOrigins.MODELS_COLLECTION:
            return resetTermFromCollectionData(originTermData, termIndex);

        case DataOrigins.PAYMENT_CALCULATOR:
            return resetTermFromCalculatorData(originTermData, termIndex);

        case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
            return resetTermFromModelData(originTermData, termIndex);

        default:
            return new _TermModel2.default();
    }
}

function recalculateTermPayment(term, paymentCalculationParameters) {
    if (term.get('term') === 0 || !(0, _lodash.isObjectLike)(paymentCalculationParameters)) {
        return term;
    }

    var paymentFrequency = paymentCalculationParameters.paymentFrequency,
        taxesIncluded = paymentCalculationParameters.taxesIncluded,
        taxesFactor = paymentCalculationParameters.taxesFactor,
        cashDown = paymentCalculationParameters.cashDown,
        tradeIn = paymentCalculationParameters.tradeIn,
        lien = paymentCalculationParameters.lien,
        exteriorColourRetail = paymentCalculationParameters.exteriorColourRetail,
        exteriorColourResidualRetail = paymentCalculationParameters.exteriorColourResidualRetail,
        interiorColourRetail = paymentCalculationParameters.interiorColourRetail,
        interiorColourResidualRetail = paymentCalculationParameters.interiorColourResidualRetail,
        optionsTotalRetail = paymentCalculationParameters.optionsTotalRetail,
        optionsTotalResidualRetail = paymentCalculationParameters.optionsTotalResidualRetail;


    var paymentFrequencies = term.get('paymentFrequencies');
    var currentPaymentFrequency = paymentFrequencies[paymentFrequency];
    if (!currentPaymentFrequency) {
        return term;
    }
    var payment = currentPaymentFrequency.payment;
    var paymentTaxes = currentPaymentFrequency.paymentTaxes;

    // This variable is used as a multiplier for taxes calculations
    var taxesIncludedFactor = taxesIncluded ? 1 : 0;

    var newTerm = term.set('paymentFrequency', currentPaymentFrequency.paymentFrequency);

    var optionsResidualRetail = exteriorColourResidualRetail + interiorColourResidualRetail + optionsTotalResidualRetail;
    var optionsPaymentAdjustment = newTerm.calculatePaymentAdjustment(exteriorColourRetail + interiorColourRetail + optionsTotalRetail, optionsResidualRetail);
    var optionsPaymentTaxesAdjustment = optionsPaymentAdjustment * taxesFactor;

    var netTradeInPaymentAdjustment = newTerm.calculatePaymentAdjustment(tradeIn - lien, 0);
    if (netTradeInPaymentAdjustment > payment + optionsPaymentAdjustment) {
        netTradeInPaymentAdjustment = payment + optionsPaymentAdjustment;
    }

    var netTradeInPaymentTaxesAdjustment = newTerm.calculatePaymentAdjustment(tradeIn * taxesFactor, 0);
    if (netTradeInPaymentTaxesAdjustment > paymentTaxes + optionsPaymentTaxesAdjustment) {
        netTradeInPaymentTaxesAdjustment = paymentTaxes + optionsPaymentTaxesAdjustment;
    }

    var calculatedNetPayment = payment + optionsPaymentAdjustment - netTradeInPaymentAdjustment + (paymentTaxes + optionsPaymentTaxesAdjustment - netTradeInPaymentTaxesAdjustment) * taxesIncludedFactor;

    var cashDownPaymentAdjustment = newTerm.calculatePaymentAdjustment(cashDown, 0);
    if (cashDownPaymentAdjustment > calculatedNetPayment) {
        cashDownPaymentAdjustment = calculatedNetPayment;
    }

    var financedAmountAdjustment = exteriorColourRetail + interiorColourRetail + optionsTotalRetail - (tradeIn - lien) - cashDown;
    var financedAmountWithTxAdjustment = financedAmountAdjustment + (exteriorColourRetail + interiorColourRetail + optionsTotalRetail - tradeIn) * taxesFactor;

    var calculatedPayment = calculatedNetPayment - cashDownPaymentAdjustment;

    return newTerm.set('cashDown', cashDown).set('payment', payment).set('paymentTaxes', paymentTaxes).set('optionsResidualRetail', optionsResidualRetail).set('optionsPaymentAdjustment', optionsPaymentAdjustment).set('optionsPaymentTaxesAdjustment', optionsPaymentTaxesAdjustment).set('netTradeInPaymentAdjustment', netTradeInPaymentAdjustment).set('netTradeInPaymentTaxesAdjustment', netTradeInPaymentTaxesAdjustment).set('calculatedNetPayment', calculatedNetPayment).set('cashDownPaymentAdjustment', cashDownPaymentAdjustment).set('calculatedPayment', calculatedPayment).set('financedAmountAdjustment', financedAmountAdjustment).set('financedAmountWithTaxesAdjustment', financedAmountWithTxAdjustment);
}

exports.default = {
    resetTermFromCollectionData: resetTermFromCollectionData,
    resetTermFromCalculatorData: resetTermFromCalculatorData,
    resetTermFromModelData: resetTermFromModelData,
    resetTermFromOriginData: resetTermFromOriginData,
    recalculateTermPayment: recalculateTermPayment
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/actions/quoteActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_QUOTE = exports.SET_QUOTE = 'SET_QUOTE';
var SET_QUOTE_MODIFIED = exports.SET_QUOTE_MODIFIED = 'SET_QUOTE_MODIFIED';
var SET_QUOTE_REVISION = exports.SET_QUOTE_REVISION = 'SET_QUOTE_REVISION';
var SET_QUOTE_VEHICLE = exports.SET_QUOTE_VEHICLE = 'SET_QUOTE_VEHICLE';
var SET_QUOTE_MODEL_YEAR = exports.SET_QUOTE_MODEL_YEAR = 'SET_QUOTE_MODEL_YEAR';
var SET_LEAD_TYPE = exports.SET_LEAD_TYPE = 'SET_LEAD_TYPE';
var SET_STATUS = exports.SET_STATUS = 'SET_STATUS';
var SET_SECURITY_TOKEN = exports.SET_SECURITY_TOKEN = 'SET_SECURITY_TOKEN';
var SET_QUOTE_PURCHASE_METHODS = exports.SET_QUOTE_PURCHASE_METHODS = 'SET_QUOTE_PURCHASE_METHODS';

exports.default = {
    SET_QUOTE: SET_QUOTE,
    SET_QUOTE_MODIFIED: SET_QUOTE_MODIFIED,
    SET_QUOTE_REVISION: SET_QUOTE_REVISION,
    SET_QUOTE_VEHICLE: SET_QUOTE_VEHICLE,
    SET_QUOTE_MODEL_YEAR: SET_QUOTE_MODEL_YEAR,
    SET_LEAD_TYPE: SET_LEAD_TYPE,
    SET_STATUS: SET_STATUS,
    SET_SECURITY_TOKEN: SET_SECURITY_TOKEN,
    SET_QUOTE_PURCHASE_METHODS: SET_QUOTE_PURCHASE_METHODS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/actions/quoteActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setQuote = setQuote;
exports.setQuoteModified = setQuoteModified;
exports.setQuoteRevision = setQuoteRevision;
exports.setQuoteVehicle = setQuoteVehicle;
exports.setQuoteModelYear = setQuoteModelYear;
exports.setQuoteLeadType = setQuoteLeadType;
exports.setQuoteStatus = setQuoteStatus;
exports.setQuoteSecurityToken = setQuoteSecurityToken;
exports.setQuotePurchaseMethods = setQuotePurchaseMethods;

var _lodash = __webpack_require__("lodash");

var _quoteActionTypes = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setQuote(quote) {
    return { type: _quoteActionTypes2.default.SET_QUOTE, quote: quote };
}

function setQuoteModified() {
    return { type: _quoteActionTypes2.default.SET_QUOTE_MODIFIED };
}

function setQuoteRevision(quoteRevisions) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.quote && state.quote.id && !(0, _lodash.isEmpty)(quoteRevisions)) {
            var currentQuoteRevision = (0, _lodash.find)(quoteRevisions, function (quoteRevision) {
                return quoteRevision.id === state.quote.id;
            });

            if (currentQuoteRevision) {
                // eslint-disable no-underscore-dangle
                var revision = currentQuoteRevision.__revision;
                dispatch({ type: _quoteActionTypes2.default.SET_QUOTE_REVISION, revision: revision });
            }
        }
    };
}

function setQuoteVehicle(vehicle) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_VEHICLE, vehicle: vehicle };
}

function setQuoteModelYear(modelYear) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_MODEL_YEAR, modelYear: modelYear };
}

function setQuoteLeadType(leadType) {
    return { type: _quoteActionTypes2.default.SET_LEAD_TYPE, leadType: leadType };
}

function setQuoteStatus(status) {
    return { type: _quoteActionTypes2.default.SET_STATUS, status: status };
}

function setQuoteSecurityToken(securityToken) {
    return { type: _quoteActionTypes2.default.SET_SECURITY_TOKEN, securityToken: securityToken };
}

function setQuotePurchaseMethods(purchaseMethods) {
    return { type: _quoteActionTypes2.default.SET_QUOTE_PURCHASE_METHODS, purchaseMethods: purchaseMethods };
}

exports.default = {
    setQuote: setQuote,
    setQuoteModified: setQuoteModified,
    setQuoteRevision: setQuoteRevision,
    setQuoteVehicle: setQuoteVehicle,
    setQuoteModelYear: setQuoteModelYear,
    setQuoteLeadType: setQuoteLeadType,
    setQuoteStatus: setQuoteStatus,
    setQuoteSecurityToken: setQuoteSecurityToken,
    setQuotePurchaseMethods: setQuotePurchaseMethods
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/AddToGarage/AddToGarageButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsLeads = __webpack_require__("../widget-commons-leads/src/index.js");

var _QuoteModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _VehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js");

var _VehicleService2 = _interopRequireDefault(_VehicleService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddToGarageButton = function (_React$Component) {
    _inherits(AddToGarageButton, _React$Component);

    function AddToGarageButton(props) {
        _classCallCheck(this, AddToGarageButton);

        var _this = _possibleConstructorReturn(this, (AddToGarageButton.__proto__ || Object.getPrototypeOf(AddToGarageButton)).call(this, props));

        _this.onClick = _this.onClick.bind(_this);
        _this.saveToGarage = _this.saveToGarage.bind(_this);
        _this.addToGarageLeadUpdate = _this.addToGarageLeadUpdate.bind(_this);
        return _this;
    }

    _createClass(AddToGarageButton, [{
        key: 'onClick',
        value: function onClick() {
            var quote = this.props.quote;


            if (quote.vehicle) {
                _widgetCommonsGeneral.AnalyticsService.gaTrigger(_VehicleService2.default.isVehicleNew(quote.vehicle) ? _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_NEW(quote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_USED(quote.vehicle.model));
            }

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                LoginModal.addCallbacks({
                    onClose: this.saveToGarage
                });
                LoginModal.open({ quote: quote });
            } else {
                this.saveToGarage(false);
            }
        }
    }, {
        key: 'addToGarageLeadUpdate',
        value: function addToGarageLeadUpdate(quote) {
            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(quote).submit();
        }
    }, {
        key: 'saveToGarage',
        value: function saveToGarage() {
            var withAuthentication = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var quote = this.props.quote;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                if (!withAuthentication && quote.vehicle && !_VehicleService2.default.isVehicleNew(quote.vehicle)) {
                    this.addToGarageLeadUpdate(quote);
                }
                this.props.onClick(withAuthentication);
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var quote = this.props.quote;

            var isQuoteInGarage = quote.isQuoteInGarage();
            var garageTitle = isQuoteInGarage ? _widgetCommonsCoreServices.LocaleService.t('QUOTE.BTN_APPLY_QUOTE_CHANGES') : _widgetCommonsCoreServices.LocaleService.t('QUOTE.BTN_ADD_TO_GARAGE');
            var garageButtonClasses = ['widget-vehicle-quote-btn-secondary', 'sr-button-outline-2'];
            var showButton = quote.isDirty() || !isQuoteInGarage;

            if (this.props.buttonClass) {
                garageButtonClasses.push(this.props.buttonClass);
            }
            if (quote.isDirty()) {
                garageButtonClasses.push('is-modify');
            }

            return showButton && _react2.default.createElement(
                'button',
                {
                    className: garageButtonClasses.join(' '),
                    onClick: this.onClick,
                    title: garageTitle,
                    type: 'button'
                },
                _react2.default.createElement('icon', { className: 'icon-Mon-Garage' }),
                _react2.default.createElement(
                    'span',
                    null,
                    garageTitle
                )
            );
        }
    }]);

    return AddToGarageButton;
}(_react2.default.Component);

AddToGarageButton.defaultProps = {
    buttonClass: ''
};

AddToGarageButton.propTypes = {
    buttonClass: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    quote: _propTypes2.default.instanceOf(_QuoteModel2.default).isRequired
};

AddToGarageButton.displayName = 'AddToGarageButton';

exports.default = AddToGarageButton;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/AddToGarageV25/AddToGarageV25.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsLeads = __webpack_require__("../widget-commons-leads/src/index.js");

var _QuoteService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _ShowroomService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

var _VehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js");

var _VehicleService2 = _interopRequireDefault(_VehicleService);

var _errorCodes = __webpack_require__("../widget-build-and-quote/src/constants/errorCodes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// SHOWROOM V2.5
var AddToGarageV25 = function () {
    function AddToGarageV25() {
        _classCallCheck(this, AddToGarageV25);

        this.quote = null;
        this.onClick = this.onClick.bind(this);
        this.loadQuote = this.loadQuote.bind(this);
        this.addToGarageLeadUpdate = this.addToGarageLeadUpdate.bind(this);
        this.saveToGarage = this.saveToGarage.bind(this);
        this.setQuoteLead = this.setQuoteLead.bind(this);
        this.isQuoteInGarage = this.isQuoteInGarage.bind(this);
    }

    _createClass(AddToGarageV25, [{
        key: 'onClick',
        value: function onClick(quoteId) {
            var _this = this;

            if (!quoteId) return;

            _ShowroomService2.default.loadQuoteV25(quoteId).then(function (quote) {
                _this.quote = quote;

                var mappingQuote = quote;

                if (mappingQuote.vehicle) {
                    _widgetCommonsGeneral.AnalyticsService.gaTrigger(_VehicleService2.default.isVehicleNew(mappingQuote.vehicle) ? _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_NEW(mappingQuote.vehicle.model) : _widgetCommonsGeneral.TRACKING_TAGS.ADD_TO_GARAGE_CTA_USED(mappingQuote.vehicle.model));
                }

                if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                    var LoginModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
                    LoginModal.addCallbacks({
                        onClose: _this.saveToGarage
                    });
                    LoginModal.open({ mappingQuote: mappingQuote });
                } else {
                    _this.saveToGarage(false);
                }
            }).catch(function (error) {
                throw error;
            });
        }
    }, {
        key: 'setQuoteLead',
        value: function setQuoteLead(leadType) {
            var _this2 = this;

            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase();

            var mappingQuote = _QuoteService2.default.resetQuoteFromVehicle(this.quote, location, leadType, this.quote.vehicle);

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return _ShowroomService2.default.saveQuote(mappingQuote.getShowroomQuote()).then(function (showroomQuote) {
                    var mappedQuote = _QuoteService2.default.resetQuoteFromShowroomSave(mappingQuote, showroomQuote);

                    _this2.quote = mappedQuote;

                    _this2.dispatchAddToGarage();

                    // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
                    setTimeout(function () {
                        new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(mappedQuote).submit();

                        _this2.dispatchVdp(mappedQuote.id);
                    }, 2000);
                }).catch(function (error) {
                    if (error && error.response && error.response.data && error.response.data.error === _errorCodes.BAD_QUOTE_REVISION) {
                        _this2.reloadAndSaveQuote(_this2.quote);
                    } else {
                        throw error;
                    }
                });
            }
            return true;
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote(quoteId) {
            var _this3 = this;

            if (this.quote === null) {
                return _ShowroomService2.default.loadQuoteV25(quoteId).then(function (quote) {
                    _this3.quote = quote;
                }).catch(function (error) {
                    throw error;
                });
            }
            return null;
        }
    }, {
        key: 'dispatchAddToGarage',
        value: function dispatchAddToGarage() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new Event('sm360.widgets.garage.added'));
            }
        }
    }, {
        key: 'dispatchVdp',
        value: function dispatchVdp(quoteId) {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            var event = new CustomEvent('add-to-garage:success', {
                bubbles: true,
                cancelable: false,
                detail: { quoteId: quoteId }
            });

            if ($window) {
                $window.document.dispatchEvent(event);
                window.location.href = this.quote.getVehicleRedirectionFromQuote();
            }
        }
    }, {
        key: 'reloadAndSaveQuote',
        value: function reloadAndSaveQuote(quote) {
            var _this4 = this;

            _ShowroomService2.default.loadQuote(quote.id).then(function (upToDateQuote) {
                var mergedQuote = quote.set('leadId', upToDateQuote.leadId).set('revision', upToDateQuote.revision);

                return _ShowroomService2.default.saveQuote(mergedQuote.getShowroomQuote()).then(function (showroomQuote) {
                    _this4.dispatchAddToGarage();
                    _this4.quote = showroomQuote;
                });
            });
        }
    }, {
        key: 'addToGarageLeadUpdate',
        value: function addToGarageLeadUpdate(quote) {
            // TODO: Effectuer les modifications avec le nouveau systeme de lead unique lors de la futur migration (SHOWROOM-3618)
            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(_widgetCommonsLeads.LEAD_TYPES.ACCOUNT_CREATION).addQuote(quote).submit();
        }
    }, {
        key: 'saveToGarage',
        value: function saveToGarage() {
            var withAuthentication = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var mappingQuote = this.quote;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                if (!withAuthentication && mappingQuote.vehicle && !_VehicleService2.default.isVehicleNew(mappingQuote.vehicle)) {
                    this.addToGarageLeadUpdate(mappingQuote);
                }
                this.setQuoteLead('SAVE_TO_GARAGE');
            }
            return true;
        }
    }, {
        key: 'isQuoteInGarage',
        value: function isQuoteInGarage(quoteId) {
            var response = false;
            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) return false;
            return _ShowroomService2.default.loadQuotes().then(function (res) {
                if (res) {
                    res.forEach(function (e) {
                        if (e.id === quoteId) response = true;
                    });
                }
                return response;
            });
        }
    }]);

    return AddToGarageV25;
}();

exports.default = AddToGarageV25;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/index.js");

var _AmountLineItem = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccessoriesListing = function (_React$Component) {
    _inherits(AccessoriesListing, _React$Component);

    function AccessoriesListing(props) {
        _classCallCheck(this, AccessoriesListing);

        var _this = _possibleConstructorReturn(this, (AccessoriesListing.__proto__ || Object.getPrototypeOf(AccessoriesListing)).call(this, props));

        _this.state = {
            showAccessoriesDetails: false
        };

        _this.showAccessoriesDetails = _this.showAccessoriesDetails.bind(_this);
        return _this;
    }

    _createClass(AccessoriesListing, [{
        key: 'showAccessoriesDetails',
        value: function showAccessoriesDetails() {
            this.setState(function (prevState) {
                return { showAccessoriesDetails: !prevState.showAccessoriesDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                accessoriesOptions = _props.accessoriesOptions,
                purchaseMethods = _props.purchaseMethods;

            var totalOptionsAmount = purchaseMethods.getOptionsAmount(accessoriesOptions);
            var accessoriesOptionsRenderBlock = accessoriesOptions.map(function (accessoryOption) {
                return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                    label: accessoryOption.description,
                    amount: accessoryOption.retail,
                    icon: 'plus'
                });
            });
            return _react2.default.createElement(
                'div',
                { className: 'SidebarSummary__accessoriesDetails' },
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_ACCESSORIES_TITLE'),
                        !this.state.showAccessoriesDetails && _react2.default.createElement(
                            'span',
                            { className: 'SidebarSummary__groupTitle--subtitle' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELECTED_ACCESSORIES_AMOUNT', {
                                amount: accessoriesOptions.length
                            })
                        )
                    ),
                    accessoriesOptions.length > 0 && _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showAccessoriesDetails },
                        !this.state.showAccessoriesDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showAccessoriesDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'protectionsListing' },
                        accessoriesOptionsRenderBlock
                    )
                ),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL'), amount: totalOptionsAmount })
            );
        }
    }]);

    return AccessoriesListing;
}(_react2.default.Component);

AccessoriesListing.defaultProps = {
    accessoriesOptions: []
};

AccessoriesListing.propTypes = {
    accessoriesOptions: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel)
};

AccessoriesListing.displayName = 'AccessoriesListing';

exports.default = AccessoriesListing;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("../widget-commons-vehicle/src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountLineItem = function AmountLineItem(_ref) {
    var amount = _ref.amount,
        label = _ref.label,
        showZero = _ref.showZero;

    return amount !== 0 || showZero ? _react2.default.createElement(
        'li',
        { className: 'SidebarSummary__listingAmount--item sr-text-regular amountLineItem' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value' },
            _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats2.default.CURRENCY_0)
        )
    ) : null;
};

AmountLineItem.defaultProps = {
    showZero: false
};

AmountLineItem.propTypes = {
    amount: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired,
    showZero: _propTypes2.default.bool
};

AmountLineItem.displayName = 'AmountLineItem';

exports.default = AmountLineItem;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _currencyFormats = __webpack_require__("../widget-commons-vehicle/src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

__webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmountLineItemWithIcon = function AmountLineItemWithIcon(_ref) {
    var amount = _ref.amount,
        icon = _ref.icon,
        label = _ref.label;

    var iconClass = 'icon-' + icon;
    var iconElem = _react2.default.createElement('icon', { className: iconClass });

    return amount !== 0 ? _react2.default.createElement(
        'li',
        { className: 'amountLineItemWithIcon clearfix' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            iconElem,
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value sr-text-bold' },
            _widgetCommonsCoreServices.LocaleService.l(amount, _currencyFormats2.default.CURRENCY_0)
        )
    ) : _react2.default.createElement(
        'li',
        { className: 'amountLineItemWithIcon clearfix' },
        _react2.default.createElement(
            'span',
            { className: 'label' },
            iconElem,
            label
        ),
        _react2.default.createElement(
            'span',
            { className: 'value sr-text-bold' },
            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PRICE_ON_DEMAND')
        )
    );
};

AmountLineItemWithIcon.propTypes = {
    icon: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    amount: _propTypes2.default.number.isRequired
};

AmountLineItemWithIcon.displayName = 'AmountLineItemWithIcon';

exports.default = AmountLineItemWithIcon;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/index.js");

var _AmountLineItem = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CashPurchase = function CashPurchase(_ref) {
    var purchaseMethods = _ref.purchaseMethods;

    var purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    var purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    var accessoriesOptionsPackages = purchaseMethods.getSelectedOptions();

    var cashDown = purchaseMethodAmounts.cashDown,
        discounts = purchaseMethodAmounts.discounts,
        exteriorColour = purchaseMethodAmounts.exteriorColour,
        freightPDI = purchaseMethodAmounts.freightPDI,
        interiorColour = purchaseMethodAmounts.interiorColour,
        lien = purchaseMethodAmounts.lien,
        modelTrim = purchaseMethodAmounts.modelTrim,
        options = purchaseMethodAmounts.options,
        otherFees = purchaseMethodAmounts.otherFees,
        protections = purchaseMethodAmounts.protections,
        rebates = purchaseMethodAmounts.rebates,
        taxAndDuty = purchaseMethodAmounts.taxAndDuty,
        taxes = purchaseMethodAmounts.taxes,
        tradeIn = purchaseMethodAmounts.tradeIn;


    var allInPrice = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - discounts;

    var totalPriceBeforeTaxes = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - (discounts + tradeIn);

    var totalPriceAfterTaxes = totalPriceBeforeTaxes + taxes + lien - (rebates + cashDown);

    var deliveryCashDown = purchaseMethodDeliveryAmounts.deliveryCashDown,
        deliveryFees = purchaseMethodDeliveryAmounts.deliveryFees,
        deliveryTaxes = purchaseMethodDeliveryAmounts.deliveryTaxes,
        deposit = purchaseMethodDeliveryAmounts.deposit,
        upfrontPayment = purchaseMethodDeliveryAmounts.upfrontPayment;


    var totalDueAtDelivery = totalPriceAfterTaxes + deliveryFees + deliveryTaxes + deposit;
    var protectionsWithIcons = accessoriesOptionsPackages.map(function (protectionPackage) {
        return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
            label: protectionPackage.description,
            amount: protectionPackage.retail,
            icon: 'plus'
        });
    });

    return _react2.default.createElement(
        'div',
        { className: 'CashPurchaseSummary' },
        _react2.default.createElement(
            'div',
            { className: 'vehicle__salePrice' },
            _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: allInPrice - protections,
                icon: 'review'
            }),
            protectionsWithIcons
        ),
        _react2.default.createElement(
            'ul',
            { className: 'SidebarSummary__listingAmount' },
            _react2.default.createElement(
                'h3',
                { className: 'sr-title' },
                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRANSACTION_TITLE_CASH_PURCHASE')
            ),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELLING_PRICE'), amount: modelTrim }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DISCOUNTS'), amount: discounts }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.EXTERIOR_COLOUR'), amount: exteriorColour }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OPTIONS'), amount: interiorColour + options }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.FREIGHT_PDI'), amount: freightPDI }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES_AND_DUTIES'), amount: taxAndDuty }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: otherFees }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PROTECTIONS'), amount: protections }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRADE_IN'), amount: tradeIn }),
            _react2.default.createElement(_AmountLineItem2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: totalPriceBeforeTaxes
            }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: taxes }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.LIEN'), amount: lien }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.REBATES'), amount: rebates }),
            _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: cashDown }),
            _react2.default.createElement(_AmountLineItem2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES'),
                amount: totalPriceAfterTaxes
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'deliver-infos' },
            _react2.default.createElement(
                'h3',
                { className: 'sr-title' },
                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')
            ),
            _react2.default.createElement(
                'ul',
                { className: 'SidebarSummary__listingAmount' },
                _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES'),
                    amount: totalPriceAfterTaxes
                }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: deliveryFees }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: deliveryCashDown }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: deliveryTaxes }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.UPFRON_PAYMENT'), amount: upfrontPayment }),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DEPOSIT'), amount: deposit }),
                totalDueAtDelivery >= 0 ? _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY'),
                    amount: totalDueAtDelivery,
                    showZero: true
                }) : _react2.default.createElement(_AmountLineItem2.default, {
                    label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY'),
                    amount: -1 * totalDueAtDelivery
                })
            )
        )
    );
};

CashPurchase.propTypes = {
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel).isRequired
};

CashPurchase.displayName = 'CashPurchase';

exports.default = CashPurchase;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _AmountLineItem = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deliveryDetails = function (_React$Component) {
    _inherits(deliveryDetails, _React$Component);

    function deliveryDetails(props) {
        _classCallCheck(this, deliveryDetails);

        var _this = _possibleConstructorReturn(this, (deliveryDetails.__proto__ || Object.getPrototypeOf(deliveryDetails)).call(this, props));

        _this.state = {
            showDeliveryDetails: false
        };

        _this.showDeliveryDetails = _this.showDeliveryDetails.bind(_this);
        return _this;
    }

    _createClass(deliveryDetails, [{
        key: 'showDeliveryDetails',
        value: function showDeliveryDetails() {
            this.setState(function (prevState) {
                return { showDeliveryDetails: !prevState.showDeliveryDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$purchaseMethod = this.props.purchaseMethodDeliveryAmounts,
                deliveryCashDown = _props$purchaseMethod.deliveryCashDown,
                deliveryFees = _props$purchaseMethod.deliveryFees,
                deliveryTaxes = _props$purchaseMethod.deliveryTaxes,
                deposit = _props$purchaseMethod.deposit,
                upfrontPayment = _props$purchaseMethod.upfrontPayment;


            var totalDueAtDelivery = deliveryCashDown + upfrontPayment + deliveryFees + deliveryTaxes + deposit;
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showDeliveryDetails },
                        !this.state.showDeliveryDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showDeliveryDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'SidebarSummary__listingAmount' },
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.OTHER_FEES'), amount: deliveryFees }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: deliveryCashDown }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'), amount: deliveryTaxes }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.UPFRON_PAYMENT'), amount: upfrontPayment }),
                        _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.DEPOSIT'), amount: deposit }),
                        totalDueAtDelivery >= 0 ? _react2.default.createElement(_AmountLineItem2.default, {
                            label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY'),
                            amount: totalDueAtDelivery,
                            showZero: true
                        }) : _react2.default.createElement(_AmountLineItem2.default, {
                            label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY'),
                            amount: -1 * totalDueAtDelivery
                        })
                    )
                )
            );
        }
    }]);

    return deliveryDetails;
}(_react2.default.Component);

deliveryDetails.defaultProps = {
    purchaseMethodDeliveryAmounts: []
};

deliveryDetails.propTypes = {
    purchaseMethodDeliveryAmounts: _propTypes2.default.shape({
        deliveryCashDown: _propTypes2.default.number.isRequired,
        deliveryFees: _propTypes2.default.number.isRequired,
        deliveryTaxes: _propTypes2.default.number.isRequired,
        deposit: _propTypes2.default.number.isRequired,
        upfrontPayment: _propTypes2.default.number.isRequired
    })
};

deliveryDetails.displayName = 'deliveryDetails';

exports.default = deliveryDetails;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/Finance/Finance.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/index.js");

var _AccessoriesListing = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AccessoriesListing/AccessoriesListing.jsx");

var _AccessoriesListing2 = _interopRequireDefault(_AccessoriesListing);

var _AmountLineItemWithIcon = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

var _DeliveryDetails = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/DeliveryDetails/DeliveryDetails.jsx");

var _DeliveryDetails2 = _interopRequireDefault(_DeliveryDetails);

var _FinanceListing = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx");

var _FinanceListing2 = _interopRequireDefault(_FinanceListing);

var _ProtectionsListing = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx");

var _ProtectionsListing2 = _interopRequireDefault(_ProtectionsListing);

__webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/Finance/Finance.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Finance = function Finance(_ref) {
    var purchaseMethods = _ref.purchaseMethods;

    var purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    var purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    var selectedFinanceTerm = purchaseMethods.getSelectedFinanceTerm();
    var purchaseMethodLabels = purchaseMethods.getPurchaseMethodLabels(_widgetCommonsCoreServices.LocaleService);
    var paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(false, _widgetCommonsCoreServices.LocaleService);
    var protectionsPackages = purchaseMethods.getSelectedProtectionsPackages();
    var accessoiresOptionsPackages = purchaseMethods.getSelectedOptions();

    var discounts = purchaseMethodAmounts.discounts,
        exteriorColour = purchaseMethodAmounts.exteriorColour,
        freightPDI = purchaseMethodAmounts.freightPDI,
        interiorColour = purchaseMethodAmounts.interiorColour,
        modelTrim = purchaseMethodAmounts.modelTrim,
        options = purchaseMethodAmounts.options,
        otherFees = purchaseMethodAmounts.otherFees,
        protections = purchaseMethodAmounts.protections,
        taxAndDuty = purchaseMethodAmounts.taxAndDuty;


    var allInPrice = modelTrim + exteriorColour + interiorColour + options + freightPDI + otherFees + taxAndDuty + protections - discounts;

    return _react2.default.createElement(
        'div',
        { className: 'FinanceSummary' },
        _react2.default.createElement(
            'div',
            { className: 'vehicle__salePrice' },
            _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES'),
                amount: allInPrice - protections,
                icon: 'review'
            }),
            _react2.default.createElement(_ProtectionsListing2.default, {
                purchaseMethodLabels: purchaseMethodLabels,
                protectionsPackages: protectionsPackages,
                purchaseMethods: purchaseMethods
            })
        ),
        _react2.default.createElement(_AccessoriesListing2.default, { accessoriesOptions: accessoiresOptionsPackages, purchaseMethods: purchaseMethods }),
        _react2.default.createElement(_FinanceListing2.default, {
            selectedFinanceTerm: selectedFinanceTerm,
            paymentFrequencyLabels: paymentFrequencyLabels,
            purchaseMethodLabels: purchaseMethodLabels,
            purchaseMethodAmounts: purchaseMethodAmounts
        }),
        _react2.default.createElement(_DeliveryDetails2.default, { purchaseMethodDeliveryAmounts: purchaseMethodDeliveryAmounts })
    );
};

Finance.defaultProps = {};

Finance.propTypes = {
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel).isRequired
};

Finance.displayName = 'Finance';

exports.default = Finance;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/Finance/Finance.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/FinanceListing/FinanceListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/index.js");

var _currencyFormats = __webpack_require__("../widget-commons-vehicle/src/constants/currencyFormats.js");

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

var _AmountLineItem = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinanceListing = function (_React$Component) {
    _inherits(FinanceListing, _React$Component);

    function FinanceListing(props) {
        _classCallCheck(this, FinanceListing);

        var _this = _possibleConstructorReturn(this, (FinanceListing.__proto__ || Object.getPrototypeOf(FinanceListing)).call(this, props));

        _this.state = {
            showFinanceDetails: false
        };

        _this.showFinanceDetails = _this.showFinanceDetails.bind(_this);
        return _this;
    }

    _createClass(FinanceListing, [{
        key: 'showFinanceDetails',
        value: function showFinanceDetails() {
            this.setState(function (prevState) {
                return { showFinanceDetails: !prevState.showFinanceDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var frequency = this.props.paymentFrequencyLabels.periodically;

            var _props$selectedFinanc = this.props.selectedFinanceTerm.getCalculatedPayments(false),
                calculatedPayment = _props$selectedFinanc.calculatedPayment,
                calculatedPaymentBeforeTaxes = _props$selectedFinanc.calculatedPaymentBeforeTaxes,
                calculatedPaymentTaxes = _props$selectedFinanc.calculatedPaymentTaxes;

            var _props$purchaseMethod = this.props.purchaseMethodAmounts,
                cashDown = _props$purchaseMethod.cashDown,
                lien = _props$purchaseMethod.lien,
                rebates = _props$purchaseMethod.rebates,
                tradeIn = _props$purchaseMethod.tradeIn;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'ul',
                    { className: 'SidebarSummary__financialDetails' },
                    _react2.default.createElement(
                        'div',
                        { className: 'SidebarSummary__groupTitle' },
                        _react2.default.createElement(
                            'h3',
                            { className: 'sr-title SidebarSummary__groupTitle--title' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_FINANCE_TITLE', {
                                finance: this.props.purchaseMethodLabels.name
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'sr-link', onClick: this.showFinanceDetails },
                            !this.state.showFinanceDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                        )
                    ),
                    _react2.default.createElement(
                        _reactCollapse2.default,
                        { isOpened: this.state.showFinanceDetails },
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__terms sr-text-regular' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TERM'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value' },
                                this.props.selectedFinanceTerm.term
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__rate' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label sr-text-bold' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.APR'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value sr-important-price' },
                                this.props.selectedFinanceTerm.apr,
                                '%'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__payments' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label sr-text-bold' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PAYMENT'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value sr-text-regular' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPaymentBeforeTaxes, _currencyFormats2.default.CURRENCY_2)
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'SidebarSummary__financialDetails--item vehicle__taxes sr-text-regular' },
                            _react2.default.createElement(
                                'span',
                                { className: 'label' },
                                _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TAXES'),
                                ' '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'value' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPaymentTaxes, _currencyFormats2.default.CURRENCY_2)
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'li',
                        { className: 'SidebarSummary__financialDetails--item vehicle__totalPayment' },
                        _react2.default.createElement(
                            'span',
                            { className: 'label sr-text-bold' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.PAYMENT_WITH_FREQUENCY', { frequency: frequency }),
                            ' ',
                            _react2.default.createElement('br', null)
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'value' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-important-price' },
                                _widgetCommonsCoreServices.LocaleService.l(calculatedPayment, _currencyFormats2.default.CURRENCY_2)
                            ),
                            ' ',
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-text-thin' },
                                _widgetCommonsCoreServices.LocaleService.t('taxes.taxesIncluded')
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'ul',
                    { className: 'SidebarSummary__listingAmount' },
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TRADE_IN'), amount: tradeIn }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.LIEN'), amount: lien }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.REBATES'), amount: rebates }),
                    _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CASHDOWN'), amount: cashDown })
                )
            );
        }
    }]);

    return FinanceListing;
}(_react2.default.Component);

FinanceListing.defaultProps = {
    paymentFrequencyLabels: [],
    purchaseMethodAmounts: [],
    purchaseMethodLabels: [],
    selectedFinanceTerm: []
};

FinanceListing.propTypes = {
    paymentFrequencyLabels: _propTypes2.default.shape({
        periodically: _propTypes2.default.string.isRequired
    }),
    purchaseMethodAmounts: _propTypes2.default.shape({
        cashDown: _propTypes2.default.number.isRequired,
        lien: _propTypes2.default.number.isRequired,
        rebates: _propTypes2.default.number.isRequired,
        tradeIn: _propTypes2.default.number.isRequired
    }),
    purchaseMethodLabels: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    selectedFinanceTerm: _propTypes2.default.instanceOf(_index.TermModel)
};

FinanceListing.displayName = 'FinanceListing';

exports.default = FinanceListing;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/components/TransactionSummary/ProtectionsListing/ProtectionsListing.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _index = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/index.js");

var _index2 = __webpack_require__("../widget-commons-vehicle/src/ModelYear/index.js");

var _index3 = _interopRequireDefault(_index2);

var _AmountLineItem = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx");

var _AmountLineItem2 = _interopRequireDefault(_AmountLineItem);

var _AmountLineItemWithIcon = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx");

var _AmountLineItemWithIcon2 = _interopRequireDefault(_AmountLineItemWithIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProtectionsListing = function (_React$Component) {
    _inherits(ProtectionsListing, _React$Component);

    function ProtectionsListing(props) {
        _classCallCheck(this, ProtectionsListing);

        var _this = _possibleConstructorReturn(this, (ProtectionsListing.__proto__ || Object.getPrototypeOf(ProtectionsListing)).call(this, props));

        _this.state = {
            showProtectionsDetails: false
        };

        _this.showProtectionsDetails = _this.showProtectionsDetails.bind(_this);
        return _this;
    }

    _createClass(ProtectionsListing, [{
        key: 'showProtectionsDetails',
        value: function showProtectionsDetails() {
            this.setState(function (prevState) {
                return { showProtectionsDetails: !prevState.showProtectionsDetails };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                protectionsPackages = _props.protectionsPackages,
                purchaseMethodLabels = _props.purchaseMethodLabels,
                purchaseMethods = _props.purchaseMethods;

            var totalProtectionsAmount = purchaseMethods.getProtectionsAmount(protectionsPackages);
            var protectionsRenderBlock = protectionsPackages.map(function (protectionPackage) {
                var label = protectionPackage.label || protectionPackage.description;
                var description = protectionPackage.label && protectionPackage.description ? ' (' + protectionPackage.description + ')' : '';
                return _react2.default.createElement(_AmountLineItemWithIcon2.default, {
                    label: '' + label + description,
                    amount: protectionPackage.retail,
                    icon: 'plus'
                });
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'SidebarSummary__groupTitle' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-title SidebarSummary__groupTitle--title' },
                        _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SUMMARY_PROTECTIONS_TITLE', { finance: purchaseMethodLabels.name }),
                        !this.state.showProtectionsDetails && _react2.default.createElement(
                            'span',
                            { className: 'SidebarSummary__groupTitle--subtitle' },
                            _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SELECTED_PROTECTIONS_AMOUNT', {
                                amount: protectionsPackages.length
                            })
                        )
                    ),
                    protectionsPackages.length > 0 && _react2.default.createElement(
                        'button',
                        { className: 'sr-link', onClick: this.showProtectionsDetails },
                        !this.state.showProtectionsDetails ? _widgetCommonsCoreServices.LocaleService.t('SUMMARY.SEE_DETAILS') : _widgetCommonsCoreServices.LocaleService.t('SUMMARY.CLOSE_DETAILS')
                    )
                ),
                _react2.default.createElement(
                    _reactCollapse2.default,
                    { isOpened: this.state.showProtectionsDetails },
                    _react2.default.createElement(
                        'ul',
                        { className: 'protectionsListing' },
                        protectionsRenderBlock
                    )
                ),
                _react2.default.createElement(_AmountLineItem2.default, { label: _widgetCommonsCoreServices.LocaleService.t('SUMMARY.TOTAL'), amount: totalProtectionsAmount })
            );
        }
    }]);

    return ProtectionsListing;
}(_react2.default.Component);

ProtectionsListing.defaultProps = {
    purchaseMethodLabels: [],
    protectionsPackages: []
};

ProtectionsListing.propTypes = {
    purchaseMethodLabels: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired
    }),
    purchaseMethods: _propTypes2.default.instanceOf(_index.PurchaseMethodsModel),
    protectionsPackages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        items: _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_index3.default.OptionModel)),
        itemsPackage: _propTypes2.default.instanceOf(_index3.default.OptionModel),
        payment: _propTypes2.default.number.isRequired,
        paymentTaxes: _propTypes2.default.number.isRequired,
        retail: _propTypes2.default.number.isRequired,
        taxes: _propTypes2.default.number.isRequired
    }))
};

ProtectionsListing.displayName = 'ProtectionsListing';

exports.default = ProtectionsListing;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/constants/leadTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEST_DRIVE = exports.TEST_DRIVE = 'TEST_DRIVE';
var APPOINTMENT = exports.APPOINTMENT = 'APPOINTMENT';
var SAVE_TO_GARAGE = exports.SAVE_TO_GARAGE = 'SAVE_TO_GARAGE';
var GET_STARTED = exports.GET_STARTED = 'GET_STARTED';
var ASK_QUESTIONS = exports.ASK_QUESTIONS = 'ASK_QUESTIONS';

exports.default = {
    TEST_DRIVE: TEST_DRIVE,
    APPOINTMENT: APPOINTMENT,
    SAVE_TO_GARAGE: SAVE_TO_GARAGE,
    GET_STARTED: GET_STARTED,
    ASK_QUESTIONS: ASK_QUESTIONS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OPTION = exports.OPTION = 1;
var ACCESSORY = exports.ACCESSORY = 2;
var DEALER_INVENTORY = exports.DEALER_INVENTORY = 3;
var DEALER_DISCOUNT = exports.DEALER_DISCOUNT = 4;
var EXTERIOR_COLOUR = exports.EXTERIOR_COLOUR = 5;
var INTERIOR_TRIM = exports.INTERIOR_TRIM = 6;

var ITEM_SOURCE = exports.ITEM_SOURCE = {
    DEALER: 4,
    SUPPLIER: 7
};

exports.default = {
    OPTION: OPTION,
    ACCESSORY: ACCESSORY,
    DEALER_INVENTORY: DEALER_INVENTORY,
    DEALER_DISCOUNT: DEALER_DISCOUNT,
    EXTERIOR_COLOUR: EXTERIOR_COLOUR,
    INTERIOR_TRIM: INTERIOR_TRIM,
    ITEM_SOURCE: ITEM_SOURCE
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/constants/statuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DELETED = exports.DELETED = 5;
var CUSTOMER_REVIEW = exports.CUSTOMER_REVIEW = 288;
var CHECKOUT = exports.CHECKOUT = 67239936;
var CHECKOUT_WITH_DEPOSIT = exports.CHECKOUT_WITH_DEPOSIT = 100794368;
var CREDIT_APPROVAL = exports.CREDIT_APPROVAL = 1048576;
var TRADE_IN_EVALUATION = exports.TRADE_IN_EVALUATION = 262144;
var MANAGER_APPROVAL = exports.MANAGER_APPROVAL = 65536;

var ACTIVE_FLAGS = exports.ACTIVE_FLAGS = {
    ACTIVE: 0x0,
    INACTIVE: 0x1,
    LOST: 0x2,
    DELETED: 0x4
};

var ORIGIN_FLAGS = exports.ORIGIN_FLAGS = {
    LEAD: 0x10,
    CUSTOMER_WEB: 0x20
};

var OWNER_FLAGS = exports.OWNER_FLAGS = {
    CUSTOMER: 0x100,
    SALESPERSON: 0x200,
    MANAGER: 0x400,
    FNI: 0x800,
    ACCOUNTING: 0x1000
};

var PENDING_APPROVAL_FLAGS = exports.PENDING_APPROVAL_FLAGS = {
    QUOTE_COMPLETION: 0x10000,
    OFFER_APPROVAL: 0x20000,
    TRADE_IN_EVALUATION: 0x40000,
    SALE_COMPLETION: 0x80000,
    CREDIT_APPROVAL: 0x100000,
    STOCK_MATCH: 0x200000,
    VEHICLE_DELIVERED_BOOKED: 0x400000,
    VEHICLE_TRIAL: 0x800000,
    ACCOUNTING_POST_VERIFIED: 0x1000000
};

var OFFER_FLAGS = exports.OFFER_FLAGS = {
    OFFER_WITH_DEPOSIT: 0x2000000,
    OFFER_CUSTOMER_WEB: 0x4000000
};

var STOCK_MATCH_FLAGS = exports.STOCK_MATCH_FLAGS = {
    LOCATE: 0x8000000
};

var DELIVERY_FLAGS = exports.DELIVERY_FLAGS = {
    NO_FNI: 0x10000000
};

var DECLINED_FLAGS = exports.DECLINED_FLAGS = {
    OFFER_DECLINED: 0x20000000,
    CREDIT_DECLINED: 0x40000000,
    VEHICLE_TRIAL_RETURNED: 0x80000000
};

var APPROVED_COMPLETED_FLAGS = exports.APPROVED_COMPLETED_FLAGS = {
    QUOTE_COMPLETED: 0x100000000,
    OFFER_APPROVED_SOLD: 0x200000000,
    TRADE_IN_EVALUATION_COMPLETED: 0x400000000,
    SALE_COMPLETED: 0x800000000,
    CREDIT_APPROVED: 0x1000000000,
    STOCK_MATCHED: 0x2000000000,
    VEHICLE_DELIVERED: 0x4000000000,
    VEHICLE_TRIAL_ENDED: 0x8000000000,
    ACCOUNTING_POST_POSTED: 0x10000000000
};

exports.default = {
    DELETED: DELETED,
    CUSTOMER_REVIEW: CUSTOMER_REVIEW,
    CHECKOUT: CHECKOUT,
    CHECKOUT_WITH_DEPOSIT: CHECKOUT_WITH_DEPOSIT,
    CREDIT_APPROVAL: CREDIT_APPROVAL,
    TRADE_IN_EVALUATION: TRADE_IN_EVALUATION,
    MANAGER_APPROVAL: MANAGER_APPROVAL,
    ACTIVE_FLAGS: ACTIVE_FLAGS,
    ORIGIN_FLAGS: ORIGIN_FLAGS,
    OWNER_FLAGS: OWNER_FLAGS,
    PENDING_APPROVAL_FLAGS: PENDING_APPROVAL_FLAGS,
    OFFER_FLAGS: OFFER_FLAGS,
    STOCK_MATCH_FLAGS: STOCK_MATCH_FLAGS,
    DELIVERY_FLAGS: DELIVERY_FLAGS,
    DECLINED_FLAGS: DECLINED_FLAGS,
    APPROVED_COMPLETED_FLAGS: APPROVED_COMPLETED_FLAGS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/constants/warnings.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DUE_AT_DELIVERY_MISMATCH = exports.DUE_AT_DELIVERY_MISMATCH = 1023;
var RETAIL_MISMATCH = exports.RETAIL_MISMATCH = 1027;
var PAYMENT_MISMATCH = exports.PAYMENT_MISMATCH = 1036;
var PAYMENT_TAXES_MISMATCH = exports.PAYMENT_TAXES_MISMATCH = 1042;
var FINANCED_AMOUNT_MISMATCH = exports.FINANCED_AMOUNT_MISMATCH = 1043;
var FINANCED_AMOUNT_WITH_TAXES_MISMATCH = exports.FINANCED_AMOUNT_WITH_TAXES_MISMATCH = 1044;

exports.default = {
    RETAIL_MISMATCH: RETAIL_MISMATCH,
    PAYMENT_MISMATCH: PAYMENT_MISMATCH,
    PAYMENT_TAXES_MISMATCH: PAYMENT_TAXES_MISMATCH,
    FINANCED_AMOUNT_MISMATCH: FINANCED_AMOUNT_MISMATCH,
    FINANCED_AMOUNT_WITH_TAXES_MISMATCH: FINANCED_AMOUNT_WITH_TAXES_MISMATCH,
    DUE_AT_DELIVERY_MISMATCH: DUE_AT_DELIVERY_MISMATCH
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Add to Garage","BTN_APPLY_QUOTE_CHANGES":"Apply Changes"}}

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"QUOTE":{"BTN_ADD_TO_GARAGE":"Ajouter au garage","BTN_APPLY_QUOTE_CHANGES":"Appliquer les changements"}}

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Translation = exports.exteriorColourStatuses = exports.Finance = exports.CashPurchase = exports.AddToGarageV25 = exports.AddToGarageButton = exports.QuoteItemCategoryService = exports.QuoteService = exports.QuoteReducer = exports.QuoteItemCategoryModel = exports.QuoteModel = exports.ModelTrimItemCategories = exports.Statuses = exports.LeadTypes = exports.QuoteActionsTypes = exports.QuoteActions = undefined;

var _quoteActions = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActions.js");

var _quoteActions2 = _interopRequireDefault(_quoteActions);

var _quoteActionTypes = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

var _leadTypes = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/leadTypes.js");

var _leadTypes2 = _interopRequireDefault(_leadTypes);

var _statuses = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/statuses.js");

var _statuses2 = _interopRequireDefault(_statuses);

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _modelTrimItemCategories2 = _interopRequireDefault(_modelTrimItemCategories);

var _exteriorColourStatuses = __webpack_require__("../widget-commons-vehicle/src/ModelYear/constants/exteriorColourStatuses.js");

var _exteriorColourStatuses2 = _interopRequireDefault(_exteriorColourStatuses);

var _QuoteModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteItemCategoryModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

var _quoteReducer = __webpack_require__("../widget-commons-vehicle/src/Quote/reducers/quoteReducer.js");

var _quoteReducer2 = _interopRequireDefault(_quoteReducer);

var _QuoteService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteService/QuoteService.js");

var _QuoteService2 = _interopRequireDefault(_QuoteService);

var _QuoteItemCategoryService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _QuoteItemCategoryService2 = _interopRequireDefault(_QuoteItemCategoryService);

var _AddToGarageButton = __webpack_require__("../widget-commons-vehicle/src/Quote/components/AddToGarage/AddToGarageButton.jsx");

var _AddToGarageButton2 = _interopRequireDefault(_AddToGarageButton);

var _AddToGarageV = __webpack_require__("../widget-commons-vehicle/src/Quote/components/AddToGarageV25/AddToGarageV25.jsx");

var _AddToGarageV2 = _interopRequireDefault(_AddToGarageV);

var _Finance = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/Finance/Finance.jsx");

var _Finance2 = _interopRequireDefault(_Finance);

var _CashPurchase = __webpack_require__("../widget-commons-vehicle/src/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx");

var _CashPurchase2 = _interopRequireDefault(_CashPurchase);

var _en = __webpack_require__("../widget-commons-vehicle/src/Quote/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("../widget-commons-vehicle/src/Quote/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Translation = { en: _en2.default, fr: _fr2.default };

exports.QuoteActions = _quoteActions2.default;
exports.QuoteActionsTypes = _quoteActionTypes2.default;
exports.LeadTypes = _leadTypes2.default;
exports.Statuses = _statuses2.default;
exports.ModelTrimItemCategories = _modelTrimItemCategories2.default;
exports.QuoteModel = _QuoteModel2.default;
exports.QuoteItemCategoryModel = _QuoteItemCategoryModel2.default;
exports.QuoteReducer = _quoteReducer2.default;
exports.QuoteService = _QuoteService2.default;
exports.QuoteItemCategoryService = _QuoteItemCategoryService2.default;
exports.AddToGarageButton = _AddToGarageButton2.default;
exports.AddToGarageV25 = _AddToGarageV2.default;
exports.CashPurchase = _CashPurchase2.default;
exports.Finance = _Finance2.default;
exports.exteriorColourStatuses = _exteriorColourStatuses2.default;
exports.Translation = Translation;
exports.default = {
    QuoteActions: _quoteActions2.default,
    QuoteActionsTypes: _quoteActionTypes2.default,
    LeadTypes: _leadTypes2.default,
    Statuses: _statuses2.default,
    ModelTrimItemCategories: _modelTrimItemCategories2.default,

    QuoteModel: _QuoteModel2.default,
    QuoteItemCategoryModel: _QuoteItemCategoryModel2.default,
    QuoteReducer: _quoteReducer2.default,
    QuoteService: _QuoteService2.default,
    QuoteItemCategoryService: _QuoteItemCategoryService2.default,

    exteriorColourStatuses: _exteriorColourStatuses2.default,

    AddToGarageButton: _AddToGarageButton2.default,
    AddToGarageV25: _AddToGarageV2.default, // SHOWROOM V2.5
    CashPurchase: _CashPurchase2.default,
    Finance: _Finance2.default,

    Translation: Translation
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/models/QuoteItemCategoryModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _dataConversions = __webpack_require__("../widget-commons-vehicle/src/constants/dataConversions.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuoteItemCategoryRecord = (0, _immutable.Record)({
    enabled: false,
    visible: true,
    selected: false,
    declined: false,
    singlePackageSelection: true,
    id: 0,
    order: _dataConversions.DEFAULT_KEY_ORDER,
    description: '',
    note: '',
    dataType: 0,
    imageUrl: '',
    webUrl: '',
    itemsPackages: [],
    items: []
});

function getSelectedItems(items) {
    return (0, _lodash.filter)(items, function (item) {
        return item.selected;
    });
}

var QuoteItemCategory = function (_QuoteItemCategoryRec) {
    _inherits(QuoteItemCategory, _QuoteItemCategoryRec);

    function QuoteItemCategory() {
        _classCallCheck(this, QuoteItemCategory);

        return _possibleConstructorReturn(this, (QuoteItemCategory.__proto__ || Object.getPrototypeOf(QuoteItemCategory)).apply(this, arguments));
    }

    _createClass(QuoteItemCategory, [{
        key: 'getItemsPackageContent',
        value: function getItemsPackageContent(itemsPackageSelectionCode) {
            if ((0, _lodash.isEmpty)(itemsPackageSelectionCode)) {
                return [];
            }

            var selectedItemsPackage = (0, _lodash.find)(this.itemsPackages, function (itemsPackage) {
                return itemsPackage.selectionCode === itemsPackageSelectionCode;
            });
            if (!selectedItemsPackage || (0, _lodash.isEmpty)(selectedItemsPackage.includedCodes)) {
                return [];
            }

            return (0, _lodash.filter)(this.items, function (item) {
                return (0, _lodash.includes)(selectedItemsPackage.includedCodes, item.selectionCode);
            });
        }
    }, {
        key: 'getSelectedItemsCount',
        value: function getSelectedItemsCount() {
            return getSelectedItems(this.items).length;
        }
    }, {
        key: 'getSelectedItemsPackagesCount',
        value: function getSelectedItemsPackagesCount() {
            return getSelectedItems(this.itemsPackages).length;
        }
    }, {
        key: 'getSelectedItemsAndPackages',
        value: function getSelectedItemsAndPackages() {
            return (0, _lodash.concat)(getSelectedItems(this.itemsPackages), getSelectedItems(this.items));
        }
    }, {
        key: 'getSelectedItemsPackagesAmountsWithContent',
        value: function getSelectedItemsPackagesAmountsWithContent(isLease, taxesFactor, selectedFinanceTerm) {
            var _this2 = this;

            var selectedPackages = getSelectedItems(this.itemsPackages);

            var selectedPackagesWithContent = (0, _lodash.map)(selectedPackages, function (itemsPackage) {
                var items = _this2.getItemsPackageContent(itemsPackage.selectionCode);

                var _itemsPackage$calcula = itemsPackage.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor),
                    retail = _itemsPackage$calcula.retail,
                    taxes = _itemsPackage$calcula.taxes,
                    payment = _itemsPackage$calcula.payment,
                    paymentTaxes = _itemsPackage$calcula.paymentTaxes;

                (0, _lodash.forEach)(items, function (item) {
                    var itemAmounts = item.calculateItemAmounts(isLease, selectedFinanceTerm, taxesFactor, itemsPackage);
                    retail += itemAmounts.retail;
                    taxes += itemAmounts.taxes;
                    payment += itemAmounts.payment;
                    paymentTaxes += itemAmounts.paymentTaxes;
                });

                return {
                    itemsPackage: itemsPackage,
                    items: items,
                    retail: retail,
                    taxes: taxes,
                    payment: payment,
                    paymentTaxes: paymentTaxes
                };
            });

            return selectedPackagesWithContent;
        }
    }]);

    return QuoteItemCategory;
}(QuoteItemCategoryRecord);

exports.default = QuoteItemCategory;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/models/QuoteModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _leadTypes = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/leadTypes.js");

var _leadTypes2 = _interopRequireDefault(_leadTypes);

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _statuses = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/statuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QuoteRecord = (0, _immutable.Record)({
    revision: '',
    id: '',
    location: '',
    status: 0,
    creationDate: 0,
    modifiedDate: 0,
    expirationDate: 0,
    dealerId: '',
    accountId: '',
    leadType: _leadTypes2.default.APPOINTMENT,
    leadId: '',
    creditCardChargeId: '',
    creditApplicationId: '',
    vehicle: new _VehicleModel2.default(),
    vehicleId: '',
    tradeInVehicles: [],
    isValid: true,
    warnings: [],
    errors: [],
    showroomItems: [],
    securityToken: '',
    modified: false
});

var Quote = function (_QuoteRecord) {
    _inherits(Quote, _QuoteRecord);

    function Quote(vehicle, modelYear) {
        _classCallCheck(this, Quote);

        var quoteVehicle = vehicle instanceof _VehicleModel2.default ? vehicle : new _VehicleModel2.default(vehicle);

        if (modelYear) {
            var configuration = modelYear.getSelectedOptionsPackageConfiguration();

            quoteVehicle = quoteVehicle.set('vehicleConditionType', _vehicle2.default.CONDITIONS.NEW).set('year', modelYear.year).set('make', modelYear.make).set('model', modelYear.model).set('bodyStyleCode', modelYear.bodyStyleCode).set('configuration', configuration).set('purchaseMethods', configuration.purchaseMethods);
        }

        return _possibleConstructorReturn(this, (Quote.__proto__ || Object.getPrototypeOf(Quote)).call(this, { vehicle: quoteVehicle }));
    }

    _createClass(Quote, [{
        key: 'getShowroomQuote',
        value: function getShowroomQuote() {
            return {
                __revision: this.revision,
                id: String(this.id),
                location: String(this.location) || _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase(),
                status: this.status,
                creationDate: this.creationDate,
                modifiedDate: this.modifiedDate,
                expirationDate: this.expirationDate,
                dealerId: this.dealerId,
                accountId: this.accountId,
                leadId: this.leadId,
                creditCardChargeId: this.creditCardChargeId,
                creditApplicationId: this.creditApplicationId,
                purchaseMethod: this.vehicle.purchaseMethods.getSelectedPurchaseMethodValue(),
                pricingSummary: this.getShowroomQuotePricingSummary(),
                financingSummary: this.getShowroomQuoteFinancingSummary(),
                vehicle: this.getShowroomVehicle(this.vehicle),
                vehicleId: String(this.vehicleId),
                tradeIns: this.getShowroomTradeIns(),
                securityToken: String(this.securityToken),
                items: (0, _lodash.map)(this.vehicle.purchaseMethods.getAllSelectedOptions(), function (option) {
                    return option.getShowroomQuoteItem();
                })
            };
        }
    }, {
        key: 'getShowroomQuotePricingSummary',
        value: function getShowroomQuotePricingSummary() {
            var _vehicle$purchaseMeth = this.vehicle.purchaseMethods.getSelectedPurchaseMethodAmounts(),
                modelTrim = _vehicle$purchaseMeth.modelTrim,
                exteriorColour = _vehicle$purchaseMeth.exteriorColour,
                interiorColour = _vehicle$purchaseMeth.interiorColour,
                options = _vehicle$purchaseMeth.options,
                discounts = _vehicle$purchaseMeth.discounts,
                freightPDI = _vehicle$purchaseMeth.freightPDI,
                otherFees = _vehicle$purchaseMeth.otherFees,
                taxAndDuty = _vehicle$purchaseMeth.taxAndDuty,
                rebates = _vehicle$purchaseMeth.rebates,
                protections = _vehicle$purchaseMeth.protections,
                taxes = _vehicle$purchaseMeth.taxes;

            var retail = modelTrim + exteriorColour + interiorColour + options + freightPDI + taxAndDuty + otherFees - (discounts + rebates);

            return {
                retail: retail,
                protections: protections,
                taxes: taxes,
                discount: discounts,
                rebate: rebates,
                rebateAtDelivery: 0,
                cashDown: this.vehicle.purchaseMethods.getSelectedFinanceCashDown()
            };
        }
    }, {
        key: 'getShowroomQuoteFinancingSummary',
        value: function getShowroomQuoteFinancingSummary() {
            var selectedFinance = this.vehicle.purchaseMethods.getSelectedFinance();
            var selectedFinanceTerm = this.vehicle.purchaseMethods.getSelectedFinanceTerm();
            var calculatedPayments = selectedFinanceTerm ? selectedFinanceTerm.getCalculatedPayments() : '';

            return !selectedFinanceTerm ? {
                paymentsPerYear: 0,
                term: 0,
                apr: 0,
                financedAmount: 0,
                financedAmountWithTaxes: 0,
                validationFinancedAmountMinimum: 0,
                validationFinancedAmountMaximum: 0,
                residualizingAmount: 0,
                residualRate: 0,
                residualAmountTotal: 0,
                annualKMAllowed: 0,
                endTermKMCost: 0,
                dueAtDelivery: 0,
                payment: 0,
                paymentTaxes: 0,
                protectionsPayment: 0
            } : {
                paymentsPerYear: selectedFinanceTerm.paymentFrequency,
                term: selectedFinanceTerm.term,
                apr: selectedFinanceTerm.apr,
                financedAmount: selectedFinanceTerm.financedAmount,
                financedAmountWithTaxes: selectedFinanceTerm.financedAmountWithTaxes,
                validationFinancedAmountMinimum: 0,
                validationFinancedAmountMaximum: 0,
                residualizingAmount: 0,
                residualRate: selectedFinanceTerm.residualRate,
                residualAmountTotal: selectedFinanceTerm.residualAmount,
                annualKMAllowed: selectedFinance.annualKMAllowed,
                endTermKMCost: selectedFinance.endTermKMCost,
                dueAtDelivery: 0,
                payment: calculatedPayments.calculatedPaymentBeforeTaxes,
                paymentTaxes: calculatedPayments.calculatedPaymentTaxes,
                protectionsPayment: 0
            };
        }
    }, {
        key: 'getShowroomVehicle',
        value: function getShowroomVehicle(vehicle) {
            return {
                id: vehicle.id,
                vehicleId: String(vehicle.vehicleId),
                catalogVehicleId: String(vehicle.catalogVehicleId),
                newCarTrimId: String(vehicle.newCarTrimId), // V2.5
                vehicleCondition: vehicle.vehicleConditionType,
                vin: vehicle.vin,
                year: vehicle.year,
                make: vehicle.make,
                model: vehicle.model,
                modelTrimCode: vehicle.configuration !== null ? vehicle.configuration.modelTrimCode : vehicle.modelTrimCode,
                configurationID: vehicle.configuration !== null ? vehicle.configuration.id : vehicle.configurationId,
                configurationToken: vehicle.configurationToken || '',
                inventory: {
                    stock: vehicle.stockNumber
                }
            };
        }
    }, {
        key: 'getShowroomTradeInVehicle',
        value: function getShowroomTradeInVehicle(tradeInVehicle) {
            return {
                vehicle: this.getShowroomVehicle(tradeInVehicle.vehicle),
                lien: tradeInVehicle.lien,
                amount: tradeInVehicle.amount,
                evaluationQuestion: tradeInVehicle.evaluationQuestion
            };
        }
    }, {
        key: 'getShowroomTradeIns',
        value: function getShowroomTradeIns() {
            var _this2 = this;

            var tradeIns = {
                amountSummary: {
                    tradeIn: this.vehicle.purchaseMethods.tradeIn,
                    lien: this.vehicle.purchaseMethods.lien
                },
                tradeInVehicles: [{
                    vehicle: {
                        vehicleCondition: _vehicle2.default.CONDITIONS.USED,
                        year: 0,
                        make: '',
                        model: ''
                    },
                    lien: {
                        owner: '',
                        amount: this.vehicle.purchaseMethods.lien
                    },
                    amount: this.vehicle.purchaseMethods.tradeIn
                }]
            };

            if (!(0, _lodash.isEmpty)(this.tradeInVehicles)) {
                tradeIns.tradeInVehicles = (0, _lodash.map)(this.tradeInVehicles, function (tradeInVehicle) {
                    return _this2.getShowroomTradeInVehicle(tradeInVehicle);
                });
            }

            return tradeIns;
        }
    }, {
        key: 'getVehicleRedirectionFromQuote',
        value: function getVehicleRedirectionFromQuote(vdpUrl) {
            var vehicle = this.vehicle;
            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var isQuoteInPending = (this.status & _statuses.CHECKOUT_WITH_DEPOSIT) === _statuses.CHECKOUT_WITH_DEPOSIT;
            var isInManagerApprovalStatus = this.isQuoteInApproval();
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            var redirections = _widgetCommonsGeneral.REDIRECTIONS[locale];

            var shortUrl = redirections.checkout;
            var vehicleId = vehicle.vehicleId;

            if (!isQuoteInPending) {
                if (vehicle.getIsVehicleNew()) {
                    if (isShowroomV25Enabled) {
                        shortUrl = redirections.catalogMarketplace;
                        vehicleId = vehicle.newCarTrimId;
                    } else {
                        shortUrl = redirections.buildAndQuote;
                    }
                } else {
                    shortUrl = vdpUrl && !(0, _lodash.isNull)(vdpUrl) && (0, _lodash.isString)(vdpUrl) ? vdpUrl : redirections.vdp;
                }

                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{make}', vehicle.make);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{model}', vehicle.model);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{year}', vehicle.year);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{vehicleId}', vehicleId);
                shortUrl = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(shortUrl, '{bodyStyle}', vehicle.bodyStyleCode);
                shortUrl = shortUrl.toLowerCase().replace(/\s/g, '-');
            }

            return !isInManagerApprovalStatus ? this.buildUrl(shortUrl) : null;
        }
    }, {
        key: 'getVDPUrl',
        value: function getVDPUrl() {
            var vehicle = this.vehicle;

            var locale = _widgetCommonsCoreServices.LocaleService.getSimpleLocale();
            var isShowroomV25Enabled = _widgetCommonsCoreServices.ConfigsService.isShowroomV25Enabled();
            var redirections = _widgetCommonsGeneral.REDIRECTIONS[locale];

            var vdpURL = redirections.vdp;
            var vehicleId = vehicle.vehicleId;
            if (vehicle.getIsVehicleNew()) {
                if (isShowroomV25Enabled) {
                    vdpURL = redirections.catalogMarketplace;
                    vehicleId = vehicle.newCarTrimId;
                } else {
                    vdpURL = redirections.buildAndQuote;
                }
            }

            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{make}', vehicle.make);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{model}', vehicle.model);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{year}', vehicle.year);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{vehicleId}', vehicleId);
            vdpURL = _widgetCommonsCoreServices.UrlService.replaceParamWithValue(vdpURL, '{bodyStyle}', vehicle.bodyStyleCode);
            vdpURL = vdpURL.toLowerCase().replace(/\s/g, '-');

            return this.buildUrl(vdpURL);
        }
    }, {
        key: 'isQuoteInPending',
        value: function isQuoteInPending() {
            var pendingStatus = _statuses.CUSTOMER_REVIEW | _statuses.CHECKOUT_WITH_DEPOSIT;
            return (this.status & pendingStatus) === pendingStatus;
        }
    }, {
        key: 'isQuoteInApproval',
        value: function isQuoteInApproval() {
            return (this.status & _statuses.MANAGER_APPROVAL) === _statuses.MANAGER_APPROVAL;
        }
    }, {
        key: 'isQuoteInGarage',
        value: function isQuoteInGarage() {
            return !!(this.id && !this.securityToken);
        }
    }, {
        key: 'isDepositDone',
        value: function isDepositDone() {
            return (this.status & _statuses.OFFER_FLAGS.OFFER_WITH_DEPOSIT) === _statuses.OFFER_FLAGS.OFFER_WITH_DEPOSIT;
        }
    }, {
        key: 'isDirty',
        value: function isDirty() {
            return !!(this.isQuoteInGarage() && this.modified);
        }
    }, {
        key: 'isQuoteVehicleFromInventory',
        value: function isQuoteVehicleFromInventory() {
            return !!this.vehicleId;
        }
    }, {
        key: 'buildUrl',
        value: function buildUrl(url) {
            var id = this.id,
                securityToken = this.securityToken;

            var prefix = !(0, _lodash.includes)(url, '?') ? '?' : '&';

            if (!url) {
                return '';
            }

            var fullUrl = '' + url + prefix + 'quoteId=' + id;

            if (securityToken) {
                fullUrl += '&writeToken=' + securityToken;
            }

            return fullUrl;
        }
    }]);

    return Quote;
}(QuoteRecord);

exports.default = Quote;

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/reducers/quoteReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quoteReducer;

var _lodash = __webpack_require__("lodash");

var _quoteActionTypes = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActionTypes.js");

var _quoteActionTypes2 = _interopRequireDefault(_quoteActionTypes);

var _purchaseMethodsActionTypes = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActionTypes.js");

var _purchaseMethodsActionTypes2 = _interopRequireDefault(_purchaseMethodsActionTypes);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _QuoteModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function quoteReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _QuoteModel2.default();
    var action = arguments[1];

    switch (action.type) {
        case _quoteActionTypes2.default.SET_QUOTE:
            return action.quote;

        case _quoteActionTypes2.default.SET_QUOTE_MODIFIED:
            return state.set('modified', true);

        case _quoteActionTypes2.default.SET_QUOTE_REVISION:
            return state.set('revision', action.revision);

        case _quoteActionTypes2.default.SET_QUOTE_MODEL_YEAR:
            return state.set('vehicle', action.modelYear.getVehicleFromConfiguration());

        case _quoteActionTypes2.default.SET_QUOTE_VEHICLE:
            return state.set('vehicle', action.vehicle);

        case _quoteActionTypes2.default.SET_LEAD_TYPE:
            return state.set('leadType', action.leadType);

        case _quoteActionTypes2.default.SET_STATUS:
            return state.set('status', action.status);

        case _quoteActionTypes2.default.SET_SECURITY_TOKEN:
            return state.set('securityToken', action.securityToken);

        case _quoteActionTypes2.default.SET_QUOTE_PURCHASE_METHODS:
            return state.setIn(['vehicle', 'purchaseMethods'], action.purchaseMethods);

        case _purchaseMethodsActionTypes2.default.SELECT_PURCHASE_METHOD:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectPurchaseMethod(state.vehicle.purchaseMethods, action.purchaseMethod)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_TERM:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectTerm(state.vehicle.purchaseMethods, action.term)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_PAYMENT_FREQUENCY:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectPaymentFrequency(state.vehicle.purchaseMethods, action.paymentFrequency.value)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_CASH_DOWN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setCashDown(state.vehicle.purchaseMethods, action.cashDown)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_TRADE_IN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setTradeIn(state.vehicle.purchaseMethods, action.tradeIn)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_LIEN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setLien(state.vehicle.purchaseMethods, action.lien)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SET_TAXES_INCLUDED:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.setTaxesIncluded(state, action.taxesIncluded)).set('modified', true);

        case _purchaseMethodsActionTypes2.default.SELECT_KM_PLAN:
            return state.setIn(['vehicle', 'purchaseMethods'], PurchaseMethodsService.selectKMPlan(state.vehicle.purchaseMethods, action.kmPlan.value)).set('modified', true);

        default:
            if ((0, _lodash.includes)(_purchaseMethodsActionTypes2.default.QUOTE_UPDATE_TYPES, action.type)) {
                return state.set('modified', true);
            }
            return state;
    }
}

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetQuoteItemCategoriesFromQuoteProtections = resetQuoteItemCategoriesFromQuoteProtections;
exports.resetQuoteItemCategoryFromCategory = resetQuoteItemCategoryFromCategory;
exports.resetQuoteItemCategoriesFromModelTrimOptions = resetQuoteItemCategoriesFromModelTrimOptions;
exports.selectQuoteItemCategory = selectQuoteItemCategory;
exports.selectNextPreviousQuoteItemCategory = selectNextPreviousQuoteItemCategory;
exports.selectQuoteItemPackage = selectQuoteItemPackage;
exports.resetQuoteItemCategoriesFromOptionsValidation = resetQuoteItemCategoriesFromOptionsValidation;

var _lodash = __webpack_require__("lodash");

var _OptionService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/OptionService/OptionService.js");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _QuoteItemCategoryModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROTECTION = _dataTypes.DATA_TYPES.PROTECTION,
    FEATURE = _dataTypes.DATA_TYPES.FEATURE,
    REBATE = _dataTypes.DATA_TYPES.REBATE;


function splitItemsAndPackages(quoteItemCategories, quoteItemsPackages, quoteItems) {
    return (0, _lodash.filter)((0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var itemsPackages = (0, _lodash.orderBy)((0, _lodash.filter)(quoteItemsPackages, function (item) {
            return item.categoryID === itemCategory.id;
        }), ['keyOrder']);
        var items = (0, _lodash.orderBy)((0, _lodash.filter)(quoteItems, function (item) {
            return item.categoryID === itemCategory.id;
        }), ['keyOrder']);

        var noItems = (0, _lodash.isEmpty)(items) && (0, _lodash.isEmpty)(itemsPackages);
        return itemCategory.set('visible', !noItems).set('itemsPackages', itemsPackages).set('items', items);
    }), 'visible');
}

function getItemCategoryFromType(item, categoryId) {
    var notColour = item.typeID !== FEATURE.TYPES.EXTERIOR_COLOUR && item.typeID !== FEATURE.TYPES.INTERIOR_TRIM;

    if (item.typeID === FEATURE.TYPES.EXTERIOR_COLOUR && categoryId === _modelTrimItemCategories.EXTERIOR_COLOUR) {
        return _modelTrimItemCategories.EXTERIOR_COLOUR;
    } else if (item.typeID === FEATURE.TYPES.INTERIOR_TRIM && categoryId === _modelTrimItemCategories.INTERIOR_TRIM) {
        return _modelTrimItemCategories.INTERIOR_TRIM;
    } else if (notColour && item.isInstalledAtDealership && categoryId === _modelTrimItemCategories.ACCESSORY) {
        return _modelTrimItemCategories.ACCESSORY;
    } else if (notColour && !item.isInstalledAtDealership && categoryId === _modelTrimItemCategories.OPTION) {
        return _modelTrimItemCategories.OPTION;
    }
    return 0;
}

function splitModelTrimItemsAndPackages(quoteItemCategories, modelItemsPackages, modelItems) {
    var parentCodeInclusions = {};
    (0, _lodash.forEach)(modelItems, function (item) {
        if (!parentCodeInclusions[item.parentCode]) {
            parentCodeInclusions[item.parentCode] = [];
        }
        parentCodeInclusions[item.parentCode].push(item.selectionCode);
    });
    var newModelItemsPackages = (0, _lodash.map)(modelItemsPackages, function (itemsPackage) {
        return parentCodeInclusions[itemsPackage.code] ? itemsPackage.set('includedCodes', parentCodeInclusions[itemsPackage.code]) : itemsPackage;
    });

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var itemsPackages = (0, _lodash.orderBy)((0, _lodash.filter)(newModelItemsPackages, function (item) {
            return getItemCategoryFromType(item, itemCategory.id) > 0;
        }), ['description']);
        var items = (0, _lodash.orderBy)((0, _lodash.filter)(modelItems, function (item) {
            return getItemCategoryFromType(item, itemCategory.id) > 0;
        }), ['description']);

        var noItems = (0, _lodash.isEmpty)(items) && (0, _lodash.isEmpty)(itemsPackages);
        return itemCategory.set('visible', !noItems && itemCategory.id <= _modelTrimItemCategories.ACCESSORY).set('itemsPackages', itemsPackages).set('items', items);
    });
}

function extractCategoriesWebUrls(quoteItemCategories) {
    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var webUrls = (0, _lodash.uniqBy)(itemCategory.itemsPackages, 'webUrl');
        if (!itemCategory.webUrl && webUrls.length === 1) {
            return itemCategory.set('webUrl', webUrls[0].webUrl).set('itemsPackages', (0, _lodash.map)(itemCategory.itemsPackages, function (itemsPackage) {
                return itemsPackage.set('webUrl', '');
            }));
        }
        return itemCategory;
    });
}

function extractCategoriesNotes(quoteItemCategories) {
    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        var typeNotes = (0, _lodash.uniqBy)(itemCategory.itemsPackages, 'note');
        if (!itemCategory.note && typeNotes.length === 1) {
            return itemCategory.set('note', typeNotes[0].note).set('itemsPackages', (0, _lodash.map)(itemCategory.itemsPackages, function (itemsPackage) {
                return itemsPackage.set('note', '');
            }));
        }
        return itemCategory;
    });
}

function unselectItemsAndPackages(quoteItemCategory) {
    return quoteItemCategory.set('items', (0, _lodash.map)(quoteItemCategory.items, function (item) {
        return item.set('selected', false);
    })).set('itemsPackages', (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        return item.set('selected', false);
    }));
}

function resetItemsAndPackagesAmountsFromOptions(quoteItemCategory, options) {
    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        var itemOption = (0, _lodash.find)(options, function (option) {
            return option.selectionCode === item.selectionCode;
        });
        return item.set('retail', itemOption ? itemOption.retail : item.retail).set('residualizingAmount', itemOption ? itemOption.residualizingAmount : item.residualizingAmount);
    });

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        var itemOption = (0, _lodash.find)(options, function (option) {
            return option.selectionCode === item.selectionCode;
        });
        return item.set('retail', itemOption ? itemOption.retail : item.retail).set('residualizingAmount', itemOption ? itemOption.residualizingAmount : item.residualizingAmount);
    });

    return quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);
}

function selectItemsAndPackagesFromCodes(quoteItemCategory, itemsPackageSelectionCodes) {
    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        if (quoteItemCategory.id === _modelTrimItemCategories.DEALER_INVENTORY && quoteItemCategory.dataType === FEATURE.DATA_TYPE_ID || quoteItemCategory.id === _modelTrimItemCategories.DEALER_DISCOUNT && quoteItemCategory.dataType === REBATE.DATA_TYPE_ID) {
            return item.set('selected', true);
        }
        return item.set('selected', (0, _lodash.includes)(itemsPackageSelectionCodes, item.selectionCode));
    });

    var selectedItemsPackages = (0, _lodash.filter)(itemsPackages, 'selected');
    var includedCodes = (0, _lodash.flatten)((0, _lodash.map)(selectedItemsPackages, function (itemsPackage) {
        return itemsPackage.includedCodes;
    }));

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        return item.set('selected', (0, _lodash.includes)(includedCodes, item.selectionCode) || (0, _lodash.includes)(itemsPackageSelectionCodes, item.selectionCode));
    });

    return quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);
}

function disableCategory(quoteItemCategory) {
    var unselectedItemCategory = unselectItemsAndPackages(quoteItemCategory);
    return unselectedItemCategory.set('selected', false).set('enabled', false).set('declined', false);
}

function setCategoryDone(quoteItemCategory, declineProtections) {
    var quoteItemCatSelected = quoteItemCategory;
    if (declineProtections) {
        quoteItemCatSelected = unselectItemsAndPackages(quoteItemCategory);
    }

    var declined = declineProtections || quoteItemCatSelected.getSelectedItemsCount() === 0 && quoteItemCatSelected.getSelectedItemsPackagesCount() === 0;

    return quoteItemCatSelected.set('selected', false).set('declined', declined);
}

function setSelectedItemsAndPackages(quoteItemCategory, selectedOptions) {
    var selectedOptionsCodes = (0, _lodash.map)(selectedOptions, function (selectedOption) {
        return selectedOption.selectionCode;
    });
    var newQuoteItemCategory = unselectItemsAndPackages(quoteItemCategory);
    newQuoteItemCategory = resetItemsAndPackagesAmountsFromOptions(newQuoteItemCategory, selectedOptions);
    return selectItemsAndPackagesFromCodes(newQuoteItemCategory, selectedOptionsCodes);
}

function resetQuoteItemCategoriesFromQuoteProtections(quoteItemCategories, quoteProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isArrayLikeObject)(quoteProtections) || (0, _lodash.isEmpty)(quoteProtections)) {
        return quoteItemCategories;
    }

    var protectionPackages = [];
    var protections = [];

    (0, _lodash.forEach)(quoteProtections, function (protection) {
        if (protection.dataType === PROTECTION.DATA_TYPE_ID) {
            if (protection.categoryID === PROTECTION.CATEGORIES.PROTECTION || !(0, _lodash.isEmpty)(protection.identificationType) && protection.identificationType.isGroup) {
                protectionPackages.push((0, _OptionService.resetOptionFromProtectionItem)(protection));
            } else {
                protections.push((0, _OptionService.resetOptionFromProtectionItem)(protection));
            }
        }
    });

    var quoteItemCatSplitItems = splitItemsAndPackages(quoteItemCategories, protectionPackages, protections);
    var quoteItemCatUrls = extractCategoriesWebUrls(quoteItemCatSplitItems);
    var quoteItemCatNotes = extractCategoriesNotes(quoteItemCatUrls);

    return (0, _lodash.map)(quoteItemCatNotes, function (protectionCategory, index) {
        return protectionCategory.set('selected', index === 0).set('enabled', index === 0);
    });
}

function resetQuoteItemCategoryFromCategory(quoteItemCategory, dataType, category) {
    if (!(0, _lodash.isObjectLike)(category) || (0, _lodash.isUndefined)(category.categoryID)) {
        return quoteItemCategory;
    }
    return quoteItemCategory.set('id', category.categoryID).set('singlePackageSelection', category.categoryID !== PROTECTION.CATEGORIES.INSURANCE && category.categoryID !== PROTECTION.CATEGORIES.PROTECTION).set('description', (0, _lodash.isEmpty)(category.description) ? '' : category.description.descriptions[0]).set('note', (0, _lodash.isEmpty)(category.description) ? '' : category.description.notes[0]).set('dataType', dataType).set('order', category.rank);
}

function resetQuoteItemCategoriesFromModelTrimOptions(modelOptions) {
    if (!(0, _lodash.isArrayLikeObject)(modelOptions) || (0, _lodash.isEmpty)(modelOptions)) {
        return [];
    }

    var quoteItemCategories = [new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.OPTION,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.OPTION
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.ACCESSORY,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.ACCESSORY
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.DEALER_INVENTORY,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.DEALER_INVENTORY
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.DEALER_DISCOUNT,
        dataType: REBATE.DATA_TYPE_ID,
        singlePackageSelection: false,
        order: _modelTrimItemCategories.DEALER_DISCOUNT
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.EXTERIOR_COLOUR,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: true,
        order: _modelTrimItemCategories.EXTERIOR_COLOUR
    }), new _QuoteItemCategoryModel2.default({
        id: _modelTrimItemCategories.INTERIOR_TRIM,
        dataType: FEATURE.DATA_TYPE_ID,
        singlePackageSelection: true,
        order: _modelTrimItemCategories.INTERIOR_TRIM
    })];

    var optionsAccessoriesPackages = [];
    var optionsAccessories = [];

    (0, _lodash.forEach)(modelOptions, function (optionAccessory) {
        if ((0, _lodash.isEmpty)(optionAccessory.parentCode)) {
            optionsAccessoriesPackages.push(optionAccessory);
        } else {
            optionsAccessories.push(optionAccessory);
        }
    });

    var quoteItemCatSplitItems = splitModelTrimItemsAndPackages(quoteItemCategories, optionsAccessoriesPackages, optionsAccessories);
    return (0, _lodash.map)(quoteItemCatSplitItems, function (protectionCategory, index) {
        return protectionCategory.set('selected', index === 0).set('enabled', index === 0);
    });
}

function selectQuoteItemCategory(quoteItemCategories, quoteItemCategory, declineProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if ((!(0, _lodash.isObjectLike)(quoteItemCategory) || (0, _lodash.isUndefined)(quoteItemCategory.id)) && !(0, _lodash.isNull)(quoteItemCategory)) {
        return quoteItemCategories;
    }

    var categoriesIds = (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id;
    });
    var categoriesCount = categoriesIds.length;
    var currentIndex = categoriesCount;
    if (quoteItemCategory !== null) {
        currentIndex = (0, _lodash.findIndex)(quoteItemCategories, function (itemCategory) {
            return itemCategory.id === quoteItemCategory.id;
        });
    }
    var previousIds = (0, _lodash.dropRight)(categoriesIds, categoriesCount - currentIndex);

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        if ((0, _lodash.includes)(previousIds, itemCategory.id)) {
            return itemCategory.selected ? setCategoryDone(itemCategory, declineProtections) : itemCategory;
        } else if (itemCategory.id === quoteItemCategory.id) {
            return itemCategory.set('selected', true).set('enabled', true).set('declined', false);
        }
        return disableCategory(itemCategory);
    });
}

function selectNextPreviousQuoteItemCategory(quoteItemCategories, quoteItemCategory, previous, declineProtections) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }

    var nextIndex = (0, _lodash.findIndex)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id === quoteItemCategory.id;
    }) + (previous ? -1 : 1);

    if (nextIndex < 0) {
        return selectQuoteItemCategory(quoteItemCategories, quoteItemCategory, declineProtections);
    } else if (nextIndex >= quoteItemCategories.length) {
        return selectQuoteItemCategory(quoteItemCategories, null, declineProtections);
    }
    return selectQuoteItemCategory(quoteItemCategories, quoteItemCategories[nextIndex], declineProtections);
}

function selectQuoteItemPackage(quoteItemCategories, quoteItemCategory, itemsPackage) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isObjectLike)(quoteItemCategory) || (0, _lodash.isUndefined)(quoteItemCategory.id) || !(0, _lodash.isObjectLike)(itemsPackage) || (0, _lodash.isUndefined)(itemsPackage.selectionCode)) {
        return quoteItemCategories;
    }

    var itemsPackages = (0, _lodash.map)(quoteItemCategory.itemsPackages, function (item) {
        if (quoteItemCategory.singlePackageSelection) {
            var selected = item.selectionCode === itemsPackage.selectionCode && !itemsPackage.selected;
            return item.set('selected', selected).set('userSelected', selected);
        }
        var multiSelected = item.selectionCode === itemsPackage.selectionCode && !itemsPackage.selected || item.selectionCode !== itemsPackage.selectionCode && item.selected;
        return item.set('selected', multiSelected).set('userSelected', multiSelected);
    });

    var items = (0, _lodash.map)(quoteItemCategory.items, function (item) {
        if (quoteItemCategory.singlePackageSelection) {
            var selected = !itemsPackage.selected && (0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode);
            return item.set('selected', selected).set('userSelected', selected);
        }
        var multiSelected = (0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode) && !itemsPackage.selected || !(0, _lodash.includes)(itemsPackage.includedCodes, item.selectionCode) && item.selected;
        return item.set('selected', multiSelected).set('userSelected', multiSelected);
    });

    var newQuoteItemCategory = quoteItemCategory.set('itemsPackages', itemsPackages).set('items', items);

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return itemCategory.id === newQuoteItemCategory.id ? newQuoteItemCategory : itemCategory;
    });
}

function resetQuoteItemCategoriesFromOptionsValidation(quoteItemCategories, selectedOptions) {
    if (!(0, _lodash.isArrayLikeObject)(quoteItemCategories) || (0, _lodash.isEmpty)(quoteItemCategories)) {
        return [];
    }
    if (!(0, _lodash.isArrayLikeObject)(selectedOptions) || (0, _lodash.isEmpty)(selectedOptions)) {
        return quoteItemCategories;
    }

    return (0, _lodash.map)(quoteItemCategories, function (itemCategory) {
        return setSelectedItemsAndPackages(itemCategory, selectedOptions);
    });
}

exports.default = {
    resetQuoteItemCategoriesFromQuoteProtections: resetQuoteItemCategoriesFromQuoteProtections,
    resetQuoteItemCategoryFromCategory: resetQuoteItemCategoryFromCategory,
    resetQuoteItemCategoriesFromModelTrimOptions: resetQuoteItemCategoriesFromModelTrimOptions,
    selectNextPreviousQuoteItemCategory: selectNextPreviousQuoteItemCategory,
    selectQuoteItemCategory: selectQuoteItemCategory,
    selectQuoteItemPackage: selectQuoteItemPackage,
    resetQuoteItemCategoriesFromOptionsValidation: resetQuoteItemCategoriesFromOptionsValidation
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Quote/services/QuoteService/QuoteService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.resetQuoteFromModelYear = resetQuoteFromModelYear;
exports.resetQuoteFromVehicle = resetQuoteFromVehicle;
exports.resetQuoteFromShowroomSave = resetQuoteFromShowroomSave;
exports.resetQuoteFromShowroomLoad = resetQuoteFromShowroomLoad;
exports.resetQuoteDepositLead = resetQuoteDepositLead;
exports.resetQuoteCreditApplication = resetQuoteCreditApplication;
exports.getEmployeeRebateFromShowroomQuote = getEmployeeRebateFromShowroomQuote;
exports.quoteHasVehicle = quoteHasVehicle;

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var _purchaseMethodsValues = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethodsValues.js");

var _purchaseMethodsValues2 = _interopRequireDefault(_purchaseMethodsValues);

var _purchaseMethods = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/constants/purchaseMethods.js");

var _warnings = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/warnings.js");

var WARNINGS = _interopRequireWildcard(_warnings);

var _statuses = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/statuses.js");

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _VehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js");

var _ShowroomService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomService.js");

var _ShowroomService2 = _interopRequireDefault(_ShowroomService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var criticalWarnings = [WARNINGS.RETAIL_MISMATCH, WARNINGS.PAYMENT_MISMATCH, WARNINGS.PAYMENT_TAXES_MISMATCH, WARNINGS.FINANCED_AMOUNT_MISMATCH, WARNINGS.FINANCED_AMOUNT_WITH_TAXES_MISMATCH, WARNINGS.DUE_AT_DELIVERY_MISMATCH];

var QuoteService = function () {
    function QuoteService() {
        _classCallCheck(this, QuoteService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(QuoteService, [{
        key: 'saveQuote',
        value: function saveQuote(quote, conf) {
            var _this = this;

            if (!conf || !quote) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }

            var orgId = conf.organizationId;
            var orgUnitId = conf.organizationUnitId;
            var location = conf.location;
            var context = 'refresh=1&location=' + location + '&datalevel=1&context=' + orgId + '.' + orgUnitId + '&userName=public&password=public';

            return _ShowroomService2.default.getPublicToken().then(function (response) {
                var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

                return _axios2.default.put(_this.basePath + '/Quote?' + context, quote, {
                    headers: {
                        'x-jwt': userCookie || response.data
                    }
                });
            });
        }
    }, {
        key: 'getQuote',
        value: function getQuote(quoteId) {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _axios2.default.get(this.basePath + '/Quote/' + quoteId + '?datalevel=1', {
                headers: {
                    'x-jwt': token
                }
            });
        }
    }, {
        key: 'getQuoteIds',
        value: function getQuoteIds() {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _axios2.default.get(this.basePath + '/Quotes', {
                headers: {
                    'x-jwt': token
                }
            });
        }
    }]);

    return QuoteService;
}();

function resetQuoteFromModelYear(quote, location, leadType, modelYear) {
    return quote.set('location', location).set('leadType', leadType).set('vehicle', modelYear.getVehicleFromConfiguration(quote.vehicle));
}

function resetQuoteFromVehicle(quote, location, leadType, vehicle) {
    return quote.set('location', location).set('leadType', leadType).set('vehicle', vehicle);
}

function resetQuoteFromShowroomSave(quote, showroomQuote) {
    var warningCodes = (0, _lodash.map)(showroomQuote.warnings, function (warning) {
        return warning.error;
    });
    var availableItems = showroomQuote.availableItems || quote.vehicle.purchaseMethods.availableOptions.map(function (option) {
        return option.getShowroomQuoteItem();
    });
    var writeToken = _widgetCommonsCoreServices.UrlService.getUrlParameter('writeToken');

    if (!(0, _lodash.isEmpty)(writeToken) && showroomQuote.accountId === 'public') {
        showroomQuote.securityToken = writeToken;
    }

    return quote.set('id', showroomQuote.id).set('revision', showroomQuote.__revision) // eslint-disable-line no-underscore-dangle
    .set('accountId', showroomQuote.accountId).set('leadId', showroomQuote.leadId).set('dealerId', showroomQuote.dealerId).set('isValid', (0, _lodash.isEmpty)((0, _lodash.intersection)(criticalWarnings, warningCodes))).set('showroomItems', showroomQuote.items).set('warnings', showroomQuote.warnings).set('errors', showroomQuote.errors).set('securityToken', showroomQuote.securityToken || '').set('modified', false).set('vehicleId', String(showroomQuote.vehicleId || '')).setIn(['vehicle', 'purchaseMethods'], (0, _PurchaseMethodsService.resetOptionsAmounts)((0, _PurchaseMethodsService.resetPurchaseMethodsOptionsFromQuoteItems)(quote.vehicle.purchaseMethods, showroomQuote.items, availableItems)));
}

function resetQuoteFromShowroomLoad(quote, showroomQuote, disclaimers) {
    var pricingSummary = showroomQuote.pricingSummary,
        financingSummary = showroomQuote.financingSummary,
        tradeIns = showroomQuote.tradeIns,
        purchaseMethod = showroomQuote.purchaseMethod,
        purchaseMethods = showroomQuote.purchaseMethods;


    var vehicle = (0, _VehicleService.resetVehicleFromShowroomQuoteVehicle)(showroomQuote);
    if (!(0, _lodash.isEmpty)(purchaseMethods)) {
        var selectedPurchaseMethod = _purchaseMethods.CASH_PURCHASE;
        if (purchaseMethod === _purchaseMethodsValues2.default.LEASE || purchaseMethod === _purchaseMethodsValues2.default.SINGLE_PAYMENT_LEASE) {
            selectedPurchaseMethod = _purchaseMethods.LEASE;
        } else if (purchaseMethod === _purchaseMethodsValues2.default.FINANCE || purchaseMethod === _purchaseMethodsValues2.default.FINANCE_WITH_BALLOON) {
            selectedPurchaseMethod = _purchaseMethods.FINANCE;
        }

        var quotePurchaseMethods = selectedPurchaseMethod === _purchaseMethods.CASH_PURCHASE ? (0, _PurchaseMethodsService.selectPurchaseMethod)((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, purchaseMethods, null, disclaimers), selectedPurchaseMethod) : (0, _PurchaseMethodsService.selectPurchaseMethod)((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, purchaseMethods, null, disclaimers), selectedPurchaseMethod);

        if (selectedPurchaseMethod !== _purchaseMethods.CASH_PURCHASE) {
            quotePurchaseMethods = (0, _PurchaseMethodsService.selectTerm)(quotePurchaseMethods, financingSummary.term);
            quotePurchaseMethods = (0, _PurchaseMethodsService.selectPaymentFrequency)(quotePurchaseMethods, financingSummary.paymentsPerYear);
            quotePurchaseMethods = (0, _PurchaseMethodsService.setCashDown)(quotePurchaseMethods, pricingSummary.cashDown);
            if (financingSummary.annualKMAllowed > 0) {
                quotePurchaseMethods = (0, _PurchaseMethodsService.selectKMPlan)(quotePurchaseMethods, financingSummary.annualKMAllowed);
            }
        }
        quotePurchaseMethods = (0, _PurchaseMethodsService.setTradeIn)(quotePurchaseMethods, tradeIns.amountSummary.tradeIn);
        quotePurchaseMethods = (0, _PurchaseMethodsService.setLien)(quotePurchaseMethods, tradeIns.amountSummary.lien);

        vehicle = vehicle.set('purchaseMethods', quotePurchaseMethods);
    }

    var newQuote = quote.set('location', showroomQuote.location).set('status', showroomQuote.status).set('creditApplicationId', showroomQuote.creditApplicationId).set('vehicleId', String(showroomQuote.vehicleId || '')).set('vehicle', vehicle);

    return resetQuoteFromShowroomSave(newQuote, showroomQuote);
}

function resetQuoteDepositLead(quote, depositResponse) {
    return quote.set('status', quote.status | _statuses.CHECKOUT_WITH_DEPOSIT).set('leadId', String(depositResponse.leadId)).set('creditCardChargeId', depositResponse.stripeChargeId).setIn(['vehicle', 'purchaseMethods'], (0, _PurchaseMethodsService.setDeposit)(quote.vehicle.purchaseMethods, {
        checkout: true,
        override: depositResponse.depositAmount
    }));
}

function resetQuoteCreditApplication(quote, creditApplicationId) {
    return quote.set('creditApplicationId', creditApplicationId);
}

function getEmployeeRebateFromShowroomQuote(showroomQuote) {
    if (!(0, _lodash.isObjectLike)(showroomQuote) || (0, _lodash.isEmpty)(showroomQuote) || (0, _lodash.isEmpty)(showroomQuote.items)) {
        return null;
    }

    var employeeRebates = (0, _lodash.filter)(showroomQuote.items, function (item) {
        return item.dataType === _dataTypes.DATA_TYPES.REBATE.DATA_TYPE_ID && item.typeID === _dataTypes.DATA_TYPES.REBATE.TYPES.EMPLOYEE;
    });

    if ((0, _lodash.isEmpty)(employeeRebates)) {
        return null;
    }

    return {
        description: employeeRebates[0].description.descriptions[0],
        rebate: (0, _lodash.sumBy)(employeeRebates, function (employeeRebate) {
            return employeeRebate.amounts.retail;
        })
    };
}

function quoteHasVehicle(quote) {
    return quote && quote.vehicle && quote.vehicle.year && !(0, _lodash.isEmpty)(quote.vehicle.make) && !(0, _lodash.isEmpty)(quote.vehicle.model);
}

exports.default = {
    QuoteService: new QuoteService(),
    resetQuoteFromModelYear: resetQuoteFromModelYear,
    resetQuoteFromVehicle: resetQuoteFromVehicle,
    resetQuoteFromShowroomSave: resetQuoteFromShowroomSave,
    resetQuoteFromShowroomLoad: resetQuoteFromShowroomLoad,
    resetQuoteDepositLead: resetQuoteDepositLead,
    resetQuoteCreditApplication: resetQuoteCreditApplication,
    getEmployeeRebateFromShowroomQuote: getEmployeeRebateFromShowroomQuote,
    quoteHasVehicle: quoteHasVehicle
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/actions/tradeInVehicleActionTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_TRADE_IN_VEHICLE = exports.SET_TRADE_IN_VEHICLE = 'SET_TRADE_IN_VEHICLE';

exports.default = {
    SET_TRADE_IN_VEHICLE: SET_TRADE_IN_VEHICLE
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/actions/tradeInVehicleActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTradeInVehicle = setTradeInVehicle;
exports.saveTradeInVehicle = saveTradeInVehicle;
exports.loadTradeInVehicle = loadTradeInVehicle;

var _tradeInVehicleActionTypes = __webpack_require__("../widget-commons-vehicle/src/Vehicle/actions/tradeInVehicleActionTypes.js");

var tradeInVehicleTypes = _interopRequireWildcard(_tradeInVehicleActionTypes);

var _TradeInVehicleAPIService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js");

var _TradeInVehicleAPIService2 = _interopRequireDefault(_TradeInVehicleAPIService);

var _TradeInVehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

var TradeInVehicleService = _interopRequireWildcard(_TradeInVehicleService);

var _quoteActions = __webpack_require__("../widget-commons-vehicle/src/Quote/actions/quoteActions.js");

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _purchaseMethodsActions = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/actions/purchaseMethodsActions.js");

var PurchaseMethodsActions = _interopRequireWildcard(_purchaseMethodsActions);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _tradeInVehicleStatuses = __webpack_require__("../widget-commons-vehicle/src/Vehicle/constants/tradeInVehicleStatuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function setTradeInVehicle(tradeInVehicle) {
    return { type: tradeInVehicleTypes.SET_TRADE_IN_VEHICLE, tradeInVehicle: tradeInVehicle };
}

function saveTradeInVehicle(tradeInVehicle) {
    return function (dispatch) {
        _TradeInVehicleAPIService2.default.saveTradeInVehicle(tradeInVehicle).then(function (result) {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new CustomEvent(_widgetCommonsGeneral.EVENTS.TRADEIN_CREATED));
            }
            dispatch((0, _quoteActions.setQuoteRevision)(result.data.updatedQuotes));
            dispatch(setTradeInVehicle(tradeInVehicle.set('modified', false)));
        });
    };
}

function loadTradeInVehicle(stateTradeInVehicle, tradeInVehicleId) {
    return function (dispatch) {
        return _TradeInVehicleAPIService2.default.loadTradeInVehicle(tradeInVehicleId).then(function (tradeInVehicle) {
            var isEmptyTradeIn = !stateTradeInVehicle.id;
            var newTradeInVehicle = tradeInVehicle;
            var defaultPurchaseMethods = new _PurchaseMethodsModel2.default();
            var stateTradeInAmount = isEmptyTradeIn ? defaultPurchaseMethods.tradeIn : stateTradeInVehicle.getTradeInAmount();
            var stateLienAmount = isEmptyTradeIn ? defaultPurchaseMethods.lien : stateTradeInVehicle.getLienAmount();
            var loadedTradeInAmount = tradeInVehicle.getTradeInAmount();
            var loadedLienAmount = tradeInVehicle.getLienAmount();
            var isActivatedTradeIn = newTradeInVehicle.getUpdateStatus() === _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
            var isDescribedTradeIn = newTradeInVehicle.getUpdateStatus() === _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED;

            if (stateTradeInAmount !== loadedTradeInAmount || stateLienAmount !== loadedLienAmount) {
                if (stateTradeInAmount > 0 && (isActivatedTradeIn || isDescribedTradeIn)) {
                    newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, stateTradeInAmount);
                    newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, stateLienAmount);
                    if (isEmptyTradeIn) {
                        dispatch(PurchaseMethodsActions.setTradeIn(stateTradeInAmount));
                        dispatch(PurchaseMethodsActions.setLien(stateLienAmount));
                    }
                } else {
                    dispatch(PurchaseMethodsActions.setTradeIn(newTradeInVehicle.getTradeInAmount()));
                    dispatch(PurchaseMethodsActions.setLien(newTradeInVehicle.getLienAmount()));
                }
            } else if (isEmptyTradeIn && isActivatedTradeIn && !stateTradeInAmount && !loadedTradeInAmount && !stateLienAmount && !loadedLienAmount) {
                newTradeInVehicle = TradeInVehicleService.setTradeIn(newTradeInVehicle, 0);
                newTradeInVehicle = TradeInVehicleService.setLien(newTradeInVehicle, 0);
                dispatch(PurchaseMethodsActions.setTradeIn(0));
                dispatch(PurchaseMethodsActions.setLien(0));
            }

            dispatch(setTradeInVehicle(newTradeInVehicle));
            if (newTradeInVehicle.id && newTradeInVehicle.modified) {
                dispatch(saveTradeInVehicle(newTradeInVehicle));
            }
        });
    };
}

exports.default = {
    setTradeInVehicle: setTradeInVehicle,
    saveTradeInVehicle: saveTradeInVehicle,
    loadTradeInVehicle: loadTradeInVehicle
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/constants/tradeInVehicleStatuses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var AVAILABILITY_FLAGS = exports.AVAILABILITY_FLAGS = {
    ACTIVE: 0x0,
    EXPIRED: 0x1,
    DELETED: 0x2
};

var DATA_CONTENT_FLAGS = exports.DATA_CONTENT_FLAGS = {
    DESCRIPTION: 0x10,
    HISTORY: 0x20
};

var VALUE_SOURCE_FLAGS = exports.VALUE_SOURCE_FLAGS = {
    ESTIMATED: 0x100,
    OFFICIAL: 0x200
};

var UPDATE_STATUS = exports.UPDATE_STATUS = {
    ACTIVATED: AVAILABILITY_FLAGS.ACTIVE,
    DESCRIBED: DATA_CONTENT_FLAGS.DESCRIPTION,
    ESTIMATED: VALUE_SOURCE_FLAGS.ESTIMATED,
    ESTIMATED_EXPIRED: VALUE_SOURCE_FLAGS.ESTIMATED | AVAILABILITY_FLAGS.EXPIRED,
    OFFICIAL: VALUE_SOURCE_FLAGS.OFFICIAL,
    OFFICIAL_EXPIRED: VALUE_SOURCE_FLAGS.OFFICIAL | AVAILABILITY_FLAGS.EXPIRED
};

exports.default = {
    AVAILABILITY_FLAGS: AVAILABILITY_FLAGS,
    VALUE_SOURCE_FLAGS: VALUE_SOURCE_FLAGS,
    DATA_CONTENT_FLAGS: DATA_CONTENT_FLAGS,
    UPDATE_STATUS: UPDATE_STATUS
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/constants/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var URL = {
    NO_PHOTO: '/widget/showroom/asset/non-photo.png'
};

exports.default = URL;

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/models/MultiMediaModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.imageInventoryPath = exports.imagesBasePath = exports.imagesServer = exports.buildCatalogWithMatchedCatalogVehicle = exports.buildInventoryBasePath = exports.buildImageUrls = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _url = __webpack_require__("../widget-commons-vehicle/src/Vehicle/constants/url.js");

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var imagesServer = _index2.default.source.image;
var imagesBasePath = '/images';
var imageInventoryPath = '/inventory';

function buildImageUrls(imagePath) {
    return {
        url: '' + imagesServer + (imagePath || ''),
        url360x270: imagesServer + '/ir/w360h270' + (imagePath || ''),
        url360x240: imagesServer + '/ir/w360h197c' + (imagePath || ''),
        url440: imagesServer + '/ir/w440' + (imagePath || '')
    };
}

function buildInventoryBasePath() {
    return '' + imagesBasePath + imageInventoryPath;
}

function buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle) {
    if (matchedCatalogVehicle && matchedCatalogVehicle.multimedia && matchedCatalogVehicle.multimedia.exteriorPictures) {
        return {
            catalog: matchedCatalogVehicle.multimedia.exteriorPictures
        };
    }
    return null;
}

var MultiMediaRecord = (0, _immutable.Record)({
    pictures: [],
    mainPicture: {
        url: '',
        url360x270: '',
        url440: ''
    },
    catalog: {
        side: {
            url: '',
            url360x197: '',
            exactMatch: false
        }
    },
    video: {
        url: ''
    }
});

var MultiMedia = function (_MultiMediaRecord) {
    _inherits(MultiMedia, _MultiMediaRecord);

    function MultiMedia(obj, matchedCatalogVehicle) {
        _classCallCheck(this, MultiMedia);

        var args = (0, _lodash.pickBy)(obj);
        var newArgs = {};

        if (args) {
            if (args.pictures && args.pictures.length) {
                newArgs.pictures = args.pictures.map(function (picture) {
                    var newUrl = '';

                    if (picture.url) {
                        newUrl = '' + imagesServer + buildInventoryBasePath() + picture.url;
                    }

                    return _extends({}, picture, {
                        url: newUrl,
                        src: newUrl
                    });
                });
            }

            if (args.mainPicture && args.mainPicture.url) {
                var imagePath = '' + buildInventoryBasePath() + args.mainPicture.url;

                newArgs.mainPicture = _extends({}, args.mainPicture, buildImageUrls(imagePath));
            }

            if (args.catalog) {
                var _imagePath = args.catalog.side && args.catalog.side.url ? args.catalog.side.url : _url2.default.NO_PHOTO;
                var imageUrl = imagesBasePath + '/' + _imagePath;
                newArgs.catalog = {
                    side: buildImageUrls(imageUrl)
                };
            }
        }

        if (matchedCatalogVehicle) {
            var multimediaCatalog = buildCatalogWithMatchedCatalogVehicle(matchedCatalogVehicle);
            if (multimediaCatalog) {
                newArgs.catalog = multimediaCatalog.catalog;
            }
        }

        return _possibleConstructorReturn(this, (MultiMedia.__proto__ || Object.getPrototypeOf(MultiMedia)).call(this, _extends({}, args, newArgs)));
    }

    _createClass(MultiMedia, [{
        key: 'getMainImage',
        value: function getMainImage() {
            return this.mainPicture && this.mainPicture.url ? this.mainPicture.url : '';
        }
    }, {
        key: 'getMainImage360x270',
        value: function getMainImage360x270() {
            return this.mainPicture && this.mainPicture.url360x270 ? this.mainPicture.url360x270 : '';
        }
    }, {
        key: 'getMainImage440',
        value: function getMainImage440() {
            return this.mainPicture && this.mainPicture.url440 ? this.mainPicture.url440 : '';
        }
    }, {
        key: 'getCatalogSideImage',
        value: function getCatalogSideImage() {
            return this.catalog && this.catalog.side && this.catalog.side.url ? this.catalog.side.url : '';
        }
    }, {
        key: 'getCatalogSideImage360x197',
        value: function getCatalogSideImage360x197() {
            return this.catalog && this.catalog.side && this.catalog.side.url360x240 ? this.catalog.side.url360x240 : '';
        }
    }, {
        key: 'getPicture',
        value: function getPicture(index) {
            // eslint-disable-next-line no-restricted-globals
            if (!isFinite(index) || index < 0 || !this.pictures.length || index > this.pictures.length) {
                return '';
            }

            var picture = this.pictures[index];

            return picture && picture.url ? picture.url : '';
        }
    }, {
        key: 'getVideo',
        value: function getVideo() {
            return this.hasVideo() ? this.video.url : '';
        }
    }, {
        key: 'hasPictures',
        value: function hasPictures() {
            return !(0, _lodash.isEmpty)(this.pictures);
        }
    }, {
        key: 'hasVideo',
        value: function hasVideo() {
            return !!(this.video && this.video.url);
        }
    }]);

    return MultiMedia;
}(MultiMediaRecord);

exports.buildImageUrls = buildImageUrls;
exports.buildInventoryBasePath = buildInventoryBasePath;
exports.buildCatalogWithMatchedCatalogVehicle = buildCatalogWithMatchedCatalogVehicle;
exports.imagesServer = imagesServer;
exports.imagesBasePath = imagesBasePath;
exports.imageInventoryPath = imageInventoryPath;
exports.default = MultiMedia;

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/models/TradeInVehicleModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _tradeInVehicleStatuses = __webpack_require__("../widget-commons-vehicle/src/Vehicle/constants/tradeInVehicleStatuses.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeInVehicleRecord = (0, _immutable.Record)({
    id: '',
    status: 0,
    accountId: '',
    dealerId: '',
    taxesFactor: 0,
    taxCodes: [],
    vehicle: new _VehicleModel2.default(),
    lien: {
        owner: '',
        amount: 0
    },
    amount: 0,
    evaluationQuestion: null,
    modified: false
});

var TradeInVehicle = function (_TradeInVehicleRecord) {
    _inherits(TradeInVehicle, _TradeInVehicleRecord);

    function TradeInVehicle() {
        _classCallCheck(this, TradeInVehicle);

        return _possibleConstructorReturn(this, (TradeInVehicle.__proto__ || Object.getPrototypeOf(TradeInVehicle)).apply(this, arguments));
    }

    _createClass(TradeInVehicle, [{
        key: 'getTradeInAmount',
        value: function getTradeInAmount() {
            return this.amount;
        }
    }, {
        key: 'getLienAmount',
        value: function getLienAmount() {
            return this.lien.amount;
        }
    }, {
        key: 'getShowroomTradeInVehicle',
        value: function getShowroomTradeInVehicle() {
            var id = this.id,
                status = this.status,
                lien = this.lien,
                amount = this.amount,
                evaluationQuestion = this.evaluationQuestion;

            var showroomVehicle = this.vehicle.getShowroomVehicle();

            return {
                id: id,
                status: status,
                vehicle: showroomVehicle,
                lien: lien,
                amount: amount,
                evaluationQuestion: evaluationQuestion
            };
        }
    }, {
        key: 'getUpdateStatus',
        value: function getUpdateStatus() {
            if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED) === _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL_EXPIRED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL) === _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.OFFICIAL;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED) === _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED_EXPIRED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED) === _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.ESTIMATED;
            } else if ((this.status & _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED) === _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED && (this.status & _tradeInVehicleStatuses.AVAILABILITY_FLAGS.DELETED) === 0) {
                return _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED;
            }
            return _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
        }
    }, {
        key: 'checkIsLocked',
        value: function checkIsLocked() {
            var updateStatus = this.getUpdateStatus();
            return updateStatus !== _tradeInVehicleStatuses.UPDATE_STATUS.DESCRIBED && updateStatus !== _tradeInVehicleStatuses.UPDATE_STATUS.ACTIVATED;
        }
    }, {
        key: 'checkIsUpdatable',
        value: function checkIsUpdatable() {
            return _widgetCommonsGeneral.AccountService.isAuthenticated() && !this.checkIsLocked() && this.id && this.modified;
        }
    }, {
        key: 'getTaxCredits',
        value: function getTaxCredits() {
            return Math.round(this.amount * this.taxesFactor * 100) / 100;
        }
    }]);

    return TradeInVehicle;
}(TradeInVehicleRecord);

exports.default = TradeInVehicle;

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__("immutable");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _currencyFormats = __webpack_require__("../widget-commons-vehicle/src/constants/currencyFormats.js");

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _MultiMediaModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/MultiMediaModel.js");

var _MultiMediaModel2 = _interopRequireDefault(_MultiMediaModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleRecord = (0, _immutable.Record)({
    bodyStyle: null,
    bodyStyleCode: '',
    bodyColour: null,
    exteriorColourStatus: 0,
    boxSizeCode: '',
    boxSize: '',
    cabSizeCode: '',
    cabSize: '',
    catalogVehicleId: 0,
    clearance: false,
    configuration: null,
    configurationId: 0,
    configurationToken: '',
    discount: 0,
    doors: 0,
    driveTrain: '',
    driveTrainCode: '',
    engine: '',
    exteriorColour: '',
    favorite: false,
    features: [],
    flags: [],
    fuelCity: 0.0,
    fuelHighway: 0.0,
    fuelType: '',
    id: '',
    interiorColour: '',
    organizationUnitName: '',
    locked: false,
    make: '',
    model: '',
    modelTrim: '',
    modelTrimCode: '',
    modelTrimStyle: [],
    multimedia: new _MultiMediaModel2.default(),
    newCarTrimId: 0, // V2.5
    note: '',
    odometer: null,
    purchaseMethods: new _PurchaseMethodsModel2.default(),
    recentViewCount: 0,
    seating: 0,
    sellingPrice: 0,
    stockNumber: '',
    sold: false,
    tagLine: '',
    transmission: '',
    trim: '',
    vehicleConditionType: _vehicle2.default.CONDITIONS.USED,
    vehicleId: 0,
    vin: '',
    warranty: {},
    year: 0,
    discontinued: false,
    online: true
});

var Vehicle = function (_VehicleRecord) {
    _inherits(Vehicle, _VehicleRecord);

    function Vehicle() {
        _classCallCheck(this, Vehicle);

        return _possibleConstructorReturn(this, (Vehicle.__proto__ || Object.getPrototypeOf(Vehicle)).apply(this, arguments));
    }

    _createClass(Vehicle, [{
        key: 'isAvailable',
        value: function isAvailable() {
            return !(this.sold || this.locked || this.discontinued || !this.online);
        }
    }, {
        key: 'getIsVehicleNew',
        value: function getIsVehicleNew() {
            return this.vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || this.vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO;
        }
    }, {
        key: 'getMake',
        value: function getMake() {
            return !this.model.includes(this.make) ? this.make : '';
        }
    }, {
        key: 'getVehicleConditionType',
        value: function getVehicleConditionType() {
            switch (this.vehicleConditionType) {
                case _vehicle2.default.CONDITIONS.NEW:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.NEW');
                case _vehicle2.default.CONDITIONS.DEMO:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.DEMO');
                default:
                    return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_STATUS.USED');
            }
        }
    }, {
        key: 'getYearMakeModel',
        value: function getYearMakeModel() {
            return this.year > 0 ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL', {
                year: this.year,
                make: this.getMake(),
                model: this.model
            }) : '';
        }
    }, {
        key: 'getYearMakeModelTrim',
        value: function getYearMakeModelTrim() {
            if (this.year === 0) {
                return '';
            }

            var modelTrim = this.configuration !== null ? this.configuration.modelTrim.description : this.modelTrim;

            return this.modelTrim && !this.model.includes(this.modelTrim) ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL_TRIM', {
                year: this.year,
                make: this.getMake(),
                model: this.model,
                modelTrim: modelTrim
            }) : _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MAKE_MODEL', {
                year: this.year,
                make: this.getMake(),
                model: this.model
            });
        }
    }, {
        key: 'getYearModel',
        value: function getYearModel() {
            if (this.year === 0) {
                return '';
            }

            return _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL', { year: this.year, model: this.model });
        }
    }, {
        key: 'getYearModelTrim',
        value: function getYearModelTrim() {
            if (this.year === 0) {
                return '';
            }

            var modelTrim = this.configuration !== null ? this.configuration.modelTrim.description : this.modelTrim;
            return this.modelTrim && this.modelTrim !== this.model ? _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL_TRIM', {
                year: this.year,
                model: this.model,
                modelTrim: modelTrim
            }) : _widgetCommonsCoreServices.LocaleService.t('VEHICLE_MODEL.YEAR_MODEL', {
                year: this.year,
                model: this.model
            });
        }
    }, {
        key: 'getDiscount',
        value: function getDiscount() {
            return this.discount > 250 ? this.discount : 0;
        }
    }, {
        key: 'getOdometer',
        value: function getOdometer() {
            if (!this.odometer) {
                return '';
            }

            var odometer = _widgetCommonsCoreServices.LocaleService.l(this.odometer, _currencyFormats.ODOMETER);
            return odometer + ' km';
        }
    }, {
        key: 'getFuelConsumptionAverage',
        value: function getFuelConsumptionAverage() {
            return Math.round((this.fuelCity + this.fuelHighway) / 2 * 10) / 10;
        }
    }, {
        key: 'getDriveTrain',
        value: function getDriveTrain() {
            if (this.configuration !== null) {
                return this.configuration.driveTrain.longDescription;
            }
            return this.driveTrain;
        }
    }, {
        key: 'getEngine',
        value: function getEngine() {
            if (this.configuration !== null) {
                return this.configuration.engine.getSizeSpecifications();
            }
            return this.engine;
        }
    }, {
        key: 'getTransmission',
        value: function getTransmission() {
            if (this.configuration !== null) {
                return this.configuration.transmission.getTransmission();
            }
            return this.transmission;
        }
    }, {
        key: 'getPaymentCalculatorVehicleParameters',
        value: function getPaymentCalculatorVehicleParameters() {
            return {
                vehicleConditionType: this.vehicleConditionType,
                year: this.year,
                make: this.make,
                model: this.model,
                bodyStyleCode: this.bodyStyleCode,
                driveTrainCode: this.driveTrainCode,
                odometer: this.odometer,
                sellingPrice: this.sellingPrice
            };
        }
    }, {
        key: 'getDefaultVehicleQuoteItem',
        value: function getDefaultVehicleQuoteItem() {
            return {
                dataType: _dataTypes.DATA_TYPES.FEATURE.DATA_TYPE_ID,
                typeID: _dataTypes.DATA_TYPES.FEATURE.TYPES.MODEL_TRIM,
                code: _dataTypes.DEFAULT_MODEL_TRIM_CODE,
                flag: _dataTypes.ITEM_FLAG.SELECTED,
                amounts: {
                    retail: this.sellingPrice
                },
                description: {
                    descriptions: [this.model]
                }
            };
        }
    }, {
        key: 'getShowroomVehicle',
        value: function getShowroomVehicle() {
            var bodyColour = this.bodyColour,
                bodyStyle = this.bodyStyle,
                id = this.id,
                vehicleId = this.vehicleId,
                catalogVehicleId = this.catalogVehicleId,
                newCarTrimId = this.newCarTrimId,
                vehicleConditionType = this.vehicleConditionType,
                vin = this.vin,
                year = this.year,
                make = this.make,
                model = this.model,
                modelTrim = this.modelTrim,
                modelTrimCode = this.modelTrimCode,
                modelTrimStyle = this.modelTrimStyle,
                stockNumber = this.stockNumber,
                sold = this.sold,
                odometer = this.odometer,
                configuration = this.configuration,
                configurationId = this.configurationId,
                configurationToken = this.configurationToken;


            var isNewFromConfiguration = configuration !== null && (vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO);

            return {
                bodyColour: bodyColour,
                bodyStyle: bodyStyle,
                id: id,
                vehicleId: String(vehicleId),
                catalogVehicleId: String(catalogVehicleId),
                newCarTrimId: String(newCarTrimId), // V2.5
                vehicleCondition: vehicleConditionType,
                vin: vin,
                year: year,
                make: make,
                model: model,
                modelTrim: modelTrim,
                modelTrimCode: isNewFromConfiguration ? configuration.modelTrimCode : modelTrimCode,
                modelTrimStyle: isNewFromConfiguration ? configuration.modelTrimStyle : modelTrimStyle,
                configurationID: isNewFromConfiguration ? configuration.id : configurationId,
                configurationToken: configurationToken || '',
                odometer: odometer,
                sold: sold,
                inventory: {
                    stock: stockNumber
                }
            };
        }
    }]);

    return Vehicle;
}(VehicleRecord);

exports.default = Vehicle;

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleAPIService/TradeInVehicleAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TradeInVehicleAPIService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _TradeInVehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Groups Trade In Vehicle api calls to ShowroomAPI
 */
var TradeInVehicleAPIService = function () {
    function TradeInVehicleAPIService() {
        _classCallCheck(this, TradeInVehicleAPIService);

        /**
         * The base path for Trade In Vehicle ShowroomAPI
         * @type {string}
         */
        this.basePath = _index2.default.endpoint.showroom + '/service/v1/TradeInVehicle';
    }

    /**
     * Returns the axios request configuration object to load a Trade In Vehicle Model
     * @param {string} tradeInVehicleId
     */


    _createClass(TradeInVehicleAPIService, [{
        key: 'getLoadTradeInVehicleRequestConfig',
        value: function getLoadTradeInVehicleRequestConfig(tradeInVehicleId) {
            var requestTradeInVehicleId = (0, _lodash.isString)(tradeInVehicleId) ? tradeInVehicleId : '';
            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var tradeInVehicleIdParam = requestTradeInVehicleId ? '/' + requestTradeInVehicleId : '';

            var requestConfig = {
                url: '' + this.basePath + tradeInVehicleIdParam,
                method: 'get'
            };

            requestConfig.headers = {
                'x-jwt': (0, _lodash.isEmpty)(token) ? '' : token
            };

            requestConfig.params = {
                context: ((0, _lodash.isNull)(orgId) ? '' : orgId) + '.' + ((0, _lodash.isNull)(orgUnitId) ? '' : orgUnitId),
                language: (0, _lodash.isEmpty)(language) ? '' : language,
                location: (0, _lodash.isEmpty)(location) ? '' : location
            };

            return requestConfig;
        }

        /**
         * Returns a Trade In Vehicle Model from an id or from the authenticated account
         * @param {string} tradeInVehicleId
         */

    }, {
        key: 'loadTradeInVehicle',
        value: function loadTradeInVehicle(tradeInVehicleId) {
            var requestConfig = this.getLoadTradeInVehicleRequestConfig(tradeInVehicleId);
            return _axios2.default.request(requestConfig).then(function (result) {
                return (0, _TradeInVehicleService.resetTradeInVehicleFromShowroomTradeInVehicle)(result.data);
            }).catch(function () {
                console.error('Unable to get trade in vehicle for id ' + tradeInVehicleId);
                return Promise.reject();
            });
        }

        /**
         * Saves a Trade In Vehicle Model back in the showroom database
         * @param {TradeInVehicleModel} tradeInVehicle
         */

    }, {
        key: 'saveTradeInVehicle',
        value: function saveTradeInVehicle(tradeInVehicle) {
            if (!tradeInVehicle || !(0, _lodash.isObjectLike)(tradeInVehicle)) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing or invalid parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }

            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + orgId + '.' + orgUnitId;

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var showroomTradeInVehicle = tradeInVehicle.getShowroomTradeInVehicle();

            return _axios2.default.put(this.basePath + '?' + context + '&updateQuotes=true', showroomTradeInVehicle, {
                headers: { 'x-jwt': token }
            }).then(function (result) {
                return result;
            }).catch(function () {
                console.error('Unable to save trade in vehicle');
                return Promise.reject();
            });
        }
    }]);

    return TradeInVehicleAPIService;
}();

exports.TradeInVehicleAPIService = TradeInVehicleAPIService;
exports.default = new TradeInVehicleAPIService();

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.resetTradeInVehicleFromShowroomTradeInVehicle = resetTradeInVehicleFromShowroomTradeInVehicle;
exports.setTaxesFactor = setTaxesFactor;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;

var _lodash = __webpack_require__("lodash");

var _VehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js");

var _TradeInVehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/TradeInVehicleModel.js");

var _TradeInVehicleModel2 = _interopRequireDefault(_TradeInVehicleModel);

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseAmount(amount) {
    var parsedAmount = 0;
    if (amount) {
        parsedAmount = parseInt(amount, 10);
    }
    return !(0, _lodash.isNaN)(parsedAmount) ? parsedAmount : 0;
}

function resetTradeInVehicleFromShowroomTradeInVehicle(tradeInVehicle) {
    if (!(0, _lodash.isObjectLike)(tradeInVehicle)) {
        return new _TradeInVehicleModel2.default();
    }

    var id = tradeInVehicle.id,
        status = tradeInVehicle.status,
        lien = tradeInVehicle.lien,
        amount = tradeInVehicle.amount,
        evaluationQuestion = tradeInVehicle.evaluationQuestion,
        taxesFactor = tradeInVehicle.taxesFactor,
        taxCodes = tradeInVehicle.taxCodes;


    var vehicle = new _VehicleModel2.default();
    if ((0, _lodash.isObjectLike)(tradeInVehicle.vehicle)) {
        vehicle = (0, _VehicleService.resetVehicleFromShowroomVehicle)(tradeInVehicle.vehicle);
    }

    return new _TradeInVehicleModel2.default({
        id: id,
        status: status,
        taxesFactor: (0, _lodash.isUndefined)(taxesFactor) ? 0 : taxesFactor,
        taxCodes: (0, _lodash.isUndefined)(taxCodes) ? [] : taxCodes,
        vehicle: vehicle,
        lien: lien,
        amount: amount,
        evaluationQuestion: evaluationQuestion,
        modified: false
    });
}

function setTaxesFactor(tradeInVehicle, purchaseMethods) {
    var lien = _extends({}, tradeInVehicle.lien, { amount: purchaseMethods.lien });
    return tradeInVehicle.set('amount', purchaseMethods.tradeIn).set('lien', lien).set('taxesFactor', purchaseMethods.taxesFactor).set('taxCodes', purchaseMethods.taxCodes);
}

function setTradeIn(tradeInVehicle, tradeInAmount) {
    var parsedTradeInAmount = parseAmount(tradeInAmount);
    if (tradeInVehicle.amount === parsedTradeInAmount) {
        return tradeInVehicle;
    }

    return tradeInVehicle.set('amount', parsedTradeInAmount).set('modified', true);
}

function setLien(tradeInVehicle, lienAmount) {
    var lien = tradeInVehicle.lien;

    var parsedLienAmount = parseAmount(lienAmount);
    if (lien.amount === parsedLienAmount) {
        return tradeInVehicle;
    }

    lien.amount = parsedLienAmount;
    return tradeInVehicle.set('lien', lien).set('modified', true);
}

exports.default = {
    resetTradeInVehicleFromShowroomTradeInVehicle: resetTradeInVehicleFromShowroomTradeInVehicle,
    setTradeIn: setTradeIn,
    setLien: setLien
};

/***/ }),

/***/ "../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetVehicleFromWebAutoInventory = resetVehicleFromWebAutoInventory;
exports.resetVehicleFromShowroomVehicle = resetVehicleFromShowroomVehicle;
exports.resetVehicleFromShowroomQuoteVehicle = resetVehicleFromShowroomQuoteVehicle;
exports.setVehiclePurchaseMethods = setVehiclePurchaseMethods;
exports.setBestPaymentTerm = setBestPaymentTerm;
exports.selectPaymentFrequency = selectPaymentFrequency;
exports.setCashDown = setCashDown;
exports.setTradeIn = setTradeIn;
exports.setLien = setLien;
exports.setTargetPayment = setTargetPayment;
exports.isVehicleNew = isVehicleNew;

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var PurchaseMethodsService = _interopRequireWildcard(_PurchaseMethodsService);

var _VehicleModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/VehicleModel.js");

var _VehicleModel2 = _interopRequireDefault(_VehicleModel);

var _MultiMediaModel = __webpack_require__("../widget-commons-vehicle/src/Vehicle/models/MultiMediaModel.js");

var _MultiMediaModel2 = _interopRequireDefault(_MultiMediaModel);

var _EngineModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/EngineModel.js");

var _EngineModel2 = _interopRequireDefault(_EngineModel);

var _TransmissionModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/TransmissionModel.js");

var _TransmissionModel2 = _interopRequireDefault(_TransmissionModel);

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imagesServer = _index2.default.source.image;
var imagesBasePath = '/images/newcar';

function resetVehicleFromWebAutoInventory(inventory) {
    if (!(0, _lodash.isObjectLike)(inventory)) {
        return new _VehicleModel2.default();
    }

    var driveTrain = '';
    var engine = '';
    var fuelType = '';
    var fuelCity = 0.0;
    var fuelHighway = 0.0;
    var transmission = '';
    var exteriorColour = '';
    var interiorColour = '';
    var bodyStyle = '';
    var doors = 0;
    var seating = 0;

    if (!(0, _lodash.isEmpty)(inventory.characteristics)) {
        if (!(0, _lodash.isEmpty)(inventory.characteristics.transmission)) {
            transmission = inventory.characteristics.transmission.label;
            if (!(0, _lodash.isEmpty)(inventory.characteristics.transmission.driveTrain)) {
                driveTrain = inventory.characteristics.transmission.driveTrain.label;
            }
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.engine)) {
            engine = inventory.characteristics.engine.description;
            fuelType = inventory.characteristics.engine.fuel ? inventory.characteristics.engine.fuel.label : '';
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.exteriorColor)) {
            exteriorColour = inventory.characteristics.exteriorColor.label;
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.interiorColor)) {
            interiorColour = inventory.characteristics.interiorColor.label;
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.body)) {
            doors = inventory.characteristics.body.doors;
            seating = inventory.characteristics.body.passengers;
            bodyStyle = inventory.characteristics.body.frameStyle ? inventory.characteristics.body.frameStyle.label : '';
        }

        if (!(0, _lodash.isEmpty)(inventory.characteristics.consumptions)) {
            (0, _lodash.forEach)(inventory.characteristics.consumptions, function (consumption) {
                if (consumption.type === 'IN_CITY') {
                    fuelCity = consumption.quantity;
                } else if (consumption.type === 'ON_HIGHWAY') {
                    fuelHighway = consumption.quantity;
                }
            });
        }
    }

    var flags = [];
    var vehicleConditionType = _vehicle2.default.CONDITIONS.USED;
    if (!(0, _lodash.isEmpty)(inventory.flags)) {
        flags = inventory.flags;

        var isCertified = flags.filter(function (flag) {
            return flag.type === 'CERTIFIED';
        }).length > 0;

        var isNew = flags.filter(function (flag) {
            return flag.type === 'NEW';
        }).length > 0;

        if (isCertified) vehicleConditionType = _vehicle2.default.CONDITIONS.CERTIFIED;
        if (isNew) vehicleConditionType = _vehicle2.default.CONDITIONS.NEW;
    }

    return new _VehicleModel2.default({
        vehicleId: inventory.id,
        vehicleConditionType: vehicleConditionType,
        vin: inventory.vin,
        stockNumber: inventory.stockNo || '',
        sold: inventory.sold,
        year: inventory.year,
        make: inventory.make ? inventory.make.name : '',
        model: inventory.model ? inventory.model.name : '',
        trim: inventory.trim ? inventory.trim.name : '',
        bodyStyle: bodyStyle,
        driveTrain: driveTrain,
        engine: engine,
        fuelType: fuelType,
        flags: flags,
        fuelCity: fuelCity,
        fuelHighway: fuelHighway,
        transmission: transmission,
        exteriorColour: exteriorColour,
        interiorColour: interiorColour,
        doors: doors,
        seating: seating,
        odometer: inventory.odometer,
        sellingPrice: inventory.prices ? inventory.prices.sale : 0,
        discount: inventory.prices ? inventory.prices.regular - inventory.prices.sale : 0,
        features: !(0, _lodash.isEmpty)(inventory.options) ? inventory.options.labels : [],
        multimedia: new _MultiMediaModel2.default(inventory.multimedia),
        tagLine: inventory.tagline || '',
        note: inventory.description,
        recentViewCount: inventory.pageViewSummary ? inventory.pageViewSummary.recentViewCount : 0,
        locked: inventory.onHold,
        warranty: inventory.warranty,
        online: inventory.online
    });
}

function resetVehicleFromShowroomVehicle(vehicle) {
    if (!(0, _lodash.isObjectLike)(vehicle) || (0, _lodash.isEmpty)(vehicle)) {
        return new _VehicleModel2.default();
    }

    var id = vehicle.id,
        vehicleId = vehicle.vehicleId,
        catalogVehicleId = vehicle.catalogVehicleId,
        newCarTrimId = vehicle.newCarTrimId,
        vin = vehicle.vin,
        vehicleCondition = vehicle.vehicleCondition,
        year = vehicle.year,
        make = vehicle.make,
        model = vehicle.model,
        bodyColourStatus = vehicle.bodyColourStatus,
        bodyStyleCode = vehicle.bodyStyleCode,
        bodyStyle = vehicle.bodyStyle,
        cabSizeCode = vehicle.cabSizeCode,
        cabSize = vehicle.cabSize,
        boxSizeCode = vehicle.boxSizeCode,
        boxSize = vehicle.boxSize,
        driveTrainDescription = vehicle.driveTrainDescription,
        modelTrim = vehicle.modelTrim,
        modelTrimCode = vehicle.modelTrimCode,
        modelTrimStyle = vehicle.modelTrimStyle,
        bodyColour = vehicle.bodyColour,
        engineFeatures = vehicle.engineFeatures,
        transmissionFeatures = vehicle.transmissionFeatures,
        configurationID = vehicle.configurationID,
        configurationToken = vehicle.configurationToken,
        odometer = vehicle.odometer,
        inventory = vehicle.inventory,
        sold = vehicle.sold;


    var engine = '';
    if (engineFeatures) {
        var engineModel = new _EngineModel2.default({
            fuelTypeCode: engineFeatures.fuelType,
            cylinders: engineFeatures.cylinders,
            displacement: engineFeatures.displacement,
            isTurbo: engineFeatures.isTurbo,
            hp: engineFeatures.hp,
            hpRpm: engineFeatures.hpRpm,
            torque: engineFeatures.torque,
            torqueRpm: engineFeatures.torqueRpm
        });
        engine = engineModel.getSizeSpecifications(_widgetCommonsCoreServices.LocaleService);
    }

    var transmission = '';
    if (transmissionFeatures) {
        var transmissionModel = new _TransmissionModel2.default({
            typeCode: transmissionFeatures.transmissionTypeCode,
            type: transmissionFeatures.transmissionType,
            speeds: transmissionFeatures.speeds,
            isCVT: transmissionFeatures.isCVT,
            description: transmissionFeatures.transmissionTypeDescription[0]
        });
        transmission = transmissionModel.getTransmission(_widgetCommonsCoreServices.LocaleService);
    }

    var multimedia = new _MultiMediaModel2.default();
    if (!(0, _lodash.isEmpty)(bodyColour)) {
        var url = '' + imagesServer + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url360x270 = imagesServer + '/ir/w360h270' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url360x240 = imagesServer + '/ir/w360h197c' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;
        var url440 = imagesServer + '/ir/w440' + imagesBasePath + '/' + bodyColour.vehiclePhotoUrl;

        multimedia = multimedia.set('mainPicture', { url: url, url360x270: url360x270 }).set('catalog', {
            side: {
                url: url,
                url360x240: url360x240,
                url360x270: url360x270,
                url440: url440
            }
        });
    }

    var vehicleIdInt = parseInt(vehicleId, 10);
    var catalogVehicleIdInt = parseInt(catalogVehicleId, 10);
    var newCarTrimIdInt = parseInt(newCarTrimId, 10);
    return new _VehicleModel2.default({
        id: id,
        vehicleId: (0, _lodash.isNaN)(vehicleIdInt) ? 0 : vehicleIdInt,
        catalogVehicleId: (0, _lodash.isNaN)(catalogVehicleIdInt) ? 0 : catalogVehicleIdInt,
        newCarTrimId: (0, _lodash.isNaN)(newCarTrimIdInt) ? 0 : newCarTrimIdInt,
        vehicleConditionType: vehicleCondition,
        vin: vin,
        stockNumber: inventory ? inventory.stock : '',
        year: year,
        make: make,
        model: model,
        modelTrim: modelTrim,
        modelTrimStyle: modelTrimStyle,
        bodyColour: bodyColour,
        exteriorColourStatus: bodyColourStatus,
        bodyStyle: bodyStyle,
        bodyStyleCode: bodyStyleCode,
        cabSizeCode: cabSizeCode,
        cabSize: cabSize,
        boxSizeCode: boxSizeCode,
        boxSize: boxSize,
        driveTrain: driveTrainDescription,
        modelTrimCode: modelTrimCode,
        engine: engine,
        transmission: transmission,
        odometer: odometer,
        multimedia: multimedia,
        configurationToken: configurationToken,
        configurationId: configurationID,
        sold: sold
    });
}

function resetVehicleFromShowroomQuoteVehicle(quote) {
    if (!(0, _lodash.isObjectLike)(quote) || !quote.vehicle || !(0, _lodash.isObjectLike)(quote.vehicle)) {
        return new _VehicleModel2.default();
    }

    return resetVehicleFromShowroomVehicle(quote.vehicle);
}

function setVehiclePurchaseMethods(vehicle, purchaseMethods) {
    if (!(0, _lodash.isObjectLike)(purchaseMethods)) {
        return vehicle.set('purchaseMethods', PurchaseMethodsService.selectPurchaseMethod(vehicle.purchaseMethods, purchaseMethods));
    }
    return vehicle.set('purchaseMethods', purchaseMethods);
}

function setBestPaymentTerm(vehicle, maximumTerm) {
    var selectedFinanceTerm = vehicle.purchaseMethods.getSelectedFinanceTerm();
    if (!selectedFinanceTerm) {
        return vehicle;
    }

    return vehicle.set('purchaseMethods', PurchaseMethodsService.setSelectedFinanceBestPaymentTerm(vehicle.purchaseMethods, maximumTerm));
}

function selectPaymentFrequency(vehicle, paymentFrequency) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.selectPaymentFrequency(vehicle.purchaseMethods, paymentFrequency));
}

function setCashDown(vehicle, cashDown) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setCashDown(vehicle.purchaseMethods, cashDown));
}

function setTradeIn(vehicle, tradeIn) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setTradeIn(vehicle.purchaseMethods, tradeIn));
}

function setLien(vehicle, lien) {
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setLien(vehicle.purchaseMethods, lien));
}

function setTargetPayment(vehicle, targetPayment) {
    var targetCashDown = vehicle.purchaseMethods.getCashDownFromTargetPayment(targetPayment);
    return vehicle.set('purchaseMethods', PurchaseMethodsService.setCashDown(vehicle.purchaseMethods, targetCashDown));
}

function isVehicleNew(vehicle) {
    if (vehicle && vehicle.vehicleConditionType) {
        if (vehicle.vehicleConditionType === _vehicle2.default.CONDITIONS.NEW || vehicle.vehicleConditionType === _vehicle2.default.CONDITIONS.DEMO) {
            return true;
        }
    }
    return false;
}

exports.default = {
    resetVehicleFromWebAutoInventory: resetVehicleFromWebAutoInventory,
    resetVehicleFromShowroomQuoteVehicle: resetVehicleFromShowroomQuoteVehicle,
    resetVehicleFromShowroomVehicle: resetVehicleFromShowroomVehicle,
    setVehiclePurchaseMethods: setVehiclePurchaseMethods,
    setBestPaymentTerm: setBestPaymentTerm,
    selectPaymentFrequency: selectPaymentFrequency,
    setCashDown: setCashDown,
    setTradeIn: setTradeIn,
    setLien: setLien,
    setTargetPayment: setTargetPayment,
    isVehicleNew: isVehicleNew
};

/***/ }),

/***/ "../widget-commons-vehicle/src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "../widget-commons-vehicle/src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("../widget-commons-vehicle/src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("../widget-commons-vehicle/src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("../widget-commons-vehicle/src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("../widget-commons-vehicle/src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "../widget-commons-vehicle/src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "../widget-commons-vehicle/src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-api-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"http://localhost:3360/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "../widget-commons-vehicle/src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]}}

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/apiDataConversionConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DESCRIPTION_LANGUAGE_INDEX = exports.DESCRIPTION_LANGUAGE_INDEX = 0;

var VIEW_1 = exports.VIEW_1 = {
    VEHICLE: {
        HIGH_PRICE: 'highPrice',
        HIGH_PRICE_INDEX: 0,
        URL_EXTERIOR_COLOUR: 7,
        EXTERIOR_COLOUR_STATUS: 9,

        REBATE: 'rebate',
        REBATE_INDEX: 0,
        REBATE_RETAIL: 6,

        HIGH_REBATE: 'highRebate',
        HIGH_REBATE_INDEX: 0,
        HIGH_REBATE_RETAIL: 6,
        HIGH_REBATE_PURCHASE_METHOD: 8,
        HIGH_REBATE_REBATES_TAXES: 9,

        PRICE: 'price',
        PRICE_INDEX: 0,
        PRICE_YEAR: 0,
        PRICE_MODEL_TRIM_CODE: 3,
        PRICE_CONFIGURATION_ID: 4,
        PRICE_RETAIL: 6,
        PRICE_AMOUNTS: 9,
        PRICE_DISCLAIMER: 10,

        LEASE: 'lease',
        LEASE_INDEX: 0,
        LEASE_YEAR: 0,
        LEASE_MODEL_TRIM_CODE: 3,
        LEASE_CONFIGURATION_ID: 4,
        LEASE_TERMS: 6,
        LEASE_DISCLAIMER: 18,

        FINANCE: 'finance',
        FINANCE_INDEX: 0,
        FINANCE_YEAR: 0,
        FINANCE_MODEL_TRIM_CODE: 3,
        FINANCE_CONFIGURATION_ID: 4,
        FINANCE_TERMS: 6,
        FINANCE_DISCLAIMER: 12
    },

    COLOUR_IMAGE: {
        PHOTO_1: 0,
        PHOTO_2: 1,
        PHOTO_3: 2
    },

    FINANCE: {
        PAYMENT_FREQUENCY: 0,
        BASE_PAYMENT: 1,
        FEES_PAYMENT: 2,
        DUTIES_PAYMENT: 3,
        PAYMENT_TAXES: 4,
        FINANCE_FACTOR: 5,
        BALLOON_FACTOR: 6
    },

    PRICE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1,
        MODEL_PRICE: 2,
        INCLUSIONS: 3,
        EXCLUSIONS: 4
    },

    FINANCE_DISCLAIMER: {
        MODEL_SHORT: 0,
        MODEL_LONG: 1
    },

    PRICING: {
        BASE_RETAIL: 0,
        FREIGHT_PDI: 1,
        TAXES_DUTIES: 2
    }
};

var VIEW_2_1 = exports.VIEW_2_1 = {
    VEHICLE: {
        MODEL_YEARS: 0,

        MODEL_YEAR: {
            BIT_FIELD: 0,
            YEAR: 1,
            FEATURES: 2,
            CABS: 3,
            DRIVES: 4,
            TRANSMISSIONS: 5,
            BOXES: 6,
            TRIMS: 7
        },

        FEATURES: {
            BIT_FIELD: 0,
            LIST: 1,

            FEATURE: {
                CODE: 0,
                TYPE: 1,
                KEY_ORDER: 2,
                IS_STANDARD: 3,
                DATA_TYPE_ID: 4,
                TYPE_ID: 5,
                DESCRIPTION: 6,
                TYPE_IDS: 7,
                TYPE_ICONS: 8,
                COLOUR_FEATURES: 9,

                ICON: {
                    KEY_ORDER: 0,
                    VALUE: 1,
                    CODE: 2,
                    DESCRIPTION: 3
                }
            }
        },

        CAB: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2
        },

        DRIVE: {
            BIT_FIELD: 0,
            ID_CODE: 2,
            DESCRIPTION: 1,
            CODE: 3,
            LONG_DESCRIPTION: 4
        },

        TRANSMISSION: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2
        },

        BOX: {
            BIT_FIELD: 0,
            ID_CODE: 1,
            CODE: 3,
            DESCRIPTION: 2
        },

        TRIM: {
            BIT_FIELD: 0,
            CODE: 1,
            DESCRIPTION: 2,
            CONFIGURATIONS: 3,
            EXTENSION_DESCRIPTION: 4,
            EXTENSION_CODE: 5,
            HAS_OPTIONS: 6,

            CONFIGURATION: {
                BIT_FIELD: 0,
                TRIM_CODE: 1,
                TRIM_RANK: 2,
                ID: 3,
                RANK: 4,
                DESCRIPTION: 5,
                SEATING: 6,
                FUEL_CONSUMPTION: 7,
                ENGINE: 8,
                TRANSMISSION: 9,
                PACKAGE_CODE: 10,
                PACKAGE: 11,
                OPTION_CODES: 12,
                URL_EXTERIOR_COLOUR: 13,
                URL_INTERIOR_TRIM: 14,
                PRICING: 15,
                FINANCE: 16,
                LEASE: 17,
                CAR_ID: 18,
                VEH_ID: 19
            },

            ENGINE: {
                FUEL: 0,
                CYLINDERS: 1,
                DISPLACEMENT: 2,
                IS_TURBO: 3,
                HP: 4,
                HP_RPM: 5,
                TORQUE: 6,
                TORQUE_RPM: 7
            },

            TRANSMISSION: {
                TYPE_CODE: 0,
                TYPE: 1,
                SPEEDS: 2,
                IS_CVT: 3,
                DESCRIPTION: 4
            },

            COLOUR_IMAGE: {
                CODE: 0,
                TILE: 1,
                PHOTO_1: 2,
                PHOTO_2: 3,
                PHOTO_3: 4,
                PRICING: 5,

                AMOUNTS: {
                    RETAIL: 0,
                    RESIDUAL_RETAIL: 1
                }
            },

            PRICING: {
                RETAIL: 0,
                REBATE: 1
            }
        },

        LEASE_TERMS: 0,

        FINANCE_TERMS: 0
    },

    FINANCE: {
        APR: 0,
        TERM: 1,
        DISCOUNT: 3,
        REBATE: 4,
        REBATE_AT_DELIVERY: 5,
        CASH_DOWN: 6,
        PAYMENT_FREQUENCIES: 7,

        PAYMENT_FREQUENCY: 0,
        PAYMENT: 1,
        PAYMENT_TAXES: 2,
        FINANCE_FACTOR: 3,
        BALLOON_FACTOR: 4
    },

    DATA_TYPES: {
        FEATURE: 1,
        TAX_AND_DUTY: 2,
        FEE: 3,
        PROTECTION: 4,
        REBATE: 5,
        FEATURE_TYPE_MECHANICAL: 1,
        FEATURE_TYPE_EXTERIOR: 2,
        FEATURE_TYPE_COMMUNICATION: 3,
        FEATURE_TYPE_INTERIOR: 4,
        FEATURE_TYPE_SAFETY: 5,
        FEATURE_TYPE_MODEL_TRIM: 50,
        FEATURE_TYPE_PACKAGE: 51,
        FEATURE_TYPE_ENGINE: 52,
        FEATURE_TYPE_TRANSMISSION: 53,
        FEATURE_TYPE_EXTERIOR_COLOUR: 54,
        FEATURE_TYPE_INTERIOR_TRIM: 55,
        TAX_AND_DUTY_TYPE_AIR: 1,
        TAX_AND_DUTY_TYPE_WEIGHT: 2,
        TAX_AND_DUTY_TYPE_BATTERY: 3,
        TAX_AND_DUTY_TYPE_TIRE: 4,
        TAX_AND_DUTY_TYPE_ENVIRONMENTAL: 5,
        TAX_AND_DUTY_TYPE_LICENCE: 6,
        TAX_AND_DUTY_TYPE_RECOVERY: 7,
        TAX_AND_DUTY_TYPE_LEVY: 8,
        FEE_TYPE_FREIGHT: 1,
        FEE_TYPE_PREPARATION: 2,
        FEE_TYPE_MARKETING: 3,
        FEE_TYPE_REGISTRATION: 4,
        FEE_TYPE_ADMINISTRATION_DEALER: 5,
        FEE_TYPE_DOCUMENT: 6,
        FEE_TYPE_ACQUISITION: 7,
        FEE_TYPE_ADMINISTRATION_CREDITOR: 8,
        FEE_TYPE_RECOVERY: 9,
        FEE_TYPE_RECYCLING: 10,
        FEE_TYPE_SECURITY_DEPOSIT: 11,
        FEE_TYPE_LEASE_BUY_BACK: 12
    },

    DEFAULT_ICON: 'E917'
};

exports.default = {
    DESCRIPTION_LANGUAGE_INDEX: DESCRIPTION_LANGUAGE_INDEX,
    VIEW_1: VIEW_1,
    VIEW_2_1: VIEW_2_1
};

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/currencyFormats.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CURRENCY_0 = exports.CURRENCY_0 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
};

var CURRENCY_2 = exports.CURRENCY_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

var CURRENCY_MIN_0_MAX_2 = exports.CURRENCY_MIN_0_MAX_2 = {
    style: 'currency',
    currency: 'CAD',
    currencyDisplay: 'symbol',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
};

var ODOMETER = exports.ODOMETER = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
};

var FUEL_CONSUMPTION = exports.FUEL_CONSUMPTION = {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
};

exports.default = {
    CURRENCY_0: CURRENCY_0,
    CURRENCY_2: CURRENCY_2,
    CURRENCY_MIN_0_MAX_2: CURRENCY_MIN_0_MAX_2,
    ODOMETER: ODOMETER,
    FUEL_CONSUMPTION: FUEL_CONSUMPTION
};

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/dataConversions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DEFAULT_KEY_ORDER = exports.DEFAULT_KEY_ORDER = 9999999;
var CASH_PURCHASE_ONLY_DISCOUNT = exports.CASH_PURCHASE_ONLY_DISCOUNT = '%';
var DRIVE_TRAIN_4WD = exports.DRIVE_TRAIN_4WD = '4WD';
var CAB_SIZE_REGULAR = exports.CAB_SIZE_REGULAR = 'RC';
var CAB_SIZE_EXTENDED = exports.CAB_SIZE_EXTENDED = 'XC';
var CAB_SIZE_CREW = exports.CAB_SIZE_CREW = 'CC';
var BOX_SIZE_SHORT = exports.BOX_SIZE_SHORT = 'SB';
var BOX_SIZE_LONG = exports.BOX_SIZE_LONG = 'LB';

var CAB_SIZE_DATA = exports.CAB_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3
};

var BOX_SIZE_DATA = exports.BOX_SIZE_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 1,
    DESCRIPTION: 2,
    CODE: 3
};

var DRIVE_TRAIN_DATA = exports.DRIVE_TRAIN_DATA = {
    BIT_FIELD: 0,
    ID_CODE: 2,
    DESCRIPTION: 1,
    CODE: 3,
    LONG_DESCRIPTION: 4
};

var ENGINE_DATA = exports.ENGINE_DATA = {
    FUEL: 0,
    CYLINDERS: 1,
    DISPLACEMENT: 2,
    IS_TURBO: 3,
    HP: 4,
    HP_RPM: 5,
    TORQUE: 6,
    TORQUE_RPM: 7
};

var TRANSMISSION_DATA = exports.TRANSMISSION_DATA = {
    TYPE_CODE: 0,
    TYPE: 1,
    SPEEDS: 2,
    IS_CVT: 3,
    DESCRIPTION: 4
};

var COLOUR_DATA = exports.COLOUR_DATA = {
    CODE: 0,
    TILE: 1,
    PHOTO_1: 2,
    PHOTO_2: 3,
    PHOTO_3: 4,
    PRICING: 5,

    AMOUNTS: {
        RETAIL: 0,
        RESIDUAL_RETAIL: 1
    },

    FEATURE_FABRIC: 0,
    FEATURE_INTERIOR: 1,
    FEATURE_SEAT: 2
};

var MODEL_CONFIGURATION = exports.MODEL_CONFIGURATION = {
    BIT_FIELD: 0,
    TRIM_CODE: 1,
    TRIM_RANK: 2,
    ID: 3,
    RANK: 4,
    DESCRIPTION: 5,
    SEATING: 6,
    FUEL_CONSUMPTION: 7,
    ENGINE: 8,
    TRANSMISSION: 9,
    PACKAGE_CODE: 10,
    PACKAGE: 11,
    OPTION_CODES: 12,
    URL_EXTERIOR_COLOUR: 13,
    URL_INTERIOR_TRIM: 14,
    PRICING: 15,
    FINANCE: 16,
    LEASE: 17,
    CAR_ID: 18,
    VEH_ID: 19,
    EXTERIOR_COLOUR_STATUS: 20,
    TAXES_FACTOR: 21,
    TAX_CODES: 22
};

exports.default = {
    DEFAULT_KEY_ORDER: DEFAULT_KEY_ORDER,
    CASH_PURCHASE_ONLY_DISCOUNT: CASH_PURCHASE_ONLY_DISCOUNT,
    DRIVE_TRAIN_4WD: DRIVE_TRAIN_4WD,
    CAB_SIZE_REGULAR: CAB_SIZE_REGULAR,
    CAB_SIZE_EXTENDED: CAB_SIZE_EXTENDED,
    CAB_SIZE_CREW: CAB_SIZE_CREW,
    CAB_SIZE_DATA: CAB_SIZE_DATA,
    BOX_SIZE_DATA: BOX_SIZE_DATA,
    BOX_SIZE_SHORT: BOX_SIZE_SHORT,
    BOX_SIZE_LONG: BOX_SIZE_LONG,
    DRIVE_TRAIN_DATA: DRIVE_TRAIN_DATA,
    ENGINE_DATA: ENGINE_DATA,
    TRANSMISSION_DATA: TRANSMISSION_DATA,
    COLOUR_DATA: COLOUR_DATA,
    MODEL_CONFIGURATION: MODEL_CONFIGURATION
};

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/dataOrigins.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MODELS_COLLECTION = exports.MODELS_COLLECTION = 'MODELS_COLLECTION';
var MODEL_YEARS = exports.MODEL_YEARS = 'MODEL_YEARS';
var MODEL_YEAR_POWERS_TRIMS = exports.MODEL_YEAR_POWERS_TRIMS = 'MODEL_YEAR_POWERS_TRIMS';
var PAYMENT_CALCULATOR = exports.PAYMENT_CALCULATOR = 'PAYMENT_CALCULATOR';
var VEHICLE_PAYMENTS = exports.VEHICLE_PAYMENTS = 'VEHICLE_PAYMENTS';
var OPTIONS_VALIDATION = exports.OPTIONS_VALIDATION = 'OPTIONS_VALIDATION';

exports.default = {
    MODELS_COLLECTION: MODELS_COLLECTION,
    MODEL_YEARS: MODEL_YEARS,
    MODEL_YEAR_POWERS_TRIMS: MODEL_YEAR_POWERS_TRIMS,
    PAYMENT_CALCULATOR: PAYMENT_CALCULATOR,
    VEHICLE_PAYMENTS: VEHICLE_PAYMENTS,
    OPTIONS_VALIDATION: OPTIONS_VALIDATION
};

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/dataTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SUPPLIER_OPTION = exports.SUPPLIER_OPTION = 'O';
var SUPPLIER_INCENTIVE = exports.SUPPLIER_INCENTIVE = 'I';
var DEALER_OPTION = exports.DEALER_OPTION = 'D';

var ITEM_FLAG = exports.ITEM_FLAG = {
    NOT_SELECTED: 0x0,
    SELECTED: 0x1,
    USER_SELECTED: 0x2,
    CONFIGURATION_SELECTED: 0x4,
    INCLUDED_IN_OTHER_ITEM: 0x8,
    AVAILABLE: 0x80,
    CONFIGURATION_AVAILABLE: 0x100,
    DYNAMIC_ITEM: 0x2000,
    IGNORE_ITEM: 0x4000,
    NON_TAXABLE_FEDERAL: 0x10000,
    NON_TAXABLE_PROVINCIAL: 0x20000
};

var ITEM_DATA_LEVEL = exports.ITEM_DATA_LEVEL = {
    AVAILABLE: 0x1,
    PRICING: 0x2,
    DESCRIPTIONS: 0x4,
    DEALER_ITEMS: 0x4000
};

var DATA_TYPES = exports.DATA_TYPES = {
    FEATURE: {
        DATA_TYPE_ID: 1,
        TYPES: {
            MECHANICAL: 1,
            EXTERIOR: 2,
            COMMUNICATION: 3,
            INTERIOR: 4,
            SAFETY: 5,
            MODEL_TRIM: 50,
            PACKAGE: 51,
            ENGINE: 52,
            TRANSMISSION: 53,
            EXTERIOR_COLOUR: 54,
            INTERIOR_TRIM: 55,
            DEALER_INVENTORY: 2
        }
    },
    TAX_AND_DUTY: {
        DATA_TYPE_ID: 2,
        TYPES: {
            AIR: 1,
            WEIGHT: 2,
            BATTERY: 3,
            TIRE: 4,
            ENVIRONMENTAL: 5,
            LICENCE: 6,
            RECOVERY: 7,
            LEVY: 8
        }
    },
    FEE: {
        DATA_TYPE_ID: 3,
        TYPES: {
            FREIGHT: 1,
            PREPARATION: 2,
            MARKETING: 3,
            REGISTRATION: 4,
            ADMINISTRATION_DEALER: 8,
            DOCUMENT: 6,
            ACQUISITION: 7,
            ADMINISTRATION_CREDITOR: 5,
            RECOVERY: 9,
            RECYCLING: 10,
            SECURITY_DEPOSIT: 11,
            LEASE_BUY_BACK: 12,
            DELIVERY: 13,
            CHECKOUT_DEPOSIT: 14,
            RESERVATION_DEPOSIT: 15
        }
    },
    PROTECTION: {
        DATA_TYPE_ID: 4,
        TYPES: {
            OEM_EXTENDED_WARRANTY: 1,
            EXTENDED_WARRANTY: 2,
            WARRANTY_PACKAGE: 11,
            PROTECTION_REPLACEMENT_WARRANTY: 21,
            PROTECTION_REPLACEMENT_INSURANCE: 22,
            PROTECTION_GAP: 41,
            ROAD_HAZARD_PACKAGE: 60,
            ROAD_HAZARD_PLAN: 61,
            APPEARANCE_PACKAGE: 100,
            APPEARANCE_INTERIOR: 101,
            APPEARANCE_PAINT: 102,
            APPEARANCE_RUST: 103,
            APPEARANCE_EXTERIOR: 104,
            THEFT_DETERRENT: 201,
            INSURANCE_LIFE: 301,
            INSURANCE_CRITICAL_ILLNESS: 302,
            INSURANCE_DISABILITY: 303,
            INSURANCE_LOSS_EMPLOYMENT: 304,
            INSURANCE_RESIDUAL: 305
        },
        CATEGORIES: {
            WARRANTY: 1,
            INSURANCE: 2,
            APPEARANCE: 3,
            THEFT_DETERRENT: 4,
            SAFETY: 5,
            PROTECTION: 6
        }
    },
    REBATE: {
        DATA_TYPE_ID: 5,
        TYPES: {
            DEALER_DISCOUNT: 1,
            DAA_CASH_DOWN: 4,
            EMPLOYEE: 5,
            ELECTRIC: 7,
            MSRP_PERCENTAGE: 9,
            BONUS: 10
        }
    }
};

var DEFAULT_MODEL_TRIM_CODE = exports.DEFAULT_MODEL_TRIM_CODE = '_MT';
var DEFAULT_KEY_ORDER = exports.DEFAULT_KEY_ORDER = 9999999;
var SYSTEM_PACKAGE_CODE = exports.SYSTEM_PACKAGE_CODE = '_P_';

exports.default = {
    SUPPLIER_OPTION: SUPPLIER_OPTION,
    SUPPLIER_INCENTIVE: SUPPLIER_INCENTIVE,
    DEALER_OPTION: DEALER_OPTION,
    ITEM_FLAG: ITEM_FLAG,
    ITEM_DATA_LEVEL: ITEM_DATA_LEVEL,
    DATA_TYPES: DATA_TYPES,
    DEFAULT_MODEL_TRIM_CODE: DEFAULT_MODEL_TRIM_CODE,
    DEFAULT_KEY_ORDER: DEFAULT_KEY_ORDER,
    SYSTEM_PACKAGE_CODE: SYSTEM_PACKAGE_CODE
};

/***/ }),

/***/ "../widget-commons-vehicle/src/constants/vehicle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VEHICLE = {
    CONDITIONS: {
        NEW: 0x1,
        DEMO: 0x3,
        USED: 0x100,
        CERTIFIED: 0x300
    }
};

exports.default = VEHICLE;

/***/ }),

/***/ "../widget-commons-vehicle/src/services/ShowroomService/ShowroomAPIService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShowroomAPIService = function () {
    function ShowroomAPIService() {
        _classCallCheck(this, ShowroomAPIService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(ShowroomAPIService, [{
        key: 'getPublicToken',
        value: function getPublicToken() {
            return _axios2.default.get(this.basePath + '/jwt?userName=public&password=public');
        }
    }, {
        key: 'saveQuote',
        value: function saveQuote(quote, token, quoteContext) {
            if (!quote || !token) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }

            var orgId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var orgUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation().toLowerCase();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();

            var context = 'refresh=1&location=' + location + '&datalevel=1&context=' + orgId + '.' + orgUnitId + '&language=' + locale;

            if (quote.securityToken) {
                context += '&securityToken=' + quote.securityToken;
            }

            if (quoteContext) {
                context += '&' + quoteContext;
            }

            return _axios2.default.put(this.basePath + '/Quote?' + context, quote, { headers: { 'x-jwt': token } }).then(function (result) {
                return Promise.resolve(result.data);
            });
        }
    }]);

    return ShowroomAPIService;
}();

exports.default = new ShowroomAPIService();

/***/ }),

/***/ "../widget-commons-vehicle/src/services/ShowroomService/ShowroomService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _immutable = __webpack_require__("immutable");

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("../widget-commons-vehicle/src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _modelTrimItemCategories = __webpack_require__("../widget-commons-vehicle/src/Quote/constants/modelTrimItemCategories.js");

var _vehicle = __webpack_require__("../widget-commons-vehicle/src/constants/vehicle.js");

var _vehicle2 = _interopRequireDefault(_vehicle);

var _dataTypes = __webpack_require__("../widget-commons-vehicle/src/constants/dataTypes.js");

var dataTypes = _interopRequireWildcard(_dataTypes);

var _dataOrigins = __webpack_require__("../widget-commons-vehicle/src/constants/dataOrigins.js");

var DataOrigins = _interopRequireWildcard(_dataOrigins);

var _ModelYearService = __webpack_require__("../widget-commons-vehicle/src/ModelYear/services/ModelYearService/ModelYearService.js");

var _QuoteService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteService/QuoteService.js");

var _QuoteItemCategoryService = __webpack_require__("../widget-commons-vehicle/src/Quote/services/QuoteItemCategoryService/QuoteItemCategoryService.js");

var _QuoteModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteModel.js");

var _QuoteModel2 = _interopRequireDefault(_QuoteModel);

var _QuoteItemCategoryModel = __webpack_require__("../widget-commons-vehicle/src/Quote/models/QuoteItemCategoryModel.js");

var _QuoteItemCategoryModel2 = _interopRequireDefault(_QuoteItemCategoryModel);

var _PurchaseMethodsService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsService/PurchaseMethodsService.js");

var _VehicleService = __webpack_require__("../widget-commons-vehicle/src/Vehicle/services/VehicleService/VehicleService.js");

var _ModelYearModel = __webpack_require__("../widget-commons-vehicle/src/ModelYear/models/ModelYearModel.js");

var _ModelYearModel2 = _interopRequireDefault(_ModelYearModel);

var _PurchaseMethodsModel = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/models/PurchaseMethodsModel.js");

var _PurchaseMethodsModel2 = _interopRequireDefault(_PurchaseMethodsModel);

var _ShowroomAPIService = __webpack_require__("../widget-commons-vehicle/src/services/ShowroomService/ShowroomAPIService.js");

var _ShowroomAPIService2 = _interopRequireDefault(_ShowroomAPIService);

var _DisclaimerAPIService = __webpack_require__("../widget-commons-vehicle/src/PurchaseMethods/services/PurchaseMethodsAPIService/DisclaimerAPIService.js");

var _DisclaimerAPIService2 = _interopRequireDefault(_DisclaimerAPIService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Util to uppercase the given value and encode the result to be URI compliant
 * @param {String} value String to modify
 * @returns {String} value or empty string if given param is not a string
 */
function upperEncodedString(value) {
    if ((0, _lodash.isString)(value)) {
        return (0, _lodash.toUpper)(encodeURIComponent(value));
    }
    return '';
}

function resetPurchaseMethodsDiscount(purchaseMethods, sellingPrice, discount) {
    var newCashPurchase = purchaseMethods.cashPurchase;
    newCashPurchase = newCashPurchase.set('retail', sellingPrice + discount).set('discounts', discount);

    var newFinanceTerms = (0, _lodash.map)(purchaseMethods.finance.terms, function (term) {
        return term.set('discounts', discount);
    });
    var newFinance = purchaseMethods.finance.set('terms', newFinanceTerms);

    var newLeaseTerms = (0, _lodash.map)(purchaseMethods.lease.terms, function (term) {
        return term.set('discounts', discount);
    });
    var newLease = purchaseMethods.lease.set('terms', newLeaseTerms);

    return purchaseMethods.set('cashPurchase', newCashPurchase).set('finance', newFinance).set('lease', newLease);
}

// TODO: #complete - documentation & tests

var ShowroomService = function () {
    function ShowroomService() {
        _classCallCheck(this, ShowroomService);

        this.basePath = _index2.default.endpoint.showroom + '/service/v1';
    }

    _createClass(ShowroomService, [{
        key: 'getModelYear',
        value: function getModelYear(callType, year, make, model, bodyStyleCode, modelTrimCode, locale) {
            var _this = this;

            var urlMakeModelSection = 'make=' + upperEncodedString(make) + '&model=' + upperEncodedString(model) + ('&bodyStyleCode=' + upperEncodedString(bodyStyleCode));

            var modelString = callType === DataOrigins.MODEL_YEARS ? urlMakeModelSection + '&subGrouping=year&datalevel=768' : 'year=' + year + '&' + urlMakeModelSection + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return new Promise(function (resolve) {
                switch (callType) {
                    case DataOrigins.MODELS_COLLECTION:
                        _axios2.default.get(_this.basePath + '/view/1?' + context).then(function (result) {
                            var vehicles = (0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale);
                            resolve(vehicles[0].purchaseMethods);
                        });
                        break;

                    case DataOrigins.MODEL_YEARS:
                        _axios2.default.get(_this.basePath + '/view/1.1?' + context).then(function (result) {
                            resolve((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale));
                        });
                        break;

                    case DataOrigins.MODEL_YEAR_POWERS_TRIMS:
                        _axios2.default.get(_this.basePath + '/view/2.1?unfiltered=true&' + context).then(function (result) {
                            resolve((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale));
                        });
                        break;

                    default:
                        resolve({
                            modelYear: new _ModelYearModel2.default(),
                            purchaseMethods: new _PurchaseMethodsModel2.default()
                        });
                }
            });
        }
    }, {
        key: 'getModels',
        value: function getModels(callType, makes, locale) {
            var _this2 = this;

            var makesQuery = (0, _lodash.join)(makes, '|');
            var modelString = 'make=' + makesQuery + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                switch (callType) {
                    case DataOrigins.MODELS_COLLECTION:
                        return _axios2.default.get(_this2.basePath + '/view/1?' + context).then(function (result) {
                            return (0, _immutable.fromJS)((0, _ModelYearService.resetModelYearFromOriginData)(callType, result.data.view, locale, disclaimers));
                        });

                    default:
                        return Promise.resolve((0, _immutable.List)([]));
                }
            });
        }
    }, {
        key: 'validateSelectedOptions',
        value: function validateSelectedOptions(callType, year, make, configuration, locale, optionSelectionCode, selectionResolutions) {
            var _this3 = this;

            var organizationUnitLocation = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var parameters = 'location=' + organizationUnitLocation + ('&language=' + locale) + '&includeNonManufacturerItems=true&datalevel=65535&userName=public&password=public' + ('&context=' + organizationId + '.' + organizationUnitId);

            var selectedItems = configuration.getValidationSelectedOptions();
            if (selectionResolutions) {
                selectedItems = selectionResolutions.getResolutionActionOptions(selectedItems);
            }

            return new Promise(function (resolve, reject) {
                switch (callType) {
                    case DataOrigins.OPTIONS_VALIDATION:
                        _axios2.default.post(_this3.basePath + '/builder?' + parameters, {
                            year: year,
                            make: make,
                            modelTrimCode: configuration.get('modelTrimCode'),
                            configurationID: configuration.get('id'),
                            purchaseMethod: configuration.get('purchaseMethods').getSelectedPurchaseMethodValue(),
                            term: configuration.get('purchaseMethods').getSelectedFinanceTermValue(),
                            items: selectedItems
                        }).then(function (result) {
                            if (result.data.resolutions) {
                                reject({
                                    optionSelectionCode: optionSelectionCode,
                                    errors: result.data.errors,
                                    resolutions: result.data.resolutions
                                });
                            }
                            resolve(result.data);
                        });
                        break;

                    default:
                        resolve([]);
                }
            });
        }
    }, {
        key: 'getVehicleId',
        value: function getVehicleId(vehicle) {
            var vehicleConditionType = vehicle.vehicleConditionType,
                year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                bodyStyleCode = vehicle.bodyStyleCode,
                driveTrainCode = vehicle.driveTrainCode,
                odometer = vehicle.odometer,
                sellingPrice = vehicle.sellingPrice;


            return vehicleConditionType + '|' + year + '|' + make + '|' + model + '|' + (bodyStyleCode + '|' + driveTrainCode + '|' + ((0, _lodash.isNull)(odometer) ? 0 : odometer) + '|' + sellingPrice);
        }
    }, {
        key: 'getVehiclePayments',
        value: function getVehiclePayments(vehicle, oldPurchaseMethods) {
            var _this4 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + _widgetCommonsCoreServices.LocaleService.getLocale()) + ('&context=' + organizationId + '.' + organizationUnitId) + '&datalevel=65535&userName=public&password=public';

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                bodyStyleCode = vehicle.bodyStyleCode,
                driveTrainCode = vehicle.driveTrainCode,
                odometer = vehicle.odometer,
                vehicleConditionType = vehicle.vehicleConditionType,
                sellingPrice = vehicle.sellingPrice,
                discount = vehicle.discount;


            var isUsed = vehicleConditionType === _vehicle2.default.CONDITIONS.USED || vehicleConditionType === _vehicle2.default.CONDITIONS.CERTIFIED;
            var paymentParameters = {
                year: year,
                make: make,
                model: model,
                bodyStyleCode: bodyStyleCode,
                driveTrainCode: driveTrainCode,
                odometer: odometer,
                vehicleCondition: vehicleConditionType,
                amounts: isUsed ? { retail: sellingPrice } : null
            };

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _axios2.default.post(_this4.basePath + '/vehiclePayments?' + context, paymentParameters).then(function (result) {
                    var purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, result.data, oldPurchaseMethods, disclaimers);
                    if (isUsed) {
                        purchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsOptionsFromQuoteItems)(purchaseMethods, [vehicle.getDefaultVehicleQuoteItem()]);
                        if (discount) {
                            purchaseMethods = resetPurchaseMethodsDiscount(purchaseMethods, sellingPrice, discount);
                        }
                    }
                    var vehicleWithPurchaseMethods = (0, _VehicleService.setVehiclePurchaseMethods)(vehicle, purchaseMethods);

                    return _DisclaimerAPIService2.default.getVehiclesDisclaimers([vehicleWithPurchaseMethods]).then(function (vehiclesWithDisclaimers) {
                        return Promise.resolve(vehiclesWithDisclaimers[0]);
                    });
                });
            });
        }
    }, {
        key: 'getVehiclesPayments',
        value: function getVehiclesPayments(vehicles, purchaseMethod, termMinimum, termMaximum) {
            var _this5 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = 'language=' + language + '&location=' + location + '&context=' + organizationId + '.' + organizationUnitId + '&userName=public&password=public';

            var paymentParameters = {
                termMinimum: termMinimum,
                termMaximum: termMaximum,
                purchaseMethod: purchaseMethod,
                vehicles: vehicles.map(function (vehicle) {
                    return vehicle.getPaymentCalculatorVehicleParameters();
                })
            };

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _axios2.default.post(_this5.basePath + '/sm360core.paymentCalculator?' + context, paymentParameters).then(function (result) {
                    var newVehicles = [];
                    (0, _lodash.forEach)(vehicles, function (vehicle) {
                        var matchVehicle = (0, _lodash.find)(result.data.vehicles, function (resultVehicle) {
                            return _this5.getVehicleId(resultVehicle) === _this5.getVehicleId(vehicle);
                        });

                        if (matchVehicle) {
                            result.data.vehicle = matchVehicle;
                            var newPurchaseMethods = (0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.PAYMENT_CALCULATOR, result.data);
                            newPurchaseMethods = newPurchaseMethods.set('disclaimers', disclaimers);

                            if (!vehicle.getIsVehicleNew() && vehicle.discount) {
                                newPurchaseMethods = resetPurchaseMethodsDiscount(newPurchaseMethods, vehicle.sellingPrice, vehicle.discount);
                            }
                            var newVehicle = (0, _VehicleService.setVehiclePurchaseMethods)(vehicle, newPurchaseMethods);
                            newVehicles.push(newVehicle);
                        } else {
                            newVehicles.push(vehicle);
                        }
                    });

                    return _DisclaimerAPIService2.default.getVehiclesDisclaimers(newVehicles);
                });
            });
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote(quoteId) {
            var _this6 = this;

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                return _ShowroomAPIService2.default.getPublicToken().then(function (response) {
                    var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
                    var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
                    var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
                    var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
                    var language = _widgetCommonsCoreServices.LocaleService.getLocale();
                    var context = 'datalevel=7&source=4&dataTypes=3&context=' + organizationId + '.' + organizationUnitId + ('&location=' + location + '&language=' + language);

                    return _axios2.default.get(_this6.basePath + '/Quote/' + quoteId + '?' + context, {
                        headers: {
                            'x-jwt': userCookie || response.data
                        }
                    }).then(function (result) {
                        var quote = (0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), result.data, disclaimers);

                        return Promise.resolve(quote);
                    });
                });
            });
        }

        // SHOWROOM V2.5

    }, {
        key: 'loadQuoteV25',
        value: function loadQuoteV25(quoteId) {
            var _this7 = this;

            return _DisclaimerAPIService2.default.getGenericDisclaimers().then(function (disclaimers) {
                var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
                var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
                var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
                var language = _widgetCommonsCoreServices.LocaleService.getLocale();
                var context = 'datalevel=7&source=4&dataTypes=3&context=' + organizationId + '.' + organizationUnitId + ('&location=' + location + '&language=' + language + '&userName=public&password=public');
                return _axios2.default.get(_this7.basePath + '/Quote/' + quoteId + '?' + context, {}).then(function (result) {
                    var data = result.data;

                    data.accountId = '';
                    data.id = '';
                    var quote = (0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), data, disclaimers);

                    return Promise.resolve(quote);
                });
            });
        }
    }, {
        key: 'loadQuotes',
        value: function loadQuotes() {
            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return this.searchQuotes(token);
        }
    }, {
        key: 'loadQuotesByLeadId',
        value: function loadQuotesByLeadId(leadId) {
            if (!(0, _lodash.isNumber)(leadId)) {
                throw TypeError('param [leadId] must be a number');
            }
            var token = _widgetCommonsCoreServices.ConfigsService.getDeskingToken();
            return this.searchQuotes(token, { leadId: leadId });
        }
    }, {
        key: 'searchQuotes',
        value: function searchQuotes(token, searchParams) {
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var language = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = (location ? 'location=' + location + '&' : '') + 'language=' + language + '&context=' + organizationId + '.' + organizationUnitId;

            var searchParamsString = '';
            if (searchParams) {
                searchParamsString = Object.entries(searchParams).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        key = _ref2[0],
                        val = _ref2[1];

                    return key + '=' + val;
                }).join('&');
            }

            var url = this.basePath + '/Quotes?' + context + '&offset=0&limit=10&quoteDetail=true&datalevel=3' + ('' + (searchParamsString ? '&' + searchParamsString : ''));

            return _axios2.default.get(url, {
                headers: {
                    'x-jwt': token
                }
            }).then(function (result) {
                var quotes = [];
                if ((0, _lodash.isEmpty)(result.data)) {
                    return Promise.resolve(quotes);
                }

                (0, _lodash.forEach)(result.data, function (showroomQuote) {
                    quotes.push((0, _QuoteService.resetQuoteFromShowroomLoad)(new _QuoteModel2.default(), showroomQuote));
                });
                return Promise.resolve(quotes);
            });
        }
    }, {
        key: 'saveQuote',
        value: function saveQuote(quote, validateOnly) {
            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return this.saveQuoteToPublic(quote, validateOnly);
            }

            return this.saveQuoteToUser(quote, validateOnly);
        }
    }, {
        key: 'saveQuoteToUser',
        value: function saveQuoteToUser(quote) {
            var validateOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var quoteContext = validateOnly && 'validateOnly=1';
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);

            return _ShowroomAPIService2.default.saveQuote(quote, userCookie, quoteContext);
        }
    }, {
        key: 'saveQuoteToPublic',
        value: function saveQuoteToPublic(quote) {
            var validateOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var quoteContext = validateOnly ? 'validateOnly=1' : !quote.securityToken && 'createWriteToken=true';

            return _ShowroomAPIService2.default.getPublicToken().then(function (response) {
                return _ShowroomAPIService2.default.saveQuote(quote, response.data, quoteContext);
            });
        }
    }, {
        key: 'deleteQuote',
        value: function deleteQuote(quote) {
            if (!quote) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            }
            return this.saveQuote(quote, false);
        }
    }, {
        key: 'getIdentificationTypes',
        value: function getIdentificationTypes() {
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            return _axios2.default.get(this.basePath + '/IdentificationTypes?language=' + locale + '&userName=public&password=public').then(function (result) {
                return Promise.resolve(result.data);
            });
        }
    }, {
        key: 'loadQuoteProtections',
        value: function loadQuoteProtections(quoteId) {
            var _this8 = this;

            var token = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            var source = _modelTrimItemCategories.ITEM_SOURCE.DEALER + '|' + _modelTrimItemCategories.ITEM_SOURCE.SUPPLIER;
            var context = 'source=' + source + '&context=' + organizationId + '.' + organizationUnitId + '&language=' + locale;

            return this.getIdentificationTypes().then(function (identificationTypes) {
                var protectionCategories = [];
                if ((0, _lodash.isEmpty)(identificationTypes) || (0, _lodash.isEmpty)(identificationTypes.identificationDataTypes)) {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('no protections categories'));
                }
                var protectionDataType = (0, _lodash.find)(identificationTypes.identificationDataTypes, function (resultDataType) {
                    return resultDataType.dataType === dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID;
                });
                if (!protectionDataType) {
                    return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('no protections categories'));
                }

                protectionCategories = (0, _lodash.orderBy)((0, _lodash.map)(protectionDataType.categories, function (category) {
                    return (0, _QuoteItemCategoryService.resetQuoteItemCategoryFromCategory)(new _QuoteItemCategoryModel2.default(), dataTypes.DATA_TYPES.PROTECTION.DATA_TYPE_ID, category);
                }), ['order']);

                return _axios2.default.get(_this8.basePath + '/QuoteItems/' + quoteId + '?' + context, {
                    headers: {
                        'x-jwt': token
                    }
                }).then(function (result) {
                    if ((0, _lodash.isEmpty)(result.data)) {
                        return Promise.resolve([]);
                    }
                    return Promise.resolve((0, _QuoteItemCategoryService.resetQuoteItemCategoriesFromQuoteProtections)(protectionCategories, result.data));
                });
            });
        }
    }, {
        key: 'loadModelTrimOptions',
        value: function loadModelTrimOptions(year, make, configuration) {
            var ITEM_DATA_LEVEL = dataTypes.ITEM_DATA_LEVEL;

            var datalevel = ITEM_DATA_LEVEL.AVAILABLE | ITEM_DATA_LEVEL.PRICING | ITEM_DATA_LEVEL.DESCRIPTIONS | ITEM_DATA_LEVEL.DEALER_ITEMS;
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var locale = _widgetCommonsCoreServices.LocaleService.getLocale();
            var context = 'datalevel=' + datalevel + '&context=' + organizationId + '.' + organizationUnitId + '&location=' + location + '&language=' + locale + '&userName=public&password=public';

            return _axios2.default.post(this.basePath + '/modelTrimItems?' + context, {
                year: year,
                make: make,
                modelTrimCode: configuration.modelTrimCode,
                configurationID: configuration.id
            }).then(function (result) {
                return Promise.resolve(result.data.items);
            });
        }
    }, {
        key: 'getQuoteVehiclePayments',
        value: function getQuoteVehiclePayments(vehicle, locale) {
            var _this9 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + '&datalevel=65535&userName=public&password=public';

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                modelTrimCode = vehicle.modelTrimCode,
                configurationID = vehicle.configurationID,
                vehicleCondition = vehicle.vehicleCondition,
                retail = vehicle.retail;


            var isUsed = vehicleCondition === _vehicle2.default.CONDITIONS.USED || vehicleCondition === _vehicle2.default.CONDITIONS.CERTIFIED;
            var paymentParameters = {
                year: year,
                make: make,
                model: model,
                modelTrimCode: modelTrimCode,
                configurationID: configurationID,
                vehicleCondition: vehicleCondition,
                amounts: isUsed ? { retail: retail } : null
            };

            return new Promise(function (resolve) {
                _axios2.default.post(_this9.basePath + '/vehiclePayments?' + context, paymentParameters).then(function (result) {
                    resolve((0, _PurchaseMethodsService.resetPurchaseMethodsFromOriginData)(DataOrigins.VEHICLE_PAYMENTS, result.data));
                });
            });
        }
    }, {
        key: 'getQuoteVehicleModelYear',
        value: function getQuoteVehicleModelYear(vehicle, locale) {
            var _this10 = this;

            var year = vehicle.year,
                make = vehicle.make,
                model = vehicle.model,
                modelTrimCode = vehicle.modelTrimCode,
                configurationID = vehicle.configurationID;


            var modelString = 'year=' + year + '&make=' + make + '&model=' + model + '&modelTrimCode=' + modelTrimCode + '&datalevel=256';

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var context = 'location=' + location + ('&language=' + locale) + ('&context=' + organizationId + '.' + organizationUnitId) + ('&' + modelString) + '&compact=false&userName=public&password=public';

            return new Promise(function (resolve) {
                _axios2.default.get(_this10.basePath + '/view/2.1?' + context).then(function (result) {
                    var modelYear = (0, _ModelYearService.resetModelYearFromOriginData)(DataOrigins.MODEL_YEAR_POWERS_TRIMS, result.data.view, locale);
                    modelYear = (0, _ModelYearService.setSelectedOptionsPackage)(modelYear.modelYear, modelYear.modelYear.getOptionsPackageFromConfigurationId(configurationID), true);
                    resolve(modelYear.getVehicleFromConfiguration());
                });
            });
        }
    }, {
        key: 'saveCreditApplication',
        value: function saveCreditApplication(creditApplication) {
            var _this11 = this;

            if (!creditApplication) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('not connected'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return new Promise(function (resolve) {
                return _axios2.default.put(_this11.basePath + '/CreditApplication?' + context, creditApplication, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'loadCreditApplication',
        value: function loadCreditApplication(creditApplicationId) {
            var _this12 = this;

            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var creditApplicationIdParam = creditApplicationId ? '/' + creditApplicationId : '';

            return new Promise(function (resolve) {
                return _axios2.default.get(_this12.basePath + '/CreditApplication' + creditApplicationIdParam + '?' + context, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'saveTradeInVehicle',
        value: function saveTradeInVehicle(tradeIn) {
            var _this13 = this;

            if (!tradeIn) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('missing parameters'));
            } else if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            return new Promise(function (resolve) {
                return _axios2.default.put(_this13.basePath + '/TradeInVehicle?' + context + '&updateQuotes=true', tradeIn, {
                    headers: { 'x-jwt': userCookie }
                }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }, {
        key: 'loadTradeInVehicle',
        value: function loadTradeInVehicle(tradeInVehicleId) {
            var _this14 = this;

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return Promise.reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('user not authenticated'));
            }
            var organizationId = _widgetCommonsCoreServices.ConfigsService.getOrganizationId();
            var organizationUnitId = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitId();
            var context = 'context=' + organizationId + '.' + organizationUnitId;
            var language = 'locale=' + _widgetCommonsCoreServices.LocaleService.getLocale();
            var location = 'location=' + _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
            var userCookie = _widgetCommonsGeneral.CookieService.getToken(_widgetCommonsGeneral.COOKIES.ACCOUNT.AUTHENTICATE_TOKEN);
            var tradeInVehicleIdParam = tradeInVehicleId ? '/' + tradeInVehicleId : '';

            return new Promise(function (resolve) {
                return _axios2.default.get(_this14.basePath + '/TradeInVehicle' + tradeInVehicleIdParam + '?' + [context, language, location].join('&'), { headers: { 'x-jwt': userCookie } }).then(function (result) {
                    resolve(result.data);
                });
            });
        }
    }]);

    return ShowroomService;
}();

exports.default = new ShowroomService();

/***/ }),

/***/ "./src/InstantEstimateProvider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _InstantEstimate = __webpack_require__("./src/components/InstantEstimate/InstantEstimate.jsx");

var _InstantEstimate2 = _interopRequireDefault(_InstantEstimate);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstantEstimateProvider = function (_Component) {
    _inherits(InstantEstimateProvider, _Component);

    function InstantEstimateProvider(props) {
        _classCallCheck(this, InstantEstimateProvider);

        var _this = _possibleConstructorReturn(this, (InstantEstimateProvider.__proto__ || Object.getPrototypeOf(InstantEstimateProvider)).call(this, props));

        (0, _lodash.merge)(_en2.default, _widgetCommonsForms.Translations.en, _widgetCommonsGeneral.Translations.en);
        (0, _lodash.merge)(_fr2.default, _widgetCommonsForms.Translations.fr, _widgetCommonsGeneral.Translations.fr);

        _widgetCommonsCoreServices.LocaleService.setLocale(props.locale);
        _widgetCommonsCoreServices.LocaleService.loadTranslations({ en: _en2.default, fr: _fr2.default });

        _widgetCommonsCoreServices.ConfigsService.setLocation(props.location);
        _widgetCommonsCoreServices.ConfigsService.setWebsiteId(props.websiteId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationId(_this.props.organizationId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitId(_this.props.organizationUnitId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitLocation(_this.props.organizationUnitLocation);
        _widgetCommonsCoreServices.ContentZonesService.setImageServerBaseUrl(_index2.default.source.image);
        _widgetCommonsCoreServices.ContentZonesService.addContentZones(_this.props.contentZones);
        return _this;
    }

    _createClass(InstantEstimateProvider, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_InstantEstimate2.default, {
                parentElementId: this.props.location,
                isShowroomV2Enabled: this.props.isShowroomV2Enabled
            });
        }
    }]);

    return InstantEstimateProvider;
}(_react.Component);

InstantEstimateProvider.displayName = 'InstantEstimateProvider';

InstantEstimateProvider.propTypes = {
    locale: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.string.isRequired,
    websiteId: _propTypes2.default.number.isRequired,
    organizationUnitId: _propTypes2.default.number.isRequired,
    organizationId: _propTypes2.default.number.isRequired,
    organizationUnitLocation: _propTypes2.default.string.isRequired,
    contentZones: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        active: _propTypes2.default.bool,
        group: _propTypes2.default.string,
        id: _propTypes2.default.number,
        location: _propTypes2.default.string,
        position: _propTypes2.default.number,
        type: _propTypes2.default.string,
        value: _propTypes2.default.string
    }))).isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired
};

exports.default = InstantEstimateProvider;

/***/ }),

/***/ "./src/OfficialTradeInProvider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _OfficialTradeIn = __webpack_require__("./src/components/OfficialTradeIn/OfficialTradeIn.jsx");

var _OfficialTradeIn2 = _interopRequireDefault(_OfficialTradeIn);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfficialTradeInProvider = function (_Component) {
    _inherits(OfficialTradeInProvider, _Component);

    function OfficialTradeInProvider(props) {
        _classCallCheck(this, OfficialTradeInProvider);

        var _this = _possibleConstructorReturn(this, (OfficialTradeInProvider.__proto__ || Object.getPrototypeOf(OfficialTradeInProvider)).call(this, props));

        (0, _lodash.merge)(_en2.default, _widgetCommonsForms.Translations.en, _widgetCommonsGeneral.Translations.en);
        (0, _lodash.merge)(_fr2.default, _widgetCommonsForms.Translations.fr, _widgetCommonsGeneral.Translations.fr);

        _widgetCommonsCoreServices.LocaleService.setLocale(props.locale);
        _widgetCommonsCoreServices.LocaleService.loadTranslations({ en: _en2.default, fr: _fr2.default });

        _widgetCommonsCoreServices.ConfigsService.setLocation(props.location);
        _widgetCommonsCoreServices.ConfigsService.setWebsiteId(props.websiteId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationId(_this.props.organizationId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitId(_this.props.organizationUnitId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitLocation(_this.props.organizationUnitLocation);
        _widgetCommonsCoreServices.ContentZonesService.setImageServerBaseUrl(_index2.default.source.image);
        _widgetCommonsCoreServices.ContentZonesService.addContentZones(_this.props.contentZones);
        return _this;
    }

    _createClass(OfficialTradeInProvider, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_OfficialTradeIn2.default, null);
        }
    }]);

    return OfficialTradeInProvider;
}(_react.Component);

OfficialTradeInProvider.displayName = 'OfficialTradeInProvider';

OfficialTradeInProvider.propTypes = {
    locale: _propTypes2.default.string.isRequired,
    location: _propTypes2.default.string.isRequired,
    websiteId: _propTypes2.default.number.isRequired,
    organizationUnitId: _propTypes2.default.number.isRequired,
    organizationId: _propTypes2.default.number.isRequired,
    organizationUnitLocation: _propTypes2.default.string.isRequired,
    contentZones: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        active: _propTypes2.default.bool,
        group: _propTypes2.default.string,
        id: _propTypes2.default.number,
        location: _propTypes2.default.string,
        position: _propTypes2.default.number,
        type: _propTypes2.default.string,
        value: _propTypes2.default.string
    }))).isRequired
};

exports.default = OfficialTradeInProvider;

/***/ }),

/***/ "./src/TradeInProvider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _TradeInWrapper = __webpack_require__("./src/components/TradeInWrapper/TradeInWrapper.jsx");

var _TradeInWrapper2 = _interopRequireDefault(_TradeInWrapper);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var czGroup = 'widget.tradein';

var TradeInProvider = function (_Component) {
    _inherits(TradeInProvider, _Component);

    function TradeInProvider(props) {
        _classCallCheck(this, TradeInProvider);

        var _this = _possibleConstructorReturn(this, (TradeInProvider.__proto__ || Object.getPrototypeOf(TradeInProvider)).call(this, props));

        (0, _lodash.merge)(_en2.default, _widgetCommonsForms.Translations.en, _widgetCommonsGeneral.Translations.en);
        (0, _lodash.merge)(_fr2.default, _widgetCommonsForms.Translations.fr, _widgetCommonsGeneral.Translations.fr);

        _widgetCommonsCoreServices.LocaleService.setLocale(props.locale);
        _widgetCommonsCoreServices.LocaleService.loadTranslations({ en: _en2.default, fr: _fr2.default });

        _widgetCommonsCoreServices.ConfigsService.setWebsiteId(props.websiteId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationId(_this.props.organizationId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitId(_this.props.organizationUnitId);
        _widgetCommonsCoreServices.ConfigsService.setOrganizationUnitLocation(_this.props.organizationUnitLocation);

        _this.onUnload = _this.onUnload.bind(_this);

        _widgetCommonsCoreServices.ContentZonesService.setImageServerBaseUrl(_index2.default.source.image);
        _widgetCommonsCoreServices.ContentZonesService.addContentZones(_this.props.contentZones);
        return _this;
    }

    _createClass(TradeInProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.addEventListener('beforeunload', this.onUnload);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.onUnload();
        }
    }, {
        key: 'onUnload',
        value: function onUnload() {
            _widgetCommonsGeneral.HistoryService.add(_widgetCommonsCoreServices.WindowProxy.location().href);
        }
    }, {
        key: 'render',
        value: function render() {
            var cz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'hascbb');
            var hasCBB = cz ? cz.getValue() === 'true' : false;
            var isOfficialTradeIn = hasCBB ? ['official', 'officiel'].includes(_widgetCommonsCoreServices.UrlService.getUrlParameter('view')) : true;

            return _react2.default.createElement(_TradeInWrapper2.default, {
                useCBB: hasCBB,
                isOfficialTradeIn: isOfficialTradeIn,
                isRenderedInModal: false,
                onTradeInSuccess: this.props.onTradeInSuccess
            });
        }
    }]);

    return TradeInProvider;
}(_react.Component);

TradeInProvider.displayName = 'TradeInProvider';

TradeInProvider.defaultProps = {
    onTradeInSuccess: _lodash.noop
};

TradeInProvider.propTypes = {
    locale: _propTypes2.default.string.isRequired,
    websiteId: _propTypes2.default.number.isRequired,
    organizationUnitId: _propTypes2.default.number.isRequired,
    organizationId: _propTypes2.default.number.isRequired,
    organizationUnitLocation: _propTypes2.default.string.isRequired,
    onTradeInSuccess: _propTypes2.default.func,
    contentZones: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
        active: _propTypes2.default.bool,
        group: _propTypes2.default.string,
        id: _propTypes2.default.number,
        location: _propTypes2.default.string,
        position: _propTypes2.default.number,
        type: _propTypes2.default.string,
        value: _propTypes2.default.string
    }))).isRequired
};

exports.default = TradeInProvider;

/***/ }),

/***/ "./src/components/CBBAutoComplete/CBBAutoComplete.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _ShowroomCBBService = __webpack_require__("./src/services/ShowroomCBBService/ShowroomCBBService.js");

var _ShowroomCBBService2 = _interopRequireDefault(_ShowroomCBBService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CBBAutoComplete = function (_Component) {
    _inherits(CBBAutoComplete, _Component);

    function CBBAutoComplete(props) {
        _classCallCheck(this, CBBAutoComplete);

        var _this = _possibleConstructorReturn(this, (CBBAutoComplete.__proto__ || Object.getPrototypeOf(CBBAutoComplete)).call(this, props));

        _this.state = {
            autoCompleteValues: []
        };

        _this.handleReset = _this.handleReset.bind(_this);
        _this.handleSelectedOption = _this.handleSelectedOption.bind(_this);
        _this.initializeAutoCompleteValues = _this.initializeAutoCompleteValues.bind(_this);
        _this.updateAutocompleteValues = _this.updateAutocompleteValues.bind(_this);

        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());

        _this.inputAutoCompleteRef = null;
        return _this;
    }

    _createClass(CBBAutoComplete, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initializeAutoCompleteValues(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            this.initializeAutoCompleteValues(newProps);
        }
    }, {
        key: 'handleReset',
        value: function handleReset() {
            this.setState({
                autoCompleteValues: []
            });
            this.props.onValueSelected('', null, null);
        }
    }, {
        key: 'handleSelectedOption',
        value: function handleSelectedOption(inputValue, handler) {
            var selectedValue = this.state.autoCompleteValues.find(function (item) {
                return item.value === inputValue;
            });
            this.props.onValueSelected(inputValue, selectedValue, handler);
        }
    }, {
        key: 'initializeAutoCompleteValues',
        value: function initializeAutoCompleteValues(props) {
            if (!this.state.autoCompleteValues.length && props.value !== '') {
                this.updateAutocompleteValues(props.value);
            }
        }
    }, {
        key: 'updateAutocompleteValues',
        value: function updateAutocompleteValues(value) {
            var _this2 = this;

            if (!(0, _lodash.isString)(value) || (0, _lodash.isEmpty)(value)) {
                this.logger.debug('Value must be a non-empty string but got ' + value);
                return;
            }

            _ShowroomCBBService2.default.searchAutocomplete(value).then(function (items) {
                _this2.setState({
                    autoCompleteValues: items.map(function (item) {
                        return _extends({
                            id: item.name,
                            value: item.name
                        }, item);
                    })
                });
            }).catch(function (e) {
                _this2.logger.error('CBBAutoComplete#updateAutocompleteValues error calling ShowroomCBBService.searchAutocomplete', e, value);
                _this2.setState({
                    autoCompleteValues: []
                });
            });
        }
    }, {
        key: 'validateInput',
        value: function validateInput() {
            return this.inputAutoCompleteRef ? this.inputAutoCompleteRef.validateInput() : Promise.resolve(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(_widgetCommonsForms.InputAutoComplete, {
                errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.DEFAULT'),
                iconClassName: 'icon-review',
                items: this.state.autoCompleteValues,
                name: 'vehicleInformations',
                placeholder: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.AUTOCOMPLETE_CAR'),
                refreshItems: this.updateAutocompleteValues,
                suggestionsToDisplay: 10,
                value: this.props.value,
                onResetValue: this.handleReset,
                onSelectedOption: this.handleSelectedOption,
                dataTestPrefix: this.props.dataTestPrefix,
                ref: function ref(element) {
                    _this3.inputAutoCompleteRef = element;
                },
                isRequired: true
            });
        }
    }]);

    return CBBAutoComplete;
}(_react.Component);

CBBAutoComplete.defaultProps = {
    value: '',
    dataTestPrefix: ''
};

CBBAutoComplete.propTypes = {
    onValueSelected: _propTypes2.default.func.isRequired,
    value: _propTypes2.default.string,
    dataTestPrefix: _propTypes2.default.string
};

CBBAutoComplete.displayName = 'CBBAutoComplete';

exports.default = CBBAutoComplete;

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/CanadianBlackBookEstimate.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _slider = __webpack_require__("./src/constants/slider.js");

var _slider2 = _interopRequireDefault(_slider);

var _EstimateTradeIn = __webpack_require__("./src/components/EstimateTradeIn/EstimateTradeIn.jsx");

var _EstimateTradeIn2 = _interopRequireDefault(_EstimateTradeIn);

var _TradeInCta = __webpack_require__("./src/components/TradeInCta/TradeInCta.jsx");

var _TradeInCta2 = _interopRequireDefault(_TradeInCta);

var _RangeValue = __webpack_require__("./src/components/CanadianBlackBookEstimate/components/RangeValue.jsx");

var _RangeValue2 = _interopRequireDefault(_RangeValue);

var _EstimateHeader = __webpack_require__("./src/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.jsx");

var _EstimateHeader2 = _interopRequireDefault(_EstimateHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PurchaseMethodsActions = _widgetCommonsVehicle.PurchaseMethods.PurchaseMethodsActions;

var CanadianBlackBookEstimate = function (_Component) {
    _inherits(CanadianBlackBookEstimate, _Component);

    function CanadianBlackBookEstimate(props) {
        _classCallCheck(this, CanadianBlackBookEstimate);

        var _this = _possibleConstructorReturn(this, (CanadianBlackBookEstimate.__proto__ || Object.getPrototypeOf(CanadianBlackBookEstimate)).call(this, props));

        _this.state = {
            tradeInValues: props.tradeInValues
        };

        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());

        _this.handleEstimateChange = _this.handleEstimateChange.bind(_this);
        _this.handleRangeChange = _this.handleRangeChange.bind(_this);
        _this.saveTradeIn = _this.saveTradeIn.bind(_this);
        _this.dispatchTradeInCreatedEvent = _this.dispatchTradeInCreatedEvent.bind(_this);
        return _this;
    }

    _createClass(CanadianBlackBookEstimate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.ESTIMATED_TRADEIN_CONDITION());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                tradeInValues: nextProps.tradeInValues
            });
        }
    }, {
        key: 'handleRangeChange',
        value: function handleRangeChange(tradeInValue) {
            if (tradeInValue) {
                var tradeInValues = _extends({}, this.state.tradeInValues, {
                    amount: _widgetCommonsGeneral.UtilsService.roundValueToStepIntoRange(tradeInValue, _slider2.default.STEP_VALUE, this.state.tradeInValues.low, this.state.tradeInValues.high)
                });

                this.setState({
                    tradeInValues: tradeInValues
                });
            }
        }
    }, {
        key: 'dispatchTradeInCreatedEvent',
        value: function dispatchTradeInCreatedEvent() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new Event(_widgetCommonsGeneral.EVENTS.TRADEIN_CREATED));
            }
        }
    }, {
        key: 'saveTradeIn',
        value: function saveTradeIn() {
            var _this2 = this;

            this.props.handleEstimateChange(_widgetCommonsGeneral.UtilsService.roundValueToStepIntoRange(this.state.tradeInValues.amount, _slider2.default.STEP_VALUE, this.state.tradeInValues.low, this.state.tradeInValues.high)).then(function () {
                _this2.dispatchTradeInCreatedEvent();
                PurchaseMethodsActions.setTradeIn(_this2.state.tradeInValues);
            });
        }
    }, {
        key: 'handleEstimateChange',
        value: function handleEstimateChange(tradeInValue) {
            var _props = this.props,
                handleEstimateChange = _props.handleEstimateChange,
                account = _props.account;

            return handleEstimateChange(_widgetCommonsGeneral.UtilsService.roundValueToStepIntoRange(tradeInValue, _slider2.default.STEP_VALUE, this.state.tradeInValues.low, this.state.tradeInValues.high), account);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'estimate-value__wrapper' },
                _react2.default.createElement(_EstimateHeader2.default, {
                    onEditVehicle: this.props.backToVehicleForm,
                    tradeInValues: this.state.tradeInValues,
                    tradeInVehicle: this.props.tradeInVehicle
                }),
                _react2.default.createElement(_RangeValue2.default, { high: this.state.tradeInValues.high, low: this.state.tradeInValues.low }),
                _react2.default.createElement(_EstimateTradeIn2.default, {
                    tradeInValues: this.state.tradeInValues,
                    handleRangeChange: this.handleRangeChange,
                    handleEstimateChange: this.handleEstimateChange,
                    backToVehicleForm: this.props.backToVehicleForm
                }),
                _react2.default.createElement(_TradeInCta2.default, {
                    saveTradeIn: this.saveTradeIn,
                    goToOfficialTradeInForm: this.props.goToOfficialTradeInForm,
                    isOfficialTradeInActivated: this.props.isOfficialTradeInActivated,
                    isRenderedInModal: this.props.isRenderedInModal,
                    isShowroomV2Enabled: this.props.isShowroomV2Enabled,
                    account: this.props.account
                })
            );
        }
    }]);

    return CanadianBlackBookEstimate;
}(_react.Component);

CanadianBlackBookEstimate.defaultProps = {
    tradeInValues: {
        amount: 0,
        high: 0,
        low: 0,
        taxesFactor: 0
    },
    isShowroomV2Enabled: false,
    account: new _widgetCommonsGeneral.Account()
};

CanadianBlackBookEstimate.propTypes = {
    backToVehicleForm: _propTypes2.default.func.isRequired,
    goToOfficialTradeInForm: _propTypes2.default.func.isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number,
        high: _propTypes2.default.number,
        low: _propTypes2.default.number,
        taxesFactor: _propTypes2.default.number
    }),
    handleEstimateChange: _propTypes2.default.func.isRequired,
    isOfficialTradeInActivated: _propTypes2.default.bool.isRequired,
    isRenderedInModal: _propTypes2.default.bool.isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool,
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account)
};

CanadianBlackBookEstimate.displayName = 'CanadianBlackBookEstimate';

exports.default = CanadianBlackBookEstimate;

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("lodash");

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _reactResponsive = __webpack_require__("../../node_modules/react-responsive/dist/react-responsive.js");

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

__webpack_require__("./src/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imagesServer = _index2.default.source.image;

var EstimateHeader = function EstimateHeader(_ref) {
    var onEditVehicle = _ref.onEditVehicle,
        tradeInVehicle = _ref.tradeInVehicle;

    var vehicleName = _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VEHICLE_NAME', {
        year: tradeInVehicle.year,
        make: tradeInVehicle.make,
        model: tradeInVehicle.model,
        modelTrim: tradeInVehicle.trim,
        modelTrimStyle: tradeInVehicle.style
    });

    function renderWithClassUtil(classParam) {
        var classUtil = (0, _lodash.isString)(classParam) ? classParam : '';
        return _react2.default.createElement(
            'div',
            { className: 'EstimateHeader' },
            _react2.default.createElement(
                'div',
                { className: 'estimate-header--details' },
                _react2.default.createElement(
                    'div',
                    { className: 'estimate-header--title sr-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'is-price' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TITLES.TOP_DOLLAR')
                    ),
                    _react2.default.createElement(
                        'h3',
                        { className: 'sr-subtitle-1' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.SUBTITLES.ESTIMATE_RANGE')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'estimate-header--description sr-text ' + classUtil },
                    _react2.default.createElement(
                        'div',
                        { className: 'estimate-header--line', 'data-test': 'trade-in.estimate-header.vehicle-name' },
                        _react2.default.createElement('icon', { className: 'icon-review' }),
                        vehicleName
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'estimate-header--line', 'data-test': 'trade-in.estimate-header.vehicle-odometer' },
                        tradeInVehicle.odometer,
                        ' ',
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ODOMETER.SYMBOL')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'estimate-header--line', 'data-test': 'trade-in.estimate-header.edit' },
                        _react2.default.createElement(
                            'button',
                            { type: 'button', className: 'sr-link', onClick: onEditVehicle },
                            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.MODIFY')
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'estimate-header--image' },
                _react2.default.createElement(
                    'span',
                    { className: 'powered-by is-uppercase is-light sr-disclaimer' },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.POWERED_BY')
                ),
                _react2.default.createElement('img', {
                    src: imagesServer + '/images/widget/showroom/asset/canadian_black_book.png',
                    alt: 'logo Canadian Black Book'
                })
            )
        );
    }

    // TODO: #refactor - #rhang
    // We do this to apply the class "is-mobile" to correctly format text size
    // according to viewport. The titles scales automatically but not the rest
    // of texts. To be remove when widget-styles allow to scale texts on
    // viewport size.
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: _widgetCommonsGeneral.MEDIA_QUERIES.MOBILE.MAX },
            renderWithClassUtil('is-mobile')
        ),
        _react2.default.createElement(
            _reactResponsive2.default,
            { minWidth: _widgetCommonsGeneral.MEDIA_QUERIES.LAPTOP.MIN },
            renderWithClassUtil()
        )
    );
};

EstimateHeader.propTypes = {
    onEditVehicle: _propTypes2.default.func.isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired
};

EstimateHeader.displayName = 'CanadianBlackBookEstimate.EstimateHeader';

exports.default = EstimateHeader;

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/components/EstimateHeader/EstimateHeader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/components/RangeValue.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _RangeValueItem = __webpack_require__("./src/components/CanadianBlackBookEstimate/components/RangeValueItem.jsx");

var _RangeValueItem2 = _interopRequireDefault(_RangeValueItem);

__webpack_require__("./src/components/CanadianBlackBookEstimate/components/RangeValue.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var czGroup = 'widget.tradein.teaser';

var RangeValue = function RangeValue(_ref) {
    var high = _ref.high,
        low = _ref.low;

    var defaultHighValueCz = '#1DD1A1';
    var defaultLowValueCz = '#EB3B5A';
    var highValueCz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
    var lowValueCz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'estimate.value.low.color');
    return _react2.default.createElement(
        'div',
        { className: 'range-value_wrapper' },
        _react2.default.createElement(_RangeValueItem2.default, {
            backgroundColor: lowValueCz ? lowValueCz.getValue() : defaultLowValueCz,
            classesName: ['low_value'],
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.DESCRIPTION'),
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.TITLE'),
            value: low,
            dataTest: 'trade-in.range-value.low-value'
        }),
        _react2.default.createElement(_RangeValueItem2.default, {
            backgroundColor: highValueCz ? highValueCz.getValue() : defaultHighValueCz,
            classesName: ['high_value'],
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.DESCRIPTION'),
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.TITLE'),
            value: high,
            dataTest: 'trade-in.range-value.high-value'
        })
    );
};

RangeValue.displayName = 'RangeValue';

RangeValue.propTypes = {
    high: _propTypes2.default.number.isRequired,
    low: _propTypes2.default.number.isRequired
};

exports.default = RangeValue;

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/components/RangeValue.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/CanadianBlackBookEstimate/components/RangeValueItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResponsive = __webpack_require__("../../node_modules/react-responsive/dist/react-responsive.js");

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _reactAddonsCssTransitionGroup = __webpack_require__("../../node_modules/react-addons-css-transition-group/index.js");

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RangeValueItem = function (_Component) {
    _inherits(RangeValueItem, _Component);

    function RangeValueItem(props) {
        _classCallCheck(this, RangeValueItem);

        var _this = _possibleConstructorReturn(this, (RangeValueItem.__proto__ || Object.getPrototypeOf(RangeValueItem)).call(this, props));

        _this.state = {
            isDescriptionOpenOnMobile: false
        };

        _this.toggleDescription = _this.toggleDescription.bind(_this);
        return _this;
    }

    _createClass(RangeValueItem, [{
        key: 'toggleDescription',
        value: function toggleDescription() {
            this.setState(function (oldState) {
                return {
                    isDescriptionOpenOnMobile: !oldState.isDescriptionOpenOnMobile
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                backgroundColor = _props.backgroundColor,
                classesName = _props.classesName,
                description = _props.description,
                value = _props.value,
                title = _props.title,
                dataTest = _props.dataTest;

            var classesString = classesName.join(' ');
            var boxStyle = {
                backgroundColor: backgroundColor
            };
            return _react2.default.createElement(
                'div',
                { className: 'range-value_column ' + classesString, style: boxStyle },
                _react2.default.createElement(
                    'div',
                    { className: 'range-value_column_main-content' },
                    _react2.default.createElement(
                        'h2',
                        { className: 'sr-text is-uppercase is-small range-value_column_main-content_title' },
                        title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'sr-title-2 is-bold range-value_column_main-content_value', 'data-test': dataTest },
                        value > 0 ? _widgetCommonsCoreServices.LocaleService.l(value, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0) : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.NON_AVAILABLE')
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'arrow' },
                        _react2.default.createElement('icon', { className: 'icon-arrow-circle' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'description-toggle' },
                        _react2.default.createElement(
                            'button',
                            { className: 'sr-text sr-link', onClick: this.toggleDescription },
                            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.WHAT_IT_MEANS')
                        )
                    )
                ),
                _react2.default.createElement(
                    _reactResponsive2.default,
                    { minWidth: _widgetCommonsGeneral.MEDIA_QUERIES.TABLET.MIN },
                    _react2.default.createElement(
                        'div',
                        { className: 'range-value_column_description is-small' },
                        description
                    )
                ),
                _react2.default.createElement(
                    _reactResponsive2.default,
                    { maxWidth: _widgetCommonsGeneral.MEDIA_QUERIES.MOBILE.MAX },
                    _react2.default.createElement(
                        'div',
                        { className: 'range-value_column_description_wrapper' },
                        _react2.default.createElement(
                            _reactAddonsCssTransitionGroup2.default,
                            { transitionName: 'description' },
                            this.state.isDescriptionOpenOnMobile && _react2.default.createElement(
                                'div',
                                { className: 'range-value_column_description is-small' },
                                description
                            )
                        )
                    )
                )
            );
        }
    }]);

    return RangeValueItem;
}(_react.Component);

RangeValueItem.defaultProps = {
    classesName: [],
    dataTest: ''
};

RangeValueItem.displayName = 'RangeValueItem';

RangeValueItem.propTypes = {
    backgroundColor: _propTypes2.default.string.isRequired,
    classesName: _propTypes2.default.shape([_propTypes2.default.string.isRequired]),
    description: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.number.isRequired,
    dataTest: _propTypes2.default.string
};

exports.default = RangeValueItem;

/***/ }),

/***/ "./src/components/ConfirmationStep/ConfirmationStep.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _TradeInValueSuccess = __webpack_require__("./src/components/TradeInValueSuccess/TradeInValueSuccess.jsx");

var _TradeInValueSuccess2 = _interopRequireDefault(_TradeInValueSuccess);

__webpack_require__("./src/components/ConfirmationStep/ConfirmationStep.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfficialTradeInModal = _widgetCommonsGeneral.ModalService.get('trade-in-official-modal');

var ConfirmationStep = function (_Component) {
    _inherits(ConfirmationStep, _Component);

    function ConfirmationStep() {
        _classCallCheck(this, ConfirmationStep);

        return _possibleConstructorReturn(this, (ConfirmationStep.__proto__ || Object.getPrototypeOf(ConfirmationStep)).apply(this, arguments));
    }

    _createClass(ConfirmationStep, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.onTradeInSuccess();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.OFFICIAL_TRADEIN_THANKS());
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            OfficialTradeInModal.close();
        }
    }, {
        key: 'redirectToHomepage',
        value: function redirectToHomepage() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (windowProxy) {
                windowProxy.location.assign(_widgetCommonsGeneral.REDIRECTIONS[_widgetCommonsCoreServices.LocaleService.getSimpleLocale()].homepage);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_TradeInValueSuccess2.default, null),
                _react2.default.createElement(
                    'button',
                    {
                        className: 'sr-link continue-shopping',
                        onClick: this.props.isRenderedInModal ? this.closeModal : this.redirectToHomepage,
                        dataTest: 'trade-in.trade-in-cta.confirmation.continue-shopping'
                    },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.BACK_TO_SHOP.TITLE')
                )
            );
        }
    }]);

    return ConfirmationStep;
}(_react.Component);

ConfirmationStep.propTypes = {
    onTradeInSuccess: _propTypes2.default.func.isRequired,
    isRenderedInModal: _propTypes2.default.bool.isRequired
};

ConfirmationStep.displayName = 'ConfirmationStep';

exports.default = ConfirmationStep;

/***/ }),

/***/ "./src/components/ConfirmationStep/ConfirmationStep.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/DealerLogo.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var czGroup = 'widget.tradein';

var DealerLogo = function DealerLogo() {
    var cz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'dealer.logo');
    var czDealerLogo = cz ? cz.getValue() : null;
    return czDealerLogo ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: 'DealerLogo' },
            _react2.default.createElement(
                'div',
                { className: 'DealerLogo__logo' },
                _react2.default.createElement('img', { src: czDealerLogo, alt: '' })
            )
        )
    ) : null;
};

DealerLogo.propTypes = {};

exports.default = DealerLogo;

/***/ }),

/***/ "./src/components/EstimateTradeIn/EstimateSlider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Slider = __webpack_require__("./src/components/EstimateTradeIn/components/Slider/Slider.jsx");

var _Slider2 = _interopRequireDefault(_Slider);

var _StatesDescription = __webpack_require__("./src/components/EstimateTradeIn/components/StatesDescription/StatesDescription.jsx");

var _StatesDescription2 = _interopRequireDefault(_StatesDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EstimateSlider = function EstimateSlider(_ref) {
    var tradeInValues = _ref.tradeInValues,
        handleRangeChange = _ref.handleRangeChange,
        handleEstimateChange = _ref.handleEstimateChange;

    return _react2.default.createElement(
        'div',
        { className: 'slider__content' },
        _react2.default.createElement(_Slider2.default, {
            tradeInValues: tradeInValues,
            handleRangeChange: handleRangeChange,
            handleEstimateChange: handleEstimateChange
        }),
        _react2.default.createElement(_StatesDescription2.default, null)
    );
};

EstimateSlider.propTypes = {
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired,
        high: _propTypes2.default.number.isRequired,
        low: _propTypes2.default.number.isRequired,
        taxesFactor: _propTypes2.default.number.isRequired
    }).isRequired,
    handleRangeChange: _propTypes2.default.func.isRequired,
    handleEstimateChange: _propTypes2.default.func.isRequired
};

exports.default = EstimateSlider;

/***/ }),

/***/ "./src/components/EstimateTradeIn/EstimateTradeIn.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _TaxSavings = __webpack_require__("./src/components/EstimateTradeIn/components/TaxSavings/TaxSavings.jsx");

var _TaxSavings2 = _interopRequireDefault(_TaxSavings);

var _DealerLogo = __webpack_require__("./src/components/EstimateTradeIn/DealerLogo.jsx");

var _DealerLogo2 = _interopRequireDefault(_DealerLogo);

var _EstimateSlider = __webpack_require__("./src/components/EstimateTradeIn/EstimateSlider.jsx");

var _EstimateSlider2 = _interopRequireDefault(_EstimateSlider);

__webpack_require__("./src/components/EstimateTradeIn/EstimateTradeIn.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EstimateTradeIn = function EstimateTradeIn(_ref) {
    var tradeInValues = _ref.tradeInValues,
        handleRangeChange = _ref.handleRangeChange,
        handleEstimateChange = _ref.handleEstimateChange;

    var isValidTradeInValue = (0, _lodash.isFinite)(tradeInValues.amount) && tradeInValues.amount > 0;
    var isValidTradeInValueMax = (0, _lodash.isFinite)(tradeInValues.high) && tradeInValues.high > 0;
    var isValidTradeInValueMin = (0, _lodash.isFinite)(tradeInValues.low) && tradeInValues.low > 0;

    if (!isValidTradeInValueMin || !isValidTradeInValueMax || !isValidTradeInValue) {
        return _react2.default.createElement(
            'div',
            { className: 'estimate__content' },
            _react2.default.createElement(
                'h3',
                { className: 'sr-subtitle-2 is-centered' },
                _react2.default.createElement('icon', { className: 'icon-Warning is-warning' }),
                ' ',
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.ERROR.TITLE')
            ),
            _react2.default.createElement(
                'p',
                null,
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.ERROR.TEXT')
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'estimate__content' },
        _react2.default.createElement(_DealerLogo2.default, null),
        _react2.default.createElement(
            'h3',
            { className: 'sr-subtitle-2 is-centered' },
            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.TITLE')
        ),
        _react2.default.createElement(_EstimateSlider2.default, {
            tradeInValues: tradeInValues,
            handleRangeChange: handleRangeChange,
            handleEstimateChange: handleEstimateChange
        }),
        _react2.default.createElement(_TaxSavings2.default, { tradeInValues: tradeInValues })
    );
};

EstimateTradeIn.propTypes = {
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired,
        high: _propTypes2.default.number.isRequired,
        low: _propTypes2.default.number.isRequired,
        taxesFactor: _propTypes2.default.number.isRequired
    }).isRequired,
    handleRangeChange: _propTypes2.default.func.isRequired,
    handleEstimateChange: _propTypes2.default.func.isRequired
};

EstimateTradeIn.displayName = 'EstimateTradeIn';

exports.default = EstimateTradeIn;

/***/ }),

/***/ "./src/components/EstimateTradeIn/EstimateTradeIn.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/Slider/HandleWithTooltip.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcSlider = __webpack_require__("../../node_modules/rc-slider/es/index.js");

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

__webpack_require__("./src/components/EstimateTradeIn/components/Slider/HandleWithTooltip.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var generateHandleWithTaxSavings = function generateHandleWithTaxSavings(taxSavings, roundedValue) {
    var HandleWithTooltip = function HandleWithTooltip(_ref) {
        var value = _ref.value,
            index = _ref.index,
            min = _ref.min,
            max = _ref.max,
            restProps = _objectWithoutProperties(_ref, ['value', 'index', 'min', 'max']);

        return _react2.default.createElement(
            _rcSlider.Handle,
            _extends({ id: 'tooltip', value: value }, restProps),
            _react2.default.createElement(
                'div',
                { className: 'tooltip-text' },
                _react2.default.createElement(
                    'span',
                    { className: 'is-bold', 'data-test': 'trade-in.handle-with-tooltip.value' },
                    _widgetCommonsCoreServices.LocaleService.l(roundedValue, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
                ),
                (0, _lodash.isNumber)(taxSavings) && _react2.default.createElement(
                    'span',
                    { className: 'tooltip-tax' },
                    '+ ' + _widgetCommonsCoreServices.LocaleService.l(taxSavings, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
                )
            )
        );
    };

    HandleWithTooltip.propTypes = {
        value: _propTypes2.default.string.isRequired,
        index: _propTypes2.default.number.isRequired,
        min: _propTypes2.default.number.isRequired,
        max: _propTypes2.default.number.isRequired
    };

    HandleWithTooltip.displayName = 'HandleWithTooltip';

    return HandleWithTooltip;
};

exports.default = generateHandleWithTaxSavings;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/Slider/HandleWithTooltip.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/Slider/Slider.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcSlider = __webpack_require__("../../node_modules/rc-slider/es/index.js");

var _rcSlider2 = _interopRequireDefault(_rcSlider);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _HandleWithTooltip = __webpack_require__("./src/components/EstimateTradeIn/components/Slider/HandleWithTooltip.jsx");

var _HandleWithTooltip2 = _interopRequireDefault(_HandleWithTooltip);

__webpack_require__("./src/components/EstimateTradeIn/components/Slider/Slider.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var czGroup = 'widget.tradein.teaser';

var Slider = function (_Component) {
    _inherits(Slider, _Component);

    function Slider() {
        _classCallCheck(this, Slider);

        return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    _createClass(Slider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (windowProxy) {
                var handle = windowProxy.document.getElementsByClassName('rc-slider-handle')[0];
                if (handle) {
                    handle.addEventListener('touchstart', function () {
                        return handle.classList.add('active');
                    });
                    handle.addEventListener('touchend', function () {
                        return handle.classList.remove('active');
                    });
                    handle.addEventListener('touchcancel', function () {
                        return handle.classList.remove('active');
                    });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                tradeInValues = _props.tradeInValues,
                handleRangeChange = _props.handleRangeChange,
                handleEstimateChange = _props.handleEstimateChange;

            var defaultHighValueCz = '#1DD1A1';
            var defaultLowValueCz = '#EB3B5A';
            var highValueCz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
            var lowValueCz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'estimate.value.low.color');
            var lowColor = lowValueCz ? lowValueCz.getValue() : defaultLowValueCz;
            var highColor = highValueCz ? highValueCz.getValue() : defaultHighValueCz;
            var rcSliderStyle = '.rc-slider {\n            background: ' + lowColor + ';\n            background: -moz-linear-gradient(left, ' + lowColor + ' 0%, ' + highColor + ' 100%);\n            background: -webkit-linear-gradient(left, ' + lowColor + ' 0%,' + highColor + ' 100%);\n            background: linear-gradient(to right, ' + lowColor + ' 0%,' + highColor + ' 100%);\n        }';

            var taxSavings = Math.round(tradeInValues.amount * tradeInValues.taxesFactor);

            return _react2.default.createElement(
                'div',
                { className: 'slider__content--wrapper', ontouchstart: true },
                _react2.default.createElement(
                    'style',
                    null,
                    rcSliderStyle
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'slider__content--value  low-value', style: { color: lowColor } },
                    _react2.default.createElement(
                        'span',
                        { className: 'is-bold', 'data-test': 'trade-in.slider.low-value' },
                        _widgetCommonsCoreServices.LocaleService.l(tradeInValues.low, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'slider__content--value--label is-uppercase is-light sr-disclaimer' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.LOW.TITLE')
                    )
                ),
                _react2.default.createElement(_rcSlider2.default, {
                    range: 0,
                    min: tradeInValues.low,
                    max: tradeInValues.high,
                    onChange: handleRangeChange,
                    onAfterChange: handleEstimateChange,
                    step: 1,
                    defaultValue: tradeInValues.low + (tradeInValues.high - tradeInValues.low) / 2,
                    handle: (0, _HandleWithTooltip2.default)(taxSavings, tradeInValues.amount)
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'slider__content--value high-value', style: { color: highColor } },
                    _react2.default.createElement(
                        'span',
                        { className: 'is-bold', 'data-test': 'trade-in.slider.high-value' },
                        _widgetCommonsCoreServices.LocaleService.l(tradeInValues.high, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'slider__content--value--label is-uppercase is-light sr-disclaimer' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE.VALUE.HIGH.TITLE')
                    )
                )
            );
        }
    }]);

    return Slider;
}(_react.Component);

Slider.propTypes = {
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired,
        high: _propTypes2.default.number.isRequired,
        low: _propTypes2.default.number.isRequired,
        taxesFactor: _propTypes2.default.number.isRequired
    }).isRequired,
    handleRangeChange: _propTypes2.default.func.isRequired,
    handleEstimateChange: _propTypes2.default.func.isRequired
};

exports.default = Slider;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/Slider/Slider.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/StatesDescription/StatesDescription.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _StatesDescriptionUnit = __webpack_require__("./src/components/EstimateTradeIn/components/StatesDescription/StatesDescriptionUnit.jsx");

var _StatesDescriptionUnit2 = _interopRequireDefault(_StatesDescriptionUnit);

__webpack_require__("./src/components/EstimateTradeIn/components/StatesDescription/StatesDescription.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatesDescription = function StatesDescription() {
    return _react2.default.createElement(
        'div',
        { className: 'states-description' },
        _react2.default.createElement(_StatesDescriptionUnit2.default, {
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.TITLE.FAIR'),
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.CONTENT.FAIR')
        }),
        _react2.default.createElement(_StatesDescriptionUnit2.default, {
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.TITLE.GOOD'),
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.CONTENT.GOOD')
        }),
        _react2.default.createElement(_StatesDescriptionUnit2.default, {
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.TITLE.VERYGOOD'),
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.CONTENT.VERYGOOD')
        }),
        _react2.default.createElement(_StatesDescriptionUnit2.default, {
            title: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.TITLE.EXCELLENT'),
            description: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONDITION.CONTENT.EXCELLENT')
        })
    );
};

exports.default = StatesDescription;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/StatesDescription/StatesDescription.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/StatesDescription/StatesDescriptionUnit.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__("./src/components/EstimateTradeIn/components/StatesDescription/StatesDescriptionUnit.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatesDescriptionUnit = function StatesDescriptionUnit(_ref) {
    var title = _ref.title,
        description = _ref.description;

    return _react2.default.createElement(
        'div',
        { className: 'states-description-unit' },
        _react2.default.createElement(
            'div',
            { className: 'title is-bold' },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'content sr-text is-small is-light' },
            description
        )
    );
};

StatesDescriptionUnit.propTypes = {
    title: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired
};

exports.default = StatesDescriptionUnit;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/StatesDescription/StatesDescriptionUnit.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/TaxSavings/TaxSavings.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactResponsive = __webpack_require__("../../node_modules/react-responsive/dist/react-responsive.js");

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

__webpack_require__("./src/components/EstimateTradeIn/components/TaxSavings/TaxSavings.scss");

var _TaxSavingsItem = __webpack_require__("./src/components/EstimateTradeIn/components/TaxSavings/TaxSavingsItem/TaxSavingsItem.jsx");

var _TaxSavingsItem2 = _interopRequireDefault(_TaxSavingsItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getHighValueColor() {
    var czGroup = 'widget.tradein.teaser';
    var highValueColorCz = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
    return highValueColorCz ? highValueColorCz.getValue() : 'inherit';
}

var TaxSavings = function TaxSavings(_ref) {
    var tradeInValues = _ref.tradeInValues;

    var taxSavingsValue = Math.round(tradeInValues.amount * tradeInValues.taxesFactor);
    var totalSavingsValue = tradeInValues.amount + taxSavingsValue;

    var taxSavingsItemStyle = { fontSize: '20px' };
    taxSavingsItemStyle.color = getHighValueColor();

    return _react2.default.createElement(
        'div',
        { className: 'TaxSavings__wrapper' },
        _react2.default.createElement(
            _reactResponsive2.default,
            { minWidth: _widgetCommonsGeneral.MEDIA_QUERIES.MOBILE.MAX },
            _react2.default.createElement(
                'div',
                { className: 'TaxSavingsItem__wrapper' },
                _react2.default.createElement(_TaxSavingsItem2.default, {
                    content: {
                        label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.ESTIMATE'),
                        value: tradeInValues.amount,
                        iconStyles: ['icon-SetBudget']
                    },
                    dataTest: 'trade-in.tax-savings.estimate'
                }),
                _react2.default.createElement(
                    'span',
                    { className: 'TaxSavings__divider' },
                    '+'
                ),
                _react2.default.createElement(_TaxSavingsItem2.default, {
                    content: {
                        label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.TAX_SAVINGS'),
                        value: taxSavingsValue,
                        iconStyles: ['icon-Tax']
                    },
                    dataTest: 'trade-in.tax-savings.tax-saving'
                }),
                _react2.default.createElement(
                    'span',
                    { className: 'TaxSavings__divider' },
                    '='
                ),
                _react2.default.createElement(_TaxSavingsItem2.default, {
                    content: {
                        label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.RESULT'),
                        value: totalSavingsValue,
                        iconStyles: ['icon-Thumb-up']
                    },
                    style: taxSavingsItemStyle,
                    dataTest: 'trade-in.tax-savings.final-price'
                })
            )
        ),
        _react2.default.createElement(
            _reactResponsive2.default,
            { maxWidth: _widgetCommonsGeneral.MEDIA_QUERIES.MOBILE.MAX },
            _react2.default.createElement(
                'p',
                { className: 'is-centered is-light sr-disclaimer', 'data-test': 'trade-in.tax-savings.mobile' },
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.MOBILE', {
                    estimate: _widgetCommonsCoreServices.LocaleService.l(tradeInValues.amount, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0),
                    tax: _widgetCommonsCoreServices.LocaleService.l(taxSavingsValue, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0),
                    total: _widgetCommonsCoreServices.LocaleService.l(totalSavingsValue, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'is-centered is-light sr-disclaimer' },
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement('icon', { className: 'icon-Warning is-warning' }),
                !_widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.LOGGED_OUT_DISCLAIMER') : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.LOGGED_IN_DISCLAIMER')
            ),
            _react2.default.createElement(
                'p',
                null,
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TAX_SAVINGS.MAY_CONTACT_FOR_INFO')
            )
        )
    );
};

TaxSavings.propTypes = {
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired,
        high: _propTypes2.default.number.isRequired,
        low: _propTypes2.default.number.isRequired,
        taxesFactor: _propTypes2.default.number.isRequired
    }).isRequired
};

TaxSavings.displayName = 'TaxSavings';

exports.default = TaxSavings;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/TaxSavings/TaxSavings.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/TaxSavings/TaxSavingsItem/TaxSavingsItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

__webpack_require__("./src/components/EstimateTradeIn/components/TaxSavings/TaxSavingsItem/TaxSavingsItem.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TaxSavingsItem = function TaxSavingsItem(_ref) {
    var content = _ref.content,
        style = _ref.style,
        dataTest = _ref.dataTest;

    return _react2.default.createElement(
        'div',
        { className: 'TaxSavingsItem__body' },
        _react2.default.createElement(
            'div',
            { className: 'TaxSavingsItem__body-left' },
            _react2.default.createElement('icon', { className: content.iconStyles.join('') })
        ),
        _react2.default.createElement(
            'div',
            { className: 'TaxSavingItem__body-right' },
            _react2.default.createElement(
                'p',
                { className: 'sr-text' },
                content.label
            ),
            _react2.default.createElement(
                'p',
                { className: 'sr-subtitle-2', style: style, 'data-test': dataTest },
                _widgetCommonsCoreServices.LocaleService.l(content.value, _widgetCommonsVehicle.CurrencyFormats.CURRENCY_0)
            )
        )
    );
};

TaxSavingsItem.defaultProps = {
    style: {
        fontSize: '14px',
        color: 'inherit'
    },
    dataTest: ''
};

TaxSavingsItem.propTypes = {
    content: _propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.number.isRequired,
        iconStyles: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
    }).isRequired,
    style: _propTypes2.default.shape({
        fontSize: _propTypes2.default.string,
        color: _propTypes2.default.string
    }),
    dataTest: _propTypes2.default.string
};

TaxSavingsItem.displayName = 'TaxSavingsItem';

exports.default = TaxSavingsItem;

/***/ }),

/***/ "./src/components/EstimateTradeIn/components/TaxSavings/TaxSavingsItem/TaxSavingsItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/InstantEstimate/InstantEstimate.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _InstantEstimateIcon = __webpack_require__("./src/components/InstantEstimate/InstantEstimateIcon.jsx");

var _InstantEstimateIcon2 = _interopRequireDefault(_InstantEstimateIcon);

var _InstantEstimateAutocomplete = __webpack_require__("./src/components/InstantEstimate/InstantEstimateAutocomplete.jsx");

var _InstantEstimateAutocomplete2 = _interopRequireDefault(_InstantEstimateAutocomplete);

var _InstantEstimateModal = __webpack_require__("./src/components/InstantEstimateModal/InstantEstimateModal.jsx");

var _InstantEstimateModal2 = _interopRequireDefault(_InstantEstimateModal);

var _OfficialTradeInModal = __webpack_require__("./src/components/OfficialTradeInModal/OfficialTradeInModal.jsx");

var _OfficialTradeInModal2 = _interopRequireDefault(_OfficialTradeInModal);

__webpack_require__("./src/components/InstantEstimate/InstantEstimate.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstantEstimate = function (_React$Component) {
    _inherits(InstantEstimate, _React$Component);

    function InstantEstimate(props) {
        _classCallCheck(this, InstantEstimate);

        var _this = _possibleConstructorReturn(this, (InstantEstimate.__proto__ || Object.getPrototypeOf(InstantEstimate)).call(this, props));

        _this.state = {
            isOfficialTradeInModalOpen: false,
            isEstimateTradeInModalOpen: false,
            tradeInVehicle: {},
            inputValue: ''
        };
        _this.onValueSelected = _this.onValueSelected.bind(_this);
        _this.getParentSize = _this.getParentSize.bind(_this);
        _this.handleCloseEstimate = _this.handleCloseEstimate.bind(_this);
        _this.handleCloseOfficial = _this.handleCloseOfficial.bind(_this);
        _this.handleResize = (0, _lodash.debounce)(function () {
            return _this.forceUpdate();
        }, 150).bind(_this);
        return _this;
    }

    _createClass(InstantEstimate, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (windowProxy) {
                windowProxy.addEventListener('resize', this.handleResize);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (windowProxy) {
                windowProxy.removeEventListener('resize', this.handleResize);
            }
        }
    }, {
        key: 'onValueSelected',
        value: function onValueSelected(inputValue, selectedValue) {
            this.setState({
                inputValue: inputValue,
                isEstimateTradeInModalOpen: !!selectedValue,
                tradeInVehicle: selectedValue || {}
            });
            // TODO: need 1 news params on the func. "handler" and need to setState : tradeInVehicle as selectedValue
        }
    }, {
        key: 'getParentSize',
        value: function getParentSize() {
            var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
            if (!windowProxy) {
                return null;
            }
            var parent = windowProxy.document.getElementById(this.props.parentElementId);
            if (!parent) {
                return null;
            }
            return parent.offsetWidth;
        }
    }, {
        key: 'getClassNameFromParentSize',
        value: function getClassNameFromParentSize() {
            var size = this.getParentSize();
            if (!size) {
                return null;
            }
            if (size <= _widgetCommonsGeneral.MEDIA_QUERIES.MOBILE.MAX) {
                return 'instant-estimate-mobile';
            }
            if (size >= _widgetCommonsGeneral.MEDIA_QUERIES.TABLET.MIN && size <= _widgetCommonsGeneral.MEDIA_QUERIES.TABLET.MAX) {
                return 'instant-estimate-tablet';
            }
            return null;
        }
    }, {
        key: 'handleCloseEstimate',
        value: function handleCloseEstimate() {
            this.setState({ isEstimateTradeInModalOpen: false });
        }
    }, {
        key: 'handleCloseOfficial',
        value: function handleCloseOfficial() {
            this.setState({ isOfficialTradeInModalOpen: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var czGroup = 'widget.tradein.teaser';
            var styleBackgroundPrimary = {
                backgroundColor: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue() : '#21232e'
            };
            var stylePatternOverlay = {
                backgroundImage: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'pattern') && 'url(' + _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'pattern').getValue() + ')'
            };

            return _react2.default.createElement(
                'div',
                {
                    className: ['instant-estimate__showroom', this.getClassNameFromParentSize()].join(' ').trim(),
                    style: styleBackgroundPrimary
                },
                _react2.default.createElement(
                    'div',
                    { className: 'instant-estimate__wrapper' },
                    _react2.default.createElement(_InstantEstimateIcon2.default, null),
                    _react2.default.createElement(_InstantEstimateAutocomplete2.default, {
                        onAutoCompleteSelect: this.onValueSelected,
                        selectedValue: this.state.inputValue
                    }),
                    stylePatternOverlay.backgroundImage && _react2.default.createElement('div', { className: 'instant-estimate__pattern', style: stylePatternOverlay })
                ),
                _react2.default.createElement(_InstantEstimateModal2.default, {
                    openModal: this.state.isEstimateTradeInModalOpen,
                    onClose: this.handleCloseEstimate,
                    tradeInVehicle: this.state.tradeInVehicle,
                    isShowroomV2Enabled: this.props.isShowroomV2Enabled,
                    quote: this.props.quote
                }),
                _react2.default.createElement(_OfficialTradeInModal2.default, {
                    openModal: this.state.isOfficialTradeInModalOpen,
                    onClose: this.handleCloseOfficial,
                    tradeInVehicle: this.state.tradeInVehicle,
                    quote: this.props.quote
                })
            );
        }
    }]);

    return InstantEstimate;
}(_react2.default.Component);

InstantEstimate.displayName = 'InstantEstimate';

InstantEstimate.propTypes = {
    parentElementId: _propTypes2.default.string.isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel).isRequired
};

exports.default = InstantEstimate;

/***/ }),

/***/ "./src/components/InstantEstimate/InstantEstimate.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/InstantEstimate/InstantEstimateAutocomplete.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _CBBAutoComplete = __webpack_require__("./src/components/CBBAutoComplete/CBBAutoComplete.jsx");

var _CBBAutoComplete2 = _interopRequireDefault(_CBBAutoComplete);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantEstimateAutocomplete = function InstantEstimateAutocomplete(_ref) {
    var onAutoCompleteSelect = _ref.onAutoCompleteSelect,
        selectedValue = _ref.selectedValue;

    var czGroup = 'widget.tradein.teaser';
    var defaultStyleBackgroundColor = '#CD1122';
    var defaultStyleTextColor = '#ffffff';

    var styleBackgroundColor = {
        backgroundColor: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue() : defaultStyleBackgroundColor
    };
    var estimateTitle = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.title') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.title').getValue() : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TEASER.ESTIMATE_TITLE');

    var estimateSubtitle = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle').getValue() : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TEASER.ESTIMATE_SUBTITLE');

    var styleTextColor = {
        color: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.text.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.text.color').getValue() : defaultStyleTextColor
    };
    var imagesServer = _index2.default.source.image;
    return _react2.default.createElement(
        'div',
        { className: 'instant-estimate__content', style: styleBackgroundColor },
        _react2.default.createElement(
            'div',
            { className: 'instant-estimate__text-content' },
            _react2.default.createElement(
                'div',
                { className: 'instant-estimate__text-wrapper' },
                _react2.default.createElement(
                    'p',
                    { style: styleTextColor, className: 'instant-estimate__content-subtitle sr-text is-light is-small' },
                    estimateSubtitle
                ),
                _react2.default.createElement(
                    'p',
                    { style: styleTextColor, className: 'instant-estimate__content-title' },
                    estimateTitle
                )
            ),
            _react2.default.createElement(_CBBAutoComplete2.default, {
                onValueSelected: onAutoCompleteSelect,
                value: selectedValue,
                dataTestPrefix: 'trade-in.instant-estimate-autocomplete'
            })
        ),
        _react2.default.createElement('img', {
            src: imagesServer + '/images/widget/showroom/asset/canadian_black_book_monochrone.png',
            alt: estimateTitle,
            className: 'teaser-cbb__image'
        })
    );
};

InstantEstimateAutocomplete.propTypes = {
    onAutoCompleteSelect: _propTypes2.default.func.isRequired,
    selectedValue: _propTypes2.default.string.isRequired
};

InstantEstimateAutocomplete.displayName = 'InstantEstimateAutocomplete';

exports.default = InstantEstimateAutocomplete;

/***/ }),

/***/ "./src/components/InstantEstimate/InstantEstimateIcon.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstantEstimateIcon = function InstantEstimateIcon() {
    var imagesServer = _index2.default.source.image;
    var czGroup = 'widget.tradein.teaser';
    var estimateIcon = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon').getValue() : imagesServer + '/images/widget/showroom/asset/estimate-value-teaser.png';
    var estimateBackground = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon.background.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon.background.color').getValue() : '#B01925';
    var backgroundColor = {
        backgroundColor: estimateBackground
    };
    return _react2.default.createElement(
        'div',
        { className: 'instant-estimate__image-section', style: backgroundColor },
        _react2.default.createElement('img', { src: estimateIcon, alt: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TEASER.INSTANT_ESTIMATE') })
    );
};

InstantEstimateIcon.propTypes = {};

InstantEstimateIcon.displayName = 'InstantEstimateIcon';

exports.default = InstantEstimateIcon;

/***/ }),

/***/ "./src/components/InstantEstimateModal/InstantEstimateModal.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MODAL_NAME = undefined;

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _InstantEstimateWrapper = __webpack_require__("./src/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx");

var _InstantEstimateWrapper2 = _interopRequireDefault(_InstantEstimateWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_NAME = 'trade-in-estimate-modal';

var InstantEstimateModal = function InstantEstimateModal(_ref) {
    var _onClose = _ref.onClose,
        openModal = _ref.openModal,
        tradeInVehicle = _ref.tradeInVehicle,
        isShowroomV2Enabled = _ref.isShowroomV2Enabled,
        quote = _ref.quote;

    var modal = _widgetCommonsGeneral.ModalService.get(MODAL_NAME);
    if (openModal && !modal.isOpen()) {
        modal.open();
    }
    modal.addCallbacks({
        onClose: function onClose() {
            _onClose();
            return true;
        }
    });
    return _react2.default.createElement(
        _widgetCommonsGeneral.WhiteModal,
        {
            name: MODAL_NAME,
            contentLabel: 'trade-in-modal-label',
            dataTestPrefix: 'trade-in.instant-estimate-modal',
            isScrollable: true,
            isClosable: true
        },
        _react2.default.createElement(_InstantEstimateWrapper2.default, {
            tradeInVehicle: tradeInVehicle,
            isShowroomV2Enabled: isShowroomV2Enabled,
            quote: quote
        })
    );
};

InstantEstimateModal.defaultProps = {
    openModal: false
};

InstantEstimateModal.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    openModal: _propTypes2.default.bool,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel).isRequired
};

InstantEstimateModal.displayName = 'InstantEstimateModal';
exports.MODAL_NAME = MODAL_NAME;
exports.default = InstantEstimateModal;

/***/ }),

/***/ "./src/components/InstantEstimateWrapper/InstantEstimateWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _TradeInModel = __webpack_require__("./src/model/TradeInModel.js");

var _TradeInModel2 = _interopRequireDefault(_TradeInModel);

var _TradeInService = __webpack_require__("./src/services/TradeInService/TradeInService.js");

var _TradeInService2 = _interopRequireDefault(_TradeInService);

var _VehicleForm = __webpack_require__("./src/components/VehicleForm/VehicleForm.jsx");

var _VehicleForm2 = _interopRequireDefault(_VehicleForm);

var _CanadianBlackBookEstimate = __webpack_require__("./src/components/CanadianBlackBookEstimate/CanadianBlackBookEstimate.jsx");

var _CanadianBlackBookEstimate2 = _interopRequireDefault(_CanadianBlackBookEstimate);

__webpack_require__("./src/components/InstantEstimateWrapper/InstantEstimateWrapper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstantEstimateWrapper = function (_Component) {
    _inherits(InstantEstimateWrapper, _Component);

    function InstantEstimateWrapper(props) {
        _classCallCheck(this, InstantEstimateWrapper);

        var _this = _possibleConstructorReturn(this, (InstantEstimateWrapper.__proto__ || Object.getPrototypeOf(InstantEstimateWrapper)).call(this, props));

        _this.state = {
            isScreenLock: false,
            tradeInVehicle: props.tradeInVehicle,
            tradeInValues: null,
            account: new _widgetCommonsGeneral.Account()
        };

        _this.getSteps = _this.getSteps.bind(_this);
        _this.toggleScreenLock = _this.toggleScreenLock.bind(_this);
        _this.updateLead = _this.updateLead.bind(_this);
        _this.updateTradeInVehicle = _this.updateTradeInVehicle.bind(_this);
        return _this;
    }

    _createClass(InstantEstimateWrapper, [{
        key: 'getSteps',
        value: function getSteps() {
            var _this2 = this;

            var steps = [];
            steps.push(function (_ref) {
                var goNextStep = _ref.goNextStep;
                return _react2.default.createElement(_VehicleForm2.default, {
                    autofillTradeInVehicleFromAccount: false,
                    account: _this2.state.account,
                    updateAccount: function updateAccount(account) {
                        return _this2.setState({ account: account });
                    },
                    lockScreen: _this2.toggleScreenLock,
                    onFormSubmit: function onFormSubmit(data) {
                        return _this2.setState(data, goNextStep);
                    },
                    onTradeInVehicleUpdated: _this2.updateTradeInVehicle,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    isRenderedInModal: true,
                    useCBB: true,
                    quote: _this2.props.quote
                });
            });

            steps.push(function (_ref2) {
                var goPreviousStep = _ref2.goPreviousStep;
                return _react2.default.createElement(_CanadianBlackBookEstimate2.default, {
                    account: _this2.state.account,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    backToVehicleForm: goPreviousStep,
                    tradeInValues: _this2.state.tradeInValues,
                    handleEstimateChange: _this2.updateLead,
                    isOfficialTradeInActivated: _this2.props.isShowroomV2Enabled,
                    isShowroomV2Enabled: _this2.props.isShowroomV2Enabled,
                    isRenderedInModal: true
                });
            });

            return steps;
        }
    }, {
        key: 'toggleScreenLock',
        value: function toggleScreenLock() {
            this.setState(function (prevState) {
                return { isScreenLock: !prevState.isScreenLock };
            });
        }
    }, {
        key: 'updateTradeInVehicle',
        value: function updateTradeInVehicle(tradeInVehicle, onStateSet) {
            this.setState(function (oldState) {
                return _extends({}, oldState, { tradeInVehicle: tradeInVehicle });
            }, onStateSet);
        }
    }, {
        key: 'updateLead',
        value: function updateLead(amount, profile) {
            var updatedTradeInModel = new _TradeInModel2.default({
                leadId: this.state.leadId,
                tradeInVehicle: this.state.tradeInVehicle,
                estimation: {
                    amount: amount,
                    high: this.state.tradeInValues.high,
                    low: this.state.tradeInValues.low
                },
                profile: profile
            });
            return _TradeInService2.default.saveTradeIn(updatedTradeInModel, this.props.quote);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'TradeIn__wrapper' },
                _react2.default.createElement(
                    _widgetCommonsGeneral.LoaderFullScreen,
                    { show: this.state.isScreenLock, message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.SCREEN_LOCKED') },
                    _react2.default.createElement(_widgetCommonsForms.Wizard, { steps: this.getSteps(), parentSelector: '.TradeIn__wrapper' })
                )
            );
        }
    }]);

    return InstantEstimateWrapper;
}(_react.Component);

InstantEstimateWrapper.propTypes = {
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel).isRequired
};

InstantEstimateWrapper.displayName = 'InstantEstimateWrapper';

exports.default = InstantEstimateWrapper;

/***/ }),

/***/ "./src/components/InstantEstimateWrapper/InstantEstimateWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/LoginStep/LoginStep.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetLogin = __webpack_require__("@sm360/widget-login");

var _widgetLogin2 = _interopRequireDefault(_widgetLogin);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginStep = function (_Component) {
    _inherits(LoginStep, _Component);

    function LoginStep(props) {
        _classCallCheck(this, LoginStep);

        var _this = _possibleConstructorReturn(this, (LoginStep.__proto__ || Object.getPrototypeOf(LoginStep)).call(this, props));

        _this.state = {
            accountLoading: false,
            account: props.account
        };

        _this.initModal = _this.initModal.bind(_this);
        _this.onLogin = _this.onLogin.bind(_this);
        if (!props.isRenderedInModal) {
            _this.initModal();
        }
        return _this;
    }

    _createClass(LoginStep, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            function loadAccount() {
                var _this2 = this;

                return _widgetCommonsGeneral.ProfileService.getLoggedAccountProfile().then(function (account) {
                    return _this2.setState({ accountLoading: false, account: new _widgetCommonsGeneral.Account(account) }, function () {
                        return _this2.props.stepDone(_this2.state.account);
                    });
                });
            }

            if (_widgetCommonsGeneral.AccountService.isAuthenticated() && !this.state.account) {
                this.setState({ accountLoading: true }, loadAccount);
            } else if (this.state.account) {
                this.props.stepDone();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.isRenderedInModal && !this.modal) {
                this.initModal();
            }
        }
    }, {
        key: 'onLogin',
        value: function onLogin() {
            var _this3 = this;

            if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return this.props.stepDone();
            }
            return _widgetCommonsGeneral.ProfileService.getLoggedAccountProfile().then(function (account) {
                return _this3.props.stepDone(new _widgetCommonsGeneral.Account(account));
            });
        }
    }, {
        key: 'initModal',
        value: function initModal() {
            this.modal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
            this.modal.addCallbacks({ onClose: this.onLogin });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!_widgetCommonsGeneral.AccountService.isAuthenticated() && !this.state.account && !this.state.accountLoading) {
                if (this.props.isRenderedInModal) {
                    return _react2.default.createElement(_widgetLogin2.default.GuestOrSignin, { onSuccess: this.onLogin });
                }
                this.modal.open();
            }
            return null;
        }
    }]);

    return LoginStep;
}(_react.Component);

LoginStep.defaultProps = {
    account: null
};

LoginStep.propTypes = {
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account),
    isRenderedInModal: _propTypes2.default.bool.isRequired,
    stepDone: _propTypes2.default.func.isRequired
};

LoginStep.displayName = 'LoginStep';

exports.default = LoginStep;

/***/ }),

/***/ "./src/components/OfficialTradeIn/OfficialTradeIn.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _OfficialTradeInModal = __webpack_require__("./src/components/OfficialTradeInModal/OfficialTradeInModal.jsx");

var _OfficialTradeInModal2 = _interopRequireDefault(_OfficialTradeInModal);

__webpack_require__("./src/components/InstantEstimate/InstantEstimate.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfficialTradeIn = function (_React$Component) {
    _inherits(OfficialTradeIn, _React$Component);

    function OfficialTradeIn(props) {
        _classCallCheck(this, OfficialTradeIn);

        var _this = _possibleConstructorReturn(this, (OfficialTradeIn.__proto__ || Object.getPrototypeOf(OfficialTradeIn)).call(this, props));

        _this.state = {
            isModalOpen: false,
            tradeInVehicle: {}
        };
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }

    _createClass(OfficialTradeIn, [{
        key: 'handleClose',
        value: function handleClose() {
            this.setState({ isModalOpen: false });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_OfficialTradeInModal2.default, {
                openModal: this.state.isModalOpen,
                onClose: this.handleClose,
                tradeInVehicle: this.state.tradeInVehicle,
                quote: this.props.quote
            });
        }
    }]);

    return OfficialTradeIn;
}(_react2.default.Component);

OfficialTradeIn.defaultProps = {
    quote: null
};

OfficialTradeIn.propTypes = {
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel)
};

OfficialTradeIn.displayName = 'OfficialTradeIn';

exports.default = OfficialTradeIn;

/***/ }),

/***/ "./src/components/OfficialTradeInForm/OfficialTradeInForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfficialTradeInForm = exports.STEPS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _ShowroomTradeInService = __webpack_require__("./src/services/ShowroomTradeInService/ShowroomTradeInService.js");

var _ShowroomTradeInService2 = _interopRequireDefault(_ShowroomTradeInService);

var _CarStory = __webpack_require__("./src/components/OfficialTradeInForm/components/CarStory/CarStory.jsx");

var _CarStory2 = _interopRequireDefault(_CarStory);

var _CarCondition = __webpack_require__("./src/components/OfficialTradeInForm/components/CarCondition/CarCondition.jsx");

var _CarCondition2 = _interopRequireDefault(_CarCondition);

var _TradeInService = __webpack_require__("./src/services/TradeInService/TradeInService.js");

var _TradeInService2 = _interopRequireDefault(_TradeInService);

var _TradeInModel = __webpack_require__("./src/model/TradeInModel.js");

var _TradeInModel2 = _interopRequireDefault(_TradeInModel);

__webpack_require__("./src/components/OfficialTradeInForm/OfficialTradeInForm.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STEPS = {
    CAR_STORY: 0,
    CAR_CONDITION: 1
};

var OfficialTradeInForm = function (_Component) {
    _inherits(OfficialTradeInForm, _Component);

    function OfficialTradeInForm(props) {
        var _completedSteps, _stepInputValues;

        _classCallCheck(this, OfficialTradeInForm);

        var _this = _possibleConstructorReturn(this, (OfficialTradeInForm.__proto__ || Object.getPrototypeOf(OfficialTradeInForm)).call(this, props));

        _this.state = {
            completedSteps: (_completedSteps = {}, _defineProperty(_completedSteps, STEPS.CAR_STORY, false), _defineProperty(_completedSteps, STEPS.CAR_CONDITION, false), _completedSteps),
            stepInputValues: (_stepInputValues = {}, _defineProperty(_stepInputValues, STEPS.CAR_STORY, {}), _defineProperty(_stepInputValues, STEPS.CAR_CONDITION, {}), _stepInputValues),
            currentStep: STEPS.CAR_STORY,
            tradeInVehicle: props.tradeInVehicle
        };

        _this.handleStepFormSubmit = _this.handleStepFormSubmit.bind(_this);
        _this.allStepCompleted = _this.allStepCompleted.bind(_this);
        _this.goNextStep = _this.goNextStep.bind(_this);
        _this.saveApiTradeIn = _this.saveApiTradeIn.bind(_this);
        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
        return _this;
    }

    _createClass(OfficialTradeInForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                _widgetCommonsGeneral.ProfileService.fetchProfile().then(function (_ref) {
                    var firstname = _ref.firstname,
                        lastname = _ref.lastname,
                        homePhone = _ref.homePhone,
                        email1 = _ref.email1,
                        email2 = _ref.email2;
                    return _this2.setState({
                        profile: {
                            firstname: firstname,
                            lastname: lastname,
                            homePhone: homePhone,
                            email: email1 || email2
                        }
                    });
                });
            }
        }
    }, {
        key: 'allStepCompleted',
        value: function allStepCompleted() {
            return Object.values(this.state.completedSteps).every(function (step) {
                return step;
            });
        }
    }, {
        key: 'goNextStep',
        value: function goNextStep() {
            this.setState(function (oldState) {
                return {
                    currentStep: oldState.currentStep + 1,
                    completedSteps: _extends({}, oldState.completedSteps, _defineProperty({}, oldState.currentStep, true))
                };
            });
        }
    }, {
        key: 'saveApiTradeIn',
        value: function saveApiTradeIn() {
            var _this3 = this;

            return new Promise(function (resolve, reject) {
                var _state = _this3.state,
                    tradeInVehicle = _state.tradeInVehicle,
                    profile = _state.profile;

                _ShowroomTradeInService2.default.fetchTradeIn().then(function (tradeIn) {
                    return new _TradeInModel2.default(_extends({}, tradeIn, {
                        profile: profile,
                        tradeInVehicle: tradeInVehicle,
                        estimation: _this3.props.tradeInValues,
                        status: _this3.allStepCompleted() ? _widgetCommonsVehicle.Vehicle.TRADEIN_STATUSES.DATA_CONTENT_FLAGS.HISTORY : tradeIn.status,
                        leadId: _this3.props.leadId,
                        evaluationQuestions: _extends({}, _this3.state.stepInputValues[STEPS.CAR_STORY], _this3.state.stepInputValues[STEPS.CAR_CONDITION])
                    }));
                }).then(function (tradeInModel) {
                    return _TradeInService2.default.saveTradeIn(tradeInModel, _this3.props.quote);
                }).then(function (createdTradeIn) {
                    _this3.props.loadQuote();
                    resolve(createdTradeIn);
                }).catch(function (e) {
                    _this3.logger.error('An error happened while saving the showroom tradeInVehicle', e, tradeInVehicle);
                    reject(e);
                });
            });
        }
    }, {
        key: 'handleStepFormSubmit',
        value: function handleStepFormSubmit(inputValues) {
            function saveTradeIn() {
                var _this4 = this;

                this.saveApiTradeIn(inputValues).then(function (_ref2) {
                    var leadId = _ref2.leadId;

                    if (_this4.state.completedSteps[STEPS.CAR_STORY] && !_this4.state.completedSteps[STEPS.CAR_CONDITION]) {
                        _widgetCommonsGeneral.ShiftDigitalService.createFormEvent(leadId, 'Trade-In | Showroom | Car Story');
                        _widgetCommonsGeneral.AnalyticsService.eventDataLayer('form|trade-in - Car Story', 'submit', 'trade-in-showroom');
                    } else if (_this4.state.completedSteps[STEPS.CAR_CONDITION]) {
                        _widgetCommonsGeneral.ShiftDigitalService.createFormEvent(leadId, 'Trade-In | Showroom | Car Condition');
                        _widgetCommonsGeneral.AnalyticsService.eventDataLayer('form|trade-in - Car Condition', 'submit', 'trade-in-showroom');
                    }
                    _this4.goNextStep();
                });
            }

            this.setState({
                stepInputValues: _extends({}, this.state.stepInputValues, _defineProperty({}, this.state.currentStep, inputValues))
            }, saveTradeIn);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var onStepTransition = function onStepTransition(inputValues, goNextStep) {
                _this5.handleStepFormSubmit(inputValues);
                goNextStep();
            };
            var steps = [function (_ref3) {
                var goNextStep = _ref3.goNextStep;
                return _react2.default.createElement(_CarStory2.default, { onFormSubmit: function onFormSubmit(inputValues) {
                        return onStepTransition(inputValues, goNextStep);
                    } });
            }, function () {
                return _react2.default.createElement(_CarCondition2.default, {
                    onFormSubmit: function onFormSubmit(inputValues) {
                        return onStepTransition(inputValues, _this5.props.onFormCompletion);
                    }
                });
            }];
            return _react2.default.createElement(
                'div',
                { className: 'officialTradeInForm' },
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-subtitle-1' },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.OFFICIAL_TITLE')
                ),
                _react2.default.createElement(_widgetCommonsForms.Wizard, { steps: steps })
            );
        }
    }]);

    return OfficialTradeInForm;
}(_react.Component);

OfficialTradeInForm.propTypes = {
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel),
    tradeInValues: _propTypes2.default.shape({
        amount: _propTypes2.default.number.isRequired,
        high: _propTypes2.default.number.isRequired,
        low: _propTypes2.default.number.isRequired
    }).isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    onFormCompletion: _propTypes2.default.func.isRequired,
    leadId: _propTypes2.default.number,
    loadQuote: _propTypes2.default.func
};

OfficialTradeInForm.defaultProps = {
    quote: null,
    leadId: null,
    loadQuote: _lodash.noop
};

OfficialTradeInForm.displayName = 'OfficialTradeInForm';

exports.STEPS = STEPS;
exports.OfficialTradeInForm = OfficialTradeInForm; // For the tests

exports.default = OfficialTradeInForm;

/***/ }),

/***/ "./src/components/OfficialTradeInForm/OfficialTradeInForm.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarCondition/CarCondition.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _reactCollapse = __webpack_require__("../../node_modules/react-collapse/lib/index.js");

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _ShowroomTradeInService = __webpack_require__("./src/services/ShowroomTradeInService/ShowroomTradeInService.js");

var _ShowroomTradeInService2 = _interopRequireDefault(_ShowroomTradeInService);

var _formInputs = __webpack_require__("./src/components/OfficialTradeInForm/components/CarCondition/formInputs.js");

var _formInputs2 = _interopRequireDefault(_formInputs);

__webpack_require__("./src/components/OfficialTradeInForm/components/CarCondition/CarCondition.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CarCondition = function (_Component) {
    _inherits(CarCondition, _Component);

    function CarCondition(props) {
        _classCallCheck(this, CarCondition);

        var _this = _possibleConstructorReturn(this, (CarCondition.__proto__ || Object.getPrototypeOf(CarCondition)).call(this, props));

        _this.state = {
            isValid: false,
            inputs: {
                hadAnAccident: '',
                needReparationOtherExplanation: '',
                clarifyDamage: '',
                airBagsOperational: '',
                modifiedParts: '',
                partsToReplace: [],
                replacedTires: '',
                replacedBrakes: '',
                anyScratches: '',
                damageExceeding3000: '',
                majorExteriorInteriorDamage: ''
            },
            formValidation: {
                hadAnAccident: false,
                needReparationOtherExplanation: true,
                clarifyDamage: true,
                airBagsOperational: false,
                modifiedParts: false,
                partsToReplace: false,
                replacedTires: false,
                replacedBrakes: false,
                anyScratches: false,
                damageExceeding3000: false,
                majorExteriorInteriorDamage: false
            },
            errors: []
        };

        _this.buildInput = _this.buildInput.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.sendForm = _this.sendForm.bind(_this);
        return _this;
    }

    _createClass(CarCondition, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _ShowroomTradeInService2.default.fetchTradeIn().then(function (tradeIn) {
                if (tradeIn && tradeIn.evaluationQuestion && tradeIn.evaluationQuestion.carCondition) {
                    _this2.setState({
                        inputs: _extends({}, tradeIn.evaluationQuestion.carCondition)
                    }, _this2.validateForm);
                }
            });
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.OFFICIAL_TRADEIN_CONDITIONS_FORM());
        }
    }, {
        key: 'validateForm',
        value: function validateForm() {
            var _this3 = this;

            var formValidation = this.state.formValidation;

            (0, _lodash.forOwn)(formValidation, function (value, key) {
                var fieldRequireValidation = key === 'needReparationOtherExplanation' && (0, _lodash.includes)(_this3.state.partsToReplace, 'other') || key === 'clarifyDamage' && _this3.state.majorExteriorInteriorDamage || key !== 'needReparationOtherExplanation' && key !== 'clarifyDamage';

                if (fieldRequireValidation) {
                    var stateValue = _this3.state.inputs[key];
                    formValidation[key] = (0, _lodash.isBoolean)(stateValue) || _widgetCommonsForms.ValidationService.validateIsNotEmpty(stateValue);
                }
            });

            this.setState({ formValidation: formValidation });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(value, name) {
            var nextState = this.state;

            switch (name) {
                case 'partsToReplace':
                    {
                        var currentSelection = nextState.inputs.partsToReplace;
                        if (value === 'none') {
                            currentSelection = ['none'];
                        } else {
                            (0, _lodash.remove)(currentSelection, function (selection) {
                                return selection === 'none';
                            });
                            var index = currentSelection.findIndex(function (elem) {
                                return elem === value;
                            });

                            if (index === -1) {
                                currentSelection.push(value);
                            } else {
                                currentSelection.splice(index, 1);
                            }
                        }

                        nextState.formValidation[name] = currentSelection.length > 0;
                        nextState.inputs[name] = currentSelection;

                        break;
                    }
                case 'hadAnAccident':
                    {
                        (0, _lodash.forEach)(_formInputs2.default.ACCIDENT_QUESTION, function (input) {
                            if (input.name !== 'needReparationOtherExplanation') {
                                nextState.formValidation[input.name] = value === 'none' || value === 'lessThan3000';
                            }

                            nextState.inputs[input.name] = value !== '3000AndMore' ? nextState.inputs[input.name] : '';
                        });

                        nextState.inputs[name] = value;
                        nextState.formValidation[name] = true;
                        break;
                    }
                default:
                    {
                        nextState.inputs[name] = value;
                        nextState.formValidation[name] = true;
                        break;
                    }
            }

            this.setState(nextState);
        }
    }, {
        key: 'sendForm',
        value: function sendForm(event) {
            event.preventDefault();

            if (!_widgetCommonsForms.ValidationService.validateForm(this.state.formValidation)) {
                this.setState({
                    errors: [{
                        message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VEHICLE_INFORMATION.ERROR'),
                        code: 'error.missing_inputs',
                        group: 'carInformation'
                    }]
                });
                var nav = _widgetCommonsCoreServices.WindowProxy.get().document.getElementsByClassName('officialTradeInForm') ? _widgetCommonsCoreServices.WindowProxy.get().document.getElementsByClassName('officialTradeInForm')[0] : undefined;
                if (nav) {
                    nav.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
                return;
            }

            this.setState({
                errors: [],
                isValid: true
            });

            this.props.onFormSubmit(this.state.inputs);
        }
    }, {
        key: 'buildInput',
        value: function buildInput(input) {
            var _this4 = this;

            var isRequired = true;
            var options = input.options && input.options.map(function (option) {
                if (input.inputType === 'radio') {
                    return _extends({}, option, {
                        label: _react2.default.createElement(
                            'span',
                            null,
                            _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                        ),
                        isRequired: true
                    });
                } else if (input.inputType === 'checkbox') {
                    return _extends({}, option, {
                        isSelected: (0, _lodash.includes)(_this4.state.inputs.partsToReplace, option.value),
                        label: _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                    });
                }

                return _extends({}, option, {
                    label: option.transKey && _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                });
            });

            if (input.name === 'needReparationOtherExplanation' || input.name === 'clarifyAccident') {
                isRequired = false;
            }

            return _react2.default.createElement(
                'div',
                { key: input.name },
                _react2.default.createElement(_widgetCommonsForms.FormBuilder, {
                    inputParams: _extends({}, input, {
                        label: _widgetCommonsCoreServices.LocaleService.t(input.transKey),
                        options: options,
                        value: this.state.inputs[input.name],
                        isRequired: isRequired
                    }),
                    onChange: this.handleInputChange
                }),
                input.subQuestions && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        _reactCollapse2.default,
                        {
                            isOpened: this.state.inputs[input.name] === input.showSubQuestionsValue,
                            springConfig: { stiffness: 200, damping: 30 }
                        },
                        _react2.default.createElement(
                            'div',
                            null,
                            input.subQuestions.map(this.buildInput)
                        )
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isOpen = this.props.isOpen;
            var _state = this.state,
                isValid = _state.isValid,
                errors = _state.errors;

            var inputsCarQuestion = _formInputs2.default.CAR_CONDITION_QUESTION.map(this.buildInput);
            var inputsReparation = this.state.inputs.partsToReplace.length >= 1 && this.state.inputs.partsToReplace[0] !== 'none' && _formInputs2.default.EXPLAIN_REPARATION.map(this.buildInput);
            var inputsCarConditions = _formInputs2.default.CAR_CONDITION.map(this.buildInput);
            var inputsExteriorDommage = this.state.inputs.majorExteriorInteriorDamage && _formInputs2.default.VEHICLE_DAMAGE.map(this.buildInput);

            var formClass = isOpen ? 'officialTradeIn__section carCondition is-open' : 'officialTradeIn__section carCondition is-closed ' + (isValid && 'is-valid');

            var errorBlock = !!errors.length && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: errors });

            var carConditionForm = isOpen && _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    inputsCarQuestion,
                    inputsReparation,
                    inputsCarConditions,
                    inputsExteriorDommage
                ),
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'sr-button-1', onClick: this.sendForm },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.BUTTONS.DONE')
                )
            );
            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement(
                    'h3',
                    { className: 'sr-subtitle-2' },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VEHICLE_INFORMATION.TITLE')
                ),
                errorBlock,
                carConditionForm
            );
        }
    }]);

    return CarCondition;
}(_react.Component);

CarCondition.propTypes = {
    isOpen: _propTypes2.default.bool,
    onFormSubmit: _propTypes2.default.func.isRequired
};

CarCondition.defaultProps = {
    isOpen: true
};

CarCondition.displayName = 'CarCondition';

exports.default = CarCondition;

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarCondition/CarCondition.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarCondition/formInputs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ACCIDENT_QUESTION = [{
    name: 'clarifyAccident',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.CLARIFY_ACCIDENT',
    inputType: 'textarea',
    classNames: 'full'
}, {
    name: 'bodyPartReplaced',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.BODY_PARTS_REPLACED.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'absOperational',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ABS_OPERATIONAL.NO',
        value: false
    }],
    classNames: 'full'
}];

var CAR_CONDITION_QUESTION = [{
    name: 'hadAnAccident',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.NONE',
        value: 'none'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.LESS_THAN_3000',
        value: 'lessThan3000'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.EVER_HAD_AN_ACCIDENT.3000_AND_MORE',
        value: '3000AndMore'
    }],
    classNames: 'full',
    showSubQuestionsValue: '3000AndMore',
    subQuestions: ACCIDENT_QUESTION
}, {
    name: 'airBagsOperational',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.AIR_BAGS_OPERATIONAL.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'modifiedParts',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MODIFIED_PARTS.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'partsToReplace',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.TITLE',
    inputType: 'checkbox',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.NONE',
        value: 'none'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.ENGINE',
        value: 'engine'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.SUSPENSION',
        value: 'suspension'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.TRANSMISSIONS',
        value: 'transmission'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.POWER_TRAIN',
        value: 'powertrain'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.COMPUTER',
        value: 'computer'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.ELECTRICAL',
        value: 'electrical'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.FUEL_OPERATION_SYSTEM',
        value: 'fuelOperationSystem'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.AIR_CONDITIONING_SYSTEM',
        value: 'airConditioningSystem'
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OPTIONS.OTHER',
        value: 'other'
    }],
    classNames: 'full'
}];

var EXPLAIN_REPARATION = [{
    name: 'needReparationOtherExplanation',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.PARTS_TO_REPLACE.OTHER_EXPLANATION',
    inputType: 'textarea',
    classNames: 'full'
}];

var CAR_CONDITION = [{
    name: 'replacedTires',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_TIRES.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'replacedBrakes',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.REPLACED_BRAKES.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'anyScratches',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'damageExceeding3000',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.DAMAGE_EXCEEDING_3000.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.ANY_SCRATCHES.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'majorExteriorInteriorDamage',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_INFORMATION.MAJOR_EXTERIOR_INTERIOR_DAMAGE.NO',
        value: false
    }],
    classNames: 'full'
}];

var VEHICLE_DAMAGE = [{
    name: 'clarifyDamage',
    transKey: 'TRADE_IN.VEHICLE_INFORMATION.CLARIFY_ACCIDENT',
    inputType: 'textarea',
    classNames: 'full'
}];

var carConditionQuestions = {
    CAR_CONDITION: CAR_CONDITION,
    CAR_CONDITION_QUESTION: CAR_CONDITION_QUESTION,
    ACCIDENT_QUESTION: ACCIDENT_QUESTION,
    EXPLAIN_REPARATION: EXPLAIN_REPARATION,
    VEHICLE_DAMAGE: VEHICLE_DAMAGE
};

exports.default = carConditionQuestions;

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarStory/CarStory.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("lodash");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _formInputs = __webpack_require__("./src/components/OfficialTradeInForm/components/CarStory/formInputs.js");

var _formInputs2 = _interopRequireDefault(_formInputs);

var _ShowroomTradeInService = __webpack_require__("./src/services/ShowroomTradeInService/ShowroomTradeInService.js");

var _ShowroomTradeInService2 = _interopRequireDefault(_ShowroomTradeInService);

__webpack_require__("./src/components/OfficialTradeInForm/components/CarStory/CarStory.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CarStory = function (_Component) {
    _inherits(CarStory, _Component);

    function CarStory(props) {
        _classCallCheck(this, CarStory);

        var _this = _possibleConstructorReturn(this, (CarStory.__proto__ || Object.getPrototypeOf(CarStory)).call(this, props));

        _this.state = {
            inputs: {
                originalOwner: '',
                vehiclePurchase: '',
                vehicleCondition: '',
                corporateUse: '',
                corporateUseExplanation: '',
                rustProof: '',
                mechanicalProtection: '',
                coverageBalance: ''
            },
            formValidation: {
                originalOwner: false,
                vehiclePurchase: false,
                vehicleCondition: false,
                corporateUse: false,
                corporateUseExplanation: true,
                rustProof: false,
                mechanicalProtection: false,
                coverageBalance: true
            },
            errors: []
        };

        _this.buildInput = _this.buildInput.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.sendForm = _this.sendForm.bind(_this);
        _this.validateForm = _this.validateForm.bind(_this);
        return _this;
    }

    _createClass(CarStory, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _ShowroomTradeInService2.default.fetchTradeIn().then(function (tradeIn) {
                if (tradeIn && tradeIn.evaluationQuestion) {
                    _this2.setState({
                        inputs: _extends({}, tradeIn.evaluationQuestion.carStory)
                    }, _this2.validateForm);
                }
            });
            _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.OFFICIAL_TRADEIN_CAR_STORY());
        }
    }, {
        key: 'validateForm',
        value: function validateForm() {
            var _this3 = this;

            var formValidation = this.state.formValidation;


            (0, _lodash.forOwn)(formValidation, function (value, key) {
                var fieldRequireValidation = key === 'corporateUseExplanation' && _this3.state.inputs.corporateUse || key === 'coverageBalance' && _this3.state.inputs.mechanicalProtection || key !== 'coverageBalance' && key !== 'corporateUseExplanation';

                if (fieldRequireValidation) {
                    var stateValue = _this3.state.inputs[key];
                    formValidation[key] = (0, _lodash.isBoolean)(stateValue) || _widgetCommonsForms.ValidationService.validateIsNotEmpty(stateValue);
                } else {
                    formValidation[key] = true;
                }
            });

            this.setState({ formValidation: formValidation });
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(value, name) {
            var nextState = this.state;

            nextState.inputs[name] = value;
            nextState.formValidation[name] = true;

            this.setState(nextState, this.validateForm);
        }
    }, {
        key: 'sendForm',
        value: function sendForm(event) {
            event.preventDefault();
            if (!_widgetCommonsForms.ValidationService.validateForm(this.state.formValidation)) {
                this.setState({
                    errors: [{
                        message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VEHICLE_STORY.ERROR'),
                        code: 'error.missing_inputs',
                        group: 'carStory'
                    }]
                });
                var nav = _widgetCommonsCoreServices.WindowProxy.get().document.getElementsByClassName('officialTradeInForm') ? _widgetCommonsCoreServices.WindowProxy.get().document.getElementsByClassName('officialTradeInForm')[0] : undefined;
                if (nav) {
                    nav.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
                return;
            }

            this.setState({
                errors: []
            });

            var data = _extends({}, this.state.inputs);
            this.props.onFormSubmit(data);
        }
    }, {
        key: 'buildInput',
        value: function buildInput(input) {
            var options = input.options && input.options.map(function (option) {
                return _extends({}, option, {
                    label: _react2.default.createElement(
                        'span',
                        null,
                        _widgetCommonsCoreServices.LocaleService.t(option.transKey)
                    ),
                    isRequired: true
                });
            });

            return _react2.default.createElement(
                'div',
                { key: input.name },
                _react2.default.createElement(_widgetCommonsForms.FormBuilder, {
                    inputParams: _extends({}, input, {
                        label: _widgetCommonsCoreServices.LocaleService.t(input.transKey),
                        options: options,
                        value: this.state.inputs[input.name],
                        isValid: this.state.formValidation[input.name]
                    }),
                    onChange: this.handleInputChange
                }),
                input.subQuestions && this.state.inputs[input.name] && input.subQuestions.map(this.buildInput)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isOpen = this.props.isOpen;

            var inputs = (0, _lodash.map)(_formInputs2.default, this.buildInput);

            var formClass = isOpen ? 'officialTradeIn__section carStory is-open' : 'officialTradeIn__section carStory is-closed is-valid';

            var errorBlock = !!this.state.errors.length && _react2.default.createElement(_widgetCommonsForms.ErrorsHandler, { errors: this.state.errors });

            var carStoryForm = isOpen && _react2.default.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                inputs,
                _react2.default.createElement(
                    'button',
                    { type: 'button', className: 'sr-button-1', onClick: this.sendForm },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.BUTTONS.NEXT')
                )
            );

            return _react2.default.createElement(
                'div',
                { className: formClass },
                _react2.default.createElement(
                    'p',
                    { className: 'sr-text is-bold' },
                    _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VEHICLE_STORY.TITLE')
                ),
                errorBlock,
                carStoryForm
            );
        }
    }]);

    return CarStory;
}(_react.Component);

CarStory.propTypes = {
    isOpen: _propTypes2.default.bool,
    onFormSubmit: _propTypes2.default.func.isRequired
};

CarStory.defaultProps = {
    isOpen: true
};

CarStory.displayName = 'CarStory';

exports.default = CarStory;

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarStory/CarStory.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/OfficialTradeInForm/components/CarStory/formInputs.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    name: 'originalOwner',
    transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.ORIGINAL_OWNER.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'vehiclePurchase',
    transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.PRIVATE',
        value: 'private'
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_PURCHASE.DEALER',
        value: 'dealer'
    }],
    classNames: 'full'
}, {
    name: 'vehicleCondition',
    transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.PERFECT_VALUE',
        value: 'perfect'
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.OK_VALUE',
        value: 'ok'
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.VEHICLE_CONDITION.ROUGH_VALUE',
        value: 'rough'
    }],
    classNames: 'full'
}, {
    name: 'corporateUse',
    transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.NO',
        value: false
    }],
    classNames: 'full',
    subQuestions: [{
        name: 'corporateUseExplanation',
        transKey: 'TRADE_IN.VEHICLE_STORY.CORPORATE_USE.EXPLANATION',
        inputType: 'textarea',
        classNames: 'full'
    }]
}, {
    name: 'rustProof',
    transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.RUST_PROOF.NO',
        value: false
    }],
    classNames: 'full'
}, {
    name: 'mechanicalProtection',
    transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.TITLE',
    inputType: 'radio',
    options: [{
        transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.YES',
        value: true
    }, {
        transKey: 'TRADE_IN.VEHICLE_STORY.MECHANICAL_PROTECTION.NO',
        value: false
    }],
    classNames: 'full',
    subQuestions: [{
        name: 'coverageBalance',
        transKey: 'TRADE_IN.VEHICLE_STORY.COVERAGE_BALANCE',
        inputType: 'textarea',
        classNames: 'full'
    }]
}];

/***/ }),

/***/ "./src/components/OfficialTradeInModal/OfficialTradeInModal.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MODAL_NAME = undefined;

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _OfficialTradeInWrapper = __webpack_require__("./src/components/OfficialTradeInWrapper/OfficialTradeInWrapper.jsx");

var _OfficialTradeInWrapper2 = _interopRequireDefault(_OfficialTradeInWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODAL_NAME = 'trade-in-official-modal';

var OfficialTradeInModal = function OfficialTradeInModal(_ref) {
    var _onClose = _ref.onClose,
        openModal = _ref.openModal,
        tradeInVehicle = _ref.tradeInVehicle,
        quote = _ref.quote;

    var modal = _widgetCommonsGeneral.ModalService.get(MODAL_NAME);
    if (openModal && !modal.isOpen()) {
        modal.open();
    }
    modal.addCallbacks({
        onClose: function onClose() {
            _onClose();
            return true;
        }
    });
    return _react2.default.createElement(
        _widgetCommonsGeneral.WhiteModal,
        {
            name: MODAL_NAME,
            contentLabel: 'trade-in-official-modal-label',
            dataTestPrefix: 'trade-in.official-modal',
            isScrollable: true,
            isClosable: true
        },
        _react2.default.createElement(_OfficialTradeInWrapper2.default, { isRenderedInModal: true, tradeInVehicle: tradeInVehicle, quote: quote })
    );
};

OfficialTradeInModal.defaultProps = {
    openModal: false,
    quote: null
};

OfficialTradeInModal.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    openModal: _propTypes2.default.bool,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel)
};

OfficialTradeInModal.displayName = 'OfficialTradeInModal';
exports.MODAL_NAME = MODAL_NAME;
exports.default = OfficialTradeInModal;

/***/ }),

/***/ "./src/components/OfficialTradeInWrapper/OfficialTradeInWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _noop = __webpack_require__("../../node_modules/lodash/noop.js");

var _noop2 = _interopRequireDefault(_noop);

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _VehicleForm = __webpack_require__("./src/components/VehicleForm/VehicleForm.jsx");

var _VehicleForm2 = _interopRequireDefault(_VehicleForm);

var _ConfirmationStep = __webpack_require__("./src/components/ConfirmationStep/ConfirmationStep.jsx");

var _ConfirmationStep2 = _interopRequireDefault(_ConfirmationStep);

var _OfficialTradeInForm = __webpack_require__("./src/components/OfficialTradeInForm/OfficialTradeInForm.jsx");

var _OfficialTradeInForm2 = _interopRequireDefault(_OfficialTradeInForm);

__webpack_require__("./src/components/OfficialTradeInWrapper/OfficialTradeInWrapper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfficialTradeInWrapper = function (_Component) {
    _inherits(OfficialTradeInWrapper, _Component);

    function OfficialTradeInWrapper(props) {
        _classCallCheck(this, OfficialTradeInWrapper);

        var _this = _possibleConstructorReturn(this, (OfficialTradeInWrapper.__proto__ || Object.getPrototypeOf(OfficialTradeInWrapper)).call(this, props));

        _this.state = {
            isScreenLock: false,
            quote: props.quote,
            tradeInVehicle: props.tradeInVehicle,
            tradeInValues: {
                low: 0,
                high: 0,
                amount: 0
            }
        };

        _this.loadQuote = _this.loadQuote.bind(_this);
        _this.toggleScreenLock = _this.toggleScreenLock.bind(_this);
        _this.allStepCompleted = _this.allStepCompleted.bind(_this);
        _this.updateQuoteRevision = _this.updateQuoteRevision.bind(_this);
        _this.updateTradeInVehicle = _this.updateTradeInVehicle.bind(_this);

        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
        return _this;
    }

    _createClass(OfficialTradeInWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadQuote();
        }
    }, {
        key: 'getSteps',
        value: function getSteps() {
            var _this2 = this;

            var steps = [];

            steps.push(function (_ref) {
                var goNextStep = _ref.goNextStep;
                return _react2.default.createElement(_VehicleForm2.default, {
                    lockScreen: _this2.toggleScreenLock,
                    quote: _this2.state.quote,
                    onFormSubmit: function onFormSubmit(data) {
                        return _this2.setState(data, goNextStep);
                    },
                    onTradeInVehicleUpdated: _this2.updateTradeInVehicle,
                    useCBB: false,
                    isOfficialTradeIn: true,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    loadQuote: _this2.loadQuote
                });
            });

            steps.push(function (_ref2) {
                var goNextStep = _ref2.goNextStep;
                return _react2.default.createElement(_OfficialTradeInForm2.default, {
                    quote: _this2.state.quote,
                    updateQuoteRevision: _this2.updateQuoteRevision,
                    onFormCompletion: goNextStep,
                    tradeInValues: _this2.state.tradeInValues,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    tradeInId: _this2.state.tradeInVehicle.id,
                    leadId: _this2.state.leadId,
                    loadQuote: _this2.loadQuote
                });
            });

            steps.push(function () {
                return _react2.default.createElement(_ConfirmationStep2.default, {
                    isRenderedInModal: _this2.props.isRenderedInModal,
                    onTradeInSuccess: function onTradeInSuccess() {
                        return _this2.props.onTradeInSuccess(_this2.state.quote);
                    }
                });
            });

            return steps;
        }
    }, {
        key: 'updateQuoteRevision',
        value: function updateQuoteRevision(updatedQuotes) {
            var _this3 = this;

            if (this.state.quote) {
                var updatedQuote = updatedQuotes.find(function (quote) {
                    return quote.id === _this3.state.quote.id;
                });
                if (updatedQuote) {
                    this.setState(function (prevState) {
                        return {
                            quote: prevState.quote.set('revision', updatedQuote.__revision || updatedQuote.revision)
                        };
                    });
                }
            }
        }
    }, {
        key: 'updateTradeInVehicle',
        value: function updateTradeInVehicle(tradeInVehicle, onStateSet) {
            this.setState(function (oldState) {
                return _extends({}, oldState, { tradeInVehicle: tradeInVehicle });
            }, onStateSet);
        }
    }, {
        key: 'toggleScreenLock',
        value: function toggleScreenLock() {
            this.setState(function (prevState) {
                return { isScreenLock: !prevState.isScreenLock };
            });
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote() {
            var _this4 = this;

            var quoteId = _widgetCommonsCoreServices.UrlService.getUrlParameter('quoteId');
            var writeToken = _widgetCommonsCoreServices.UrlService.getUrlParameter('writeToken');
            if (quoteId) {
                _widgetCommonsVehicle.ShowroomService.loadQuote(quoteId).then(function (quote) {
                    if (writeToken) {
                        _this4.setState({ quote: quote.set('securityToken', writeToken) });
                    } else {
                        _this4.setState({ quote: quote });
                    }
                }).catch(function (error) {
                    _this4.logger.error('OfficialTradeInWrapper#loadQuote error', error);
                });
            }
        }
    }, {
        key: 'allStepCompleted',
        value: function allStepCompleted() {
            return Object.values(this.state.completedSteps).every(function (step) {
                return step;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'OfficialTradeIn__wrapper' },
                _react2.default.createElement(
                    _widgetCommonsGeneral.LoaderFullScreen,
                    { show: this.state.isScreenLock, message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.SCREEN_LOCKED') },
                    _react2.default.createElement(_widgetCommonsForms.Wizard, { steps: this.getSteps() })
                )
            );
        }
    }]);

    return OfficialTradeInWrapper;
}(_react.Component);

OfficialTradeInWrapper.defaultProps = {
    quote: null,
    onTradeInSuccess: _noop2.default
};

OfficialTradeInWrapper.propTypes = {
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel),
    isRenderedInModal: _propTypes2.default.bool.isRequired,
    onTradeInSuccess: _propTypes2.default.func
};

OfficialTradeInWrapper.displayName = 'OfficialTradeInWrapper';

exports.default = OfficialTradeInWrapper;

/***/ }),

/***/ "./src/components/OfficialTradeInWrapper/OfficialTradeInWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInBarWrapper/TradeInBarWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _InstantEstimate = __webpack_require__("./src/components/InstantEstimate/InstantEstimate.jsx");

var _InstantEstimate2 = _interopRequireDefault(_InstantEstimate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TradeInBarWrapper = function TradeInBarWrapper(_ref) {
    var style = _ref.style,
        isShowroomV2Enabled = _ref.isShowroomV2Enabled,
        quote = _ref.quote;

    var czHasCbb = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.tradein', 'widget.tradein.hascbb');
    if (!czHasCbb || czHasCbb && czHasCbb.getValue() !== 'true') {
        return null;
    }
    return _react2.default.createElement(
        'div',
        { id: 'instant-estimate-bar-wrapper', style: style },
        _react2.default.createElement(_InstantEstimate2.default, {
            parentElementId: 'instant-estimate-bar-wrapper',
            isShowroomV2Enabled: isShowroomV2Enabled,
            quote: quote
        })
    );
};

TradeInBarWrapper.defaultProps = {
    style: {},
    isShowroomV2Enabled: false
};

TradeInBarWrapper.propTypes = {
    style: _propTypes2.default.objectOf(_propTypes2.default.string),
    isShowroomV2Enabled: _propTypes2.default.bool,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel).isRequired
};

TradeInBarWrapper.displayName = 'TradeInBarWrapper';

exports.default = TradeInBarWrapper;

/***/ }),

/***/ "./src/components/TradeInCta/TradeInCta.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.advisorAppointment = exports.redirectToHomepage = exports.closeModal = undefined;

__webpack_require__("./src/components/TradeInCta/TradeInCta.scss");

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _TradeInCtaItem = __webpack_require__("./src/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.jsx");

var _TradeInCtaItem2 = _interopRequireDefault(_TradeInCtaItem);

var _lodash = __webpack_require__("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
var SignInModal = _widgetCommonsGeneral.ModalService.get('login/SignInModal');
var SaveConfirmationModal = _widgetCommonsGeneral.ModalService.get('login/SaveConfirmationModal');
var TradeInModal = _widgetCommonsGeneral.ModalService.get('trade-in-estimate-modal');
var OfficialTradeInModal = _widgetCommonsGeneral.ModalService.get('trade-in-official-modal');

var closeModal = function closeModal() {
    TradeInModal.close();
};

var redirectToHomepage = function redirectToHomepage() {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy) {
        windowProxy.location.assign(_widgetCommonsGeneral.REDIRECTIONS[_widgetCommonsCoreServices.LocaleService.getSimpleLocale()].homepage);
    }
};

var advisorAppointment = function advisorAppointment() {
    var windowProxy = _widgetCommonsCoreServices.WindowProxy.get();
    if (windowProxy) {
        windowProxy.location.assign(_widgetCommonsGeneral.REDIRECTIONS[_widgetCommonsCoreServices.LocaleService.getSimpleLocale()].advisorAppointment);
    }
};

var TradeInCta = function TradeInCta(_ref) {
    var isOfficialTradeInActivated = _ref.isOfficialTradeInActivated,
        isRenderedInModal = _ref.isRenderedInModal,
        isShowroomV2Enabled = _ref.isShowroomV2Enabled,
        saveTradeIn = _ref.saveTradeIn,
        account = _ref.account,
        goToOfficialTradeInForm = _ref.goToOfficialTradeInForm;

    var loginToSave = function loginToSave() {
        [SignUpModal, SignInModal, SaveConfirmationModal].forEach(function (modal) {
            modal.addCallbacks({
                onClose: function onClose() {
                    saveTradeIn();
                    return true;
                }
            });
        });
        SignUpModal.open({ context: 'widget.login.signup.information', account: account, hasConfirmation: true });
        TradeInModal.close();
    };

    var loginToOfficialize = function loginToOfficialize() {
        if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
            [SignUpModal, SignInModal].forEach(function (modal) {
                modal.addCallbacks({
                    onClose: function onClose() {
                        if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                            OfficialTradeInModal.open();
                        }
                        return true;
                    }
                });
            });
            TradeInModal.close();
            SignUpModal.open({ context: 'widget.login.signup.information', account: account });
        } else if (goToOfficialTradeInForm) {
            goToOfficialTradeInForm();
        } else {
            TradeInModal.close();
            OfficialTradeInModal.open();
        }
    };

    var ctaOfficialValueContent = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.tradein', 'cta.official.value') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.tradein', 'cta.official.value').getValue() : '<ul>\n        <li>' + _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.OFFICIAL.DEFAULT_1') + '</li>\n        <li>' + _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.OFFICIAL.DEFAULT_2') + '</li>\n        </ul>';

    var wrapper = _react2.default.createElement(
        'div',
        { className: 'TradeInCta__wrapper' },
        isOfficialTradeInActivated && _react2.default.createElement(
            'h1',
            { className: 'sr-subtitle-1 is-centered' },
            !_widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.LOGGED_OUT_TITLE') : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.LOGGED_IN_TITLE')
        ),
        _react2.default.createElement(
            'div',
            { className: 'TradeInCta__content' },
            isShowroomV2Enabled && !_widgetCommonsGeneral.AccountService.isAuthenticated() && _react2.default.createElement(_TradeInCtaItem2.default, {
                classesName: ['sr-button-2', 'save-estimate'],
                dataTest: 'trade-in.trade-in-cta.save-trade-in',
                onClick: loginToSave,
                buttonText: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.SAVE_TRADE_IN_VALUE'),
                content: ''
            }),
            _widgetCommonsGeneral.AccountService.isAuthenticated() && _react2.default.createElement(_TradeInCtaItem2.default, {
                classesName: ['sr-button-2'],
                dataTest: 'trade-in.trade-in-cta.dealership-evaluation',
                onClick: advisorAppointment,
                buttonText: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.IN_PERSON'),
                content: ''
            }),
            isOfficialTradeInActivated && _react2.default.createElement(_TradeInCtaItem2.default, {
                classesName: ['sr-button-1', 'get-official'],
                dataTest: 'trade-in.trade-in-cta.get-official-trade-in',
                onClick: loginToOfficialize,
                buttonText: !_widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.OFFICIAL.LOGGED_OUT_TITLE') : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.OFFICIAL.LOGGED_IN_TITLE'),
                content: { __html: ctaOfficialValueContent }
            })
        ),
        isShowroomV2Enabled && _react2.default.createElement(
            'p',
            { className: 'sr-disclaimer is-centered is-light fineprint' },
            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.DISCLAIMER')
        ),
        _react2.default.createElement(
            'button',
            {
                className: 'sr-link continue-shopping',
                onClick: isRenderedInModal ? closeModal : redirectToHomepage,
                dataTest: 'trade-in.trade-in-cta.continue-shopping'
            },
            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CTA.BACK_TO_SHOP.TITLE')
        )
    );
    return wrapper;
};

TradeInCta.defaultProps = {
    saveTradeIn: _lodash.noop,
    account: new _widgetCommonsGeneral.Account()
};

TradeInCta.propTypes = {
    isOfficialTradeInActivated: _propTypes2.default.bool.isRequired,
    isRenderedInModal: _propTypes2.default.bool.isRequired,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired,
    saveTradeIn: _propTypes2.default.func,
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account),
    goToOfficialTradeInForm: _propTypes2.default.func.isRequired
};

TradeInCta.displayName = 'TradeInCta';
exports.closeModal = closeModal;
exports.redirectToHomepage = redirectToHomepage;
exports.advisorAppointment = advisorAppointment;
exports.default = TradeInCta;

/***/ }),

/***/ "./src/components/TradeInCta/TradeInCta.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__("./src/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.scss");

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TradeInCtaItem = function TradeInCtaItem(_ref) {
    var classesName = _ref.classesName,
        dataTest = _ref.dataTest,
        onClick = _ref.onClick,
        buttonText = _ref.buttonText,
        content = _ref.content;

    var classes = classesName.join(' ');

    var wrapper = _react2.default.createElement(
        'div',
        { className: 'TradeInCtaItem__wrapper is-light is-small', 'data-test': dataTest },
        _react2.default.createElement(
            'button',
            { className: 'is-wide ' + classes, onClick: onClick },
            buttonText
        ),
        /* fprovost: Hiding the description until the part 2 of the trade-in. @see https://jira.sm360.ca/browse/SHOWROOM-3106 */
        false && _react2.default.createElement('div', { className: 'TradeInCtaItem__list', dangerouslySetInnerHTML: content })
    );
    return wrapper;
};

TradeInCtaItem.defaultProps = {
    dataTest: ''
};

TradeInCtaItem.propTypes = {
    classesName: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    dataTest: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    buttonText: _propTypes2.default.string.isRequired,
    content: _propTypes2.default.string.isRequired
};

TradeInCtaItem.displayName = 'TradeInCtaItem';

exports.default = TradeInCtaItem;

/***/ }),

/***/ "./src/components/TradeInCta/TradeInCtaItem/TradeInCtaItem.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInTiles/TradeInTiles.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _TradeInTile = __webpack_require__("./src/components/TradeInTiles/components/TradeInTile/TradeInTile.jsx");

var _TradeInTile2 = _interopRequireDefault(_TradeInTile);

__webpack_require__("./src/components/TradeInTiles/TradeInTiles.scss");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _Quote = __webpack_require__("../widget-commons-vehicle/src/Quote/index.js");

var _OfficialTradeIn = __webpack_require__("./src/components/OfficialTradeIn/OfficialTradeIn.jsx");

var _OfficialTradeIn2 = _interopRequireDefault(_OfficialTradeIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TradeInTiles = function TradeInTiles(_ref) {
    var descriptions = _ref.descriptions,
        title = _ref.title,
        isShowroomV2Enabled = _ref.isShowroomV2Enabled,
        tradeInTileContent = _ref.tradeInTileContent,
        quote = _ref.quote;

    var trackEvaluateVehicleCta = function trackEvaluateVehicleCta() {
        return _widgetCommonsGeneral.AnalyticsService.gaTrigger(_widgetCommonsGeneral.TRACKING_TAGS.EVALUATE_MY_VEHICLE_CTA(quote.vehicle.model));
    };
    var czHasCbb = _widgetCommonsCoreServices.ContentZonesService.getContentZone('widget.tradein', 'widget.tradein.hascbb');
    var hasCBB = czHasCbb && czHasCbb.getValue() === 'true';
    var instantEstimate = isShowroomV2Enabled && tradeInTileContent && hasCBB;

    return _react2.default.createElement(
        'div',
        { className: 'tradeInTiles--section' },
        _react2.default.createElement(
            'div',
            { className: 'tradeInTiles--title' },
            _react2.default.createElement(
                'p',
                { className: 'sr-title-2 is-centered' },
                title
            ),
            _react2.default.createElement(
                'p',
                { className: 'sr-subtitle-2 is-centered' },
                descriptions
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'tradeInTiles--content' },
            instantEstimate ? _react2.default.createElement(_TradeInTile2.default, { tileContent: tradeInTileContent, isShowroomV2Enabled: isShowroomV2Enabled }) : _react2.default.createElement(_OfficialTradeIn2.default, { quote: quote }),
            _react2.default.createElement(_TradeInTile2.default, { onClick: trackEvaluateVehicleCta })
        )
    );
};

TradeInTiles.defaultProps = {
    tradeInTileContent: null
};

TradeInTiles.propTypes = {
    descriptions: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    tradeInTileContent: _propTypes2.default.element,
    isShowroomV2Enabled: _propTypes2.default.bool.isRequired,
    quote: _propTypes2.default.instanceOf(_Quote.QuoteModel).isRequired
};

TradeInTiles.displayName = 'TradeInTiles';

exports.default = TradeInTiles;

/***/ }),

/***/ "./src/components/TradeInTiles/TradeInTiles.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInTiles/components/TradeInTile/TradeInTile.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

__webpack_require__("./src/components/TradeInTiles/components/TradeInTile/TradeInTile.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TradeInTile = function TradeInTile(_ref) {
    var tileContent = _ref.tileContent,
        onClick = _ref.onClick;

    var SignUpModal = _widgetCommonsGeneral.ModalService.get('login/SignUpModal');
    var SignInModal = _widgetCommonsGeneral.ModalService.get('login/SignInModal');
    var OfficialTradeInModal = _widgetCommonsGeneral.ModalService.get('trade-in-official-modal');

    var imagesServer = _index2.default.source.image;
    var czGroup = 'widget.tradein.teaser';

    var estimateIcon = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon').getValue() : imagesServer + '/images/widget/showroom/asset/estimate-value-teaser.png';

    var officialIcon = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon.official') && _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'icon.official').getValue();

    var defaultStyleBackgroundColor = '#CD1122';
    var defaultStyleTextColor = '#ffffff';

    var styleBackground = {
        backgroundImage: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'pattern') && 'url(' + _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'pattern').getValue() + ')',
        backgroundColor: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.background.color').getValue() : defaultStyleBackgroundColor
    };
    var estimateTitle = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.title') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.title').getValue() : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE_TILE.TITLE');

    var estimateSubtitle = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'instant.estimate.subtitle').getValue() : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE_TILE.SUBTITLE');

    var styleTextColor = {
        color: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.text.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'primary.text.color').getValue() : defaultStyleTextColor
    };
    var styleTagLineColor = {
        color: _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'tagline.text.color') ? _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'tagline.text.color').getValue() : defaultStyleTextColor
    };

    var loginToOfficialize = function loginToOfficialize() {
        onClick();
        if (!_widgetCommonsGeneral.AccountService.isAuthenticated()) {
            [SignUpModal, SignInModal].forEach(function (modal) {
                modal.addCallbacks({
                    onClose: function onClose() {
                        if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                            OfficialTradeInModal.open();
                        }
                        return true;
                    }
                });
            });
            SignUpModal.open({ context: 'widget.login.signup.information' });
        } else {
            OfficialTradeInModal.open();
        }
    };
    var blockContent = tileContent ? _react2.default.createElement(
        'div',
        { style: styleBackground, className: 'TradeInTile--content-estimate' },
        _react2.default.createElement(
            'div',
            { className: 'TradeInTile--content-estimate-text' },
            _react2.default.createElement('img', { src: estimateIcon, alt: 'test' }),
            _react2.default.createElement(
                'p',
                { style: styleTagLineColor, className: 'sr-text is-small' },
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ESTIMATE_TILE.TAGLINE')
            ),
            _react2.default.createElement(
                'div',
                { className: 'TradeInTile--content-estimate-title' },
                _react2.default.createElement(
                    'p',
                    { style: styleTextColor, className: 'sr-subtitle-2 is-centered' },
                    estimateTitle
                ),
                _react2.default.createElement(
                    'p',
                    { style: styleTextColor, className: 'sr-text is-small' },
                    estimateSubtitle
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'TradeInTile--content-estimate-input' },
            tileContent
        )
    ) : _react2.default.createElement(
        'div',
        { className: 'TradeInTile--content-official' },
        _react2.default.createElement('img', { src: officialIcon, alt: 'test' }),
        _react2.default.createElement(
            'div',
            { className: 'TradeInTile--content-official-title' },
            _react2.default.createElement(
                'p',
                { className: 'sr-subtitle-2 is-centered' },
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.OFFICIAL_TILE.TITLE')
            ),
            _react2.default.createElement(
                'p',
                { className: 'TradeInTile--content-official-subtitle is-small' },
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.OFFICIAL_TILE.SUBTITLE')
            )
        ),
        _react2.default.createElement(
            'button',
            { className: 'sr-button-1 is-small', onClick: loginToOfficialize },
            _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.OFFICIAL_TILE.CTA')
        )
    );

    return _react2.default.createElement(
        'div',
        { className: 'TradeInTile--block' },
        blockContent
    );
};

TradeInTile.defaultProps = {
    tileContent: null,
    onClick: _lodash.noop
};

TradeInTile.propTypes = {
    tileContent: _propTypes2.default.element,
    onClick: _propTypes2.default.func
};

TradeInTile.displayName = 'TradeInTile';

exports.default = TradeInTile;

/***/ }),

/***/ "./src/components/TradeInTiles/components/TradeInTile/TradeInTile.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInValueSuccess/TradeInValueSuccess.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

__webpack_require__("./src/components/TradeInValueSuccess/TradeInValueSuccess.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TradeInValueSuccess = function TradeInValueSuccess() {
    return _react2.default.createElement(
        'div',
        { className: 'confirm_tradein--wrapper' },
        _react2.default.createElement(
            'div',
            { className: 'confirm_tradein--icon' },
            _react2.default.createElement('icon', { className: 'icon-Crochet' })
        ),
        _react2.default.createElement(
            'div',
            { className: 'confirm_tradein--content' },
            _react2.default.createElement(
                'p',
                { className: 'confirm_tradein--title sr-text is-bold' },
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONGRATS')
            ),
            _react2.default.createElement(
                'p',
                null,
                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.GUEST_USER_SUCCESS')
            )
        )
    );
};

TradeInValueSuccess.displayName = 'TradeInValueSuccess';

exports.default = TradeInValueSuccess;

/***/ }),

/***/ "./src/components/TradeInValueSuccess/TradeInValueSuccess.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/TradeInWrapper/TradeInWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _noop = __webpack_require__("../../node_modules/lodash/noop.js");

var _noop2 = _interopRequireDefault(_noop);

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _LoginStep = __webpack_require__("./src/components/LoginStep/LoginStep.jsx");

var _LoginStep2 = _interopRequireDefault(_LoginStep);

var _VehicleForm = __webpack_require__("./src/components/VehicleForm/VehicleForm.jsx");

var _VehicleForm2 = _interopRequireDefault(_VehicleForm);

var _ConfirmationStep = __webpack_require__("./src/components/ConfirmationStep/ConfirmationStep.jsx");

var _ConfirmationStep2 = _interopRequireDefault(_ConfirmationStep);

var _CanadianBlackBookEstimate = __webpack_require__("./src/components/CanadianBlackBookEstimate/CanadianBlackBookEstimate.jsx");

var _CanadianBlackBookEstimate2 = _interopRequireDefault(_CanadianBlackBookEstimate);

var _ShowroomTradeInService = __webpack_require__("./src/services/ShowroomTradeInService/ShowroomTradeInService.js");

var _ShowroomTradeInService2 = _interopRequireDefault(_ShowroomTradeInService);

var _OfficialTradeInForm = __webpack_require__("./src/components/OfficialTradeInForm/OfficialTradeInForm.jsx");

var _OfficialTradeInForm2 = _interopRequireDefault(_OfficialTradeInForm);

var _TradeInModel = __webpack_require__("./src/model/TradeInModel.js");

var _TradeInModel2 = _interopRequireDefault(_TradeInModel);

var _TradeInService = __webpack_require__("./src/services/TradeInService/TradeInService.js");

var _TradeInService2 = _interopRequireDefault(_TradeInService);

__webpack_require__("./src/components/TradeInWrapper/TradeInWrapper.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PurchaseMethodsActions = _widgetCommonsVehicle.PurchaseMethods.PurchaseMethodsActions;

var TradeInWrapper = function (_Component) {
    _inherits(TradeInWrapper, _Component);

    function TradeInWrapper(props) {
        _classCallCheck(this, TradeInWrapper);

        var _this = _possibleConstructorReturn(this, (TradeInWrapper.__proto__ || Object.getPrototypeOf(TradeInWrapper)).call(this, props));

        _this.state = {
            isScreenLock: false,
            account: props.account,
            quote: props.quote,
            tradeInVehicle: {
                id: '',
                make: '',
                model: '',
                trim: '',
                style: '',
                year: '',
                exteriorColor: '',
                odometer: ''
            },
            tradeInValues: {
                low: 0,
                high: 0,
                amount: 0
            }
        };

        _this.loadQuote = _this.loadQuote.bind(_this);
        _this.toggleScreenLock = _this.toggleScreenLock.bind(_this);
        _this.onLoginStepDone = _this.onLoginStepDone.bind(_this);
        _this.allStepCompleted = _this.allStepCompleted.bind(_this);
        _this.updateQuoteRevision = _this.updateQuoteRevision.bind(_this);
        _this.updateTradeInVehicle = _this.updateTradeInVehicle.bind(_this);

        _this.handleCBBEstimateChange = _this.handleCBBEstimateChange.bind(_this);

        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
        return _this;
    }

    _createClass(TradeInWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadQuote();
            if (this.props.isOfficialTradeIn) {
                _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.OFFICIAL_TRADEIN());
            }
        }
    }, {
        key: 'onLoginStepDone',
        value: function onLoginStepDone(account) {
            if (account) {
                this.setState({ account: account });
            }
        }
    }, {
        key: 'getSteps',
        value: function getSteps() {
            var _this2 = this;

            var steps = [];

            steps.push(function (_ref) {
                var goNextStep = _ref.goNextStep;
                return _react2.default.createElement(_LoginStep2.default, {
                    account: _this2.state.account,
                    stepDone: function stepDone(account) {
                        _this2.onLoginStepDone(account);
                        goNextStep();
                    },
                    isRenderedInModal: _this2.props.isRenderedInModal
                });
            });

            steps.push(function (_ref2) {
                var goNextStep = _ref2.goNextStep;
                return _react2.default.createElement(_VehicleForm2.default, {
                    isRenderedInModal: _this2.props.isRenderedInModal,
                    lockScreen: _this2.toggleScreenLock,
                    quote: _this2.state.quote,
                    onFormSubmit: function onFormSubmit(data) {
                        return _this2.setState(data, goNextStep);
                    },
                    onTradeInVehicleUpdated: _this2.updateTradeInVehicle,
                    useCBB: _this2.props.useCBB,
                    isOfficialTradeIn: _this2.props.isOfficialTradeIn,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    loadQuote: _this2.loadQuote
                });
            });

            if (!this.props.isOfficialTradeIn && this.props.useCBB) {
                steps.push(function (_ref3) {
                    var goPreviousStep = _ref3.goPreviousStep,
                        goNextStep = _ref3.goNextStep;
                    return _react2.default.createElement(_CanadianBlackBookEstimate2.default, {
                        tradeInVehicle: _this2.state.tradeInVehicle,
                        goToOfficialTradeInForm: goNextStep,
                        backToVehicleForm: goPreviousStep,
                        tradeInValues: _this2.state.tradeInValues,
                        handleEstimateChange: _this2.handleCBBEstimateChange,
                        isOfficialTradeInActivated: true,
                        isRenderedInModal: _this2.props.isRenderedInModal
                    });
                });
            }

            steps.push(function (_ref4) {
                var goNextStep = _ref4.goNextStep;
                return _react2.default.createElement(_OfficialTradeInForm2.default, {
                    quote: _this2.state.quote,
                    updateQuoteRevision: _this2.updateQuoteRevision,
                    onFormCompletion: goNextStep,
                    tradeInValues: _this2.state.tradeInValues,
                    tradeInVehicle: _this2.state.tradeInVehicle,
                    tradeInId: _this2.state.tradeInVehicle.id,
                    leadId: _this2.state.leadId,
                    loadQuote: _this2.loadQuote
                });
            });

            steps.push(function () {
                return _react2.default.createElement(_ConfirmationStep2.default, { onTradeInSuccess: function onTradeInSuccess() {
                        return _this2.props.onTradeInSuccess(_this2.state.quote);
                    } });
            });

            return steps;
        }
    }, {
        key: 'updateQuoteRevision',
        value: function updateQuoteRevision(updatedQuotes) {
            var _this3 = this;

            if (this.state.quote) {
                var updatedQuote = updatedQuotes.find(function (quote) {
                    return quote.id === _this3.state.quote.id;
                });
                if (updatedQuote) {
                    this.setState(function (prevState) {
                        return {
                            quote: prevState.quote.set('revision', updatedQuote.__revision || updatedQuote.revision)
                        };
                    });
                }
            }
        }
    }, {
        key: 'updateTradeInVehicle',
        value: function updateTradeInVehicle(tradeInVehicle, onStateSet) {
            this.setState(function (oldState) {
                return _extends({}, oldState, { tradeInVehicle: tradeInVehicle });
            }, onStateSet);
        }
    }, {
        key: 'toggleScreenLock',
        value: function toggleScreenLock() {
            this.setState(function (prevState) {
                return { isScreenLock: !prevState.isScreenLock };
            });
        }
    }, {
        key: 'loadQuote',
        value: function loadQuote() {
            var _this4 = this;

            var quoteId = _widgetCommonsCoreServices.UrlService.getUrlParameter('quoteId');
            var writeToken = _widgetCommonsCoreServices.UrlService.getUrlParameter('writeToken');
            if (quoteId) {
                _widgetCommonsVehicle.ShowroomService.loadQuote(quoteId).then(function (quote) {
                    if (writeToken) {
                        _this4.setState({ quote: quote.set('securityToken', writeToken) });
                    } else {
                        _this4.setState({ quote: quote });
                    }
                }).catch(function (error) {
                    _this4.logger.error('TradeInWrapper#loadQuote error', error);
                });
            }
        }
    }, {
        key: 'handleCBBEstimateChange',
        value: function handleCBBEstimateChange(tradeInValue) {
            var _this5 = this;

            PurchaseMethodsActions.setTradeIn(tradeInValue);

            return _ShowroomTradeInService2.default.fetchTradeIn().then(function (tradeIn) {
                return new _TradeInModel2.default(_extends({}, tradeIn, {
                    leadId: _this5.state.leadId,
                    tradeInVehicle: _this5.state.tradeInVehicle,
                    estimation: {
                        amount: tradeInValue,
                        high: _this5.state.tradeInValues.high,
                        low: _this5.state.tradeInValues.low
                    }
                }));
            }).then(function (tradeInToSave) {
                return _TradeInService2.default.saveTradeIn(tradeInToSave, _this5.props.quote);
            }).then(function () {
                _this5.loadQuote();
            }).catch(function (e) {
                _this5.logger.error('An error happened while saving the showroom tradeIn value', e);
                return Promise.reject(e);
            });
        }
    }, {
        key: 'allStepCompleted',
        value: function allStepCompleted() {
            return Object.values(this.state.completedSteps).every(function (step) {
                return step;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var startingStepIndex = _widgetCommonsGeneral.AccountService.isAuthenticated() ? 1 : 0;

            return _react2.default.createElement(
                'div',
                { className: 'TradeIn__wrapper' },
                _react2.default.createElement(
                    _widgetCommonsGeneral.LoaderFullScreen,
                    { show: this.state.isScreenLock, message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.SCREEN_LOCKED') },
                    _react2.default.createElement(_widgetCommonsForms.Wizard, { steps: this.getSteps(), onStepTransition: function onStepTransition() {}, startingStepIndex: startingStepIndex })
                )
            );
        }
    }]);

    return TradeInWrapper;
}(_react.Component);

TradeInWrapper.defaultProps = {
    quote: null,
    account: null,
    onTradeInSuccess: _noop2.default
};

TradeInWrapper.propTypes = {
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account),
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel),
    useCBB: _propTypes2.default.bool.isRequired,
    isOfficialTradeIn: _propTypes2.default.bool.isRequired,
    isRenderedInModal: _propTypes2.default.bool.isRequired,
    onTradeInSuccess: _propTypes2.default.func
};

TradeInWrapper.displayName = 'TradeInWrapper';

exports.default = TradeInWrapper;

/***/ }),

/***/ "./src/components/TradeInWrapper/TradeInWrapper.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/VehicleForm/VehicleForm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _propTypes = __webpack_require__("../../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("react");

var _react2 = _interopRequireDefault(_react);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsForms = __webpack_require__("@sm360/widget-commons-forms");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsBasicComponents = __webpack_require__("@sm360/widget-commons-basic-components");

var _CBBAutoComplete = __webpack_require__("./src/components/CBBAutoComplete/CBBAutoComplete.jsx");

var _CBBAutoComplete2 = _interopRequireDefault(_CBBAutoComplete);

var _ShowroomCBBService = __webpack_require__("./src/services/ShowroomCBBService/ShowroomCBBService.js");

var _ShowroomCBBService2 = _interopRequireDefault(_ShowroomCBBService);

var _ShowroomTradeInService = __webpack_require__("./src/services/ShowroomTradeInService/ShowroomTradeInService.js");

var _ShowroomTradeInService2 = _interopRequireDefault(_ShowroomTradeInService);

var _TradeInVehicleMapperService = __webpack_require__("./src/services/TradeInVehicleMapperService/TradeInVehicleMapperService.js");

var _TradeInVehicleMapperService2 = _interopRequireDefault(_TradeInVehicleMapperService);

var _TradeInModel = __webpack_require__("./src/model/TradeInModel.js");

var _TradeInModel2 = _interopRequireDefault(_TradeInModel);

var _TradeInService = __webpack_require__("./src/services/TradeInService/TradeInService.js");

var _TradeInService2 = _interopRequireDefault(_TradeInService);

var _slider = __webpack_require__("./src/constants/slider.js");

var _slider2 = _interopRequireDefault(_slider);

__webpack_require__("./src/components/VehicleForm/VehicleForm.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fieldValidations = {
    odometer: _widgetCommonsForms.ValidationService.validateOdometer,
    vin: _widgetCommonsForms.ValidationService.optional(_widgetCommonsForms.ValidationService.validateVin),
    year: _widgetCommonsForms.ValidationService.validateYear
};

var czGroup = 'widget.tradein.teaser';

var VehicleForm = function (_Component) {
    _inherits(VehicleForm, _Component);

    function VehicleForm(props) {
        _classCallCheck(this, VehicleForm);

        var _this = _possibleConstructorReturn(this, (VehicleForm.__proto__ || Object.getPrototypeOf(VehicleForm)).call(this, props));

        _this.state = {
            formValidation: {
                make: false,
                model: false,
                year: false,
                exteriorColor: false,
                odometer: false,
                trim: false,
                vin: true,
                identityGroup: false
            },
            cbbAutocompleteValues: [],
            hasBeenSubmitted: false,
            autoCompleteValue: '',
            tradeInVehicle: props.tradeInVehicle,
            account: props.account,
            displaySubmitError: false,
            displayCheckInfoMessage: false
        };

        _this.createLeadTradeIn = _this.createLeadTradeIn.bind(_this);
        _this.dispatchTradeInCreatedEvent = _this.dispatchTradeInCreatedEvent.bind(_this);
        _this.fetchEstimation = _this.fetchEstimation.bind(_this);
        _this.fillAutoCompleteValueFromTradeInVehicle = _this.fillAutoCompleteValueFromTradeInVehicle.bind(_this);
        _this.getIdentityForm = _this.getIdentityForm.bind(_this);
        _this.getVehicleForm = _this.getVehicleForm.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleTradeInChange = _this.handleTradeInChange.bind(_this);
        _this.isFieldValid = _this.isFieldValid.bind(_this);
        _this.onAutoCompleteSelect = _this.onAutoCompleteSelect.bind(_this);
        _this.onIdentityGroupChange = _this.onIdentityGroupChange.bind(_this);
        _this.sendTradeIn = _this.sendTradeIn.bind(_this);
        _this.validateVehicleInformationForm = _this.validateVehicleInformationForm.bind(_this);

        _this.logger = new _loggerSentry2.default(_this.constructor.displayName, _widgetCommonsCoreServices.ConfigsService.getLoggerContext());

        _this.cbbAutoCompleteRef = null;
        _this.sendingTradeIn = false;
        return _this;
    }

    _createClass(VehicleForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (_widgetCommonsGeneral.AccountService.isAuthenticated() && this.props.autofillTradeInVehicleFromAccount) {
                this.getAccountTradeIn();
            }
            this.fillAutoCompleteValueFromTradeInVehicle();
            if (!this.props.isOfficialTradeIn) {
                _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.ESTIMATED_TRADEIN_VEHICLE());
            } else {
                _widgetCommonsGeneral.AnalyticsService.virtualPageView(_widgetCommonsGeneral.VIRTUAL_PAGEVIEWS.OFFICIAL_TRADEIN_VEHICLE_FORM());
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.tradeInVehicle !== this.state.tradeInVehicle) {
                this.fillAutoCompleteValueFromTradeInVehicle(newProps.tradeInVehicle);
            }
        }
    }, {
        key: 'onIdentityGroupChange',
        value: function onIdentityGroupChange(groupResponse) {
            var _this2 = this;

            this.setState({
                account: groupResponse.value,
                formValidation: _extends({}, this.state.formValidation, { identityGroup: groupResponse.valid })
            }, function () {
                return _this2.props.updateAccount(groupResponse.value);
            });
        }
    }, {
        key: 'onAutoCompleteSelect',
        value: function onAutoCompleteSelect(autoCompleteValue, selectedValue) {
            var _this3 = this;

            var tradeInVehicle = null;
            if (selectedValue) {
                tradeInVehicle = _extends({}, selectedValue, {
                    exteriorColor: this.state.tradeInVehicle.exteriorColor,
                    odometer: String(this.state.tradeInVehicle.odometer)
                });
            } else {
                tradeInVehicle = {
                    exteriorColor: this.state.tradeInVehicle.exteriorColor,
                    odometer: String(this.state.tradeInVehicle.odometer)
                };
            }

            this.setState({ autoCompleteValue: autoCompleteValue, tradeInVehicle: tradeInVehicle }, function () {
                _this3.props.onTradeInVehicleUpdated(tradeInVehicle);
            });
        }
    }, {
        key: 'getAccountTradeIn',
        value: function getAccountTradeIn() {
            var _this4 = this;

            _ShowroomTradeInService2.default.fetchTradeIn().then(function (tradeIn) {
                var vehicle = tradeIn.vehicle;


                if (vehicle && !(0, _lodash.isEmpty)(vehicle)) {
                    var tradeInVehicle = _TradeInVehicleMapperService2.default.vehicleToTradeInVehicle(vehicle);
                    _this4.setState(function (oldState) {
                        return _extends({}, oldState, { tradeInVehicle: tradeInVehicle });
                    }, function () {
                        return _this4.fillAutoCompleteValueFromTradeInVehicle(tradeInVehicle);
                    });
                }
            });
        }
    }, {
        key: 'getVehicleDetailsFields',
        value: function getVehicleDetailsFields(useCBB, isOfficial) {
            var _this5 = this;

            return useCBB && !isOfficial ? _react2.default.createElement(
                'div',
                { className: 'trade-in-form--autocomplete', key: 'vehicle-form' },
                _react2.default.createElement(_CBBAutoComplete2.default, {
                    value: this.state.autoCompleteValue,
                    onValueSelected: this.onAutoCompleteSelect,
                    dataTestPrefix: 'trade-in.vehicle-form',
                    ref: function ref(element) {
                        _this5.cbbAutoCompleteRef = element;
                    }
                })
            ) : _react2.default.createElement(
                'div',
                { key: 'vehicle-form' },
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.YEAR'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.YEAR'),
                    name: 'year',
                    type: 'number',
                    value: this.state.tradeInVehicle.year,
                    classNames: ['styled-placeholder quarter'],
                    isValid: this.state.formValidation.year,
                    isRequired: true,
                    valueChange: this.handleTradeInChange,
                    hasBeenSubmit: this.state.hasBeenSubmitted,
                    dataTest: 'trade-in.vehicle-form.year',
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.YEAR_MAX
                }),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.MAKE'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.MAKE'),
                    name: 'make',
                    type: 'text',
                    value: this.state.tradeInVehicle.make,
                    classNames: ['styled-placeholder triple-quarter'],
                    isValid: this.state.formValidation.make,
                    isRequired: true,
                    valueChange: this.handleTradeInChange,
                    hasBeenSubmit: this.state.hasBeenSubmitted,
                    dataTest: 'trade-in.vehicle-form.make',
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.MAKE_MAX
                }),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.MODEL'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.MODEL'),
                    name: 'model',
                    type: 'text',
                    value: this.state.tradeInVehicle.model,
                    classNames: ['styled-placeholder half'],
                    isValid: this.state.formValidation.model,
                    isRequired: true,
                    valueChange: this.handleTradeInChange,
                    hasBeenSubmit: this.state.hasBeenSubmitted,
                    dataTest: 'trade-in.vehicle-form.model',
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.MODEL_MAX
                }),
                _react2.default.createElement(_widgetCommonsForms.InputText, {
                    label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TRIM'),
                    errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.TRIM'),
                    name: 'trim',
                    type: 'text',
                    value: this.state.tradeInVehicle.trim,
                    classNames: ['styled-placeholder half'],
                    isValid: this.state.formValidation.trim,
                    isRequired: true,
                    valueChange: this.handleTradeInChange,
                    hasBeenSubmit: this.state.hasBeenSubmitted,
                    dataTest: 'trade-in.vehicle-form.trim',
                    maxLength: _widgetCommonsForms.FIELD_LENGTH.TRIM_MAX
                })
            );
        }
    }, {
        key: 'getVehicleForm',
        value: function getVehicleForm() {
            var vehicleColorMileageFields = [_react2.default.createElement(_widgetCommonsForms.InputText, {
                key: 'exteriorColor',
                label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.COLOR'),
                errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.COLOR'),
                name: 'exteriorColor',
                type: 'text',
                value: this.state.tradeInVehicle.exteriorColor,
                classNames: ['styled-placeholder half'],
                isValid: this.state.formValidation.exteriorColor,
                isRequired: true,
                valueChange: this.handleTradeInChange,
                hasBeenSubmit: this.state.hasBeenSubmitted,
                dataTest: 'trade-in.vehicle-form.exterior-color',
                maxLength: _widgetCommonsForms.FIELD_LENGTH.COLOR_MAX
            }), _react2.default.createElement(_widgetCommonsForms.InputText, {
                key: 'odometer',
                label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.MILEAGE'),
                errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.MILLEAGE'),
                name: 'odometer',
                type: 'number',
                min: 0,
                maxLength: _widgetCommonsForms.FIELD_LENGTH.ODOMETER_MAX,
                value: this.state.tradeInVehicle.odometer,
                classNames: ['styled-placeholder half'],
                isValid: this.state.formValidation.odometer,
                isRequired: true,
                valueChange: this.handleTradeInChange,
                hasBeenSubmit: this.state.hasBeenSubmitted,
                dataTest: 'trade-in.vehicle-form.odometer'
            })];
            var vinField = _react2.default.createElement(_widgetCommonsForms.InputText, {
                label: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.VIN'),
                errorLabel: _widgetCommonsCoreServices.LocaleService.t('COMMONS_FORMS.ERRORS.VIN'),
                name: 'vin',
                type: 'text',
                value: this.state.tradeInVehicle.vin,
                classNames: ['styled-placeholder full'],
                isValid: this.state.formValidation.vin,
                valueChange: this.handleTradeInChange,
                hasBeenSubmit: this.state.hasBeenSubmitted,
                dataTest: 'trade-in.vehicle-form.vin',
                minLength: _widgetCommonsForms.FIELD_LENGTH.VIN_MIN,
                maxLength: _widgetCommonsForms.FIELD_LENGTH.VIN_MAX
            });

            var vehicleFormFields = [this.getVehicleDetailsFields(this.props.useCBB, this.props.isOfficialTradeIn)].concat(vehicleColorMileageFields);

            if (!this.props.useCBB || this.props.isOfficialTradeIn) {
                vehicleFormFields.push(vinField);
            }

            return vehicleFormFields;
        }
    }, {
        key: 'getIdentityForm',
        value: function getIdentityForm() {
            return _react2.default.createElement(_widgetCommonsForms.Groups.IdentityGroup, {
                values: this.state.account,
                labels: {
                    firstname: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONTACT.FIRST_NAME'),
                    lastname: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONTACT.LAST_NAME'),
                    phoneNumber: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONTACT.PHONE_NUMBER'),
                    email: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONTACT.EMAIL')
                },
                onChange: this.onIdentityGroupChange,
                hasBeenSubmit: this.state.hasBeenSubmitted,
                dataTestPrefix: 'trade-in.vehicle-form'
            });
        }
    }, {
        key: 'fillAutoCompleteValueFromTradeInVehicle',
        value: function fillAutoCompleteValueFromTradeInVehicle(updatedVehicle) {
            var _this6 = this;

            var tradeInVehicle = updatedVehicle || this.state.tradeInVehicle;

            if (!(0, _lodash.isEmpty)(tradeInVehicle)) {
                this.setState(function (oldState) {
                    return _extends({}, oldState, {
                        tradeInVehicle: tradeInVehicle,
                        autoCompleteValue: tradeInVehicle.id,
                        displayCheckInfoMessage: true
                    });
                }, function () {
                    _this6.validateVehicleInformationForm(tradeInVehicle);
                    _this6.props.onTradeInVehicleUpdated(tradeInVehicle);
                });
            }
        }
    }, {
        key: 'validateVehicleInformationForm',
        value: function validateVehicleInformationForm(vehicle) {
            var _this7 = this;

            var formValidation = _extends({}, this.state.formValidation);
            (0, _lodash.forOwn)(formValidation, function (isValid, key) {
                if (key !== 'identityGroup') {
                    formValidation[key] = _this7.isFieldValid(vehicle[key], key);
                }
            });
            this.setState({ formValidation: formValidation });
        }
    }, {
        key: 'isFieldValid',
        value: function isFieldValid(value, name) {
            return fieldValidations[name] ? fieldValidations[name](value) : _widgetCommonsForms.ValidationService.validateIsNotEmpty(value);
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
        }
    }, {
        key: 'handleTradeInChange',
        value: function handleTradeInChange(value, name) {
            var tradeInVehicle = this.state.tradeInVehicle;

            tradeInVehicle[name] = ['year', 'odometer'].includes(name) ? parseInt(value, 10) : value;

            this.setState({
                tradeInVehicle: tradeInVehicle,
                formValidation: _extends({}, this.state.formValidation, _defineProperty({}, name, this.isFieldValid(value, name)))
            }, this.props.onTradeInVehicleUpdated(tradeInVehicle));
        }
    }, {
        key: 'isAutocompleteFormValid',
        value: function isAutocompleteFormValid(state) {
            return Promise.resolve(this.cbbAutoCompleteRef ? this.cbbAutoCompleteRef.validateInput() : true).then(function (isAutoCompleteValid) {
                return isAutoCompleteValid && !!state.autoCompleteValue && !!state.tradeInVehicle.exteriorColor && !!state.tradeInVehicle.odometer && !!state.formValidation.identityGroup;
            });
        }
    }, {
        key: 'sendTradeIn',
        value: function sendTradeIn() {
            var _this8 = this;

            // Allow sending only one trade-in at a time. Flag is reset after trade-in has been sent or validation has failed.
            if (this.sendingTradeIn) {
                return Promise.resolve();
            }
            this.sendingTradeIn = true;

            return Promise.resolve(this.props.useCBB && !this.props.isOfficialTradeIn ? this.isAutocompleteFormValid(this.state) : _widgetCommonsForms.ValidationService.validateForm(this.state.formValidation)).then(function (isFormValid) {
                if (!isFormValid) {
                    _this8.setState({
                        hasBeenSubmitted: true
                    });
                    return false;
                }

                var tradeInVehicle = _this8.state.tradeInVehicle;

                _this8.props.lockScreen();

                return _this8.fetchEstimation(tradeInVehicle).then(function (estimation) {
                    return _this8.createLeadTradeIn(estimation, tradeInVehicle).then(function (tradeInModel) {
                        return Promise.all([estimation, tradeInModel]);
                    });
                }).then(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        estimation = _ref2[0],
                        tradeInModel = _ref2[1];

                    _this8.dispatchTradeInCreatedEvent();
                    _this8.props.lockScreen();

                    var data = _extends({}, _this8.state, {
                        leadId: tradeInModel.leadId,
                        tradeInValues: estimation
                    });

                    _this8.props.onTradeInVehicleUpdated(tradeInVehicle, function () {
                        return _this8.props.onFormSubmit(data);
                    });
                    _this8.setState({ displaySubmitError: false });
                    return Promise.resolve();
                }).catch(function (e) {
                    _this8.logger.error('TradeIn#handleFormSubmit Promise.all error', e);
                    _this8.props.lockScreen();

                    _this8.setState({ displaySubmitError: true });
                    return Promise.reject(e);
                });
            }).finally(function () {
                _this8.sendingTradeIn = false;
            });
        }
    }, {
        key: 'dispatchTradeInCreatedEvent',
        value: function dispatchTradeInCreatedEvent() {
            var $window = _widgetCommonsCoreServices.WindowProxy.get();
            if ($window) {
                $window.document.dispatchEvent(new Event(_widgetCommonsGeneral.EVENTS.TRADEIN_CREATED));
            }
        }
    }, {
        key: 'fetchEstimation',
        value: function fetchEstimation(vehicle) {
            var _this9 = this;

            if (!this.props.useCBB || this.props.isOfficialTradeIn) {
                return Promise.resolve(null);
            }

            return _ShowroomCBBService2.default.fetchEstimation(vehicle).then(function (_ref3) {
                var low = _ref3.low,
                    high = _ref3.high,
                    taxesFactor = _ref3.taxesFactor;

                var averageValue = Math.round(low + (high - low) / 2);
                var roundedAverageValue = Math.floor(averageValue / _slider2.default.STEP_VALUE) * _slider2.default.STEP_VALUE;

                var estimation = {
                    amount: roundedAverageValue,
                    high: high,
                    low: low,
                    taxesFactor: taxesFactor
                };

                return Promise.resolve(estimation);
            }).catch(function (e) {
                _this9.logger.error('TradeIn#fetchEstimation error', e, vehicle);
                return Promise.reject(e);
            });
        }
    }, {
        key: 'createLeadTradeIn',
        value: function createLeadTradeIn(estimation, tradeInVehicle) {
            var _this10 = this;

            if (!tradeInVehicle) {
                return Promise.reject(new Error('Missing [tradeInVehicle] argument'));
            }

            var fetchTradeInPromise = _widgetCommonsGeneral.AccountService.isAuthenticated() ? _ShowroomTradeInService2.default.fetchTradeIn() : Promise.resolve({});

            return fetchTradeInPromise.then(function (tradeIn) {
                var tradeInToSave = new _TradeInModel2.default(_extends({}, tradeIn, {
                    tradeInVehicle: tradeInVehicle,
                    estimation: estimation,
                    profile: _this10.state.account
                }));

                return _TradeInService2.default.saveTradeIn(tradeInToSave, _this10.props.quote).then(function (tradeInModel) {
                    return tradeInModel;
                }).catch(function (e) {
                    _this10.logger.error('An error happened while saving the showroom tradeIn value', e);
                    return Promise.reject(e);
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var descriptionImageContentZone = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'description.image');
            var descriptionAltContentZone = _widgetCommonsCoreServices.ContentZonesService.getContentZone(czGroup, 'description.image.alt');

            var buttonLabel = 'TRADE_IN.GET_YOUR_VALUE';
            if (_widgetCommonsGeneral.AccountService.isAuthenticated) {
                buttonLabel = this.props.isOfficialTradeIn ? 'TRADE_IN.GET_OFFICIAL_VALUE' : 'TRADE_IN.GET_ESTIMATE_VALUE';
            }

            return _react2.default.createElement(
                'div',
                { className: 'vehicle-form' },
                _react2.default.createElement(
                    'div',
                    { className: 'vehicle-form-title' },
                    _react2.default.createElement(
                        'p',
                        { className: 'is-price' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TITLES.TOP_DOLLAR')
                    ),
                    _react2.default.createElement(
                        'h2',
                        { className: 'sr-subtitle-1', 'data-test': 'vehicle-form_title' },
                        this.props.isOfficialTradeIn ? _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TITLES.GET_OFFICIAL') : _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TITLES.GET_ESTIMATE')
                    ),
                    this.props.isOfficialTradeIn && this.state.displayCheckInfoMessage && _react2.default.createElement(
                        'h3',
                        { className: 'sr-text' },
                        _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.TITLES.CHECK_INFORMATIONS')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'vehicle-form-body' },
                    _react2.default.createElement(
                        'form',
                        { className: 'trade-in-form', onSubmit: this.handleSubmit },
                        _react2.default.createElement(
                            'div',
                            { className: 'trade-in-cta' },
                            this.state.displaySubmitError && _react2.default.createElement(_widgetCommonsBasicComponents.MessageBox, { level: 'error', message: _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.ERROR') })
                        ),
                        _react2.default.createElement(
                            'section',
                            { className: 'clearfix vehicle-form-body--vehicle-details' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'sr-text' },
                                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.FORM_TITLE')
                            ),
                            this.getVehicleForm()
                        ),
                        _react2.default.createElement(
                            'section',
                            { className: 'clearfix' },
                            _react2.default.createElement(
                                'h3',
                                { className: 'sr-text' },
                                _widgetCommonsCoreServices.LocaleService.t('TRADE_IN.CONTACT.TITLE')
                            ),
                            this.getIdentityForm()
                        ),
                        _react2.default.createElement(
                            'section',
                            { className: 'clearfix', 'data-test': 'trade-in.vehicle-form.submit' },
                            _react2.default.createElement(
                                'div',
                                { className: 'trade-in-cta' },
                                _react2.default.createElement(
                                    'button',
                                    { className: 'sr-button-1 is-uppercase', type: 'submit', onClick: this.sendTradeIn },
                                    _widgetCommonsCoreServices.LocaleService.t(buttonLabel)
                                )
                            )
                        )
                    ),
                    !this.props.isOfficialTradeIn && descriptionImageContentZone && _react2.default.createElement(
                        'div',
                        { className: 'trade-in-talktrack' },
                        _react2.default.createElement('img', {
                            src: descriptionImageContentZone.getValue(),
                            alt: descriptionAltContentZone.getValue()
                        })
                    )
                )
            );
        }
    }]);

    return VehicleForm;
}(_react.Component);

VehicleForm.defaultProps = {
    autofillTradeInVehicleFromAccount: true,
    quote: null,
    updateAccount: _lodash.noop,
    account: new _widgetCommonsGeneral.Account()
};

VehicleForm.propTypes = {
    autofillTradeInVehicleFromAccount: _propTypes2.default.bool,
    lockScreen: _propTypes2.default.func.isRequired,
    onFormSubmit: _propTypes2.default.func.isRequired,
    onTradeInVehicleUpdated: _propTypes2.default.func.isRequired,
    quote: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Quote.QuoteModel),
    useCBB: _propTypes2.default.bool.isRequired,
    isOfficialTradeIn: _propTypes2.default.bool.isRequired,
    tradeInVehicle: _propTypes2.default.instanceOf(_widgetCommonsVehicle.Vehicle.TradeInVehicleModel).isRequired,
    updateAccount: _propTypes2.default.func,
    account: _propTypes2.default.instanceOf(_widgetCommonsGeneral.Account)
};

VehicleForm.displayName = 'VehicleForm';

exports.default = VehicleForm;

/***/ }),

/***/ "./src/components/VehicleForm/VehicleForm.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/config/dev.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://service.backbones.widget-supplier.dev.office.n360.io","account":"https://service.backbones.account.dev.office.n360.io/api","showroom":"https://dev-api.showroom360.ca:9443","authentication":"https://service.authentication.dev.office.n360.io","leadSubmission":"https://service.lead-submission.dev.office.n360.io","graphql":"https://service.backbones.webauto-supplier.dev.office.n360.io/webauto/graphql"},"source":{"image":"http://img-dev.sm360.ca","widget":"https://service.backbones.widget-supplier.dev.office.n360.io/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-dev-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-dev-cdn.sm360.ca).*$"]},"secrets":{"authentication":"452e9145-29ab-4275-bca9-fa8ba7ae19d9"}}

/***/ }),

/***/ "./src/config/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dev = __webpack_require__("./src/config/dev.json");

var _dev2 = _interopRequireDefault(_dev);

var _int = __webpack_require__("./src/config/int.json");

var _int2 = _interopRequireDefault(_int);

var _local = __webpack_require__("./src/config/local.json");

var _local2 = _interopRequireDefault(_local);

var _prod = __webpack_require__("./src/config/prod.json");

var _prod2 = _interopRequireDefault(_prod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {};

if (true) {
    config = _prod2.default;
} else if (process.env.BUILD_ENV === 'development') {
    config = _dev2.default;
} else if (process.env.BUILD_ENV === 'integration') {
    config = _int2.default;
} else {
    config = _local2.default;
}

exports.default = _extends({}, config);

/***/ }),

/***/ "./src/config/int.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service-lead-submission-int.sm360.ca","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"33934e6c-d3ba-41c1-b62f-334dee5f8d8f"}}

/***/ }),

/***/ "./src/config/local.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget-int.sm360.ca","account":"https://account-int.sm360.ca/api","showroom":"https://int-api.showroom360.ca:8443","authentication":"https://service-authentication-int.sm360.ca","leadSubmission":"https://service-lead-submission-int.sm360.ca","graphql":"https://webauto-supplier-api-int.sm360.ca/webauto/graphql"},"source":{"image":"http://img-int.sm360.ca","widget":"https://widget-int.sm360.ca/client"},"secureCookies":false,"sentry":{"url":"","sentryLevel":"NONE","consoleLevel":"DEBUG","whitelistUrls":["^.*(widgets-int-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-int-cdn.sm360.ca).*$"]},"secrets":{"authentication":"452e9145-29ab-4275-bca9-fa8ba7ae19d9"}}

/***/ }),

/***/ "./src/config/prod.json":
/***/ (function(module, exports) {

module.exports = {"endpoint":{"widget":"https://widget.sm360.ca","account":"https://account.sm360.ca/api","showroom":"https://api.showroom360.ca","authentication":"https://service-authentication.sm360.ca","leadSubmission":"https://service-lead-submission.sm360.ca","graphql":"https://webauto-supplier-api.sm360.ca/webauto/graphql"},"source":{"image":"https://img.sm360.ca","widget":"https://widget.sm360.ca/client"},"secureCookies":true,"sentry":{"url":"","sentryLevel":"WARNING","consoleLevel":"ERROR","whitelistUrls":["^.*(widgets-cdn.sm360.ca).*$"],"includePaths":["^.*(widgets-cdn.sm360.ca).*$"]},"secrets":{"authentication":"6524a774-d33b-47c4-9f13-ea2ad2fb12ee"}}

/***/ }),

/***/ "./src/constants/slider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    STEP_VALUE: 25
};

/***/ }),

/***/ "./src/i18n/en.json":
/***/ (function(module, exports) {

module.exports = {"TRADE_IN":{"NON_AVAILABLE":"N/A","ODOMETER":{"SYMBOL":"Km"},"APPLY_TO_QUOTE":"Apply to your transaction","BUTTONS":{"DONE":"Done","NEXT":"Next"},"COLOR":"Colour","CONTACT":{"EMAIL":"Email","FIRST_NAME":"First Name","LAST_NAME":"Last Name","PHONE_NUMBER":"Phone Number","TITLE":"Your Information"},"ERROR":"Sorry something went wrong. Please try again.","FORM_TITLE":"What Are You Driving Now?","GET_YOUR_VALUE":"Get your trade-in value","MAKE":"Make","MILEAGE":"Mileage","MODEL":"Model","QUICK":"Take 5 minutes now","GET_ESTIMATE_VALUE":"Get My Estimate","GET_OFFICIAL_VALUE":"Get My Official Evaluation","CONGRATS":"Congratulations","GUEST_USER_SUCCESS":"Your trade-in appraisal has been sent. We will reach you as fast as we can.","TITLE":"Evaluate Your Trade-In","AUTOCOMPLETE_CAR":"Type Your Year, Make, Model","TRIM":"Trim","VIN":"Vehicle Identification Number (VIN) - optional","YEAR":"Year","CONDITION":{"TITLE":{"FAIR":"Fair Condition","GOOD":"Good Condition","VERYGOOD":"Very Good Condition","EXCELLENT":"Excellent Condition"},"CONTENT":{"FAIR":"Has Some mechanical or cosmetic defects","GOOD":"Free of mechanical problems but may need some reconditioning","VERYGOOD":"This vehicle has minor wear or visible defects","EXCELLENT":"This vehicle looks brand new and doesn't have any mechanical problems"}},"ESTIMATE":{"VALUE":{"LOW":{"TITLE":"LOW Value","DESCRIPTION":"Your vehicle will need to be reconditionned cosmetically and mechanically to give it that new-to-you feeling for the next buyer."},"HIGH":{"TITLE":"HIGH Value","DESCRIPTION":"Your vehicle is near-perfect with no exterior blemishes or interior wear or odours. Mechanically, nothing would be required to sell it."}},"TITLE":"Set Your Own Estimate","MODIFY":"Edit","ERROR":{"TITLE":"An Error Has Occurred With Your Estimate","TEXT":"Please contact us","CTA":"Change my vehicle"},"YOUR_ESTIMATE":"Your Estimate","WHAT_IT_MEANS":"Tell Me More","POWERED_BY":"Powered By","INFO_OFFICIAL":"Your estimate is saved. To continue, you will need to obtain your vehicle’s official value to continue your transaction."},"VEHICLE_NAME":"%{year} %{make} %{model} %{modelTrim} %{modelTrimStyle}","ESTIMATE_TITLE":"Your Vehicle Trade-In Value Estimate Range","ESTIMATE_SUBTITLE":"Powered by Canadian Black Book","OFFICIAL_TITLE":"Get an Official Trade-In Value","TAX_SAVINGS":{"ESTIMATE":"Your Estimate","TAX_SAVINGS":"Tax Savings","RESULT":"You Can Get Up To:","LOGGED_OUT_DISCLAIMER":"Please note that the trade-in value is presented only as a guideline and does not represent an official evaluation.","LOGGED_IN_DISCLAIMER":"Your estimate is saved. To continue, you will need to obtain your vehicle’s official value to continue your transaction.","MAY_CONTACT_FOR_INFO":"We may contact you to obtain more information about your vehicle.","MOBILE":"%{estimate} (Estimate) + %{tax} (Tax Savings) = %{total}"},"CTA":{"LOGGED_OUT_TITLE":"What Would You like to Do?","LOGGED_IN_TITLE":"Two Ways to Get Your Vehicle’s Official Value","DISCLAIMER":"Please note that prior to the delivery of your vehicle, a visual inspection will be done to confirm the condition and information of the vehicle.","OFFICIAL":{"LOGGED_OUT_TITLE":"Get the Official Evaluation","LOGGED_IN_TITLE":"Online Evaluation","DEFAULT_1":"Fill the condition report","DEFAULT_2":"Save time","KEEP_BROWSING":"Keep Browsing"},"BACK_TO_SHOP":{"TITLE":"Keep Browsing","DEFAULT_1":"You will receive a confirmation email shortly","DEFAULT_2":"Get an official appraisal later"},"SAVE_TRADE_IN_VALUE":"Save My Estimate","IN_PERSON":"In Person Evaluation"},"OFFICIALEVALUATION":{"ESTIMATE_DONE":{"TITLE":"I Got My Estimate","SUBTITLE":"Now I Want To:"},"TITLE":"Get an Official Trade-In Appraisal","NEEDS":{"TITLE":"You Will Need:","PHOTOS":"Attach Pictures","VIN":"Fill the condition report","READY":"Get an Official Value","SAVE_TIME":"Save time","MOVE_TO_OFFICIAL":"Move to official when ready"},"CTA":"Get My Official Evaluation"},"BACK_TO_SHOPPING":{"TITLE":"Back to<br />Shopping","DESCRIPTION":"Apply your trade-in value in your transactions and continue shopping for the perfect car.","CTA":"Continue Shopping"},"TEASER":{"ESTIMATE_TITLE":"Estimate Your Trade-In Value","ESTIMATE_SUBTITLE":"Based on Thousand of Vehicles in Canada"},"VEHICLE_INFORMATION":{"ABS_OPERATIONAL":{"TITLE":"Is the ABS Operational?","YES":"Yes","NO":"No"},"ACCIDENT_OVER_3000":{"TITLE":"Have You Ever Had Been in Any Accidents Exceeding $3000?","YES":"Yes","NO":"No"},"AIR_BAGS_OPERATIONAL":{"TITLE":"Are All Air Bags Operational?","YES":"Yes","NO":"No"},"AIR_CONDTIONING_REPAIRS":{"TITLE":"Have Any Body Parts Been Replaced, Repaired or Repainted?","YES":"Yes","NO":"No"},"ANY_SCRATCHES":{"TITLE":"Are There Any Scratches, Chips or Cracks of Any Size on the Windshield?","YES":"Yes","NO":"No"},"BODY_PARTS_REPLACED":{"TITLE":"Have Any Body Parts Been Replaced, Repaired or Repainted?","YES":"Yes","NO":"No"},"CLARIFY_ACCIDENT":"Please Clarify","DAMAGE_EXCEEDING_3000":{"TITLE":"Has Your Vehicle Required Repairs Exceeding $3,000?","YES":"Yes","NO":"No"},"ERROR":"Please fill in all the fields.","EVER_HAD_AN_ACCIDENT":{"TITLE":"Have You Ever Had an Accident With Your Vehicle?","NONE":"None","3000_AND_MORE":"$3000 and more","LESS_THAN_3000":"Less than $3000"},"MAJOR_EXTERIOR_INTERIOR_DAMAGE":{"TITLE":"Is There Any Damage on the Exterior or Interior of the Vehicle That Is Greater Than the Size of a Loonie?","YES":"Yes","NO":"No"},"MODIFIED_PARTS":{"TITLE":"Has the Vehicle Been Modified, Including Badging or Decals, from Its Original Specifications?","YES":"Yes","NO":"No"},"PARTS_TO_REPLACE":{"TITLE":"Select Which Parts Need to Be Replaced","OPTIONS":{"NONE":"None","ENGINE":"Engine","SUSPENSION":"Suspension","TRANSMISSIONS":"Transmission","POWER_TRAIN":"Powertrain","COMPUTER":"Computer Equipment","ELECTRICAL":"Electrical","FUEL_OPERATION_SYSTEM":"Fuel Operation System","AIR_CONDITIONING_SYSTEM":"Air Conditioning System","OTHER":"Other"},"OTHER_EXPLANATION":"Please Clarify"},"REPLACED_BRAKES":{"TITLE":"Have You Replaced the Brakes Lately?","YES":"Yes","NO":"No"},"REPLACED_TIRES":{"TITLE":"Have You Replaced the Tires Lately?","YES":"Yes","NO":"No"},"TITLE":"Tell Us About Your Vehicle Condition"},"VEHICLE_STORY":{"CORPORATE_USE":{"TITLE":"Has the Vehicle Been Used as a Taxi, Emergency Vehicle or Was Leased on a Regular Basis?","YES":"Yes","NO":"No","EXPLANATION":"Please Explain in Details"},"COVERAGE_BALANCE":"Coverage Balance","ERROR":"Please fill in all the fields.","MECHANICAL_PROTECTION":{"TITLE":"Is This Vehicle Still Covered by a Mechanical Protection?","YES":"Yes","NO":"No"},"ORIGINAL_OWNER":{"TITLE":"Are You the Original Owner?","YES":"Yes","NO":"No"},"RUST_PROOF":{"TITLE":"Has the Vehicle Been Treated for Rust?","YES":"Yes","NO":"No"},"TITLE":"Tell Us About Your Vehicle History","VEHICLE_CONDITION":{"TITLE":"What Is the Condition of the Vehicle","OK_VALUE":"Ok","OK_TOOLTIP":"My vehicle is starting to look old and has a few bumps and scratches.","PERFECT_VALUE":"Perfect","PERFECT_TOOLTIP":"My vehicle has many years ahead of it. It looks great & runs great. It smell & look good.","ROUGH_VALUE":"Rough","ROUGH_TOOLTIP":"My vehicle needs love, paint is not good, might need repairs and/or parts."},"VEHICLE_PURCHASE":{"TITLE":"Where the Vehicle Has Been Purchased?","DEALER":"Dealership","PRIVATE":"Private"}},"SCREEN_LOCKED":"We Are Processing Your Request","TITLES":{"ESTIMATE_RANGE":"Just answer a few questions","GET_ESTIMATE":"Get Your Instant Estimated Trade-In Value","GET_OFFICIAL":"Get Your Official Trade-In Value","TOP_DOLLAR":"Top Dollar for Your Trade-In","CHECK_INFORMATIONS":"Let's Check your Information a Last Time"},"SUBTITLES":{"ESTIMATE_RANGE":"Your Estimated Value Range"},"ESTIMATE_TILE":{"TITLE":"Estimate the value of your exchange","SUBTITLE":"Get the value of your vehicle, based on its condition and mileage.","TAGLINE":"The value of your vehicle in just one minute"},"OFFICIAL_TILE":{"TITLE":"Get Your Vehicle’s Official Value","SUBTITLE":"This fast and easy process will allow you to receive a precise evaluation of your vehicle based on its history, condition and mileage.","CTA":"Get an official value"}}}

/***/ }),

/***/ "./src/i18n/fr.json":
/***/ (function(module, exports) {

module.exports = {"TRADE_IN":{"NON_AVAILABLE":"N/D","ODOMETER":{"SYMBOL":"Km"},"APPLY_TO_QUOTE":"Appliquez la valeur à ma soumission","BUTTONS":{"DONE":"Terminé","NEXT":"Suivant"},"COLOR":"Couleur","CONTACT":{"EMAIL":"Adresse électronique","FIRST_NAME":"Prénom","LAST_NAME":"Nom de famille","PHONE_NUMBER":"Numéro de téléphone","TITLE":"Vos informations"},"ERROR":"Désolé, quelque chose s'est mal passé. Veuillez réessayer.","FORM_TITLE":"Quel véhicule conduisez-vous actuellement?","GET_YOUR_VALUE":"Recevez la valeur de votre échange","MAKE":"Marque","MILEAGE":"Odomètre","MODEL":"Modèle","QUICK":"Prenez 5 minutes maintenant","GET_ESTIMATE_VALUE":"Obtenez votre estimation","GET_OFFICIAL_VALUE":"Obtenez votre évaluation officielle","CONGRATS":"Félicitations","GUEST_USER_SUCCESS":"Votre demande d'échange à été envoyée avec succès. Nous allons vous revenir le plus vite possible avec la meilleure valeur pour votre échange.","TITLE":"Évaluez votre échange","AUTOCOMPLETE_CAR":"Entrez votre année, marque, modèle","TRIM":"Version","VIN":"Numéro d'identification de véhicule (NIV) - optionnel","YEAR":"Année","CONDITION":{"TITLE":{"FAIR":"Condition passable","GOOD":"Bonne condition","VERYGOOD":"Très bonne condition","EXCELLENT":"Excellente condition"},"CONTENT":{"FAIR":"Quelques défauts de mécanique ou esthétique","GOOD":"Sans problèmes mécaniques, mais peut-être besoin d'un rafraîchissement esthétique","VERYGOOD":"Ce véhicule a une usure ou des défauts visibles sur la carrosserie et l'intérieur","EXCELLENT":"Ce véhicule est comme neuf"}},"ESTIMATE":{"VALUE":{"LOW":{"TITLE":"Valeur MINIMALE","DESCRIPTION":"Votre véhicule requiert une remise en état cosmétique et mécanique afin de lui redonner son éclat d'antan pour ainsi plaire au futur acheteur."},"HIGH":{"TITLE":"Valeur MAXIMALE","DESCRIPTION":"Votre véhicule est très près de la perfection puisqu'il ne présente pas de défauts apparents à la carosserie extérieure ni de signe évident d'odeur et d'usure prématurée des garnitures intérieures."}},"TITLE":"Définissez votre propre estimation","MODIFY":"Éditer","ERROR":{"TITLE":"Une erreur est survenue lors de votre estimation","TEXT":"S'il vous plait contactez-nous","CTA":"Éditer mon véhicule"},"YOUR_ESTIMATE":"Votre estimation","WHAT_IT_MEANS":"En savoir plus","POWERED_BY":"propulsé par","INFO_OFFICIAL":"Votre estimation est sauvegardée. Vous devez obtenir une évaluation réelle pour continuer votre transaction."},"VEHICLE_NAME":"%{year} %{make} %{model} %{modelTrim} %{modelTrimStyle}","ESTIMATE_TITLE":"Estimation de votre véhicule","ESTIMATE_SUBTITLE":"Propulsé par Canadian Black Book","OFFICIAL_TITLE":"Obtenez votre valeur d'échange officielle","TAX_SAVINGS":{"ESTIMATE":"Votre valeur d'échange","TAX_SAVINGS":"Crédit de taxes","RESULT":"Obtenez jusqu'à:","LOGGED_OUT_DISCLAIMER":"Veuillez noter que la valeur d'échange présentée est une estimation et ne représente en aucun cas une évaluation officielle.","LOGGED_IN_DISCLAIMER":"Votre estimation est sauvegardée. Vous devez obtenir une évaluation réelle pour continuer votre transaction.","MAY_CONTACT_FOR_INFO":"Nous pourrions vous contacter pour obtenir plus d'informations sur votre véhicule.","MOBILE":"%{estimate} (Valeur d'échange) + %{tax} (Crédit de taxes) = %{total}"},"CTA":{"LOGGED_OUT_TITLE":"Que voulez-vous faire ?","LOGGED_IN_TITLE":"Deux façons d’obtenir la valeur réelle de votre véhicule d’échange","DISCLAIMER":"Notez que le véhicule d’échange devra être inspecté pour confirmer son état et les informations fournies avant la livraison du nouveau véhicule.","OFFICIAL":{"LOGGED_OUT_TITLE":"Obtenir la valeur réelle","LOGGED_IN_TITLE":"Évaluation en ligne","DEFAULT_1":"Avoir votre NIV (numéro d'identification du véhicule) en main","DEFAULT_2":"Vous serez prêt en quelques minutes, dans le confort de votre maison ou en déplacement","KEEP_BROWSING":"Continuer les recherches"},"BACK_TO_SHOP":{"TITLE":"Continuer les recherches","DEFAULT_1":"Vous recevrez un email de confirmation sous peu","DEFAULT_2":"Remplissez le rapport de condition plus tard"},"SAVE_TRADE_IN_VALUE":"Sauvegarder mon estimation","IN_PERSON":"Évaluation en concession"},"OFFICIALEVALUATION":{"ESTIMATE_DONE":{"TITLE":"J'ai eu mon estimation","SUBTITLE":"Maintenant je veux:"},"TITLE":"Obtenez une évaluation d'échange officielle","NEEDS":{"TITLE":"Vous aurez besoin de :","PHOTOS":"Préparez votre véhicule pour quelques photos","VIN":"Avoir votre NIV (numéro d'identification du véhicule) en main","READY":"Vous serez prêt en quelques minutes, dans le confort de votre maison ou en déplacement","SAVE_TIME":"Appliquez votre valeur estimée à vos transactions","MOVE_TO_OFFICIAL":"Remplissez le rapport de condition plus tard"},"CTA":"Obtenir mon évaluation officielle"},"BACK_TO_SHOPPING":{"TITLE":"Retour<br />aux achats","DESCRIPTION":"Appliquez votre valeur d'échange dans vos transactions et continuez à magasiner pour la voiture parfaite.","CTA":"Continuer mon magasinage"},"TEASER":{"ESTIMATE_TITLE":"Estimez votre valeur d'échange","ESTIMATE_SUBTITLE":"Basé sur des milliers de véhicules au Canada"},"VEHICLE_INFORMATION":{"ABS_OPERATIONAL":{"TITLE":"Le système de freins antiblocage(ABS) est fonctionnel?","YES":"Oui","NO":"Non"},"ACCIDENT_OVER_3000":{"TITLE":"Avez-vous déjà eu un accident qui a nécessité plus de 3,000$ de dommage?","YES":"Oui","NO":"Non"},"AIR_BAGS_OPERATIONAL":{"TITLE":"Les coussins de sécurité sont fonctionnels?","YES":"Oui","NO":"Non"},"ANY_SCRATCHES":{"TITLE":"Est-ce que la vitre du pare-brise contient des égratignures ou des fissures?","YES":"Oui","NO":"Non"},"BODY_PARTS_REPLACED":{"TITLE":"Avez-vous réparé, peinturé ou remplacé un panneau du véhicule?","YES":"Oui","NO":"Non"},"CLARIFY_ACCIDENT":"Veuillez clarifier","DAMAGE_EXCEEDING_3000":{"TITLE":"Est-ce que votre véhicle requiert des réparations de 3000$ ou plus?","YES":"Oui","NO":"Non"},"ERROR":"Remplisser tous les champs du formulaire.","EVER_HAD_AN_ACCIDENT":{"TITLE":"Avez-vous déjà eu un accident avec ce véhicule?","NONE":"Aucun","3000_AND_MORE":"3000$ et plus","LESS_THAN_3000":"Moins de 3000$"},"MAJOR_EXTERIOR_INTERIOR_DAMAGE":{"TITLE":"Est-ce qu'il y a des dommages à l'intérieur ou à l'extérieur du véhicule qui sont plus gros que la largeur d'une pièce de 1$?","YES":"Oui","NO":"Non"},"MODIFIED_PARTS":{"TITLE":"Est-ce que le véhicule a été modifié, incluant les écussons et décalques originaux?","YES":"Oui","NO":"Non"},"PARTS_TO_REPLACE":{"TITLE":"Sélectionner quelle partie du véhicle doit être remplacée.","OPTIONS":{"NONE":"Aucune","ENGINE":"Moteur","SUSPENSION":"Suspension","TRANSMISSIONS":"Transmission","POWER_TRAIN":"Groupe motopropulseur","COMPUTER":"Équipment embarqué","ELECTRICAL":"Électrique","FUEL_OPERATION_SYSTEM":"Système d'exploitation de carburant","AIR_CONDITIONING_SYSTEM":"Système de climatisation","OTHER":"Autre"},"OTHER_EXPLANATION":"Veuillez clarifier"},"REPLACED_BRAKES":{"TITLE":"Avez-vous remplacé les freins récemment?","YES":"Oui","NO":"Non"},"REPLACED_TIRES":{"TITLE":"Avez-vous remplacé les pneus récemment?","YES":"Oui","NO":"Non"},"TITLE":"Dites-nous en plus sur la condition de votre véhicule"},"VEHICLE_STORY":{"CORPORATE_USE":{"TITLE":"Ce véhicule a été utilisé comme un taxi, véhicule d'urgence ou loué sur une base régulière?","YES":"Oui","NO":"Non","EXPLANATION":"SVP fournissez des détails"},"COVERAGE_BALANCE":"Balance de couverture","ERROR":"Remplissez tous les champs du formulaire.","MECHANICAL_PROTECTION":{"TITLE":"Ce véhicule est-il encore couvert par une garantie mécanique?","YES":"Oui","NO":"Non"},"ORIGINAL_OWNER":{"TITLE":"Êtes-vous le propriétaire original du véhicule?","YES":"Oui","NO":"Non"},"RUST_PROOF":{"TITLE":"Ce véhicule a-t-il été traité pour la rouille?","YES":"Oui","NO":"Non"},"TITLE":"Dites-nous en plus sur l'historique de votre véhicule","VEHICLE_CONDITION":{"TITLE":"Quelle est la condition du véhicule?","OK_VALUE":"Ok","OK_TOOLTIP":"Mon véhicule prend de l'âge et il a quelques égratignures.","PERFECT_VALUE":"Parfaite","PERFECT_TOOLTIP":"Mon véhicule a encore plusieurs années devant lui. Il est beau et roule parfaitement. Il sent bon et fait encore tourner les têtes.","ROUGH_VALUE":"Usée","ROUGH_TOOLTIP":"Mon véhicule a besoin d'amour. Sa peinture n'est pas très belle et il pourrait avoir besoin de réparations ou pièces."},"VEHICLE_PURCHASE":{"TITLE":"Où avez-vous acheté le véhicule?","DEALER":"Concessionnaire","PRIVATE":"Particulier"}},"SCREEN_LOCKED":"Nous traitons votre demande","TITLES":{"ESTIMATE_RANGE":"Il suffit de répondre à quelques questions","GET_ESTIMATE":"Obtenez votre valeur d'échange estimée","GET_OFFICIAL":"Obtenez votre valeur d’échange officielle","TOP_DOLLAR":"Rapide et sans tracas","CHECK_INFORMATIONS":"Révisons une dernière fois vos informations"},"SUBTITLES":{"ESTIMATE_RANGE":"Votre plage de valeurs estimées"},"ESTIMATE_TILE":{"TITLE":"Estimez la valeur de votre échange","SUBTITLE":"Obtenez la valeur de votre véhicule selon sa condition d’après votre propre évaluation","TAGLINE":"La valeur de votre véhicule en une minute"},"OFFICIAL_TILE":{"TITLE":"Obtenez la valeur officielle de votre véhicule d’échange","SUBTITLE":"Ce court processus vous permettra d’obtenir la valeur précise de votre échange en tenant compte de l’historique, du kilométrage et de l’état de votre véhicule.","CTA":"Obtenez la valeur officielle"}}}

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.widgets = undefined;

var _TradeInProvider = __webpack_require__("./src/TradeInProvider.jsx");

var _TradeInProvider2 = _interopRequireDefault(_TradeInProvider);

var _TradeInWrapper = __webpack_require__("./src/components/TradeInWrapper/TradeInWrapper.jsx");

var _TradeInWrapper2 = _interopRequireDefault(_TradeInWrapper);

var _InstantEstimateProvider = __webpack_require__("./src/InstantEstimateProvider.jsx");

var _InstantEstimateProvider2 = _interopRequireDefault(_InstantEstimateProvider);

var _OfficialTradeInProvider = __webpack_require__("./src/OfficialTradeInProvider.jsx");

var _OfficialTradeInProvider2 = _interopRequireDefault(_OfficialTradeInProvider);

var _TradeInBarWrapper = __webpack_require__("./src/components/TradeInBarWrapper/TradeInBarWrapper.jsx");

var _TradeInBarWrapper2 = _interopRequireDefault(_TradeInBarWrapper);

var _TradeInTiles = __webpack_require__("./src/components/TradeInTiles/TradeInTiles.jsx");

var _TradeInTiles2 = _interopRequireDefault(_TradeInTiles);

var _en = __webpack_require__("./src/i18n/en.json");

var _en2 = _interopRequireDefault(_en);

var _fr = __webpack_require__("./src/i18n/fr.json");

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = _TradeInWrapper2.default;
var provider = _TradeInProvider2.default;
var main = provider;

var i18n = {
    en: _en2.default,
    fr: _fr2.default
};

var widgets = exports.widgets = {
    TradeIn: {
        components: {
            root: root,
            main: main,
            provider: provider,
            TradeInBarWrapper: _TradeInBarWrapper2.default,
            TradeInTiles: _TradeInTiles2.default
        },
        i18n: i18n,
        InstantEstimateProvider: _InstantEstimateProvider2.default,
        OfficialTradeInProvider: _OfficialTradeInProvider2.default
    }
};

exports.default = {
    TradeIn: main,
    Translations: i18n,
    root: root,
    provider: provider,
    InstantEstimateProvider: _InstantEstimateProvider2.default,
    OfficialTradeInProvider: _OfficialTradeInProvider2.default,
    components: {
        TradeInBarWrapper: _TradeInBarWrapper2.default,
        TradeInTiles: _TradeInTiles2.default
    }
};

/***/ }),

/***/ "./src/model/TradeInModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = __webpack_require__("immutable");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TradeInRecord = new _immutable.Record({
    id: null,
    status: 0,
    leadId: 0,
    tradeInVehicle: {
        id: '',
        make: '',
        model: '',
        trim: '',
        style: '',
        year: '',
        exteriorColor: '',
        vin: '',
        odometer: ''
    },
    estimation: {
        amount: 0,
        high: 0,
        low: 0
    },
    evaluationQuestions: {},
    profile: {
        firstname: '',
        lastname: '',
        homePhone: '',
        email: ''
    }
});

var TradeInModel = function (_TradeInRecord) {
    _inherits(TradeInModel, _TradeInRecord);

    function TradeInModel() {
        _classCallCheck(this, TradeInModel);

        return _possibleConstructorReturn(this, (TradeInModel.__proto__ || Object.getPrototypeOf(TradeInModel)).apply(this, arguments));
    }

    return TradeInModel;
}(TradeInRecord);

exports.default = TradeInModel;

/***/ }),

/***/ "./src/services/ShowroomCBBService/ShowroomCBBService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = __webpack_require__("../../node_modules/axios/index.js");

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__("lodash");

var _index = __webpack_require__("./src/config/index.js");

var _index2 = _interopRequireDefault(_index);

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-underscore-dangle */

/**
 * Services talking to the ShowroomAPI for Canadian Black Books APIs
 * @class ShowroomCBBService
 */
var ShowroomCBBService = function () {
    function ShowroomCBBService() {
        _classCallCheck(this, ShowroomCBBService);

        /**
         * @type {String} Base path for api calls
         */
        this._basePath = _index2.default.endpoint.showroom + '/service/v1';

        /**
         * @type {String} Authentication parameters to add in the URI
         */
        this._authParameters = 'username=public&password=public';

        this.logger = new _loggerSentry2.default('ShowroomCBBService', _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
    }

    _createClass(ShowroomCBBService, [{
        key: '_getDataForEstimation',
        value: function _getDataForEstimation(tradeInVehicle) {
            if (!tradeInVehicle || !(0, _lodash.isObjectLike)(tradeInVehicle) || (0, _lodash.isEmpty)(tradeInVehicle)) {
                return null;
            }

            var km = tradeInVehicle.odometer || this._getDefaultOdometerValue(tradeInVehicle.year);

            return {
                year: String(tradeInVehicle.year),
                make: tradeInVehicle.make,
                model: tradeInVehicle.model,
                trim: tradeInVehicle.trim,
                style: tradeInVehicle.style,
                kilometers: String(km)
            };
        }

        /**
         * Private method to get an approximated odometer value for a given model year vehicle
         * @memberof ShowroomCBBService
         * @param {Number} [vehicleYear] model year of the vehicle
         * @param {?Number} [averageMileageByYear=15000] value of average odometer by year. Default: 15000. (optional)
         * @return {?Number} Integer or null
         */

    }, {
        key: '_getDefaultOdometerValue',
        value: function _getDefaultOdometerValue(vehicleYear) {
            var averageMileageByYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15000;

            var year = _widgetCommonsGeneral.UtilsService.getIntegerOrNull(vehicleYear);
            if (!year || year < 1900) {
                throw new TypeError('argument [vehicleYear] should be a safe integer higher than 1900');
            }

            var defaultMileageByYear = 15000;
            var currentYear = new Date().getFullYear();

            var odometerByYear = _widgetCommonsGeneral.UtilsService.getIntegerOrNull(averageMileageByYear);
            if (!odometerByYear || odometerByYear <= 0) {
                odometerByYear = defaultMileageByYear;
            }

            var yearDiff = currentYear - year;
            if (yearDiff < -1) {
                throw new TypeError('could not obtain a negative or null value');
            }
            yearDiff = yearDiff < 0 ? -0.5 : yearDiff;

            return Math.floor((yearDiff + 1) * odometerByYear);
        }

        /**
         * Call to get vehicle information for the Canadian Black Book autocomplete
         * @memberof ShowroomCBBService
         * @param {String} [hint] The value searched
         * @param {Number} [limit=10] The desired size of the result. Default: 10
         * @returns {Promise} An array of vehicle details
         */

    }, {
        key: 'searchAutocomplete',
        value: function searchAutocomplete(hint) {
            var _this = this;

            var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

            if (!hint) {
                return Promise.resolve([]);
            }

            var url = this._basePath + '/vehicleEvaluation.autoComplete?' + this._authParameters + ('&hint=' + encodeURIComponent(hint) + '&limit=' + limit);

            return _axios2.default.get(url).then(function (_ref) {
                var data = _ref.data;

                if (data.error) {
                    _this.logger.warn('An error occurred while doing the search for the autocomplete' + (' with hint [' + hint + '] and limit [' + limit + ']'), data.error);
                    return Promise.reject([]);
                }
                return Promise.resolve(data);
            }).catch(function (err) {
                _this.logger.error('An error occurred while doing the search for the autocomplete' + (' with hint [' + hint + '] and limit [' + limit + ']'), err);
                return Promise.reject([]);
            });
        }

        /**
         * Call to get an estimated value of a vehicle by Canadian Black Book
         * @memberof ShowroomCBBService
         *
         */

    }, {
        key: 'fetchEstimation',
        value: function fetchEstimation(tradeInVehicle) {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                var location = _widgetCommonsCoreServices.ConfigsService.getOrganizationUnitLocation();
                var obj = _this2._getDataForEstimation(tradeInVehicle);

                if (!obj) {
                    return reject(_widgetCommonsCoreServices.HTTPService.formatRejectResponse('invalidParams', {
                        status: 400
                    }));
                }

                var url = _this2._basePath + '/vehicleEvaluation?' + _this2._authParameters + ('&' + _widgetCommonsCoreServices.UrlService.buildUriParametersFromCollection(obj) + '&location=' + location);

                return _axios2.default.get(url).then(function (_ref2) {
                    var data = _ref2.data;

                    if (data.error) {
                        _this2.logger.error('An error occurred while fetching CBB estimation', data.error);
                        return reject(data.error);
                    }
                    return resolve(data);
                }).catch(function (err) {
                    _this2.logger.error('An error occurred while fetching CBB estimation', err);
                    return reject(err);
                });
            });
        }
    }]);

    return ShowroomCBBService;
}();

exports.default = new ShowroomCBBService();

/***/ }),

/***/ "./src/services/ShowroomTradeInService/ShowroomTradeInService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Service to fetch/get and keep in memory the TradeIn save in the Showroom API
 */
var ShowroomTradeInService = function () {
    function ShowroomTradeInService() {
        _classCallCheck(this, ShowroomTradeInService);

        /**
         * @type {Object} The ShowroomAPI TradeIn object
         */
        this.tradeIn = null;
    }

    /**
     * Fetch on the ShowroomAPI the tradeIn for the logger account and set it as a class variable
     * @return {Promise} A Promise the gives the TradeIn
     */


    _createClass(ShowroomTradeInService, [{
        key: 'fetchTradeIn',
        value: function fetchTradeIn() {
            var _this = this;

            return _widgetCommonsVehicle.ShowroomService.loadTradeInVehicle().then(function (tradeIn) {
                delete tradeIn.dealerIds;
                _this.tradeIn = tradeIn;
                return Promise.resolve(tradeIn);
            });
        }

        /**
         * If set, returns the TradeIn otherwise fetch it first
         * @return {Promise} A Promise the gives the TradeIn
         */

    }, {
        key: 'getTradeIn',
        value: function getTradeIn() {
            if (this.tradeIn) {
                return Promise.resolve(this.tradeIn);
            }
            return this.fetchTradeIn();
        }
    }]);

    return ShowroomTradeInService;
}();

exports.default = new ShowroomTradeInService();

/***/ }),

/***/ "./src/services/TradeInService/TradeInService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _widgetCommonsGeneral = __webpack_require__("@sm360/widget-commons-general");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

var _widgetCommonsLeads = __webpack_require__("../widget-commons-leads/src/index.js");

var _TradeInVehicleMapperService = __webpack_require__("./src/services/TradeInVehicleMapperService/TradeInVehicleMapperService.js");

var _TradeInVehicleMapperService2 = _interopRequireDefault(_TradeInVehicleMapperService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * If there's an authenticated user, save the tradeIn in the account (ShowroomAPI) otherwise just resolve
 * @param {TradeInModel} tradeIn
 * @returns {Promise} that returns the tradeIn ID
 */
function showroomSaveTradeIn(tradeIn) {
    return _widgetCommonsGeneral.AccountService.isAuthenticated() ? _widgetCommonsVehicle.ShowroomService.saveTradeInVehicle({
        id: tradeIn.id,
        vehicle: _TradeInVehicleMapperService2.default.tradeInVehicleToVehicle(tradeIn.tradeInVehicle),
        amount: tradeIn.estimation ? tradeIn.estimation.amount : undefined,
        evaluationQuestions: tradeIn.evaluationQuestions
    }).then(function (_ref) {
        var id = _ref.id;
        return id;
    }) : Promise.resolve(tradeIn.id);
}

/**
 * Service that handles the logic with the creation and update of the Trade In depending of the situation
 * (User logged or not, lead created or not, etc.)
 */

var TradeInService = function () {
    function TradeInService() {
        _classCallCheck(this, TradeInService);
    }

    _createClass(TradeInService, [{
        key: 'saveTradeIn',

        /**
         * Saves the trade in in the logged account and create/update the lead with the trade in information
         * @param {TradeInModel} tradeIn
         * @returns {Promise} the returns the created/updated `TradeInModel`
         */
        value: function saveTradeIn(tradeIn, quote) {
            var showroomServicePromise = showroomSaveTradeIn(tradeIn);

            var leadServicePromise = void 0;
            if (!(0, _lodash.isEmpty)(tradeIn.estimation)) {
                leadServicePromise = this.leadSaveTradeInEstimation(tradeIn, quote);

                return Promise.all([showroomServicePromise, leadServicePromise]).then(function (_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 1),
                        tradeInId = _ref3[0];

                    return tradeIn.set('id', tradeInId);
                });
            }
            if (tradeIn.evaluationQuestions) {
                leadServicePromise = this.leadSaveTradeInEvaluation(tradeIn, quote);
                return Promise.all([showroomServicePromise, leadServicePromise]).then(function (_ref4) {
                    var _ref5 = _slicedToArray(_ref4, 1),
                        tradeInId = _ref5[0];

                    return tradeIn.set('id', tradeInId);
                });
            }
            return null;
        }
    }, {
        key: 'leadSaveTradeInEstimation',
        value: function leadSaveTradeInEstimation(tradeIn, quote) {
            var isVehicleNew = quote && quote.vehicle && quote.vehicle.getIsVehicleNew();

            var _tradeIn$profile = tradeIn.profile,
                firstname = _tradeIn$profile.firstname,
                lastname = _tradeIn$profile.lastname,
                email = _tradeIn$profile.email,
                homePhone = _tradeIn$profile.homePhone,
                phoneNumber = _tradeIn$profile.phoneNumber;
            var _tradeIn$tradeInVehic = tradeIn.tradeInVehicle,
                make = _tradeIn$tradeInVehic.make,
                model = _tradeIn$tradeInVehic.model,
                trim = _tradeIn$tradeInVehic.trim,
                style = _tradeIn$tradeInVehic.style,
                year = _tradeIn$tradeInVehic.year,
                odometer = _tradeIn$tradeInVehic.odometer,
                exteriorColor = _tradeIn$tradeInVehic.exteriorColor,
                vin = _tradeIn$tradeInVehic.vin;
            var _tradeIn$estimation = tradeIn.estimation,
                amount = _tradeIn$estimation.amount,
                high = _tradeIn$estimation.high,
                low = _tradeIn$estimation.low;

            if (_widgetCommonsGeneral.AccountService.isAuthenticated()) {
                return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(isVehicleNew ? _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_NEW : _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_USED).addContactInformation(firstname, lastname, phoneNumber || homePhone, email).addVehicle(quote).addTradeInVehicle(parseInt(year, 10), make, model, trim, style, exteriorColor, parseInt(odometer, 10), vin).addTradeInEstimation(parseInt(amount, 10), parseInt(low, 10), parseInt(high, 10)).submit();
            }
            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(isVehicleNew ? _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_NEW : _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_USED).addContactInformation(firstname, lastname, phoneNumber || homePhone, email).addTradeInVehicle(parseInt(year, 10), make, model, trim, style, exteriorColor, parseInt(odometer, 10), vin).addTradeInEstimation(parseInt(amount, 10), parseInt(low, 10), parseInt(high, 10)).submit();
        }
    }, {
        key: 'leadSaveTradeInEvaluation',
        value: function leadSaveTradeInEvaluation(tradeIn, quote) {
            var isVehicleNew = quote && quote.vehicle && quote.vehicle.getIsVehicleNew();

            var _tradeIn$profile2 = tradeIn.profile,
                firstname = _tradeIn$profile2.firstname,
                lastname = _tradeIn$profile2.lastname,
                email = _tradeIn$profile2.email,
                homePhone = _tradeIn$profile2.homePhone,
                phoneNumber = _tradeIn$profile2.phoneNumber;
            var _tradeIn$tradeInVehic2 = tradeIn.tradeInVehicle,
                make = _tradeIn$tradeInVehic2.make,
                model = _tradeIn$tradeInVehic2.model,
                trim = _tradeIn$tradeInVehic2.trim,
                style = _tradeIn$tradeInVehic2.style,
                year = _tradeIn$tradeInVehic2.year,
                odometer = _tradeIn$tradeInVehic2.odometer,
                exteriorColor = _tradeIn$tradeInVehic2.exteriorColor,
                vin = _tradeIn$tradeInVehic2.vin;


            return new _widgetCommonsLeads.LeadSubmissionBuilder().addLeadType(isVehicleNew ? _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_NEW : _widgetCommonsLeads.LEAD_TYPES.TRADE_IN_USED).addContactInformation(firstname, lastname, phoneNumber || homePhone, email).addVehicle(quote).addTradeInVehicle(parseInt(year, 10), make, model, trim, style, exteriorColor, parseInt(odometer, 10), vin).addTradeInEvaluation(tradeIn.evaluationQuestions).submit();
        }
    }]);

    return TradeInService;
}();

exports.default = new TradeInService();

/***/ }),

/***/ "./src/services/TradeInVehicleMapperService/TradeInVehicleMapperService.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("lodash");

var _loggerSentry = __webpack_require__("../../node_modules/@sm360/logger-sentry/dist/index.js");

var _loggerSentry2 = _interopRequireDefault(_loggerSentry);

var _widgetCommonsCoreServices = __webpack_require__("@sm360/widget-commons-core-services");

var _widgetCommonsVehicle = __webpack_require__("@sm360/widget-commons-vehicle");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TradeInVehicleMapperService = function () {
    function TradeInVehicleMapperService() {
        _classCallCheck(this, TradeInVehicleMapperService);

        this.logger = new _loggerSentry2.default('TradeInVehicleMapperService', _widgetCommonsCoreServices.ConfigsService.getLoggerContext());
    }

    /**
     * Convert a Vehicle to a tradeInVehicle.
     * @param {VehicleModel} vehicle
     * @returns {Object} TradeInVehicle
     */


    _createClass(TradeInVehicleMapperService, [{
        key: 'vehicleToTradeInVehicle',
        value: function vehicleToTradeInVehicle(vehicle) {
            if ((0, _lodash.isEmpty)(vehicle) || !(0, _lodash.isObjectLike)(vehicle)) {
                this.logger.error('Error converting vehicleToTradeInVehicle. Argument `vehicle` is invalid.', { vehicle: vehicle });
                return {};
            }
            return {
                id: vehicle.id,
                make: vehicle.make,
                model: vehicle.model,
                trim: vehicle.modelTrim,
                style: !(0, _lodash.isEmpty)(vehicle.modelTrimStyle) ? vehicle.modelTrimStyle[0] : '',
                year: parseInt(vehicle.year, 10),
                odometer: parseInt(vehicle.odometer, 10),
                exteriorColor: !(0, _lodash.isEmpty)(vehicle.bodyColour) ? vehicle.bodyColour.colorCode : '',
                vin: vehicle.vin
            };
        }

        /**
         * Convert a TradeInVehicle to a VehicleModel.
         * @param {Object} TradeInVehicle
         * @returns {VehicleModel} Vehicle
         */

    }, {
        key: 'tradeInVehicleToVehicle',
        value: function tradeInVehicleToVehicle(tradeInVehicle) {
            if ((0, _lodash.isEmpty)(tradeInVehicle) || !(0, _lodash.isObjectLike)(tradeInVehicle)) {
                this.logger.error('Error converting tradeInVehicleToVehicle. Argument `tradeInVehicle` is invalid.', {
                    tradeInVehicle: tradeInVehicle
                });
                return new _widgetCommonsVehicle.Vehicle.VehicleModel();
            }
            return new _widgetCommonsVehicle.Vehicle.VehicleModel(_extends({}, tradeInVehicle, {
                bodyColour: { colorCode: tradeInVehicle.exteriorColor },
                year: parseInt(tradeInVehicle.year, 10),
                odometer: parseInt(tradeInVehicle.odometer, 10),
                modelTrim: tradeInVehicle.trim,
                modelTrimStyle: [tradeInVehicle.style]
            }));
        }

        /**
         * Convert a TradeInVehicle to a TradeInVehicleLead.
         * @param {Object} TradeInVehicle
         * @returns {Object} TradeInVehicleLead
         */

    }, {
        key: 'tradeInVehicleToVehicleLead',
        value: function tradeInVehicleToVehicleLead(tradeInVehicle) {
            if ((0, _lodash.isEmpty)(tradeInVehicle) || !(0, _lodash.isObjectLike)(tradeInVehicle)) {
                this.logger.error('Error converting tradeInVehicleToVehicleLead. Argument `tradeInVehicle` is invalid.', {
                    tradeInVehicle: tradeInVehicle
                });
                return {};
            }
            return {
                id: tradeInVehicle.id,
                make: tradeInVehicle.make,
                model: tradeInVehicle.model,
                // We need to concatenate the trim and style because the showroomAPI doesn't have the style property. They are splited in the widget-supplier
                modelTrimCode: tradeInVehicle.trim + '|' + tradeInVehicle.style,
                year: parseInt(tradeInVehicle.year, 10),
                odometer: parseInt(tradeInVehicle.odometer, 10),
                exteriorColor: tradeInVehicle.exteriorColor,
                vin: tradeInVehicle.vin
            };
        }
    }]);

    return TradeInVehicleMapperService;
}();

exports.default = new TradeInVehicleMapperService();

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/index.js");


/***/ }),

/***/ "@sm360/widget-commons-basic-components":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_basic_components__;

/***/ }),

/***/ "@sm360/widget-commons-core-services":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_core_services__;

/***/ }),

/***/ "@sm360/widget-commons-forms":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_forms__;

/***/ }),

/***/ "@sm360/widget-commons-general":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_general__;

/***/ }),

/***/ "@sm360/widget-commons-vehicle":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_commons_vehicle__;

/***/ }),

/***/ "@sm360/widget-login":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__sm360_widget_login__;

/***/ }),

/***/ "immutable":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_immutable__;

/***/ }),

/***/ "lodash":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_lodash__;

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// widget-7.1.6.min.js